window.RAINBOW_BROWSER_DATA =
{
  "browser_name": "Rainbow Browser",
  "generated_at": "2026-03-27T13:54:29.682602+00:00",
  "filters": {
    "shopify_search_query": "",
    "metafield_namespace": "custom",
    "swatch_metafield_key": "colour_swatch_images",
    "material_metafield_key": "material",
    "front_image_source_column": "Front Image",
    "require_white_background": true
  },
  "count": 2408,
  "items": [
    {
      "product_id": "gid://shopify/Product/10455556981002",
      "product_title": "Tee Jays CoolDry™ T-Shirt",
      "product_handle": "t7020",
      "product_url": "/products/t7020",
      "product_full_url": "https://oakdenemerch.com/products/t7020",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t7020",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7020",
      "colour_name": "Black Melange",
      "colour_group": "Black > Heather/Effect Black",
      "rgb": "#262626",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.14902,
      "swatch_file_id": "gid://shopify/MediaImage/49469011853578",
      "swatch_filename": "T7020_Black_Melange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_Black_Melange.jpg?v=1774315920",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_Black_Melange.jpg?v=1774315920",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7020/ProductCarouselMain/T7020%20BKML%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7020_Black_Melange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557079306",
      "product_title": "Tee Jays Ladies CoolDry™ T-Shirt",
      "product_handle": "t7021",
      "product_url": "/products/t7021",
      "product_full_url": "https://oakdenemerch.com/products/t7021",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-t7021",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7021",
      "colour_name": "Black Melange",
      "colour_group": "Black > Heather/Effect Black",
      "rgb": "#262626",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.14902,
      "swatch_file_id": "gid://shopify/MediaImage/49471676383498",
      "swatch_filename": "T7021_Black_Melange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_Black_Melange.jpg?v=1774350799",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_Black_Melange.jpg?v=1774350799",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7021/ProductCarouselMain/T7021%20BKML%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7021_Black_Melange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688736010",
      "product_title": "Tee Jays Long Sleeve CoolDry™ T-Shirt",
      "product_handle": "t7022",
      "product_url": "/products/t7022",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-t7022",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7022",
      "colour_name": "Black Melange",
      "colour_group": "Black > Heather/Effect Black",
      "rgb": "#262626",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.14902,
      "swatch_file_id": "gid://shopify/MediaImage/49490492489994",
      "swatch_filename": "t7022_Black_Melange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t7022_Black_Melange.jpg?v=1774523117",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t7022_Black_Melange.jpg?v=1774523117",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7022/ProductCarouselMain/T7022%20BKML%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7022_Black_Melange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Vintage Black",
      "colour_group": "Black > Black",
      "rgb": "#141414",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.078431,
      "swatch_file_id": "gid://shopify/MediaImage/49473259307274",
      "swatch_filename": "CV3001_Vintage_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Vintage_Black.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Vintage_Black.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20VBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Vintage_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550099722",
      "product_title": "AWDis Cool Contrast Wicking T-Shirt",
      "product_handle": "jc003",
      "product_url": "/products/jc003",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003",
      "colour_name": "Arctic White/Jet Black",
      "colour_group": "White > White",
      "rgb": "#ffffff;#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491403669770",
      "swatch_filename": "jc003_Arctic_WhiteJet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Arctic_WhiteJet_Black.jpg?v=1774526719",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Arctic_WhiteJet_Black.jpg?v=1774526719",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003/ProductCarouselMain/JC003%20AW%252fJB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003_Arctic_WhiteJet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550132490",
      "product_title": "AWDis Kids Cool Contrast T-Shirt",
      "product_handle": "jc003b",
      "product_url": "/products/jc003b",
      "product_full_url": "https://oakdenemerch.com/products/jc003b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "style-jc003b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003B",
      "colour_name": "Arctic White/Jet Black",
      "colour_group": "White > White",
      "rgb": "#ffffff;#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474198077706",
      "swatch_filename": "JC003B_Arctic_WhiteJet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC003B_Arctic_WhiteJet_Black.jpg?v=1774370308",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC003B_Arctic_WhiteJet_Black.jpg?v=1774370308",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003B/ProductCarouselMain/JC003B%20AW%252fJB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003b_Arctic_WhiteJet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548625162",
      "product_title": "Bella Ladies Micro Rib 3/4 Raglan Baby T-Shirt",
      "product_handle": "bl1200",
      "product_url": "/products/bl1200",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-bl1200",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1200",
      "colour_name": "Athletic Heather/Black",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#97a7ab;#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491492864266",
      "swatch_filename": "bl1200_Athletic_HeatherBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1200_Athletic_HeatherBlack.jpg?v=1774526798",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1200_Athletic_HeatherBlack.jpg?v=1774526798",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1200/ProductCarouselMain/BL1200%20AH%252fBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1200_Athletic_HeatherBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548657930",
      "product_title": "Bella Ladies Micro Rib Raglan Baby T-Shirt",
      "product_handle": "bl1201",
      "product_url": "/products/bl1201",
      "product_full_url": "https://oakdenemerch.com/products/bl1201",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "headwear",
        "L",
        "M",
        "S",
        "style-bl1201",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1201",
      "colour_name": "Athletic Heather/Black",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#97a7ab;#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472614924554",
      "swatch_filename": "BL1201_Athletic_HeatherBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL1201_Athletic_HeatherBlack.jpg?v=1774358245",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL1201_Athletic_HeatherBlack.jpg?v=1774358245",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1201/ProductCarouselMain/BL1201%20AH%252fBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1201_Athletic_HeatherBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548690698",
      "product_title": "Bella Ladies Heavy Boxy T-Shirt",
      "product_handle": "bl6110",
      "product_url": "/products/bl6110",
      "product_full_url": "https://oakdenemerch.com/products/bl6110",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-bl6110",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "BL6110",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472881459466",
      "swatch_filename": "BL6110_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_Black.jpg?v=1774360125",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_Black.jpg?v=1774360125",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL6110/ProductCarouselMain/BL6110%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl6110_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548723466",
      "product_title": "Bella Ladies Relaxed Jersey T-Shirt",
      "product_handle": "bl6400",
      "product_url": "/products/bl6400",
      "product_full_url": "https://oakdenemerch.com/products/bl6400",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-bl6400",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "BL6400",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471852806410",
      "swatch_filename": "BL6400_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6400_Black.jpg?v=1774351968",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6400_Black.jpg?v=1774351968",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL6400/ProductCarouselMain/BL6400%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl6400_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548789002",
      "product_title": "Canterbury Club Dry T-Shirt",
      "product_handle": "cn260",
      "product_url": "/products/cn260",
      "product_full_url": "https://oakdenemerch.com/products/cn260",
      "vendor": "Canterbury",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-cn260",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "CN260",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468934324490",
      "swatch_filename": "CN260_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CN260_Black.jpg?v=1774313120",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CN260_Black.jpg?v=1774313120",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Canterbury/Product%20Images/CN260/ProductCarouselMain/CN260%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cn260_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473259438346",
      "swatch_filename": "CV3001_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Black.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Black.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548920074",
      "product_title": "Canvas Unisex Heavyweight Boxy T-Shirt",
      "product_handle": "cv3010",
      "product_url": "/products/cv3010",
      "product_full_url": "https://oakdenemerch.com/products/cv3010",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv3010",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3010",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472879296778",
      "swatch_filename": "CV3010_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_Black.jpg?v=1774360083",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_Black.jpg?v=1774360083",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3010/ProductCarouselMain/CV3010%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3010_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686737162",
      "product_title": "Canvas Unisex Heavyweight Long Sleeve Boxy T-Shirt",
      "product_handle": "cv3511",
      "product_url": "/products/cv3511",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv3511",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3511",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490422464778",
      "swatch_filename": "cv3511_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_Black.jpg?v=1774522800",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_Black.jpg?v=1774522800",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3511/ProductCarouselMain/CV3511%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3511_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686835466",
      "product_title": "Canvas Unisex Heavyweight Long Sleeve T-Shirt",
      "product_handle": "cv4651",
      "product_url": "/products/cv4651",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv4651",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV4651",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490434752778",
      "swatch_filename": "cv4651_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4651_Black.jpg?v=1774522811",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4651_Black.jpg?v=1774522811",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV4651/ProductCarouselMain/CV4651%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv4651_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549018378",
      "product_title": "Canvas Unisex Heavyweight T-Shirt",
      "product_handle": "cv4610",
      "product_url": "/products/cv4610",
      "product_full_url": "https://oakdenemerch.com/products/cv4610",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv4610",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV4610",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473247609098",
      "swatch_filename": "CV4610_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV4610_Black.jpg?v=1774362975",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV4610_Black.jpg?v=1774362975",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV4610/ProductCarouselMain/CV4610%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv4610_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686638858",
      "product_title": "Canvas Unisex Jersey Long Sleeve T-Shirt",
      "product_handle": "cv3501",
      "product_url": "/products/cv3501",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv3501",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3501",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490418499850",
      "swatch_filename": "cv3501_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3501_Black.jpg?v=1774522794",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3501_Black.jpg?v=1774522794",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3501/ProductCarouselMain/CV3501%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3501_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549247754",
      "product_title": "Ecologie Arrow Recycled Heavy Oversize T-Shirt",
      "product_handle": "ea006",
      "product_url": "/products/ea006",
      "product_full_url": "https://oakdenemerch.com/products/ea006",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ea006",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "48% recycled cotton/47% recycled polyester/5% elastane.",
      "style_code": "EA006",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472604832010",
      "swatch_filename": "EA006_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA006_Black.jpg?v=1774358065",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA006_Black.jpg?v=1774358065",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA006/ProductCarouselMain/EA006%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea006_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549935882",
      "product_title": "Henbury HiCool® Performance T-Shirt",
      "product_handle": "h024",
      "product_url": "/products/h024",
      "product_full_url": "https://oakdenemerch.com/products/h024",
      "vendor": "Henbury",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-h024",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% HiCool® polyester interlock.",
      "style_code": "H024",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473151762698",
      "swatch_filename": "H024_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/H024_Black.jpg?v=1774362359",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/H024_Black.jpg?v=1774362359",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H024/ProductCarouselMain/H024%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h024_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687163146",
      "product_title": "Henbury Long Sleeve Roll Neck Top",
      "product_handle": "h020",
      "product_url": "/products/h020",
      "product_full_url": "None",
      "vendor": "Henbury",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-h020",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane single jersey.",
      "style_code": "H020",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490470338826",
      "swatch_filename": "h020_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h020_Black.jpg?v=1774522878",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h020_Black.jpg?v=1774522878",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H020/ProductCarouselMain/H020%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h020_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550001418",
      "product_title": "Henbury Unisex Coolplus® Wicking Piqué T-Shirt",
      "product_handle": "h075",
      "product_url": "/products/h075",
      "product_full_url": "https://oakdenemerch.com/products/h075",
      "vendor": "Henbury",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-h075",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester micro piqué.",
      "style_code": "H075",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474231337226",
      "swatch_filename": "H075_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/H075_Black.jpg?v=1774370566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/H075_Black.jpg?v=1774370566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H075/ProductCarouselMain/H075%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h075_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491369885962",
      "swatch_filename": "kb3025ic_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Black.jpg?v=1774526618",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Black.jpg?v=1774526618",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551672586",
      "product_title": "Kariban Crew Neck T-Shirt",
      "product_handle": "kb356",
      "product_url": "/products/kb356",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb356",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed cotton.*",
      "style_code": "KB356",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491360678154",
      "swatch_filename": "kb356_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb356_Black.jpg?v=1774526588",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb356_Black.jpg?v=1774526588",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB356/ProductCarouselMain/KB356%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb356_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562167050",
      "product_title": "Kariban Eco-Friendly Tank Top",
      "product_handle": "kb3023ic",
      "product_url": "/products/kb3023ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3023ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3023IC",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513928786186",
      "swatch_filename": "kb3023ic_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3023ic_Black.jpg?v=1774619023",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3023ic_Black.jpg?v=1774619023",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3023IC/ProductCarouselMain/KB3023IC%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3023ic_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562265354",
      "product_title": "Kariban Ladies Eco-Friendly Tank Top",
      "product_handle": "kb3024ic",
      "product_url": "/products/kb3024ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-kb3024ic",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3024IC",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513929277706",
      "swatch_filename": "kb3024ic_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3024ic_Black.jpg?v=1774619031",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3024ic_Black.jpg?v=1774619031",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3024IC/ProductCarouselMain/KB3024IC%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3024ic_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551639818",
      "product_title": "Kariban Unisex 190IC Crew Neck T-Shirt",
      "product_handle": "kb3032ic",
      "product_url": "/products/kb3032ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3032ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3032IC",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491363070218",
      "swatch_filename": "kb3032ic_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Black.jpg?v=1774526597",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Black.jpg?v=1774526597",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3032IC/ProductCarouselMain/KB3032IC%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3032ic_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551049994",
      "product_title": "Kustom Kit Fashion Fit Cotton T-Shirt",
      "product_handle": "k507",
      "product_url": "/products/k507",
      "product_full_url": "https://oakdenemerch.com/products/k507",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-k507",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "K507",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472797802762",
      "swatch_filename": "K507_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K507_Black.jpg?v=1774359878",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K507_Black.jpg?v=1774359878",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K507/ProductCarouselMain/K507%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k507_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550984458",
      "product_title": "Kustom Kit Hunky® Superior T-Shirt",
      "product_handle": "k500",
      "product_url": "/products/k500",
      "product_full_url": "https://oakdenemerch.com/products/k500",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-k500",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed cotton.*",
      "style_code": "K500",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474181693706",
      "swatch_filename": "K500_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K500_Black.jpg?v=1774369965",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K500_Black.jpg?v=1774369965",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K500/ProductCarouselMain/K500%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k500_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551475978",
      "product_title": "Kustom Kit Ladies 3/4 Sleeve Mandarin Collar Top",
      "product_handle": "k785",
      "product_url": "/products/k785",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "12-14",
        "12-14-16-18-20-22-8-10",
        "16-18",
        "20-22",
        "8-10",
        "Long Sleeve T-Shirt",
        "style-k785",
        "t-shirts",
        "womens"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "95% cotton/5% elastane.",
      "style_code": "K785",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491383386378",
      "swatch_filename": "k785_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k785_Black.jpg?v=1774526655",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k785_Black.jpg?v=1774526655",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K785/ProductCarouselMain/K785%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k785_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551279370",
      "product_title": "Kustom Kit Ladies Keyhole Neck Corporate Top",
      "product_handle": "k755",
      "product_url": "/products/k755",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "12-14",
        "12-14-16-18-20-22-8-10",
        "16-18",
        "20-22",
        "8-10",
        "corporatewear",
        "style-k755",
        "t-shirts",
        "womens"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "95% cotton/5% elastane.",
      "style_code": "K755",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491387449610",
      "swatch_filename": "k755_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k755_Black.jpg?v=1774526667",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k755_Black.jpg?v=1774526667",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K755/ProductCarouselMain/K755%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k755_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551377674",
      "product_title": "Kustom Kit Ladies V Neck Corporate Top",
      "product_handle": "k770",
      "product_url": "/products/k770",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "12-14",
        "12-14-16-18-20-22-8-10",
        "16-18",
        "20-22",
        "8-10",
        "corporatewear",
        "style-k770",
        "t-shirts",
        "womens"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "95% cotton/5% elastane.",
      "style_code": "K770",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491384828170",
      "swatch_filename": "k770_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k770_Black.jpg?v=1774526661",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k770_Black.jpg?v=1774526661",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K770/ProductCarouselMain/K770%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k770_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687556362",
      "product_title": "Kustom Kit Long Sleeve Fashion Fit Superwash® 60°C T-Shirt",
      "product_handle": "k510",
      "product_url": "/products/k510",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-k510",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton.",
      "style_code": "K510",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490479350026",
      "swatch_filename": "k510_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k510_Black.jpg?v=1774522932",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k510_Black.jpg?v=1774522932",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K510/ProductCarouselMain/K510%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k510_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551181066",
      "product_title": "Kustom Kit Regular Fit Cooltex® Plus Wicking T-Shirt",
      "product_handle": "k555",
      "product_url": "/products/k555",
      "product_full_url": "https://oakdenemerch.com/products/k555",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k555",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester mesh.",
      "style_code": "K555",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473108672778",
      "swatch_filename": "K555_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K555_Black.jpg?v=1774362040",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K555_Black.jpg?v=1774362040",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K555/ProductCarouselMain/K555%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k555_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551148298",
      "product_title": "Kustom Kit Superwash® 60°C Piqué T-Shirt",
      "product_handle": "k530",
      "product_url": "/products/k530",
      "product_full_url": "https://oakdenemerch.com/products/k530",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-k530",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton piqué.",
      "style_code": "K530",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472793346314",
      "swatch_filename": "K530_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K530_Black.jpg?v=1774359824",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K530_Black.jpg?v=1774359824",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K530/ProductCarouselMain/K530%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k530_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551017226",
      "product_title": "Kustom Kit Superwash® 60°C T-Shirt",
      "product_handle": "k504",
      "product_url": "/products/k504",
      "product_full_url": "https://oakdenemerch.com/products/k504",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k504",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton.*",
      "style_code": "K504",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473127219466",
      "swatch_filename": "K504_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K504_Black.jpg?v=1774362160",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K504_Black.jpg?v=1774362160",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K504/ProductCarouselMain/K504%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k504_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687589130",
      "product_title": "Kustom Kit Warmtex® Long Sleeve Base Layer",
      "product_handle": "k979",
      "product_url": "/products/k979",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-k979",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "90% polyester/10% spandex.",
      "style_code": "K979",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490479612170",
      "swatch_filename": "k979_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k979_Black.jpg?v=1774522937",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k979_Black.jpg?v=1774522937",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K979/ProductCarouselMain/K979%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k979_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687621898",
      "product_title": "Mantis Unisex Essential Heavy Long Sleeve T-Shirt",
      "product_handle": "m06",
      "product_url": "/products/m06",
      "product_full_url": "None",
      "vendor": "Mantis",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-m06",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "M06",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490480005386",
      "swatch_filename": "m06_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m06_Black.jpg?v=1774522943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m06_Black.jpg?v=1774522943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Mantis/M06/ProductCarouselMain/M06%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "m06_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552098570",
      "product_title": "Onna by Premier Ladies Unstoppable Fresh Underscrub Base Layer",
      "product_handle": "nn370",
      "product_url": "/products/nn370",
      "product_full_url": "None",
      "vendor": "Onna by Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-nn370",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Nylon",
      "shopify_material": "Nylon",
      "csv_material": "50% recycled nylon/50% nylon.",
      "style_code": "NN370",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491319881994",
      "swatch_filename": "nn370_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/nn370_Black.jpg?v=1774526514",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/nn370_Black.jpg?v=1774526514",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Onna%20by%20Premier/Product%20Images/NN370/ProductCarouselMain/NN370%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "nn370_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552065802",
      "product_title": "Onna by Premier Unstoppable Fresh Underscrub Base Layer",
      "product_handle": "nn270",
      "product_url": "/products/nn270",
      "product_full_url": "None",
      "vendor": "Onna by Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-nn270",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Nylon",
      "shopify_material": "Nylon",
      "csv_material": "50% recycled nylon/50% nylon.*",
      "style_code": "NN270",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491322634506",
      "swatch_filename": "nn270_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/nn270_Black.jpg?v=1774526524",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/nn270_Black.jpg?v=1774526524",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Onna%20by%20Premier/Product%20Images/NN270/ProductCarouselMain/NN270%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "nn270_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552786698",
      "product_title": "Premier Coolchecker® Chef's T-Shirt",
      "product_handle": "pr649",
      "product_url": "/products/pr649",
      "product_full_url": "https://oakdenemerch.com/products/pr649",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "chefswear-catering",
        "hospitality",
        "L",
        "M",
        "S",
        "style-pr649",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PR649",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474098364682",
      "swatch_filename": "PR649_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR649_Black.jpg?v=1774369069",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR649_Black.jpg?v=1774369069",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR649/ProductCarouselMain/PR649%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr649_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552655626",
      "product_title": "Premier Cotton Rich Comis T-Shirt",
      "product_handle": "pr219",
      "product_url": "/products/pr219",
      "product_full_url": "https://oakdenemerch.com/products/pr219",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-pr219",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% recycled polyester.*",
      "style_code": "PR219",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468948054282",
      "swatch_filename": "PR219_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR219_Black.jpg?v=1774314717",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR219_Black.jpg?v=1774314717",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR219/ProductCarouselMain/PR219%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr219_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687687434",
      "product_title": "Premier Essential Coolchecker® Long Sleeve Chef's Shirt",
      "product_handle": "pr647",
      "product_url": "/products/pr647",
      "product_full_url": "None",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "aprons",
        "chefswear-catering",
        "hospitality",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-pr647",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "PR647",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490481053962",
      "swatch_filename": "pr647_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr647_Black.jpg?v=1774522958",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr647_Black.jpg?v=1774522958",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR647/ProductCarouselMain/PR647%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr647_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552753930",
      "product_title": "Premier Essential Coolchecker® Short Sleeve Chef's Shirt",
      "product_handle": "pr646",
      "product_url": "/products/pr646",
      "product_full_url": "None",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "aprons",
        "chefswear-catering",
        "hospitality",
        "L",
        "M",
        "S",
        "style-pr646",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "PR646",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491311984906",
      "swatch_filename": "pr646_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr646_Black.jpg?v=1774526489",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr646_Black.jpg?v=1774526489",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR646/ProductCarouselMain/PR646%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr646_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552721162",
      "product_title": "Premier Ladies Cotton Rich Comis T-Shirt",
      "product_handle": "pr319",
      "product_url": "/products/pr319",
      "product_full_url": "https://oakdenemerch.com/products/pr319",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-pr319",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% recycled polyester.*",
      "style_code": "PR319",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472275284234",
      "swatch_filename": "PR319_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR319_Black.jpg?v=1774354101",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR319_Black.jpg?v=1774354101",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR319/ProductCarouselMain/PR319%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr319_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552688394",
      "product_title": "Premier Ladies Long John Roll Sleeve T-Shirt",
      "product_handle": "pr318",
      "product_url": "/products/pr318",
      "product_full_url": "None",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-pr318",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Viscose/Elastane",
      "shopify_material": "Poly/Viscose/Elastane",
      "csv_material": "82% polyester/14% viscose/4% elastane.",
      "style_code": "PR318",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491313656074",
      "swatch_filename": "pr318_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr318_Black.jpg?v=1774526495",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr318_Black.jpg?v=1774526495",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR318/ProductCarouselMain/PR318%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr318_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552622858",
      "product_title": "Premier Long John Roll Sleeve T-Shirt",
      "product_handle": "pr218",
      "product_url": "/products/pr218",
      "product_full_url": "https://oakdenemerch.com/products/pr218",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-pr218",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Viscose/Elastane",
      "shopify_material": "Poly/Viscose/Elastane",
      "csv_material": "82% polyester/14% viscose/4% elastane.",
      "style_code": "PR218",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472776929546",
      "swatch_filename": "PR218_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR218_Black.jpg?v=1774359566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR218_Black.jpg?v=1774359566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR218/ProductCarouselMain/PR218%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr218_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687785738",
      "product_title": "Pro RTX Pro Long Sleeve T-Shirt",
      "product_handle": "rx152",
      "product_url": "/products/rx152",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx152",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX152",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490481840394",
      "swatch_filename": "rx152_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx152_Black.jpg?v=1774522972",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx152_Black.jpg?v=1774522972",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX152/ProductCarouselMain/RX152%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx152_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474088927498",
      "swatch_filename": "RX151_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Black.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Black.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552557322",
      "product_title": "Proact Ladies Performance T-Shirt",
      "product_handle": "pa439",
      "product_url": "/products/pa439",
      "product_full_url": "https://oakdenemerch.com/products/pa439",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa439",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA439",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471737331978",
      "swatch_filename": "PA439_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Black.jpg?v=1774351220",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Black.jpg?v=1774351220",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA439/ProductCarouselMain/PA439%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa439_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552491786",
      "product_title": "Proact Ladies Triblend Sports T-Shirt",
      "product_handle": "pa4021",
      "product_url": "/products/pa4021",
      "product_full_url": "https://oakdenemerch.com/products/pa4021",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-pa4021",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% cotton/25% viscose.",
      "style_code": "PA4021",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474101674250",
      "swatch_filename": "PA4021_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA4021_Black.jpg?v=1774369137",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA4021_Black.jpg?v=1774369137",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA4021/ProductCarouselMain/PA4021%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa4021_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552524554",
      "product_title": "Proact Performance T-Shirt",
      "product_handle": "pa438",
      "product_url": "/products/pa438",
      "product_full_url": "https://oakdenemerch.com/products/pa438",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa438",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA438",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471751979274",
      "swatch_filename": "PA438_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Black.jpg?v=1774351290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Black.jpg?v=1774351290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA438/ProductCarouselMain/PA438%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa438_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552459018",
      "product_title": "Proact Triblend Sports T-Shirt",
      "product_handle": "pa4011",
      "product_url": "/products/pa4011",
      "product_full_url": "https://oakdenemerch.com/products/pa4011",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa4011",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% cotton/25% viscose.",
      "style_code": "PA4011",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471762137354",
      "swatch_filename": "PA4011_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA4011_Black.jpg?v=1774351357",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA4011_Black.jpg?v=1774351357",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA4011/ProductCarouselMain/PA4011%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa4011_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552885002",
      "product_title": "Regatta Ladies Ada Cotton Stretch T-Shirt",
      "product_handle": "rg810",
      "product_url": "/products/rg810",
      "product_full_url": "https://oakdenemerch.com/products/rg810",
      "vendor": "Regatta Professional",
      "product_type": "T-Shirt",
      "tags": [
        "10",
        "12",
        "14",
        "16",
        "18",
        "20",
        "8",
        "8-10-12-14-16-18-20",
        "style-rg810",
        "t-shirts",
        "womens"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "95% sustainable cotton/5% elastane.",
      "style_code": "RG810",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474093515018",
      "swatch_filename": "RG810_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RG810_Black.jpg?v=1774368984",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RG810_Black.jpg?v=1774368984",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Regatta%20Professional/Product%20Images/RG810/ProductCarouselMain/RG810%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rg810_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548297482",
      "product_title": "Russell Athletic Authentic Heavyweight T-Shirt",
      "product_handle": "215m",
      "product_url": "/products/215m",
      "product_full_url": "https://oakdenemerch.com/products/215m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "sports",
        "style-215m",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "215M",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49470972657930",
      "swatch_filename": "215M_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/215M_Black.jpg?v=1774347211",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/215M_Black.jpg?v=1774347211",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/215M/ProductCarouselMain/215M%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "215m_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686147338",
      "product_title": "Russell Athletic Classic Long Sleeve T-Shirt",
      "product_handle": "180l",
      "product_url": "/products/180l",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-180l",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "180L",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490372002058",
      "swatch_filename": "180l_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180l_Black.jpg?v=1774522756",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180l_Black.jpg?v=1774522756",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180L/ProductCarouselMain/180L%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180l_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473273266442",
      "swatch_filename": "180M_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Black.jpg?v=1774363124",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Black.jpg?v=1774363124",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546724618",
      "product_title": "Russell Athletic Heavyweight T-Shirt",
      "product_handle": "010m",
      "product_url": "/products/010m",
      "product_full_url": "https://oakdenemerch.com/products/010m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-010m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "010M",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468778348810",
      "swatch_filename": "010M_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/010M_Black.jpg?v=1774311231",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/010M_Black.jpg?v=1774311231",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/010M/ProductCarouselMain/010M%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "010m_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548199178",
      "product_title": "Russell Athletic Kids Classic Ringspun T-Shirt",
      "product_handle": "180b",
      "product_url": "/products/180b",
      "product_full_url": "https://oakdenemerch.com/products/180b",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "PCBest_Seller",
        "performance-activewear",
        "sports",
        "style-180b",
        "t-shirts"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.",
      "style_code": "180B",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474443575562",
      "swatch_filename": "180B_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_Black.jpg?v=1774371757",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_Black.jpg?v=1774371757",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180B/ProductCarouselMain/180B%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180b_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548231946",
      "product_title": "Russell Athletic Ladies Authentic Classic Ringspun T-Shirt",
      "product_handle": "180f",
      "product_url": "/products/180f",
      "product_full_url": "https://oakdenemerch.com/products/180f",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-180f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180F",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472623509770",
      "swatch_filename": "180F_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180F_Black.jpg?v=1774358324",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180F_Black.jpg?v=1774358324",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180F/ProductCarouselMain/180F%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180f_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687818506",
      "product_title": "SF Clothing Feel Good Stretch Long Sleeve T-Shirt",
      "product_handle": "sf124",
      "product_url": "/products/sf124",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-sf124",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane.",
      "style_code": "SF124",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490482102538",
      "swatch_filename": "sf124_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf124_Black.jpg?v=1774522979",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf124_Black.jpg?v=1774522979",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF124/ProductCarouselMain/SF124%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf124_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553081610",
      "product_title": "SF Clothing Feel Good Stretch Roll Neck Top",
      "product_handle": "sf125",
      "product_url": "/products/sf125",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-sf125",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane.",
      "style_code": "SF125",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491308904714",
      "swatch_filename": "sf125_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf125_Black.jpg?v=1774526478",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf125_Black.jpg?v=1774526478",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF125/ProductCarouselMain/SF125%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf125_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553016074",
      "product_title": "SF Clothing Feel Good Stretch T-Shirt",
      "product_handle": "sf121",
      "product_url": "/products/sf121",
      "product_full_url": "https://oakdenemerch.com/products/sf121",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-sf121",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane single jersey.*",
      "style_code": "SF121",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472270729482",
      "swatch_filename": "SF121_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF121_Black.jpg?v=1774354029",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF121_Black.jpg?v=1774354029",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF121/ProductCarouselMain/SF121%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf121_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553048842",
      "product_title": "SF Clothing Feel Good Stretch V Neck T-Shirt",
      "product_handle": "sf122",
      "product_url": "/products/sf122",
      "product_full_url": "https://oakdenemerch.com/products/sf122",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-sf122",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane.*",
      "style_code": "SF122",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471724617994",
      "swatch_filename": "SF122_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF122_Black.jpg?v=1774351145",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF122_Black.jpg?v=1774351145",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF122/ProductCarouselMain/SF122%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf122_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562494730",
      "product_title": "SF Clothing Feel Good Stretch Vest",
      "product_handle": "sf123",
      "product_url": "/products/sf123",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "sleeveless",
        "style-sf123",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane.*",
      "style_code": "SF123",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513932587274",
      "swatch_filename": "sf123_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf123_Black.jpg?v=1774619079",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf123_Black.jpg?v=1774619079",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF123/ProductCarouselMain/SF123%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf123_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562527498",
      "product_title": "SF Clothing High Neck Vest",
      "product_handle": "sf232",
      "product_url": "/products/sf232",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-sf232",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% polyester.*",
      "style_code": "SF232",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513933275402",
      "swatch_filename": "sf232_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf232_Black.jpg?v=1774619083",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf232_Black.jpg?v=1774619083",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF232/ProductCarouselMain/SF232%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf232_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553540362",
      "product_title": "SF Clothing Kids Cropped Top",
      "product_handle": "sm106",
      "product_url": "/products/sm106",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "11-12",
        "11-12-5-6-7-8-9-10",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-sm106",
        "t-shirts"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "93% cotton/7% elastane.",
      "style_code": "SM106",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491294060810",
      "swatch_filename": "sm106_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sm106_Black.jpg?v=1774526436",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sm106_Black.jpg?v=1774526436",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SM106/ProductCarouselMain/SM106%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sm106_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553573130",
      "product_title": "SF Clothing Kids Feel Good Stretch T-Shirt",
      "product_handle": "sm121",
      "product_url": "/products/sm121",
      "product_full_url": "https://oakdenemerch.com/products/sm121",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "11-12",
        "11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-sm121",
        "t-shirts"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane single jersey.",
      "style_code": "SM121",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474080178442",
      "swatch_filename": "SM121_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SM121_Black.jpg?v=1774368752",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SM121_Black.jpg?v=1774368752",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SM121/ProductCarouselMain/SM121%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sm121_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562920714",
      "product_title": "SF Clothing Kids Feel Good Stretch Vest",
      "product_handle": "sm123",
      "product_url": "/products/sm123",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "11-12",
        "11-12-5-6-7-8-9-10",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "sleeveless",
        "style-sm123",
        "t-shirts"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane.",
      "style_code": "SM123",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513936584970",
      "swatch_filename": "sm123_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sm123_Black.jpg?v=1774619138",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sm123_Black.jpg?v=1774619138",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SM123/ProductCarouselMain/SM123%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sm123_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553278218",
      "product_title": "SF Clothing Ladies Bandeau Top",
      "product_handle": "sk115",
      "product_url": "/products/sk115",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-sk115",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "93% cotton/7% elastane.",
      "style_code": "SK115",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491303268618",
      "swatch_filename": "sk115_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk115_Black.jpg?v=1774526464",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk115_Black.jpg?v=1774526464",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK115/ProductCarouselMain/SK115%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk115_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553474826",
      "product_title": "SF Clothing Ladies Cropped Boxy T-Shirt",
      "product_handle": "sk237",
      "product_url": "/products/sk237",
      "product_full_url": "https://oakdenemerch.com/products/sk237",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-sk237",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XXS",
        "XXS-XS-S-M-L-XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% polyester.",
      "style_code": "SK237",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474083160330",
      "swatch_filename": "SK237_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SK237_Black.jpg?v=1774368817",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SK237_Black.jpg?v=1774368817",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK237/ProductCarouselMain/SK237%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk237_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553245450",
      "product_title": "SF Clothing Ladies Cropped Top",
      "product_handle": "sk106",
      "product_url": "/products/sk106",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-sk106",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "93% cotton/7% elastane.",
      "style_code": "SK106",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491306479882",
      "swatch_filename": "sk106_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk106_Black.jpg?v=1774526470",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk106_Black.jpg?v=1774526470",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK106/ProductCarouselMain/SK106%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk106_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562887946",
      "product_title": "SF Clothing Ladies Fashion Workout Vest",
      "product_handle": "sk241",
      "product_url": "/products/sk241",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-sk241",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "90% polyester/10% elastane.",
      "style_code": "SK241",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513936257290",
      "swatch_filename": "sk241_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk241_Black.jpg?v=1774619132",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk241_Black.jpg?v=1774619132",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SF%20Clothing/SK241/ProductCarouselMain/SK241%20BLK%20FRONT.png",
      "match_source": "title/style + filename",
      "expected_filename": "sk241_Black.png"
    },
    {
      "product_id": "gid://shopify/Product/10457687884042",
      "product_title": "SF Clothing Ladies Feel Good Long Sleeve Stretch T-Shirt",
      "product_handle": "sk124",
      "product_url": "/products/sk124",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-sk124",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane.",
      "style_code": "SK124",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490484232458",
      "swatch_filename": "sk124_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk124_Black.jpg?v=1774522990",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk124_Black.jpg?v=1774522990",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK124/ProductCarouselMain/SK124%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk124_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553376522",
      "product_title": "SF Clothing Ladies Feel Good Stretch Roll Neck T-Shirt",
      "product_handle": "sk125",
      "product_url": "/products/sk125",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-sk125",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane.",
      "style_code": "SK125",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491301859594",
      "swatch_filename": "sk125_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk125_Black.jpg?v=1774526459",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk125_Black.jpg?v=1774526459",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK125/ProductCarouselMain/SK125%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk125_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562724106",
      "product_title": "SF Clothing Ladies Feel Good Stretch Spaghetti Vest",
      "product_handle": "sk126",
      "product_url": "/products/sk126",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-sk126",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane.",
      "style_code": "SK126",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513934586122",
      "swatch_filename": "sk126_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk126_Black.jpg?v=1774619107",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk126_Black.jpg?v=1774619107",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK126/ProductCarouselMain/SK126%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk126_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553343754",
      "product_title": "SF Clothing Ladies Feel Good Stretch V Neck T-Shirt",
      "product_handle": "sk122",
      "product_url": "/products/sk122",
      "product_full_url": "https://oakdenemerch.com/products/sk122",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-sk122",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane single jersey.*",
      "style_code": "SK122",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472236224778",
      "swatch_filename": "SK122_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SK122_Black.jpg?v=1774353925",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SK122_Black.jpg?v=1774353925",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK122/ProductCarouselMain/SK122%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk122_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562691338",
      "product_title": "SF Clothing Ladies Feel Good Stretch Vest",
      "product_handle": "sk123",
      "product_url": "/products/sk123",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-sk123",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane.*",
      "style_code": "SK123",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513934487818",
      "swatch_filename": "sk123_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk123_Black.jpg?v=1774619103",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk123_Black.jpg?v=1774619103",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK123/ProductCarouselMain/SK123%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk123_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562756874",
      "product_title": "SF Clothing Ladies High Neck Crop Vest",
      "product_handle": "sk170",
      "product_url": "/products/sk170",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-sk170",
        "t-shirts",
        "womens",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane.",
      "style_code": "SK170",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513934717194",
      "swatch_filename": "sk170_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk170_Black.jpg?v=1774619111",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk170_Black.jpg?v=1774619111",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK170/ProductCarouselMain/SK170%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk170_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562658570",
      "product_title": "SF Clothing Ladies One Shoulder Top",
      "product_handle": "sk116",
      "product_url": "/products/sk116",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-sk116",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "93% cotton/7% elastane.",
      "style_code": "SK116",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513934258442",
      "swatch_filename": "sk116_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk116_Black.jpg?v=1774619097",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk116_Black.jpg?v=1774619097",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK116/ProductCarouselMain/SK116%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk116_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562855178",
      "product_title": "SF Clothing Ladies Slounge Vest",
      "product_handle": "sk234",
      "product_url": "/products/sk234",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-sk234",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% polyester.",
      "style_code": "SK234",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513935798538",
      "swatch_filename": "sk234_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk234_Black.jpg?v=1774619127",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk234_Black.jpg?v=1774619127",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SF%20Clothing/SK234/ProductCarouselMain/SK234%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk234_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562789642",
      "product_title": "SF Clothing Ladies Sustainable Fashion Cropped Cami Vest Top",
      "product_handle": "sk230",
      "product_url": "/products/sk230",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-sk230",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly/Elastane",
      "shopify_material": "Cotton/Poly/Elastane",
      "csv_material": "48% regenerated cotton/47% recycled polyester/5% elastane.",
      "style_code": "SK230",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513935077642",
      "swatch_filename": "sk230_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk230_Black.jpg?v=1774619117",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk230_Black.jpg?v=1774619117",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK230/ProductCarouselMain/SK230%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk230_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553409290",
      "product_title": "SF Clothing Ladies Workout Crop Top",
      "product_handle": "sk235",
      "product_url": "/products/sk235",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "S",
        "S-M-L",
        "style-sk235",
        "t-shirts",
        "womens"
      ],
      "material": "Nylon/Elastane",
      "shopify_material": "Nylon/Elastane",
      "csv_material": "92% nylon/8% elastane.",
      "style_code": "SK235",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491299434762",
      "swatch_filename": "sk235_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk235_Black.jpg?v=1774526454",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk235_Black.jpg?v=1774526454",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SF%20Clothing/SK235/ProductCarouselMain/SK235%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk235_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553212682",
      "product_title": "SF Clothing Longline Dipped Hem T-Shirt",
      "product_handle": "sf258",
      "product_url": "/products/sf258",
      "product_full_url": "https://oakdenemerch.com/products/sf258",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-sf258",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SF258",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471718752522",
      "swatch_filename": "SF258_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF258_Black.jpg?v=1774351098",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF258_Black.jpg?v=1774351098",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF258/ProductCarouselMain/SF258%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf258_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562593034",
      "product_title": "SF Clothing Muscle Vest",
      "product_handle": "sf236",
      "product_url": "/products/sf236",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "sleeveless",
        "style-sf236",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% polyester.*",
      "style_code": "SF236",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513933668618",
      "swatch_filename": "sf236_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf236_Black.jpg?v=1774619090",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf236_Black.jpg?v=1774619090",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF236/ProductCarouselMain/SF236%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf236_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553147146",
      "product_title": "SF Clothing Unisex Organic T-Shirt",
      "product_handle": "sf140",
      "product_url": "/products/sf140",
      "product_full_url": "https://oakdenemerch.com/products/sf140",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-sf140",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "SF140",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473613267210",
      "swatch_filename": "SF140_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF140_Black.jpg?v=1774364427",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF140_Black.jpg?v=1774364427",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF140/ProductCarouselMain/SF140%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf140_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473588297994",
      "swatch_filename": "SR287_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Black.jpg?v=1774364344",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Black.jpg?v=1774364344",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554097418",
      "product_title": "Spiro Kids Impact Performance Aircool T-Shirt",
      "product_handle": "sr287b",
      "product_url": "/products/sr287b",
      "product_full_url": "https://oakdenemerch.com/products/sr287b",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "children",
        "kids",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287b",
        "t-shirts",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287B",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474059960586",
      "swatch_filename": "SR287B_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Black.jpg?v=1774368252",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Black.jpg?v=1774368252",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287B/ProductCarouselMain/SR287B%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287b_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687916810",
      "product_title": "Spiro Ladies Performance Long Sleeve T-Shirt",
      "product_handle": "sr254f",
      "product_url": "/products/sr254f",
      "product_full_url": "None",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr254f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester interlock.",
      "style_code": "SR254F",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490484592906",
      "swatch_filename": "sr254f_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr254f_Black.jpg?v=1774522995",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr254f_Black.jpg?v=1774522995",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR254F/ProductCarouselMain/SR254F%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr254f_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553671434",
      "product_title": "Spiro Ladies Quick Dry Performance T-Shirt",
      "product_handle": "sr253f",
      "product_url": "/products/sr253f",
      "product_full_url": "https://oakdenemerch.com/products/sr253f",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr253f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester interlock.",
      "style_code": "SR253F",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474072969482",
      "swatch_filename": "SR253F_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR253F_Black.jpg?v=1774368615",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR253F_Black.jpg?v=1774368615",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR253F/ProductCarouselMain/SR253F%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr253f_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553704202",
      "product_title": "Spiro Quick Dry Performance T-Shirt",
      "product_handle": "sr253m",
      "product_url": "/products/sr253m",
      "product_full_url": "https://oakdenemerch.com/products/sr253m",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-sr253m",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester interlock.",
      "style_code": "SR253M",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471706890506",
      "swatch_filename": "SR253M_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR253M_Black.jpg?v=1774351026",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR253M_Black.jpg?v=1774351026",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR253M/ProductCarouselMain/SR253M%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr253m_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686540554",
      "product_title": "Stormtech Equinox Long Sleeve T-Shirt",
      "product_handle": "cpm2",
      "product_url": "/products/cpm2",
      "product_full_url": "https://oakdenemerch.com/products/cpm2",
      "vendor": "Stormtech",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-cpm2",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "60% BCI cotton/40% polyester.",
      "style_code": "CPM2",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490413322506",
      "swatch_filename": "cpm2_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cpm2_Black.jpg?v=1774522789",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cpm2_Black.jpg?v=1774522789",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Stormtech/Product%20Images/CPM2/ProductCarouselMain/CPM2%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cpm2_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556981002",
      "product_title": "Tee Jays CoolDry™ T-Shirt",
      "product_handle": "t7020",
      "product_url": "/products/t7020",
      "product_full_url": "https://oakdenemerch.com/products/t7020",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t7020",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7020",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49469011919114",
      "swatch_filename": "T7020_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_Black.jpg?v=1774315920",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_Black.jpg?v=1774315920",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7020/ProductCarouselMain/T7020%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7020_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557374218",
      "product_title": "Tee Jays Fashion Sof T-Shirt",
      "product_handle": "t8005",
      "product_url": "/products/t8005",
      "product_full_url": "https://oakdenemerch.com/products/t8005",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t8005",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T8005",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49470730895626",
      "swatch_filename": "T8005_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8005_Black.jpg?v=1774345393",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8005_Black.jpg?v=1774345393",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8005/ProductCarouselMain/T8005%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8005_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471257313546",
      "swatch_filename": "T520_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Black.jpg?v=1774348349",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Black.jpg?v=1774348349",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557079306",
      "product_title": "Tee Jays Ladies CoolDry™ T-Shirt",
      "product_handle": "t7021",
      "product_url": "/products/t7021",
      "product_full_url": "https://oakdenemerch.com/products/t7021",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-t7021",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7021",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471676317962",
      "swatch_filename": "T7021_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_Black.jpg?v=1774350799",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_Black.jpg?v=1774350799",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7021/ProductCarouselMain/T7021%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7021_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556587786",
      "product_title": "Tee Jays Ladies Interlock T-Shirt",
      "product_handle": "t580",
      "product_url": "/products/t580",
      "product_full_url": "https://oakdenemerch.com/products/t580",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t580",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T580",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49469002219786",
      "swatch_filename": "T580_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Black.jpg?v=1774315823",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Black.jpg?v=1774315823",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T580/ProductCarouselMain/T580%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t580_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688703242",
      "product_title": "Tee Jays Ladies Long Sleeve Interlock T-Shirt",
      "product_handle": "t590",
      "product_url": "/products/t590",
      "product_full_url": "https://oakdenemerch.com/products/t590",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t590",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T590",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490491769098",
      "swatch_filename": "t590_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t590_Black.jpg?v=1774523107",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t590_Black.jpg?v=1774523107",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T590/ProductCarouselMain/T590%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t590_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555244298",
      "product_title": "Tee Jays Ladies Pima Cotton T-Shirt",
      "product_handle": "t1451",
      "product_url": "/products/t1451",
      "product_full_url": "https://oakdenemerch.com/products/t1451",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t1451",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed pima cotton.",
      "style_code": "T1451",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468966240522",
      "swatch_filename": "T1451_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1451_Black.jpg?v=1774315340",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1451_Black.jpg?v=1774315340",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1451/ProductCarouselMain/T1451%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1451_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555768586",
      "product_title": "Tee Jays Ladies Roll-Up T-Shirt",
      "product_handle": "t5063",
      "product_url": "/products/t5063",
      "product_full_url": "https://oakdenemerch.com/products/t5063",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "hospitality",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-t5063",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T5063",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471685951754",
      "swatch_filename": "T5063_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5063_Black.jpg?v=1774350892",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5063_Black.jpg?v=1774350892",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5063/ProductCarouselMain/T5063%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5063_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557439754",
      "product_title": "Tee Jays Ladies Sof T-Shirt",
      "product_handle": "t8050",
      "product_url": "/products/t8050",
      "product_full_url": "https://oakdenemerch.com/products/t8050",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t8050",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T8050",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49470794301706",
      "swatch_filename": "T8050_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8050_Black.jpg?v=1774345776",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8050_Black.jpg?v=1774345776",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8050/ProductCarouselMain/T8050%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8050_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555571978",
      "product_title": "Tee Jays Ladies Stretch 3/4 Sleeve T-Shirt",
      "product_handle": "t460",
      "product_url": "/products/t460",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t460",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "90% ringspun combed cotton/10% elastane.",
      "style_code": "T460",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491210830090",
      "swatch_filename": "t460_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t460_Black.jpg?v=1774526231",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t460_Black.jpg?v=1774526231",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T460/ProductCarouselMain/T460%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t460_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555440906",
      "product_title": "Tee Jays Ladies Stretch T-Shirt",
      "product_handle": "t450",
      "product_url": "/products/t450",
      "product_full_url": "https://oakdenemerch.com/products/t450",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t450",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "90% ringspun combed cotton/10% elastane.",
      "style_code": "T450",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468979970314",
      "swatch_filename": "T450_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T450_Black.jpg?v=1774315491",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T450_Black.jpg?v=1774315491",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T450/ProductCarouselMain/T450%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t450_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688736010",
      "product_title": "Tee Jays Long Sleeve CoolDry™ T-Shirt",
      "product_handle": "t7022",
      "product_url": "/products/t7022",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-t7022",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7022",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490492391690",
      "swatch_filename": "t7022_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t7022_Black.jpg?v=1774523116",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t7022_Black.jpg?v=1774523116",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7022/ProductCarouselMain/T7022%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7022_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688670474",
      "product_title": "Tee Jays Long Sleeve Interlock T-Shirt",
      "product_handle": "t530",
      "product_url": "/products/t530",
      "product_full_url": "https://oakdenemerch.com/products/t530",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t530",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T530",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490491506954",
      "swatch_filename": "t530_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t530_Black.jpg?v=1774523101",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t530_Black.jpg?v=1774523101",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T530/ProductCarouselMain/T530%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t530_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688801546",
      "product_title": "Tee Jays Long Sleeve Sof T-Shirt",
      "product_handle": "t8007",
      "product_url": "/products/t8007",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t8007",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T8007",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490493178122",
      "swatch_filename": "t8007_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t8007_Black.jpg?v=1774523123",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t8007_Black.jpg?v=1774523123",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8007/ProductCarouselMain/T8007%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8007_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555637514",
      "product_title": "Tee Jays Luxury Cotton T-Shirt",
      "product_handle": "t5000",
      "product_url": "/products/t5000",
      "product_full_url": "https://oakdenemerch.com/products/t5000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T5000",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468986589450",
      "swatch_filename": "T5000_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5000_Black.jpg?v=1774315592",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5000_Black.jpg?v=1774315592",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5000/ProductCarouselMain/T5000%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5000_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555178762",
      "product_title": "Tee Jays Pima Cotton T-Shirt",
      "product_handle": "t1450",
      "product_url": "/products/t1450",
      "product_full_url": "https://oakdenemerch.com/products/t1450",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t1450",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed pima cotton.",
      "style_code": "T1450",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468963225866",
      "swatch_filename": "T1450_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1450_Black.jpg?v=1774315272",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1450_Black.jpg?v=1774315272",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1450/ProductCarouselMain/T1450%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1450_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555735818",
      "product_title": "Tee Jays Roll-Up T-Shirt",
      "product_handle": "t5062",
      "product_url": "/products/t5062",
      "product_full_url": "https://oakdenemerch.com/products/t5062",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "hospitality",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5062",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T5062",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468994355466",
      "swatch_filename": "T5062_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5062_Black.jpg?v=1774315684",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5062_Black.jpg?v=1774315684",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5062/ProductCarouselMain/T5062%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5062_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557341450",
      "product_title": "Tee Jays Sof T-Shirt",
      "product_handle": "t8000",
      "product_url": "/products/t8000",
      "product_full_url": "https://oakdenemerch.com/products/t8000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t8000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T8000",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471239029002",
      "swatch_filename": "T8000_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Black.jpg?v=1774348259",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Black.jpg?v=1774348259",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8000/ProductCarouselMain/T8000%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8000_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555342602",
      "product_title": "Tee Jays Stretch T-Shirt",
      "product_handle": "t400",
      "product_url": "/products/t400",
      "product_full_url": "https://oakdenemerch.com/products/t400",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t400",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "90% ringspun combed cotton/10% elastane.",
      "style_code": "T400",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468974301450",
      "swatch_filename": "T400_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T400_Black.jpg?v=1774315420",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T400_Black.jpg?v=1774315420",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T400/ProductCarouselMain/T400%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t400_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554785546",
      "product_title": "Tee Jays Unlabeled Loose Fit T-Shirt",
      "product_handle": "t1160",
      "product_url": "/products/t1160",
      "product_full_url": "https://oakdenemerch.com/products/t1160",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t1160",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T1160",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468958703882",
      "swatch_filename": "T1160_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1160_Black.jpg?v=1774315207",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1160_Black.jpg?v=1774315207",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1160/ProductCarouselMain/T1160%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1160_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474052587786",
      "swatch_filename": "T1150_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Black.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Black.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554720010",
      "product_title": "Tee Jays Unlabelled T-Shirt",
      "product_handle": "t1140",
      "product_url": "/products/t1140",
      "product_full_url": "https://oakdenemerch.com/products/t1140",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1140",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T1140",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474054619402",
      "swatch_filename": "T1140_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1140_Black.jpg?v=1774368141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1140_Black.jpg?v=1774368141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1140/ProductCarouselMain/T1140%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1140_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557406986",
      "product_title": "Tee Jays V Neck Sof T-Shirt",
      "product_handle": "t8006",
      "product_url": "/products/t8006",
      "product_full_url": "https://oakdenemerch.com/products/t8006",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t8006",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T8006",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49470768611594",
      "swatch_filename": "T8006_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8006_Black.jpg?v=1774345593",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8006_Black.jpg?v=1774345593",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8006/ProductCarouselMain/T8006%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8006_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558455562",
      "product_title": "Tombo Kids Seamless Crop Top",
      "product_handle": "tl697",
      "product_url": "/products/tl697",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "11-13",
        "11-13-5-6-7-8-9-10",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "knitwear",
        "style-tl697",
        "t-shirts"
      ],
      "material": "Nylon/Elastane",
      "shopify_material": "Nylon/Elastane",
      "csv_material": "89% nylon/11% elastane.",
      "style_code": "TL697",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491001442570",
      "swatch_filename": "tl697_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl697_Black.jpg?v=1774525748",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl697_Black.jpg?v=1774525748",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL697/ProductCarouselMain/TL697%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl697_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458563150090",
      "product_title": "Tombo Ladies Open Back Vest",
      "product_handle": "tl507",
      "product_url": "/products/tl507",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-tl507",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Rayon",
      "shopify_material": "Poly/Rayon",
      "csv_material": "65% polyester/35% rayon.",
      "style_code": "TL507",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513938649354",
      "swatch_filename": "tl507_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl507_Black.jpg?v=1774619171",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl507_Black.jpg?v=1774619171",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL507/ProductCarouselMain/TL507%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl507_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558258954",
      "product_title": "Tombo Ladies Over T-Shirt",
      "product_handle": "tl526",
      "product_url": "/products/tl526",
      "product_full_url": "https://oakdenemerch.com/products/tl526",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "style-tl526",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "90% polyester/10% elastane.",
      "style_code": "TL526",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472023462154",
      "swatch_filename": "TL526_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/TL526_Black.jpg?v=1774353401",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/TL526_Black.jpg?v=1774353401",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL526/ProductCarouselMain/TL526%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl526_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558422794",
      "product_title": "Tombo Ladies Seamless Crop Top",
      "product_handle": "tl696",
      "product_url": "/products/tl696",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "S",
        "style-tl696",
        "t-shirts",
        "womens",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "89% polyester/11% elastane.",
      "style_code": "TL696",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491003998474",
      "swatch_filename": "tl696_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl696_Black.jpg?v=1774525753",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl696_Black.jpg?v=1774525753",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL696/ProductCarouselMain/TL696%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl696_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558193418",
      "product_title": "Tombo Medium Impact Core Bra",
      "product_handle": "tl371",
      "product_url": "/products/tl371",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-tl371",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "86% polyester/14% elastane interlock.",
      "style_code": "TL371",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491007406346",
      "swatch_filename": "tl371_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl371_Black.jpg?v=1774525766",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl371_Black.jpg?v=1774525766",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL371/ProductCarouselMain/TL371%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl371_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458563084554",
      "product_title": "Tombo Muscle Vest",
      "product_handle": "tl504",
      "product_url": "/products/tl504",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "sleeveless",
        "style-tl504",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "90% polyester/10% elastane.",
      "style_code": "TL504",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513938190602",
      "swatch_filename": "tl504_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl504_Black.jpg?v=1774619161",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl504_Black.jpg?v=1774619161",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL504/ProductCarouselMain/TL504%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl504_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558324490",
      "product_title": "Tombo Scoop Neck T-Shirt",
      "product_handle": "tl527",
      "product_url": "/products/tl527",
      "product_full_url": "https://oakdenemerch.com/products/tl527",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-tl527",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Viscose/Polyurethane",
      "shopify_material": "Poly/Viscose/Polyurethane",
      "csv_material": "68% polyester/28% viscose/4% polyurethane.",
      "style_code": "TL527",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472774275338",
      "swatch_filename": "TL527_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/TL527_Black.jpg?v=1774359511",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/TL527_Black.jpg?v=1774359511",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL527/ProductCarouselMain/TL527%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl527_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558357258",
      "product_title": "Tombo Unisex Recycled Performance T-Shirt",
      "product_handle": "tl545",
      "product_url": "/products/tl545",
      "product_full_url": "https://oakdenemerch.com/products/tl545",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "recycled",
        "S",
        "sports",
        "style-tl545",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester interlock.",
      "style_code": "TL545",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472019333386",
      "swatch_filename": "TL545_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/TL545_Black.jpg?v=1774353321",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/TL545_Black.jpg?v=1774353321",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL545/ProductCarouselMain/TL545%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl545_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688834314",
      "product_title": "Warrior Thermal Long Sleeve T-Shirt",
      "product_handle": "wr202",
      "product_url": "/products/wr202",
      "product_full_url": "None",
      "vendor": "Warrior",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "sports",
        "style-wr202",
        "t-shirts",
        "underwear-thermals",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Viscose",
      "shopify_material": "Poly/Viscose",
      "csv_material": "80% polyester/20% viscose.",
      "style_code": "WR202",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490493604106",
      "swatch_filename": "wr202_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/wr202_Black.jpg?v=1774523128",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/wr202_Black.jpg?v=1774523128",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Warrior/Product%20Images/WR202/ProductCarouselMain/WR202%20BLK%20FRONT%203.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "wr202_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558586634",
      "product_title": "Warrior Thermal Short Sleeve T-Shirt",
      "product_handle": "wr201",
      "product_url": "/products/wr201",
      "product_full_url": "https://oakdenemerch.com/products/wr201",
      "vendor": "Warrior",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "sports",
        "style-wr201",
        "t-shirts",
        "underwear-thermals",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Viscose",
      "shopify_material": "Poly/Viscose",
      "csv_material": "80% polyester/20% viscose.",
      "style_code": "WR201",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468754100490",
      "swatch_filename": "WR201_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/WR201_Black.jpg?v=1774310802",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/WR201_Black.jpg?v=1774310802",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Warrior/Product%20Images/WR201/ProductCarouselMain/WR201%20BLK%20FRONT%203.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "wr201_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558488330",
      "product_title": "WK Designed to Work Anti-Bacterial Short Sleeve T-Shirt",
      "product_handle": "wk306",
      "product_url": "/products/wk306",
      "product_full_url": "https://oakdenemerch.com/products/wk306",
      "vendor": "WK Designed To Work",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-wk306",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% combed cotton.",
      "style_code": "WK306",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49470913478922",
      "swatch_filename": "WK306_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/WK306_Black.jpg?v=1774346721",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/WK306_Black.jpg?v=1774346721",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/WK%20Designed%20to%20Work/Product%20Images/WK306/ProductCarouselMain/WK306%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "wk306_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551541514",
      "product_title": "Kustom Kit Cooltex® T-Shirt",
      "product_handle": "k991",
      "product_url": "/products/k991",
      "product_full_url": "https://oakdenemerch.com/products/k991",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-k991",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "K991",
      "colour_name": "Black/Black",
      "colour_group": "Black > Black",
      "rgb": "#000000;#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472789283082",
      "swatch_filename": "K991_BlackBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K991_BlackBlack.jpg?v=1774359773",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K991_BlackBlack.jpg?v=1774359773",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K991/ProductCarouselMain/K991%20BK%252fBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k991_BlackBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553638666",
      "product_title": "SF Clothing Kids Fashion Crop Top",
      "product_handle": "sm236",
      "product_url": "/products/sm236",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "11-12",
        "11-12-5-6-7-8-9-10",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-sm236",
        "t-shirts"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "88% polyester/12% elastane.",
      "style_code": "SM236",
      "colour_name": "Black/Black",
      "colour_group": "Black > Black",
      "rgb": "#000000;#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491289080074",
      "swatch_filename": "sm236_BlackBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sm236_BlackBlack.jpg?v=1774526425",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sm236_BlackBlack.jpg?v=1774526425",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SM236/ProductCarouselMain/SM236%20BK%252fBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sm236_BlackBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553442058",
      "product_title": "SF Clothing Ladies Fashion Crop Top",
      "product_handle": "sk236",
      "product_url": "/products/sk236",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-sk236",
        "t-shirts",
        "womens",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "88% polyester/12% elastane single jersey.",
      "style_code": "SK236",
      "colour_name": "Black/Black",
      "colour_group": "Black > Black",
      "rgb": "#000000;#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491297009930",
      "swatch_filename": "sk236_BlackBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk236_BlackBlack.jpg?v=1774526446",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk236_BlackBlack.jpg?v=1774526446",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK236/ProductCarouselMain/SK236%20BK%252fBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk236_BlackBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558226186",
      "product_title": "Tombo Slim Fit T-Shirt",
      "product_handle": "tl515",
      "product_url": "/products/tl515",
      "product_full_url": "https://oakdenemerch.com/products/tl515",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-tl515",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "90% polyester/10% elastane.",
      "style_code": "TL515",
      "colour_name": "Black/Black",
      "colour_group": "Black > Black",
      "rgb": "#000000;#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471641387274",
      "swatch_filename": "TL515_BlackBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/TL515_BlackBlack.jpg?v=1774350550",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/TL515_BlackBlack.jpg?v=1774350550",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL515/ProductCarouselMain/TL515%20BK%252fBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl515_BlackBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547707658",
      "product_title": "SOL'S Ladies Vortex Ripstop Performance T-Shirt",
      "product_handle": "04788",
      "product_url": "/products/04788",
      "product_full_url": "https://oakdenemerch.com/products/04788",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04788",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04788",
      "colour_name": "Black/Charcoal",
      "colour_group": "Black > Black",
      "rgb": "#131a24;#0b0e14",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472651952394",
      "swatch_filename": "04788_BlackCharcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_BlackCharcoal.jpg?v=1774358494",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_BlackCharcoal.jpg?v=1774358494",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04788/ProductCarouselMain/04788%20BK_CH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04788_BlackCharcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547674890",
      "product_title": "SOL'S Vortex Ripstop Performance T-Shirt",
      "product_handle": "04787",
      "product_url": "/products/04787",
      "product_full_url": "https://oakdenemerch.com/products/04787",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04787",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04787",
      "colour_name": "Black/Charcoal",
      "colour_group": "Black > Black",
      "rgb": "#131a24;#0b0e14",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472658145546",
      "swatch_filename": "04787_BlackCharcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_BlackCharcoal.jpg?v=1774358538",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_BlackCharcoal.jpg?v=1774358538",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04787/ProductCarouselMain/04787%20BK_CH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04787_BlackCharcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551836426",
      "product_title": "Finden + Hales Kids Team T-Shirt",
      "product_handle": "lv292",
      "product_url": "/products/lv292",
      "product_full_url": "https://oakdenemerch.com/products/lv292",
      "vendor": "Finden + Hales",
      "product_type": "T-Shirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-lv292",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "LV292",
      "colour_name": "Black/Emerald",
      "colour_group": "Black > Black",
      "rgb": "#000000;#1c8b38",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474137129226",
      "swatch_filename": "LV292_BlackEmerald.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV292_BlackEmerald.jpg?v=1774369540",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV292_BlackEmerald.jpg?v=1774369540",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV292/ProductCarouselMain/LV292%20BK%252fEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv292_BlackEmerald.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551803658",
      "product_title": "Finden + Hales Unisex Team T-Shirt",
      "product_handle": "lv290",
      "product_url": "/products/lv290",
      "product_full_url": "https://oakdenemerch.com/products/lv290",
      "vendor": "Finden + Hales",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv290",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "LV290",
      "colour_name": "Black/Emerald",
      "colour_group": "Black > Black",
      "rgb": "#000000;#1c8b38",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472784498954",
      "swatch_filename": "LV290_BlackEmerald.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV290_BlackEmerald.jpg?v=1774359680",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV290_BlackEmerald.jpg?v=1774359680",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV290/ProductCarouselMain/LV290%20BK%252fEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv290_BlackEmerald.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551836426",
      "product_title": "Finden + Hales Kids Team T-Shirt",
      "product_handle": "lv292",
      "product_url": "/products/lv292",
      "product_full_url": "https://oakdenemerch.com/products/lv292",
      "vendor": "Finden + Hales",
      "product_type": "T-Shirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-lv292",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "LV292",
      "colour_name": "Black/Gold",
      "colour_group": "Black > Black",
      "rgb": "#000000;#ffa312",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474137358602",
      "swatch_filename": "LV292_BlackGold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV292_BlackGold.jpg?v=1774369540",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV292_BlackGold.jpg?v=1774369540",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV292/ProductCarouselMain/LV292%20BK%252fGO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv292_BlackGold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551803658",
      "product_title": "Finden + Hales Unisex Team T-Shirt",
      "product_handle": "lv290",
      "product_url": "/products/lv290",
      "product_full_url": "https://oakdenemerch.com/products/lv290",
      "vendor": "Finden + Hales",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv290",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "LV290",
      "colour_name": "Black/Gold",
      "colour_group": "Black > Black",
      "rgb": "#000000;#ffa312",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472784400650",
      "swatch_filename": "LV290_BlackGold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV290_BlackGold.jpg?v=1774359680",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV290_BlackGold.jpg?v=1774359680",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV290/ProductCarouselMain/LV290%20BK%252fGO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv290_BlackGold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547969802",
      "product_title": "SOL'S Funky Contrast Baseball T-Shirt",
      "product_handle": "11190",
      "product_url": "/products/11190",
      "product_full_url": "https://oakdenemerch.com/products/11190",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11190",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "Body 100% ringspun semi-combed cotton. Sleeves 85% cotton/15% viscose",
      "style_code": "11190",
      "colour_name": "Black/Grey",
      "colour_group": "Black > Black",
      "rgb": "#131a24;#707070",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468904833290",
      "swatch_filename": "11190_BlackGrey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11190_BlackGrey.jpg?v=1774312736",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11190_BlackGrey.jpg?v=1774312736",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11190/ProductCarouselMain/11190%20BK%252fGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11190_BlackGrey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551836426",
      "product_title": "Finden + Hales Kids Team T-Shirt",
      "product_handle": "lv292",
      "product_url": "/products/lv292",
      "product_full_url": "https://oakdenemerch.com/products/lv292",
      "vendor": "Finden + Hales",
      "product_type": "T-Shirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-lv292",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "LV292",
      "colour_name": "Black/Gunmetal",
      "colour_group": "Black > Black",
      "rgb": "#000000;#445156",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474137260298",
      "swatch_filename": "LV292_BlackGunmetal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV292_BlackGunmetal.jpg?v=1774369540",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV292_BlackGunmetal.jpg?v=1774369540",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV292/ProductCarouselMain/LV292%20BK%252fGT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv292_BlackGunmetal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551803658",
      "product_title": "Finden + Hales Unisex Team T-Shirt",
      "product_handle": "lv290",
      "product_url": "/products/lv290",
      "product_full_url": "https://oakdenemerch.com/products/lv290",
      "vendor": "Finden + Hales",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv290",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "LV290",
      "colour_name": "Black/Gunmetal",
      "colour_group": "Black > Black",
      "rgb": "#000000;#445156",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472784367882",
      "swatch_filename": "LV290_BlackGunmetal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV290_BlackGunmetal.jpg?v=1774359680",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV290_BlackGunmetal.jpg?v=1774359680",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV290/ProductCarouselMain/LV290%20BK%252fGT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv290_BlackGunmetal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551541514",
      "product_title": "Kustom Kit Cooltex® T-Shirt",
      "product_handle": "k991",
      "product_url": "/products/k991",
      "product_full_url": "https://oakdenemerch.com/products/k991",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-k991",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "K991",
      "colour_name": "Black/Lime Green",
      "colour_group": "Black > Black",
      "rgb": "#000000;#c2ff6e",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472789348618",
      "swatch_filename": "K991_BlackLime_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K991_BlackLime_Green.jpg?v=1774359774",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K991_BlackLime_Green.jpg?v=1774359774",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K991/ProductCarouselMain/K991%20BK%252fLM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k991_BlackLime_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551541514",
      "product_title": "Kustom Kit Cooltex® T-Shirt",
      "product_handle": "k991",
      "product_url": "/products/k991",
      "product_full_url": "https://oakdenemerch.com/products/k991",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-k991",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "K991",
      "colour_name": "Black/Orange",
      "colour_group": "Black > Black",
      "rgb": "#000000;#ff6308",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472789414154",
      "swatch_filename": "K991_BlackOrange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K991_BlackOrange.jpg?v=1774359773",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K991_BlackOrange.jpg?v=1774359773",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K991/ProductCarouselMain/K991%20BK%252fOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k991_BlackOrange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551836426",
      "product_title": "Finden + Hales Kids Team T-Shirt",
      "product_handle": "lv292",
      "product_url": "/products/lv292",
      "product_full_url": "https://oakdenemerch.com/products/lv292",
      "vendor": "Finden + Hales",
      "product_type": "T-Shirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-lv292",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "LV292",
      "colour_name": "Black/Red",
      "colour_group": "Black > Black",
      "rgb": "#000000;#f5002f",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474137194762",
      "swatch_filename": "LV292_BlackRed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV292_BlackRed.jpg?v=1774369540",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV292_BlackRed.jpg?v=1774369540",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV292/ProductCarouselMain/LV292%20BK%252fRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv292_BlackRed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551803658",
      "product_title": "Finden + Hales Unisex Team T-Shirt",
      "product_handle": "lv290",
      "product_url": "/products/lv290",
      "product_full_url": "https://oakdenemerch.com/products/lv290",
      "vendor": "Finden + Hales",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv290",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "LV290",
      "colour_name": "Black/Red",
      "colour_group": "Black > Black",
      "rgb": "#000000;#f5002f",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472784531722",
      "swatch_filename": "LV290_BlackRed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV290_BlackRed.jpg?v=1774359680",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV290_BlackRed.jpg?v=1774359680",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV290/ProductCarouselMain/LV290%20BK%252fRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv290_BlackRed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551541514",
      "product_title": "Kustom Kit Cooltex® T-Shirt",
      "product_handle": "k991",
      "product_url": "/products/k991",
      "product_full_url": "https://oakdenemerch.com/products/k991",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-k991",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "K991",
      "colour_name": "Black/Red",
      "colour_group": "Black > Black",
      "rgb": "#000000;#e00053",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472789315850",
      "swatch_filename": "K991_BlackRed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K991_BlackRed.jpg?v=1774359773",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K991_BlackRed.jpg?v=1774359773",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K991/ProductCarouselMain/K991%20BK%252fRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k991_BlackRed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547969802",
      "product_title": "SOL'S Funky Contrast Baseball T-Shirt",
      "product_handle": "11190",
      "product_url": "/products/11190",
      "product_full_url": "https://oakdenemerch.com/products/11190",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11190",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11190",
      "colour_name": "Black/Red",
      "colour_group": "Black > Black",
      "rgb": "#131a24;#c90546",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468904702218",
      "swatch_filename": "11190_BlackRed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11190_BlackRed.jpg?v=1774312736",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11190_BlackRed.jpg?v=1774312736",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11190/ProductCarouselMain/11190%20BK%252fRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11190_BlackRed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551770890",
      "product_title": "Finden + Hales Performance Panel T-Shirt",
      "product_handle": "lv240",
      "product_url": "/products/lv240",
      "product_full_url": "https://oakdenemerch.com/products/lv240",
      "vendor": "Finden + Hales",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-lv240",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "LV240",
      "colour_name": "Black/Red/White",
      "colour_group": "Black > Black",
      "rgb": "#000000;#ff0000;#ffffff",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472787218698",
      "swatch_filename": "LV240_BlackRedWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV240_BlackRedWhite.jpg?v=1774359730",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV240_BlackRedWhite.jpg?v=1774359730",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV240/ProductCarouselMain/LV240%20B%252fR%252fW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv240_BlackRedWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548952842",
      "product_title": "Canvas Unisex 3/4 Sleeve Baseball T-Shirt",
      "product_handle": "cv3200",
      "product_url": "/products/cv3200",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv3200",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "CV3200",
      "colour_name": "Black/White",
      "colour_group": "Black > Black",
      "rgb": "#000000;#ffffff",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491485032714",
      "swatch_filename": "cv3200_BlackWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3200_BlackWhite.jpg?v=1774526775",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3200_BlackWhite.jpg?v=1774526775",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3200/ProductCarouselMain/CV3200%20BK%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3200_BlackWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551836426",
      "product_title": "Finden + Hales Kids Team T-Shirt",
      "product_handle": "lv292",
      "product_url": "/products/lv292",
      "product_full_url": "https://oakdenemerch.com/products/lv292",
      "vendor": "Finden + Hales",
      "product_type": "T-Shirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-lv292",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "LV292",
      "colour_name": "Black/White",
      "colour_group": "Black > Black",
      "rgb": "#000000;#ffffff",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474137293066",
      "swatch_filename": "LV292_BlackWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV292_BlackWhite.jpg?v=1774369540",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV292_BlackWhite.jpg?v=1774369540",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV292/ProductCarouselMain/LV292%20BK%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv292_BlackWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551803658",
      "product_title": "Finden + Hales Unisex Team T-Shirt",
      "product_handle": "lv290",
      "product_url": "/products/lv290",
      "product_full_url": "https://oakdenemerch.com/products/lv290",
      "vendor": "Finden + Hales",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv290",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "LV290",
      "colour_name": "Black/White",
      "colour_group": "Black > Black",
      "rgb": "#000000;#ffffff",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472784564490",
      "swatch_filename": "LV290_BlackWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV290_BlackWhite.jpg?v=1774359681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV290_BlackWhite.jpg?v=1774359681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV290/ProductCarouselMain/LV290%20BK%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv290_BlackWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554294026",
      "product_title": "Fruit of the Loom Contrast Ringer T-Shirt",
      "product_handle": "ss34",
      "product_url": "/products/ss34",
      "product_full_url": "https://oakdenemerch.com/products/ss34",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss34",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS34",
      "colour_name": "Black/White",
      "colour_group": "Black > Black",
      "rgb": "#0f1315;#ffffff",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468953133322",
      "swatch_filename": "SS34_BlackWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS34_BlackWhite.jpg?v=1774315005",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS34_BlackWhite.jpg?v=1774315005",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS34/ProductCarouselMain/SS34%20BK%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss34_BlackWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551082762",
      "product_title": "Kustom Kit Fashion Fit Ringer T-Shirt",
      "product_handle": "k508",
      "product_url": "/products/k508",
      "product_full_url": "https://oakdenemerch.com/products/k508",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-k508",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton.",
      "style_code": "K508",
      "colour_name": "Black/White",
      "colour_group": "Black > Black",
      "rgb": "#000000;#ffffff",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472290652426",
      "swatch_filename": "K508_BlackWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K508_BlackWhite.jpg?v=1774354444",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K508_BlackWhite.jpg?v=1774354444",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K508/ProductCarouselMain/K508%20BK%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k508_BlackWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553638666",
      "product_title": "SF Clothing Kids Fashion Crop Top",
      "product_handle": "sm236",
      "product_url": "/products/sm236",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "11-12",
        "11-12-5-6-7-8-9-10",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-sm236",
        "t-shirts"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "88% polyester/12% elastane.",
      "style_code": "SM236",
      "colour_name": "Black/White",
      "colour_group": "Black > Black",
      "rgb": "#000000;#ffffff",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491290063114",
      "swatch_filename": "sm236_BlackWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sm236_BlackWhite.jpg?v=1774526426",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sm236_BlackWhite.jpg?v=1774526426",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SM236/ProductCarouselMain/SM236%20BK%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sm236_BlackWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553868042",
      "product_title": "Spiro Basketball Top",
      "product_handle": "sr278m",
      "product_url": "/products/sr278m",
      "product_full_url": "None",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "lightweight",
        "M",
        "S",
        "style-sr278m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "SR278M",
      "colour_name": "Black/White",
      "colour_group": "Black > Black",
      "rgb": "#000000;#ffffff",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491285475594",
      "swatch_filename": "sr278m_BlackWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr278m_BlackWhite.jpg?v=1774526414",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr278m_BlackWhite.jpg?v=1774526414",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR278M/ProductCarouselMain/SR278M%20BK%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr278m_BlackWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552590090",
      "product_title": "Premier Unisex Utility 2.0 Oversized T-Shirt",
      "product_handle": "pr020",
      "product_url": "/products/pr020",
      "product_full_url": "https://oakdenemerch.com/products/pr020",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-pr020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% BCI cotton.",
      "style_code": "PR020",
      "colour_name": "Black/White Stripe",
      "colour_group": "Patterns > Stripes",
      "rgb": "#000000;#ffffff",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473100218634",
      "swatch_filename": "PR020_BlackWhite_Stripe.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR020_BlackWhite_Stripe.jpg?v=1774361960",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR020_BlackWhite_Stripe.jpg?v=1774361960",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR020/ProductCarouselMain/PR020%20B_WST%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr020_BlackWhite_Stripe.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550099722",
      "product_title": "AWDis Cool Contrast Wicking T-Shirt",
      "product_handle": "jc003",
      "product_url": "/products/jc003",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003",
      "colour_name": "Charcoal/Jet Black",
      "colour_group": "Grey > Charcoal",
      "rgb": "#15221d;#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491404390666",
      "swatch_filename": "jc003_CharcoalJet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_CharcoalJet_Black.jpg?v=1774526721",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_CharcoalJet_Black.jpg?v=1774526721",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003/ProductCarouselMain/JC003%20CH%252fJB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003_CharcoalJet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550099722",
      "product_title": "AWDis Cool Contrast Wicking T-Shirt",
      "product_handle": "jc003",
      "product_url": "/products/jc003",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003",
      "colour_name": "Electric Yellow/Jet Black",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#cffa03;#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491405078794",
      "swatch_filename": "jc003_Electric_YellowJet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Electric_YellowJet_Black.jpg?v=1774526722",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Electric_YellowJet_Black.jpg?v=1774526722",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003/ProductCarouselMain/JC003%20EY%252fJB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003_Electric_YellowJet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550099722",
      "product_title": "AWDis Cool Contrast Wicking T-Shirt",
      "product_handle": "jc003",
      "product_url": "/products/jc003",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003",
      "colour_name": "Fire Red/Jet Black",
      "colour_group": "Red > Red",
      "rgb": "#eb0024;#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491405603082",
      "swatch_filename": "jc003_Fire_RedJet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Fire_RedJet_Black.jpg?v=1774526724",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Fire_RedJet_Black.jpg?v=1774526724",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003/ProductCarouselMain/JC003%20FR%252fJB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003_Fire_RedJet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550132490",
      "product_title": "AWDis Kids Cool Contrast T-Shirt",
      "product_handle": "jc003b",
      "product_url": "/products/jc003b",
      "product_full_url": "https://oakdenemerch.com/products/jc003b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "style-jc003b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003B",
      "colour_name": "Fire Red/Jet Black",
      "colour_group": "Red > Red",
      "rgb": "#eb0024;#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474197946634",
      "swatch_filename": "JC003B_Fire_RedJet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC003B_Fire_RedJet_Black.jpg?v=1774370307",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC003B_Fire_RedJet_Black.jpg?v=1774370307",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003B/ProductCarouselMain/JC003B%20FR%252fJB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003b_Fire_RedJet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688637706",
      "product_title": "Tee Jays Long Sleeve Baseball T-Shirt",
      "product_handle": "t5072",
      "product_url": "/products/t5072",
      "product_full_url": "https://oakdenemerch.com/products/t5072",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5072",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "Body 85% cotton/15% viscose. Sleeves 100% ringspun combed cotton.",
      "style_code": "T5072",
      "colour_name": "Heather Grey/Black",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#999999;#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490491146506",
      "swatch_filename": "t5072_Heather_GreyBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5072_Heather_GreyBlack.jpg?v=1774523095",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5072_Heather_GreyBlack.jpg?v=1774523095",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Tee%20Jays/T5072/ProductCarouselMain/T5072%20HE%252fBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5072_Heather_GreyBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549116682",
      "product_title": "Ecologie Cascades Organic T-Shirt",
      "product_handle": "ea001",
      "product_url": "/products/ea001",
      "product_full_url": "https://oakdenemerch.com/products/ea001",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-ea001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474304213258",
      "swatch_filename": "EA001_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Jet_Black.jpg?v=1774371175",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Jet_Black.jpg?v=1774371175",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001/ProductCarouselMain/EA001%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549214986",
      "product_title": "Ecologie Daintree EcoViscose T-Shirt",
      "product_handle": "ea002",
      "product_url": "/products/ea002",
      "product_full_url": "https://oakdenemerch.com/products/ea002",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-ea002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "70% Lenzing™ Ecovero™/30% organic cotton.",
      "shopify_material": "",
      "csv_material": "70% Lenzing™ Ecovero™/30% organic cotton.",
      "style_code": "EA002",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471837962506",
      "swatch_filename": "EA002_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA002_Jet_Black.jpg?v=1774351788",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA002_Jet_Black.jpg?v=1774351788",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA002/ProductCarouselMain/EA002%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea002_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686901002",
      "product_title": "Ecologie Erawan Organic Long Sleeve T-Shirt",
      "product_handle": "ea021",
      "product_url": "/products/ea021",
      "product_full_url": "None",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-ea021",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA021",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490437538058",
      "swatch_filename": "ea021_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ea021_Jet_Black.jpg?v=1774522817",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ea021_Jet_Black.jpg?v=1774522817",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA021/ProductCarouselMain/EA021%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea021_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549149450",
      "product_title": "Ecologie Kids Cascades Organic T-Shirt",
      "product_handle": "ea001b",
      "product_url": "/products/ea001b",
      "product_full_url": "https://oakdenemerch.com/products/ea001b",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "organic",
        "organic-recycled",
        "style-ea001b",
        "t-shirts"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001B",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474280587530",
      "swatch_filename": "EA001B_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001B_Jet_Black.jpg?v=1774371055",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001B_Jet_Black.jpg?v=1774371055",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001B/ProductCarouselMain/EA001B%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001b_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549182218",
      "product_title": "Ecologie Ladies Cascades Organic T-Shirt",
      "product_handle": "ea001f",
      "product_url": "/products/ea001f",
      "product_full_url": "https://oakdenemerch.com/products/ea001f",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-ea001f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001F",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474275016970",
      "swatch_filename": "EA001F_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001F_Jet_Black.jpg?v=1774370991",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001F_Jet_Black.jpg?v=1774370991",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001F/ProductCarouselMain/EA001F%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001f_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550099722",
      "product_title": "AWDis Cool Contrast Wicking T-Shirt",
      "product_handle": "jc003",
      "product_url": "/products/jc003",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003",
      "colour_name": "Jet Black/Arctic White",
      "colour_group": "Black > Black",
      "rgb": "#171c21;#ffffff",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491405996298",
      "swatch_filename": "jc003_Jet_BlackArctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Jet_BlackArctic_White.jpg?v=1774526725",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Jet_BlackArctic_White.jpg?v=1774526725",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003/ProductCarouselMain/JC003%20JB%252fAW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003_Jet_BlackArctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550132490",
      "product_title": "AWDis Kids Cool Contrast T-Shirt",
      "product_handle": "jc003b",
      "product_url": "/products/jc003b",
      "product_full_url": "https://oakdenemerch.com/products/jc003b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "style-jc003b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003B",
      "colour_name": "Jet Black/Arctic White",
      "colour_group": "Black > Black",
      "rgb": "#171c21;#ffffff",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474198143242",
      "swatch_filename": "JC003B_Jet_BlackArctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC003B_Jet_BlackArctic_White.jpg?v=1774370308",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC003B_Jet_BlackArctic_White.jpg?v=1774370308",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003B/ProductCarouselMain/JC003B%20JB%252fAW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003b_Jet_BlackArctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550099722",
      "product_title": "AWDis Cool Contrast Wicking T-Shirt",
      "product_handle": "jc003",
      "product_url": "/products/jc003",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003",
      "colour_name": "Jet Black/Electric Orange",
      "colour_group": "Black > Black",
      "rgb": "#171c21;#ff6600",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491406586122",
      "swatch_filename": "jc003_Jet_BlackElectric_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Jet_BlackElectric_Orange.jpg?v=1774526727",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Jet_BlackElectric_Orange.jpg?v=1774526727",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003/ProductCarouselMain/JC003%20JB%252fEO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003_Jet_BlackElectric_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550099722",
      "product_title": "AWDis Cool Contrast Wicking T-Shirt",
      "product_handle": "jc003",
      "product_url": "/products/jc003",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003",
      "colour_name": "Jet Black/Fire Red",
      "colour_group": "Black > Black",
      "rgb": "#171c21;#eb0024",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491407307018",
      "swatch_filename": "jc003_Jet_BlackFire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Jet_BlackFire_Red.jpg?v=1774526729",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Jet_BlackFire_Red.jpg?v=1774526729",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003/ProductCarouselMain/JC003%20JB%252fFR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003_Jet_BlackFire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550132490",
      "product_title": "AWDis Kids Cool Contrast T-Shirt",
      "product_handle": "jc003b",
      "product_url": "/products/jc003b",
      "product_full_url": "https://oakdenemerch.com/products/jc003b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "style-jc003b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003B",
      "colour_name": "Jet Black/Fire Red",
      "colour_group": "Black > Black",
      "rgb": "#171c21;#eb0024",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474198176010",
      "swatch_filename": "JC003B_Jet_BlackFire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC003B_Jet_BlackFire_Red.jpg?v=1774370308",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC003B_Jet_BlackFire_Red.jpg?v=1774370308",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003B/ProductCarouselMain/JC003B%20JB%252fFR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003b_Jet_BlackFire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550099722",
      "product_title": "AWDis Cool Contrast Wicking T-Shirt",
      "product_handle": "jc003",
      "product_url": "/products/jc003",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003",
      "colour_name": "Jet Black/Gold",
      "colour_group": "Black > Black",
      "rgb": "#171c21;#ff9600",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491407798538",
      "swatch_filename": "jc003_Jet_BlackGold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Jet_BlackGold.jpg?v=1774526730",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Jet_BlackGold.jpg?v=1774526730",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003/ProductCarouselMain/JC003%20JB%252fGO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003_Jet_BlackGold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551082762",
      "product_title": "Kustom Kit Fashion Fit Ringer T-Shirt",
      "product_handle": "k508",
      "product_url": "/products/k508",
      "product_full_url": "https://oakdenemerch.com/products/k508",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-k508",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton.",
      "style_code": "K508",
      "colour_name": "Light Grey Marl/Black",
      "colour_group": "Grey > Light Grey",
      "rgb": "#ababab;#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472290619658",
      "swatch_filename": "K508_Light_Grey_MarlBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K508_Light_Grey_MarlBlack.jpg?v=1774354444",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K508_Light_Grey_MarlBlack.jpg?v=1774354444",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K508/ProductCarouselMain/K508%20LML%252fB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k508_Light_Grey_MarlBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548625162",
      "product_title": "Bella Ladies Micro Rib 3/4 Raglan Baby T-Shirt",
      "product_handle": "bl1200",
      "product_url": "/products/bl1200",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-bl1200",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1200",
      "colour_name": "Natural/Black",
      "colour_group": "Natural > Natural",
      "rgb": "#ded1a6;#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491493224714",
      "swatch_filename": "bl1200_NaturalBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1200_NaturalBlack.jpg?v=1774526799",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1200_NaturalBlack.jpg?v=1774526799",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1200/ProductCarouselMain/BL1200%20NT%252fBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1200_NaturalBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547347210",
      "product_title": "SOL'S Unisex Odyssey Recycled T-Shirt",
      "product_handle": "03805",
      "product_url": "/products/03805",
      "product_full_url": "https://oakdenemerch.com/products/03805",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-03805",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "55% recycled cotton/45% recycled polyester.",
      "style_code": "03805",
      "colour_name": "Recycled Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473296105738",
      "swatch_filename": "03805_Recycled_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03805_Recycled_Black.jpg?v=1774363246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03805_Recycled_Black.jpg?v=1774363246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03805/ProductCarouselMain/03805%20RCB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03805_Recycled_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550787850",
      "product_title": "AWDis Ladies Tri-Blend Cropped T-Shirt",
      "product_handle": "jt006",
      "product_url": "/products/jt006",
      "product_full_url": "https://oakdenemerch.com/products/jt006",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-jt006",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% cotton/25% viscose.*",
      "style_code": "JT006",
      "colour_name": "Solid Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474185855242",
      "swatch_filename": "JT006_Solid_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT006_Solid_Black.jpg?v=1774370028",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT006_Solid_Black.jpg?v=1774370028",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT006/ProductCarouselMain/JT006%20SOB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt006_Solid_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550755082",
      "product_title": "AWDis Ladies Tri-Blend T-Shirt",
      "product_handle": "jt001f",
      "product_url": "/products/jt001f",
      "product_full_url": "https://oakdenemerch.com/products/jt001f",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-jt001f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% viscose/25% cotton.*",
      "style_code": "JT001F",
      "colour_name": "Solid Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472587727114",
      "swatch_filename": "JT001F_Solid_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT001F_Solid_Black.jpg?v=1774357792",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT001F_Solid_Black.jpg?v=1774357792",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT001F/ProductCarouselMain/JT001F%20SOB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt001f_Solid_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687326986",
      "product_title": "AWDis Long Sleeve Tri-Blend T-Shirt",
      "product_handle": "jt002",
      "product_url": "/products/jt002",
      "product_full_url": "None",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jt002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% viscose/25% cotton.",
      "style_code": "JT002",
      "colour_name": "Solid Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490478661898",
      "swatch_filename": "jt002_Solid_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jt002_Solid_Black.jpg?v=1774522913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jt002_Solid_Black.jpg?v=1774522913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT002/ProductCarouselMain/JT002%20SOB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt002_Solid_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550722314",
      "product_title": "AWDis Tri-Blend T-Shirt",
      "product_handle": "jt001",
      "product_url": "/products/jt001",
      "product_full_url": "https://oakdenemerch.com/products/jt001",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-jt001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% viscose/25% cotton.*",
      "style_code": "JT001",
      "colour_name": "Solid Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468945400074",
      "swatch_filename": "JT001_Solid_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT001_Solid_Black.jpg?v=1774314481",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT001_Solid_Black.jpg?v=1774314481",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT001/ProductCarouselMain/JT001%20SOB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt001_Solid_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548985610",
      "product_title": "Canvas Unisex Tri-Blend T-Shirt",
      "product_handle": "cv3413",
      "product_url": "/products/cv3413",
      "product_full_url": "https://oakdenemerch.com/products/cv3413",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-cv3413",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Cotton/Rayon",
      "shopify_material": "Poly/Cotton/Rayon",
      "csv_material": "50% polyester/25% airlume combed ringspun cotton/25% rayon.",
      "style_code": "CV3413",
      "colour_name": "Solid Black Tri-Blend",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472609452298",
      "swatch_filename": "CV3413_Solid_Black_Tri-Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_Solid_Black_Tri-Blend.jpg?v=1774358160",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_Solid_Black_Tri-Blend.jpg?v=1774358160",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3413/ProductCarouselMain/CV3413%20SOB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3413_Solid_Black_Tri-Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552590090",
      "product_title": "Premier Unisex Utility 2.0 Oversized T-Shirt",
      "product_handle": "pr020",
      "product_url": "/products/pr020",
      "product_full_url": "https://oakdenemerch.com/products/pr020",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-pr020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% BCI cotton.",
      "style_code": "PR020",
      "colour_name": "Stay Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473100153098",
      "swatch_filename": "PR020_Stay_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR020_Stay_Black.jpg?v=1774361959",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR020_Stay_Black.jpg?v=1774361959",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR020/ProductCarouselMain/PR020%20SBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr020_Stay_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550918922",
      "product_title": "AWDis Washed T-Shirt",
      "product_handle": "jt099",
      "product_url": "/products/jt099",
      "product_full_url": "https://oakdenemerch.com/products/jt099",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "S",
        "style-jt099",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "55% ringspun cotton/45% polyester.",
      "style_code": "JT099",
      "colour_name": "Washed Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472801767690",
      "swatch_filename": "JT099_Washed_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT099_Washed_Jet_Black.jpg?v=1774359931",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT099_Washed_Jet_Black.jpg?v=1774359931",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT099/ProductCarouselMain/JT099%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt099_Washed_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548625162",
      "product_title": "Bella Ladies Micro Rib 3/4 Raglan Baby T-Shirt",
      "product_handle": "bl1200",
      "product_url": "/products/bl1200",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-bl1200",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1200",
      "colour_name": "White/Black",
      "colour_group": "White > White",
      "rgb": "#ffffff;#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491493585162",
      "swatch_filename": "bl1200_WhiteBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1200_WhiteBlack.jpg?v=1774526800",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1200_WhiteBlack.jpg?v=1774526800",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1200/ProductCarouselMain/BL1200%20WH%252fBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1200_WhiteBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548657930",
      "product_title": "Bella Ladies Micro Rib Raglan Baby T-Shirt",
      "product_handle": "bl1201",
      "product_url": "/products/bl1201",
      "product_full_url": "https://oakdenemerch.com/products/bl1201",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "headwear",
        "L",
        "M",
        "S",
        "style-bl1201",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1201",
      "colour_name": "White/Black",
      "colour_group": "White > White",
      "rgb": "#ffffff;#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472614859018",
      "swatch_filename": "BL1201_WhiteBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL1201_WhiteBlack.jpg?v=1774358245",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL1201_WhiteBlack.jpg?v=1774358245",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1201/ProductCarouselMain/BL1201%20WH%252fBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1201_WhiteBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548952842",
      "product_title": "Canvas Unisex 3/4 Sleeve Baseball T-Shirt",
      "product_handle": "cv3200",
      "product_url": "/products/cv3200",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv3200",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "CV3200",
      "colour_name": "White/Black",
      "colour_group": "White > White",
      "rgb": "#ffffff;#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491486212362",
      "swatch_filename": "cv3200_WhiteBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3200_WhiteBlack.jpg?v=1774526776",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3200_WhiteBlack.jpg?v=1774526776",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3200/ProductCarouselMain/CV3200%20WH%252fBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3200_WhiteBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554261258",
      "product_title": "Fruit of the Loom Contrast Baseball T-Shirt",
      "product_handle": "ss31",
      "product_url": "/products/ss31",
      "product_full_url": "https://oakdenemerch.com/products/ss31",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss31",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS31",
      "colour_name": "White/Black",
      "colour_group": "White > White",
      "rgb": "#ffffff;#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468950905098",
      "swatch_filename": "SS31_WhiteBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS31_WhiteBlack.jpg?v=1774314925",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS31_WhiteBlack.jpg?v=1774314925",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS31/ProductCarouselMain/SS31%20WH%252fBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss31_WhiteBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688015114",
      "product_title": "Fruit of the Loom Contrast Long Sleeve Baseball T-Shirt",
      "product_handle": "ss32",
      "product_url": "/products/ss32",
      "product_full_url": "https://oakdenemerch.com/products/ss32",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss32",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS32",
      "colour_name": "White/Black",
      "colour_group": "White > White",
      "rgb": "#ffffff;#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490486657290",
      "swatch_filename": "ss32_WhiteBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss32_WhiteBlack.jpg?v=1774523022",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss32_WhiteBlack.jpg?v=1774523022",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS32/ProductCarouselMain/SS32%20WH%252fBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss32_WhiteBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554294026",
      "product_title": "Fruit of the Loom Contrast Ringer T-Shirt",
      "product_handle": "ss34",
      "product_url": "/products/ss34",
      "product_full_url": "https://oakdenemerch.com/products/ss34",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss34",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS34",
      "colour_name": "White/Black",
      "colour_group": "White > White",
      "rgb": "#ffffff;#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468953166090",
      "swatch_filename": "SS34_WhiteBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS34_WhiteBlack.jpg?v=1774315005",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS34_WhiteBlack.jpg?v=1774315005",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS34/ProductCarouselMain/SS34%20WH%252fBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss34_WhiteBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547969802",
      "product_title": "SOL'S Funky Contrast Baseball T-Shirt",
      "product_handle": "11190",
      "product_url": "/products/11190",
      "product_full_url": "https://oakdenemerch.com/products/11190",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11190",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11190",
      "colour_name": "White/Black",
      "colour_group": "White > White",
      "rgb": "#ffffff;#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468904669450",
      "swatch_filename": "11190_WhiteBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11190_WhiteBlack.jpg?v=1774312736",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11190_WhiteBlack.jpg?v=1774312736",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11190/ProductCarouselMain/11190%20WH%252fBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11190_WhiteBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553868042",
      "product_title": "Spiro Basketball Top",
      "product_handle": "sr278m",
      "product_url": "/products/sr278m",
      "product_full_url": "None",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "lightweight",
        "M",
        "S",
        "style-sr278m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "SR278M",
      "colour_name": "White/Black",
      "colour_group": "White > White",
      "rgb": "#ffffff;#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491285868810",
      "swatch_filename": "sr278m_WhiteBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr278m_WhiteBlack.jpg?v=1774526415",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr278m_WhiteBlack.jpg?v=1774526415",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR278M/ProductCarouselMain/SR278M%20WH%252fBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr278m_WhiteBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688637706",
      "product_title": "Tee Jays Long Sleeve Baseball T-Shirt",
      "product_handle": "t5072",
      "product_url": "/products/t5072",
      "product_full_url": "https://oakdenemerch.com/products/t5072",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5072",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T5072",
      "colour_name": "White/Black",
      "colour_group": "White > White",
      "rgb": "#ffffff;#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490491244810",
      "swatch_filename": "t5072_WhiteBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5072_WhiteBlack.jpg?v=1774523096",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5072_WhiteBlack.jpg?v=1774523096",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Tee%20Jays/T5072/ProductCarouselMain/T5072%20WH%252fBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5072_WhiteBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554818314",
      "product_title": "Tee Jays Unlabeled Baseball T-Shirt",
      "product_handle": "t1170",
      "product_url": "/products/t1170",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-t1170",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T1170",
      "colour_name": "White/Black",
      "colour_group": "White > White",
      "rgb": "#ffffff;#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491278659850",
      "swatch_filename": "t1170_WhiteBlack.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t1170_WhiteBlack.jpg?v=1774526391",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t1170_WhiteBlack.jpg?v=1774526391",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1170/ProductCarouselMain/T1170%20WH_BK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1170_WhiteBlack.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548428554",
      "product_title": "Anthem Amplify Heavyweight T-Shirt",
      "product_handle": "am18",
      "product_url": "/products/am18",
      "product_full_url": "https://oakdenemerch.com/products/am18",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-am18",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM18",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#424236",
      "sort_bucket": "black",
      "sort_hue": 0.166667,
      "sort_sat": 0.181818,
      "sort_val": 0.258824,
      "swatch_file_id": "gid://shopify/MediaImage/49472893092106",
      "swatch_filename": "AM18_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_Black.jpg?v=1774360286",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_Black.jpg?v=1774360286",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM18/ProductCarouselMain/AM18%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am18_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686311178",
      "product_title": "Anthem Headline Heavy Long Sleeve T-Shirt",
      "product_handle": "am16",
      "product_url": "/products/am16",
      "product_full_url": "None",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "PCBest_Seller",
        "S",
        "style-am16",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "AM16",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#424236",
      "sort_bucket": "black",
      "sort_hue": 0.166667,
      "sort_sat": 0.181818,
      "sort_val": 0.258824,
      "swatch_file_id": "gid://shopify/MediaImage/49490391564554",
      "swatch_filename": "am16_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am16_Black.jpg?v=1774522770",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am16_Black.jpg?v=1774522770",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM16/ProductCarouselMain/AM16%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am16_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686212874",
      "product_title": "Anthem Organic Long Sleeve T-Shirt",
      "product_handle": "am11",
      "product_url": "/products/am11",
      "product_full_url": "None",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-am11",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM11",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#424236",
      "sort_bucket": "black",
      "sort_hue": 0.166667,
      "sort_sat": 0.181818,
      "sort_val": 0.258824,
      "swatch_file_id": "gid://shopify/MediaImage/49490375770378",
      "swatch_filename": "am11_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am11_Black.jpg?v=1774522763",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am11_Black.jpg?v=1774522763",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM11/ProductCarouselMain/AM11%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am11_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#424236",
      "sort_bucket": "black",
      "sort_hue": 0.166667,
      "sort_sat": 0.181818,
      "sort_val": 0.258824,
      "swatch_file_id": "gid://shopify/MediaImage/49474343076106",
      "swatch_filename": "AM10_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Black.jpg?v=1774371250",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Black.jpg?v=1774371250",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548395786",
      "product_title": "Anthem Unisex Organic Heavyweight T-Shirt",
      "product_handle": "am15",
      "product_url": "/products/am15",
      "product_full_url": "https://oakdenemerch.com/products/am15",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am15",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM15",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#424236",
      "sort_bucket": "black",
      "sort_hue": 0.166667,
      "sort_sat": 0.181818,
      "sort_val": 0.258824,
      "swatch_file_id": "gid://shopify/MediaImage/49472895680778",
      "swatch_filename": "AM15_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Black.jpg?v=1774360325",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Black.jpg?v=1774360325",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM15/ProductCarouselMain/AM15%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am15_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548363018",
      "product_title": "Anthem Unisex Organic Midweight T-Shirt",
      "product_handle": "am12",
      "product_url": "/products/am12",
      "product_full_url": "https://oakdenemerch.com/products/am12",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am12",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM12",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#424236",
      "sort_bucket": "black",
      "sort_hue": 0.166667,
      "sort_sat": 0.181818,
      "sort_val": 0.258824,
      "swatch_file_id": "gid://shopify/MediaImage/49472902758666",
      "swatch_filename": "AM12_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Black.jpg?v=1774360382",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Black.jpg?v=1774360382",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM12/ProductCarouselMain/AM12%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am12_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549673738",
      "product_title": "Gildan Hammer Maxweight T-Shirt",
      "product_handle": "gd201",
      "product_url": "/products/gd201",
      "product_full_url": "https://oakdenemerch.com/products/gd201",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd201",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD201",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#091b10",
      "sort_bucket": "black",
      "sort_hue": 0.398148,
      "sort_sat": 0.666667,
      "sort_val": 0.105882,
      "swatch_file_id": "gid://shopify/MediaImage/49468939272458",
      "swatch_filename": "GD201_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_Forest_Green.jpg?v=1774313826",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_Forest_Green.jpg?v=1774313826",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD201/ProductCarouselMain/GD201%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd201_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#091b10",
      "sort_bucket": "black",
      "sort_hue": 0.398148,
      "sort_sat": 0.666667,
      "sort_val": 0.105882,
      "swatch_file_id": "gid://shopify/MediaImage/49471386222858",
      "swatch_filename": "GD05_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Forest_Green.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Forest_Green.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#091b10",
      "sort_bucket": "black",
      "sort_hue": 0.398148,
      "sort_sat": 0.666667,
      "sort_val": 0.105882,
      "swatch_file_id": "gid://shopify/MediaImage/49474267775242",
      "swatch_filename": "GD01_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Forest_Green.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Forest_Green.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD14",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#091b10",
      "sort_bucket": "black",
      "sort_hue": 0.398148,
      "sort_sat": 0.666667,
      "sort_val": 0.105882,
      "swatch_file_id": "gid://shopify/MediaImage/49490452644106",
      "swatch_filename": "gd14_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Forest_Green.jpg?v=1774522841",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Forest_Green.jpg?v=1774522841",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#091b10",
      "sort_bucket": "black",
      "sort_hue": 0.398148,
      "sort_sat": 0.666667,
      "sort_val": 0.105882,
      "swatch_file_id": "gid://shopify/MediaImage/49471398084874",
      "swatch_filename": "GD02_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Forest_Green.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Forest_Green.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550918922",
      "product_title": "AWDis Washed T-Shirt",
      "product_handle": "jt099",
      "product_url": "/products/jt099",
      "product_full_url": "https://oakdenemerch.com/products/jt099",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "S",
        "style-jt099",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "55% ringspun cotton/45% polyester.",
      "style_code": "JT099",
      "colour_name": "Washed Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#0d120f",
      "sort_bucket": "black",
      "sort_hue": 0.4,
      "sort_sat": 0.277778,
      "sort_val": 0.070588,
      "swatch_file_id": "gid://shopify/MediaImage/49472801800458",
      "swatch_filename": "JT099_Washed_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT099_Washed_Charcoal.jpg?v=1774359931",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT099_Washed_Charcoal.jpg?v=1774359931",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT099/ProductCarouselMain/JT099%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt099_Washed_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562953482",
      "product_title": "Fruit of the Loom Athletic Vest",
      "product_handle": "ss18",
      "product_url": "/products/ss18",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "sleeveless",
        "sports",
        "style-ss18",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS18",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49513937043722",
      "swatch_filename": "ss18_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss18_Black.jpg?v=1774619144",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss18_Black.jpg?v=1774619144",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS18/ProductCarouselMain/SS18%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss18_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552983306",
      "product_title": "Fruit of the Loom Heavy Cotton T-Shirt",
      "product_handle": "sa101",
      "product_url": "/products/sa101",
      "product_full_url": "https://oakdenemerch.com/products/sa101",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-sa101",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SA101",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49468678603018",
      "swatch_filename": "SA101_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SA101_Black.jpg?v=1774309789",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SA101_Black.jpg?v=1774309789",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SA101/ProductCarouselMain/SA101%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sa101_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49471285756170",
      "swatch_filename": "SS621_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Black.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Black.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688047882",
      "product_title": "Fruit of the Loom Iconic 195 Long Sleeve T-Shirt",
      "product_handle": "ss624",
      "product_url": "/products/ss624",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-ss624",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS624",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49490486952202",
      "swatch_filename": "ss624_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss624_Black.jpg?v=1774523029",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss624_Black.jpg?v=1774523029",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS624/ProductCarouselMain/SS624%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss624_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49471313412362",
      "swatch_filename": "SS620_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Black.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Black.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554621706",
      "product_title": "Fruit of the Loom Ladies Iconic 150 T-Shirt",
      "product_handle": "ss721",
      "product_url": "/products/ss721",
      "product_full_url": "https://oakdenemerch.com/products/ss721",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss721",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS721",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49472056557834",
      "swatch_filename": "SS721_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Black.jpg?v=1774353579",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Black.jpg?v=1774353579",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS721/ProductCarouselMain/SS721%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss721_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS720",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49472219087114",
      "swatch_filename": "SS720_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Black.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Black.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554556170",
      "product_title": "Fruit of the Loom Lady Fit Original T-Shirt",
      "product_handle": "ss712",
      "product_url": "/products/ss712",
      "product_full_url": "https://oakdenemerch.com/products/ss712",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss712",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS712",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49472223019274",
      "swatch_filename": "SS712_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS712_Black.jpg?v=1774353740",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS712_Black.jpg?v=1774353740",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS712/ProductCarouselMain/SS712%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss712_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554654474",
      "product_title": "Fruit of the Loom Lady Fit Value T-Shirt",
      "product_handle": "ss77",
      "product_url": "/products/ss77",
      "product_full_url": "https://oakdenemerch.com/products/ss77",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss77",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS77",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49472025985290",
      "swatch_filename": "SS77_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Black.jpg?v=1774353471",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Black.jpg?v=1774353471",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS77/ProductCarouselMain/SS77%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss77_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554523402",
      "product_title": "Fruit of the Loom Lady Fit Value V Neck T-Shirt",
      "product_handle": "ss702",
      "product_url": "/products/ss702",
      "product_full_url": "https://oakdenemerch.com/products/ss702",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss702",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS702",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49472224231690",
      "swatch_filename": "SS702_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS702_Black.jpg?v=1774353786",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS702_Black.jpg?v=1774353786",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS702/ProductCarouselMain/SS702%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss702_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458563051786",
      "product_title": "Fruit of the Loom Lady Fit Value Vest",
      "product_handle": "ss704",
      "product_url": "/products/ss704",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-ss704",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS704",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49513937895690",
      "swatch_filename": "ss704_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss704_Black.jpg?v=1774619155",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss704_Black.jpg?v=1774619155",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS704/ProductCarouselMain/SS704%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss704_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687982346",
      "product_title": "Fruit of the Loom Long Sleeve Value T-Shirt",
      "product_handle": "ss21",
      "product_url": "/products/ss21",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "knitwear",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss21",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS21",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49490485281034",
      "swatch_filename": "ss21_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss21_Black.jpg?v=1774523012",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss21_Black.jpg?v=1774523012",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS21/ProductCarouselMain/SS21%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss21_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688080650",
      "product_title": "Fruit of the Loom Original Long Sleeve T-Shirt",
      "product_handle": "ss632",
      "product_url": "/products/ss632",
      "product_full_url": "https://oakdenemerch.com/products/ss632",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss632",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS632",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49490487345418",
      "swatch_filename": "ss632_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss632_Black.jpg?v=1774523037",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss632_Black.jpg?v=1774523037",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS632/ProductCarouselMain/SS632%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss632_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49471330287882",
      "swatch_filename": "SS12_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Black.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Black.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554425098",
      "product_title": "Fruit of the Loom Original V Neck T-Shirt",
      "product_handle": "ss631",
      "product_url": "/products/ss631",
      "product_full_url": "https://oakdenemerch.com/products/ss631",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-ss631",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS631",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49471693947146",
      "swatch_filename": "SS631_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS631_Black.jpg?v=1774350964",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS631_Black.jpg?v=1774350964",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS631/ProductCarouselMain/SS631%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss631_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554457866",
      "product_title": "Fruit of the Loom Pure Cotton T-Shirt",
      "product_handle": "ss640",
      "product_url": "/products/ss640",
      "product_full_url": "https://oakdenemerch.com/products/ss640",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss640",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "SS640",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49468957720842",
      "swatch_filename": "SS640_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Black.jpg?v=1774315114",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Black.jpg?v=1774315114",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS640/ProductCarouselMain/SS640%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss640_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554195722",
      "product_title": "Fruit of the Loom Super Premium T-Shirt",
      "product_handle": "ss10",
      "product_url": "/products/ss10",
      "product_full_url": "https://oakdenemerch.com/products/ss10",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss10",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS10",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49471341691146",
      "swatch_filename": "SS10_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_Black.jpg?v=1774348796",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_Black.jpg?v=1774348796",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS10/ProductCarouselMain/SS10%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss10_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554490634",
      "product_title": "Fruit of the Loom V Neck Value T-Shirt",
      "product_handle": "ss7",
      "product_url": "/products/ss7",
      "product_full_url": "https://oakdenemerch.com/products/ss7",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss7",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS7",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49471271928074",
      "swatch_filename": "SS7_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Black.jpg?v=1774348430",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Black.jpg?v=1774348430",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS7/ProductCarouselMain/SS7%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss7_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49471322128650",
      "swatch_filename": "SS6_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Black.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Black.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562396426",
      "product_title": "Native Spirit Ladies Ribbed Tank Top",
      "product_handle": "ns344",
      "product_url": "/products/ns344",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns344",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "98% organic combed cotton/2% recycled elastane.",
      "style_code": "NS344",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0b1013",
      "sort_bucket": "black",
      "sort_hue": 0.5625,
      "sort_sat": 0.421053,
      "sort_val": 0.07451,
      "swatch_file_id": "gid://shopify/MediaImage/49513931407626",
      "swatch_filename": "ns344_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns344_Black.jpg?v=1774619066",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns344_Black.jpg?v=1774619066",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS344/ProductCarouselMain/NS344%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns344_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552196874",
      "product_title": "Native Spirit Ladies Roll-Up Sleeve T-Shirt",
      "product_handle": "ns309",
      "product_url": "/products/ns309",
      "product_full_url": "https://oakdenemerch.com/products/ns309",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "S",
        "style-ns309",
        "t-shirts",
        "womens",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS309",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0b1013",
      "sort_bucket": "black",
      "sort_hue": 0.5625,
      "sort_sat": 0.421053,
      "sort_val": 0.07451,
      "swatch_file_id": "gid://shopify/MediaImage/49474128609546",
      "swatch_filename": "NS309_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS309_Black.jpg?v=1774369419",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS309_Black.jpg?v=1774369419",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS309/ProductCarouselMain/NS309%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns309_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552295178",
      "product_title": "Native Spirit Ladies T-Shirt",
      "product_handle": "ns324",
      "product_url": "/products/ns324",
      "product_full_url": "https://oakdenemerch.com/products/ns324",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns324",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS324",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0b1013",
      "sort_bucket": "black",
      "sort_hue": 0.5625,
      "sort_sat": 0.421053,
      "sort_val": 0.07451,
      "swatch_file_id": "gid://shopify/MediaImage/49472283410698",
      "swatch_filename": "NS324_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Black.jpg?v=1774354240",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Black.jpg?v=1774354240",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS324/ProductCarouselMain/NS324%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns324_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562330890",
      "product_title": "Native Spirit Ladies Tank Top",
      "product_handle": "ns341",
      "product_url": "/products/ns341",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns341",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS341",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0b1013",
      "sort_bucket": "black",
      "sort_hue": 0.5625,
      "sort_sat": 0.421053,
      "sort_val": 0.07451,
      "swatch_file_id": "gid://shopify/MediaImage/49513929769226",
      "swatch_filename": "ns341_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns341_Black.jpg?v=1774619040",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns341_Black.jpg?v=1774619040",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS341/ProductCarouselMain/NS341%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns341_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552393482",
      "product_title": "Native Spirit Oversized T-Shirt",
      "product_handle": "ns332",
      "product_url": "/products/ns332",
      "product_full_url": "https://oakdenemerch.com/products/ns332",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns332",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "NS332",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0b1013",
      "sort_bucket": "black",
      "sort_hue": 0.5625,
      "sort_sat": 0.421053,
      "sort_val": 0.07451,
      "swatch_file_id": "gid://shopify/MediaImage/49474121826570",
      "swatch_filename": "NS332_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_Black.jpg?v=1774369280",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_Black.jpg?v=1774369280",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS332/ProductCarouselMain/NS332%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns332_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687654666",
      "product_title": "Native Spirit Unisex Crew Neck Long Sleeve T-Shirt",
      "product_handle": "ns333",
      "product_url": "/products/ns333",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-ns333",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS333",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0b1013",
      "sort_bucket": "black",
      "sort_hue": 0.5625,
      "sort_sat": 0.421053,
      "sort_val": 0.07451,
      "swatch_file_id": "gid://shopify/MediaImage/49490480398602",
      "swatch_filename": "ns333_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns333_Black.jpg?v=1774522950",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns333_Black.jpg?v=1774522950",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS333/ProductCarouselMain/NS333%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns333_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552164106",
      "product_title": "Native Spirit Unisex French Terry T-Shirt",
      "product_handle": "ns308",
      "product_url": "/products/ns308",
      "product_full_url": "https://oakdenemerch.com/products/ns308",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns308",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "NS308",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0b1013",
      "sort_bucket": "black",
      "sort_hue": 0.5625,
      "sort_sat": 0.421053,
      "sort_val": 0.07451,
      "swatch_file_id": "gid://shopify/MediaImage/49472288325898",
      "swatch_filename": "NS308_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS308_Black.jpg?v=1774354362",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS308_Black.jpg?v=1774354362",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS308/ProductCarouselMain/NS308%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns308_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0b1013",
      "sort_bucket": "black",
      "sort_hue": 0.5625,
      "sort_sat": 0.421053,
      "sort_val": 0.07451,
      "swatch_file_id": "gid://shopify/MediaImage/49473667334410",
      "swatch_filename": "NS305_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Black.jpg?v=1774364709",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Black.jpg?v=1774364709",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552360714",
      "product_title": "Native Spirit Unisex Oversized T-Shirt",
      "product_handle": "ns330",
      "product_url": "/products/ns330",
      "product_full_url": "https://oakdenemerch.com/products/ns330",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-ns330",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS330",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0b1013",
      "sort_bucket": "black",
      "sort_hue": 0.5625,
      "sort_sat": 0.421053,
      "sort_val": 0.07451,
      "swatch_file_id": "gid://shopify/MediaImage/49473635189002",
      "swatch_filename": "NS330_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS330_Black.jpg?v=1774364535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS330_Black.jpg?v=1774364535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS330/ProductCarouselMain/NS330%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns330_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548985610",
      "product_title": "Canvas Unisex Tri-Blend T-Shirt",
      "product_handle": "cv3413",
      "product_url": "/products/cv3413",
      "product_full_url": "https://oakdenemerch.com/products/cv3413",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-cv3413",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Cotton/Rayon",
      "shopify_material": "Poly/Cotton/Rayon",
      "csv_material": "50% polyester/25% airlume combed ringspun cotton/25% rayon.",
      "style_code": "CV3413",
      "colour_name": "Charcoal Black Tri-Blend",
      "colour_group": "Grey > Charcoal",
      "rgb": "#1d252a",
      "sort_bucket": "black",
      "sort_hue": 0.564103,
      "sort_sat": 0.309524,
      "sort_val": 0.164706,
      "swatch_file_id": "gid://shopify/MediaImage/49472609583370",
      "swatch_filename": "CV3413_Charcoal_Black_Tri-Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_Charcoal_Black_Tri-Blend.jpg?v=1774358160",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_Charcoal_Black_Tri-Blend.jpg?v=1774358160",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3413/ProductCarouselMain/CV3413%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3413_Charcoal_Black_Tri-Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547379978",
      "product_title": "SOL'S Boxy Oversized Organic T-Shirt",
      "product_handle": "03806",
      "product_url": "/products/03806",
      "product_full_url": "https://oakdenemerch.com/products/03806",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL",
        "style-03806",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "03806",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49471864570122",
      "swatch_filename": "03806_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03806_Deep_Black.jpg?v=1774352127",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03806_Deep_Black.jpg?v=1774352127",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03806/ProductCarouselMain/03806%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03806_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49474468348170",
      "swatch_filename": "03582_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Deep_Black.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Deep_Black.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547511050",
      "product_title": "SOL'S Crusader Recycled T-Shirt",
      "product_handle": "04233",
      "product_url": "/products/04233",
      "product_full_url": "https://oakdenemerch.com/products/04233",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04233",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% recycled cotton/50% cotton.*",
      "style_code": "04233",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49473284931850",
      "swatch_filename": "04233_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Deep_Black.jpg?v=1774363191",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Deep_Black.jpg?v=1774363191",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04233/ProductCarouselMain/04233%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04233_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547904266",
      "product_title": "SOL'S Imperial Fit T-Shirt",
      "product_handle": "10580",
      "product_url": "/products/10580",
      "product_full_url": "https://oakdenemerch.com/products/10580",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-10580",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "10580",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49471859261706",
      "swatch_filename": "10580_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10580_Deep_Black.jpg?v=1774352022",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10580_Deep_Black.jpg?v=1774352022",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/10580/ProductCarouselMain/10580%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "10580_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49474449113354",
      "swatch_filename": "11500_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Deep_Black.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Deep_Black.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685623050",
      "product_title": "SOL'S Imperial Long Sleeve T-Shirt",
      "product_handle": "02074",
      "product_url": "/products/02074",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-02074",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "02074",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49490366562570",
      "swatch_filename": "02074_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02074_Deep_Black.jpg?v=1774522700",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02074_Deep_Black.jpg?v=1774522700",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02074/ProductCarouselMain/02074%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02074_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546953994",
      "product_title": "SOL'S Imperial V Neck T-Shirt",
      "product_handle": "02940",
      "product_url": "/products/02940",
      "product_full_url": "https://oakdenemerch.com/products/02940",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-02940",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "02940",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49468829106442",
      "swatch_filename": "02940_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02940_Deep_Black.jpg?v=1774312050",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02940_Deep_Black.jpg?v=1774312050",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02940/ProductCarouselMain/02940%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02940_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561773834",
      "product_title": "SOL'S Justin Tank Top",
      "product_handle": "11465",
      "product_url": "/products/11465",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11465",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11465",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49513914368266",
      "swatch_filename": "11465_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11465_Deep_Black.jpg?v=1774618889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11465_Deep_Black.jpg?v=1774618889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11465/ProductCarouselMain/11465%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11465_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547412746",
      "product_title": "SOL'S Ladies Boxy Oversized Organic T-Shirt",
      "product_handle": "03807",
      "product_url": "/products/03807",
      "product_full_url": "https://oakdenemerch.com/products/03807",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03807",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "03807",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49474463564042",
      "swatch_filename": "03807_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03807_Deep_Black.jpg?v=1774372092",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03807_Deep_Black.jpg?v=1774372092",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03807/ProductCarouselMain/03807%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03807_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49468835758346",
      "swatch_filename": "03581_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Deep_Black.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Deep_Black.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49468933669130",
      "swatch_filename": "11502_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Deep_Black.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Deep_Black.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685688586",
      "product_title": "SOL'S Ladies Imperial Long Sleeve T-Shirt",
      "product_handle": "02075",
      "product_url": "/products/02075",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-02075",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "02075",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49490367152394",
      "swatch_filename": "02075_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02075_Deep_Black.jpg?v=1774522709",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02075_Deep_Black.jpg?v=1774522709",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02075/ProductCarouselMain/02075%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02075_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547052298",
      "product_title": "SOL'S Ladies Imperial V Neck T-Shirt",
      "product_handle": "02941",
      "product_url": "/products/02941",
      "product_full_url": "https://oakdenemerch.com/products/02941",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-02941",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "02941",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49471878398218",
      "swatch_filename": "02941_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02941_Deep_Black.jpg?v=1774352302",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02941_Deep_Black.jpg?v=1774352302",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02941/ProductCarouselMain/02941%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02941_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547642122",
      "product_title": "SOL'S Ladies Legend T-Shirt",
      "product_handle": "04776",
      "product_url": "/products/04776",
      "product_full_url": "https://oakdenemerch.com/products/04776",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-04776",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "04776",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49472963674378",
      "swatch_filename": "04776_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Deep_Black.jpg?v=1774360489",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Deep_Black.jpg?v=1774360489",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04776/ProductCarouselMain/04776%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04776_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547740426",
      "product_title": "SOL'S Ladies Lilia Low Crop T-Shirt",
      "product_handle": "04811",
      "product_url": "/products/04811",
      "product_full_url": "https://oakdenemerch.com/products/04811",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL",
        "style-04811",
        "t-shirts",
        "womens",
        "XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "04811",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49474453340426",
      "swatch_filename": "04811_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04811_Deep_Black.jpg?v=1774371893",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04811_Deep_Black.jpg?v=1774371893",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04811/ProductCarouselMain/04811%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04811_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547117834",
      "product_title": "SOL'S Ladies Millenium Stretch T-Shirt",
      "product_handle": "02946",
      "product_url": "/products/02946",
      "product_full_url": "https://oakdenemerch.com/products/02946",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-02946",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "95% semi-combed ringspun cotton/5% elastane.*",
      "style_code": "02946",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49471871484170",
      "swatch_filename": "02946_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02946_Deep_Black.jpg?v=1774352219",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02946_Deep_Black.jpg?v=1774352219",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02946/ProductCarouselMain/02946%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02946_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548035338",
      "product_title": "SOL'S Ladies Moon V Neck T-Shirt",
      "product_handle": "11388",
      "product_url": "/products/11388",
      "product_full_url": "https://oakdenemerch.com/products/11388",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11388",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11388",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49468932292874",
      "swatch_filename": "11388_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_Deep_Black.jpg?v=1774312856",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_Deep_Black.jpg?v=1774312856",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11388/ProductCarouselMain/11388%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11388_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49468833431818",
      "swatch_filename": "03579_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Deep_Black.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Deep_Black.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49468823372042",
      "swatch_filename": "01825_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Deep_Black.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Deep_Black.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547609354",
      "product_title": "SOL'S Ladies Regent V Neck T-Shirt",
      "product_handle": "04766",
      "product_url": "/products/04766",
      "product_full_url": "https://oakdenemerch.com/products/04766",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "S",
        "style-04766",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "04766",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49472664535306",
      "swatch_filename": "04766_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04766_Deep_Black.jpg?v=1774358606",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04766_Deep_Black.jpg?v=1774358606",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04766/ProductCarouselMain/04766%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04766_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547838730",
      "product_title": "SOL'S Ladies Sara T-Shirt",
      "product_handle": "04814",
      "product_url": "/products/04814",
      "product_full_url": "https://oakdenemerch.com/products/04814",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-04814",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "04814",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49472643006730",
      "swatch_filename": "04814_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04814_Deep_Black.jpg?v=1774358443",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04814_Deep_Black.jpg?v=1774358443",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04814/ProductCarouselMain/04814%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04814_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686049034",
      "product_title": "SOL'S Monarch Long Sleeve T-Shirt",
      "product_handle": "11420",
      "product_url": "/products/11420",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11420",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "11420",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49490370625802",
      "swatch_filename": "11420_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Deep_Black.jpg?v=1774522740",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Deep_Black.jpg?v=1774522740",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11420/ProductCarouselMain/11420%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11420_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03565",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49473306001674",
      "swatch_filename": "03565_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Deep_Black.jpg?v=1774363313",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Deep_Black.jpg?v=1774363313",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547871498",
      "product_title": "SOL'S Regent Fit T-Shirt",
      "product_handle": "10553",
      "product_url": "/products/10553",
      "product_full_url": "https://oakdenemerch.com/products/10553",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-10553",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "10553",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49472629014794",
      "swatch_filename": "10553_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_Deep_Black.jpg?v=1774358391",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_Deep_Black.jpg?v=1774358391",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/10553/ProductCarouselMain/10553%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "10553_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49473718485258",
      "swatch_filename": "11380_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Deep_Black.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Deep_Black.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547805962",
      "product_title": "SOL'S Unisex Cliff T-Shirt",
      "product_handle": "04813",
      "product_url": "/products/04813",
      "product_full_url": "https://oakdenemerch.com/products/04813",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "S",
        "style-04813",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "04813",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49472952041738",
      "swatch_filename": "04813_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04813_Deep_Black.jpg?v=1774360433",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04813_Deep_Black.jpg?v=1774360433",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04813/ProductCarouselMain/04813%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04813_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561675530",
      "product_title": "SOL'S Unisex Crusader Tank Top",
      "product_handle": "03980",
      "product_url": "/products/03980",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03980",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03980",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49513912926474",
      "swatch_filename": "03980_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03980_Deep_Black.jpg?v=1774618872",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03980_Deep_Black.jpg?v=1774618872",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03980/ProductCarouselMain/03980%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03980_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547183370",
      "product_title": "SOL'S Unisex Epic Organic T-Shirt",
      "product_handle": "03564",
      "product_url": "/products/03564",
      "product_full_url": "https://oakdenemerch.com/products/03564",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03564",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03564",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49473320091914",
      "swatch_filename": "03564_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03564_Deep_Black.jpg?v=1774363396",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03564_Deep_Black.jpg?v=1774363396",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03564/ProductCarouselMain/03564%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03564_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49473744240906",
      "swatch_filename": "03981_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Deep_Black.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Deep_Black.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685786890",
      "product_title": "SOL'S Unisex Pioneer Long Sleeve T-Shirt",
      "product_handle": "03982",
      "product_url": "/products/03982",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03982",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03982",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49490368168202",
      "swatch_filename": "03982_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03982_Deep_Black.jpg?v=1774522717",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03982_Deep_Black.jpg?v=1774522717",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03982/ProductCarouselMain/03982%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03982_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547478282",
      "product_title": "SOL'S Unisex Tuner T-Shirt",
      "product_handle": "04203",
      "product_url": "/products/04203",
      "product_full_url": "https://oakdenemerch.com/products/04203",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-04203",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.*",
      "style_code": "04203",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49474458943754",
      "swatch_filename": "04203_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_Deep_Black.jpg?v=1774372011",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_Deep_Black.jpg?v=1774372011",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04203/ProductCarouselMain/04203%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04203_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547937034",
      "product_title": "SOL'S Victory V Neck T-Shirt",
      "product_handle": "11150",
      "product_url": "/products/11150",
      "product_full_url": "https://oakdenemerch.com/products/11150",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11150",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11150",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49468838379786",
      "swatch_filename": "11150_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11150_Deep_Black.jpg?v=1774312556",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11150_Deep_Black.jpg?v=1774312556",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11150/ProductCarouselMain/11150%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11150_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548461322",
      "product_title": "Anthem Distortion Washed T-Shirt",
      "product_handle": "am19",
      "product_url": "/products/am19",
      "product_full_url": "https://oakdenemerch.com/products/am19",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-am19",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed ringspun cotton.",
      "style_code": "AM19",
      "colour_name": "Washed Black",
      "colour_group": "Black > Heather/Effect Black",
      "rgb": "#3f4850",
      "sort_bucket": "black",
      "sort_hue": 0.578431,
      "sort_sat": 0.2125,
      "sort_val": 0.313725,
      "swatch_file_id": "gid://shopify/MediaImage/49472886898954",
      "swatch_filename": "AM19_Washed_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM19_Washed_Black.jpg?v=1774360222",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM19_Washed_Black.jpg?v=1774360222",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM19/ProductCarouselMain/AM19%20WBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am19_Washed_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687097610",
      "product_title": "Gildan Hammer Heavyweight Long Sleeve T-Shirt",
      "product_handle": "gd22",
      "product_url": "/products/gd22",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-gd22",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD22",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#010407",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.857143,
      "sort_val": 0.027451,
      "swatch_file_id": "gid://shopify/MediaImage/49490466472202",
      "swatch_filename": "gd22_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd22_Black.jpg?v=1774522868",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd22_Black.jpg?v=1774522868",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD22/ProductCarouselMain/GD22%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd22_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549706506",
      "product_title": "Gildan Hammer Heavyweight T-Shirt",
      "product_handle": "gd21",
      "product_url": "/products/gd21",
      "product_full_url": "https://oakdenemerch.com/products/gd21",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-gd21",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD21",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#010407",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.857143,
      "sort_val": 0.027451,
      "swatch_file_id": "gid://shopify/MediaImage/49470943494410",
      "swatch_filename": "GD21_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD21_Black.jpg?v=1774347003",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD21_Black.jpg?v=1774347003",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD21/ProductCarouselMain/GD21%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd21_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549509898",
      "product_title": "Gildan Heavy Cotton™ Toddler T-Shirt",
      "product_handle": "gd05p",
      "product_url": "/products/gd05p",
      "product_full_url": "https://oakdenemerch.com/products/gd05p",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "2T",
        "2T-3T-4T-5T-6T",
        "3T",
        "4T",
        "5T",
        "6T",
        "baby-toddler",
        "style-gd05p",
        "t-shirts",
        "unisex"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05P",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#010407",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.857143,
      "sort_val": 0.027451,
      "swatch_file_id": "gid://shopify/MediaImage/49474248835338",
      "swatch_filename": "GD05P_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05P_Black.jpg?v=1774370725",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05P_Black.jpg?v=1774370725",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05P/ProductCarouselMain/GD05P%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05p_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549903114",
      "product_title": "Gildan Ladies Heavy Cotton™ T-Shirt",
      "product_handle": "gd95",
      "product_url": "/products/gd95",
      "product_full_url": "https://oakdenemerch.com/products/gd95",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd95",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD95",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#010407",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.857143,
      "sort_val": 0.027451,
      "swatch_file_id": "gid://shopify/MediaImage/49468944023818",
      "swatch_filename": "GD95_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD95_Black.jpg?v=1774314277",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD95_Black.jpg?v=1774314277",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD95/ProductCarouselMain/GD95%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd95_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549772042",
      "product_title": "Gildan Ladies SoftStyle® T-Shirt",
      "product_handle": "gd72",
      "product_url": "/products/gd72",
      "product_full_url": "https://oakdenemerch.com/products/gd72",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd72",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD72",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#010407",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.857143,
      "sort_val": 0.027451,
      "swatch_file_id": "gid://shopify/MediaImage/49468940681482",
      "swatch_filename": "GD72_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Black.jpg?v=1774314002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Black.jpg?v=1774314002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD72/ProductCarouselMain/GD72%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd72_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561970442",
      "product_title": "Gildan Ladies SoftStyle® Tank Top",
      "product_handle": "gd77",
      "product_url": "/products/gd77",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd77",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.",
      "style_code": "GD77",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#010407",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.857143,
      "sort_val": 0.027451,
      "swatch_file_id": "gid://shopify/MediaImage/49513920495882",
      "swatch_filename": "gd77_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd77_Black.jpg?v=1774618950",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd77_Black.jpg?v=1774618950",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD77/ProductCarouselMain/GD77%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd77_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549804810",
      "product_title": "Gildan Ladies SoftStyle® V Neck T-Shirt",
      "product_handle": "gd78",
      "product_url": "/products/gd78",
      "product_full_url": "https://oakdenemerch.com/products/gd78",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd78",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD78",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#010407",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.857143,
      "sort_val": 0.027451,
      "swatch_file_id": "gid://shopify/MediaImage/49471832588554",
      "swatch_filename": "GD78_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD78_Black.jpg?v=1774351724",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD78_Black.jpg?v=1774351724",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD78/ProductCarouselMain/GD78%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd78_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#010407",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.857143,
      "sort_val": 0.027451,
      "swatch_file_id": "gid://shopify/MediaImage/49474267939082",
      "swatch_filename": "GD01_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Black.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Black.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549411594",
      "product_title": "Gildan SoftStyle® EZ T-Shirt",
      "product_handle": "gd04",
      "product_url": "/products/gd04",
      "product_full_url": "https://oakdenemerch.com/products/gd04",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd04",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "GD04",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#010407",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.857143,
      "sort_val": 0.027451,
      "swatch_file_id": "gid://shopify/MediaImage/49468937502986",
      "swatch_filename": "GD04_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Black.jpg?v=1774313523",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Black.jpg?v=1774313523",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD04/ProductCarouselMain/GD04%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd04_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686966538",
      "product_title": "Gildan SoftStyle® Long Sleeve T-Shirt",
      "product_handle": "gd11",
      "product_url": "/products/gd11",
      "product_full_url": "https://oakdenemerch.com/products/gd11",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd11",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD11",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#010407",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.857143,
      "sort_val": 0.027451,
      "swatch_file_id": "gid://shopify/MediaImage/49490441601290",
      "swatch_filename": "gd11_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Black.jpg?v=1774522826",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Black.jpg?v=1774522826",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD11/ProductCarouselMain/GD11%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd11_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561937674",
      "product_title": "Gildan SoftStyle® Tank Top",
      "product_handle": "gd12",
      "product_url": "/products/gd12",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD12",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#010407",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.857143,
      "sort_val": 0.027451,
      "swatch_file_id": "gid://shopify/MediaImage/49513919021322",
      "swatch_filename": "gd12_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd12_Black.jpg?v=1774618935",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd12_Black.jpg?v=1774618935",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD12/ProductCarouselMain/GD12%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd12_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549575434",
      "product_title": "Gildan SoftStyle® V Neck T-Shirt",
      "product_handle": "gd10",
      "product_url": "/products/gd10",
      "product_full_url": "https://oakdenemerch.com/products/gd10",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd10",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD10",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#010407",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.857143,
      "sort_val": 0.027451,
      "swatch_file_id": "gid://shopify/MediaImage/49468938748170",
      "swatch_filename": "GD10_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD10_Black.jpg?v=1774313702",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD10_Black.jpg?v=1774313702",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD10/ProductCarouselMain/GD10%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd10_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD14",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#010407",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.857143,
      "sort_val": 0.027451,
      "swatch_file_id": "gid://shopify/MediaImage/49490453332234",
      "swatch_filename": "gd14_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Black.jpg?v=1774522842",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Black.jpg?v=1774522842",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#010407",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.857143,
      "sort_val": 0.027451,
      "swatch_file_id": "gid://shopify/MediaImage/49471397069066",
      "swatch_filename": "GD02_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Black.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Black.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548559626",
      "product_title": "AWDis Heavyweight Boxy 240 T-Shirt",
      "product_handle": "at003",
      "product_url": "/products/at003",
      "product_full_url": "https://oakdenemerch.com/products/at003",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-at003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT003",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49472884670730",
      "swatch_filename": "AT003_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT003_Deep_Black.jpg?v=1774360179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT003_Deep_Black.jpg?v=1774360179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT003/ProductCarouselMain/AT003%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at003_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686409482",
      "product_title": "AWDis Long Sleeve 180 T-Shirt",
      "product_handle": "at012",
      "product_url": "/products/at012",
      "product_full_url": "https://oakdenemerch.com/products/at012",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-shirt",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-at012",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT012",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49490396872970",
      "swatch_filename": "at012_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/at012_Deep_Black.jpg?v=1774522774",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/at012_Deep_Black.jpg?v=1774522774",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT012/ProductCarouselMain/AT012%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at012_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550951690",
      "product_title": "AWDis Signature Heavyweight T-Shirt",
      "product_handle": "jt120",
      "product_url": "/products/jt120",
      "product_full_url": "https://oakdenemerch.com/products/jt120",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "heavyweight",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jt120",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.",
      "style_code": "JT120",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49471782977802",
      "swatch_filename": "JT120_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT120_Deep_Black.jpg?v=1774351411",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT120_Deep_Black.jpg?v=1774351411",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT120/ProductCarouselMain/JT120%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt120_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49471442944266",
      "swatch_filename": "AT001_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Deep_Black.jpg?v=1774349536",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Deep_Black.jpg?v=1774349536",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49471430033674",
      "swatch_filename": "AT002_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Deep_Black.jpg?v=1774349457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Deep_Black.jpg?v=1774349457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687523594",
      "product_title": "AWDis Unisex Oversize 100 Long Sleeve T-Shirt",
      "product_handle": "jt019",
      "product_url": "/products/jt019",
      "product_full_url": "None",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jt019",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.",
      "style_code": "JT019",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49490479251722",
      "swatch_filename": "jt019_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jt019_Deep_Black.jpg?v=1774522928",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jt019_Deep_Black.jpg?v=1774522928",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT019/ProductCarouselMain/JT019%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt019_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550820618",
      "product_title": "AWDis Unisex Oversize 100 T-Shirt",
      "product_handle": "jt009",
      "product_url": "/products/jt009",
      "product_full_url": "https://oakdenemerch.com/products/jt009",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jt009",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.*",
      "style_code": "JT009",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49471817974026",
      "swatch_filename": "JT009_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_Deep_Black.jpg?v=1774351553",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_Deep_Black.jpg?v=1774351553",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT009/ProductCarouselMain/JT009%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt009_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550656778",
      "product_title": "AWDis Cool Active Recycled Base Layer",
      "product_handle": "jc232",
      "product_url": "/products/jc232",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-jc232",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "91% recycled polyester/9% elastane.",
      "style_code": "JC232",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49491394494730",
      "swatch_filename": "jc232_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc232_Jet_Black.jpg?v=1774526692",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc232_Jet_Black.jpg?v=1774526692",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC232/ProductCarouselMain/JC232%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc232_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687294218",
      "product_title": "AWDis Cool Long Sleeve Active T-Shirt",
      "product_handle": "jc023",
      "product_url": "/products/jc023",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jc023",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "JC023",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49490478137610",
      "swatch_filename": "jc023_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc023_Jet_Black.jpg?v=1774522905",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc023_Jet_Black.jpg?v=1774522905",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC023/ProductCarouselMain/JC023%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc023_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687228682",
      "product_title": "AWDis Cool Long Sleeve Wicking T-Shirt",
      "product_handle": "jc002",
      "product_url": "/products/jc002",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jc002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC002",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49490476663050",
      "swatch_filename": "jc002_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Jet_Black.jpg?v=1774522886",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Jet_Black.jpg?v=1774522886",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC002/ProductCarouselMain/JC002%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc002_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550361866",
      "product_title": "AWDis Cool Smooth T-Shirt",
      "product_handle": "jc020",
      "product_url": "/products/jc020",
      "product_full_url": "https://oakdenemerch.com/products/jc020",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-jc020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49472871596298",
      "swatch_filename": "JC020_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Jet_Black.jpg?v=1774359994",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Jet_Black.jpg?v=1774359994",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020/ProductCarouselMain/JC020%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49474218950922",
      "swatch_filename": "JC001_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Jet_Black.jpg?v=1774370458",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Jet_Black.jpg?v=1774370458",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550460170",
      "product_title": "AWDis Cool Urban Fitness T-Shirt",
      "product_handle": "jc110",
      "product_url": "/products/jc110",
      "product_full_url": "https://oakdenemerch.com/products/jc110",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-jc110",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% polyester.",
      "style_code": "JC110",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49472593363210",
      "swatch_filename": "JC110_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC110_Jet_Black.jpg?v=1774357870",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC110_Jet_Black.jpg?v=1774357870",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC110/ProductCarouselMain/JC110%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc110_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562003210",
      "product_title": "AWDis Cool Vest",
      "product_handle": "jc007",
      "product_url": "/products/jc007",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc007",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49513921872138",
      "swatch_filename": "jc007_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Jet_Black.jpg?v=1774618961",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Jet_Black.jpg?v=1774618961",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC007/ProductCarouselMain/JC007%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550394634",
      "product_title": "AWDis Kids Cool Smooth T-Shirt",
      "product_handle": "jc020b",
      "product_url": "/products/jc020b",
      "product_full_url": "https://oakdenemerch.com/products/jc020b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "style-jc020b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020B",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49474193096970",
      "swatch_filename": "JC020B_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020B_Jet_Black.jpg?v=1774370151",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020B_Jet_Black.jpg?v=1774370151",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020B/ProductCarouselMain/JC020B%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020b_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49474210529546",
      "swatch_filename": "JC001B_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Jet_Black.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Jet_Black.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562068746",
      "product_title": "AWDis Kids Cool Vest",
      "product_handle": "jc007b",
      "product_url": "/products/jc007b",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "sleeveless",
        "style-jc007b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007B",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49513924821258",
      "swatch_filename": "jc007b_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007b_Jet_Black.jpg?v=1774618987",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007b_Jet_Black.jpg?v=1774618987",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC007B/ProductCarouselMain/JC007B%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007b_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687261450",
      "product_title": "AWDis Ladies Cool Long Sleeve T-Shirt",
      "product_handle": "jc012",
      "product_url": "/products/jc012",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-jc012",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC012",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49490477646090",
      "swatch_filename": "jc012_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc012_Jet_Black.jpg?v=1774522898",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc012_Jet_Black.jpg?v=1774522898",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC012/ProductCarouselMain/JC012%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc012_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550230794",
      "product_title": "AWDis Ladies Cool Open Back T-Shirt",
      "product_handle": "jc013",
      "product_url": "/products/jc013",
      "product_full_url": "https://oakdenemerch.com/products/jc013",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-jc013",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC013",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49474194964746",
      "swatch_filename": "JC013_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC013_Jet_Black.jpg?v=1774370210",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC013_Jet_Black.jpg?v=1774370210",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC013/ProductCarouselMain/JC013%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc013_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550591242",
      "product_title": "AWDis Ladies Cool Recycled Cropped T-Shirt",
      "product_handle": "jc215",
      "product_url": "/products/jc215",
      "product_full_url": "https://oakdenemerch.com/products/jc215",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-jc215",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "80% recycled polyester/20% elastane.",
      "style_code": "JC215",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49473132953866",
      "swatch_filename": "JC215_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC215_Jet_Black.jpg?v=1774362217",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC215_Jet_Black.jpg?v=1774362217",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC215/ProductCarouselMain/JC215%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc215_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550624010",
      "product_title": "AWDis Ladies Cool Recycled Tech Sports Bra",
      "product_handle": "jc217",
      "product_url": "/products/jc217",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "performance-activewear",
        "recycled",
        "S",
        "sports",
        "style-jc217",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "80% recycled polyester/20% elastane.",
      "style_code": "JC217",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49491396854026",
      "swatch_filename": "jc217_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc217_Jet_Black.jpg?v=1774526699",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc217_Jet_Black.jpg?v=1774526699",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC217/ProductCarouselMain/JC217%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc217_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550427402",
      "product_title": "AWDis Ladies Cool Smooth T-Shirt",
      "product_handle": "jc025",
      "product_url": "/products/jc025",
      "product_full_url": "https://oakdenemerch.com/products/jc025",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-jc025",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC025",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49474190803210",
      "swatch_filename": "JC025_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC025_Jet_Black.jpg?v=1774370109",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC025_Jet_Black.jpg?v=1774370109",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC025/ProductCarouselMain/JC025%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc025_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562134282",
      "product_title": "AWDis Ladies Cool Smooth Workout Vest",
      "product_handle": "jc027",
      "product_url": "/products/jc027",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-jc027",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XXS",
        "XXS-XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC027",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49513928327434",
      "swatch_filename": "jc027_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc027_Jet_Black.jpg?v=1774619017",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc027_Jet_Black.jpg?v=1774619017",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Just%20Cool/JC027/ProductCarouselMain/JC027%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc027_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550329098",
      "product_title": "AWDis Ladies Cool Sports Crop Top",
      "product_handle": "jc017",
      "product_url": "/products/jc017",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-jc017",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XXS",
        "XXS-XS-S-M-L-XL"
      ],
      "material": "Nylon/Elastane",
      "shopify_material": "Nylon/Elastane",
      "csv_material": "90% nylon/10% elastane.",
      "style_code": "JC017",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49491399508234",
      "swatch_filename": "jc017_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc017_Jet_Black.jpg?v=1774526709",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc017_Jet_Black.jpg?v=1774526709",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC017/ProductCarouselMain/JC017%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc017_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49473142718730",
      "swatch_filename": "JC005_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Jet_Black.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Jet_Black.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562101514",
      "product_title": "AWDis Ladies Cool Vest",
      "product_handle": "jc015",
      "product_url": "/products/jc015",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc015",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC015",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49513926000906",
      "swatch_filename": "jc015_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Jet_Black.jpg?v=1774618996",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Jet_Black.jpg?v=1774618996",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC015/ProductCarouselMain/JC015%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc015_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550198026",
      "product_title": "AWDis SuperCool™ Performance T-Shirt",
      "product_handle": "jc011",
      "product_url": "/products/jc011",
      "product_full_url": "https://oakdenemerch.com/products/jc011",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-jc011",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester piqué.",
      "style_code": "JC011",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49471826034954",
      "swatch_filename": "JC011_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC011_Jet_Black.jpg?v=1774351620",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC011_Jet_Black.jpg?v=1774351620",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC011/ProductCarouselMain/JC011%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc011_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548592394",
      "product_title": "Bella Ladies Micro Rib Baby T-Shirt",
      "product_handle": "bl1010",
      "product_url": "/products/bl1010",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "M",
        "S",
        "style-bl1010",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1010",
      "colour_name": "Solid Black Blend",
      "colour_group": "Black > Black",
      "rgb": "#0d0f11",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.235294,
      "sort_val": 0.066667,
      "swatch_file_id": "gid://shopify/MediaImage/49491497582858",
      "swatch_filename": "bl1010_Solid_Black_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1010_Solid_Black_Blend.jpg?v=1774526811",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1010_Solid_Black_Blend.jpg?v=1774526811",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1010/ProductCarouselMain/BL1010%20SOB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1010_Solid_Black_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561839370",
      "product_title": "Bella Ladies Micro Rib Racer Tank Top",
      "product_handle": "bl1019",
      "product_url": "/products/bl1019",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-bl1019",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1019",
      "colour_name": "Solid Black Blend",
      "colour_group": "Black > Black",
      "rgb": "#0d0f11",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.235294,
      "sort_val": 0.066667,
      "swatch_file_id": "gid://shopify/MediaImage/49513917546762",
      "swatch_filename": "bl1019_Solid_Black_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1019_Solid_Black_Blend.jpg?v=1774618918",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1019_Solid_Black_Blend.jpg?v=1774618918",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1019/ProductCarouselMain/BL1019%20SOB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1019_Solid_Black_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561806602",
      "product_title": "Bella Ladies Micro Rib Spaghetti Strap Tank Top",
      "product_handle": "bl1012",
      "product_url": "/products/bl1012",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-bl1012",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1012",
      "colour_name": "Solid Black Blend",
      "colour_group": "Black > Black",
      "rgb": "#0d0f11",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.235294,
      "sort_val": 0.066667,
      "swatch_file_id": "gid://shopify/MediaImage/49513916039434",
      "swatch_filename": "bl1012_Solid_Black_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1012_Solid_Black_Blend.jpg?v=1774618905",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1012_Solid_Black_Blend.jpg?v=1774618905",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1012/ProductCarouselMain/BL1012%20SOB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1012_Solid_Black_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686475018",
      "product_title": "Bella Micro Rib Long Sleeve Baby T-Shirt",
      "product_handle": "bl1501",
      "product_url": "/products/bl1501",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-bl1501",
        "t-shirts",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1501",
      "colour_name": "Solid Black Blend",
      "colour_group": "Black > Black",
      "rgb": "#0d0f11",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.235294,
      "sort_val": 0.066667,
      "swatch_file_id": "gid://shopify/MediaImage/49490401198346",
      "swatch_filename": "bl1501_Solid_Black_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1501_Solid_Black_Blend.jpg?v=1774522782",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1501_Solid_Black_Blend.jpg?v=1774522782",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1501/ProductCarouselMain/BL1501%20SOB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1501_Solid_Black_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548559626",
      "product_title": "AWDis Heavyweight Boxy 240 T-Shirt",
      "product_handle": "at003",
      "product_url": "/products/at003",
      "product_full_url": "https://oakdenemerch.com/products/at003",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-at003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT003",
      "colour_name": "New French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000710",
      "sort_bucket": "black",
      "sort_hue": 0.59375,
      "sort_sat": 1.0,
      "sort_val": 0.062745,
      "swatch_file_id": "gid://shopify/MediaImage/49472884506890",
      "swatch_filename": "AT003_New_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT003_New_French_Navy.jpg?v=1774360179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT003_New_French_Navy.jpg?v=1774360179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT003/ProductCarouselMain/AT003%20NFN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at003_New_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686409482",
      "product_title": "AWDis Long Sleeve 180 T-Shirt",
      "product_handle": "at012",
      "product_url": "/products/at012",
      "product_full_url": "https://oakdenemerch.com/products/at012",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-shirt",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-at012",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT012",
      "colour_name": "New French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000710",
      "sort_bucket": "black",
      "sort_hue": 0.59375,
      "sort_sat": 1.0,
      "sort_val": 0.062745,
      "swatch_file_id": "gid://shopify/MediaImage/49490397135114",
      "swatch_filename": "at012_New_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/at012_New_French_Navy.jpg?v=1774522775",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/at012_New_French_Navy.jpg?v=1774522775",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT012/ProductCarouselMain/AT012%20NFN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at012_New_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "New French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000710",
      "sort_bucket": "black",
      "sort_hue": 0.59375,
      "sort_sat": 1.0,
      "sort_val": 0.062745,
      "swatch_file_id": "gid://shopify/MediaImage/49471442518282",
      "swatch_filename": "AT001_New_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_New_French_Navy.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_New_French_Navy.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20NFN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_New_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "New French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000710",
      "sort_bucket": "black",
      "sort_hue": 0.59375,
      "sort_sat": 1.0,
      "sort_val": 0.062745,
      "swatch_file_id": "gid://shopify/MediaImage/49471429902602",
      "swatch_filename": "AT002_New_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_New_French_Navy.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_New_French_Navy.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20NFN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_New_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550820618",
      "product_title": "AWDis Unisex Oversize 100 T-Shirt",
      "product_handle": "jt009",
      "product_url": "/products/jt009",
      "product_full_url": "https://oakdenemerch.com/products/jt009",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jt009",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.*",
      "style_code": "JT009",
      "colour_name": "New French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000710",
      "sort_bucket": "black",
      "sort_hue": 0.59375,
      "sort_sat": 1.0,
      "sort_val": 0.062745,
      "swatch_file_id": "gid://shopify/MediaImage/49471818137866",
      "swatch_filename": "JT009_New_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_New_French_Navy.jpg?v=1774351553",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_New_French_Navy.jpg?v=1774351553",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT009/ProductCarouselMain/JT009%20NFN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt009_New_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687425290",
      "product_title": "AWDis Ladies Long Sleeve Cropped T-Shirt",
      "product_handle": "jt016",
      "product_url": "/products/jt016",
      "product_full_url": "None",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-jt016",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Poly/Viscose",
      "shopify_material": "Poly/Viscose",
      "csv_material": "40% viscose/40% cotton/20% polyester",
      "style_code": "JT016",
      "colour_name": "Heather Black",
      "colour_group": "Black > Heather/Effect Black",
      "rgb": "#03080f",
      "sort_bucket": "black",
      "sort_hue": 0.597222,
      "sort_sat": 0.8,
      "sort_val": 0.058824,
      "swatch_file_id": "gid://shopify/MediaImage/49490478924042",
      "swatch_filename": "jt016_Heather_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jt016_Heather_Black.jpg?v=1774522919",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jt016_Heather_Black.jpg?v=1774522919",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT016/ProductCarouselMain/JT016%20HBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt016_Heather_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550787850",
      "product_title": "AWDis Ladies Tri-Blend Cropped T-Shirt",
      "product_handle": "jt006",
      "product_url": "/products/jt006",
      "product_full_url": "https://oakdenemerch.com/products/jt006",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-jt006",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "40% cotton/40% viscose/20% polyester.",
      "style_code": "JT006",
      "colour_name": "Heather Black",
      "colour_group": "Black > Heather/Effect Black",
      "rgb": "#03080f",
      "sort_bucket": "black",
      "sort_hue": 0.597222,
      "sort_sat": 0.8,
      "sort_val": 0.058824,
      "swatch_file_id": "gid://shopify/MediaImage/49474185920778",
      "swatch_filename": "JT006_Heather_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT006_Heather_Black.jpg?v=1774370028",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT006_Heather_Black.jpg?v=1774370028",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT006/ProductCarouselMain/JT006%20HBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt006_Heather_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550755082",
      "product_title": "AWDis Ladies Tri-Blend T-Shirt",
      "product_handle": "jt001f",
      "product_url": "/products/jt001f",
      "product_full_url": "https://oakdenemerch.com/products/jt001f",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-jt001f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "40% viscose/40% cotton/20% polyester.",
      "style_code": "JT001F",
      "colour_name": "Heather Black",
      "colour_group": "Black > Heather/Effect Black",
      "rgb": "#03080f",
      "sort_bucket": "black",
      "sort_hue": 0.597222,
      "sort_sat": 0.8,
      "sort_val": 0.058824,
      "swatch_file_id": "gid://shopify/MediaImage/49472587759882",
      "swatch_filename": "JT001F_Heather_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT001F_Heather_Black.jpg?v=1774357792",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT001F_Heather_Black.jpg?v=1774357792",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT001F/ProductCarouselMain/JT001F%20HBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt001f_Heather_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550722314",
      "product_title": "AWDis Tri-Blend T-Shirt",
      "product_handle": "jt001",
      "product_url": "/products/jt001",
      "product_full_url": "https://oakdenemerch.com/products/jt001",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-jt001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "40% viscose/40% cotton/20% polyester.",
      "style_code": "JT001",
      "colour_name": "Heather Black",
      "colour_group": "Black > Heather/Effect Black",
      "rgb": "#03080f",
      "sort_bucket": "black",
      "sort_hue": 0.597222,
      "sort_sat": 0.8,
      "sort_val": 0.058824,
      "swatch_file_id": "gid://shopify/MediaImage/49468945432842",
      "swatch_filename": "JT001_Heather_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT001_Heather_Black.jpg?v=1774314481",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT001_Heather_Black.jpg?v=1774314481",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT001/ProductCarouselMain/JT001%20HBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt001_Heather_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561577226",
      "product_title": "SOL'S Ladies Justin Vest",
      "product_handle": "01826",
      "product_url": "/products/01826",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-01826",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01826",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49513909354762",
      "swatch_filename": "01826_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01826_Black.jpg?v=1774618839",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01826_Black.jpg?v=1774618839",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01826/ProductCarouselMain/01826%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01826_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546757386",
      "product_title": "SOL'S Ladies Sporty Performance T-Shirt",
      "product_handle": "01159",
      "product_url": "/products/01159",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-01159",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "01159",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49491517014282",
      "swatch_filename": "01159_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01159_Black.jpg?v=1774526872",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01159_Black.jpg?v=1774526872",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01159/ProductCarouselMain/01159%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01159_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561642762",
      "product_title": "SOL'S Ladies Sporty Performance Tank Top",
      "product_handle": "02117",
      "product_url": "/products/02117",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-02117",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02117",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49513911025930",
      "swatch_filename": "02117_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02117_Black.jpg?v=1774618860",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02117_Black.jpg?v=1774618860",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02117/ProductCarouselMain/02117%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02117_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547707658",
      "product_title": "SOL'S Ladies Vortex Ripstop Performance T-Shirt",
      "product_handle": "04788",
      "product_url": "/products/04788",
      "product_full_url": "https://oakdenemerch.com/products/04788",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04788",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04788",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49472652116234",
      "swatch_filename": "04788_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_Black.jpg?v=1774358494",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_Black.jpg?v=1774358494",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04788/ProductCarouselMain/04788%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04788_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685590282",
      "product_title": "SOL'S Sporty Long Sleeve Performance T-Shirt",
      "product_handle": "02071",
      "product_url": "/products/02071",
      "product_full_url": "https://oakdenemerch.com/products/02071",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL",
        "sports",
        "style-02071",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02071",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49490364530954",
      "swatch_filename": "02071_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02071_Black.jpg?v=1774522690",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02071_Black.jpg?v=1774522690",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02071/ProductCarouselMain/02071%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02071_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548166410",
      "product_title": "SOL'S Sporty Performance T-Shirt",
      "product_handle": "11939",
      "product_url": "/products/11939",
      "product_full_url": "https://oakdenemerch.com/products/11939",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-11939",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "11939",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49473692631306",
      "swatch_filename": "11939_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Black.jpg?v=1774364865",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Black.jpg?v=1774364865",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11939/ProductCarouselMain/11939%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11939_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561609994",
      "product_title": "SOL'S Sporty Performance Tank Top",
      "product_handle": "02073",
      "product_url": "/products/02073",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL",
        "sports",
        "style-02073",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02073",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49513909682442",
      "swatch_filename": "02073_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02073_Black.jpg?v=1774618844",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02073_Black.jpg?v=1774618844",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02073/ProductCarouselMain/02073%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02073_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547543818",
      "product_title": "SOL'S Unisex Explorer Recycled T-Shirt",
      "product_handle": "04461",
      "product_url": "/products/04461",
      "product_full_url": "https://oakdenemerch.com/products/04461",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04461",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "60% recycled cotton/40% recycled polyester.",
      "style_code": "04461",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49472969146634",
      "swatch_filename": "04461_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04461_Black.jpg?v=1774360549",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04461_Black.jpg?v=1774360549",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04461/ProductCarouselMain/04461%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04461_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547773194",
      "product_title": "SOL'S Unisex Nino V Neck T-Shirt",
      "product_handle": "04812",
      "product_url": "/products/04812",
      "product_full_url": "https://oakdenemerch.com/products/04812",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-04812",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04812",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49471862145290",
      "swatch_filename": "04812_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04812_Black.jpg?v=1774352075",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04812_Black.jpg?v=1774352075",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04812/ProductCarouselMain/04812%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04812_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547150602",
      "product_title": "SOL'S Unisex Sprint T-Shirt",
      "product_handle": "02995",
      "product_url": "/products/02995",
      "product_full_url": "https://oakdenemerch.com/products/02995",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-02995",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "02995",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49473768358154",
      "swatch_filename": "02995_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Black.jpg?v=1774365179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Black.jpg?v=1774365179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02995/ProductCarouselMain/02995%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02995_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547576586",
      "product_title": "SOL'S Unisex Titan T-Shirt",
      "product_handle": "04728",
      "product_url": "/products/04728",
      "product_full_url": "https://oakdenemerch.com/products/04728",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "knitwear",
        "L",
        "M",
        "S",
        "style-04728",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.",
      "style_code": "04728",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49474456977674",
      "swatch_filename": "04728_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_Black.jpg?v=1774371966",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_Black.jpg?v=1774371966",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04728/ProductCarouselMain/04728%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04728_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547674890",
      "product_title": "SOL'S Vortex Ripstop Performance T-Shirt",
      "product_handle": "04787",
      "product_url": "/products/04787",
      "product_full_url": "https://oakdenemerch.com/products/04787",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04787",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04787",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49472658112778",
      "swatch_filename": "04787_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_Black.jpg?v=1774358538",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_Black.jpg?v=1774358538",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04787/ProductCarouselMain/04787%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04787_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549673738",
      "product_title": "Gildan Hammer Maxweight T-Shirt",
      "product_handle": "gd201",
      "product_url": "/products/gd201",
      "product_full_url": "https://oakdenemerch.com/products/gd201",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd201",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD201",
      "colour_name": "Pitch Black",
      "colour_group": "Black > Black",
      "rgb": "#00040a",
      "sort_bucket": "black",
      "sort_hue": 0.6,
      "sort_sat": 1.0,
      "sort_val": 0.039216,
      "swatch_file_id": "gid://shopify/MediaImage/49468939403530",
      "swatch_filename": "GD201_Pitch_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_Pitch_Black.jpg?v=1774313827",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_Pitch_Black.jpg?v=1774313827",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD201/ProductCarouselMain/GD201%20PHB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd201_Pitch_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549837578",
      "product_title": "Gildan Ladies SoftStyle® Midweight T-Shirt",
      "product_handle": "gd92",
      "product_url": "/products/gd92",
      "product_full_url": "https://oakdenemerch.com/products/gd92",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd92",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD92",
      "colour_name": "Pitch Black",
      "colour_group": "Black > Black",
      "rgb": "#00040a",
      "sort_bucket": "black",
      "sort_hue": 0.6,
      "sort_sat": 1.0,
      "sort_val": 0.039216,
      "swatch_file_id": "gid://shopify/MediaImage/49468942057738",
      "swatch_filename": "GD92_Pitch_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD92_Pitch_Black.jpg?v=1774314177",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD92_Pitch_Black.jpg?v=1774314177",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD92/ProductCarouselMain/GD92%20PHB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd92_Pitch_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Pitch Black",
      "colour_group": "Black > Black",
      "rgb": "#00040a",
      "sort_bucket": "black",
      "sort_hue": 0.6,
      "sort_sat": 1.0,
      "sort_val": 0.039216,
      "swatch_file_id": "gid://shopify/MediaImage/49471368626442",
      "swatch_filename": "GD15_Pitch_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Pitch_Black.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Pitch_Black.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20PHB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Pitch_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549247754",
      "product_title": "Ecologie Arrow Recycled Heavy Oversize T-Shirt",
      "product_handle": "ea006",
      "product_url": "/products/ea006",
      "product_full_url": "https://oakdenemerch.com/products/ea006",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ea006",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "48% recycled cotton/47% recycled polyester/5% elastane.",
      "style_code": "EA006",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000b1c",
      "sort_bucket": "black",
      "sort_hue": 0.60119,
      "sort_sat": 1.0,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49472604897546",
      "swatch_filename": "EA006_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA006_Navy.jpg?v=1774358065",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA006_Navy.jpg?v=1774358065",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA006/ProductCarouselMain/EA006%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea006_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549116682",
      "product_title": "Ecologie Cascades Organic T-Shirt",
      "product_handle": "ea001",
      "product_url": "/products/ea001",
      "product_full_url": "https://oakdenemerch.com/products/ea001",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-ea001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000b1c",
      "sort_bucket": "black",
      "sort_hue": 0.60119,
      "sort_sat": 1.0,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49474303918346",
      "swatch_filename": "EA001_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Navy.jpg?v=1774371175",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Navy.jpg?v=1774371175",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001/ProductCarouselMain/EA001%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549149450",
      "product_title": "Ecologie Kids Cascades Organic T-Shirt",
      "product_handle": "ea001b",
      "product_url": "/products/ea001b",
      "product_full_url": "https://oakdenemerch.com/products/ea001b",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "organic",
        "organic-recycled",
        "style-ea001b",
        "t-shirts"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001B",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000b1c",
      "sort_bucket": "black",
      "sort_hue": 0.60119,
      "sort_sat": 1.0,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49474280685834",
      "swatch_filename": "EA001B_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001B_Navy.jpg?v=1774371055",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001B_Navy.jpg?v=1774371055",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001B/ProductCarouselMain/EA001B%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001b_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549182218",
      "product_title": "Ecologie Ladies Cascades Organic T-Shirt",
      "product_handle": "ea001f",
      "product_url": "/products/ea001f",
      "product_full_url": "https://oakdenemerch.com/products/ea001f",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-ea001f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001F",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000b1c",
      "sort_bucket": "black",
      "sort_hue": 0.60119,
      "sort_sat": 1.0,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49474275082506",
      "swatch_filename": "EA001F_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001F_Navy.jpg?v=1774370992",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001F_Navy.jpg?v=1774370992",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001F/ProductCarouselMain/EA001F%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001f_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550656778",
      "product_title": "AWDis Cool Active Recycled Base Layer",
      "product_handle": "jc232",
      "product_url": "/products/jc232",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-jc232",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "91% recycled polyester/9% elastane.",
      "style_code": "JC232",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49491395379466",
      "swatch_filename": "jc232_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc232_French_Navy.jpg?v=1774526694",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc232_French_Navy.jpg?v=1774526694",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC232/ProductCarouselMain/JC232%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc232_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687294218",
      "product_title": "AWDis Cool Long Sleeve Active T-Shirt",
      "product_handle": "jc023",
      "product_url": "/products/jc023",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jc023",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "JC023",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49490478203146",
      "swatch_filename": "jc023_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc023_French_Navy.jpg?v=1774522906",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc023_French_Navy.jpg?v=1774522906",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC023/ProductCarouselMain/JC023%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc023_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687228682",
      "product_title": "AWDis Cool Long Sleeve Wicking T-Shirt",
      "product_handle": "jc002",
      "product_url": "/products/jc002",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jc002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC002",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49490476728586",
      "swatch_filename": "jc002_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_French_Navy.jpg?v=1774522887",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_French_Navy.jpg?v=1774522887",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC002/ProductCarouselMain/JC002%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc002_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550361866",
      "product_title": "AWDis Cool Smooth T-Shirt",
      "product_handle": "jc020",
      "product_url": "/products/jc020",
      "product_full_url": "https://oakdenemerch.com/products/jc020",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-jc020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49472871366922",
      "swatch_filename": "JC020_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_French_Navy.jpg?v=1774359994",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_French_Navy.jpg?v=1774359994",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020/ProductCarouselMain/JC020%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49474218328330",
      "swatch_filename": "JC001_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_French_Navy.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_French_Navy.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562003210",
      "product_title": "AWDis Cool Vest",
      "product_handle": "jc007",
      "product_url": "/products/jc007",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc007",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49513921937674",
      "swatch_filename": "jc007_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_French_Navy.jpg?v=1774618962",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_French_Navy.jpg?v=1774618962",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC007/ProductCarouselMain/JC007%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550394634",
      "product_title": "AWDis Kids Cool Smooth T-Shirt",
      "product_handle": "jc020b",
      "product_url": "/products/jc020b",
      "product_full_url": "https://oakdenemerch.com/products/jc020b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "style-jc020b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020B",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49474193064202",
      "swatch_filename": "JC020B_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020B_French_Navy.jpg?v=1774370151",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020B_French_Navy.jpg?v=1774370151",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020B/ProductCarouselMain/JC020B%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020b_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49474210398474",
      "swatch_filename": "JC001B_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_French_Navy.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_French_Navy.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550427402",
      "product_title": "AWDis Ladies Cool Smooth T-Shirt",
      "product_handle": "jc025",
      "product_url": "/products/jc025",
      "product_full_url": "https://oakdenemerch.com/products/jc025",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-jc025",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC025",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49474190835978",
      "swatch_filename": "JC025_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC025_French_Navy.jpg?v=1774370109",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC025_French_Navy.jpg?v=1774370109",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC025/ProductCarouselMain/JC025%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc025_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49473142653194",
      "swatch_filename": "JC005_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_French_Navy.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_French_Navy.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562101514",
      "product_title": "AWDis Ladies Cool Vest",
      "product_handle": "jc015",
      "product_url": "/products/jc015",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc015",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC015",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49513926689034",
      "swatch_filename": "jc015_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_French_Navy.jpg?v=1774618997",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_French_Navy.jpg?v=1774618997",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC015/ProductCarouselMain/JC015%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc015_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550198026",
      "product_title": "AWDis SuperCool™ Performance T-Shirt",
      "product_handle": "jc011",
      "product_url": "/products/jc011",
      "product_full_url": "https://oakdenemerch.com/products/jc011",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-jc011",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester piqué.",
      "style_code": "JC011",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49471825936650",
      "swatch_filename": "JC011_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC011_French_Navy.jpg?v=1774351619",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC011_French_Navy.jpg?v=1774351619",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC011/ProductCarouselMain/JC011%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc011_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549411594",
      "product_title": "Gildan SoftStyle® EZ T-Shirt",
      "product_handle": "gd04",
      "product_url": "/products/gd04",
      "product_full_url": "https://oakdenemerch.com/products/gd04",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd04",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "GD04",
      "colour_name": "Smoke",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#0d0d0e",
      "sort_bucket": "black",
      "sort_hue": 0.666667,
      "sort_sat": 0.071429,
      "sort_val": 0.054902,
      "swatch_file_id": "gid://shopify/MediaImage/49468937371914",
      "swatch_filename": "GD04_Smoke.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Smoke.jpg?v=1774313523",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Smoke.jpg?v=1774313523",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD04/ProductCarouselMain/GD04%20SMO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd04_Smoke.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD05",
      "colour_name": "Blackberry",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#221c36",
      "sort_bucket": "black",
      "sort_hue": 0.705128,
      "sort_sat": 0.481481,
      "sort_val": 0.211765,
      "swatch_file_id": "gid://shopify/MediaImage/49471386255626",
      "swatch_filename": "GD05_Blackberry.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Blackberry.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Blackberry.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20BBY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Blackberry.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549673738",
      "product_title": "Gildan Hammer Maxweight T-Shirt",
      "product_handle": "gd201",
      "product_url": "/products/gd201",
      "product_full_url": "https://oakdenemerch.com/products/gd201",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd201",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD201",
      "colour_name": "Dark Chocolate",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#0c0a0e",
      "sort_bucket": "black",
      "sort_hue": 0.75,
      "sort_sat": 0.285714,
      "sort_val": 0.054902,
      "swatch_file_id": "gid://shopify/MediaImage/49468939469066",
      "swatch_filename": "GD201_Dark_Chocolate.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_Dark_Chocolate.jpg?v=1774313827",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_Dark_Chocolate.jpg?v=1774313827",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD201/ProductCarouselMain/GD201%20DCH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd201_Dark_Chocolate.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Dark Chocolate",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#0c0a0e",
      "sort_bucket": "black",
      "sort_hue": 0.75,
      "sort_sat": 0.285714,
      "sort_val": 0.054902,
      "swatch_file_id": "gid://shopify/MediaImage/49471385796874",
      "swatch_filename": "GD05_Dark_Chocolate.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Dark_Chocolate.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Dark_Chocolate.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20DCH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Dark_Chocolate.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Dark Chocolate",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#0c0a0e",
      "sort_bucket": "black",
      "sort_hue": 0.75,
      "sort_sat": 0.285714,
      "sort_val": 0.054902,
      "swatch_file_id": "gid://shopify/MediaImage/49474267480330",
      "swatch_filename": "GD01_Dark_Chocolate.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Dark_Chocolate.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Dark_Chocolate.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20DCH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Dark_Chocolate.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD14",
      "colour_name": "Dark Chocolate",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#0c0a0e",
      "sort_bucket": "black",
      "sort_hue": 0.75,
      "sort_sat": 0.285714,
      "sort_val": 0.054902,
      "swatch_file_id": "gid://shopify/MediaImage/49490453561610",
      "swatch_filename": "gd14_Dark_Chocolate.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Dark_Chocolate.jpg?v=1774522842",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Dark_Chocolate.jpg?v=1774522842",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20DCH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Dark_Chocolate.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Dark Chocolate",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#0c0a0e",
      "sort_bucket": "black",
      "sort_hue": 0.75,
      "sort_sat": 0.285714,
      "sort_val": 0.054902,
      "swatch_file_id": "gid://shopify/MediaImage/49471398215946",
      "swatch_filename": "GD02_Dark_Chocolate.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Dark_Chocolate.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Dark_Chocolate.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20DCH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Dark_Chocolate.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% organic combed ringspun cotton/40% polyester.",
      "style_code": "AM10",
      "colour_name": "Black Marl",
      "colour_group": "Black > Heather/Effect Black",
      "rgb": "#3b3536",
      "sort_bucket": "black",
      "sort_hue": 0.972222,
      "sort_sat": 0.101695,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49474342682890",
      "swatch_filename": "AM10_Black_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Black_Marl.jpg?v=1774371249",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Black_Marl.jpg?v=1774371249",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20BCM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Black_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Absolute White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474449539338",
      "swatch_filename": "11500_Absolute_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Absolute_White.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Absolute_White.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20ABW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Absolute_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Absolute White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468934193418",
      "swatch_filename": "11502_Absolute_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Absolute_White.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Absolute_White.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20ABW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Absolute_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547642122",
      "product_title": "SOL'S Ladies Legend T-Shirt",
      "product_handle": "04776",
      "product_url": "/products/04776",
      "product_full_url": "https://oakdenemerch.com/products/04776",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-04776",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "04776",
      "colour_name": "Absolute White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472963608842",
      "swatch_filename": "04776_Absolute_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Absolute_White.jpg?v=1774360489",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Absolute_White.jpg?v=1774360489",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04776/ProductCarouselMain/04776%20ABW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04776_Absolute_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Absolute White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468823109898",
      "swatch_filename": "01825_Absolute_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Absolute_White.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Absolute_White.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20ABW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Absolute_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Absolute White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473718681866",
      "swatch_filename": "11380_Absolute_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Absolute_White.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Absolute_White.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20ABW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Absolute_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Absolute White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473744273674",
      "swatch_filename": "03981_Absolute_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Absolute_White.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Absolute_White.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20ABW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Absolute_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550656778",
      "product_title": "AWDis Cool Active Recycled Base Layer",
      "product_handle": "jc232",
      "product_url": "/products/jc232",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-jc232",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "91% recycled polyester/9% elastane.",
      "style_code": "JC232",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491395772682",
      "swatch_filename": "jc232_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc232_Arctic_White.jpg?v=1774526695",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc232_Arctic_White.jpg?v=1774526695",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC232/ProductCarouselMain/JC232%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc232_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687228682",
      "product_title": "AWDis Cool Long Sleeve Wicking T-Shirt",
      "product_handle": "jc002",
      "product_url": "/products/jc002",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jc002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC002",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490476761354",
      "swatch_filename": "jc002_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Arctic_White.jpg?v=1774522888",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Arctic_White.jpg?v=1774522888",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC002/ProductCarouselMain/JC002%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc002_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550361866",
      "product_title": "AWDis Cool Smooth T-Shirt",
      "product_handle": "jc020",
      "product_url": "/products/jc020",
      "product_full_url": "https://oakdenemerch.com/products/jc020",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-jc020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472871432458",
      "swatch_filename": "JC020_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Arctic_White.jpg?v=1774359994",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Arctic_White.jpg?v=1774359994",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020/ProductCarouselMain/JC020%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474218754314",
      "swatch_filename": "JC001_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Arctic_White.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Arctic_White.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550460170",
      "product_title": "AWDis Cool Urban Fitness T-Shirt",
      "product_handle": "jc110",
      "product_url": "/products/jc110",
      "product_full_url": "https://oakdenemerch.com/products/jc110",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-jc110",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% polyester.",
      "style_code": "JC110",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472593297674",
      "swatch_filename": "JC110_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC110_Arctic_White.jpg?v=1774357870",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC110_Arctic_White.jpg?v=1774357870",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC110/ProductCarouselMain/JC110%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc110_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562003210",
      "product_title": "AWDis Cool Vest",
      "product_handle": "jc007",
      "product_url": "/products/jc007",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc007",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513922003210",
      "swatch_filename": "jc007_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Arctic_White.jpg?v=1774618964",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Arctic_White.jpg?v=1774618964",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC007/ProductCarouselMain/JC007%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548559626",
      "product_title": "AWDis Heavyweight Boxy 240 T-Shirt",
      "product_handle": "at003",
      "product_url": "/products/at003",
      "product_full_url": "https://oakdenemerch.com/products/at003",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-at003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT003",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472884539658",
      "swatch_filename": "AT003_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT003_Arctic_White.jpg?v=1774360180",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT003_Arctic_White.jpg?v=1774360180",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT003/ProductCarouselMain/AT003%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at003_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550394634",
      "product_title": "AWDis Kids Cool Smooth T-Shirt",
      "product_handle": "jc020b",
      "product_url": "/products/jc020b",
      "product_full_url": "https://oakdenemerch.com/products/jc020b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "style-jc020b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020B",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474193031434",
      "swatch_filename": "JC020B_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020B_Arctic_White.jpg?v=1774370151",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020B_Arctic_White.jpg?v=1774370151",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020B/ProductCarouselMain/JC020B%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020b_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474210791690",
      "swatch_filename": "JC001B_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Arctic_White.jpg?v=1774370371",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Arctic_White.jpg?v=1774370371",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562068746",
      "product_title": "AWDis Kids Cool Vest",
      "product_handle": "jc007b",
      "product_url": "/products/jc007b",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "sleeveless",
        "style-jc007b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007B",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513925050634",
      "swatch_filename": "jc007b_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007b_Arctic_White.jpg?v=1774618989",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007b_Arctic_White.jpg?v=1774618989",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC007B/ProductCarouselMain/JC007B%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007b_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687261450",
      "product_title": "AWDis Ladies Cool Long Sleeve T-Shirt",
      "product_handle": "jc012",
      "product_url": "/products/jc012",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-jc012",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC012",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490477678858",
      "swatch_filename": "jc012_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc012_Arctic_White.jpg?v=1774522899",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc012_Arctic_White.jpg?v=1774522899",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC012/ProductCarouselMain/JC012%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc012_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550427402",
      "product_title": "AWDis Ladies Cool Smooth T-Shirt",
      "product_handle": "jc025",
      "product_url": "/products/jc025",
      "product_full_url": "https://oakdenemerch.com/products/jc025",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-jc025",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC025",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474190868746",
      "swatch_filename": "JC025_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC025_Arctic_White.jpg?v=1774370109",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC025_Arctic_White.jpg?v=1774370109",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC025/ProductCarouselMain/JC025%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc025_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562134282",
      "product_title": "AWDis Ladies Cool Smooth Workout Vest",
      "product_handle": "jc027",
      "product_url": "/products/jc027",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-jc027",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XXS",
        "XXS-XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC027",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513928491274",
      "swatch_filename": "jc027_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc027_Arctic_White.jpg?v=1774619019",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc027_Arctic_White.jpg?v=1774619019",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Just%20Cool/JC027/ProductCarouselMain/JC027%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc027_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550329098",
      "product_title": "AWDis Ladies Cool Sports Crop Top",
      "product_handle": "jc017",
      "product_url": "/products/jc017",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-jc017",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XXS",
        "XXS-XS-S-M-L-XL"
      ],
      "material": "Nylon/Elastane",
      "shopify_material": "Nylon/Elastane",
      "csv_material": "90% nylon/10% elastane.",
      "style_code": "JC017",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491400032522",
      "swatch_filename": "jc017_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc017_Arctic_White.jpg?v=1774526710",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc017_Arctic_White.jpg?v=1774526710",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC017/ProductCarouselMain/JC017%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc017_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473141932298",
      "swatch_filename": "JC005_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Arctic_White.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Arctic_White.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562101514",
      "product_title": "AWDis Ladies Cool Vest",
      "product_handle": "jc015",
      "product_url": "/products/jc015",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc015",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC015",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513926754570",
      "swatch_filename": "jc015_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Arctic_White.jpg?v=1774618999",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Arctic_White.jpg?v=1774618999",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC015/ProductCarouselMain/JC015%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc015_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686409482",
      "product_title": "AWDis Long Sleeve 180 T-Shirt",
      "product_handle": "at012",
      "product_url": "/products/at012",
      "product_full_url": "https://oakdenemerch.com/products/at012",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-shirt",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-at012",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT012",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490397167882",
      "swatch_filename": "at012_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/at012_Arctic_White.jpg?v=1774522776",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/at012_Arctic_White.jpg?v=1774522776",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT012/ProductCarouselMain/AT012%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at012_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471442485514",
      "swatch_filename": "AT001_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Arctic_White.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Arctic_White.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471429476618",
      "swatch_filename": "AT002_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Arctic_White.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Arctic_White.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549116682",
      "product_title": "Ecologie Cascades Organic T-Shirt",
      "product_handle": "ea001",
      "product_url": "/products/ea001",
      "product_full_url": "https://oakdenemerch.com/products/ea001",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-ea001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474304246026",
      "swatch_filename": "EA001_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Arctic_White.jpg?v=1774371175",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Arctic_White.jpg?v=1774371175",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001/ProductCarouselMain/EA001%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549214986",
      "product_title": "Ecologie Daintree EcoViscose T-Shirt",
      "product_handle": "ea002",
      "product_url": "/products/ea002",
      "product_full_url": "https://oakdenemerch.com/products/ea002",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-ea002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "70% Lenzing™ Ecovero™/30% organic cotton.",
      "shopify_material": "",
      "csv_material": "70% Lenzing™ Ecovero™/30% organic cotton.",
      "style_code": "EA002",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471837929738",
      "swatch_filename": "EA002_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA002_Arctic_White.jpg?v=1774351788",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA002_Arctic_White.jpg?v=1774351788",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA002/ProductCarouselMain/EA002%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea002_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686901002",
      "product_title": "Ecologie Erawan Organic Long Sleeve T-Shirt",
      "product_handle": "ea021",
      "product_url": "/products/ea021",
      "product_full_url": "None",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-ea021",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA021",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490437603594",
      "swatch_filename": "ea021_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ea021_Arctic_White.jpg?v=1774522818",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ea021_Arctic_White.jpg?v=1774522818",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA021/ProductCarouselMain/EA021%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea021_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549149450",
      "product_title": "Ecologie Kids Cascades Organic T-Shirt",
      "product_handle": "ea001b",
      "product_url": "/products/ea001b",
      "product_full_url": "https://oakdenemerch.com/products/ea001b",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "organic",
        "organic-recycled",
        "style-ea001b",
        "t-shirts"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001B",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474280718602",
      "swatch_filename": "EA001B_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001B_Arctic_White.jpg?v=1774371054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001B_Arctic_White.jpg?v=1774371054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001B/ProductCarouselMain/EA001B%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001b_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549182218",
      "product_title": "Ecologie Ladies Cascades Organic T-Shirt",
      "product_handle": "ea001f",
      "product_url": "/products/ea001f",
      "product_full_url": "https://oakdenemerch.com/products/ea001f",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-ea001f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001F",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474275049738",
      "swatch_filename": "EA001F_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001F_Arctic_White.jpg?v=1774370991",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001F_Arctic_White.jpg?v=1774370991",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001F/ProductCarouselMain/EA001F%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001f_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550099722",
      "product_title": "AWDis Cool Contrast Wicking T-Shirt",
      "product_handle": "jc003",
      "product_url": "/products/jc003",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003",
      "colour_name": "Arctic White/Fire Red",
      "colour_group": "White > White",
      "rgb": "#ffffff;#eb0024",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491408322826",
      "swatch_filename": "jc003_Arctic_WhiteFire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Arctic_WhiteFire_Red.jpg?v=1774526732",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Arctic_WhiteFire_Red.jpg?v=1774526732",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003/ProductCarouselMain/JC003%20AW%252fFR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003_Arctic_WhiteFire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550132490",
      "product_title": "AWDis Kids Cool Contrast T-Shirt",
      "product_handle": "jc003b",
      "product_url": "/products/jc003b",
      "product_full_url": "https://oakdenemerch.com/products/jc003b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "style-jc003b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003B",
      "colour_name": "Arctic White/Fire Red",
      "colour_group": "White > White",
      "rgb": "#ffffff;#eb0024",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474198110474",
      "swatch_filename": "JC003B_Arctic_WhiteFire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC003B_Arctic_WhiteFire_Red.jpg?v=1774370308",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC003B_Arctic_WhiteFire_Red.jpg?v=1774370308",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003B/ProductCarouselMain/JC003B%20AW%252fFR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003b_Arctic_WhiteFire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550099722",
      "product_title": "AWDis Cool Contrast Wicking T-Shirt",
      "product_handle": "jc003",
      "product_url": "/products/jc003",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003",
      "colour_name": "Arctic White/Sapphire Blue",
      "colour_group": "White > White",
      "rgb": "#ffffff;#26c9ff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491408683274",
      "swatch_filename": "jc003_Arctic_WhiteSapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Arctic_WhiteSapphire_Blue.jpg?v=1774526733",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Arctic_WhiteSapphire_Blue.jpg?v=1774526733",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003/ProductCarouselMain/JC003%20AW%252fSA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003_Arctic_WhiteSapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550132490",
      "product_title": "AWDis Kids Cool Contrast T-Shirt",
      "product_handle": "jc003b",
      "product_url": "/products/jc003b",
      "product_full_url": "https://oakdenemerch.com/products/jc003b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "style-jc003b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003B",
      "colour_name": "Arctic White/Sapphire Blue",
      "colour_group": "White > White",
      "rgb": "#ffffff;#26c9ff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474198044938",
      "swatch_filename": "JC003B_Arctic_WhiteSapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC003B_Arctic_WhiteSapphire_Blue.jpg?v=1774370308",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC003B_Arctic_WhiteSapphire_Blue.jpg?v=1774370308",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003B/ProductCarouselMain/JC003B%20AW%252fSA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003b_Arctic_WhiteSapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550099722",
      "product_title": "AWDis Cool Contrast Wicking T-Shirt",
      "product_handle": "jc003",
      "product_url": "/products/jc003",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003",
      "colour_name": "Fire Red/Arctic White",
      "colour_group": "Red > Red",
      "rgb": "#eb0024;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491409404170",
      "swatch_filename": "jc003_Fire_RedArctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Fire_RedArctic_White.jpg?v=1774526735",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Fire_RedArctic_White.jpg?v=1774526735",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003/ProductCarouselMain/JC003%20FR%252fAW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003_Fire_RedArctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550099722",
      "product_title": "AWDis Cool Contrast Wicking T-Shirt",
      "product_handle": "jc003",
      "product_url": "/products/jc003",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003",
      "colour_name": "French Navy/Arctic White",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491409862922",
      "swatch_filename": "jc003_French_NavyArctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_French_NavyArctic_White.jpg?v=1774526737",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_French_NavyArctic_White.jpg?v=1774526737",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003/ProductCarouselMain/JC003%20FN%252fAW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003_French_NavyArctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550132490",
      "product_title": "AWDis Kids Cool Contrast T-Shirt",
      "product_handle": "jc003b",
      "product_url": "/products/jc003b",
      "product_full_url": "https://oakdenemerch.com/products/jc003b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "style-jc003b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003B",
      "colour_name": "French Navy/Arctic White",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474197913866",
      "swatch_filename": "JC003B_French_NavyArctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC003B_French_NavyArctic_White.jpg?v=1774370308",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC003B_French_NavyArctic_White.jpg?v=1774370308",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003B/ProductCarouselMain/JC003B%20FN%252fAW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003b_French_NavyArctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550099722",
      "product_title": "AWDis Cool Contrast Wicking T-Shirt",
      "product_handle": "jc003",
      "product_url": "/products/jc003",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003",
      "colour_name": "Kelly Green/Arctic White",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#17bd09;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491410551050",
      "swatch_filename": "jc003_Kelly_GreenArctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Kelly_GreenArctic_White.jpg?v=1774526738",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Kelly_GreenArctic_White.jpg?v=1774526738",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003/ProductCarouselMain/JC003%20KG%252fAW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003_Kelly_GreenArctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547642122",
      "product_title": "SOL'S Ladies Legend T-Shirt",
      "product_handle": "04776",
      "product_url": "/products/04776",
      "product_full_url": "https://oakdenemerch.com/products/04776",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-04776",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "04776",
      "colour_name": "Navy/Off White",
      "colour_group": "Patterns > Stripes",
      "rgb": "#061731;#f2ede6",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472963313930",
      "swatch_filename": "04776_NavyOff_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_NavyOff_White.jpg?v=1774360489",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_NavyOff_White.jpg?v=1774360489",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04776/ProductCarouselMain/04776%20NV_OW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04776_NavyOff_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Navy/Off White",
      "colour_group": "Patterns > Stripes",
      "rgb": "#061731;#f2ede6",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473745125642",
      "swatch_filename": "03981_NavyOff_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_NavyOff_White.jpg?v=1774365053",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_NavyOff_White.jpg?v=1774365053",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20NV_OW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_NavyOff_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551770890",
      "product_title": "Finden + Hales Performance Panel T-Shirt",
      "product_handle": "lv240",
      "product_url": "/products/lv240",
      "product_full_url": "https://oakdenemerch.com/products/lv240",
      "vendor": "Finden + Hales",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-lv240",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "LV240",
      "colour_name": "Navy/Royal Blue/White",
      "colour_group": "Blue > Navy",
      "rgb": "#0c184a;#0746d9;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472787185930",
      "swatch_filename": "LV240_NavyRoyal_BlueWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV240_NavyRoyal_BlueWhite.jpg?v=1774359730",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV240_NavyRoyal_BlueWhite.jpg?v=1774359730",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV240/ProductCarouselMain/LV240%20N-R-W%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv240_NavyRoyal_BlueWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551836426",
      "product_title": "Finden + Hales Kids Team T-Shirt",
      "product_handle": "lv292",
      "product_url": "/products/lv292",
      "product_full_url": "https://oakdenemerch.com/products/lv292",
      "vendor": "Finden + Hales",
      "product_type": "T-Shirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-lv292",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "LV292",
      "colour_name": "Navy/White",
      "colour_group": "Blue > Navy",
      "rgb": "#0c184a;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474137325834",
      "swatch_filename": "LV292_NavyWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV292_NavyWhite.jpg?v=1774369540",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV292_NavyWhite.jpg?v=1774369540",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV292/ProductCarouselMain/LV292%20NV%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv292_NavyWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551803658",
      "product_title": "Finden + Hales Unisex Team T-Shirt",
      "product_handle": "lv290",
      "product_url": "/products/lv290",
      "product_full_url": "https://oakdenemerch.com/products/lv290",
      "vendor": "Finden + Hales",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv290",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "LV290",
      "colour_name": "Navy/White",
      "colour_group": "Blue > Navy",
      "rgb": "#0c184a;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472784433418",
      "swatch_filename": "LV290_NavyWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV290_NavyWhite.jpg?v=1774359680",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV290_NavyWhite.jpg?v=1774359680",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV290/ProductCarouselMain/LV290%20NV%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv290_NavyWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549280522",
      "product_title": "Front Row Unisex Breton Striped T-Shirt",
      "product_handle": "fr135",
      "product_url": "/products/fr135",
      "product_full_url": "https://oakdenemerch.com/products/fr135",
      "vendor": "Front Row",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-fr135",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton single jersey.",
      "style_code": "FR135",
      "colour_name": "Navy/White",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472601489674",
      "swatch_filename": "FR135_NavyWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/FR135_NavyWhite.jpg?v=1774358004",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/FR135_NavyWhite.jpg?v=1774358004",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Front%20Row/Product%20Images/FR135/ProductCarouselMain/FR135%20NV%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "fr135_NavyWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686933770",
      "product_title": "Front Row Unisex Long Sleeve Breton Striped T-Shirt",
      "product_handle": "fr134",
      "product_url": "/products/fr134",
      "product_full_url": "None",
      "vendor": "Front Row",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-fr134",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton single jersey.",
      "style_code": "FR134",
      "colour_name": "Navy/White",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490439110922",
      "swatch_filename": "fr134_NavyWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/fr134_NavyWhite.jpg?v=1774522822",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/fr134_NavyWhite.jpg?v=1774522822",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Front%20Row/Product%20Images/FR134/ProductCarouselMain/FR134%20NV%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "fr134_NavyWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554294026",
      "product_title": "Fruit of the Loom Contrast Ringer T-Shirt",
      "product_handle": "ss34",
      "product_url": "/products/ss34",
      "product_full_url": "https://oakdenemerch.com/products/ss34",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss34",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS34",
      "colour_name": "Navy/White",
      "colour_group": "Blue > Navy",
      "rgb": "#002466;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468953231626",
      "swatch_filename": "SS34_NavyWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS34_NavyWhite.jpg?v=1774315005",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS34_NavyWhite.jpg?v=1774315005",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS34/ProductCarouselMain/SS34%20NV%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss34_NavyWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552590090",
      "product_title": "Premier Unisex Utility 2.0 Oversized T-Shirt",
      "product_handle": "pr020",
      "product_url": "/products/pr020",
      "product_full_url": "https://oakdenemerch.com/products/pr020",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-pr020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% BCI cotton.",
      "style_code": "PR020",
      "colour_name": "Navy/White Stripe",
      "colour_group": "Patterns > Stripes",
      "rgb": "#041848;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473100251402",
      "swatch_filename": "PR020_NavyWhite_Stripe.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR020_NavyWhite_Stripe.jpg?v=1774361960",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR020_NavyWhite_Stripe.jpg?v=1774361960",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR020/ProductCarouselMain/PR020%20N_WST%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr020_NavyWhite_Stripe.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547642122",
      "product_title": "SOL'S Ladies Legend T-Shirt",
      "product_handle": "04776",
      "product_url": "/products/04776",
      "product_full_url": "https://oakdenemerch.com/products/04776",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-04776",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "04776",
      "colour_name": "Off White/Navy",
      "colour_group": "Patterns > Stripes",
      "rgb": "#f2ede6;#061731",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472963641610",
      "swatch_filename": "04776_Off_WhiteNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Off_WhiteNavy.jpg?v=1774360489",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Off_WhiteNavy.jpg?v=1774360489",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04776/ProductCarouselMain/04776%20OW_NV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04776_Off_WhiteNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Off White/Navy",
      "colour_group": "Patterns > Stripes",
      "rgb": "#f2ede6;#061731",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473745223946",
      "swatch_filename": "03981_Off_WhiteNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Off_WhiteNavy.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Off_WhiteNavy.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20OW_NV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Off_WhiteNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550099722",
      "product_title": "AWDis Cool Contrast Wicking T-Shirt",
      "product_handle": "jc003",
      "product_url": "/products/jc003",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003",
      "colour_name": "Purple/Arctic White",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#2504b1;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491411763466",
      "swatch_filename": "jc003_PurpleArctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_PurpleArctic_White.jpg?v=1774526740",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_PurpleArctic_White.jpg?v=1774526740",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003/ProductCarouselMain/JC003%20PR%252fAW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003_PurpleArctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554294026",
      "product_title": "Fruit of the Loom Contrast Ringer T-Shirt",
      "product_handle": "ss34",
      "product_url": "/products/ss34",
      "product_full_url": "https://oakdenemerch.com/products/ss34",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss34",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS34",
      "colour_name": "Red/White",
      "colour_group": "Red > Red",
      "rgb": "#ff002e;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468953067786",
      "swatch_filename": "SS34_RedWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS34_RedWhite.jpg?v=1774315005",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS34_RedWhite.jpg?v=1774315005",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS34/ProductCarouselMain/SS34%20RD%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss34_RedWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553868042",
      "product_title": "Spiro Basketball Top",
      "product_handle": "sr278m",
      "product_url": "/products/sr278m",
      "product_full_url": "None",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "lightweight",
        "M",
        "S",
        "style-sr278m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "SR278M",
      "colour_name": "Red/White",
      "colour_group": "Red > Red",
      "rgb": "#e10037;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491286819082",
      "swatch_filename": "sr278m_RedWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr278m_RedWhite.jpg?v=1774526417",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr278m_RedWhite.jpg?v=1774526417",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR278M/ProductCarouselMain/SR278M%20RD%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr278m_RedWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550099722",
      "product_title": "AWDis Cool Contrast Wicking T-Shirt",
      "product_handle": "jc003",
      "product_url": "/products/jc003",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003",
      "colour_name": "Royal Blue/Arctic White",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491412451594",
      "swatch_filename": "jc003_Royal_BlueArctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Royal_BlueArctic_White.jpg?v=1774526742",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Royal_BlueArctic_White.jpg?v=1774526742",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003/ProductCarouselMain/JC003%20RY%252fAW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003_Royal_BlueArctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550132490",
      "product_title": "AWDis Kids Cool Contrast T-Shirt",
      "product_handle": "jc003b",
      "product_url": "/products/jc003b",
      "product_full_url": "https://oakdenemerch.com/products/jc003b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "style-jc003b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003B",
      "colour_name": "Royal Blue/Arctic White",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474198012170",
      "swatch_filename": "JC003B_Royal_BlueArctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC003B_Royal_BlueArctic_White.jpg?v=1774370307",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC003B_Royal_BlueArctic_White.jpg?v=1774370307",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003B/ProductCarouselMain/JC003B%20RY%252fAW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003b_Royal_BlueArctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554294026",
      "product_title": "Fruit of the Loom Contrast Ringer T-Shirt",
      "product_handle": "ss34",
      "product_url": "/products/ss34",
      "product_full_url": "https://oakdenemerch.com/products/ss34",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss34",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS34",
      "colour_name": "Royal Blue/White",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468953198858",
      "swatch_filename": "SS34_Royal_BlueWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS34_Royal_BlueWhite.jpg?v=1774315005",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS34_Royal_BlueWhite.jpg?v=1774315005",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS34/ProductCarouselMain/SS34%20RY%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss34_Royal_BlueWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553868042",
      "product_title": "Spiro Basketball Top",
      "product_handle": "sr278m",
      "product_url": "/products/sr278m",
      "product_full_url": "None",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "lightweight",
        "M",
        "S",
        "style-sr278m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "SR278M",
      "colour_name": "Royal Blue/White",
      "colour_group": "Blue > Royal",
      "rgb": "#001da8;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491287900426",
      "swatch_filename": "sr278m_Royal_BlueWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr278m_Royal_BlueWhite.jpg?v=1774526418",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr278m_Royal_BlueWhite.jpg?v=1774526418",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR278M/ProductCarouselMain/SR278M%20RY%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr278m_Royal_BlueWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687425290",
      "product_title": "AWDis Ladies Long Sleeve Cropped T-Shirt",
      "product_handle": "jt016",
      "product_url": "/products/jt016",
      "product_full_url": "None",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-jt016",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Poly/Viscose",
      "shopify_material": "Poly/Viscose",
      "csv_material": "50% polyester/25% viscose/25% cotton.*",
      "style_code": "JT016",
      "colour_name": "Solid White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490478989578",
      "swatch_filename": "jt016_Solid_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jt016_Solid_White.jpg?v=1774522920",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jt016_Solid_White.jpg?v=1774522920",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT016/ProductCarouselMain/JT016%20SWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt016_Solid_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550787850",
      "product_title": "AWDis Ladies Tri-Blend Cropped T-Shirt",
      "product_handle": "jt006",
      "product_url": "/products/jt006",
      "product_full_url": "https://oakdenemerch.com/products/jt006",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-jt006",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% cotton/25% viscose.*",
      "style_code": "JT006",
      "colour_name": "Solid White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474185888010",
      "swatch_filename": "JT006_Solid_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT006_Solid_White.jpg?v=1774370028",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT006_Solid_White.jpg?v=1774370028",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT006/ProductCarouselMain/JT006%20SWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt006_Solid_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687326986",
      "product_title": "AWDis Long Sleeve Tri-Blend T-Shirt",
      "product_handle": "jt002",
      "product_url": "/products/jt002",
      "product_full_url": "None",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jt002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% viscose/25% cotton.",
      "style_code": "JT002",
      "colour_name": "Solid White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490478760202",
      "swatch_filename": "jt002_Solid_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jt002_Solid_White.jpg?v=1774522914",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jt002_Solid_White.jpg?v=1774522914",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT002/ProductCarouselMain/JT002%20SWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt002_Solid_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548592394",
      "product_title": "Bella Ladies Micro Rib Baby T-Shirt",
      "product_handle": "bl1010",
      "product_url": "/products/bl1010",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "M",
        "S",
        "style-bl1010",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1010",
      "colour_name": "Solid White Blend",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491497976074",
      "swatch_filename": "bl1010_Solid_White_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1010_Solid_White_Blend.jpg?v=1774526812",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1010_Solid_White_Blend.jpg?v=1774526812",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1010/ProductCarouselMain/BL1010%20SWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1010_Solid_White_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561839370",
      "product_title": "Bella Ladies Micro Rib Racer Tank Top",
      "product_handle": "bl1019",
      "product_url": "/products/bl1019",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-bl1019",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1019",
      "colour_name": "Solid White Blend",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513917743370",
      "swatch_filename": "bl1019_Solid_White_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1019_Solid_White_Blend.jpg?v=1774618919",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1019_Solid_White_Blend.jpg?v=1774618919",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1019/ProductCarouselMain/BL1019%20SWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1019_Solid_White_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561806602",
      "product_title": "Bella Ladies Micro Rib Spaghetti Strap Tank Top",
      "product_handle": "bl1012",
      "product_url": "/products/bl1012",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-bl1012",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1012",
      "colour_name": "Solid White Blend",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513916104970",
      "swatch_filename": "bl1012_Solid_White_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1012_Solid_White_Blend.jpg?v=1774618906",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1012_Solid_White_Blend.jpg?v=1774618906",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1012/ProductCarouselMain/BL1012%20SWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1012_Solid_White_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686475018",
      "product_title": "Bella Micro Rib Long Sleeve Baby T-Shirt",
      "product_handle": "bl1501",
      "product_url": "/products/bl1501",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-bl1501",
        "t-shirts",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1501",
      "colour_name": "Solid White Blend",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490402050314",
      "swatch_filename": "bl1501_Solid_White_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1501_Solid_White_Blend.jpg?v=1774522783",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1501_Solid_White_Blend.jpg?v=1774522783",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1501/ProductCarouselMain/BL1501%20SWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1501_Solid_White_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548461322",
      "product_title": "Anthem Distortion Washed T-Shirt",
      "product_handle": "am19",
      "product_url": "/products/am19",
      "product_full_url": "https://oakdenemerch.com/products/am19",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-am19",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed ringspun cotton.",
      "style_code": "AM19",
      "colour_name": "Washed White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472886866186",
      "swatch_filename": "AM19_Washed_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM19_Washed_White.jpg?v=1774360222",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM19_Washed_White.jpg?v=1774360222",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM19/ProductCarouselMain/AM19%20WDW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am19_Washed_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548428554",
      "product_title": "Anthem Amplify Heavyweight T-Shirt",
      "product_handle": "am18",
      "product_url": "/products/am18",
      "product_full_url": "https://oakdenemerch.com/products/am18",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-am18",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM18",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472893223178",
      "swatch_filename": "AM18_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_White.jpg?v=1774360285",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_White.jpg?v=1774360285",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM18/ProductCarouselMain/AM18%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am18_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686311178",
      "product_title": "Anthem Headline Heavy Long Sleeve T-Shirt",
      "product_handle": "am16",
      "product_url": "/products/am16",
      "product_full_url": "None",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "PCBest_Seller",
        "S",
        "style-am16",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "AM16",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490391793930",
      "swatch_filename": "am16_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am16_White.jpg?v=1774522771",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am16_White.jpg?v=1774522771",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM16/ProductCarouselMain/AM16%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am16_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686212874",
      "product_title": "Anthem Organic Long Sleeve T-Shirt",
      "product_handle": "am11",
      "product_url": "/products/am11",
      "product_full_url": "None",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-am11",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM11",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490376851722",
      "swatch_filename": "am11_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am11_White.jpg?v=1774522763",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am11_White.jpg?v=1774522763",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM11/ProductCarouselMain/AM11%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am11_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474343469322",
      "swatch_filename": "AM10_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_White.jpg?v=1774371250",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_White.jpg?v=1774371250",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548395786",
      "product_title": "Anthem Unisex Organic Heavyweight T-Shirt",
      "product_handle": "am15",
      "product_url": "/products/am15",
      "product_full_url": "https://oakdenemerch.com/products/am15",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am15",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM15",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472895910154",
      "swatch_filename": "AM15_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_White.jpg?v=1774360325",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_White.jpg?v=1774360325",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM15/ProductCarouselMain/AM15%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am15_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548363018",
      "product_title": "Anthem Unisex Organic Midweight T-Shirt",
      "product_handle": "am12",
      "product_url": "/products/am12",
      "product_full_url": "https://oakdenemerch.com/products/am12",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am12",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM12",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472902529290",
      "swatch_filename": "AM12_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_White.jpg?v=1774360382",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_White.jpg?v=1774360382",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM12/ProductCarouselMain/AM12%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am12_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550230794",
      "product_title": "AWDis Ladies Cool Open Back T-Shirt",
      "product_handle": "jc013",
      "product_url": "/products/jc013",
      "product_full_url": "https://oakdenemerch.com/products/jc013",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-jc013",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC013",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474195030282",
      "swatch_filename": "JC013_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC013_White.jpg?v=1774370211",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC013_White.jpg?v=1774370211",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC013/ProductCarouselMain/JC013%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc013_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550951690",
      "product_title": "AWDis Signature Heavyweight T-Shirt",
      "product_handle": "jt120",
      "product_url": "/products/jt120",
      "product_full_url": "https://oakdenemerch.com/products/jt120",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "heavyweight",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jt120",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.",
      "style_code": "JT120",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471783010570",
      "swatch_filename": "JT120_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT120_White.jpg?v=1774351411",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT120_White.jpg?v=1774351411",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT120/ProductCarouselMain/JT120%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt120_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687523594",
      "product_title": "AWDis Unisex Oversize 100 Long Sleeve T-Shirt",
      "product_handle": "jt019",
      "product_url": "/products/jt019",
      "product_full_url": "None",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jt019",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.",
      "style_code": "JT019",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490479317258",
      "swatch_filename": "jt019_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jt019_White.jpg?v=1774522929",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jt019_White.jpg?v=1774522929",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT019/ProductCarouselMain/JT019%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt019_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550820618",
      "product_title": "AWDis Unisex Oversize 100 T-Shirt",
      "product_handle": "jt009",
      "product_url": "/products/jt009",
      "product_full_url": "https://oakdenemerch.com/products/jt009",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jt009",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.*",
      "style_code": "JT009",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471818170634",
      "swatch_filename": "JT009_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_White.jpg?v=1774351553",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_White.jpg?v=1774351553",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT009/ProductCarouselMain/JT009%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt009_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548690698",
      "product_title": "Bella Ladies Heavy Boxy T-Shirt",
      "product_handle": "bl6110",
      "product_url": "/products/bl6110",
      "product_full_url": "https://oakdenemerch.com/products/bl6110",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-bl6110",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "BL6110",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472881361162",
      "swatch_filename": "BL6110_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_White.jpg?v=1774360125",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_White.jpg?v=1774360125",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL6110/ProductCarouselMain/BL6110%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl6110_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548723466",
      "product_title": "Bella Ladies Relaxed Jersey T-Shirt",
      "product_handle": "bl6400",
      "product_url": "/products/bl6400",
      "product_full_url": "https://oakdenemerch.com/products/bl6400",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-bl6400",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "BL6400",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471852871946",
      "swatch_filename": "BL6400_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6400_White.jpg?v=1774351968",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6400_White.jpg?v=1774351968",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL6400/ProductCarouselMain/BL6400%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl6400_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473258914058",
      "swatch_filename": "CV3001_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_White.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_White.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548920074",
      "product_title": "Canvas Unisex Heavyweight Boxy T-Shirt",
      "product_handle": "cv3010",
      "product_url": "/products/cv3010",
      "product_full_url": "https://oakdenemerch.com/products/cv3010",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv3010",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3010",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472879460618",
      "swatch_filename": "CV3010_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_White.jpg?v=1774360083",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_White.jpg?v=1774360083",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3010/ProductCarouselMain/CV3010%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3010_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686737162",
      "product_title": "Canvas Unisex Heavyweight Long Sleeve Boxy T-Shirt",
      "product_handle": "cv3511",
      "product_url": "/products/cv3511",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv3511",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3511",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490424070410",
      "swatch_filename": "cv3511_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_White.jpg?v=1774522800",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_White.jpg?v=1774522800",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3511/ProductCarouselMain/CV3511%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3511_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686835466",
      "product_title": "Canvas Unisex Heavyweight Long Sleeve T-Shirt",
      "product_handle": "cv4651",
      "product_url": "/products/cv4651",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv4651",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV4651",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490434785546",
      "swatch_filename": "cv4651_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4651_White.jpg?v=1774522812",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4651_White.jpg?v=1774522812",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV4651/ProductCarouselMain/CV4651%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv4651_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549018378",
      "product_title": "Canvas Unisex Heavyweight T-Shirt",
      "product_handle": "cv4610",
      "product_url": "/products/cv4610",
      "product_full_url": "https://oakdenemerch.com/products/cv4610",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv4610",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV4610",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473247543562",
      "swatch_filename": "CV4610_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV4610_White.jpg?v=1774362975",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV4610_White.jpg?v=1774362975",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV4610/ProductCarouselMain/CV4610%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv4610_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686638858",
      "product_title": "Canvas Unisex Jersey Long Sleeve T-Shirt",
      "product_handle": "cv3501",
      "product_url": "/products/cv3501",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv3501",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3501",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490419351818",
      "swatch_filename": "cv3501_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3501_White.jpg?v=1774522795",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3501_White.jpg?v=1774522795",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3501/ProductCarouselMain/CV3501%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3501_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549247754",
      "product_title": "Ecologie Arrow Recycled Heavy Oversize T-Shirt",
      "product_handle": "ea006",
      "product_url": "/products/ea006",
      "product_full_url": "https://oakdenemerch.com/products/ea006",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ea006",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "48% recycled cotton/47% recycled polyester/5% elastane.",
      "style_code": "EA006",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472604864778",
      "swatch_filename": "EA006_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA006_White.jpg?v=1774358065",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA006_White.jpg?v=1774358065",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA006/ProductCarouselMain/EA006%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea006_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562953482",
      "product_title": "Fruit of the Loom Athletic Vest",
      "product_handle": "ss18",
      "product_url": "/products/ss18",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "sleeveless",
        "sports",
        "style-ss18",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS18",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513937142026",
      "swatch_filename": "ss18_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss18_White.jpg?v=1774619145",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss18_White.jpg?v=1774619145",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS18/ProductCarouselMain/SS18%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss18_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552983306",
      "product_title": "Fruit of the Loom Heavy Cotton T-Shirt",
      "product_handle": "sa101",
      "product_url": "/products/sa101",
      "product_full_url": "https://oakdenemerch.com/products/sa101",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-sa101",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SA101",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468678570250",
      "swatch_filename": "SA101_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SA101_White.jpg?v=1774309789",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SA101_White.jpg?v=1774309789",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SA101/ProductCarouselMain/SA101%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sa101_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471285788938",
      "swatch_filename": "SS621_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_White.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_White.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688047882",
      "product_title": "Fruit of the Loom Iconic 195 Long Sleeve T-Shirt",
      "product_handle": "ss624",
      "product_url": "/products/ss624",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-ss624",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS624",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490486984970",
      "swatch_filename": "ss624_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss624_White.jpg?v=1774523030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss624_White.jpg?v=1774523030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS624/ProductCarouselMain/SS624%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss624_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471313838346",
      "swatch_filename": "SS620_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_White.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_White.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554621706",
      "product_title": "Fruit of the Loom Ladies Iconic 150 T-Shirt",
      "product_handle": "ss721",
      "product_url": "/products/ss721",
      "product_full_url": "https://oakdenemerch.com/products/ss721",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss721",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS721",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472056230154",
      "swatch_filename": "SS721_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_White.jpg?v=1774353579",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_White.jpg?v=1774353579",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS721/ProductCarouselMain/SS721%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss721_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS720",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472218759434",
      "swatch_filename": "SS720_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_White.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_White.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554556170",
      "product_title": "Fruit of the Loom Lady Fit Original T-Shirt",
      "product_handle": "ss712",
      "product_url": "/products/ss712",
      "product_full_url": "https://oakdenemerch.com/products/ss712",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss712",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS712",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472223084810",
      "swatch_filename": "SS712_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS712_White.jpg?v=1774353741",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS712_White.jpg?v=1774353741",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS712/ProductCarouselMain/SS712%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss712_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554654474",
      "product_title": "Fruit of the Loom Lady Fit Value T-Shirt",
      "product_handle": "ss77",
      "product_url": "/products/ss77",
      "product_full_url": "https://oakdenemerch.com/products/ss77",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss77",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS77",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472025854218",
      "swatch_filename": "SS77_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_White.jpg?v=1774353471",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_White.jpg?v=1774353471",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS77/ProductCarouselMain/SS77%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss77_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554523402",
      "product_title": "Fruit of the Loom Lady Fit Value V Neck T-Shirt",
      "product_handle": "ss702",
      "product_url": "/products/ss702",
      "product_full_url": "https://oakdenemerch.com/products/ss702",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss702",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS702",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472224166154",
      "swatch_filename": "SS702_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS702_White.jpg?v=1774353786",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS702_White.jpg?v=1774353786",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS702/ProductCarouselMain/SS702%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss702_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458563051786",
      "product_title": "Fruit of the Loom Lady Fit Value Vest",
      "product_handle": "ss704",
      "product_url": "/products/ss704",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-ss704",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS704",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513937993994",
      "swatch_filename": "ss704_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss704_White.jpg?v=1774619157",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss704_White.jpg?v=1774619157",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS704/ProductCarouselMain/SS704%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss704_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687982346",
      "product_title": "Fruit of the Loom Long Sleeve Value T-Shirt",
      "product_handle": "ss21",
      "product_url": "/products/ss21",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "knitwear",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss21",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS21",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490485313802",
      "swatch_filename": "ss21_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss21_White.jpg?v=1774523013",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss21_White.jpg?v=1774523013",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS21/ProductCarouselMain/SS21%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss21_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688080650",
      "product_title": "Fruit of the Loom Original Long Sleeve T-Shirt",
      "product_handle": "ss632",
      "product_url": "/products/ss632",
      "product_full_url": "https://oakdenemerch.com/products/ss632",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss632",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS632",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490487443722",
      "swatch_filename": "ss632_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss632_White.jpg?v=1774523038",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss632_White.jpg?v=1774523038",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS632/ProductCarouselMain/SS632%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss632_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471330222346",
      "swatch_filename": "SS12_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_White.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_White.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554425098",
      "product_title": "Fruit of the Loom Original V Neck T-Shirt",
      "product_handle": "ss631",
      "product_url": "/products/ss631",
      "product_full_url": "https://oakdenemerch.com/products/ss631",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-ss631",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS631",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471693914378",
      "swatch_filename": "SS631_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS631_White.jpg?v=1774350965",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS631_White.jpg?v=1774350965",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS631/ProductCarouselMain/SS631%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss631_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554457866",
      "product_title": "Fruit of the Loom Pure Cotton T-Shirt",
      "product_handle": "ss640",
      "product_url": "/products/ss640",
      "product_full_url": "https://oakdenemerch.com/products/ss640",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss640",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "SS640",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468957917450",
      "swatch_filename": "SS640_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_White.jpg?v=1774315115",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_White.jpg?v=1774315115",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS640/ProductCarouselMain/SS640%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss640_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554195722",
      "product_title": "Fruit of the Loom Super Premium T-Shirt",
      "product_handle": "ss10",
      "product_url": "/products/ss10",
      "product_full_url": "https://oakdenemerch.com/products/ss10",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss10",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS10",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471341723914",
      "swatch_filename": "SS10_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_White.jpg?v=1774348796",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_White.jpg?v=1774348796",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS10/ProductCarouselMain/SS10%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss10_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554490634",
      "product_title": "Fruit of the Loom V Neck Value T-Shirt",
      "product_handle": "ss7",
      "product_url": "/products/ss7",
      "product_full_url": "https://oakdenemerch.com/products/ss7",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss7",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS7",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471271993610",
      "swatch_filename": "SS7_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_White.jpg?v=1774348430",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_White.jpg?v=1774348430",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS7/ProductCarouselMain/SS7%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss7_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471322358026",
      "swatch_filename": "SS6_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_White.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_White.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687097610",
      "product_title": "Gildan Hammer Heavyweight Long Sleeve T-Shirt",
      "product_handle": "gd22",
      "product_url": "/products/gd22",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-gd22",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD22",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490467127562",
      "swatch_filename": "gd22_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd22_White.jpg?v=1774522869",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd22_White.jpg?v=1774522869",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD22/ProductCarouselMain/GD22%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd22_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549706506",
      "product_title": "Gildan Hammer Heavyweight T-Shirt",
      "product_handle": "gd21",
      "product_url": "/products/gd21",
      "product_full_url": "https://oakdenemerch.com/products/gd21",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-gd21",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD21",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49470943428874",
      "swatch_filename": "GD21_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD21_White.jpg?v=1774347002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD21_White.jpg?v=1774347002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD21/ProductCarouselMain/GD21%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd21_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549673738",
      "product_title": "Gildan Hammer Maxweight T-Shirt",
      "product_handle": "gd201",
      "product_url": "/products/gd201",
      "product_full_url": "https://oakdenemerch.com/products/gd201",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd201",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD201",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468939370762",
      "swatch_filename": "GD201_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_White.jpg?v=1774313827",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_White.jpg?v=1774313827",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD201/ProductCarouselMain/GD201%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd201_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471385993482",
      "swatch_filename": "GD05_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_White.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_White.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549509898",
      "product_title": "Gildan Heavy Cotton™ Toddler T-Shirt",
      "product_handle": "gd05p",
      "product_url": "/products/gd05p",
      "product_full_url": "https://oakdenemerch.com/products/gd05p",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "2T",
        "2T-3T-4T-5T-6T",
        "3T",
        "4T",
        "5T",
        "6T",
        "baby-toddler",
        "style-gd05p",
        "t-shirts",
        "unisex"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05P",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474248737034",
      "swatch_filename": "GD05P_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05P_White.jpg?v=1774370725",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05P_White.jpg?v=1774370725",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05P/ProductCarouselMain/GD05P%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05p_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549903114",
      "product_title": "Gildan Ladies Heavy Cotton™ T-Shirt",
      "product_handle": "gd95",
      "product_url": "/products/gd95",
      "product_full_url": "https://oakdenemerch.com/products/gd95",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd95",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD95",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468944417034",
      "swatch_filename": "GD95_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD95_White.jpg?v=1774314277",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD95_White.jpg?v=1774314277",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD95/ProductCarouselMain/GD95%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd95_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549837578",
      "product_title": "Gildan Ladies SoftStyle® Midweight T-Shirt",
      "product_handle": "gd92",
      "product_url": "/products/gd92",
      "product_full_url": "https://oakdenemerch.com/products/gd92",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd92",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD92",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468942024970",
      "swatch_filename": "GD92_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD92_White.jpg?v=1774314177",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD92_White.jpg?v=1774314177",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD92/ProductCarouselMain/GD92%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd92_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549772042",
      "product_title": "Gildan Ladies SoftStyle® T-Shirt",
      "product_handle": "gd72",
      "product_url": "/products/gd72",
      "product_full_url": "https://oakdenemerch.com/products/gd72",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd72",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD72",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468940517642",
      "swatch_filename": "GD72_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_White.jpg?v=1774314002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_White.jpg?v=1774314002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD72/ProductCarouselMain/GD72%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd72_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561970442",
      "product_title": "Gildan Ladies SoftStyle® Tank Top",
      "product_handle": "gd77",
      "product_url": "/products/gd77",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd77",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.",
      "style_code": "GD77",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513920692490",
      "swatch_filename": "gd77_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd77_White.jpg?v=1774618951",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd77_White.jpg?v=1774618951",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD77/ProductCarouselMain/GD77%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd77_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549804810",
      "product_title": "Gildan Ladies SoftStyle® V Neck T-Shirt",
      "product_handle": "gd78",
      "product_url": "/products/gd78",
      "product_full_url": "https://oakdenemerch.com/products/gd78",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd78",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD78",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471832621322",
      "swatch_filename": "GD78_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD78_White.jpg?v=1774351724",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD78_White.jpg?v=1774351724",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD78/ProductCarouselMain/GD78%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd78_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549411594",
      "product_title": "Gildan SoftStyle® EZ T-Shirt",
      "product_handle": "gd04",
      "product_url": "/products/gd04",
      "product_full_url": "https://oakdenemerch.com/products/gd04",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd04",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "GD04",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468937208074",
      "swatch_filename": "GD04_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_White.jpg?v=1774313523",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_White.jpg?v=1774313523",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD04/ProductCarouselMain/GD04%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd04_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686966538",
      "product_title": "Gildan SoftStyle® Long Sleeve T-Shirt",
      "product_handle": "gd11",
      "product_url": "/products/gd11",
      "product_full_url": "https://oakdenemerch.com/products/gd11",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd11",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD11",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490441797898",
      "swatch_filename": "gd11_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_White.jpg?v=1774522828",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_White.jpg?v=1774522828",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD11/ProductCarouselMain/GD11%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd11_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471369183498",
      "swatch_filename": "GD15_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_White.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_White.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561937674",
      "product_title": "Gildan SoftStyle® Tank Top",
      "product_handle": "gd12",
      "product_url": "/products/gd12",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD12",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513919185162",
      "swatch_filename": "gd12_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd12_White.jpg?v=1774618937",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd12_White.jpg?v=1774618937",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD12/ProductCarouselMain/GD12%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd12_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549575434",
      "product_title": "Gildan SoftStyle® V Neck T-Shirt",
      "product_handle": "gd10",
      "product_url": "/products/gd10",
      "product_full_url": "https://oakdenemerch.com/products/gd10",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd10",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD10",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468938715402",
      "swatch_filename": "GD10_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD10_White.jpg?v=1774313702",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD10_White.jpg?v=1774313702",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD10/ProductCarouselMain/GD10%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd10_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD14",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490454216970",
      "swatch_filename": "gd14_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_White.jpg?v=1774522844",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_White.jpg?v=1774522844",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471398904074",
      "swatch_filename": "GD02_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_White.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_White.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549935882",
      "product_title": "Henbury HiCool® Performance T-Shirt",
      "product_handle": "h024",
      "product_url": "/products/h024",
      "product_full_url": "https://oakdenemerch.com/products/h024",
      "vendor": "Henbury",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-h024",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% HiCool® polyester interlock.",
      "style_code": "H024",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473151664394",
      "swatch_filename": "H024_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/H024_White.jpg?v=1774362358",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/H024_White.jpg?v=1774362358",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H024/ProductCarouselMain/H024%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h024_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687163146",
      "product_title": "Henbury Long Sleeve Roll Neck Top",
      "product_handle": "h020",
      "product_url": "/products/h020",
      "product_full_url": "None",
      "vendor": "Henbury",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-h020",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane single jersey.",
      "style_code": "H020",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490472567050",
      "swatch_filename": "h020_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h020_White.jpg?v=1774522880",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h020_White.jpg?v=1774522880",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Henbury/H020/ProductCarouselMain/H020%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h020_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550001418",
      "product_title": "Henbury Unisex Coolplus® Wicking Piqué T-Shirt",
      "product_handle": "h075",
      "product_url": "/products/h075",
      "product_full_url": "https://oakdenemerch.com/products/h075",
      "vendor": "Henbury",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-h075",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester micro piqué.",
      "style_code": "H075",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474231369994",
      "swatch_filename": "H075_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/H075_White.jpg?v=1774370566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/H075_White.jpg?v=1774370566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H075/ProductCarouselMain/H075%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h075_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491370770698",
      "swatch_filename": "kb3025ic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_White.jpg?v=1774526620",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_White.jpg?v=1774526620",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551672586",
      "product_title": "Kariban Crew Neck T-Shirt",
      "product_handle": "kb356",
      "product_url": "/products/kb356",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb356",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed cotton.*",
      "style_code": "KB356",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491361071370",
      "swatch_filename": "kb356_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb356_White.jpg?v=1774526590",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb356_White.jpg?v=1774526590",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB356/ProductCarouselMain/KB356%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb356_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562167050",
      "product_title": "Kariban Eco-Friendly Tank Top",
      "product_handle": "kb3023ic",
      "product_url": "/products/kb3023ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3023ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3023IC",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513928884490",
      "swatch_filename": "kb3023ic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3023ic_White.jpg?v=1774619024",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3023ic_White.jpg?v=1774619024",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3023IC/ProductCarouselMain/KB3023IC%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3023ic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562265354",
      "product_title": "Kariban Ladies Eco-Friendly Tank Top",
      "product_handle": "kb3024ic",
      "product_url": "/products/kb3024ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-kb3024ic",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3024IC",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513929408778",
      "swatch_filename": "kb3024ic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3024ic_White.jpg?v=1774619033",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3024ic_White.jpg?v=1774619033",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3024IC/ProductCarouselMain/KB3024IC%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3024ic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551639818",
      "product_title": "Kariban Unisex 190IC Crew Neck T-Shirt",
      "product_handle": "kb3032ic",
      "product_url": "/products/kb3032ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3032ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3032IC",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491363627274",
      "swatch_filename": "kb3032ic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_White.jpg?v=1774526599",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_White.jpg?v=1774526599",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3032IC/ProductCarouselMain/KB3032IC%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3032ic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551049994",
      "product_title": "Kustom Kit Fashion Fit Cotton T-Shirt",
      "product_handle": "k507",
      "product_url": "/products/k507",
      "product_full_url": "https://oakdenemerch.com/products/k507",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-k507",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "K507",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472797835530",
      "swatch_filename": "K507_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K507_White.jpg?v=1774359878",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K507_White.jpg?v=1774359878",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K507/ProductCarouselMain/K507%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k507_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550984458",
      "product_title": "Kustom Kit Hunky® Superior T-Shirt",
      "product_handle": "k500",
      "product_url": "/products/k500",
      "product_full_url": "https://oakdenemerch.com/products/k500",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-k500",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed cotton.*",
      "style_code": "K500",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474181726474",
      "swatch_filename": "K500_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K500_White.jpg?v=1774369965",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K500_White.jpg?v=1774369965",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K500/ProductCarouselMain/K500%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k500_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551475978",
      "product_title": "Kustom Kit Ladies 3/4 Sleeve Mandarin Collar Top",
      "product_handle": "k785",
      "product_url": "/products/k785",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "12-14",
        "12-14-16-18-20-22-8-10",
        "16-18",
        "20-22",
        "8-10",
        "Long Sleeve T-Shirt",
        "style-k785",
        "t-shirts",
        "womens"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "95% cotton/5% elastane.",
      "style_code": "K785",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491383451914",
      "swatch_filename": "k785_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k785_White.jpg?v=1774526656",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k785_White.jpg?v=1774526656",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K785/ProductCarouselMain/K785%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k785_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551279370",
      "product_title": "Kustom Kit Ladies Keyhole Neck Corporate Top",
      "product_handle": "k755",
      "product_url": "/products/k755",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "12-14",
        "12-14-16-18-20-22-8-10",
        "16-18",
        "20-22",
        "8-10",
        "corporatewear",
        "style-k755",
        "t-shirts",
        "womens"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "95% cotton/5% elastane.",
      "style_code": "K755",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491387547914",
      "swatch_filename": "k755_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k755_White.jpg?v=1774526668",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k755_White.jpg?v=1774526668",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Kustom%20Kit/K755/ProductCarouselMain/K755%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k755_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551377674",
      "product_title": "Kustom Kit Ladies V Neck Corporate Top",
      "product_handle": "k770",
      "product_url": "/products/k770",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "12-14",
        "12-14-16-18-20-22-8-10",
        "16-18",
        "20-22",
        "8-10",
        "corporatewear",
        "style-k770",
        "t-shirts",
        "womens"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "95% cotton/5% elastane.",
      "style_code": "K770",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491385221386",
      "swatch_filename": "k770_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k770_White.jpg?v=1774526662",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k770_White.jpg?v=1774526662",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K770/ProductCarouselMain/K770%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k770_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551181066",
      "product_title": "Kustom Kit Regular Fit Cooltex® Plus Wicking T-Shirt",
      "product_handle": "k555",
      "product_url": "/products/k555",
      "product_full_url": "https://oakdenemerch.com/products/k555",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k555",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester mesh.",
      "style_code": "K555",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473108476170",
      "swatch_filename": "K555_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K555_White.jpg?v=1774362040",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K555_White.jpg?v=1774362040",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K555/ProductCarouselMain/K555%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k555_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551148298",
      "product_title": "Kustom Kit Superwash® 60°C Piqué T-Shirt",
      "product_handle": "k530",
      "product_url": "/products/k530",
      "product_full_url": "https://oakdenemerch.com/products/k530",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-k530",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton piqué.",
      "style_code": "K530",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472793313546",
      "swatch_filename": "K530_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K530_White.jpg?v=1774359823",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K530_White.jpg?v=1774359823",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K530/ProductCarouselMain/K530%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k530_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551017226",
      "product_title": "Kustom Kit Superwash® 60°C T-Shirt",
      "product_handle": "k504",
      "product_url": "/products/k504",
      "product_full_url": "https://oakdenemerch.com/products/k504",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k504",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton.*",
      "style_code": "K504",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473127285002",
      "swatch_filename": "K504_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K504_White.jpg?v=1774362160",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K504_White.jpg?v=1774362160",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K504/ProductCarouselMain/K504%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k504_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687589130",
      "product_title": "Kustom Kit Warmtex® Long Sleeve Base Layer",
      "product_handle": "k979",
      "product_url": "/products/k979",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-k979",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "90% polyester/10% spandex.",
      "style_code": "K979",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490479677706",
      "swatch_filename": "k979_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k979_White.jpg?v=1774522938",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k979_White.jpg?v=1774522938",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K979/ProductCarouselMain/K979%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k979_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687621898",
      "product_title": "Mantis Unisex Essential Heavy Long Sleeve T-Shirt",
      "product_handle": "m06",
      "product_url": "/products/m06",
      "product_full_url": "None",
      "vendor": "Mantis",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-m06",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "M06",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490480038154",
      "swatch_filename": "m06_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m06_White.jpg?v=1774522944",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m06_White.jpg?v=1774522944",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Mantis/M06/ProductCarouselMain/M06%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "m06_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552098570",
      "product_title": "Onna by Premier Ladies Unstoppable Fresh Underscrub Base Layer",
      "product_handle": "nn370",
      "product_url": "/products/nn370",
      "product_full_url": "None",
      "vendor": "Onna by Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-nn370",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Nylon",
      "shopify_material": "Nylon",
      "csv_material": "50% recycled nylon/50% nylon.",
      "style_code": "NN370",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491320307978",
      "swatch_filename": "nn370_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/nn370_White.jpg?v=1774526516",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/nn370_White.jpg?v=1774526516",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Onna%20by%20Premier/Product%20Images/NN370/ProductCarouselMain/NN370%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "nn370_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552065802",
      "product_title": "Onna by Premier Unstoppable Fresh Underscrub Base Layer",
      "product_handle": "nn270",
      "product_url": "/products/nn270",
      "product_full_url": "None",
      "vendor": "Onna by Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-nn270",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Nylon",
      "shopify_material": "Nylon",
      "csv_material": "50% recycled nylon/50% nylon.*",
      "style_code": "NN270",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491334103306",
      "swatch_filename": "nn270_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/nn270_White.jpg?v=1774526525",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/nn270_White.jpg?v=1774526525",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Onna%20by%20Premier/Product%20Images/NN270/ProductCarouselMain/NN270%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "nn270_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552786698",
      "product_title": "Premier Coolchecker® Chef's T-Shirt",
      "product_handle": "pr649",
      "product_url": "/products/pr649",
      "product_full_url": "https://oakdenemerch.com/products/pr649",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "chefswear-catering",
        "hospitality",
        "L",
        "M",
        "S",
        "style-pr649",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PR649",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474098397450",
      "swatch_filename": "PR649_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR649_White.jpg?v=1774369069",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR649_White.jpg?v=1774369069",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR649/ProductCarouselMain/PR649%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr649_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552655626",
      "product_title": "Premier Cotton Rich Comis T-Shirt",
      "product_handle": "pr219",
      "product_url": "/products/pr219",
      "product_full_url": "https://oakdenemerch.com/products/pr219",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-pr219",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% recycled polyester.*",
      "style_code": "PR219",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468948087050",
      "swatch_filename": "PR219_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR219_White.jpg?v=1774314717",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR219_White.jpg?v=1774314717",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR219/ProductCarouselMain/PR219%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr219_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687687434",
      "product_title": "Premier Essential Coolchecker® Long Sleeve Chef's Shirt",
      "product_handle": "pr647",
      "product_url": "/products/pr647",
      "product_full_url": "None",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "aprons",
        "chefswear-catering",
        "hospitality",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-pr647",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "PR647",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490481086730",
      "swatch_filename": "pr647_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr647_White.jpg?v=1774522960",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr647_White.jpg?v=1774522960",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR647/ProductCarouselMain/PR647%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr647_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552753930",
      "product_title": "Premier Essential Coolchecker® Short Sleeve Chef's Shirt",
      "product_handle": "pr646",
      "product_url": "/products/pr646",
      "product_full_url": "None",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "aprons",
        "chefswear-catering",
        "hospitality",
        "L",
        "M",
        "S",
        "style-pr646",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "PR646",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491312541962",
      "swatch_filename": "pr646_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr646_White.jpg?v=1774526490",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr646_White.jpg?v=1774526490",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR646/ProductCarouselMain/PR646%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr646_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552721162",
      "product_title": "Premier Ladies Cotton Rich Comis T-Shirt",
      "product_handle": "pr319",
      "product_url": "/products/pr319",
      "product_full_url": "https://oakdenemerch.com/products/pr319",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-pr319",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% recycled polyester.*",
      "style_code": "PR319",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472275218698",
      "swatch_filename": "PR319_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR319_White.jpg?v=1774354101",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR319_White.jpg?v=1774354101",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR319/ProductCarouselMain/PR319%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr319_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552688394",
      "product_title": "Premier Ladies Long John Roll Sleeve T-Shirt",
      "product_handle": "pr318",
      "product_url": "/products/pr318",
      "product_full_url": "None",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-pr318",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Viscose/Elastane",
      "shopify_material": "Poly/Viscose/Elastane",
      "csv_material": "82% polyester/14% viscose/4% elastane.",
      "style_code": "PR318",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491314245898",
      "swatch_filename": "pr318_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr318_White.jpg?v=1774526496",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr318_White.jpg?v=1774526496",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR318/ProductCarouselMain/PR318%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr318_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552622858",
      "product_title": "Premier Long John Roll Sleeve T-Shirt",
      "product_handle": "pr218",
      "product_url": "/products/pr218",
      "product_full_url": "https://oakdenemerch.com/products/pr218",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-pr218",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Viscose/Elastane",
      "shopify_material": "Poly/Viscose/Elastane",
      "csv_material": "82% polyester/14% viscose/4% elastane.",
      "style_code": "PR218",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472776896778",
      "swatch_filename": "PR218_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR218_White.jpg?v=1774359566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR218_White.jpg?v=1774359566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR218/ProductCarouselMain/PR218%20WHI%20FRONT%202.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr218_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552590090",
      "product_title": "Premier Unisex Utility 2.0 Oversized T-Shirt",
      "product_handle": "pr020",
      "product_url": "/products/pr020",
      "product_full_url": "https://oakdenemerch.com/products/pr020",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-pr020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% BCI cotton.",
      "style_code": "PR020",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473100087562",
      "swatch_filename": "PR020_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR020_White.jpg?v=1774361959",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR020_White.jpg?v=1774361959",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR020/ProductCarouselMain/PR020%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr020_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687785738",
      "product_title": "Pro RTX Pro Long Sleeve T-Shirt",
      "product_handle": "rx152",
      "product_url": "/products/rx152",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx152",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX152",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490481873162",
      "swatch_filename": "rx152_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx152_White.jpg?v=1774522973",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx152_White.jpg?v=1774522973",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX152/ProductCarouselMain/RX152%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx152_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474088763658",
      "swatch_filename": "RX151_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_White.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_White.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552557322",
      "product_title": "Proact Ladies Performance T-Shirt",
      "product_handle": "pa439",
      "product_url": "/products/pa439",
      "product_full_url": "https://oakdenemerch.com/products/pa439",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa439",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA439",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471736905994",
      "swatch_filename": "PA439_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_White.jpg?v=1774351220",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_White.jpg?v=1774351220",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA439/ProductCarouselMain/PA439%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa439_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552491786",
      "product_title": "Proact Ladies Triblend Sports T-Shirt",
      "product_handle": "pa4021",
      "product_url": "/products/pa4021",
      "product_full_url": "https://oakdenemerch.com/products/pa4021",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-pa4021",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% cotton/25% viscose.",
      "style_code": "PA4021",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474101707018",
      "swatch_filename": "PA4021_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA4021_White.jpg?v=1774369137",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA4021_White.jpg?v=1774369137",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA4021/ProductCarouselMain/PA4021%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa4021_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552524554",
      "product_title": "Proact Performance T-Shirt",
      "product_handle": "pa438",
      "product_url": "/products/pa438",
      "product_full_url": "https://oakdenemerch.com/products/pa438",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa438",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA438",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471751880970",
      "swatch_filename": "PA438_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_White.jpg?v=1774351290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_White.jpg?v=1774351290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA438/ProductCarouselMain/PA438%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa438_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552459018",
      "product_title": "Proact Triblend Sports T-Shirt",
      "product_handle": "pa4011",
      "product_url": "/products/pa4011",
      "product_full_url": "https://oakdenemerch.com/products/pa4011",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa4011",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% cotton/25% viscose.",
      "style_code": "PA4011",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471762006282",
      "swatch_filename": "PA4011_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA4011_White.jpg?v=1774351357",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA4011_White.jpg?v=1774351357",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA4011/ProductCarouselMain/PA4011%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa4011_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687720202",
      "product_title": "Regatta Thermal Long Sleeve Vest",
      "product_handle": "rg289",
      "product_url": "/products/rg289",
      "product_full_url": "None",
      "vendor": "Regatta Professional",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "sleeveless",
        "style-rg289",
        "t-shirts",
        "underwear-thermals",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "Polyester/cotton fabric.",
      "style_code": "RG289",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490481152266",
      "swatch_filename": "rg289_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg289_White.jpg?v=1774522965",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg289_White.jpg?v=1774522965",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Regatta%20Professional/Product%20Images/RG289/ProductCarouselMain/RG289%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rg289_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562461962",
      "product_title": "Regatta Thermal Short Sleeve Vest",
      "product_handle": "rg288",
      "product_url": "/products/rg288",
      "product_full_url": "None",
      "vendor": "Regatta Professional",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "sleeveless",
        "style-rg288",
        "t-shirts",
        "underwear-thermals",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "Polyester/cotton fabric.",
      "style_code": "RG288",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513932030218",
      "swatch_filename": "rg288_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg288_White.jpg?v=1774619071",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg288_White.jpg?v=1774619071",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Regatta%20Professional/Product%20Images/RG288/ProductCarouselMain/RG288%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rg288_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548297482",
      "product_title": "Russell Athletic Authentic Heavyweight T-Shirt",
      "product_handle": "215m",
      "product_url": "/products/215m",
      "product_full_url": "https://oakdenemerch.com/products/215m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "sports",
        "style-215m",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "215M",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49470972854538",
      "swatch_filename": "215M_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/215M_White.jpg?v=1774347211",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/215M_White.jpg?v=1774347211",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/215M/ProductCarouselMain/215M%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "215m_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686147338",
      "product_title": "Russell Athletic Classic Long Sleeve T-Shirt",
      "product_handle": "180l",
      "product_url": "/products/180l",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-180l",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "180L",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490372624650",
      "swatch_filename": "180l_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180l_White.jpg?v=1774522757",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180l_White.jpg?v=1774522757",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180L/ProductCarouselMain/180L%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180l_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473273135370",
      "swatch_filename": "180M_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_White.jpg?v=1774363125",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_White.jpg?v=1774363125",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546724618",
      "product_title": "Russell Athletic Heavyweight T-Shirt",
      "product_handle": "010m",
      "product_url": "/products/010m",
      "product_full_url": "https://oakdenemerch.com/products/010m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-010m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "010M",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468778381578",
      "swatch_filename": "010M_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/010M_White.jpg?v=1774311231",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/010M_White.jpg?v=1774311231",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/010M/ProductCarouselMain/010M%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "010m_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548199178",
      "product_title": "Russell Athletic Kids Classic Ringspun T-Shirt",
      "product_handle": "180b",
      "product_url": "/products/180b",
      "product_full_url": "https://oakdenemerch.com/products/180b",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "PCBest_Seller",
        "performance-activewear",
        "sports",
        "style-180b",
        "t-shirts"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.",
      "style_code": "180B",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474443673866",
      "swatch_filename": "180B_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_White.jpg?v=1774371757",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_White.jpg?v=1774371757",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180B/ProductCarouselMain/180B%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180b_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548231946",
      "product_title": "Russell Athletic Ladies Authentic Classic Ringspun T-Shirt",
      "product_handle": "180f",
      "product_url": "/products/180f",
      "product_full_url": "https://oakdenemerch.com/products/180f",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-180f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180F",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472623542538",
      "swatch_filename": "180F_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180F_White.jpg?v=1774358325",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180F_White.jpg?v=1774358325",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180F/ProductCarouselMain/180F%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180f_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687818506",
      "product_title": "SF Clothing Feel Good Stretch Long Sleeve T-Shirt",
      "product_handle": "sf124",
      "product_url": "/products/sf124",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-sf124",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane.",
      "style_code": "SF124",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490482200842",
      "swatch_filename": "sf124_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf124_White.jpg?v=1774522981",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf124_White.jpg?v=1774522981",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF124/ProductCarouselMain/SF124%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf124_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553016074",
      "product_title": "SF Clothing Feel Good Stretch T-Shirt",
      "product_handle": "sf121",
      "product_url": "/products/sf121",
      "product_full_url": "https://oakdenemerch.com/products/sf121",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-sf121",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane single jersey.*",
      "style_code": "SF121",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472270696714",
      "swatch_filename": "SF121_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF121_White.jpg?v=1774354029",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF121_White.jpg?v=1774354029",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF121/ProductCarouselMain/SF121%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf121_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553048842",
      "product_title": "SF Clothing Feel Good Stretch V Neck T-Shirt",
      "product_handle": "sf122",
      "product_url": "/products/sf122",
      "product_full_url": "https://oakdenemerch.com/products/sf122",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-sf122",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane.*",
      "style_code": "SF122",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471724552458",
      "swatch_filename": "SF122_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF122_White.jpg?v=1774351145",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF122_White.jpg?v=1774351145",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF122/ProductCarouselMain/SF122%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf122_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562527498",
      "product_title": "SF Clothing High Neck Vest",
      "product_handle": "sf232",
      "product_url": "/products/sf232",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-sf232",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% polyester.*",
      "style_code": "SF232",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513933373706",
      "swatch_filename": "sf232_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf232_White.jpg?v=1774619085",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf232_White.jpg?v=1774619085",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF232/ProductCarouselMain/SF232%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf232_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553573130",
      "product_title": "SF Clothing Kids Feel Good Stretch T-Shirt",
      "product_handle": "sm121",
      "product_url": "/products/sm121",
      "product_full_url": "https://oakdenemerch.com/products/sm121",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "11-12",
        "11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-sm121",
        "t-shirts"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane single jersey.",
      "style_code": "SM121",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474080211210",
      "swatch_filename": "SM121_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SM121_White.jpg?v=1774368753",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SM121_White.jpg?v=1774368753",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SM121/ProductCarouselMain/SM121%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sm121_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562920714",
      "product_title": "SF Clothing Kids Feel Good Stretch Vest",
      "product_handle": "sm123",
      "product_url": "/products/sm123",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "11-12",
        "11-12-5-6-7-8-9-10",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "sleeveless",
        "style-sm123",
        "t-shirts"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane.",
      "style_code": "SM123",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513936683274",
      "swatch_filename": "sm123_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sm123_White.jpg?v=1774619139",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sm123_White.jpg?v=1774619139",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SM123/ProductCarouselMain/SM123%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sm123_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553278218",
      "product_title": "SF Clothing Ladies Bandeau Top",
      "product_handle": "sk115",
      "product_url": "/products/sk115",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-sk115",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "93% cotton/7% elastane.",
      "style_code": "SK115",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491305562378",
      "swatch_filename": "sk115_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk115_White.jpg?v=1774526466",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk115_White.jpg?v=1774526466",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK115/ProductCarouselMain/SK115%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk115_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553474826",
      "product_title": "SF Clothing Ladies Cropped Boxy T-Shirt",
      "product_handle": "sk237",
      "product_url": "/products/sk237",
      "product_full_url": "https://oakdenemerch.com/products/sk237",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-sk237",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XXS",
        "XXS-XS-S-M-L-XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% polyester.",
      "style_code": "SK237",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474083193098",
      "swatch_filename": "SK237_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SK237_White.jpg?v=1774368816",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SK237_White.jpg?v=1774368816",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK237/ProductCarouselMain/SK237%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk237_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553245450",
      "product_title": "SF Clothing Ladies Cropped Top",
      "product_handle": "sk106",
      "product_url": "/products/sk106",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-sk106",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "93% cotton/7% elastane.",
      "style_code": "SK106",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491307168010",
      "swatch_filename": "sk106_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk106_White.jpg?v=1774526472",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk106_White.jpg?v=1774526472",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK106/ProductCarouselMain/SK106%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk106_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687884042",
      "product_title": "SF Clothing Ladies Feel Good Long Sleeve Stretch T-Shirt",
      "product_handle": "sk124",
      "product_url": "/products/sk124",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-sk124",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane.",
      "style_code": "SK124",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490484265226",
      "swatch_filename": "sk124_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk124_White.jpg?v=1774522992",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk124_White.jpg?v=1774522992",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK124/ProductCarouselMain/SK124%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk124_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553343754",
      "product_title": "SF Clothing Ladies Feel Good Stretch V Neck T-Shirt",
      "product_handle": "sk122",
      "product_url": "/products/sk122",
      "product_full_url": "https://oakdenemerch.com/products/sk122",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-sk122",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane single jersey.*",
      "style_code": "SK122",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472236192010",
      "swatch_filename": "SK122_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SK122_White.jpg?v=1774353925",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SK122_White.jpg?v=1774353925",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK122/ProductCarouselMain/SK122%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk122_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562756874",
      "product_title": "SF Clothing Ladies High Neck Crop Vest",
      "product_handle": "sk170",
      "product_url": "/products/sk170",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-sk170",
        "t-shirts",
        "womens",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane.",
      "style_code": "SK170",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513934749962",
      "swatch_filename": "sk170_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk170_White.jpg?v=1774619113",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk170_White.jpg?v=1774619113",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK170/ProductCarouselMain/SK170%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk170_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562658570",
      "product_title": "SF Clothing Ladies One Shoulder Top",
      "product_handle": "sk116",
      "product_url": "/products/sk116",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-sk116",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "93% cotton/7% elastane.",
      "style_code": "SK116",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513934323978",
      "swatch_filename": "sk116_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk116_White.jpg?v=1774619099",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk116_White.jpg?v=1774619099",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK116/ProductCarouselMain/SK116%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk116_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562855178",
      "product_title": "SF Clothing Ladies Slounge Vest",
      "product_handle": "sk234",
      "product_url": "/products/sk234",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-sk234",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% polyester.",
      "style_code": "SK234",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513935896842",
      "swatch_filename": "sk234_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk234_White.jpg?v=1774619128",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk234_White.jpg?v=1774619128",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SF%20Clothing/SK234/ProductCarouselMain/SK234%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk234_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553212682",
      "product_title": "SF Clothing Longline Dipped Hem T-Shirt",
      "product_handle": "sf258",
      "product_url": "/products/sf258",
      "product_full_url": "https://oakdenemerch.com/products/sf258",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-sf258",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SF258",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471718785290",
      "swatch_filename": "SF258_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF258_White.jpg?v=1774351098",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF258_White.jpg?v=1774351098",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF258/ProductCarouselMain/SF258%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf258_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562593034",
      "product_title": "SF Clothing Muscle Vest",
      "product_handle": "sf236",
      "product_url": "/products/sf236",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "sleeveless",
        "style-sf236",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% polyester.*",
      "style_code": "SF236",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513933701386",
      "swatch_filename": "sf236_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf236_White.jpg?v=1774619092",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf236_White.jpg?v=1774619092",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF236/ProductCarouselMain/SF236%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf236_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553147146",
      "product_title": "SF Clothing Unisex Organic T-Shirt",
      "product_handle": "sf140",
      "product_url": "/products/sf140",
      "product_full_url": "https://oakdenemerch.com/products/sf140",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-sf140",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "SF140",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473613299978",
      "swatch_filename": "SF140_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF140_White.jpg?v=1774364427",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF140_White.jpg?v=1774364427",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF140/ProductCarouselMain/SF140%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf140_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547379978",
      "product_title": "SOL'S Boxy Oversized Organic T-Shirt",
      "product_handle": "03806",
      "product_url": "/products/03806",
      "product_full_url": "https://oakdenemerch.com/products/03806",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL",
        "style-03806",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "03806",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471864733962",
      "swatch_filename": "03806_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03806_White.jpg?v=1774352127",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03806_White.jpg?v=1774352127",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03806/ProductCarouselMain/03806%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03806_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474468872458",
      "swatch_filename": "03582_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_White.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_White.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547511050",
      "product_title": "SOL'S Crusader Recycled T-Shirt",
      "product_handle": "04233",
      "product_url": "/products/04233",
      "product_full_url": "https://oakdenemerch.com/products/04233",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04233",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% recycled cotton/50% cotton.*",
      "style_code": "04233",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473284866314",
      "swatch_filename": "04233_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_White.jpg?v=1774363191",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_White.jpg?v=1774363191",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04233/ProductCarouselMain/04233%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04233_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547904266",
      "product_title": "SOL'S Imperial Fit T-Shirt",
      "product_handle": "10580",
      "product_url": "/products/10580",
      "product_full_url": "https://oakdenemerch.com/products/10580",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-10580",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "10580",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471859163402",
      "swatch_filename": "10580_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10580_White.jpg?v=1774352022",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10580_White.jpg?v=1774352022",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/10580/ProductCarouselMain/10580%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "10580_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474449670410",
      "swatch_filename": "11500_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_White.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_White.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685623050",
      "product_title": "SOL'S Imperial Long Sleeve T-Shirt",
      "product_handle": "02074",
      "product_url": "/products/02074",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-02074",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "02074",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490366628106",
      "swatch_filename": "02074_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02074_White.jpg?v=1774522701",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02074_White.jpg?v=1774522701",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02074/ProductCarouselMain/02074%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02074_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546953994",
      "product_title": "SOL'S Imperial V Neck T-Shirt",
      "product_handle": "02940",
      "product_url": "/products/02940",
      "product_full_url": "https://oakdenemerch.com/products/02940",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-02940",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "02940",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468829040906",
      "swatch_filename": "02940_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02940_White.jpg?v=1774312050",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02940_White.jpg?v=1774312050",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02940/ProductCarouselMain/02940%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02940_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561773834",
      "product_title": "SOL'S Justin Tank Top",
      "product_handle": "11465",
      "product_url": "/products/11465",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11465",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11465",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513914499338",
      "swatch_filename": "11465_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11465_White.jpg?v=1774618890",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11465_White.jpg?v=1774618890",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11465/ProductCarouselMain/11465%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11465_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547412746",
      "product_title": "SOL'S Ladies Boxy Oversized Organic T-Shirt",
      "product_handle": "03807",
      "product_url": "/products/03807",
      "product_full_url": "https://oakdenemerch.com/products/03807",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03807",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "03807",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474463695114",
      "swatch_filename": "03807_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03807_White.jpg?v=1774372093",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03807_White.jpg?v=1774372093",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03807/ProductCarouselMain/03807%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03807_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468836086026",
      "swatch_filename": "03581_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_White.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_White.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468934095114",
      "swatch_filename": "11502_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_White.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_White.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685688586",
      "product_title": "SOL'S Ladies Imperial Long Sleeve T-Shirt",
      "product_handle": "02075",
      "product_url": "/products/02075",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-02075",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "02075",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490367217930",
      "swatch_filename": "02075_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02075_White.jpg?v=1774522710",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02075_White.jpg?v=1774522710",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02075/ProductCarouselMain/02075%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02075_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547052298",
      "product_title": "SOL'S Ladies Imperial V Neck T-Shirt",
      "product_handle": "02941",
      "product_url": "/products/02941",
      "product_full_url": "https://oakdenemerch.com/products/02941",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-02941",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "02941",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471878299914",
      "swatch_filename": "02941_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02941_White.jpg?v=1774352301",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02941_White.jpg?v=1774352301",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02941/ProductCarouselMain/02941%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02941_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561577226",
      "product_title": "SOL'S Ladies Justin Vest",
      "product_handle": "01826",
      "product_url": "/products/01826",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-01826",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01826",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513909485834",
      "swatch_filename": "01826_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01826_White.jpg?v=1774618840",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01826_White.jpg?v=1774618840",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01826/ProductCarouselMain/01826%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01826_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547740426",
      "product_title": "SOL'S Ladies Lilia Low Crop T-Shirt",
      "product_handle": "04811",
      "product_url": "/products/04811",
      "product_full_url": "https://oakdenemerch.com/products/04811",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL",
        "style-04811",
        "t-shirts",
        "womens",
        "XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "04811",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474453307658",
      "swatch_filename": "04811_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04811_White.jpg?v=1774371893",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04811_White.jpg?v=1774371893",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04811/ProductCarouselMain/04811%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04811_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547117834",
      "product_title": "SOL'S Ladies Millenium Stretch T-Shirt",
      "product_handle": "02946",
      "product_url": "/products/02946",
      "product_full_url": "https://oakdenemerch.com/products/02946",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-02946",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "95% semi-combed ringspun cotton/5% elastane.*",
      "style_code": "02946",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471871549706",
      "swatch_filename": "02946_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02946_White.jpg?v=1774352219",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02946_White.jpg?v=1774352219",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02946/ProductCarouselMain/02946%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02946_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685917962",
      "product_title": "SOL'S Ladies Monarch Long Sleeve T-Shirt",
      "product_handle": "04443",
      "product_url": "/products/04443",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-04443",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.",
      "style_code": "04443",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490370035978",
      "swatch_filename": "04443_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04443_White.jpg?v=1774522729",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04443_White.jpg?v=1774522729",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04443/ProductCarouselMain/04443%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04443_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548035338",
      "product_title": "SOL'S Ladies Moon V Neck T-Shirt",
      "product_handle": "11388",
      "product_url": "/products/11388",
      "product_full_url": "https://oakdenemerch.com/products/11388",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11388",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11388",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468932227338",
      "swatch_filename": "11388_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_White.jpg?v=1774312856",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_White.jpg?v=1774312856",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11388/ProductCarouselMain/11388%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11388_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468833661194",
      "swatch_filename": "03579_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_White.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_White.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468822782218",
      "swatch_filename": "01825_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_White.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_White.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547609354",
      "product_title": "SOL'S Ladies Regent V Neck T-Shirt",
      "product_handle": "04766",
      "product_url": "/products/04766",
      "product_full_url": "https://oakdenemerch.com/products/04766",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "S",
        "style-04766",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "04766",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472664568074",
      "swatch_filename": "04766_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04766_White.jpg?v=1774358606",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04766_White.jpg?v=1774358606",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04766/ProductCarouselMain/04766%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04766_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547838730",
      "product_title": "SOL'S Ladies Sara T-Shirt",
      "product_handle": "04814",
      "product_url": "/products/04814",
      "product_full_url": "https://oakdenemerch.com/products/04814",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-04814",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "04814",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472643039498",
      "swatch_filename": "04814_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04814_White.jpg?v=1774358443",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04814_White.jpg?v=1774358443",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04814/ProductCarouselMain/04814%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04814_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546757386",
      "product_title": "SOL'S Ladies Sporty Performance T-Shirt",
      "product_handle": "01159",
      "product_url": "/products/01159",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-01159",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "01159",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491517538570",
      "swatch_filename": "01159_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01159_White.jpg?v=1774526874",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01159_White.jpg?v=1774526874",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01159/ProductCarouselMain/01159%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01159_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561642762",
      "product_title": "SOL'S Ladies Sporty Performance Tank Top",
      "product_handle": "02117",
      "product_url": "/products/02117",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-02117",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02117",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513911124234",
      "swatch_filename": "02117_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02117_White.jpg?v=1774618862",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02117_White.jpg?v=1774618862",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02117/ProductCarouselMain/02117%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02117_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547707658",
      "product_title": "SOL'S Ladies Vortex Ripstop Performance T-Shirt",
      "product_handle": "04788",
      "product_url": "/products/04788",
      "product_full_url": "https://oakdenemerch.com/products/04788",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04788",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04788",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472652017930",
      "swatch_filename": "04788_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_White.jpg?v=1774358494",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_White.jpg?v=1774358494",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04788/ProductCarouselMain/04788%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04788_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686049034",
      "product_title": "SOL'S Monarch Long Sleeve T-Shirt",
      "product_handle": "11420",
      "product_url": "/products/11420",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11420",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "11420",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490370691338",
      "swatch_filename": "11420_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_White.jpg?v=1774522741",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_White.jpg?v=1774522741",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11420/ProductCarouselMain/11420%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11420_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561741066",
      "product_title": "SOL'S Pablo Ribbed Tank Top",
      "product_handle": "04452",
      "product_url": "/products/04452",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL",
        "style-04452",
        "t-shirts",
        "unisex",
        "XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "04452",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513914138890",
      "swatch_filename": "04452_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04452_White.jpg?v=1774618884",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04452_White.jpg?v=1774618884",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04452/ProductCarouselMain/04452%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04452_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03565",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473305575690",
      "swatch_filename": "03565_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_White.jpg?v=1774363312",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_White.jpg?v=1774363312",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547871498",
      "product_title": "SOL'S Regent Fit T-Shirt",
      "product_handle": "10553",
      "product_url": "/products/10553",
      "product_full_url": "https://oakdenemerch.com/products/10553",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-10553",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "10553",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472628949258",
      "swatch_filename": "10553_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_White.jpg?v=1774358391",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_White.jpg?v=1774358391",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/10553/ProductCarouselMain/10553%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "10553_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473718059274",
      "swatch_filename": "11380_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_White.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_White.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685590282",
      "product_title": "SOL'S Sporty Long Sleeve Performance T-Shirt",
      "product_handle": "02071",
      "product_url": "/products/02071",
      "product_full_url": "https://oakdenemerch.com/products/02071",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL",
        "sports",
        "style-02071",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02071",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490364662026",
      "swatch_filename": "02071_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02071_White.jpg?v=1774522691",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02071_White.jpg?v=1774522691",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02071/ProductCarouselMain/02071%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02071_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548166410",
      "product_title": "SOL'S Sporty Performance T-Shirt",
      "product_handle": "11939",
      "product_url": "/products/11939",
      "product_full_url": "https://oakdenemerch.com/products/11939",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-11939",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "11939",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473692533002",
      "swatch_filename": "11939_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_White.jpg?v=1774364865",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_White.jpg?v=1774364865",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11939/ProductCarouselMain/11939%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11939_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561609994",
      "product_title": "SOL'S Sporty Performance Tank Top",
      "product_handle": "02073",
      "product_url": "/products/02073",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL",
        "sports",
        "style-02073",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02073",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513909780746",
      "swatch_filename": "02073_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02073_White.jpg?v=1774618846",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02073_White.jpg?v=1774618846",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02073/ProductCarouselMain/02073%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02073_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547805962",
      "product_title": "SOL'S Unisex Cliff T-Shirt",
      "product_handle": "04813",
      "product_url": "/products/04813",
      "product_full_url": "https://oakdenemerch.com/products/04813",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "S",
        "style-04813",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "04813",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472952008970",
      "swatch_filename": "04813_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04813_White.jpg?v=1774360432",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04813_White.jpg?v=1774360432",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04813/ProductCarouselMain/04813%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04813_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561675530",
      "product_title": "SOL'S Unisex Crusader Tank Top",
      "product_handle": "03980",
      "product_url": "/products/03980",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03980",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03980",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513913024778",
      "swatch_filename": "03980_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03980_White.jpg?v=1774618874",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03980_White.jpg?v=1774618874",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03980/ProductCarouselMain/03980%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03980_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547183370",
      "product_title": "SOL'S Unisex Epic Organic T-Shirt",
      "product_handle": "03564",
      "product_url": "/products/03564",
      "product_full_url": "https://oakdenemerch.com/products/03564",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03564",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03564",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473320059146",
      "swatch_filename": "03564_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03564_White.jpg?v=1774363395",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03564_White.jpg?v=1774363395",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03564/ProductCarouselMain/03564%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03564_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547543818",
      "product_title": "SOL'S Unisex Explorer Recycled T-Shirt",
      "product_handle": "04461",
      "product_url": "/products/04461",
      "product_full_url": "https://oakdenemerch.com/products/04461",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04461",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "60% recycled cotton/40% recycled polyester.",
      "style_code": "04461",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472969048330",
      "swatch_filename": "04461_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04461_White.jpg?v=1774360548",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04461_White.jpg?v=1774360548",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04461/ProductCarouselMain/04461%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04461_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473745060106",
      "swatch_filename": "03981_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_White.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_White.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547773194",
      "product_title": "SOL'S Unisex Nino V Neck T-Shirt",
      "product_handle": "04812",
      "product_url": "/products/04812",
      "product_full_url": "https://oakdenemerch.com/products/04812",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-04812",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04812",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471862112522",
      "swatch_filename": "04812_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04812_White.jpg?v=1774352075",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04812_White.jpg?v=1774352075",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04812/ProductCarouselMain/04812%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04812_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685786890",
      "product_title": "SOL'S Unisex Pioneer Long Sleeve T-Shirt",
      "product_handle": "03982",
      "product_url": "/products/03982",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03982",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03982",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490368233738",
      "swatch_filename": "03982_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03982_White.jpg?v=1774522718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03982_White.jpg?v=1774522718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03982/ProductCarouselMain/03982%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03982_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547150602",
      "product_title": "SOL'S Unisex Sprint T-Shirt",
      "product_handle": "02995",
      "product_url": "/products/02995",
      "product_full_url": "https://oakdenemerch.com/products/02995",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-02995",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "02995",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473768096010",
      "swatch_filename": "02995_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_White.jpg?v=1774365179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_White.jpg?v=1774365179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02995/ProductCarouselMain/02995%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02995_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548133642",
      "product_title": "SOL'S Unisex Sublima T-Shirt",
      "product_handle": "11775",
      "product_url": "/products/11775",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11775",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "11775",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491506200842",
      "swatch_filename": "11775_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11775_White.jpg?v=1774526837",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11775_White.jpg?v=1774526837",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11775/ProductCarouselMain/11775%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11775_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547576586",
      "product_title": "SOL'S Unisex Titan T-Shirt",
      "product_handle": "04728",
      "product_url": "/products/04728",
      "product_full_url": "https://oakdenemerch.com/products/04728",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "knitwear",
        "L",
        "M",
        "S",
        "style-04728",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.",
      "style_code": "04728",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474456781066",
      "swatch_filename": "04728_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_White.jpg?v=1774371966",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_White.jpg?v=1774371966",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04728/ProductCarouselMain/04728%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04728_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547478282",
      "product_title": "SOL'S Unisex Tuner T-Shirt",
      "product_handle": "04203",
      "product_url": "/products/04203",
      "product_full_url": "https://oakdenemerch.com/products/04203",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-04203",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.*",
      "style_code": "04203",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474458976522",
      "swatch_filename": "04203_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_White.jpg?v=1774372011",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_White.jpg?v=1774372011",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04203/ProductCarouselMain/04203%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04203_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547937034",
      "product_title": "SOL'S Victory V Neck T-Shirt",
      "product_handle": "11150",
      "product_url": "/products/11150",
      "product_full_url": "https://oakdenemerch.com/products/11150",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11150",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11150",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468838150410",
      "swatch_filename": "11150_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11150_White.jpg?v=1774312556",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11150_White.jpg?v=1774312556",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11150/ProductCarouselMain/11150%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11150_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547674890",
      "product_title": "SOL'S Vortex Ripstop Performance T-Shirt",
      "product_handle": "04787",
      "product_url": "/products/04787",
      "product_full_url": "https://oakdenemerch.com/products/04787",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04787",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04787",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472658080010",
      "swatch_filename": "04787_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_White.jpg?v=1774358538",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_White.jpg?v=1774358538",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04787/ProductCarouselMain/04787%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04787_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473588396298",
      "swatch_filename": "SR287_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_White.jpg?v=1774364345",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_White.jpg?v=1774364345",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554097418",
      "product_title": "Spiro Kids Impact Performance Aircool T-Shirt",
      "product_handle": "sr287b",
      "product_url": "/products/sr287b",
      "product_full_url": "https://oakdenemerch.com/products/sr287b",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "children",
        "kids",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287b",
        "t-shirts",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287B",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474059862282",
      "swatch_filename": "SR287B_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_White.jpg?v=1774368252",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_White.jpg?v=1774368252",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287B/ProductCarouselMain/SR287B%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287b_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553671434",
      "product_title": "Spiro Ladies Quick Dry Performance T-Shirt",
      "product_handle": "sr253f",
      "product_url": "/products/sr253f",
      "product_full_url": "https://oakdenemerch.com/products/sr253f",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr253f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester interlock.",
      "style_code": "SR253F",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474072903946",
      "swatch_filename": "SR253F_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR253F_White.jpg?v=1774368616",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR253F_White.jpg?v=1774368616",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR253F/ProductCarouselMain/SR253F%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr253f_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687949578",
      "product_title": "Spiro Performance Long Sleeve T-Shirt",
      "product_handle": "sr254m",
      "product_url": "/products/sr254m",
      "product_full_url": "None",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-sr254m",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester interlock.",
      "style_code": "SR254M",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490484953354",
      "swatch_filename": "sr254m_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr254m_White.jpg?v=1774523004",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr254m_White.jpg?v=1774523004",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR254M/ProductCarouselMain/SR254M%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr254m_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553704202",
      "product_title": "Spiro Quick Dry Performance T-Shirt",
      "product_handle": "sr253m",
      "product_url": "/products/sr253m",
      "product_full_url": "https://oakdenemerch.com/products/sr253m",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-sr253m",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester interlock.",
      "style_code": "SR253M",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471706857738",
      "swatch_filename": "SR253M_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR253M_White.jpg?v=1774351025",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR253M_White.jpg?v=1774351025",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR253M/ProductCarouselMain/SR253M%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr253m_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556981002",
      "product_title": "Tee Jays CoolDry™ T-Shirt",
      "product_handle": "t7020",
      "product_url": "/products/t7020",
      "product_full_url": "https://oakdenemerch.com/products/t7020",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t7020",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7020",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49469012050186",
      "swatch_filename": "T7020_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_White.jpg?v=1774315920",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_White.jpg?v=1774315920",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7020/ProductCarouselMain/T7020%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7020_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557374218",
      "product_title": "Tee Jays Fashion Sof T-Shirt",
      "product_handle": "t8005",
      "product_url": "/products/t8005",
      "product_full_url": "https://oakdenemerch.com/products/t8005",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t8005",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T8005",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49470730862858",
      "swatch_filename": "T8005_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8005_White.jpg?v=1774345393",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8005_White.jpg?v=1774345393",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8005/ProductCarouselMain/T8005%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8005_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471257248010",
      "swatch_filename": "T520_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_White.jpg?v=1774348348",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_White.jpg?v=1774348348",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557079306",
      "product_title": "Tee Jays Ladies CoolDry™ T-Shirt",
      "product_handle": "t7021",
      "product_url": "/products/t7021",
      "product_full_url": "https://oakdenemerch.com/products/t7021",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-t7021",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7021",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471676285194",
      "swatch_filename": "T7021_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_White.jpg?v=1774350799",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_White.jpg?v=1774350799",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7021/ProductCarouselMain/T7021%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7021_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556587786",
      "product_title": "Tee Jays Ladies Interlock T-Shirt",
      "product_handle": "t580",
      "product_url": "/products/t580",
      "product_full_url": "https://oakdenemerch.com/products/t580",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t580",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T580",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49469002055946",
      "swatch_filename": "T580_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_White.jpg?v=1774315823",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_White.jpg?v=1774315823",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T580/ProductCarouselMain/T580%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t580_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688703242",
      "product_title": "Tee Jays Ladies Long Sleeve Interlock T-Shirt",
      "product_handle": "t590",
      "product_url": "/products/t590",
      "product_full_url": "https://oakdenemerch.com/products/t590",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t590",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T590",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490491900170",
      "swatch_filename": "t590_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t590_White.jpg?v=1774523108",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t590_White.jpg?v=1774523108",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T590/ProductCarouselMain/T590%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t590_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555244298",
      "product_title": "Tee Jays Ladies Pima Cotton T-Shirt",
      "product_handle": "t1451",
      "product_url": "/products/t1451",
      "product_full_url": "https://oakdenemerch.com/products/t1451",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t1451",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed pima cotton.",
      "style_code": "T1451",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468966338826",
      "swatch_filename": "T1451_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1451_White.jpg?v=1774315340",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1451_White.jpg?v=1774315340",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1451/ProductCarouselMain/T1451%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1451_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555768586",
      "product_title": "Tee Jays Ladies Roll-Up T-Shirt",
      "product_handle": "t5063",
      "product_url": "/products/t5063",
      "product_full_url": "https://oakdenemerch.com/products/t5063",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "hospitality",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-t5063",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T5063",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471685984522",
      "swatch_filename": "T5063_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5063_White.jpg?v=1774350892",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5063_White.jpg?v=1774350892",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5063/ProductCarouselMain/T5063%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5063_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557439754",
      "product_title": "Tee Jays Ladies Sof T-Shirt",
      "product_handle": "t8050",
      "product_url": "/products/t8050",
      "product_full_url": "https://oakdenemerch.com/products/t8050",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t8050",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T8050",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49470794334474",
      "swatch_filename": "T8050_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8050_White.jpg?v=1774345776",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8050_White.jpg?v=1774345776",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8050/ProductCarouselMain/T8050%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8050_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555571978",
      "product_title": "Tee Jays Ladies Stretch 3/4 Sleeve T-Shirt",
      "product_handle": "t460",
      "product_url": "/products/t460",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t460",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "90% ringspun combed cotton/10% elastane.",
      "style_code": "T460",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491211682058",
      "swatch_filename": "t460_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t460_White.jpg?v=1774526232",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t460_White.jpg?v=1774526232",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T460/ProductCarouselMain/T460%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t460_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555440906",
      "product_title": "Tee Jays Ladies Stretch T-Shirt",
      "product_handle": "t450",
      "product_url": "/products/t450",
      "product_full_url": "https://oakdenemerch.com/products/t450",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t450",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "90% ringspun combed cotton/10% elastane.",
      "style_code": "T450",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468979937546",
      "swatch_filename": "T450_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T450_White.jpg?v=1774315491",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T450_White.jpg?v=1774315491",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T450/ProductCarouselMain/T450%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t450_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688670474",
      "product_title": "Tee Jays Long Sleeve Interlock T-Shirt",
      "product_handle": "t530",
      "product_url": "/products/t530",
      "product_full_url": "https://oakdenemerch.com/products/t530",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t530",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T530",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490491539722",
      "swatch_filename": "t530_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t530_White.jpg?v=1774523102",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t530_White.jpg?v=1774523102",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T530/ProductCarouselMain/T530%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t530_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688801546",
      "product_title": "Tee Jays Long Sleeve Sof T-Shirt",
      "product_handle": "t8007",
      "product_url": "/products/t8007",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t8007",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T8007",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490493374730",
      "swatch_filename": "t8007_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t8007_White.jpg?v=1774523124",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t8007_White.jpg?v=1774523124",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8007/ProductCarouselMain/T8007%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8007_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555637514",
      "product_title": "Tee Jays Luxury Cotton T-Shirt",
      "product_handle": "t5000",
      "product_url": "/products/t5000",
      "product_full_url": "https://oakdenemerch.com/products/t5000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T5000",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468986654986",
      "swatch_filename": "T5000_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5000_White.jpg?v=1774315592",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5000_White.jpg?v=1774315592",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5000/ProductCarouselMain/T5000%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5000_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555178762",
      "product_title": "Tee Jays Pima Cotton T-Shirt",
      "product_handle": "t1450",
      "product_url": "/products/t1450",
      "product_full_url": "https://oakdenemerch.com/products/t1450",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t1450",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed pima cotton.",
      "style_code": "T1450",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468963324170",
      "swatch_filename": "T1450_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1450_White.jpg?v=1774315272",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1450_White.jpg?v=1774315272",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1450/ProductCarouselMain/T1450%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1450_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555735818",
      "product_title": "Tee Jays Roll-Up T-Shirt",
      "product_handle": "t5062",
      "product_url": "/products/t5062",
      "product_full_url": "https://oakdenemerch.com/products/t5062",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "hospitality",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5062",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T5062",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468994388234",
      "swatch_filename": "T5062_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5062_White.jpg?v=1774315684",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5062_White.jpg?v=1774315684",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5062/ProductCarouselMain/T5062%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5062_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557341450",
      "product_title": "Tee Jays Sof T-Shirt",
      "product_handle": "t8000",
      "product_url": "/products/t8000",
      "product_full_url": "https://oakdenemerch.com/products/t8000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t8000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T8000",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471238799626",
      "swatch_filename": "T8000_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_White.jpg?v=1774348259",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_White.jpg?v=1774348259",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8000/ProductCarouselMain/T8000%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8000_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554785546",
      "product_title": "Tee Jays Unlabeled Loose Fit T-Shirt",
      "product_handle": "t1160",
      "product_url": "/products/t1160",
      "product_full_url": "https://oakdenemerch.com/products/t1160",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t1160",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T1160",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468958736650",
      "swatch_filename": "T1160_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1160_White.jpg?v=1774315207",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1160_White.jpg?v=1774315207",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1160/ProductCarouselMain/T1160%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1160_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474051899658",
      "swatch_filename": "T1150_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_White.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_White.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554720010",
      "product_title": "Tee Jays Unlabelled T-Shirt",
      "product_handle": "t1140",
      "product_url": "/products/t1140",
      "product_full_url": "https://oakdenemerch.com/products/t1140",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1140",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T1140",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474054717706",
      "swatch_filename": "T1140_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1140_White.jpg?v=1774368141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1140_White.jpg?v=1774368141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1140/ProductCarouselMain/T1140%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1140_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557406986",
      "product_title": "Tee Jays V Neck Sof T-Shirt",
      "product_handle": "t8006",
      "product_url": "/products/t8006",
      "product_full_url": "https://oakdenemerch.com/products/t8006",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t8006",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T8006",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49470768578826",
      "swatch_filename": "T8006_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8006_White.jpg?v=1774345594",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8006_White.jpg?v=1774345594",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8006/ProductCarouselMain/T8006%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8006_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458563084554",
      "product_title": "Tombo Muscle Vest",
      "product_handle": "tl504",
      "product_url": "/products/tl504",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "sleeveless",
        "style-tl504",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "90% polyester/10% elastane.",
      "style_code": "TL504",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513938387210",
      "swatch_filename": "tl504_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl504_White.jpg?v=1774619165",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl504_White.jpg?v=1774619165",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Tombo/TL504/ProductCarouselMain/TL504%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl504_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558488330",
      "product_title": "WK Designed to Work Anti-Bacterial Short Sleeve T-Shirt",
      "product_handle": "wk306",
      "product_url": "/products/wk306",
      "product_full_url": "https://oakdenemerch.com/products/wk306",
      "vendor": "WK Designed To Work",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-wk306",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% combed cotton.",
      "style_code": "WK306",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49470913577226",
      "swatch_filename": "WK306_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/WK306_White.jpg?v=1774346721",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/WK306_White.jpg?v=1774346721",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/WK%20Designed%20to%20Work/Product%20Images/WK306/ProductCarouselMain/WK306%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "wk306_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548657930",
      "product_title": "Bella Ladies Micro Rib Raglan Baby T-Shirt",
      "product_handle": "bl1201",
      "product_url": "/products/bl1201",
      "product_full_url": "https://oakdenemerch.com/products/bl1201",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "headwear",
        "L",
        "M",
        "S",
        "style-bl1201",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1201",
      "colour_name": "White/Baby Blue",
      "colour_group": "White > White",
      "rgb": "#ffffff;#a4d9e8",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472614760714",
      "swatch_filename": "BL1201_WhiteBaby_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL1201_WhiteBaby_Blue.jpg?v=1774358245",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL1201_WhiteBaby_Blue.jpg?v=1774358245",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1201/ProductCarouselMain/BL1201%20W%252fBBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1201_WhiteBaby_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554261258",
      "product_title": "Fruit of the Loom Contrast Baseball T-Shirt",
      "product_handle": "ss31",
      "product_url": "/products/ss31",
      "product_full_url": "https://oakdenemerch.com/products/ss31",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss31",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS31",
      "colour_name": "White/Deep Navy",
      "colour_group": "White > White",
      "rgb": "#ffffff;#000f33",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468950872330",
      "swatch_filename": "SS31_WhiteDeep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS31_WhiteDeep_Navy.jpg?v=1774314925",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS31_WhiteDeep_Navy.jpg?v=1774314925",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS31/ProductCarouselMain/SS31%20W%252fDNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss31_WhiteDeep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688015114",
      "product_title": "Fruit of the Loom Contrast Long Sleeve Baseball T-Shirt",
      "product_handle": "ss32",
      "product_url": "/products/ss32",
      "product_full_url": "https://oakdenemerch.com/products/ss32",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss32",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS32",
      "colour_name": "White/Deep Navy",
      "colour_group": "White > White",
      "rgb": "#ffffff;#000f33",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490486722826",
      "swatch_filename": "ss32_WhiteDeep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss32_WhiteDeep_Navy.jpg?v=1774523023",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss32_WhiteDeep_Navy.jpg?v=1774523023",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS32/ProductCarouselMain/SS32%20W%252fDNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss32_WhiteDeep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554818314",
      "product_title": "Tee Jays Unlabeled Baseball T-Shirt",
      "product_handle": "t1170",
      "product_url": "/products/t1170",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-t1170",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T1170",
      "colour_name": "White/Ink",
      "colour_group": "White > White",
      "rgb": "#ffffff;#005c9e",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491278692618",
      "swatch_filename": "t1170_WhiteInk.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t1170_WhiteInk.jpg?v=1774526392",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t1170_WhiteInk.jpg?v=1774526392",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1170/ProductCarouselMain/T1170%20WH_IK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1170_WhiteInk.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548625162",
      "product_title": "Bella Ladies Micro Rib 3/4 Raglan Baby T-Shirt",
      "product_handle": "bl1200",
      "product_url": "/products/bl1200",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-bl1200",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1200",
      "colour_name": "White/Kelly Green",
      "colour_group": "White > White",
      "rgb": "#ffffff;#24ad61",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491494273290",
      "swatch_filename": "bl1200_WhiteKelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1200_WhiteKelly_Green.jpg?v=1774526801",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1200_WhiteKelly_Green.jpg?v=1774526801",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1200/ProductCarouselMain/BL1200%20WH%252fKL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1200_WhiteKelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548657930",
      "product_title": "Bella Ladies Micro Rib Raglan Baby T-Shirt",
      "product_handle": "bl1201",
      "product_url": "/products/bl1201",
      "product_full_url": "https://oakdenemerch.com/products/bl1201",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "headwear",
        "L",
        "M",
        "S",
        "style-bl1201",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1201",
      "colour_name": "White/Kelly Green",
      "colour_group": "White > White",
      "rgb": "#ffffff;#24ad61",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472614727946",
      "swatch_filename": "BL1201_WhiteKelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL1201_WhiteKelly_Green.jpg?v=1774358245",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL1201_WhiteKelly_Green.jpg?v=1774358245",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1201/ProductCarouselMain/BL1201%20WH%252fKL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1201_WhiteKelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548952842",
      "product_title": "Canvas Unisex 3/4 Sleeve Baseball T-Shirt",
      "product_handle": "cv3200",
      "product_url": "/products/cv3200",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv3200",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "CV3200",
      "colour_name": "White/Kelly Green",
      "colour_group": "White > White",
      "rgb": "#ffffff;#24ad61",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491486671114",
      "swatch_filename": "cv3200_WhiteKelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3200_WhiteKelly_Green.jpg?v=1774526777",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3200_WhiteKelly_Green.jpg?v=1774526777",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3200/ProductCarouselMain/CV3200%20WH%252fKG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3200_WhiteKelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548625162",
      "product_title": "Bella Ladies Micro Rib 3/4 Raglan Baby T-Shirt",
      "product_handle": "bl1200",
      "product_url": "/products/bl1200",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-bl1200",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1200",
      "colour_name": "White/Navy",
      "colour_group": "White > White",
      "rgb": "#ffffff;#1c2449",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491494797578",
      "swatch_filename": "bl1200_WhiteNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1200_WhiteNavy.jpg?v=1774526803",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1200_WhiteNavy.jpg?v=1774526803",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1200/ProductCarouselMain/BL1200%20WH%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1200_WhiteNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548657930",
      "product_title": "Bella Ladies Micro Rib Raglan Baby T-Shirt",
      "product_handle": "bl1201",
      "product_url": "/products/bl1201",
      "product_full_url": "https://oakdenemerch.com/products/bl1201",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "headwear",
        "L",
        "M",
        "S",
        "style-bl1201",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1201",
      "colour_name": "White/Navy",
      "colour_group": "White > White",
      "rgb": "#ffffff;#1c2449",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472614695178",
      "swatch_filename": "BL1201_WhiteNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL1201_WhiteNavy.jpg?v=1774358245",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL1201_WhiteNavy.jpg?v=1774358245",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1201/ProductCarouselMain/BL1201%20WH%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1201_WhiteNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548952842",
      "product_title": "Canvas Unisex 3/4 Sleeve Baseball T-Shirt",
      "product_handle": "cv3200",
      "product_url": "/products/cv3200",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv3200",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "CV3200",
      "colour_name": "White/Navy",
      "colour_group": "White > White",
      "rgb": "#ffffff;#1c2449",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491487588618",
      "swatch_filename": "cv3200_WhiteNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3200_WhiteNavy.jpg?v=1774526779",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3200_WhiteNavy.jpg?v=1774526779",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3200/ProductCarouselMain/CV3200%20WH%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3200_WhiteNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549280522",
      "product_title": "Front Row Unisex Breton Striped T-Shirt",
      "product_handle": "fr135",
      "product_url": "/products/fr135",
      "product_full_url": "https://oakdenemerch.com/products/fr135",
      "vendor": "Front Row",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-fr135",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton single jersey.",
      "style_code": "FR135",
      "colour_name": "White/Navy",
      "colour_group": "White > White",
      "rgb": "#ffffff;#000a1a",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472601522442",
      "swatch_filename": "FR135_WhiteNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/FR135_WhiteNavy.jpg?v=1774358004",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/FR135_WhiteNavy.jpg?v=1774358004",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Front%20Row/Product%20Images/FR135/ProductCarouselMain/FR135%20WH%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "fr135_WhiteNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686933770",
      "product_title": "Front Row Unisex Long Sleeve Breton Striped T-Shirt",
      "product_handle": "fr134",
      "product_url": "/products/fr134",
      "product_full_url": "None",
      "vendor": "Front Row",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-fr134",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton single jersey.",
      "style_code": "FR134",
      "colour_name": "White/Navy",
      "colour_group": "White > White",
      "rgb": "#ffffff;#000a1a",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490439373066",
      "swatch_filename": "fr134_WhiteNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/fr134_WhiteNavy.jpg?v=1774522823",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/fr134_WhiteNavy.jpg?v=1774522823",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Front%20Row/Product%20Images/FR134/ProductCarouselMain/FR134%20WH%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "fr134_WhiteNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554294026",
      "product_title": "Fruit of the Loom Contrast Ringer T-Shirt",
      "product_handle": "ss34",
      "product_url": "/products/ss34",
      "product_full_url": "https://oakdenemerch.com/products/ss34",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss34",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS34",
      "colour_name": "White/Navy",
      "colour_group": "White > White",
      "rgb": "#ffffff;#002466",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468953100554",
      "swatch_filename": "SS34_WhiteNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS34_WhiteNavy.jpg?v=1774315005",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS34_WhiteNavy.jpg?v=1774315005",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS34/ProductCarouselMain/SS34%20WH%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss34_WhiteNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552688394",
      "product_title": "Premier Ladies Long John Roll Sleeve T-Shirt",
      "product_handle": "pr318",
      "product_url": "/products/pr318",
      "product_full_url": "None",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-pr318",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Viscose/Elastane",
      "shopify_material": "Poly/Viscose/Elastane",
      "csv_material": "82% polyester/14% viscose/4% elastane.",
      "style_code": "PR318",
      "colour_name": "White/Navy",
      "colour_group": "White > White",
      "rgb": "#ffffff;#041848",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491314934026",
      "swatch_filename": "pr318_WhiteNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr318_WhiteNavy.jpg?v=1774526498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr318_WhiteNavy.jpg?v=1774526498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR318/ProductCarouselMain/PR318%20WH%252fNV%20FRONT%202.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr318_WhiteNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552622858",
      "product_title": "Premier Long John Roll Sleeve T-Shirt",
      "product_handle": "pr218",
      "product_url": "/products/pr218",
      "product_full_url": "https://oakdenemerch.com/products/pr218",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-pr218",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Viscose/Elastane",
      "shopify_material": "Poly/Viscose/Elastane",
      "csv_material": "82% polyester/14% viscose/4% elastane.",
      "style_code": "PR218",
      "colour_name": "White/Navy",
      "colour_group": "White > White",
      "rgb": "#ffffff;#041848",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472776995082",
      "swatch_filename": "PR218_WhiteNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR218_WhiteNavy.jpg?v=1774359566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR218_WhiteNavy.jpg?v=1774359566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR218/ProductCarouselMain/PR218%20WH_NV%20FRONT%202.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr218_WhiteNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547969802",
      "product_title": "SOL'S Funky Contrast Baseball T-Shirt",
      "product_handle": "11190",
      "product_url": "/products/11190",
      "product_full_url": "https://oakdenemerch.com/products/11190",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11190",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11190",
      "colour_name": "White/Navy",
      "colour_group": "White > White",
      "rgb": "#ffffff;#061731",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468904964362",
      "swatch_filename": "11190_WhiteNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11190_WhiteNavy.jpg?v=1774312736",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11190_WhiteNavy.jpg?v=1774312736",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11190/ProductCarouselMain/11190%20WH%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11190_WhiteNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685557514",
      "product_title": "SOL'S Ladies Marine Long Sleeve Striped T-Shirt",
      "product_handle": "01403",
      "product_url": "/products/01403",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-01403",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "01403",
      "colour_name": "White/Navy",
      "colour_group": "White > White",
      "rgb": "#ffffff;#061731",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490364367114",
      "swatch_filename": "01403_WhiteNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01403_WhiteNavy.jpg?v=1774522686",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01403_WhiteNavy.jpg?v=1774522686",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01403/ProductCarouselMain/01403%20WH%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01403_WhiteNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546855690",
      "product_title": "SOL'S Ladies Miles Striped T-Shirt",
      "product_handle": "01399",
      "product_url": "/products/01399",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-01399",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "01399",
      "colour_name": "White/Navy",
      "colour_group": "White > White",
      "rgb": "#ffffff;#061731",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491514589450",
      "swatch_filename": "01399_WhiteNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01399_WhiteNavy.jpg?v=1774526865",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01399_WhiteNavy.jpg?v=1774526865",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01399/ProductCarouselMain/01399%20WH%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01399_WhiteNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685524746",
      "product_title": "SOL'S Marine Long Sleeve Striped T-Shirt",
      "product_handle": "01402",
      "product_url": "/products/01402",
      "product_full_url": "https://oakdenemerch.com/products/01402",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01402",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "01402",
      "colour_name": "White/Navy",
      "colour_group": "White > White",
      "rgb": "#ffffff;#061731",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490363318538",
      "swatch_filename": "01402_WhiteNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01402_WhiteNavy.jpg?v=1774522681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01402_WhiteNavy.jpg?v=1774522681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01402/ProductCarouselMain/01402%20WH%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01402_WhiteNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546822922",
      "product_title": "SOL'S Miles Striped T-Shirt",
      "product_handle": "01398",
      "product_url": "/products/01398",
      "product_full_url": "https://oakdenemerch.com/products/01398",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01398",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "01398",
      "colour_name": "White/Navy",
      "colour_group": "White > White",
      "rgb": "#ffffff;#061731",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468813607178",
      "swatch_filename": "01398_WhiteNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01398_WhiteNavy.jpg?v=1774311762",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01398_WhiteNavy.jpg?v=1774311762",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01398/ProductCarouselMain/01398%20WH%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01398_WhiteNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547969802",
      "product_title": "SOL'S Funky Contrast Baseball T-Shirt",
      "product_handle": "11190",
      "product_url": "/products/11190",
      "product_full_url": "https://oakdenemerch.com/products/11190",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11190",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11190",
      "colour_name": "White/Orange",
      "colour_group": "White > White",
      "rgb": "#ffffff;#ff380f",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468905029898",
      "swatch_filename": "11190_WhiteOrange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11190_WhiteOrange.jpg?v=1774312736",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11190_WhiteOrange.jpg?v=1774312736",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11190/ProductCarouselMain/11190%20WH%252fOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11190_WhiteOrange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553605898",
      "product_title": "SF Clothing Kids Striped T-Shirt",
      "product_handle": "sm202",
      "product_url": "/products/sm202",
      "product_full_url": "https://oakdenemerch.com/products/sm202",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "11-12",
        "11-12-5-6-7-8-9-10",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-sm202",
        "t-shirts"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SM202",
      "colour_name": "White/Oxford Navy",
      "colour_group": "White > White",
      "rgb": "#ffffff;#061a50",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491291996426",
      "swatch_filename": "sm202_WhiteOxford_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sm202_WhiteOxford_Navy.jpg?v=1774526431",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sm202_WhiteOxford_Navy.jpg?v=1774526431",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SM202/ProductCarouselMain/SM202%20WH%252fOX%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sm202_WhiteOxford_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687851274",
      "product_title": "SF Clothing Unisex Long Sleeve Striped T-Shirt",
      "product_handle": "sf204",
      "product_url": "/products/sf204",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-sf204",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SF204",
      "colour_name": "White/Oxford Navy",
      "colour_group": "White > White",
      "rgb": "#ffffff;#061a50",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490483773706",
      "swatch_filename": "sf204_WhiteOxford_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf204_WhiteOxford_Navy.jpg?v=1774522987",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf204_WhiteOxford_Navy.jpg?v=1774522987",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF204/ProductCarouselMain/SF204%20WH%252fOX%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf204_WhiteOxford_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548657930",
      "product_title": "Bella Ladies Micro Rib Raglan Baby T-Shirt",
      "product_handle": "bl1201",
      "product_url": "/products/bl1201",
      "product_full_url": "https://oakdenemerch.com/products/bl1201",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "headwear",
        "L",
        "M",
        "S",
        "style-bl1201",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1201",
      "colour_name": "White/Pink",
      "colour_group": "White > White",
      "rgb": "#ffffff;#ffc4ed",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472614891786",
      "swatch_filename": "BL1201_WhitePink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL1201_WhitePink.jpg?v=1774358245",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL1201_WhitePink.jpg?v=1774358245",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1201/ProductCarouselMain/BL1201%20WH%252fPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1201_WhitePink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548625162",
      "product_title": "Bella Ladies Micro Rib 3/4 Raglan Baby T-Shirt",
      "product_handle": "bl1200",
      "product_url": "/products/bl1200",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-bl1200",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1200",
      "colour_name": "White/Red",
      "colour_group": "White > White",
      "rgb": "#ffffff;#e80326",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491495649546",
      "swatch_filename": "bl1200_WhiteRed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1200_WhiteRed.jpg?v=1774526805",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1200_WhiteRed.jpg?v=1774526805",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1200/ProductCarouselMain/BL1200%20WH%252fRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1200_WhiteRed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548657930",
      "product_title": "Bella Ladies Micro Rib Raglan Baby T-Shirt",
      "product_handle": "bl1201",
      "product_url": "/products/bl1201",
      "product_full_url": "https://oakdenemerch.com/products/bl1201",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "headwear",
        "L",
        "M",
        "S",
        "style-bl1201",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1201",
      "colour_name": "White/Red",
      "colour_group": "White > White",
      "rgb": "#ffffff;#e80326",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472614793482",
      "swatch_filename": "BL1201_WhiteRed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL1201_WhiteRed.jpg?v=1774358245",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL1201_WhiteRed.jpg?v=1774358245",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1201/ProductCarouselMain/BL1201%20WH%252fRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1201_WhiteRed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548952842",
      "product_title": "Canvas Unisex 3/4 Sleeve Baseball T-Shirt",
      "product_handle": "cv3200",
      "product_url": "/products/cv3200",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv3200",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "CV3200",
      "colour_name": "White/Red",
      "colour_group": "White > White",
      "rgb": "#ffffff;#e80326",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491487817994",
      "swatch_filename": "cv3200_WhiteRed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3200_WhiteRed.jpg?v=1774526780",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3200_WhiteRed.jpg?v=1774526780",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3200/ProductCarouselMain/CV3200%20WH%252fRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3200_WhiteRed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554261258",
      "product_title": "Fruit of the Loom Contrast Baseball T-Shirt",
      "product_handle": "ss31",
      "product_url": "/products/ss31",
      "product_full_url": "https://oakdenemerch.com/products/ss31",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss31",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS31",
      "colour_name": "White/Red",
      "colour_group": "White > White",
      "rgb": "#ffffff;#ff002e",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468950806794",
      "swatch_filename": "SS31_WhiteRed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS31_WhiteRed.jpg?v=1774314925",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS31_WhiteRed.jpg?v=1774314925",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS31/ProductCarouselMain/SS31%20WH%252fRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss31_WhiteRed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688015114",
      "product_title": "Fruit of the Loom Contrast Long Sleeve Baseball T-Shirt",
      "product_handle": "ss32",
      "product_url": "/products/ss32",
      "product_full_url": "https://oakdenemerch.com/products/ss32",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss32",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS32",
      "colour_name": "White/Red",
      "colour_group": "White > White",
      "rgb": "#ffffff;#ff002e",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490486755594",
      "swatch_filename": "ss32_WhiteRed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss32_WhiteRed.jpg?v=1774523024",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss32_WhiteRed.jpg?v=1774523024",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS32/ProductCarouselMain/SS32%20WH%252fRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss32_WhiteRed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554294026",
      "product_title": "Fruit of the Loom Contrast Ringer T-Shirt",
      "product_handle": "ss34",
      "product_url": "/products/ss34",
      "product_full_url": "https://oakdenemerch.com/products/ss34",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss34",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS34",
      "colour_name": "White/Red",
      "colour_group": "White > White",
      "rgb": "#ffffff;#ff002e",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468953002250",
      "swatch_filename": "SS34_WhiteRed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS34_WhiteRed.jpg?v=1774315005",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS34_WhiteRed.jpg?v=1774315005",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS34/ProductCarouselMain/SS34%20WH%252fRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss34_WhiteRed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547969802",
      "product_title": "SOL'S Funky Contrast Baseball T-Shirt",
      "product_handle": "11190",
      "product_url": "/products/11190",
      "product_full_url": "https://oakdenemerch.com/products/11190",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11190",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11190",
      "colour_name": "White/Red",
      "colour_group": "White > White",
      "rgb": "#ffffff;#c90546",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468904800522",
      "swatch_filename": "11190_WhiteRed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11190_WhiteRed.jpg?v=1774312736",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11190_WhiteRed.jpg?v=1774312736",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11190/ProductCarouselMain/11190%20WH%252fRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11190_WhiteRed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685557514",
      "product_title": "SOL'S Ladies Marine Long Sleeve Striped T-Shirt",
      "product_handle": "01403",
      "product_url": "/products/01403",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-01403",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "01403",
      "colour_name": "White/Red",
      "colour_group": "White > White",
      "rgb": "#ffffff;#c90546",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490364432650",
      "swatch_filename": "01403_WhiteRed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01403_WhiteRed.jpg?v=1774522687",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01403_WhiteRed.jpg?v=1774522687",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01403/ProductCarouselMain/01403%20WH%252fRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01403_WhiteRed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546855690",
      "product_title": "SOL'S Ladies Miles Striped T-Shirt",
      "product_handle": "01399",
      "product_url": "/products/01399",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-01399",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "01399",
      "colour_name": "White/Red",
      "colour_group": "White > White",
      "rgb": "#ffffff;#c90546",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491515146506",
      "swatch_filename": "01399_WhiteRed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01399_WhiteRed.jpg?v=1774526868",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01399_WhiteRed.jpg?v=1774526868",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01399/ProductCarouselMain/01399%20WH%252fRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01399_WhiteRed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685524746",
      "product_title": "SOL'S Marine Long Sleeve Striped T-Shirt",
      "product_handle": "01402",
      "product_url": "/products/01402",
      "product_full_url": "https://oakdenemerch.com/products/01402",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01402",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "01402",
      "colour_name": "White/Red",
      "colour_group": "White > White",
      "rgb": "#ffffff;#c90546",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490363351306",
      "swatch_filename": "01402_WhiteRed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01402_WhiteRed.jpg?v=1774522682",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01402_WhiteRed.jpg?v=1774522682",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01402/ProductCarouselMain/01402%20WH%252fRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01402_WhiteRed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546822922",
      "product_title": "SOL'S Miles Striped T-Shirt",
      "product_handle": "01398",
      "product_url": "/products/01398",
      "product_full_url": "https://oakdenemerch.com/products/01398",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01398",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "01398",
      "colour_name": "White/Red",
      "colour_group": "White > White",
      "rgb": "#ffffff;#c90546",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468813574410",
      "swatch_filename": "01398_WhiteRed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01398_WhiteRed.jpg?v=1774311762",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01398_WhiteRed.jpg?v=1774311762",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01398/ProductCarouselMain/01398%20WH%252fRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01398_WhiteRed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548625162",
      "product_title": "Bella Ladies Micro Rib 3/4 Raglan Baby T-Shirt",
      "product_handle": "bl1200",
      "product_url": "/products/bl1200",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-bl1200",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1200",
      "colour_name": "White/Royal Blue",
      "colour_group": "White > White",
      "rgb": "#ffffff;#0549f5",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491495715082",
      "swatch_filename": "bl1200_WhiteRoyal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1200_WhiteRoyal_Blue.jpg?v=1774526806",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1200_WhiteRoyal_Blue.jpg?v=1774526806",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1200/ProductCarouselMain/BL1200%20WH%252fRY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1200_WhiteRoyal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548657930",
      "product_title": "Bella Ladies Micro Rib Raglan Baby T-Shirt",
      "product_handle": "bl1201",
      "product_url": "/products/bl1201",
      "product_full_url": "https://oakdenemerch.com/products/bl1201",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "headwear",
        "L",
        "M",
        "S",
        "style-bl1201",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1201",
      "colour_name": "White/Royal Blue",
      "colour_group": "White > White",
      "rgb": "#ffffff;#0549f5",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472614826250",
      "swatch_filename": "BL1201_WhiteRoyal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL1201_WhiteRoyal_Blue.jpg?v=1774358245",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL1201_WhiteRoyal_Blue.jpg?v=1774358245",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1201/ProductCarouselMain/BL1201%20WH%252fRY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1201_WhiteRoyal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554261258",
      "product_title": "Fruit of the Loom Contrast Baseball T-Shirt",
      "product_handle": "ss31",
      "product_url": "/products/ss31",
      "product_full_url": "https://oakdenemerch.com/products/ss31",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss31",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS31",
      "colour_name": "White/Royal Blue",
      "colour_group": "White > White",
      "rgb": "#ffffff;#175cff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468950839562",
      "swatch_filename": "SS31_WhiteRoyal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS31_WhiteRoyal_Blue.jpg?v=1774314925",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS31_WhiteRoyal_Blue.jpg?v=1774314925",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS31/ProductCarouselMain/SS31%20WH%252fRY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss31_WhiteRoyal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688015114",
      "product_title": "Fruit of the Loom Contrast Long Sleeve Baseball T-Shirt",
      "product_handle": "ss32",
      "product_url": "/products/ss32",
      "product_full_url": "https://oakdenemerch.com/products/ss32",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss32",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS32",
      "colour_name": "White/Royal Blue",
      "colour_group": "White > White",
      "rgb": "#ffffff;#175cff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490486821130",
      "swatch_filename": "ss32_WhiteRoyal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss32_WhiteRoyal_Blue.jpg?v=1774523025",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss32_WhiteRoyal_Blue.jpg?v=1774523025",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS32/ProductCarouselMain/SS32%20WH%252fRY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss32_WhiteRoyal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554294026",
      "product_title": "Fruit of the Loom Contrast Ringer T-Shirt",
      "product_handle": "ss34",
      "product_url": "/products/ss34",
      "product_full_url": "https://oakdenemerch.com/products/ss34",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss34",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS34",
      "colour_name": "White/Royal Blue",
      "colour_group": "White > White",
      "rgb": "#ffffff;#175cff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468953035018",
      "swatch_filename": "SS34_WhiteRoyal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS34_WhiteRoyal_Blue.jpg?v=1774315005",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS34_WhiteRoyal_Blue.jpg?v=1774315005",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS34/ProductCarouselMain/SS34%20WH%252fRY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss34_WhiteRoyal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547969802",
      "product_title": "SOL'S Funky Contrast Baseball T-Shirt",
      "product_handle": "11190",
      "product_url": "/products/11190",
      "product_full_url": "https://oakdenemerch.com/products/11190",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11190",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11190",
      "colour_name": "White/Royal Blue",
      "colour_group": "White > White",
      "rgb": "#ffffff;#002399",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468904767754",
      "swatch_filename": "11190_WhiteRoyal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11190_WhiteRoyal_Blue.jpg?v=1774312736",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11190_WhiteRoyal_Blue.jpg?v=1774312736",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11190/ProductCarouselMain/11190%20WH%252fRY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11190_WhiteRoyal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553442058",
      "product_title": "SF Clothing Ladies Fashion Crop Top",
      "product_handle": "sk236",
      "product_url": "/products/sk236",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-sk236",
        "t-shirts",
        "womens",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "88% polyester/12% elastane single jersey.",
      "style_code": "SK236",
      "colour_name": "White/White",
      "colour_group": "White > White",
      "rgb": "#ffffff;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491298320650",
      "swatch_filename": "sk236_WhiteWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk236_WhiteWhite.jpg?v=1774526449",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk236_WhiteWhite.jpg?v=1774526449",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK236/ProductCarouselMain/SK236%20WH%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk236_WhiteWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547347210",
      "product_title": "SOL'S Unisex Odyssey Recycled T-Shirt",
      "product_handle": "03805",
      "product_url": "/products/03805",
      "product_full_url": "https://oakdenemerch.com/products/03805",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-03805",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "55% recycled cotton/45% recycled polyester.",
      "style_code": "03805",
      "colour_name": "Recycled White",
      "colour_group": "White > White",
      "rgb": "#fcfcfc",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49473296072970",
      "swatch_filename": "03805_Recycled_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03805_Recycled_White.jpg?v=1774363245",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03805_Recycled_White.jpg?v=1774363245",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03805/ProductCarouselMain/03805%20RCW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03805_Recycled_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548690698",
      "product_title": "Bella Ladies Heavy Boxy T-Shirt",
      "product_handle": "bl6110",
      "product_url": "/products/bl6110",
      "product_full_url": "https://oakdenemerch.com/products/bl6110",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-bl6110",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "BL6110",
      "colour_name": "Vintage White",
      "colour_group": "White > White",
      "rgb": "#e4e4e4",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.894118,
      "swatch_file_id": "gid://shopify/MediaImage/49472881426698",
      "swatch_filename": "BL6110_Vintage_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_Vintage_White.jpg?v=1774360126",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_Vintage_White.jpg?v=1774360126",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL6110/ProductCarouselMain/BL6110%20VWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl6110_Vintage_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547379978",
      "product_title": "SOL'S Boxy Oversized Organic T-Shirt",
      "product_handle": "03806",
      "product_url": "/products/03806",
      "product_full_url": "https://oakdenemerch.com/products/03806",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL",
        "style-03806",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "03806",
      "colour_name": "Off White",
      "colour_group": "Natural > Natural",
      "rgb": "#f2ede6",
      "sort_bucket": "white",
      "sort_hue": 0.097222,
      "sort_sat": 0.049587,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49471864701194",
      "swatch_filename": "03806_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03806_Off_White.jpg?v=1774352127",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03806_Off_White.jpg?v=1774352127",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03806/ProductCarouselMain/03806%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03806_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547511050",
      "product_title": "SOL'S Crusader Recycled T-Shirt",
      "product_handle": "04233",
      "product_url": "/products/04233",
      "product_full_url": "https://oakdenemerch.com/products/04233",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04233",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% recycled cotton/50% cotton.*",
      "style_code": "04233",
      "colour_name": "Off White",
      "colour_group": "Natural > Natural",
      "rgb": "#f2ede6",
      "sort_bucket": "white",
      "sort_hue": 0.097222,
      "sort_sat": 0.049587,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49473285193994",
      "swatch_filename": "04233_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Off_White.jpg?v=1774363191",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Off_White.jpg?v=1774363191",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04233/ProductCarouselMain/04233%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04233_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Off White",
      "colour_group": "Natural > Natural",
      "rgb": "#f2ede6",
      "sort_bucket": "white",
      "sort_hue": 0.097222,
      "sort_sat": 0.049587,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49474449703178",
      "swatch_filename": "11500_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Off_White.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Off_White.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547412746",
      "product_title": "SOL'S Ladies Boxy Oversized Organic T-Shirt",
      "product_handle": "03807",
      "product_url": "/products/03807",
      "product_full_url": "https://oakdenemerch.com/products/03807",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03807",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "03807",
      "colour_name": "Off White",
      "colour_group": "Natural > Natural",
      "rgb": "#f2ede6",
      "sort_bucket": "white",
      "sort_hue": 0.097222,
      "sort_sat": 0.049587,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49474463629578",
      "swatch_filename": "03807_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03807_Off_White.jpg?v=1774372093",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03807_Off_White.jpg?v=1774372093",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03807/ProductCarouselMain/03807%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03807_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Off White",
      "colour_group": "Natural > Natural",
      "rgb": "#f2ede6",
      "sort_bucket": "white",
      "sort_hue": 0.097222,
      "sort_sat": 0.049587,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49468934160650",
      "swatch_filename": "11502_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Off_White.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Off_White.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547642122",
      "product_title": "SOL'S Ladies Legend T-Shirt",
      "product_handle": "04776",
      "product_url": "/products/04776",
      "product_full_url": "https://oakdenemerch.com/products/04776",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-04776",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "04776",
      "colour_name": "Off White",
      "colour_group": "Natural > Natural",
      "rgb": "#f2ede6",
      "sort_bucket": "white",
      "sort_hue": 0.097222,
      "sort_sat": 0.049587,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49472963215626",
      "swatch_filename": "04776_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Off_White.jpg?v=1774360489",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Off_White.jpg?v=1774360489",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04776/ProductCarouselMain/04776%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04776_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "Off White",
      "colour_group": "Natural > Natural",
      "rgb": "#f2ede6",
      "sort_bucket": "white",
      "sort_hue": 0.097222,
      "sort_sat": 0.049587,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49468833005834",
      "swatch_filename": "03579_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Off_White.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Off_White.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547609354",
      "product_title": "SOL'S Ladies Regent V Neck T-Shirt",
      "product_handle": "04766",
      "product_url": "/products/04766",
      "product_full_url": "https://oakdenemerch.com/products/04766",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "S",
        "style-04766",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "04766",
      "colour_name": "Off White",
      "colour_group": "Natural > Natural",
      "rgb": "#f2ede6",
      "sort_bucket": "white",
      "sort_hue": 0.097222,
      "sort_sat": 0.049587,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49472664633610",
      "swatch_filename": "04766_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04766_Off_White.jpg?v=1774358605",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04766_Off_White.jpg?v=1774358605",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04766/ProductCarouselMain/04766%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04766_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547707658",
      "product_title": "SOL'S Ladies Vortex Ripstop Performance T-Shirt",
      "product_handle": "04788",
      "product_url": "/products/04788",
      "product_full_url": "https://oakdenemerch.com/products/04788",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04788",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04788",
      "colour_name": "Off White",
      "colour_group": "Natural > Natural",
      "rgb": "#f2ede6",
      "sort_bucket": "white",
      "sort_hue": 0.097222,
      "sort_sat": 0.049587,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49472651854090",
      "swatch_filename": "04788_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_Off_White.jpg?v=1774358494",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_Off_White.jpg?v=1774358494",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04788/ProductCarouselMain/04788%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04788_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03565",
      "colour_name": "Off White",
      "colour_group": "Natural > Natural",
      "rgb": "#f2ede6",
      "sort_bucket": "white",
      "sort_hue": 0.097222,
      "sort_sat": 0.049587,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49473306099978",
      "swatch_filename": "03565_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Off_White.jpg?v=1774363313",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Off_White.jpg?v=1774363313",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Off White",
      "colour_group": "Natural > Natural",
      "rgb": "#f2ede6",
      "sort_bucket": "white",
      "sort_hue": 0.097222,
      "sort_sat": 0.049587,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49473719140618",
      "swatch_filename": "11380_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Off_White.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Off_White.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Off White",
      "colour_group": "Natural > Natural",
      "rgb": "#f2ede6",
      "sort_bucket": "white",
      "sort_hue": 0.097222,
      "sort_sat": 0.049587,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49473744765194",
      "swatch_filename": "03981_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Off_White.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Off_White.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685786890",
      "product_title": "SOL'S Unisex Pioneer Long Sleeve T-Shirt",
      "product_handle": "03982",
      "product_url": "/products/03982",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03982",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03982",
      "colour_name": "Off White",
      "colour_group": "Natural > Natural",
      "rgb": "#f2ede6",
      "sort_bucket": "white",
      "sort_hue": 0.097222,
      "sort_sat": 0.049587,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49490368332042",
      "swatch_filename": "03982_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03982_Off_White.jpg?v=1774522719",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03982_Off_White.jpg?v=1774522719",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03982/ProductCarouselMain/03982%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03982_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547674890",
      "product_title": "SOL'S Vortex Ripstop Performance T-Shirt",
      "product_handle": "04787",
      "product_url": "/products/04787",
      "product_full_url": "https://oakdenemerch.com/products/04787",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04787",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04787",
      "colour_name": "Off White",
      "colour_group": "Natural > Natural",
      "rgb": "#f2ede6",
      "sort_bucket": "white",
      "sort_hue": 0.097222,
      "sort_sat": 0.049587,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49472658309386",
      "swatch_filename": "04787_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_Off_White.jpg?v=1774358538",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_Off_White.jpg?v=1774358538",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04787/ProductCarouselMain/04787%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04787_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Off White",
      "colour_group": "White > White",
      "rgb": "#f5ebd3",
      "sort_bucket": "white",
      "sort_hue": 0.117647,
      "sort_sat": 0.138776,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49471386321162",
      "swatch_filename": "GD05_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Off_White.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Off_White.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549903114",
      "product_title": "Gildan Ladies Heavy Cotton™ T-Shirt",
      "product_handle": "gd95",
      "product_url": "/products/gd95",
      "product_full_url": "https://oakdenemerch.com/products/gd95",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd95",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD95",
      "colour_name": "Off White",
      "colour_group": "White > White",
      "rgb": "#f5ebd3",
      "sort_bucket": "white",
      "sort_hue": 0.117647,
      "sort_sat": 0.138776,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49468944384266",
      "swatch_filename": "GD95_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD95_Off_White.jpg?v=1774314277",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD95_Off_White.jpg?v=1774314277",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD95/ProductCarouselMain/GD95%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd95_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Off White",
      "colour_group": "White > White",
      "rgb": "#f5ebd3",
      "sort_bucket": "white",
      "sort_hue": 0.117647,
      "sort_sat": 0.138776,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49474268004618",
      "swatch_filename": "GD01_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Off_White.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Off_White.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548985610",
      "product_title": "Canvas Unisex Tri-Blend T-Shirt",
      "product_handle": "cv3413",
      "product_url": "/products/cv3413",
      "product_full_url": "https://oakdenemerch.com/products/cv3413",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-cv3413",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Cotton/Rayon",
      "shopify_material": "Poly/Cotton/Rayon",
      "csv_material": "50% polyester/25% airlume combed ringspun cotton/25% rayon.",
      "style_code": "CV3413",
      "colour_name": "White Fleck Tri-Blend",
      "colour_group": "White > Heather/Effect White",
      "rgb": "#d5d9d5",
      "sort_bucket": "white",
      "sort_hue": 0.333333,
      "sort_sat": 0.018433,
      "sort_val": 0.85098,
      "swatch_file_id": "gid://shopify/MediaImage/49472609485066",
      "swatch_filename": "CV3413_White_Fleck_Tri-Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_White_Fleck_Tri-Blend.jpg?v=1774358160",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_White_Fleck_Tri-Blend.jpg?v=1774358160",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3413/ProductCarouselMain/CV3413%20WHF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3413_White_Fleck_Tri-Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552196874",
      "product_title": "Native Spirit Ladies Roll-Up Sleeve T-Shirt",
      "product_handle": "ns309",
      "product_url": "/products/ns309",
      "product_full_url": "https://oakdenemerch.com/products/ns309",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "S",
        "style-ns309",
        "t-shirts",
        "womens",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS309",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ededff",
      "sort_bucket": "white",
      "sort_hue": 0.666667,
      "sort_sat": 0.070588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474128544010",
      "swatch_filename": "NS309_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS309_White.jpg?v=1774369419",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS309_White.jpg?v=1774369419",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS309/ProductCarouselMain/NS309%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns309_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552295178",
      "product_title": "Native Spirit Ladies T-Shirt",
      "product_handle": "ns324",
      "product_url": "/products/ns324",
      "product_full_url": "https://oakdenemerch.com/products/ns324",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns324",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS324",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ededff",
      "sort_bucket": "white",
      "sort_hue": 0.666667,
      "sort_sat": 0.070588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472283640074",
      "swatch_filename": "NS324_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_White.jpg?v=1774354240",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_White.jpg?v=1774354240",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS324/ProductCarouselMain/NS324%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns324_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562330890",
      "product_title": "Native Spirit Ladies Tank Top",
      "product_handle": "ns341",
      "product_url": "/products/ns341",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns341",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS341",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ededff",
      "sort_bucket": "white",
      "sort_hue": 0.666667,
      "sort_sat": 0.070588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513929834762",
      "swatch_filename": "ns341_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns341_White.jpg?v=1774619042",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns341_White.jpg?v=1774619042",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS341/ProductCarouselMain/NS341%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns341_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552393482",
      "product_title": "Native Spirit Oversized T-Shirt",
      "product_handle": "ns332",
      "product_url": "/products/ns332",
      "product_full_url": "https://oakdenemerch.com/products/ns332",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns332",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "NS332",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ededff",
      "sort_bucket": "white",
      "sort_hue": 0.666667,
      "sort_sat": 0.070588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474121302282",
      "swatch_filename": "NS332_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_White.jpg?v=1774369280",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_White.jpg?v=1774369280",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS332/ProductCarouselMain/NS332%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns332_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687654666",
      "product_title": "Native Spirit Unisex Crew Neck Long Sleeve T-Shirt",
      "product_handle": "ns333",
      "product_url": "/products/ns333",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-ns333",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS333",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ededff",
      "sort_bucket": "white",
      "sort_hue": 0.666667,
      "sort_sat": 0.070588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490480496906",
      "swatch_filename": "ns333_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns333_White.jpg?v=1774522951",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns333_White.jpg?v=1774522951",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS333/ProductCarouselMain/NS333%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns333_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ededff",
      "sort_bucket": "white",
      "sort_hue": 0.666667,
      "sort_sat": 0.070588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473667596554",
      "swatch_filename": "NS305_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_White.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_White.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552360714",
      "product_title": "Native Spirit Unisex Oversized T-Shirt",
      "product_handle": "ns330",
      "product_url": "/products/ns330",
      "product_full_url": "https://oakdenemerch.com/products/ns330",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-ns330",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS330",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ededff",
      "sort_bucket": "white",
      "sort_hue": 0.666667,
      "sort_sat": 0.070588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473635254538",
      "swatch_filename": "NS330_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS330_White.jpg?v=1774364536",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS330_White.jpg?v=1774364536",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS330/ProductCarouselMain/NS330%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns330_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "Bright Red",
      "colour_group": "Red > Red",
      "rgb": "#ff0000",
      "sort_bucket": "red",
      "sort_hue": 0.0,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473273233674",
      "swatch_filename": "180M_Bright_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Bright_Red.jpg?v=1774363125",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Bright_Red.jpg?v=1774363125",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20BRE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_Bright_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548199178",
      "product_title": "Russell Athletic Kids Classic Ringspun T-Shirt",
      "product_handle": "180b",
      "product_url": "/products/180b",
      "product_full_url": "https://oakdenemerch.com/products/180b",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "PCBest_Seller",
        "performance-activewear",
        "sports",
        "style-180b",
        "t-shirts"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.",
      "style_code": "180B",
      "colour_name": "Bright Red",
      "colour_group": "Red > Red",
      "rgb": "#ff0000",
      "sort_bucket": "red",
      "sort_hue": 0.0,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474443346186",
      "swatch_filename": "180B_Bright_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_Bright_Red.jpg?v=1774371757",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_Bright_Red.jpg?v=1774371757",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180B/ProductCarouselMain/180B%20BRE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180b_Bright_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547511050",
      "product_title": "SOL'S Crusader Recycled T-Shirt",
      "product_handle": "04233",
      "product_url": "/products/04233",
      "product_full_url": "https://oakdenemerch.com/products/04233",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04233",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% recycled cotton/50% cotton.*",
      "style_code": "04233",
      "colour_name": "Bright Red",
      "colour_group": "Red > Red",
      "rgb": "#f70000",
      "sort_bucket": "red",
      "sort_hue": 0.0,
      "sort_sat": 1.0,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49473285062922",
      "swatch_filename": "04233_Bright_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Bright_Red.jpg?v=1774363191",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Bright_Red.jpg?v=1774363191",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04233/ProductCarouselMain/04233%20BRE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04233_Bright_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547642122",
      "product_title": "SOL'S Ladies Legend T-Shirt",
      "product_handle": "04776",
      "product_url": "/products/04776",
      "product_full_url": "https://oakdenemerch.com/products/04776",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-04776",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "04776",
      "colour_name": "Bright Red",
      "colour_group": "Red > Red",
      "rgb": "#f70000",
      "sort_bucket": "red",
      "sort_hue": 0.0,
      "sort_sat": 1.0,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49472963477770",
      "swatch_filename": "04776_Bright_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Bright_Red.jpg?v=1774360489",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Bright_Red.jpg?v=1774360489",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04776/ProductCarouselMain/04776%20BRE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04776_Bright_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "Bright Red",
      "colour_group": "Red > Red",
      "rgb": "#f70000",
      "sort_bucket": "red",
      "sort_hue": 0.0,
      "sort_sat": 1.0,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49468833562890",
      "swatch_filename": "03579_Bright_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Bright_Red.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Bright_Red.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20BRE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Bright_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Bright Red",
      "colour_group": "Red > Red",
      "rgb": "#f70000",
      "sort_bucket": "red",
      "sort_hue": 0.0,
      "sort_sat": 1.0,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49473744568586",
      "swatch_filename": "03981_Bright_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Bright_Red.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Bright_Red.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20BRE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Bright_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685786890",
      "product_title": "SOL'S Unisex Pioneer Long Sleeve T-Shirt",
      "product_handle": "03982",
      "product_url": "/products/03982",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03982",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03982",
      "colour_name": "Bright Red",
      "colour_group": "Red > Red",
      "rgb": "#f70000",
      "sort_bucket": "red",
      "sort_hue": 0.0,
      "sort_sat": 1.0,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49490368397578",
      "swatch_filename": "03982_Bright_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03982_Bright_Red.jpg?v=1774522720",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03982_Bright_Red.jpg?v=1774522720",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03982/ProductCarouselMain/03982%20BRE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03982_Bright_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552557322",
      "product_title": "Proact Ladies Performance T-Shirt",
      "product_handle": "pa439",
      "product_url": "/products/pa439",
      "product_full_url": "https://oakdenemerch.com/products/pa439",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa439",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA439",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#e80000",
      "sort_bucket": "red",
      "sort_hue": 0.0,
      "sort_sat": 1.0,
      "sort_val": 0.909804,
      "swatch_file_id": "gid://shopify/MediaImage/49471737102602",
      "swatch_filename": "PA439_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Red.jpg?v=1774351221",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Red.jpg?v=1774351221",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA439/ProductCarouselMain/PA439%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa439_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552524554",
      "product_title": "Proact Performance T-Shirt",
      "product_handle": "pa438",
      "product_url": "/products/pa438",
      "product_full_url": "https://oakdenemerch.com/products/pa438",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa438",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA438",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#e80000",
      "sort_bucket": "red",
      "sort_hue": 0.0,
      "sort_sat": 1.0,
      "sort_val": 0.909804,
      "swatch_file_id": "gid://shopify/MediaImage/49471752143114",
      "swatch_filename": "PA438_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Red.jpg?v=1774351290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Red.jpg?v=1774351290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA438/ProductCarouselMain/PA438%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa438_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#e6100b",
      "sort_bucket": "red",
      "sort_hue": 0.003805,
      "sort_sat": 0.952174,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49473259536650",
      "swatch_filename": "CV3001_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Red.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Red.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562363658",
      "product_title": "Native Spirit Ladies Cropped Tank Top",
      "product_handle": "ns342",
      "product_url": "/products/ns342",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns342",
        "t-shirts",
        "womens",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS342",
      "colour_name": "Washed Paprika",
      "colour_group": "Red > Dark Red",
      "rgb": "#b8322c",
      "sort_bucket": "red",
      "sort_hue": 0.007143,
      "sort_sat": 0.76087,
      "sort_val": 0.721569,
      "swatch_file_id": "gid://shopify/MediaImage/49513930653962",
      "swatch_filename": "ns342_Washed_Paprika.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns342_Washed_Paprika.jpg?v=1774619056",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns342_Washed_Paprika.jpg?v=1774619056",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS342/ProductCarouselMain/NS342%20WPP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns342_Washed_Paprika.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552262410",
      "product_title": "Native Spirit Ladies Faded T-Shirt",
      "product_handle": "ns316",
      "product_url": "/products/ns316",
      "product_full_url": "https://oakdenemerch.com/products/ns316",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns316",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS316",
      "colour_name": "Washed Paprika",
      "colour_group": "Red > Dark Red",
      "rgb": "#b8322c",
      "sort_bucket": "red",
      "sort_hue": 0.007143,
      "sort_sat": 0.76087,
      "sort_val": 0.721569,
      "swatch_file_id": "gid://shopify/MediaImage/49472286621962",
      "swatch_filename": "NS316_Washed_Paprika.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS316_Washed_Paprika.jpg?v=1774354318",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS316_Washed_Paprika.jpg?v=1774354318",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS316/ProductCarouselMain/NS316%20WPP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns316_Washed_Paprika.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "52% cotton/48% polyester.",
      "style_code": "SS621",
      "colour_name": "Heather Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#7a1299",
      "sort_bucket": "red",
      "sort_hue": 0.795062,
      "sort_sat": 0.882353,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49471285526794",
      "swatch_filename": "SS621_Heather_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Heather_Burgundy.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Heather_Burgundy.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20HBU%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Heather_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Maroon",
      "colour_group": "Red > Burgundy",
      "rgb": "#360a36",
      "sort_bucket": "red",
      "sort_hue": 0.833333,
      "sort_sat": 0.814815,
      "sort_val": 0.211765,
      "swatch_file_id": "gid://shopify/MediaImage/49471386386698",
      "swatch_filename": "GD05_Maroon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Maroon.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Maroon.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20MAR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Maroon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Maroon",
      "colour_group": "Red > Burgundy",
      "rgb": "#360a36",
      "sort_bucket": "red",
      "sort_hue": 0.833333,
      "sort_sat": 0.814815,
      "sort_val": 0.211765,
      "swatch_file_id": "gid://shopify/MediaImage/49474267840778",
      "swatch_filename": "GD01_Maroon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Maroon.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Maroon.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20MAR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Maroon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Maroon",
      "colour_group": "Red > Burgundy",
      "rgb": "#360a36",
      "sort_bucket": "red",
      "sort_hue": 0.833333,
      "sort_sat": 0.814815,
      "sort_val": 0.211765,
      "swatch_file_id": "gid://shopify/MediaImage/49471368790282",
      "swatch_filename": "GD15_Maroon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Maroon.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Maroon.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20MAR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Maroon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD14",
      "colour_name": "Maroon",
      "colour_group": "Red > Burgundy",
      "rgb": "#360a36",
      "sort_bucket": "red",
      "sort_hue": 0.833333,
      "sort_sat": 0.814815,
      "sort_val": 0.211765,
      "swatch_file_id": "gid://shopify/MediaImage/49490455036170",
      "swatch_filename": "gd14_Maroon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Maroon.jpg?v=1774522844",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Maroon.jpg?v=1774522844",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20MAR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Maroon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Maroon",
      "colour_group": "Red > Burgundy",
      "rgb": "#360a36",
      "sort_bucket": "red",
      "sort_hue": 0.833333,
      "sort_sat": 0.814815,
      "sort_val": 0.211765,
      "swatch_file_id": "gid://shopify/MediaImage/49471397953802",
      "swatch_filename": "GD02_Maroon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Maroon.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Maroon.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20MAR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Maroon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#560d55",
      "sort_bucket": "red",
      "sort_hue": 0.835616,
      "sort_sat": 0.848837,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49471286083850",
      "swatch_filename": "SS621_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Burgundy.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Burgundy.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#560d55",
      "sort_bucket": "red",
      "sort_hue": 0.835616,
      "sort_sat": 0.848837,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49471313445130",
      "swatch_filename": "SS620_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Burgundy.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Burgundy.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS720",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#560d55",
      "sort_bucket": "red",
      "sort_hue": 0.835616,
      "sort_sat": 0.848837,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49472218792202",
      "swatch_filename": "SS720_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Burgundy.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Burgundy.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554654474",
      "product_title": "Fruit of the Loom Lady Fit Value T-Shirt",
      "product_handle": "ss77",
      "product_url": "/products/ss77",
      "product_full_url": "https://oakdenemerch.com/products/ss77",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss77",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS77",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#560d55",
      "sort_bucket": "red",
      "sort_hue": 0.835616,
      "sort_sat": 0.848837,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49472026214666",
      "swatch_filename": "SS77_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Burgundy.jpg?v=1774353471",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Burgundy.jpg?v=1774353471",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS77/ProductCarouselMain/SS77%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss77_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#560d55",
      "sort_bucket": "red",
      "sort_hue": 0.835616,
      "sort_sat": 0.848837,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49471330418954",
      "swatch_filename": "SS12_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Burgundy.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Burgundy.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#560d55",
      "sort_bucket": "red",
      "sort_hue": 0.835616,
      "sort_sat": 0.848837,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49471322161418",
      "swatch_filename": "SS6_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Burgundy.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Burgundy.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549116682",
      "product_title": "Ecologie Cascades Organic T-Shirt",
      "product_handle": "ea001",
      "product_url": "/products/ea001",
      "product_full_url": "https://oakdenemerch.com/products/ea001",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-ea001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#4d0c4b",
      "sort_bucket": "red",
      "sort_hue": 0.838462,
      "sort_sat": 0.844156,
      "sort_val": 0.301961,
      "swatch_file_id": "gid://shopify/MediaImage/49474303983882",
      "swatch_filename": "EA001_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Burgundy.jpg?v=1774371175",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Burgundy.jpg?v=1774371175",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001/ProductCarouselMain/EA001%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686049034",
      "product_title": "SOL'S Monarch Long Sleeve T-Shirt",
      "product_handle": "11420",
      "product_url": "/products/11420",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11420",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "11420",
      "colour_name": "Oxblood",
      "colour_group": "Red > Burgundy",
      "rgb": "#321630",
      "sort_bucket": "red",
      "sort_hue": 0.845238,
      "sort_sat": 0.56,
      "sort_val": 0.196078,
      "swatch_file_id": "gid://shopify/MediaImage/49490370724106",
      "swatch_filename": "11420_Oxblood.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Oxblood.jpg?v=1774522742",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Oxblood.jpg?v=1774522742",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11420/ProductCarouselMain/11420%20OBD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11420_Oxblood.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552295178",
      "product_title": "Native Spirit Ladies T-Shirt",
      "product_handle": "ns324",
      "product_url": "/products/ns324",
      "product_full_url": "https://oakdenemerch.com/products/ns324",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns324",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS324",
      "colour_name": "Dark Cherry",
      "colour_group": "Red > Dark Red",
      "rgb": "#3d0a39",
      "sort_bucket": "red",
      "sort_hue": 0.846405,
      "sort_sat": 0.836066,
      "sort_val": 0.239216,
      "swatch_file_id": "gid://shopify/MediaImage/49472283476234",
      "swatch_filename": "NS324_Dark_Cherry.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Dark_Cherry.jpg?v=1774354240",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Dark_Cherry.jpg?v=1774354240",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS324/ProductCarouselMain/NS324%20DCY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns324_Dark_Cherry.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687654666",
      "product_title": "Native Spirit Unisex Crew Neck Long Sleeve T-Shirt",
      "product_handle": "ns333",
      "product_url": "/products/ns333",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-ns333",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS333",
      "colour_name": "Dark Cherry",
      "colour_group": "Red > Dark Red",
      "rgb": "#3d0a39",
      "sort_bucket": "red",
      "sort_hue": 0.846405,
      "sort_sat": 0.836066,
      "sort_val": 0.239216,
      "swatch_file_id": "gid://shopify/MediaImage/49490480529674",
      "swatch_filename": "ns333_Dark_Cherry.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns333_Dark_Cherry.jpg?v=1774522952",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns333_Dark_Cherry.jpg?v=1774522952",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS333/ProductCarouselMain/NS333%20DCY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns333_Dark_Cherry.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Dark Cherry",
      "colour_group": "Red > Dark Red",
      "rgb": "#3d0a39",
      "sort_bucket": "red",
      "sort_hue": 0.846405,
      "sort_sat": 0.836066,
      "sort_val": 0.239216,
      "swatch_file_id": "gid://shopify/MediaImage/49473666842890",
      "swatch_filename": "NS305_Dark_Cherry.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Dark_Cherry.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Dark_Cherry.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20DCY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Dark_Cherry.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#560340",
      "sort_bucket": "red",
      "sort_hue": 0.87751,
      "sort_sat": 0.965116,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49474217836810",
      "swatch_filename": "JC001_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Burgundy.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Burgundy.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#560340",
      "sort_bucket": "red",
      "sort_hue": 0.87751,
      "sort_sat": 0.965116,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49474210496778",
      "swatch_filename": "JC001B_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Burgundy.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Burgundy.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#560340",
      "sort_bucket": "red",
      "sort_hue": 0.87751,
      "sort_sat": 0.965116,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49473142456586",
      "swatch_filename": "JC005_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Burgundy.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Burgundy.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#560340",
      "sort_bucket": "red",
      "sort_hue": 0.87751,
      "sort_sat": 0.965116,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49474088370442",
      "swatch_filename": "RX151_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Burgundy.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Burgundy.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#340426",
      "sort_bucket": "red",
      "sort_hue": 0.881944,
      "sort_sat": 0.923077,
      "sort_val": 0.203922,
      "swatch_file_id": "gid://shopify/MediaImage/49474468315402",
      "swatch_filename": "03582_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Burgundy.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Burgundy.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#340426",
      "sort_bucket": "red",
      "sort_hue": 0.881944,
      "sort_sat": 0.923077,
      "sort_val": 0.203922,
      "swatch_file_id": "gid://shopify/MediaImage/49474448982282",
      "swatch_filename": "11500_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Burgundy.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Burgundy.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#340426",
      "sort_bucket": "red",
      "sort_hue": 0.881944,
      "sort_sat": 0.923077,
      "sort_val": 0.203922,
      "swatch_file_id": "gid://shopify/MediaImage/49468835430666",
      "swatch_filename": "03581_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Burgundy.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Burgundy.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#340426",
      "sort_bucket": "red",
      "sort_hue": 0.881944,
      "sort_sat": 0.923077,
      "sort_val": 0.203922,
      "swatch_file_id": "gid://shopify/MediaImage/49468933341450",
      "swatch_filename": "11502_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Burgundy.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Burgundy.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#340426",
      "sort_bucket": "red",
      "sort_hue": 0.881944,
      "sort_sat": 0.923077,
      "sort_val": 0.203922,
      "swatch_file_id": "gid://shopify/MediaImage/49468833202442",
      "swatch_filename": "03579_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Burgundy.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Burgundy.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#340426",
      "sort_bucket": "red",
      "sort_hue": 0.881944,
      "sort_sat": 0.923077,
      "sort_val": 0.203922,
      "swatch_file_id": "gid://shopify/MediaImage/49468823011594",
      "swatch_filename": "01825_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Burgundy.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Burgundy.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03565",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#340426",
      "sort_bucket": "red",
      "sort_hue": 0.881944,
      "sort_sat": 0.923077,
      "sort_val": 0.203922,
      "swatch_file_id": "gid://shopify/MediaImage/49473305870602",
      "swatch_filename": "03565_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Burgundy.jpg?v=1774363313",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Burgundy.jpg?v=1774363313",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#340426",
      "sort_bucket": "red",
      "sort_hue": 0.881944,
      "sort_sat": 0.923077,
      "sort_val": 0.203922,
      "swatch_file_id": "gid://shopify/MediaImage/49473718092042",
      "swatch_filename": "11380_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Burgundy.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Burgundy.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#45002e",
      "sort_bucket": "red",
      "sort_hue": 0.888889,
      "sort_sat": 1.0,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49471442387210",
      "swatch_filename": "AT001_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Burgundy.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Burgundy.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#45002e",
      "sort_bucket": "red",
      "sort_hue": 0.888889,
      "sort_sat": 1.0,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49471429968138",
      "swatch_filename": "AT002_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Burgundy.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Burgundy.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550722314",
      "product_title": "AWDis Tri-Blend T-Shirt",
      "product_handle": "jt001",
      "product_url": "/products/jt001",
      "product_full_url": "https://oakdenemerch.com/products/jt001",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-jt001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% viscose/25% cotton.*",
      "style_code": "JT001",
      "colour_name": "Heather Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#45002e",
      "sort_bucket": "red",
      "sort_hue": 0.888889,
      "sort_sat": 1.0,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49468945301770",
      "swatch_filename": "JT001_Heather_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT001_Heather_Burgundy.jpg?v=1774314481",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT001_Heather_Burgundy.jpg?v=1774314481",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT001/ProductCarouselMain/JT001%20HBU%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt001_Heather_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Cranberry",
      "colour_group": "Red > Dark Red",
      "rgb": "#870059",
      "sort_bucket": "red",
      "sort_hue": 0.890123,
      "sort_sat": 1.0,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49471313576202",
      "swatch_filename": "SS620_Cranberry.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Cranberry.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Cranberry.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20CRA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Cranberry.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS720",
      "colour_name": "Cranberry",
      "colour_group": "Red > Dark Red",
      "rgb": "#870059",
      "sort_bucket": "red",
      "sort_hue": 0.890123,
      "sort_sat": 1.0,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49472218693898",
      "swatch_filename": "SS720_Cranberry.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Cranberry.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Cranberry.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20CRA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_Cranberry.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554457866",
      "product_title": "Fruit of the Loom Pure Cotton T-Shirt",
      "product_handle": "ss640",
      "product_url": "/products/ss640",
      "product_full_url": "https://oakdenemerch.com/products/ss640",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss640",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "SS640",
      "colour_name": "Cranberry",
      "colour_group": "Red > Dark Red",
      "rgb": "#870059",
      "sort_bucket": "red",
      "sort_hue": 0.890123,
      "sort_sat": 1.0,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49468957753610",
      "swatch_filename": "SS640_Cranberry.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Cranberry.jpg?v=1774315114",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Cranberry.jpg?v=1774315114",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS640/ProductCarouselMain/SS640%20CRA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss640_Cranberry.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#46002a",
      "sort_bucket": "red",
      "sort_hue": 0.9,
      "sort_sat": 1.0,
      "sort_val": 0.27451,
      "swatch_file_id": "gid://shopify/MediaImage/49473272971530",
      "swatch_filename": "180M_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Burgundy.jpg?v=1774363124",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Burgundy.jpg?v=1774363124",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548199178",
      "product_title": "Russell Athletic Kids Classic Ringspun T-Shirt",
      "product_handle": "180b",
      "product_url": "/products/180b",
      "product_full_url": "https://oakdenemerch.com/products/180b",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "PCBest_Seller",
        "performance-activewear",
        "sports",
        "style-180b",
        "t-shirts"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.",
      "style_code": "180B",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#46002a",
      "sort_bucket": "red",
      "sort_hue": 0.9,
      "sort_sat": 1.0,
      "sort_val": 0.27451,
      "swatch_file_id": "gid://shopify/MediaImage/49474443444490",
      "swatch_filename": "180B_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_Burgundy.jpg?v=1774371757",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_Burgundy.jpg?v=1774371757",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180B/ProductCarouselMain/180B%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180b_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Red Hot Chilli",
      "colour_group": "Red > Dark Red",
      "rgb": "#840043",
      "sort_bucket": "red",
      "sort_hue": 0.915404,
      "sort_sat": 1.0,
      "sort_val": 0.517647,
      "swatch_file_id": "gid://shopify/MediaImage/49474217476362",
      "swatch_filename": "JC001_Red_Hot_Chilli.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Red_Hot_Chilli.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Red_Hot_Chilli.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20RHC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Red_Hot_Chilli.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Maroon",
      "colour_group": "Red > Burgundy",
      "rgb": "#54092f",
      "sort_bucket": "red",
      "sort_hue": 0.915556,
      "sort_sat": 0.892857,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49473259372810",
      "swatch_filename": "CV3001_Maroon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Maroon.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Maroon.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20MAR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Maroon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Cardinal Red",
      "colour_group": "Red > Dark Red",
      "rgb": "#910043",
      "sort_bucket": "red",
      "sort_hue": 0.922989,
      "sort_sat": 1.0,
      "sort_val": 0.568627,
      "swatch_file_id": "gid://shopify/MediaImage/49471386288394",
      "swatch_filename": "GD05_Cardinal_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Cardinal_Red.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Cardinal_Red.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20CDR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Cardinal_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Cardinal Red",
      "colour_group": "Red > Dark Red",
      "rgb": "#910043",
      "sort_bucket": "red",
      "sort_hue": 0.922989,
      "sort_sat": 1.0,
      "sort_val": 0.568627,
      "swatch_file_id": "gid://shopify/MediaImage/49474267087114",
      "swatch_filename": "GD01_Cardinal_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Cardinal_Red.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Cardinal_Red.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20CDR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Cardinal_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD14",
      "colour_name": "Cardinal Red",
      "colour_group": "Red > Dark Red",
      "rgb": "#910043",
      "sort_bucket": "red",
      "sort_hue": 0.922989,
      "sort_sat": 1.0,
      "sort_val": 0.568627,
      "swatch_file_id": "gid://shopify/MediaImage/49490456281354",
      "swatch_filename": "gd14_Cardinal_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Cardinal_Red.jpg?v=1774522845",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Cardinal_Red.jpg?v=1774522845",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD14/ProductCarouselMain/GD14%20CDR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Cardinal_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Cardinal Red",
      "colour_group": "Red > Dark Red",
      "rgb": "#910043",
      "sort_bucket": "red",
      "sort_hue": 0.922989,
      "sort_sat": 1.0,
      "sort_val": 0.568627,
      "swatch_file_id": "gid://shopify/MediaImage/49471397724426",
      "swatch_filename": "GD02_Cardinal_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Cardinal_Red.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Cardinal_Red.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20CDR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Cardinal_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548690698",
      "product_title": "Bella Ladies Heavy Boxy T-Shirt",
      "product_handle": "bl6110",
      "product_url": "/products/bl6110",
      "product_full_url": "https://oakdenemerch.com/products/bl6110",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-bl6110",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "BL6110",
      "colour_name": "Maroon",
      "colour_group": "Red > Burgundy",
      "rgb": "#451028",
      "sort_bucket": "red",
      "sort_hue": 0.924528,
      "sort_sat": 0.768116,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49472881623306",
      "swatch_filename": "BL6110_Maroon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_Maroon.jpg?v=1774360125",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_Maroon.jpg?v=1774360125",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL6110/ProductCarouselMain/BL6110%20MAR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl6110_Maroon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548920074",
      "product_title": "Canvas Unisex Heavyweight Boxy T-Shirt",
      "product_handle": "cv3010",
      "product_url": "/products/cv3010",
      "product_full_url": "https://oakdenemerch.com/products/cv3010",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv3010",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3010",
      "colour_name": "Maroon",
      "colour_group": "Red > Burgundy",
      "rgb": "#451028",
      "sort_bucket": "red",
      "sort_hue": 0.924528,
      "sort_sat": 0.768116,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49472879264010",
      "swatch_filename": "CV3010_Maroon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_Maroon.jpg?v=1774360083",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_Maroon.jpg?v=1774360083",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3010/ProductCarouselMain/CV3010%20MAR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3010_Maroon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686737162",
      "product_title": "Canvas Unisex Heavyweight Long Sleeve Boxy T-Shirt",
      "product_handle": "cv3511",
      "product_url": "/products/cv3511",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv3511",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3511",
      "colour_name": "Maroon",
      "colour_group": "Red > Burgundy",
      "rgb": "#451028",
      "sort_bucket": "red",
      "sort_hue": 0.924528,
      "sort_sat": 0.768116,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49490424332554",
      "swatch_filename": "cv3511_Maroon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_Maroon.jpg?v=1774522801",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_Maroon.jpg?v=1774522801",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3511/ProductCarouselMain/CV3511%20MAR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3511_Maroon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Hibiscus Red",
      "colour_group": "Red > Red",
      "rgb": "#7f0038",
      "sort_bucket": "red",
      "sort_hue": 0.926509,
      "sort_sat": 1.0,
      "sort_val": 0.498039,
      "swatch_file_id": "gid://shopify/MediaImage/49473667203338",
      "swatch_filename": "NS305_Hibiscus_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Hibiscus_Red.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Hibiscus_Red.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20HIB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Hibiscus_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#633a4c",
      "sort_bucket": "red",
      "sort_hue": 0.926829,
      "sort_sat": 0.414141,
      "sort_val": 0.388235,
      "swatch_file_id": "gid://shopify/MediaImage/49474342912266",
      "swatch_filename": "AM10_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Burgundy.jpg?v=1774371249",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Burgundy.jpg?v=1774371249",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548395786",
      "product_title": "Anthem Unisex Organic Heavyweight T-Shirt",
      "product_handle": "am15",
      "product_url": "/products/am15",
      "product_full_url": "https://oakdenemerch.com/products/am15",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am15",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM15",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#633a4c",
      "sort_bucket": "red",
      "sort_hue": 0.926829,
      "sort_sat": 0.414141,
      "sort_val": 0.388235,
      "swatch_file_id": "gid://shopify/MediaImage/49472895746314",
      "swatch_filename": "AM15_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Burgundy.jpg?v=1774360325",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Burgundy.jpg?v=1774360325",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM15/ProductCarouselMain/AM15%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am15_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549673738",
      "product_title": "Gildan Hammer Maxweight T-Shirt",
      "product_handle": "gd201",
      "product_url": "/products/gd201",
      "product_full_url": "https://oakdenemerch.com/products/gd201",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd201",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD201",
      "colour_name": "Garnet",
      "colour_group": "Red > Dark Red",
      "rgb": "#5a0025",
      "sort_bucket": "red",
      "sort_hue": 0.931481,
      "sort_sat": 1.0,
      "sort_val": 0.352941,
      "swatch_file_id": "gid://shopify/MediaImage/49468939436298",
      "swatch_filename": "GD201_Garnet.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_Garnet.jpg?v=1774313827",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_Garnet.jpg?v=1774313827",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD201/ProductCarouselMain/GD201%20GAR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd201_Garnet.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "52% cotton/48% polyester.",
      "style_code": "SS621",
      "colour_name": "Heather Red",
      "colour_group": "Red > Heather/Effect Red",
      "rgb": "#a1003e",
      "sort_bucket": "red",
      "sort_hue": 0.935818,
      "sort_sat": 1.0,
      "sort_val": 0.631373,
      "swatch_file_id": "gid://shopify/MediaImage/49471285821706",
      "swatch_filename": "SS621_Heather_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Heather_Red.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Heather_Red.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20HRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Heather_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551017226",
      "product_title": "Kustom Kit Superwash® 60°C T-Shirt",
      "product_handle": "k504",
      "product_url": "/products/k504",
      "product_full_url": "https://oakdenemerch.com/products/k504",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k504",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton.*",
      "style_code": "K504",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#e00053",
      "sort_bucket": "red",
      "sort_hue": 0.938244,
      "sort_sat": 1.0,
      "sort_val": 0.878431,
      "swatch_file_id": "gid://shopify/MediaImage/49473127055626",
      "swatch_filename": "K504_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K504_Red.jpg?v=1774362160",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K504_Red.jpg?v=1774362160",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K504/ProductCarouselMain/K504%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k504_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Chilli",
      "colour_group": "Red > Dark Red",
      "rgb": "#5b1a32",
      "sort_bucket": "red",
      "sort_hue": 0.938462,
      "sort_sat": 0.714286,
      "sort_val": 0.356863,
      "swatch_file_id": "gid://shopify/MediaImage/49474448687370",
      "swatch_filename": "11500_Chilli.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Chilli.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Chilli.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20CHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Chilli.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49474468643082",
      "swatch_filename": "03582_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Red.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Red.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49474448785674",
      "swatch_filename": "11500_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Red.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Red.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685623050",
      "product_title": "SOL'S Imperial Long Sleeve T-Shirt",
      "product_handle": "02074",
      "product_url": "/products/02074",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-02074",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "02074",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49490366759178",
      "swatch_filename": "02074_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02074_Red.jpg?v=1774522702",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02074_Red.jpg?v=1774522702",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02074/ProductCarouselMain/02074%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02074_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546953994",
      "product_title": "SOL'S Imperial V Neck T-Shirt",
      "product_handle": "02940",
      "product_url": "/products/02940",
      "product_full_url": "https://oakdenemerch.com/products/02940",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-02940",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "02940",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49468829139210",
      "swatch_filename": "02940_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02940_Red.jpg?v=1774312050",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02940_Red.jpg?v=1774312050",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02940/ProductCarouselMain/02940%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02940_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561773834",
      "product_title": "SOL'S Justin Tank Top",
      "product_handle": "11465",
      "product_url": "/products/11465",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11465",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11465",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49513914564874",
      "swatch_filename": "11465_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11465_Red.jpg?v=1774618892",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11465_Red.jpg?v=1774618892",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11465/ProductCarouselMain/11465%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11465_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49468835299594",
      "swatch_filename": "03581_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Red.jpg?v=1774312352",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Red.jpg?v=1774312352",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49468933275914",
      "swatch_filename": "11502_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Red.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Red.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685688586",
      "product_title": "SOL'S Ladies Imperial Long Sleeve T-Shirt",
      "product_handle": "02075",
      "product_url": "/products/02075",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-02075",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "02075",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49490367250698",
      "swatch_filename": "02075_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02075_Red.jpg?v=1774522711",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02075_Red.jpg?v=1774522711",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02075/ProductCarouselMain/02075%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02075_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547052298",
      "product_title": "SOL'S Ladies Imperial V Neck T-Shirt",
      "product_handle": "02941",
      "product_url": "/products/02941",
      "product_full_url": "https://oakdenemerch.com/products/02941",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-02941",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "02941",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49471878267146",
      "swatch_filename": "02941_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02941_Red.jpg?v=1774352301",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02941_Red.jpg?v=1774352301",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02941/ProductCarouselMain/02941%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02941_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685917962",
      "product_title": "SOL'S Ladies Monarch Long Sleeve T-Shirt",
      "product_handle": "04443",
      "product_url": "/products/04443",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-04443",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.",
      "style_code": "04443",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49490370101514",
      "swatch_filename": "04443_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04443_Red.jpg?v=1774522730",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04443_Red.jpg?v=1774522730",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04443/ProductCarouselMain/04443%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04443_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548035338",
      "product_title": "SOL'S Ladies Moon V Neck T-Shirt",
      "product_handle": "11388",
      "product_url": "/products/11388",
      "product_full_url": "https://oakdenemerch.com/products/11388",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11388",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11388",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49468932489482",
      "swatch_filename": "11388_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_Red.jpg?v=1774312856",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_Red.jpg?v=1774312856",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11388/ProductCarouselMain/11388%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11388_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49468833366282",
      "swatch_filename": "03579_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Red.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Red.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49468823142666",
      "swatch_filename": "01825_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Red.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Red.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547609354",
      "product_title": "SOL'S Ladies Regent V Neck T-Shirt",
      "product_handle": "04766",
      "product_url": "/products/04766",
      "product_full_url": "https://oakdenemerch.com/products/04766",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "S",
        "style-04766",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "04766",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49472664600842",
      "swatch_filename": "04766_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04766_Red.jpg?v=1774358606",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04766_Red.jpg?v=1774358606",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04766/ProductCarouselMain/04766%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04766_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686049034",
      "product_title": "SOL'S Monarch Long Sleeve T-Shirt",
      "product_handle": "11420",
      "product_url": "/products/11420",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11420",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "11420",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49490370789642",
      "swatch_filename": "11420_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Red.jpg?v=1774522743",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Red.jpg?v=1774522743",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11420/ProductCarouselMain/11420%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11420_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03565",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49473305510154",
      "swatch_filename": "03565_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Red.jpg?v=1774363313",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Red.jpg?v=1774363313",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547871498",
      "product_title": "SOL'S Regent Fit T-Shirt",
      "product_handle": "10553",
      "product_url": "/products/10553",
      "product_full_url": "https://oakdenemerch.com/products/10553",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-10553",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "10553",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49472628916490",
      "swatch_filename": "10553_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_Red.jpg?v=1774358391",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_Red.jpg?v=1774358391",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/10553/ProductCarouselMain/10553%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "10553_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49473718255882",
      "swatch_filename": "11380_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Red.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Red.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685590282",
      "product_title": "SOL'S Sporty Long Sleeve Performance T-Shirt",
      "product_handle": "02071",
      "product_url": "/products/02071",
      "product_full_url": "https://oakdenemerch.com/products/02071",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL",
        "sports",
        "style-02071",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02071",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49490364727562",
      "swatch_filename": "02071_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02071_Red.jpg?v=1774522692",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02071_Red.jpg?v=1774522692",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02071/ProductCarouselMain/02071%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02071_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548166410",
      "product_title": "SOL'S Sporty Performance T-Shirt",
      "product_handle": "11939",
      "product_url": "/products/11939",
      "product_full_url": "https://oakdenemerch.com/products/11939",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-11939",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "11939",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49473692729610",
      "swatch_filename": "11939_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Red.jpg?v=1774364865",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Red.jpg?v=1774364865",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11939/ProductCarouselMain/11939%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11939_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561609994",
      "product_title": "SOL'S Sporty Performance Tank Top",
      "product_handle": "02073",
      "product_url": "/products/02073",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL",
        "sports",
        "style-02073",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02073",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49513909846282",
      "swatch_filename": "02073_Red_7e2063d9-dafb-4b02-b229-625350ab8655.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02073_Red_7e2063d9-dafb-4b02-b229-625350ab8655.jpg?v=1774618847",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02073_Red_7e2063d9-dafb-4b02-b229-625350ab8655.jpg?v=1774618847",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02073/ProductCarouselMain/02073%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02073_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547543818",
      "product_title": "SOL'S Unisex Explorer Recycled T-Shirt",
      "product_handle": "04461",
      "product_url": "/products/04461",
      "product_full_url": "https://oakdenemerch.com/products/04461",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04461",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "60% recycled cotton/40% recycled polyester.",
      "style_code": "04461",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49472969015562",
      "swatch_filename": "04461_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04461_Red.jpg?v=1774360548",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04461_Red.jpg?v=1774360548",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04461/ProductCarouselMain/04461%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04461_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547150602",
      "product_title": "SOL'S Unisex Sprint T-Shirt",
      "product_handle": "02995",
      "product_url": "/products/02995",
      "product_full_url": "https://oakdenemerch.com/products/02995",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-02995",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "02995",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49473768063242",
      "swatch_filename": "02995_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Red.jpg?v=1774365179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Red.jpg?v=1774365179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02995/ProductCarouselMain/02995%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02995_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547576586",
      "product_title": "SOL'S Unisex Titan T-Shirt",
      "product_handle": "04728",
      "product_url": "/products/04728",
      "product_full_url": "https://oakdenemerch.com/products/04728",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "knitwear",
        "L",
        "M",
        "S",
        "style-04728",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.",
      "style_code": "04728",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49474456813834",
      "swatch_filename": "04728_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_Red.jpg?v=1774371966",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_Red.jpg?v=1774371966",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04728/ProductCarouselMain/04728%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04728_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547478282",
      "product_title": "SOL'S Unisex Tuner T-Shirt",
      "product_handle": "04203",
      "product_url": "/products/04203",
      "product_full_url": "https://oakdenemerch.com/products/04203",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-04203",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.*",
      "style_code": "04203",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49474458878218",
      "swatch_filename": "04203_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_Red.jpg?v=1774372011",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_Red.jpg?v=1774372011",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04203/ProductCarouselMain/04203%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04203_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547937034",
      "product_title": "SOL'S Victory V Neck T-Shirt",
      "product_handle": "11150",
      "product_url": "/products/11150",
      "product_full_url": "https://oakdenemerch.com/products/11150",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11150",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11150",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49468838183178",
      "swatch_filename": "11150_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11150_Red.jpg?v=1774312556",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11150_Red.jpg?v=1774312556",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11150/ProductCarouselMain/11150%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11150_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD05",
      "colour_name": "Antique Cherry Red",
      "colour_group": "Red > Dark Red",
      "rgb": "#9d0033",
      "sort_bucket": "red",
      "sort_hue": 0.94586,
      "sort_sat": 1.0,
      "sort_val": 0.615686,
      "swatch_file_id": "gid://shopify/MediaImage/49471385239818",
      "swatch_filename": "GD05_Antique_Cherry_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Antique_Cherry_Red.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Antique_Cherry_Red.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20ACY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Antique_Cherry_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD01",
      "colour_name": "Antique Cherry Red",
      "colour_group": "Red > Dark Red",
      "rgb": "#9d0033",
      "sort_bucket": "red",
      "sort_hue": 0.94586,
      "sort_sat": 1.0,
      "sort_val": 0.615686,
      "swatch_file_id": "gid://shopify/MediaImage/49474267676938",
      "swatch_filename": "GD01_Antique_Cherry_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Antique_Cherry_Red.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Antique_Cherry_Red.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20ACY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Antique_Cherry_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548985610",
      "product_title": "Canvas Unisex Tri-Blend T-Shirt",
      "product_handle": "cv3413",
      "product_url": "/products/cv3413",
      "product_full_url": "https://oakdenemerch.com/products/cv3413",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-cv3413",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Cotton/Rayon",
      "shopify_material": "Poly/Cotton/Rayon",
      "csv_material": "50% polyester/25% airlume combed ringspun cotton/25% rayon.",
      "style_code": "CV3413",
      "colour_name": "Maroon Tri-Blend",
      "colour_group": "Red > Burgundy",
      "rgb": "#70263e",
      "sort_bucket": "red",
      "sort_hue": 0.945946,
      "sort_sat": 0.660714,
      "sort_val": 0.439216,
      "swatch_file_id": "gid://shopify/MediaImage/49472609714442",
      "swatch_filename": "CV3413_Maroon_Tri-Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_Maroon_Tri-Blend.jpg?v=1774358160",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_Maroon_Tri-Blend.jpg?v=1774358160",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3413/ProductCarouselMain/CV3413%20MAR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3413_Maroon_Tri-Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Fire Red",
      "colour_group": "Red > Red",
      "rgb": "#da0043",
      "sort_bucket": "red",
      "sort_hue": 0.948777,
      "sort_sat": 1.0,
      "sort_val": 0.854902,
      "swatch_file_id": "gid://shopify/MediaImage/49471442288906",
      "swatch_filename": "AT001_Fire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Fire_Red.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Fire_Red.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20FIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Fire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Fire Red",
      "colour_group": "Red > Red",
      "rgb": "#da0043",
      "sort_bucket": "red",
      "sort_hue": 0.948777,
      "sort_sat": 1.0,
      "sort_val": 0.854902,
      "swatch_file_id": "gid://shopify/MediaImage/49471430230282",
      "swatch_filename": "AT002_Fire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Fire_Red.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Fire_Red.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20FIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Fire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549116682",
      "product_title": "Ecologie Cascades Organic T-Shirt",
      "product_handle": "ea001",
      "product_url": "/products/ea001",
      "product_full_url": "https://oakdenemerch.com/products/ea001",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-ea001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001",
      "colour_name": "Fire Red",
      "colour_group": "Red > Red",
      "rgb": "#da0043",
      "sort_bucket": "red",
      "sort_hue": 0.948777,
      "sort_sat": 1.0,
      "sort_val": 0.854902,
      "swatch_file_id": "gid://shopify/MediaImage/49474303852810",
      "swatch_filename": "EA001_Fire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Fire_Red.jpg?v=1774371175",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Fire_Red.jpg?v=1774371175",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001/ProductCarouselMain/EA001%20FIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001_Fire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548789002",
      "product_title": "Canterbury Club Dry T-Shirt",
      "product_handle": "cn260",
      "product_url": "/products/cn260",
      "product_full_url": "https://oakdenemerch.com/products/cn260",
      "vendor": "Canterbury",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-cn260",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "CN260",
      "colour_name": "Flag Red",
      "colour_group": "Red > Red",
      "rgb": "#da0043",
      "sort_bucket": "red",
      "sort_hue": 0.948777,
      "sort_sat": 1.0,
      "sort_val": 0.854902,
      "swatch_file_id": "gid://shopify/MediaImage/49468934291722",
      "swatch_filename": "CN260_Flag_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CN260_Flag_Red.jpg?v=1774313121",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CN260_Flag_Red.jpg?v=1774313121",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Canterbury/Product%20Images/CN260/ProductCarouselMain/CN260%20FGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cn260_Flag_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549903114",
      "product_title": "Gildan Ladies Heavy Cotton™ T-Shirt",
      "product_handle": "gd95",
      "product_url": "/products/gd95",
      "product_full_url": "https://oakdenemerch.com/products/gd95",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd95",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD95",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff0047",
      "sort_bucket": "red",
      "sort_hue": 0.953595,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468944318730",
      "swatch_filename": "GD95_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD95_Red.jpg?v=1774314277",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD95_Red.jpg?v=1774314277",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD95/ProductCarouselMain/GD95%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd95_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549837578",
      "product_title": "Gildan Ladies SoftStyle® Midweight T-Shirt",
      "product_handle": "gd92",
      "product_url": "/products/gd92",
      "product_full_url": "https://oakdenemerch.com/products/gd92",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd92",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD92",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff0047",
      "sort_bucket": "red",
      "sort_hue": 0.953595,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468941992202",
      "swatch_filename": "GD92_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD92_Red.jpg?v=1774314177",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD92_Red.jpg?v=1774314177",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD92/ProductCarouselMain/GD92%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd92_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549772042",
      "product_title": "Gildan Ladies SoftStyle® T-Shirt",
      "product_handle": "gd72",
      "product_url": "/products/gd72",
      "product_full_url": "https://oakdenemerch.com/products/gd72",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd72",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD72",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff0047",
      "sort_bucket": "red",
      "sort_hue": 0.953595,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468940452106",
      "swatch_filename": "GD72_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Red.jpg?v=1774314002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Red.jpg?v=1774314002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD72/ProductCarouselMain/GD72%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd72_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff0047",
      "sort_bucket": "red",
      "sort_hue": 0.953595,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474268070154",
      "swatch_filename": "GD01_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Red.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Red.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686966538",
      "product_title": "Gildan SoftStyle® Long Sleeve T-Shirt",
      "product_handle": "gd11",
      "product_url": "/products/gd11",
      "product_full_url": "https://oakdenemerch.com/products/gd11",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd11",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD11",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff0047",
      "sort_bucket": "red",
      "sort_hue": 0.953595,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490442387722",
      "swatch_filename": "gd11_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Red.jpg?v=1774522829",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Red.jpg?v=1774522829",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD11/ProductCarouselMain/GD11%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd11_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff0047",
      "sort_bucket": "red",
      "sort_hue": 0.953595,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471368855818",
      "swatch_filename": "GD15_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Red.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Red.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561937674",
      "product_title": "Gildan SoftStyle® Tank Top",
      "product_handle": "gd12",
      "product_url": "/products/gd12",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD12",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff0047",
      "sort_bucket": "red",
      "sort_hue": 0.953595,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513919447306",
      "swatch_filename": "gd12_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd12_Red.jpg?v=1774618939",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd12_Red.jpg?v=1774618939",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD12/ProductCarouselMain/GD12%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd12_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549575434",
      "product_title": "Gildan SoftStyle® V Neck T-Shirt",
      "product_handle": "gd10",
      "product_url": "/products/gd10",
      "product_full_url": "https://oakdenemerch.com/products/gd10",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd10",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD10",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff0047",
      "sort_bucket": "red",
      "sort_hue": 0.953595,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468938944778",
      "swatch_filename": "GD10_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD10_Red.jpg?v=1774313702",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD10_Red.jpg?v=1774313702",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD10/ProductCarouselMain/GD10%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd10_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD14",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff0047",
      "sort_bucket": "red",
      "sort_hue": 0.953595,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490456346890",
      "swatch_filename": "gd14_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Red.jpg?v=1774522846",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Red.jpg?v=1774522846",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff0047",
      "sort_bucket": "red",
      "sort_hue": 0.953595,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471397232906",
      "swatch_filename": "GD02_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Red.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Red.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff0047",
      "sort_bucket": "red",
      "sort_hue": 0.953595,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474088468746",
      "swatch_filename": "RX151_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Red.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Red.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548592394",
      "product_title": "Bella Ladies Micro Rib Baby T-Shirt",
      "product_handle": "bl1010",
      "product_url": "/products/bl1010",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "M",
        "S",
        "style-bl1010",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1010",
      "colour_name": "Solid Red Blend",
      "colour_group": "Red > Dark Red",
      "rgb": "#bf0d3d",
      "sort_bucket": "red",
      "sort_hue": 0.955056,
      "sort_sat": 0.931937,
      "sort_val": 0.74902,
      "swatch_file_id": "gid://shopify/MediaImage/49491498500362",
      "swatch_filename": "bl1010_Solid_Red_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1010_Solid_Red_Blend.jpg?v=1774526814",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1010_Solid_Red_Blend.jpg?v=1774526814",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1010/ProductCarouselMain/BL1010%20SDR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1010_Solid_Red_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561839370",
      "product_title": "Bella Ladies Micro Rib Racer Tank Top",
      "product_handle": "bl1019",
      "product_url": "/products/bl1019",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-bl1019",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1019",
      "colour_name": "Solid Red Blend",
      "colour_group": "Red > Dark Red",
      "rgb": "#bf0d3d",
      "sort_bucket": "red",
      "sort_hue": 0.955056,
      "sort_sat": 0.931937,
      "sort_val": 0.74902,
      "swatch_file_id": "gid://shopify/MediaImage/49513917972746",
      "swatch_filename": "bl1019_Solid_Red_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1019_Solid_Red_Blend.jpg?v=1774618920",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1019_Solid_Red_Blend.jpg?v=1774618920",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1019/ProductCarouselMain/BL1019%20SDR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1019_Solid_Red_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561806602",
      "product_title": "Bella Ladies Micro Rib Spaghetti Strap Tank Top",
      "product_handle": "bl1012",
      "product_url": "/products/bl1012",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-bl1012",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1012",
      "colour_name": "Solid Red Blend",
      "colour_group": "Red > Dark Red",
      "rgb": "#bf0d3d",
      "sort_bucket": "red",
      "sort_hue": 0.955056,
      "sort_sat": 0.931937,
      "sort_val": 0.74902,
      "swatch_file_id": "gid://shopify/MediaImage/49513916465418",
      "swatch_filename": "bl1012_Solid_Red_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1012_Solid_Red_Blend.jpg?v=1774618908",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1012_Solid_Red_Blend.jpg?v=1774618908",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1012/ProductCarouselMain/BL1012%20SDR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1012_Solid_Red_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#e10037",
      "sort_bucket": "red",
      "sort_hue": 0.959259,
      "sort_sat": 1.0,
      "sort_val": 0.882353,
      "swatch_file_id": "gid://shopify/MediaImage/49473588461834",
      "swatch_filename": "SR287_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Red.jpg?v=1774364344",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Red.jpg?v=1774364344",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554097418",
      "product_title": "Spiro Kids Impact Performance Aircool T-Shirt",
      "product_handle": "sr287b",
      "product_url": "/products/sr287b",
      "product_full_url": "https://oakdenemerch.com/products/sr287b",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "children",
        "kids",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287b",
        "t-shirts",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287B",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#e10037",
      "sort_bucket": "red",
      "sort_hue": 0.959259,
      "sort_sat": 1.0,
      "sort_val": 0.882353,
      "swatch_file_id": "gid://shopify/MediaImage/49474059731210",
      "swatch_filename": "SR287B_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Red.jpg?v=1774368252",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Red.jpg?v=1774368252",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287B/ProductCarouselMain/SR287B%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287b_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549411594",
      "product_title": "Gildan SoftStyle® EZ T-Shirt",
      "product_handle": "gd04",
      "product_url": "/products/gd04",
      "product_full_url": "https://oakdenemerch.com/products/gd04",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd04",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "GD04",
      "colour_name": "True Red",
      "colour_group": "Red > Red",
      "rgb": "#ba1336",
      "sort_bucket": "red",
      "sort_hue": 0.96507,
      "sort_sat": 0.897849,
      "sort_val": 0.729412,
      "swatch_file_id": "gid://shopify/MediaImage/49468937339146",
      "swatch_filename": "GD04_True_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_True_Red.jpg?v=1774313523",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_True_Red.jpg?v=1774313523",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD04/ProductCarouselMain/GD04%20TRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd04_True_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ba0b2f",
      "sort_bucket": "red",
      "sort_hue": 0.965714,
      "sort_sat": 0.94086,
      "sort_val": 0.729412,
      "swatch_file_id": "gid://shopify/MediaImage/49491371458826",
      "swatch_filename": "kb3025ic_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Red.jpg?v=1774526621",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Red.jpg?v=1774526621",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551639818",
      "product_title": "Kariban Unisex 190IC Crew Neck T-Shirt",
      "product_handle": "kb3032ic",
      "product_url": "/products/kb3032ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3032ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3032IC",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ba0b2f",
      "sort_bucket": "red",
      "sort_hue": 0.965714,
      "sort_sat": 0.94086,
      "sort_val": 0.729412,
      "swatch_file_id": "gid://shopify/MediaImage/49491364643082",
      "swatch_filename": "kb3032ic_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Red.jpg?v=1774526600",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Red.jpg?v=1774526600",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3032IC/ProductCarouselMain/KB3032IC%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3032ic_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548297482",
      "product_title": "Russell Athletic Authentic Heavyweight T-Shirt",
      "product_handle": "215m",
      "product_url": "/products/215m",
      "product_full_url": "https://oakdenemerch.com/products/215m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "sports",
        "style-215m",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "215M",
      "colour_name": "Classic Red",
      "colour_group": "Red > Red",
      "rgb": "#bf0026",
      "sort_bucket": "red",
      "sort_hue": 0.966841,
      "sort_sat": 1.0,
      "sort_val": 0.74902,
      "swatch_file_id": "gid://shopify/MediaImage/49470972690698",
      "swatch_filename": "215M_Classic_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/215M_Classic_Red.jpg?v=1774347211",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/215M_Classic_Red.jpg?v=1774347211",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/215M/ProductCarouselMain/215M%20CSR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "215m_Classic_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "Classic Red",
      "colour_group": "Red > Red",
      "rgb": "#bf0026",
      "sort_bucket": "red",
      "sort_hue": 0.966841,
      "sort_sat": 1.0,
      "sort_val": 0.74902,
      "swatch_file_id": "gid://shopify/MediaImage/49473273069834",
      "swatch_filename": "180M_Classic_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Classic_Red.jpg?v=1774363125",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Classic_Red.jpg?v=1774363125",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20CSR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_Classic_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548199178",
      "product_title": "Russell Athletic Kids Classic Ringspun T-Shirt",
      "product_handle": "180b",
      "product_url": "/products/180b",
      "product_full_url": "https://oakdenemerch.com/products/180b",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "PCBest_Seller",
        "performance-activewear",
        "sports",
        "style-180b",
        "t-shirts"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.",
      "style_code": "180B",
      "colour_name": "Classic Red",
      "colour_group": "Red > Red",
      "rgb": "#bf0026",
      "sort_bucket": "red",
      "sort_hue": 0.966841,
      "sort_sat": 1.0,
      "sort_val": 0.74902,
      "swatch_file_id": "gid://shopify/MediaImage/49474443510026",
      "swatch_filename": "180B_Classic_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_Classic_Red.jpg?v=1774371757",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_Classic_Red.jpg?v=1774371757",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180B/ProductCarouselMain/180B%20CSR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180b_Classic_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548231946",
      "product_title": "Russell Athletic Ladies Authentic Classic Ringspun T-Shirt",
      "product_handle": "180f",
      "product_url": "/products/180f",
      "product_full_url": "https://oakdenemerch.com/products/180f",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-180f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180F",
      "colour_name": "Classic Red",
      "colour_group": "Red > Red",
      "rgb": "#bf0026",
      "sort_bucket": "red",
      "sort_hue": 0.966841,
      "sort_sat": 1.0,
      "sort_val": 0.74902,
      "swatch_file_id": "gid://shopify/MediaImage/49472623444234",
      "swatch_filename": "180F_Classic_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180F_Classic_Red.jpg?v=1774358324",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180F_Classic_Red.jpg?v=1774358324",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180F/ProductCarouselMain/180F%20CSR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180f_Classic_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562953482",
      "product_title": "Fruit of the Loom Athletic Vest",
      "product_handle": "ss18",
      "product_url": "/products/ss18",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "sleeveless",
        "sports",
        "style-ss18",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS18",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513937273098",
      "swatch_filename": "ss18_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss18_Red.jpg?v=1774619147",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss18_Red.jpg?v=1774619147",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS18/ProductCarouselMain/SS18%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss18_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471285395722",
      "swatch_filename": "SS621_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Red.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Red.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688047882",
      "product_title": "Fruit of the Loom Iconic 195 Long Sleeve T-Shirt",
      "product_handle": "ss624",
      "product_url": "/products/ss624",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-ss624",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS624",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490487050506",
      "swatch_filename": "ss624_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss624_Red.jpg?v=1774523031",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss624_Red.jpg?v=1774523031",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS624/ProductCarouselMain/SS624%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss624_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471313019146",
      "swatch_filename": "SS620_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Red.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Red.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554621706",
      "product_title": "Fruit of the Loom Ladies Iconic 150 T-Shirt",
      "product_handle": "ss721",
      "product_url": "/products/ss721",
      "product_full_url": "https://oakdenemerch.com/products/ss721",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss721",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS721",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472056164618",
      "swatch_filename": "SS721_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Red.jpg?v=1774353578",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Red.jpg?v=1774353578",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS721/ProductCarouselMain/SS721%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss721_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS720",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472218661130",
      "swatch_filename": "SS720_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Red.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Red.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554556170",
      "product_title": "Fruit of the Loom Lady Fit Original T-Shirt",
      "product_handle": "ss712",
      "product_url": "/products/ss712",
      "product_full_url": "https://oakdenemerch.com/products/ss712",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss712",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS712",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472223052042",
      "swatch_filename": "SS712_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS712_Red.jpg?v=1774353741",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS712_Red.jpg?v=1774353741",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS712/ProductCarouselMain/SS712%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss712_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554654474",
      "product_title": "Fruit of the Loom Lady Fit Value T-Shirt",
      "product_handle": "ss77",
      "product_url": "/products/ss77",
      "product_full_url": "https://oakdenemerch.com/products/ss77",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss77",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS77",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472026181898",
      "swatch_filename": "SS77_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Red.jpg?v=1774353471",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Red.jpg?v=1774353471",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS77/ProductCarouselMain/SS77%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss77_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687982346",
      "product_title": "Fruit of the Loom Long Sleeve Value T-Shirt",
      "product_handle": "ss21",
      "product_url": "/products/ss21",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "knitwear",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss21",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS21",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490485379338",
      "swatch_filename": "ss21_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss21_Red.jpg?v=1774523014",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss21_Red.jpg?v=1774523014",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS21/ProductCarouselMain/SS21%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss21_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471330189578",
      "swatch_filename": "SS12_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Red.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Red.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554457866",
      "product_title": "Fruit of the Loom Pure Cotton T-Shirt",
      "product_handle": "ss640",
      "product_url": "/products/ss640",
      "product_full_url": "https://oakdenemerch.com/products/ss640",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss640",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "SS640",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468957688074",
      "swatch_filename": "SS640_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Red.jpg?v=1774315114",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Red.jpg?v=1774315114",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS640/ProductCarouselMain/SS640%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss640_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554195722",
      "product_title": "Fruit of the Loom Super Premium T-Shirt",
      "product_handle": "ss10",
      "product_url": "/products/ss10",
      "product_full_url": "https://oakdenemerch.com/products/ss10",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss10",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS10",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471341527306",
      "swatch_filename": "SS10_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_Red.jpg?v=1774348796",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_Red.jpg?v=1774348796",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS10/ProductCarouselMain/SS10%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss10_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554490634",
      "product_title": "Fruit of the Loom V Neck Value T-Shirt",
      "product_handle": "ss7",
      "product_url": "/products/ss7",
      "product_full_url": "https://oakdenemerch.com/products/ss7",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss7",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS7",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471272157450",
      "swatch_filename": "SS7_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Red.jpg?v=1774348430",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Red.jpg?v=1774348430",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS7/ProductCarouselMain/SS7%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss7_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471321800970",
      "swatch_filename": "SS6_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Red.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Red.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549673738",
      "product_title": "Gildan Hammer Maxweight T-Shirt",
      "product_handle": "gd201",
      "product_url": "/products/gd201",
      "product_full_url": "https://oakdenemerch.com/products/gd201",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd201",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD201",
      "colour_name": "Cherry Red",
      "colour_group": "Red > Red",
      "rgb": "#bd0022",
      "sort_bucket": "red",
      "sort_hue": 0.970018,
      "sort_sat": 1.0,
      "sort_val": 0.741176,
      "swatch_file_id": "gid://shopify/MediaImage/49468939305226",
      "swatch_filename": "GD201_Cherry_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_Cherry_Red.jpg?v=1774313827",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_Cherry_Red.jpg?v=1774313827",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD201/ProductCarouselMain/GD201%20CHY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd201_Cherry_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561970442",
      "product_title": "Gildan Ladies SoftStyle® Tank Top",
      "product_handle": "gd77",
      "product_url": "/products/gd77",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd77",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.",
      "style_code": "GD77",
      "colour_name": "Cherry Red",
      "colour_group": "Red > Red",
      "rgb": "#bd0022",
      "sort_bucket": "red",
      "sort_hue": 0.970018,
      "sort_sat": 1.0,
      "sort_val": 0.741176,
      "swatch_file_id": "gid://shopify/MediaImage/49513920758026",
      "swatch_filename": "gd77_Cherry_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd77_Cherry_Red.jpg?v=1774618952",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd77_Cherry_Red.jpg?v=1774618952",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD77/ProductCarouselMain/GD77%20CHY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd77_Cherry_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549804810",
      "product_title": "Gildan Ladies SoftStyle® V Neck T-Shirt",
      "product_handle": "gd78",
      "product_url": "/products/gd78",
      "product_full_url": "https://oakdenemerch.com/products/gd78",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd78",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD78",
      "colour_name": "Cherry Red",
      "colour_group": "Red > Red",
      "rgb": "#bd0022",
      "sort_bucket": "red",
      "sort_hue": 0.970018,
      "sort_sat": 1.0,
      "sort_val": 0.741176,
      "swatch_file_id": "gid://shopify/MediaImage/49471832654090",
      "swatch_filename": "GD78_Cherry_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD78_Cherry_Red.jpg?v=1774351724",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD78_Cherry_Red.jpg?v=1774351724",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD78/ProductCarouselMain/GD78%20CHY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd78_Cherry_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Cherry Red",
      "colour_group": "Red > Red",
      "rgb": "#bd0022",
      "sort_bucket": "red",
      "sort_hue": 0.970018,
      "sort_sat": 1.0,
      "sort_val": 0.741176,
      "swatch_file_id": "gid://shopify/MediaImage/49474267152650",
      "swatch_filename": "GD01_Cherry_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Cherry_Red.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Cherry_Red.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20CHY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Cherry_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549575434",
      "product_title": "Gildan SoftStyle® V Neck T-Shirt",
      "product_handle": "gd10",
      "product_url": "/products/gd10",
      "product_full_url": "https://oakdenemerch.com/products/gd10",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd10",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD10",
      "colour_name": "Cherry Red",
      "colour_group": "Red > Red",
      "rgb": "#bd0022",
      "sort_bucket": "red",
      "sort_hue": 0.970018,
      "sort_sat": 1.0,
      "sort_val": 0.741176,
      "swatch_file_id": "gid://shopify/MediaImage/49468938813706",
      "swatch_filename": "GD10_Cherry_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD10_Cherry_Red.jpg?v=1774313702",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD10_Cherry_Red.jpg?v=1774313702",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD10/ProductCarouselMain/GD10%20CHY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd10_Cherry_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Cherry Red",
      "colour_group": "Red > Red",
      "rgb": "#bd0022",
      "sort_bucket": "red",
      "sort_hue": 0.970018,
      "sort_sat": 1.0,
      "sort_val": 0.741176,
      "swatch_file_id": "gid://shopify/MediaImage/49471397495050",
      "swatch_filename": "GD02_Cherry_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Cherry_Red.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Cherry_Red.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20CHY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Cherry_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552295178",
      "product_title": "Native Spirit Ladies T-Shirt",
      "product_handle": "ns324",
      "product_url": "/products/ns324",
      "product_full_url": "https://oakdenemerch.com/products/ns324",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns324",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS324",
      "colour_name": "Poppy Red",
      "colour_group": "Red > Red",
      "rgb": "#c50023",
      "sort_bucket": "red",
      "sort_hue": 0.970389,
      "sort_sat": 1.0,
      "sort_val": 0.772549,
      "swatch_file_id": "gid://shopify/MediaImage/49472283345162",
      "swatch_filename": "NS324_Poppy_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Poppy_Red.jpg?v=1774354240",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Poppy_Red.jpg?v=1774354240",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS324/ProductCarouselMain/NS324%20POP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns324_Poppy_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Poppy Red",
      "colour_group": "Red > Red",
      "rgb": "#c50023",
      "sort_bucket": "red",
      "sort_hue": 0.970389,
      "sort_sat": 1.0,
      "sort_val": 0.772549,
      "swatch_file_id": "gid://shopify/MediaImage/49473667367178",
      "swatch_filename": "NS305_Poppy_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Poppy_Red.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Poppy_Red.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20POP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Poppy_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556981002",
      "product_title": "Tee Jays CoolDry™ T-Shirt",
      "product_handle": "t7020",
      "product_url": "/products/t7020",
      "product_full_url": "https://oakdenemerch.com/products/t7020",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t7020",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7020",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c7102e",
      "sort_bucket": "red",
      "sort_hue": 0.972678,
      "sort_sat": 0.919598,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49469012148490",
      "swatch_filename": "T7020_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_Red.jpg?v=1774315920",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_Red.jpg?v=1774315920",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7020/ProductCarouselMain/T7020%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7020_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c7102e",
      "sort_bucket": "red",
      "sort_hue": 0.972678,
      "sort_sat": 0.919598,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49471257510154",
      "swatch_filename": "T520_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Red.jpg?v=1774348349",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Red.jpg?v=1774348349",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557079306",
      "product_title": "Tee Jays Ladies CoolDry™ T-Shirt",
      "product_handle": "t7021",
      "product_url": "/products/t7021",
      "product_full_url": "https://oakdenemerch.com/products/t7021",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-t7021",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7021",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c7102e",
      "sort_bucket": "red",
      "sort_hue": 0.972678,
      "sort_sat": 0.919598,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49471676219658",
      "swatch_filename": "T7021_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_Red.jpg?v=1774350799",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_Red.jpg?v=1774350799",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7021/ProductCarouselMain/T7021%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7021_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556587786",
      "product_title": "Tee Jays Ladies Interlock T-Shirt",
      "product_handle": "t580",
      "product_url": "/products/t580",
      "product_full_url": "https://oakdenemerch.com/products/t580",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t580",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T580",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c7102e",
      "sort_bucket": "red",
      "sort_hue": 0.972678,
      "sort_sat": 0.919598,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49469002350858",
      "swatch_filename": "T580_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Red.jpg?v=1774315823",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Red.jpg?v=1774315823",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T580/ProductCarouselMain/T580%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t580_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557341450",
      "product_title": "Tee Jays Sof T-Shirt",
      "product_handle": "t8000",
      "product_url": "/products/t8000",
      "product_full_url": "https://oakdenemerch.com/products/t8000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t8000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T8000",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c7102e",
      "sort_bucket": "red",
      "sort_hue": 0.972678,
      "sort_sat": 0.919598,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49471238701322",
      "swatch_filename": "T8000_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Red.jpg?v=1774348259",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Red.jpg?v=1774348259",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8000/ProductCarouselMain/T8000%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8000_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c7102e",
      "sort_bucket": "red",
      "sort_hue": 0.972678,
      "sort_sat": 0.919598,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49474052620554",
      "swatch_filename": "T1150_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Red.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Red.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687228682",
      "product_title": "AWDis Cool Long Sleeve Wicking T-Shirt",
      "product_handle": "jc002",
      "product_url": "/products/jc002",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jc002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC002",
      "colour_name": "Fire Red",
      "colour_group": "Red > Red",
      "rgb": "#eb0024",
      "sort_bucket": "red",
      "sort_hue": 0.974468,
      "sort_sat": 1.0,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49490476794122",
      "swatch_filename": "jc002_Fire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Fire_Red.jpg?v=1774522889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Fire_Red.jpg?v=1774522889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC002/ProductCarouselMain/JC002%20FIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc002_Fire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550361866",
      "product_title": "AWDis Cool Smooth T-Shirt",
      "product_handle": "jc020",
      "product_url": "/products/jc020",
      "product_full_url": "https://oakdenemerch.com/products/jc020",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-jc020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020",
      "colour_name": "Fire Red",
      "colour_group": "Red > Red",
      "rgb": "#eb0024",
      "sort_bucket": "red",
      "sort_hue": 0.974468,
      "sort_sat": 1.0,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49472871530762",
      "swatch_filename": "JC020_Fire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Fire_Red.jpg?v=1774359994",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Fire_Red.jpg?v=1774359994",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020/ProductCarouselMain/JC020%20FIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020_Fire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Fire Red",
      "colour_group": "Red > Red",
      "rgb": "#eb0024",
      "sort_bucket": "red",
      "sort_hue": 0.974468,
      "sort_sat": 1.0,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49474217738506",
      "swatch_filename": "JC001_Fire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Fire_Red.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Fire_Red.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20FIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Fire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562003210",
      "product_title": "AWDis Cool Vest",
      "product_handle": "jc007",
      "product_url": "/products/jc007",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc007",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007",
      "colour_name": "Fire Red",
      "colour_group": "Red > Red",
      "rgb": "#eb0024",
      "sort_bucket": "red",
      "sort_hue": 0.974468,
      "sort_sat": 1.0,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49513922593034",
      "swatch_filename": "jc007_Fire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Fire_Red.jpg?v=1774618965",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Fire_Red.jpg?v=1774618965",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC007/ProductCarouselMain/JC007%20FIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007_Fire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Fire Red",
      "colour_group": "Red > Red",
      "rgb": "#eb0024",
      "sort_bucket": "red",
      "sort_hue": 0.974468,
      "sort_sat": 1.0,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49474209972490",
      "swatch_filename": "JC001B_Fire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Fire_Red.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Fire_Red.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20FIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Fire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562068746",
      "product_title": "AWDis Kids Cool Vest",
      "product_handle": "jc007b",
      "product_url": "/products/jc007b",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "sleeveless",
        "style-jc007b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007B",
      "colour_name": "Fire Red",
      "colour_group": "Red > Red",
      "rgb": "#eb0024",
      "sort_bucket": "red",
      "sort_hue": 0.974468,
      "sort_sat": 1.0,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49513925247242",
      "swatch_filename": "jc007b_Fire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007b_Fire_Red.jpg?v=1774618990",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007b_Fire_Red.jpg?v=1774618990",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC007B/ProductCarouselMain/JC007B%20FIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007b_Fire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Fire Red",
      "colour_group": "Red > Red",
      "rgb": "#eb0024",
      "sort_bucket": "red",
      "sort_hue": 0.974468,
      "sort_sat": 1.0,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49473142391050",
      "swatch_filename": "JC005_Fire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Fire_Red.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Fire_Red.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20FIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Fire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562101514",
      "product_title": "AWDis Ladies Cool Vest",
      "product_handle": "jc015",
      "product_url": "/products/jc015",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc015",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC015",
      "colour_name": "Fire Red",
      "colour_group": "Red > Red",
      "rgb": "#eb0024",
      "sort_bucket": "red",
      "sort_hue": 0.974468,
      "sort_sat": 1.0,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49513927016714",
      "swatch_filename": "jc015_Fire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Fire_Red.jpg?v=1774619000",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Fire_Red.jpg?v=1774619000",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC015/ProductCarouselMain/JC015%20FIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc015_Fire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550394634",
      "product_title": "AWDis Kids Cool Smooth T-Shirt",
      "product_handle": "jc020b",
      "product_url": "/products/jc020b",
      "product_full_url": "https://oakdenemerch.com/products/jc020b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "style-jc020b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020B",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#eb0024",
      "sort_bucket": "red",
      "sort_hue": 0.974468,
      "sort_sat": 1.0,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49474192998666",
      "swatch_filename": "JC020B_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020B_Red.jpg?v=1774370151",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020B_Red.jpg?v=1774370151",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020B/ProductCarouselMain/JC020B%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020b_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548985610",
      "product_title": "Canvas Unisex Tri-Blend T-Shirt",
      "product_handle": "cv3413",
      "product_url": "/products/cv3413",
      "product_full_url": "https://oakdenemerch.com/products/cv3413",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-cv3413",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Cotton/Rayon",
      "shopify_material": "Poly/Cotton/Rayon",
      "csv_material": "50% polyester/25% airlume combed ringspun cotton/25% rayon.",
      "style_code": "CV3413",
      "colour_name": "Light Red Tri-Blend",
      "colour_group": "Red > Light Red",
      "rgb": "#e62e45",
      "sort_bucket": "red",
      "sort_hue": 0.979167,
      "sort_sat": 0.8,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49472609747210",
      "swatch_filename": "CV3413_Light_Red_Tri-Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_Light_Red_Tri-Blend.jpg?v=1774358160",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_Light_Red_Tri-Blend.jpg?v=1774358160",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3413/ProductCarouselMain/CV3413%20LRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3413_Light_Red_Tri-Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#cc3541",
      "sort_bucket": "red",
      "sort_hue": 0.986755,
      "sort_sat": 0.740196,
      "sort_val": 0.8,
      "swatch_file_id": "gid://shopify/MediaImage/49474343043338",
      "swatch_filename": "AM10_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Red.jpg?v=1774371249",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Red.jpg?v=1774371249",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548166410",
      "product_title": "SOL'S Sporty Performance T-Shirt",
      "product_handle": "11939",
      "product_url": "/products/11939",
      "product_full_url": "https://oakdenemerch.com/products/11939",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-11939",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "11939",
      "colour_name": "Neon Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff4233",
      "sort_bucket": "orange",
      "sort_hue": 0.012255,
      "sort_sat": 0.8,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473692958986",
      "swatch_filename": "11939_Neon_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Neon_Orange.jpg?v=1774364865",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Neon_Orange.jpg?v=1774364865",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11939/ProductCarouselMain/11939%20NOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11939_Neon_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561609994",
      "product_title": "SOL'S Sporty Performance Tank Top",
      "product_handle": "02073",
      "product_url": "/products/02073",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL",
        "sports",
        "style-02073",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02073",
      "colour_name": "Neon Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff4233",
      "sort_bucket": "orange",
      "sort_hue": 0.012255,
      "sort_sat": 0.8,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513910272266",
      "swatch_filename": "02073_Neon_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02073_Neon_Orange.jpg?v=1774618849",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02073_Neon_Orange.jpg?v=1774618849",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02073/ProductCarouselMain/02073%20NOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02073_Neon_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547150602",
      "product_title": "SOL'S Unisex Sprint T-Shirt",
      "product_handle": "02995",
      "product_url": "/products/02995",
      "product_full_url": "https://oakdenemerch.com/products/02995",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-02995",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "02995",
      "colour_name": "Neon Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff4233",
      "sort_bucket": "orange",
      "sort_hue": 0.012255,
      "sort_sat": 0.8,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473768292618",
      "swatch_filename": "02995_Neon_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Neon_Orange.jpg?v=1774365179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Neon_Orange.jpg?v=1774365179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02995/ProductCarouselMain/02995%20NOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02995_Neon_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff523d",
      "sort_bucket": "orange",
      "sort_hue": 0.018041,
      "sort_sat": 0.760784,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471384748298",
      "swatch_filename": "GD05_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Orange.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Orange.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff523d",
      "sort_bucket": "orange",
      "sort_hue": 0.018041,
      "sort_sat": 0.760784,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474267316490",
      "swatch_filename": "GD01_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Orange.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Orange.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff523d",
      "sort_bucket": "orange",
      "sort_hue": 0.018041,
      "sort_sat": 0.760784,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471369117962",
      "swatch_filename": "GD15_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Orange.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Orange.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD14",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff523d",
      "sort_bucket": "orange",
      "sort_hue": 0.018041,
      "sort_sat": 0.760784,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490456576266",
      "swatch_filename": "gd14_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Orange.jpg?v=1774522847",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Orange.jpg?v=1774522847",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff523d",
      "sort_bucket": "orange",
      "sort_hue": 0.018041,
      "sort_sat": 0.760784,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471397363978",
      "swatch_filename": "GD02_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Orange.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Orange.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547478282",
      "product_title": "SOL'S Unisex Tuner T-Shirt",
      "product_handle": "04203",
      "product_url": "/products/04203",
      "product_full_url": "https://oakdenemerch.com/products/04203",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-04203",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.*",
      "style_code": "04203",
      "colour_name": "Dark Orange",
      "colour_group": "Orange > Dark Orange",
      "rgb": "#ff3b1f",
      "sort_bucket": "orange",
      "sort_hue": 0.020833,
      "sort_sat": 0.878431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474458747146",
      "swatch_filename": "04203_Dark_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_Dark_Orange.jpg?v=1774372011",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_Dark_Orange.jpg?v=1774372011",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04203/ProductCarouselMain/04203%20DKO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04203_Dark_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD05",
      "colour_name": "Antique Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#cc1f04",
      "sort_bucket": "orange",
      "sort_hue": 0.0225,
      "sort_sat": 0.980392,
      "sort_val": 0.8,
      "swatch_file_id": "gid://shopify/MediaImage/49471385272586",
      "swatch_filename": "GD05_Antique_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Antique_Orange.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Antique_Orange.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20AOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Antique_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Orange",
      "colour_group": "Orange > Heather/Effect Orange",
      "rgb": "#ff5e40",
      "sort_bucket": "orange",
      "sort_hue": 0.026178,
      "sort_sat": 0.74902,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473258946826",
      "swatch_filename": "CV3001_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Orange.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Orange.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff380f",
      "sort_bucket": "orange",
      "sort_hue": 0.028472,
      "sort_sat": 0.941176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474468741386",
      "swatch_filename": "03582_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Orange.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Orange.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff380f",
      "sort_bucket": "orange",
      "sort_hue": 0.028472,
      "sort_sat": 0.941176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474449047818",
      "swatch_filename": "11500_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Orange.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Orange.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561773834",
      "product_title": "SOL'S Justin Tank Top",
      "product_handle": "11465",
      "product_url": "/products/11465",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11465",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11465",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff380f",
      "sort_bucket": "orange",
      "sort_hue": 0.028472,
      "sort_sat": 0.941176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513914630410",
      "swatch_filename": "11465_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11465_Orange.jpg?v=1774618893",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11465_Orange.jpg?v=1774618893",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11465/ProductCarouselMain/11465%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11465_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff380f",
      "sort_bucket": "orange",
      "sort_hue": 0.028472,
      "sort_sat": 0.941176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468835332362",
      "swatch_filename": "03581_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Orange.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Orange.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff380f",
      "sort_bucket": "orange",
      "sort_hue": 0.028472,
      "sort_sat": 0.941176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468933505290",
      "swatch_filename": "11502_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Orange.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Orange.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685917962",
      "product_title": "SOL'S Ladies Monarch Long Sleeve T-Shirt",
      "product_handle": "04443",
      "product_url": "/products/04443",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-04443",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.",
      "style_code": "04443",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff380f",
      "sort_bucket": "orange",
      "sort_hue": 0.028472,
      "sort_sat": 0.941176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490370134282",
      "swatch_filename": "04443_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04443_Orange.jpg?v=1774522731",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04443_Orange.jpg?v=1774522731",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04443/ProductCarouselMain/04443%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04443_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff380f",
      "sort_bucket": "orange",
      "sort_hue": 0.028472,
      "sort_sat": 0.941176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468833300746",
      "swatch_filename": "03579_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Orange.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Orange.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff380f",
      "sort_bucket": "orange",
      "sort_hue": 0.028472,
      "sort_sat": 0.941176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468823240970",
      "swatch_filename": "01825_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Orange.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Orange.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686049034",
      "product_title": "SOL'S Monarch Long Sleeve T-Shirt",
      "product_handle": "11420",
      "product_url": "/products/11420",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11420",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "11420",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff380f",
      "sort_bucket": "orange",
      "sort_hue": 0.028472,
      "sort_sat": 0.941176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490370855178",
      "swatch_filename": "11420_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Orange.jpg?v=1774522744",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Orange.jpg?v=1774522744",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11420/ProductCarouselMain/11420%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11420_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03565",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff380f",
      "sort_bucket": "orange",
      "sort_hue": 0.028472,
      "sort_sat": 0.941176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473305477386",
      "swatch_filename": "03565_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Orange.jpg?v=1774363312",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Orange.jpg?v=1774363312",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff380f",
      "sort_bucket": "orange",
      "sort_hue": 0.028472,
      "sort_sat": 0.941176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473718550794",
      "swatch_filename": "11380_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Orange.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Orange.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547576586",
      "product_title": "SOL'S Unisex Titan T-Shirt",
      "product_handle": "04728",
      "product_url": "/products/04728",
      "product_full_url": "https://oakdenemerch.com/products/04728",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "knitwear",
        "L",
        "M",
        "S",
        "style-04728",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.",
      "style_code": "04728",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff380f",
      "sort_bucket": "orange",
      "sort_hue": 0.028472,
      "sort_sat": 0.941176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474456879370",
      "swatch_filename": "04728_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_Orange.jpg?v=1774371966",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_Orange.jpg?v=1774371966",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04728/ProductCarouselMain/04728%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04728_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "T Orange",
      "colour_group": "Orange > Dark Orange",
      "rgb": "#c23c1d",
      "sort_bucket": "orange",
      "sort_hue": 0.031313,
      "sort_sat": 0.850515,
      "sort_val": 0.760784,
      "swatch_file_id": "gid://shopify/MediaImage/49471398052106",
      "swatch_filename": "GD02_T_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_T_Orange.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_T_Orange.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20TXO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_T_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Terracotta",
      "colour_group": "Orange > Dark Orange",
      "rgb": "#76200c",
      "sort_bucket": "orange",
      "sort_hue": 0.031447,
      "sort_sat": 0.898305,
      "sort_val": 0.462745,
      "swatch_file_id": "gid://shopify/MediaImage/49474448457994",
      "swatch_filename": "11500_Terracotta.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Terracotta.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Terracotta.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20TCT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Terracotta.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Apricot",
      "colour_group": "Orange > Light Orange",
      "rgb": "#ff704d",
      "sort_bucket": "orange",
      "sort_hue": 0.032772,
      "sort_sat": 0.698039,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473718583562",
      "swatch_filename": "11380_Apricot.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Apricot.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Apricot.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20APR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Apricot.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff3600",
      "sort_bucket": "orange",
      "sort_hue": 0.035294,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473588527370",
      "swatch_filename": "SR287_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Orange.jpg?v=1774364345",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Orange.jpg?v=1774364345",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546724618",
      "product_title": "Russell Athletic Heavyweight T-Shirt",
      "product_handle": "010m",
      "product_url": "/products/010m",
      "product_full_url": "https://oakdenemerch.com/products/010m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-010m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "010M",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff3b00",
      "sort_bucket": "orange",
      "sort_hue": 0.038562,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468778250506",
      "swatch_filename": "010M_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/010M_Orange.jpg?v=1774311231",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/010M_Orange.jpg?v=1774311231",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/010M/ProductCarouselMain/010M%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "010m_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688867082",
      "product_title": "Yoko Hi-Vis Long Sleeve T-Shirt",
      "product_handle": "yk012",
      "product_url": "/products/yk012",
      "product_full_url": "https://oakdenemerch.com/products/yk012",
      "vendor": "YOKO",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "hi-vis",
        "knitwear",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "safetywear-ppe",
        "style-yk012",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "YK012",
      "colour_name": "Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff4000",
      "sort_bucket": "orange",
      "sort_hue": 0.04183,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490493833482",
      "swatch_filename": "yk012_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk012_Orange.jpg?v=1774523132",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk012_Orange.jpg?v=1774523132",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/YOKO/Product%20Images/YK012/ProductCarouselMain/YK012%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "yk012_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558619402",
      "product_title": "Yoko Hi-Vis Short Sleeve T-Shirt",
      "product_handle": "yk010",
      "product_url": "/products/yk010",
      "product_full_url": "https://oakdenemerch.com/products/yk010",
      "vendor": "YOKO",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "hi-vis",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "safetywear-ppe",
        "style-yk010",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "YK010",
      "colour_name": "Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff4000",
      "sort_bucket": "orange",
      "sort_hue": 0.04183,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474046034186",
      "swatch_filename": "YK010_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/YK010_Orange.jpg?v=1774367926",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/YK010_Orange.jpg?v=1774367926",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/YOKO/Product%20Images/YK010/ProductCarouselMain/YK010%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "yk010_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561675530",
      "product_title": "SOL'S Unisex Crusader Tank Top",
      "product_handle": "03980",
      "product_url": "/products/03980",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03980",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03980",
      "colour_name": "Peach",
      "colour_group": "Orange > Light Orange",
      "rgb": "#ff8557",
      "sort_bucket": "orange",
      "sort_hue": 0.045635,
      "sort_sat": 0.658824,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513913319690",
      "swatch_filename": "03980_Peach.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03980_Peach.jpg?v=1774618876",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03980_Peach.jpg?v=1774618876",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03980/ProductCarouselMain/03980%20PCH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03980_Peach.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Peach",
      "colour_group": "Orange > Light Orange",
      "rgb": "#ff8557",
      "sort_bucket": "orange",
      "sort_hue": 0.045635,
      "sort_sat": 0.658824,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473744503050",
      "swatch_filename": "03981_Peach.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Peach.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Peach.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20PCH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Peach.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552557322",
      "product_title": "Proact Ladies Performance T-Shirt",
      "product_handle": "pa439",
      "product_url": "/products/pa439",
      "product_full_url": "https://oakdenemerch.com/products/pa439",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa439",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA439",
      "colour_name": "Fluorescent Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff4700",
      "sort_bucket": "orange",
      "sort_hue": 0.046405,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471737266442",
      "swatch_filename": "PA439_Fluorescent_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Fluorescent_Orange.jpg?v=1774351220",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Fluorescent_Orange.jpg?v=1774351220",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA439/ProductCarouselMain/PA439%20FLO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa439_Fluorescent_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552524554",
      "product_title": "Proact Performance T-Shirt",
      "product_handle": "pa438",
      "product_url": "/products/pa438",
      "product_full_url": "https://oakdenemerch.com/products/pa438",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa438",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA438",
      "colour_name": "Fluorescent Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff4700",
      "sort_bucket": "orange",
      "sort_hue": 0.046405,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471752012042",
      "swatch_filename": "PA438_Fluorescent_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Fluorescent_Orange.jpg?v=1774351290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Fluorescent_Orange.jpg?v=1774351290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA438/ProductCarouselMain/PA438%20FLO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa438_Fluorescent_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff4700",
      "sort_bucket": "orange",
      "sort_hue": 0.046405,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471313936650",
      "swatch_filename": "SS620_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Orange.jpg?v=1774348567",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Orange.jpg?v=1774348567",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554654474",
      "product_title": "Fruit of the Loom Lady Fit Value T-Shirt",
      "product_handle": "ss77",
      "product_url": "/products/ss77",
      "product_full_url": "https://oakdenemerch.com/products/ss77",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss77",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS77",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff4700",
      "sort_bucket": "orange",
      "sort_hue": 0.046405,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472025886986",
      "swatch_filename": "SS77_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Orange.jpg?v=1774353471",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Orange.jpg?v=1774353471",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS77/ProductCarouselMain/SS77%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss77_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff4700",
      "sort_bucket": "orange",
      "sort_hue": 0.046405,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471330681098",
      "swatch_filename": "SS12_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Orange.jpg?v=1774348719",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Orange.jpg?v=1774348719",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554490634",
      "product_title": "Fruit of the Loom V Neck Value T-Shirt",
      "product_handle": "ss7",
      "product_url": "/products/ss7",
      "product_full_url": "https://oakdenemerch.com/products/ss7",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss7",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS7",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff4700",
      "sort_bucket": "orange",
      "sort_hue": 0.046405,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471272026378",
      "swatch_filename": "SS7_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Orange.jpg?v=1774348430",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Orange.jpg?v=1774348430",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS7/ProductCarouselMain/SS7%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss7_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff4700",
      "sort_bucket": "orange",
      "sort_hue": 0.046405,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471321571594",
      "swatch_filename": "SS6_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Orange.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Orange.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558553866",
      "product_title": "Warrior Hi-Vis T-Shirt",
      "product_handle": "wr009",
      "product_url": "/products/wr009",
      "product_full_url": "https://oakdenemerch.com/products/wr009",
      "vendor": "Warrior",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "hi-vis",
        "L",
        "M",
        "S",
        "safetywear-ppe",
        "style-wr009",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "WR009",
      "colour_name": "Fluorescent Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#f75e16",
      "sort_bucket": "orange",
      "sort_hue": 0.053333,
      "sort_sat": 0.910931,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49473096581386",
      "swatch_filename": "WR009_Fluorescent_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/WR009_Fluorescent_Orange.jpg?v=1774361916",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/WR009_Fluorescent_Orange.jpg?v=1774361916",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Warrior/Product%20Images/WR009/ProductCarouselMain/WR009%20FLO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "wr009_Fluorescent_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD05",
      "colour_name": "Sunset",
      "colour_group": "Orange > Dark Orange",
      "rgb": "#ff5400",
      "sort_bucket": "orange",
      "sort_hue": 0.054902,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471385207050",
      "swatch_filename": "GD05_Sunset.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Sunset.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Sunset.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20SUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Sunset.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD14",
      "colour_name": "S Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff5900",
      "sort_bucket": "orange",
      "sort_hue": 0.05817,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490457231626",
      "swatch_filename": "gd14_S_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_S_Orange.jpg?v=1774522849",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_S_Orange.jpg?v=1774522849",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20SYO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_S_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD02",
      "colour_name": "S Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff5900",
      "sort_bucket": "orange",
      "sort_hue": 0.05817,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471397429514",
      "swatch_filename": "GD02_S_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_S_Orange.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_S_Orange.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20SYO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_S_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Orange Crush",
      "colour_group": "Orange > Orange",
      "rgb": "#ff6308",
      "sort_bucket": "orange",
      "sort_hue": 0.061404,
      "sort_sat": 0.968627,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474217378058",
      "swatch_filename": "JC001_Orange_Crush.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Orange_Crush.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Orange_Crush.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20OCR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Orange_Crush.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff6b12",
      "sort_bucket": "orange",
      "sort_hue": 0.062588,
      "sort_sat": 0.929412,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491371491594",
      "swatch_filename": "kb3025ic_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Orange.jpg?v=1774526622",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Orange.jpg?v=1774526622",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff701a",
      "sort_bucket": "orange",
      "sort_hue": 0.062591,
      "sort_sat": 0.898039,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474088567050",
      "swatch_filename": "RX151_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Orange.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Orange.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Orange Crush",
      "colour_group": "Orange > Orange",
      "rgb": "#ff701a",
      "sort_bucket": "orange",
      "sort_hue": 0.062591,
      "sort_sat": 0.898039,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471443009802",
      "swatch_filename": "AT001_Orange_Crush.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Orange_Crush.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Orange_Crush.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20OCR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Orange_Crush.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Orange Crush",
      "colour_group": "Orange > Orange",
      "rgb": "#ff701a",
      "sort_bucket": "orange",
      "sort_hue": 0.062591,
      "sort_sat": 0.898039,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471429804298",
      "swatch_filename": "AT002_Orange_Crush.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Orange_Crush.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Orange_Crush.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20OCR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Orange_Crush.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687228682",
      "product_title": "AWDis Cool Long Sleeve Wicking T-Shirt",
      "product_handle": "jc002",
      "product_url": "/products/jc002",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jc002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC002",
      "colour_name": "Electric Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff6600",
      "sort_bucket": "orange",
      "sort_hue": 0.066667,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490476957962",
      "swatch_filename": "jc002_Electric_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Electric_Orange.jpg?v=1774522890",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Electric_Orange.jpg?v=1774522890",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC002/ProductCarouselMain/JC002%20EOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc002_Electric_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550361866",
      "product_title": "AWDis Cool Smooth T-Shirt",
      "product_handle": "jc020",
      "product_url": "/products/jc020",
      "product_full_url": "https://oakdenemerch.com/products/jc020",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-jc020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020",
      "colour_name": "Electric Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff6600",
      "sort_bucket": "orange",
      "sort_hue": 0.066667,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472871727370",
      "swatch_filename": "JC020_Electric_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Electric_Orange.jpg?v=1774359994",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Electric_Orange.jpg?v=1774359994",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020/ProductCarouselMain/JC020%20EOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020_Electric_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Electric Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff6600",
      "sort_bucket": "orange",
      "sort_hue": 0.066667,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474218819850",
      "swatch_filename": "JC001_Electric_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Electric_Orange.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Electric_Orange.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20EOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Electric_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562003210",
      "product_title": "AWDis Cool Vest",
      "product_handle": "jc007",
      "product_url": "/products/jc007",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc007",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007",
      "colour_name": "Electric Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff6600",
      "sort_bucket": "orange",
      "sort_hue": 0.066667,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513922724106",
      "swatch_filename": "jc007_Electric_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Electric_Orange.jpg?v=1774618966",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Electric_Orange.jpg?v=1774618966",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Just%20Cool/JC007/ProductCarouselMain/JC007%20EOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007_Electric_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Electric Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff6600",
      "sort_bucket": "orange",
      "sort_hue": 0.066667,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474209808650",
      "swatch_filename": "JC001B_Electric_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Electric_Orange.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Electric_Orange.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20EOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Electric_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Electric Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff6600",
      "sort_bucket": "orange",
      "sort_hue": 0.066667,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473142259978",
      "swatch_filename": "JC005_Electric_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Electric_Orange.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Electric_Orange.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20EOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Electric_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562101514",
      "product_title": "AWDis Ladies Cool Vest",
      "product_handle": "jc015",
      "product_url": "/products/jc015",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc015",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC015",
      "colour_name": "Electric Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff6600",
      "sort_bucket": "orange",
      "sort_hue": 0.066667,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513927246090",
      "swatch_filename": "jc015_Electric_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Electric_Orange.jpg?v=1774619002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Electric_Orange.jpg?v=1774619002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC015/ProductCarouselMain/JC015%20EOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc015_Electric_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Apple Blossom",
      "colour_group": "Orange > Light Orange",
      "rgb": "#d4b094",
      "sort_bucket": "orange",
      "sort_hue": 0.072917,
      "sort_sat": 0.301887,
      "sort_val": 0.831373,
      "swatch_file_id": "gid://shopify/MediaImage/49473667006730",
      "swatch_filename": "NS305_Apple_Blossom.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Apple_Blossom.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Apple_Blossom.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20ABS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Apple_Blossom.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552819466",
      "product_title": "Regatta High Visibility Pro Contract T-Shirt",
      "product_handle": "rg554",
      "product_url": "/products/rg554",
      "product_full_url": "https://oakdenemerch.com/products/rg554",
      "vendor": "Regatta High Visibility",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-rg554",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "50% recycled polyester/50% polyester.",
      "style_code": "RG554",
      "colour_name": "Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff8000",
      "sort_bucket": "orange",
      "sort_hue": 0.08366,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49470933795082",
      "swatch_filename": "RG554_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RG554_Orange.jpg?v=1774346925",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RG554_Orange.jpg?v=1774346925",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Regatta%20High%20Visibility/Product%20Images/RG554/ProductCarouselMain/RG554%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rg554_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Hibiscus",
      "colour_group": "Orange > Orange",
      "rgb": "#e81c53",
      "sort_bucket": "orange",
      "sort_hue": 0.955065,
      "sort_sat": 0.87931,
      "sort_val": 0.909804,
      "swatch_file_id": "gid://shopify/MediaImage/49474449178890",
      "swatch_filename": "11500_Hibiscus.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Hibiscus.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Hibiscus.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20HIB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Hibiscus.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Pop Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff3d61",
      "sort_bucket": "orange",
      "sort_hue": 0.969072,
      "sort_sat": 0.760784,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474468708618",
      "swatch_filename": "03582_Pop_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Pop_Orange.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Pop_Orange.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20PORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Pop_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Pop Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff3d61",
      "sort_bucket": "orange",
      "sort_hue": 0.969072,
      "sort_sat": 0.760784,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468835528970",
      "swatch_filename": "03581_Pop_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Pop_Orange.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Pop_Orange.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20PORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Pop_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Pop Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff3d61",
      "sort_bucket": "orange",
      "sort_hue": 0.969072,
      "sort_sat": 0.760784,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473744929034",
      "swatch_filename": "03981_Pop_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Pop_Orange.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Pop_Orange.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20PORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Pop_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549116682",
      "product_title": "Ecologie Cascades Organic T-Shirt",
      "product_handle": "ea001",
      "product_url": "/products/ea001",
      "product_full_url": "https://oakdenemerch.com/products/ea001",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-ea001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001",
      "colour_name": "Soft Peach",
      "colour_group": "Orange > Light Orange",
      "rgb": "#ffa8b8",
      "sort_bucket": "orange",
      "sort_hue": 0.969349,
      "sort_sat": 0.341176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474304049418",
      "swatch_filename": "EA001_Soft_Peach.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Soft_Peach.jpg?v=1774371175",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Soft_Peach.jpg?v=1774371175",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001/ProductCarouselMain/EA001%20SPH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001_Soft_Peach.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Peach Sorbet",
      "colour_group": "Orange > Light Orange",
      "rgb": "#ff8791",
      "sort_bucket": "orange",
      "sort_hue": 0.986111,
      "sort_sat": 0.470588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474218688778",
      "swatch_filename": "JC001_Peach_Sorbet.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Peach_Sorbet.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Peach_Sorbet.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20PES%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Peach_Sorbet.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "Flo Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff404a",
      "sort_bucket": "orange",
      "sort_hue": 0.991274,
      "sort_sat": 0.74902,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473588691210",
      "swatch_filename": "SR287_Flo_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Flo_Orange.jpg?v=1774364345",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Flo_Orange.jpg?v=1774364345",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20FLO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_Flo_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554097418",
      "product_title": "Spiro Kids Impact Performance Aircool T-Shirt",
      "product_handle": "sr287b",
      "product_url": "/products/sr287b",
      "product_full_url": "https://oakdenemerch.com/products/sr287b",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "children",
        "kids",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287b",
        "t-shirts",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287B",
      "colour_name": "Flo Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff404a",
      "sort_bucket": "orange",
      "sort_hue": 0.991274,
      "sort_sat": 0.74902,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474059829514",
      "swatch_filename": "SR287B_Flo_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Flo_Orange.jpg?v=1774368252",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Flo_Orange.jpg?v=1774368252",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287B/ProductCarouselMain/SR287B%20FLO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287b_Flo_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Flame",
      "colour_group": "Orange > Orange",
      "rgb": "#ff2126",
      "sort_bucket": "orange",
      "sort_hue": 0.996246,
      "sort_sat": 0.870588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471285985546",
      "swatch_filename": "SS621_Flame.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Flame.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Flame.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20FLA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Flame.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552164106",
      "product_title": "Native Spirit Unisex French Terry T-Shirt",
      "product_handle": "ns308",
      "product_url": "/products/ns308",
      "product_full_url": "https://oakdenemerch.com/products/ns308",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns308",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "NS308",
      "colour_name": "Burnt Brick",
      "colour_group": "Orange > Dark Orange",
      "rgb": "#a12f31",
      "sort_bucket": "orange",
      "sort_hue": 0.997076,
      "sort_sat": 0.708075,
      "sort_val": 0.631373,
      "swatch_file_id": "gid://shopify/MediaImage/49472288391434",
      "swatch_filename": "NS308_Burnt_Brick.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS308_Burnt_Brick.jpg?v=1774354362",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS308_Burnt_Brick.jpg?v=1774354362",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS308/ProductCarouselMain/NS308%20BBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns308_Burnt_Brick.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Burnt Brick",
      "colour_group": "Orange > Dark Orange",
      "rgb": "#a12f31",
      "sort_bucket": "orange",
      "sort_hue": 0.997076,
      "sort_sat": 0.708075,
      "sort_val": 0.631373,
      "swatch_file_id": "gid://shopify/MediaImage/49473667170570",
      "swatch_filename": "NS305_Burnt_Brick.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Burnt_Brick.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Burnt_Brick.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20BBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Burnt_Brick.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Orange Flame",
      "colour_group": "Orange > Orange",
      "rgb": "#ff2124",
      "sort_bucket": "orange",
      "sort_hue": 0.997748,
      "sort_sat": 0.870588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474217574666",
      "swatch_filename": "JC001_Orange_Flame.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Orange_Flame.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Orange_Flame.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20ORF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Orange_Flame.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Old Gold",
      "colour_group": "Yellow > Gold",
      "rgb": "#c58d5b",
      "sort_bucket": "yellow",
      "sort_hue": 0.078616,
      "sort_sat": 0.538071,
      "sort_val": 0.772549,
      "swatch_file_id": "gid://shopify/MediaImage/49471386157322",
      "swatch_filename": "GD05_Old_Gold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Old_Gold.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Old_Gold.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20OGO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Old_Gold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Mustard",
      "colour_group": "Yellow > Dark Yellow",
      "rgb": "#c2954c",
      "sort_bucket": "yellow",
      "sort_hue": 0.103107,
      "sort_sat": 0.608247,
      "sort_val": 0.760784,
      "swatch_file_id": "gid://shopify/MediaImage/49471369019658",
      "swatch_filename": "GD15_Mustard.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Mustard.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Mustard.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20MUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Mustard.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Vegas Gold",
      "colour_group": "Yellow > Gold",
      "rgb": "#ffdea6",
      "sort_bucket": "yellow",
      "sort_hue": 0.104869,
      "sort_sat": 0.34902,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471398510858",
      "swatch_filename": "GD02_Vegas_Gold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Vegas_Gold.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Vegas_Gold.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20VGG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Vegas_Gold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Gold",
      "colour_group": "Yellow > Gold",
      "rgb": "#fcad17",
      "sort_bucket": "yellow",
      "sort_hue": 0.10917,
      "sort_sat": 0.90873,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49474468512010",
      "swatch_filename": "03582_Gold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Gold.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Gold.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20GOL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Gold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Gold",
      "colour_group": "Yellow > Gold",
      "rgb": "#fcad17",
      "sort_bucket": "yellow",
      "sort_hue": 0.10917,
      "sort_sat": 0.90873,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49468835496202",
      "swatch_filename": "03581_Gold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Gold.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Gold.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20GOL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Gold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Gold",
      "colour_group": "Yellow > Gold",
      "rgb": "#fcad17",
      "sort_bucket": "yellow",
      "sort_hue": 0.10917,
      "sort_sat": 0.90873,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49468934127882",
      "swatch_filename": "11502_Gold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Gold.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Gold.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20GOL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Gold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "Gold",
      "colour_group": "Yellow > Gold",
      "rgb": "#fcad17",
      "sort_bucket": "yellow",
      "sort_hue": 0.10917,
      "sort_sat": 0.90873,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49468833333514",
      "swatch_filename": "03579_Gold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Gold.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Gold.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20GOL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Gold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Gold",
      "colour_group": "Yellow > Gold",
      "rgb": "#fcad17",
      "sort_bucket": "yellow",
      "sort_hue": 0.10917,
      "sort_sat": 0.90873,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49468823273738",
      "swatch_filename": "01825_Gold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Gold.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Gold.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20GOL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Gold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03565",
      "colour_name": "Gold",
      "colour_group": "Yellow > Gold",
      "rgb": "#fcad17",
      "sort_bucket": "yellow",
      "sort_hue": 0.10917,
      "sort_sat": 0.90873,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49473305903370",
      "swatch_filename": "03565_Gold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Gold.jpg?v=1774363312",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Gold.jpg?v=1774363312",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20GOL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_Gold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Gold",
      "colour_group": "Yellow > Gold",
      "rgb": "#fcad17",
      "sort_bucket": "yellow",
      "sort_hue": 0.10917,
      "sort_sat": 0.90873,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49473718780170",
      "swatch_filename": "11380_Gold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Gold.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Gold.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20GOL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Gold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "Gold",
      "colour_group": "Yellow > Gold",
      "rgb": "#ffbd3d",
      "sort_bucket": "yellow",
      "sort_hue": 0.109966,
      "sort_sat": 0.760784,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473588265226",
      "swatch_filename": "SR287_Gold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Gold.jpg?v=1774364345",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Gold.jpg?v=1774364345",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20GOL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_Gold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Mustard",
      "colour_group": "Yellow > Yellow",
      "rgb": "#e69c05",
      "sort_bucket": "yellow",
      "sort_hue": 0.111852,
      "sort_sat": 0.978261,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49473259143434",
      "swatch_filename": "CV3001_Mustard.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Mustard.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Mustard.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20MUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Mustard.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Gold",
      "colour_group": "Yellow > Gold",
      "rgb": "#ffb005",
      "sort_bucket": "yellow",
      "sort_hue": 0.114,
      "sort_sat": 0.980392,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471385403658",
      "swatch_filename": "GD05_Gold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Gold.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Gold.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20GOL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Gold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Gold",
      "colour_group": "Yellow > Gold",
      "rgb": "#ffb005",
      "sort_bucket": "yellow",
      "sort_hue": 0.114,
      "sort_sat": 0.980392,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474268266762",
      "swatch_filename": "GD01_Gold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Gold.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Gold.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20GOL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Gold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD14",
      "colour_name": "Gold",
      "colour_group": "Yellow > Gold",
      "rgb": "#ffb005",
      "sort_bucket": "yellow",
      "sort_hue": 0.114,
      "sort_sat": 0.980392,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490458444042",
      "swatch_filename": "gd14_Gold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Gold.jpg?v=1774522850",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Gold.jpg?v=1774522850",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20GOL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Gold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Gold",
      "colour_group": "Yellow > Gold",
      "rgb": "#ffb005",
      "sort_bucket": "yellow",
      "sort_hue": 0.114,
      "sort_sat": 0.980392,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471398740234",
      "swatch_filename": "GD02_Gold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Gold.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Gold.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20GOL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Gold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffb81c",
      "sort_bucket": "yellow",
      "sort_hue": 0.114537,
      "sort_sat": 0.890196,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491372015882",
      "swatch_filename": "kb3025ic_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Yellow.jpg?v=1774526624",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Yellow.jpg?v=1774526624",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20YEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Sun Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#f2bf49",
      "sort_bucket": "yellow",
      "sort_hue": 0.116371,
      "sort_sat": 0.698347,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49473666875658",
      "swatch_filename": "NS305_Sun_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Sun_Yellow.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Sun_Yellow.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20SNY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Sun_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Daisy",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffd142",
      "sort_bucket": "yellow",
      "sort_hue": 0.126102,
      "sort_sat": 0.741176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471384912138",
      "swatch_filename": "GD05_Daisy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Daisy.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Daisy.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20DAI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Daisy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Daisy",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffd142",
      "sort_bucket": "yellow",
      "sort_hue": 0.126102,
      "sort_sat": 0.741176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474268168458",
      "swatch_filename": "GD01_Daisy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Daisy.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Daisy.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20DAI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Daisy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Daisy",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffd142",
      "sort_bucket": "yellow",
      "sort_hue": 0.126102,
      "sort_sat": 0.741176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471369150730",
      "swatch_filename": "GD15_Daisy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Daisy.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Daisy.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20DAI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Daisy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Daisy",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffd142",
      "sort_bucket": "yellow",
      "sort_hue": 0.126102,
      "sort_sat": 0.741176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471397527818",
      "swatch_filename": "GD02_Daisy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Daisy.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Daisy.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20DAI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Daisy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#f5d056",
      "sort_bucket": "yellow",
      "sort_hue": 0.127883,
      "sort_sat": 0.64898,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49474343207178",
      "swatch_filename": "AM10_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Yellow.jpg?v=1774371249",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Yellow.jpg?v=1774371249",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20YEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Sunflower",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffc700",
      "sort_bucket": "yellow",
      "sort_hue": 0.130065,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471285690634",
      "swatch_filename": "SS621_Sunflower.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Sunflower.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Sunflower.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20SUN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Sunflower.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Sunflower",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffc700",
      "sort_bucket": "yellow",
      "sort_hue": 0.130065,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471313871114",
      "swatch_filename": "SS620_Sunflower.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Sunflower.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Sunflower.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20SUN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Sunflower.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554621706",
      "product_title": "Fruit of the Loom Ladies Iconic 150 T-Shirt",
      "product_handle": "ss721",
      "product_url": "/products/ss721",
      "product_full_url": "https://oakdenemerch.com/products/ss721",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss721",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS721",
      "colour_name": "Sunflower",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffc700",
      "sort_bucket": "yellow",
      "sort_hue": 0.130065,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472056623370",
      "swatch_filename": "SS721_Sunflower.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Sunflower.jpg?v=1774353579",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Sunflower.jpg?v=1774353579",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS721/ProductCarouselMain/SS721%20SUN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss721_Sunflower.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS720",
      "colour_name": "Sunflower",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffc700",
      "sort_bucket": "yellow",
      "sort_hue": 0.130065,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472218890506",
      "swatch_filename": "SS720_Sunflower.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Sunflower.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Sunflower.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20SUN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_Sunflower.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554654474",
      "product_title": "Fruit of the Loom Lady Fit Value T-Shirt",
      "product_handle": "ss77",
      "product_url": "/products/ss77",
      "product_full_url": "https://oakdenemerch.com/products/ss77",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss77",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS77",
      "colour_name": "Sunflower",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffc700",
      "sort_bucket": "yellow",
      "sort_hue": 0.130065,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472026312970",
      "swatch_filename": "SS77_Sunflower.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Sunflower.jpg?v=1774353471",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Sunflower.jpg?v=1774353471",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS77/ProductCarouselMain/SS77%20SUN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss77_Sunflower.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "Sunflower",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffc700",
      "sort_bucket": "yellow",
      "sort_hue": 0.130065,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471330091274",
      "swatch_filename": "SS12_Sunflower.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Sunflower.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Sunflower.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20SUN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Sunflower.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554490634",
      "product_title": "Fruit of the Loom V Neck Value T-Shirt",
      "product_handle": "ss7",
      "product_url": "/products/ss7",
      "product_full_url": "https://oakdenemerch.com/products/ss7",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss7",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS7",
      "colour_name": "Sunflower",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffc700",
      "sort_bucket": "yellow",
      "sort_hue": 0.130065,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471272222986",
      "swatch_filename": "SS7_Sunflower.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Sunflower.jpg?v=1774348430",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Sunflower.jpg?v=1774348430",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS7/ProductCarouselMain/SS7%20SUN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss7_Sunflower.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Sunflower",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffc700",
      "sort_bucket": "yellow",
      "sort_hue": 0.130065,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471322259722",
      "swatch_filename": "SS6_Sunflower.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Sunflower.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Sunflower.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20SUN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Sunflower.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Sunshine",
      "colour_group": "Yellow > Yellow",
      "rgb": "#f2e6b3",
      "sort_bucket": "yellow",
      "sort_hue": 0.134921,
      "sort_sat": 0.260331,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49474052030730",
      "swatch_filename": "T1150_Sunshine.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Sunshine.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Sunshine.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20SUY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Sunshine.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Pineapple",
      "colour_group": "Yellow > Yellow",
      "rgb": "#f7e06b",
      "sort_bucket": "yellow",
      "sort_hue": 0.139286,
      "sort_sat": 0.566802,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49473667531018",
      "swatch_filename": "NS305_Pineapple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Pineapple.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Pineapple.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20PNP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Pineapple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Yellow Haze",
      "colour_group": "Yellow > Light Yellow",
      "rgb": "#fff5ba",
      "sort_bucket": "yellow",
      "sort_hue": 0.142512,
      "sort_sat": 0.270588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471386353930",
      "swatch_filename": "GD05_Yellow_Haze.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Yellow_Haze.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Yellow_Haze.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20YHZ%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Yellow_Haze.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffe338",
      "sort_bucket": "yellow",
      "sort_hue": 0.143216,
      "sort_sat": 0.780392,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474088894730",
      "swatch_filename": "RX151_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Yellow.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Yellow.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20YEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550361866",
      "product_title": "AWDis Cool Smooth T-Shirt",
      "product_handle": "jc020",
      "product_url": "/products/jc020",
      "product_full_url": "https://oakdenemerch.com/products/jc020",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-jc020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020",
      "colour_name": "Sun Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffe800",
      "sort_bucket": "yellow",
      "sort_hue": 0.151634,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472871661834",
      "swatch_filename": "JC020_Sun_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Sun_Yellow.jpg?v=1774359994",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Sun_Yellow.jpg?v=1774359994",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020/ProductCarouselMain/JC020%20SNY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020_Sun_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Sun Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffe800",
      "sort_bucket": "yellow",
      "sort_hue": 0.151634,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474218656010",
      "swatch_filename": "JC001_Sun_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Sun_Yellow.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Sun_Yellow.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20SNY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Sun_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562003210",
      "product_title": "AWDis Cool Vest",
      "product_handle": "jc007",
      "product_url": "/products/jc007",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc007",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007",
      "colour_name": "Sun Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffe800",
      "sort_bucket": "yellow",
      "sort_hue": 0.151634,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513923117322",
      "swatch_filename": "jc007_Sun_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Sun_Yellow.jpg?v=1774618968",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Sun_Yellow.jpg?v=1774618968",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC007/ProductCarouselMain/JC007%20SNY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007_Sun_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Sun Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffe800",
      "sort_bucket": "yellow",
      "sort_hue": 0.151634,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474210627850",
      "swatch_filename": "JC001B_Sun_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Sun_Yellow.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Sun_Yellow.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20SNY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Sun_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Sun Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffe800",
      "sort_bucket": "yellow",
      "sort_hue": 0.151634,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473142522122",
      "swatch_filename": "JC005_Sun_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Sun_Yellow.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Sun_Yellow.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20SNY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Sun_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Sun Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffe800",
      "sort_bucket": "yellow",
      "sort_hue": 0.151634,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471442583818",
      "swatch_filename": "AT001_Sun_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Sun_Yellow.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Sun_Yellow.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20SNY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Sun_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Sun Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffe800",
      "sort_bucket": "yellow",
      "sort_hue": 0.151634,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471430164746",
      "swatch_filename": "AT002_Sun_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Sun_Yellow.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Sun_Yellow.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20SNY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Sun_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Sherbet Lemon",
      "colour_group": "Yellow > Light Yellow",
      "rgb": "#fff25c",
      "sort_bucket": "yellow",
      "sort_hue": 0.153374,
      "sort_sat": 0.639216,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474217705738",
      "swatch_filename": "JC001_Sherbet_Lemon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Sherbet_Lemon.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Sherbet_Lemon.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20SHL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Sherbet_Lemon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549116682",
      "product_title": "Ecologie Cascades Organic T-Shirt",
      "product_handle": "ea001",
      "product_url": "/products/ea001",
      "product_full_url": "https://oakdenemerch.com/products/ea001",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-ea001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001",
      "colour_name": "Sun Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#fff205",
      "sort_bucket": "yellow",
      "sort_hue": 0.158,
      "sort_sat": 0.980392,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474303885578",
      "swatch_filename": "EA001_Sun_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Sun_Yellow.jpg?v=1774371175",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Sun_Yellow.jpg?v=1774371175",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001/ProductCarouselMain/EA001%20SNY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001_Sun_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Yellow",
      "colour_group": "Yellow",
      "rgb": "#fcfa75",
      "sort_bucket": "yellow",
      "sort_hue": 0.164198,
      "sort_sat": 0.535714,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49473259569418",
      "swatch_filename": "CV3001_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Yellow.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Yellow.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20YEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffff00",
      "sort_bucket": "yellow",
      "sort_hue": 0.166667,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471330124042",
      "swatch_filename": "SS12_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Yellow.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Yellow.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20YEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffff00",
      "sort_bucket": "yellow",
      "sort_hue": 0.166667,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471321637130",
      "swatch_filename": "SS6_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Yellow.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Yellow.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20YEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688867082",
      "product_title": "Yoko Hi-Vis Long Sleeve T-Shirt",
      "product_handle": "yk012",
      "product_url": "/products/yk012",
      "product_full_url": "https://oakdenemerch.com/products/yk012",
      "vendor": "YOKO",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "hi-vis",
        "knitwear",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "safetywear-ppe",
        "style-yk012",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "YK012",
      "colour_name": "Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#ffff00",
      "sort_bucket": "yellow",
      "sort_hue": 0.166667,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490493899018",
      "swatch_filename": "yk012_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk012_Yellow.jpg?v=1774523133",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk012_Yellow.jpg?v=1774523133",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/YOKO/Product%20Images/YK012/ProductCarouselMain/YK012%20YEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "yk012_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558619402",
      "product_title": "Yoko Hi-Vis Short Sleeve T-Shirt",
      "product_handle": "yk010",
      "product_url": "/products/yk010",
      "product_full_url": "https://oakdenemerch.com/products/yk010",
      "vendor": "YOKO",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "hi-vis",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "safetywear-ppe",
        "style-yk010",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "YK010",
      "colour_name": "Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#ffff00",
      "sort_bucket": "yellow",
      "sort_hue": 0.166667,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474045968650",
      "swatch_filename": "YK010_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/YK010_Yellow.jpg?v=1774367925",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/YK010_Yellow.jpg?v=1774367925",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/YOKO/Product%20Images/YK010/ProductCarouselMain/YK010%20YEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "yk010_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "Yellow",
      "colour_group": "Yellow",
      "rgb": "#ffff33",
      "sort_bucket": "yellow",
      "sort_hue": 0.166667,
      "sort_sat": 0.8,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473273299210",
      "swatch_filename": "180M_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Yellow.jpg?v=1774363125",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Yellow.jpg?v=1774363125",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20YEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548199178",
      "product_title": "Russell Athletic Kids Classic Ringspun T-Shirt",
      "product_handle": "180b",
      "product_url": "/products/180b",
      "product_full_url": "https://oakdenemerch.com/products/180b",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "PCBest_Seller",
        "performance-activewear",
        "sports",
        "style-180b",
        "t-shirts"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.",
      "style_code": "180B",
      "colour_name": "Yellow",
      "colour_group": "Yellow",
      "rgb": "#ffff33",
      "sort_bucket": "yellow",
      "sort_hue": 0.166667,
      "sort_sat": 0.8,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474443608330",
      "swatch_filename": "180B_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_Yellow.jpg?v=1774371757",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_Yellow.jpg?v=1774371757",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180B/ProductCarouselMain/180B%20YEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180b_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Cornsilk",
      "colour_group": "Yellow > Light Yellow",
      "rgb": "#ffff73",
      "sort_bucket": "yellow",
      "sort_hue": 0.166667,
      "sort_sat": 0.54902,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471386091786",
      "swatch_filename": "GD05_Cornsilk.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Cornsilk.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Cornsilk.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20CSK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Cornsilk.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Lemon",
      "colour_group": "Yellow > Yellow",
      "rgb": "#f7fa1c",
      "sort_bucket": "yellow",
      "sort_hue": 0.168919,
      "sort_sat": 0.888,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49474449572106",
      "swatch_filename": "11500_Lemon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Lemon.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Lemon.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20LEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Lemon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561773834",
      "product_title": "SOL'S Justin Tank Top",
      "product_handle": "11465",
      "product_url": "/products/11465",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11465",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11465",
      "colour_name": "Lemon",
      "colour_group": "Yellow > Yellow",
      "rgb": "#f7fa1c",
      "sort_bucket": "yellow",
      "sort_hue": 0.168919,
      "sort_sat": 0.888,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49513914728714",
      "swatch_filename": "11465_Lemon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11465_Lemon.jpg?v=1774618895",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11465_Lemon.jpg?v=1774618895",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11465/ProductCarouselMain/11465%20LEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11465_Lemon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Lemon",
      "colour_group": "Yellow > Yellow",
      "rgb": "#f7fa1c",
      "sort_bucket": "yellow",
      "sort_hue": 0.168919,
      "sort_sat": 0.888,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49468933964042",
      "swatch_filename": "11502_Lemon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Lemon.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Lemon.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20LEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Lemon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Lemon",
      "colour_group": "Yellow > Yellow",
      "rgb": "#f7fa1c",
      "sort_bucket": "yellow",
      "sort_hue": 0.168919,
      "sort_sat": 0.888,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49468822749450",
      "swatch_filename": "01825_Lemon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Lemon.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Lemon.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20LEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Lemon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Lemon",
      "colour_group": "Yellow > Yellow",
      "rgb": "#f7fa1c",
      "sort_bucket": "yellow",
      "sort_hue": 0.168919,
      "sort_sat": 0.888,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49473719468298",
      "swatch_filename": "11380_Lemon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Lemon.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Lemon.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20LEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Lemon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548166410",
      "product_title": "SOL'S Sporty Performance T-Shirt",
      "product_handle": "11939",
      "product_url": "/products/11939",
      "product_full_url": "https://oakdenemerch.com/products/11939",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-11939",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "11939",
      "colour_name": "Lemon",
      "colour_group": "Yellow > Yellow",
      "rgb": "#f7fa1c",
      "sort_bucket": "yellow",
      "sort_hue": 0.168919,
      "sort_sat": 0.888,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49473692434698",
      "swatch_filename": "11939_Lemon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Lemon.jpg?v=1774364865",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Lemon.jpg?v=1774364865",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11939/ProductCarouselMain/11939%20LEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11939_Lemon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552819466",
      "product_title": "Regatta High Visibility Pro Contract T-Shirt",
      "product_handle": "rg554",
      "product_url": "/products/rg554",
      "product_full_url": "https://oakdenemerch.com/products/rg554",
      "vendor": "Regatta High Visibility",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-rg554",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "50% recycled polyester/50% polyester.",
      "style_code": "RG554",
      "colour_name": "Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#f7ff38",
      "sort_bucket": "yellow",
      "sort_hue": 0.173367,
      "sort_sat": 0.780392,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49470933762314",
      "swatch_filename": "RG554_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RG554_Yellow.jpg?v=1774346925",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RG554_Yellow.jpg?v=1774346925",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Regatta%20High%20Visibility/Product%20Images/RG554/ProductCarouselMain/RG554%20YEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rg554_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558553866",
      "product_title": "Warrior Hi-Vis T-Shirt",
      "product_handle": "wr009",
      "product_url": "/products/wr009",
      "product_full_url": "https://oakdenemerch.com/products/wr009",
      "vendor": "Warrior",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "hi-vis",
        "L",
        "M",
        "S",
        "safetywear-ppe",
        "style-wr009",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "WR009",
      "colour_name": "Fluorescent Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#f0ff03",
      "sort_bucket": "yellow",
      "sort_hue": 0.176587,
      "sort_sat": 0.988235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473096614154",
      "swatch_filename": "WR009_Fluorescent_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/WR009_Fluorescent_Yellow.jpg?v=1774361916",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/WR009_Fluorescent_Yellow.jpg?v=1774361916",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Warrior/Product%20Images/WR009/ProductCarouselMain/WR009%20FLY%20FRONT%202.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "wr009_Fluorescent_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Pale Yellow",
      "colour_group": "Yellow > Light Yellow",
      "rgb": "#f2ff54",
      "sort_bucket": "yellow",
      "sort_hue": 0.179337,
      "sort_sat": 0.670588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473719304458",
      "swatch_filename": "11380_Pale_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Pale_Yellow.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Pale_Yellow.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20PYW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Pale_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547379978",
      "product_title": "SOL'S Boxy Oversized Organic T-Shirt",
      "product_handle": "03806",
      "product_url": "/products/03806",
      "product_full_url": "https://oakdenemerch.com/products/03806",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL",
        "style-03806",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "03806",
      "colour_name": "Light Yellow",
      "colour_group": "Yellow > Light Yellow",
      "rgb": "#f2ff7a",
      "sort_bucket": "yellow",
      "sort_hue": 0.182957,
      "sort_sat": 0.521569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471864766730",
      "swatch_filename": "03806_Light_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03806_Light_Yellow.jpg?v=1774352127",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03806_Light_Yellow.jpg?v=1774352127",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03806/ProductCarouselMain/03806%20LYL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03806_Light_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547412746",
      "product_title": "SOL'S Ladies Boxy Oversized Organic T-Shirt",
      "product_handle": "03807",
      "product_url": "/products/03807",
      "product_full_url": "https://oakdenemerch.com/products/03807",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03807",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "03807",
      "colour_name": "Light Yellow",
      "colour_group": "Yellow > Light Yellow",
      "rgb": "#f2ff7a",
      "sort_bucket": "yellow",
      "sort_hue": 0.182957,
      "sort_sat": 0.521569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474463760650",
      "swatch_filename": "03807_Light_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03807_Light_Yellow.jpg?v=1774372093",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03807_Light_Yellow.jpg?v=1774372093",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03807/ProductCarouselMain/03807%20LYL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03807_Light_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Light Yellow",
      "colour_group": "Yellow > Light Yellow",
      "rgb": "#f2ff7a",
      "sort_bucket": "yellow",
      "sort_hue": 0.182957,
      "sort_sat": 0.521569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473744994570",
      "swatch_filename": "03981_Light_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Light_Yellow.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Light_Yellow.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20LYL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Light_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "Flo Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#e6ff26",
      "sort_bucket": "yellow",
      "sort_hue": 0.185868,
      "sort_sat": 0.85098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473588363530",
      "swatch_filename": "SR287_Flo_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Flo_Yellow.jpg?v=1774364344",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Flo_Yellow.jpg?v=1774364344",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20FLY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_Flo_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554097418",
      "product_title": "Spiro Kids Impact Performance Aircool T-Shirt",
      "product_handle": "sr287b",
      "product_url": "/products/sr287b",
      "product_full_url": "https://oakdenemerch.com/products/sr287b",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "children",
        "kids",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287b",
        "t-shirts",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287B",
      "colour_name": "Flo Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#e6ff26",
      "sort_bucket": "yellow",
      "sort_hue": 0.185868,
      "sort_sat": 0.85098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474059993354",
      "swatch_filename": "SR287B_Flo_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Flo_Yellow.jpg?v=1774368252",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Flo_Yellow.jpg?v=1774368252",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287B/ProductCarouselMain/SR287B%20FLY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287b_Flo_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687294218",
      "product_title": "AWDis Cool Long Sleeve Active T-Shirt",
      "product_handle": "jc023",
      "product_url": "/products/jc023",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jc023",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "JC023",
      "colour_name": "Electric Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#cffa03",
      "sort_bucket": "yellow",
      "sort_hue": 0.195682,
      "sort_sat": 0.988,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49490478465290",
      "swatch_filename": "jc023_Electric_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc023_Electric_Yellow.jpg?v=1774522907",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc023_Electric_Yellow.jpg?v=1774522907",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC023/ProductCarouselMain/JC023%20EYL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc023_Electric_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687228682",
      "product_title": "AWDis Cool Long Sleeve Wicking T-Shirt",
      "product_handle": "jc002",
      "product_url": "/products/jc002",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jc002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC002",
      "colour_name": "Electric Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#cffa03",
      "sort_bucket": "yellow",
      "sort_hue": 0.195682,
      "sort_sat": 0.988,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49490476990730",
      "swatch_filename": "jc002_Electric_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Electric_Yellow.jpg?v=1774522891",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Electric_Yellow.jpg?v=1774522891",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC002/ProductCarouselMain/JC002%20EYL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc002_Electric_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550361866",
      "product_title": "AWDis Cool Smooth T-Shirt",
      "product_handle": "jc020",
      "product_url": "/products/jc020",
      "product_full_url": "https://oakdenemerch.com/products/jc020",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-jc020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020",
      "colour_name": "Electric Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#cffa03",
      "sort_bucket": "yellow",
      "sort_hue": 0.195682,
      "sort_sat": 0.988,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49472871629066",
      "swatch_filename": "JC020_Electric_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Electric_Yellow.jpg?v=1774359994",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Electric_Yellow.jpg?v=1774359994",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020/ProductCarouselMain/JC020%20EYL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020_Electric_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Electric Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#cffa03",
      "sort_bucket": "yellow",
      "sort_hue": 0.195682,
      "sort_sat": 0.988,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49474218623242",
      "swatch_filename": "JC001_Electric_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Electric_Yellow.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Electric_Yellow.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20EYL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Electric_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562003210",
      "product_title": "AWDis Cool Vest",
      "product_handle": "jc007",
      "product_url": "/products/jc007",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc007",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007",
      "colour_name": "Electric Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#cffa03",
      "sort_bucket": "yellow",
      "sort_hue": 0.195682,
      "sort_sat": 0.988,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49513923215626",
      "swatch_filename": "jc007_Electric_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Electric_Yellow.jpg?v=1774618969",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Electric_Yellow.jpg?v=1774618969",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC007/ProductCarouselMain/JC007%20EYL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007_Electric_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Electric Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#cffa03",
      "sort_bucket": "yellow",
      "sort_hue": 0.195682,
      "sort_sat": 0.988,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49474210660618",
      "swatch_filename": "JC001B_Electric_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Electric_Yellow.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Electric_Yellow.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20EYL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Electric_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687261450",
      "product_title": "AWDis Ladies Cool Long Sleeve T-Shirt",
      "product_handle": "jc012",
      "product_url": "/products/jc012",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-jc012",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC012",
      "colour_name": "Electric Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#cffa03",
      "sort_bucket": "yellow",
      "sort_hue": 0.195682,
      "sort_sat": 0.988,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49490477711626",
      "swatch_filename": "jc012_Electric_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc012_Electric_Yellow.jpg?v=1774522900",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc012_Electric_Yellow.jpg?v=1774522900",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC012/ProductCarouselMain/JC012%20EYL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc012_Electric_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Electric Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#cffa03",
      "sort_bucket": "yellow",
      "sort_hue": 0.195682,
      "sort_sat": 0.988,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49473142194442",
      "swatch_filename": "JC005_Electric_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Electric_Yellow.jpg?v=1774362306",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Electric_Yellow.jpg?v=1774362306",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20EYL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Electric_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562101514",
      "product_title": "AWDis Ladies Cool Vest",
      "product_handle": "jc015",
      "product_url": "/products/jc015",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc015",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC015",
      "colour_name": "Electric Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#cffa03",
      "sort_bucket": "yellow",
      "sort_hue": 0.195682,
      "sort_sat": 0.988,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49513927278858",
      "swatch_filename": "jc015_Electric_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Electric_Yellow.jpg?v=1774619003",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Electric_Yellow.jpg?v=1774619003",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC015/ProductCarouselMain/JC015%20EYL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc015_Electric_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561642762",
      "product_title": "SOL'S Ladies Sporty Performance Tank Top",
      "product_handle": "02117",
      "product_url": "/products/02117",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-02117",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02117",
      "colour_name": "Neon Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#d1ff12",
      "sort_bucket": "yellow",
      "sort_hue": 0.199015,
      "sort_sat": 0.929412,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513911484682",
      "swatch_filename": "02117_Neon_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02117_Neon_Yellow.jpg?v=1774618864",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02117_Neon_Yellow.jpg?v=1774618864",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02117/ProductCarouselMain/02117%20NYL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02117_Neon_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685590282",
      "product_title": "SOL'S Sporty Long Sleeve Performance T-Shirt",
      "product_handle": "02071",
      "product_url": "/products/02071",
      "product_full_url": "https://oakdenemerch.com/products/02071",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL",
        "sports",
        "style-02071",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02071",
      "colour_name": "Neon Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#d1ff12",
      "sort_bucket": "yellow",
      "sort_hue": 0.199015,
      "sort_sat": 0.929412,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490365055242",
      "swatch_filename": "02071_Neon_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02071_Neon_Yellow.jpg?v=1774522693",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02071_Neon_Yellow.jpg?v=1774522693",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02071/ProductCarouselMain/02071%20NYL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02071_Neon_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548166410",
      "product_title": "SOL'S Sporty Performance T-Shirt",
      "product_handle": "11939",
      "product_url": "/products/11939",
      "product_full_url": "https://oakdenemerch.com/products/11939",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-11939",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "11939",
      "colour_name": "Neon Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#d1ff12",
      "sort_bucket": "yellow",
      "sort_hue": 0.199015,
      "sort_sat": 0.929412,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473692926218",
      "swatch_filename": "11939_Neon_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Neon_Yellow.jpg?v=1774364865",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Neon_Yellow.jpg?v=1774364865",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11939/ProductCarouselMain/11939%20NYL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11939_Neon_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561609994",
      "product_title": "SOL'S Sporty Performance Tank Top",
      "product_handle": "02073",
      "product_url": "/products/02073",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL",
        "sports",
        "style-02073",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02073",
      "colour_name": "Neon Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#d1ff12",
      "sort_bucket": "yellow",
      "sort_hue": 0.199015,
      "sort_sat": 0.929412,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513910337802",
      "swatch_filename": "02073_Neon_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02073_Neon_Yellow.jpg?v=1774618850",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02073_Neon_Yellow.jpg?v=1774618850",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02073/ProductCarouselMain/02073%20NYL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02073_Neon_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547150602",
      "product_title": "SOL'S Unisex Sprint T-Shirt",
      "product_handle": "02995",
      "product_url": "/products/02995",
      "product_full_url": "https://oakdenemerch.com/products/02995",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-02995",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "02995",
      "colour_name": "Neon Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#d1ff12",
      "sort_bucket": "yellow",
      "sort_hue": 0.199015,
      "sort_sat": 0.929412,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473768161546",
      "swatch_filename": "02995_Neon_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Neon_Yellow.jpg?v=1774365179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Neon_Yellow.jpg?v=1774365179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02995/ProductCarouselMain/02995%20NYL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02995_Neon_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552557322",
      "product_title": "Proact Ladies Performance T-Shirt",
      "product_handle": "pa439",
      "product_url": "/products/pa439",
      "product_full_url": "https://oakdenemerch.com/products/pa439",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa439",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA439",
      "colour_name": "Fluorescent Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#d1ff2e",
      "sort_bucket": "yellow",
      "sort_hue": 0.203349,
      "sort_sat": 0.819608,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471737135370",
      "swatch_filename": "PA439_Fluorescent_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Fluorescent_Yellow.jpg?v=1774351220",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Fluorescent_Yellow.jpg?v=1774351220",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA439/ProductCarouselMain/PA439%20FLY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa439_Fluorescent_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552524554",
      "product_title": "Proact Performance T-Shirt",
      "product_handle": "pa438",
      "product_url": "/products/pa438",
      "product_full_url": "https://oakdenemerch.com/products/pa438",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa438",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA438",
      "colour_name": "Fluorescent Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#d1ff2e",
      "sort_bucket": "yellow",
      "sort_hue": 0.203349,
      "sort_sat": 0.819608,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471752110346",
      "swatch_filename": "PA438_Fluorescent_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Fluorescent_Yellow.jpg?v=1774351290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Fluorescent_Yellow.jpg?v=1774351290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA438/ProductCarouselMain/PA438%20FLY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa438_Fluorescent_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558193418",
      "product_title": "Tombo Medium Impact Core Bra",
      "product_handle": "tl371",
      "product_url": "/products/tl371",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-tl371",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "86% polyester/14% elastane interlock.",
      "style_code": "TL371",
      "colour_name": "Olive Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#26241a",
      "sort_bucket": "green",
      "sort_hue": 0.138889,
      "sort_sat": 0.315789,
      "sort_val": 0.14902,
      "swatch_file_id": "gid://shopify/MediaImage/49491007996170",
      "swatch_filename": "tl371_Olive_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl371_Olive_Green.jpg?v=1774525768",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl371_Olive_Green.jpg?v=1774525768",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL371/ProductCarouselMain/TL371%20OLI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl371_Olive_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548985610",
      "product_title": "Canvas Unisex Tri-Blend T-Shirt",
      "product_handle": "cv3413",
      "product_url": "/products/cv3413",
      "product_full_url": "https://oakdenemerch.com/products/cv3413",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-cv3413",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Cotton/Rayon",
      "shopify_material": "Poly/Cotton/Rayon",
      "csv_material": "50% polyester/25% airlume combed ringspun cotton/25% rayon.",
      "style_code": "CV3413",
      "colour_name": "Olive Green Tri-Blend",
      "colour_group": "Green > Olive/Military",
      "rgb": "#56543a",
      "sort_bucket": "green",
      "sort_hue": 0.154762,
      "sort_sat": 0.325581,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49472609550602",
      "swatch_filename": "CV3413_Olive_Green_Tri-Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_Olive_Green_Tri-Blend.jpg?v=1774358161",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_Olive_Green_Tri-Blend.jpg?v=1774358161",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3413/ProductCarouselMain/CV3413%20OLI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3413_Olive_Green_Tri-Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Prairie Dust",
      "colour_group": "Green > Dark Green",
      "rgb": "#56543a",
      "sort_bucket": "green",
      "sort_hue": 0.154762,
      "sort_sat": 0.325581,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49471398314250",
      "swatch_filename": "GD02_Prairie_Dust.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Prairie_Dust.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Prairie_Dust.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20PRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Prairie_Dust.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551017226",
      "product_title": "Kustom Kit Superwash® 60°C T-Shirt",
      "product_handle": "k504",
      "product_url": "/products/k504",
      "product_full_url": "https://oakdenemerch.com/products/k504",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k504",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton.*",
      "style_code": "K504",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#363605",
      "sort_bucket": "green",
      "sort_hue": 0.166667,
      "sort_sat": 0.907407,
      "sort_val": 0.211765,
      "swatch_file_id": "gid://shopify/MediaImage/49473127121162",
      "swatch_filename": "K504_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K504_Khaki.jpg?v=1774362160",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K504_Khaki.jpg?v=1774362160",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K504/ProductCarouselMain/K504%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k504_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "Combat",
      "colour_group": "Green > Dark Green",
      "rgb": "#393a1c",
      "sort_bucket": "green",
      "sort_hue": 0.172222,
      "sort_sat": 0.517241,
      "sort_val": 0.227451,
      "swatch_file_id": "gid://shopify/MediaImage/49473587347722",
      "swatch_filename": "SR287_Combat.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Combat.jpg?v=1774364344",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Combat.jpg?v=1774364344",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20CBT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_Combat.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687916810",
      "product_title": "Spiro Ladies Performance Long Sleeve T-Shirt",
      "product_handle": "sr254f",
      "product_url": "/products/sr254f",
      "product_full_url": "None",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr254f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester interlock.",
      "style_code": "SR254F",
      "colour_name": "Lime Green",
      "colour_group": "Green > Lime",
      "rgb": "#bfd600",
      "sort_bucket": "green",
      "sort_hue": 0.184579,
      "sort_sat": 1.0,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49490484723978",
      "swatch_filename": "sr254f_Lime_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr254f_Lime_Green.jpg?v=1774522998",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr254f_Lime_Green.jpg?v=1774522998",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR254F/ProductCarouselMain/SR254F%20LIM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr254f_Lime_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687949578",
      "product_title": "Spiro Performance Long Sleeve T-Shirt",
      "product_handle": "sr254m",
      "product_url": "/products/sr254m",
      "product_full_url": "None",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-sr254m",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester interlock.",
      "style_code": "SR254M",
      "colour_name": "Lime Green",
      "colour_group": "Green > Lime",
      "rgb": "#bfd600",
      "sort_bucket": "green",
      "sort_hue": 0.184579,
      "sort_sat": 1.0,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49490485018890",
      "swatch_filename": "sr254m_Lime_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr254m_Lime_Green.jpg?v=1774523005",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr254m_Lime_Green.jpg?v=1774523005",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR254M/ProductCarouselMain/SR254M%20LIM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr254m_Lime_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548428554",
      "product_title": "Anthem Amplify Heavyweight T-Shirt",
      "product_handle": "am18",
      "product_url": "/products/am18",
      "product_full_url": "https://oakdenemerch.com/products/am18",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-am18",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM18",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#393d23",
      "sort_bucket": "green",
      "sort_hue": 0.192308,
      "sort_sat": 0.42623,
      "sort_val": 0.239216,
      "swatch_file_id": "gid://shopify/MediaImage/49472892961034",
      "swatch_filename": "AM18_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_Khaki.jpg?v=1774360285",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_Khaki.jpg?v=1774360285",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM18/ProductCarouselMain/AM18%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am18_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#393d23",
      "sort_bucket": "green",
      "sort_hue": 0.192308,
      "sort_sat": 0.42623,
      "sort_val": 0.239216,
      "swatch_file_id": "gid://shopify/MediaImage/49474343141642",
      "swatch_filename": "AM10_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Khaki.jpg?v=1774371250",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Khaki.jpg?v=1774371250",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548395786",
      "product_title": "Anthem Unisex Organic Heavyweight T-Shirt",
      "product_handle": "am15",
      "product_url": "/products/am15",
      "product_full_url": "https://oakdenemerch.com/products/am15",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am15",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM15",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#393d23",
      "sort_bucket": "green",
      "sort_hue": 0.192308,
      "sort_sat": 0.42623,
      "sort_val": 0.239216,
      "swatch_file_id": "gid://shopify/MediaImage/49472895942922",
      "swatch_filename": "AM15_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Khaki.jpg?v=1774360326",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Khaki.jpg?v=1774360326",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM15/ProductCarouselMain/AM15%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am15_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556981002",
      "product_title": "Tee Jays CoolDry™ T-Shirt",
      "product_handle": "t7020",
      "product_url": "/products/t7020",
      "product_full_url": "https://oakdenemerch.com/products/t7020",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t7020",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7020",
      "colour_name": "Deep Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#484a3e",
      "sort_bucket": "green",
      "sort_hue": 0.194444,
      "sort_sat": 0.162162,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49469011886346",
      "swatch_filename": "T7020_Deep_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_Deep_Green.jpg?v=1774315920",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_Deep_Green.jpg?v=1774315920",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7020/ProductCarouselMain/T7020%20DPG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7020_Deep_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "Deep Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#484a3e",
      "sort_bucket": "green",
      "sort_hue": 0.194444,
      "sort_sat": 0.162162,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49471257346314",
      "swatch_filename": "T520_Deep_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Deep_Green.jpg?v=1774348349",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Deep_Green.jpg?v=1774348349",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20DPG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_Deep_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557079306",
      "product_title": "Tee Jays Ladies CoolDry™ T-Shirt",
      "product_handle": "t7021",
      "product_url": "/products/t7021",
      "product_full_url": "https://oakdenemerch.com/products/t7021",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-t7021",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7021",
      "colour_name": "Deep Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#484a3e",
      "sort_bucket": "green",
      "sort_hue": 0.194444,
      "sort_sat": 0.162162,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49471676252426",
      "swatch_filename": "T7021_Deep_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_Deep_Green.jpg?v=1774350799",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_Deep_Green.jpg?v=1774350799",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7021/ProductCarouselMain/T7021%20DPG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7021_Deep_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556587786",
      "product_title": "Tee Jays Ladies Interlock T-Shirt",
      "product_handle": "t580",
      "product_url": "/products/t580",
      "product_full_url": "https://oakdenemerch.com/products/t580",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t580",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T580",
      "colour_name": "Deep Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#484a3e",
      "sort_bucket": "green",
      "sort_hue": 0.194444,
      "sort_sat": 0.162162,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49469002088714",
      "swatch_filename": "T580_Deep_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Deep_Green.jpg?v=1774315822",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Deep_Green.jpg?v=1774315822",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T580/ProductCarouselMain/T580%20DPG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t580_Deep_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688736010",
      "product_title": "Tee Jays Long Sleeve CoolDry™ T-Shirt",
      "product_handle": "t7022",
      "product_url": "/products/t7022",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-t7022",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7022",
      "colour_name": "Deep Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#484a3e",
      "sort_bucket": "green",
      "sort_hue": 0.194444,
      "sort_sat": 0.162162,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49490492522762",
      "swatch_filename": "t7022_Deep_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t7022_Deep_Green.jpg?v=1774523118",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t7022_Deep_Green.jpg?v=1774523118",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7022/ProductCarouselMain/T7022%20DPG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7022_Deep_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547871498",
      "product_title": "SOL'S Regent Fit T-Shirt",
      "product_handle": "10553",
      "product_url": "/products/10553",
      "product_full_url": "https://oakdenemerch.com/products/10553",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-10553",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% cotton/40% polyester.",
      "style_code": "10553",
      "colour_name": "Heather Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#5d6637",
      "sort_bucket": "green",
      "sort_hue": 0.198582,
      "sort_sat": 0.460784,
      "sort_val": 0.4,
      "swatch_file_id": "gid://shopify/MediaImage/49472629145866",
      "swatch_filename": "10553_Heather_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_Heather_Khaki.jpg?v=1774358392",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_Heather_Khaki.jpg?v=1774358392",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/10553/ProductCarouselMain/10553%20HEK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "10553_Heather_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Citrus",
      "colour_group": "Green > Fluro/Neon Green",
      "rgb": "#c2fa0f",
      "sort_bucket": "green",
      "sort_hue": 0.206383,
      "sort_sat": 0.94,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49474218098954",
      "swatch_filename": "JC001_Citrus.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Citrus.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Citrus.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20CIT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Citrus.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Military Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#263300",
      "sort_bucket": "green",
      "sort_hue": 0.20915,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49473258979594",
      "swatch_filename": "CV3001_Military_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Military_Green.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Military_Green.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20MGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Military_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Moss",
      "colour_group": "Green > Olive/Military",
      "rgb": "#647535",
      "sort_bucket": "green",
      "sort_hue": 0.210938,
      "sort_sat": 0.547009,
      "sort_val": 0.458824,
      "swatch_file_id": "gid://shopify/MediaImage/49474052063498",
      "swatch_filename": "T1150_Moss.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Moss.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Moss.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20MOS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Moss.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/10% polyester.",
      "style_code": "GD05",
      "colour_name": "Safety Green",
      "colour_group": "Green > Fluro/Neon Green",
      "rgb": "#b8ff00",
      "sort_bucket": "green",
      "sort_hue": 0.213072,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471386059018",
      "swatch_filename": "GD05_Safety_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Safety_Green.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Safety_Green.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20SYG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Safety_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD14",
      "colour_name": "Safety Green",
      "colour_group": "Green > Fluro/Neon Green",
      "rgb": "#b8ff00",
      "sort_bucket": "green",
      "sort_hue": 0.213072,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490460246282",
      "swatch_filename": "gd14_Safety_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Safety_Green.jpg?v=1774522851",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Safety_Green.jpg?v=1774522851",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20SYG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Safety_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD02",
      "colour_name": "Safety Green",
      "colour_group": "Green > Fluro/Neon Green",
      "rgb": "#b8ff00",
      "sort_bucket": "green",
      "sort_hue": 0.213072,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471398347018",
      "swatch_filename": "GD02_Safety_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Safety_Green.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Safety_Green.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20SYG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Safety_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557341450",
      "product_title": "Tee Jays Sof T-Shirt",
      "product_handle": "t8000",
      "product_url": "/products/t8000",
      "product_full_url": "https://oakdenemerch.com/products/t8000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t8000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T8000",
      "colour_name": "Olive Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#464b3a",
      "sort_bucket": "green",
      "sort_hue": 0.215686,
      "sort_sat": 0.226667,
      "sort_val": 0.294118,
      "swatch_file_id": "gid://shopify/MediaImage/49471238635786",
      "swatch_filename": "T8000_Olive_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Olive_Green.jpg?v=1774348259",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Olive_Green.jpg?v=1774348259",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8000/ProductCarouselMain/T8000%20OLI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8000_Olive_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556981002",
      "product_title": "Tee Jays CoolDry™ T-Shirt",
      "product_handle": "t7020",
      "product_url": "/products/t7020",
      "product_full_url": "https://oakdenemerch.com/products/t7020",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t7020",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7020",
      "colour_name": "Olive Melange",
      "colour_group": "Green > Olive/Military",
      "rgb": "#464b3a",
      "sort_bucket": "green",
      "sort_hue": 0.215686,
      "sort_sat": 0.226667,
      "sort_val": 0.294118,
      "swatch_file_id": "gid://shopify/MediaImage/49469011984650",
      "swatch_filename": "T7020_Olive_Melange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_Olive_Melange.jpg?v=1774315920",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_Olive_Melange.jpg?v=1774315920",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7020/ProductCarouselMain/T7020%20OML%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7020_Olive_Melange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557079306",
      "product_title": "Tee Jays Ladies CoolDry™ T-Shirt",
      "product_handle": "t7021",
      "product_url": "/products/t7021",
      "product_full_url": "https://oakdenemerch.com/products/t7021",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-t7021",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7021",
      "colour_name": "Olive Melange",
      "colour_group": "Green > Olive/Military",
      "rgb": "#464b3a",
      "sort_bucket": "green",
      "sort_hue": 0.215686,
      "sort_sat": 0.226667,
      "sort_val": 0.294118,
      "swatch_file_id": "gid://shopify/MediaImage/49471676416266",
      "swatch_filename": "T7021_Olive_Melange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_Olive_Melange.jpg?v=1774350800",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_Olive_Melange.jpg?v=1774350800",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7021/ProductCarouselMain/T7021%20OML%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7021_Olive_Melange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "Lime Green",
      "colour_group": "Green > Lime",
      "rgb": "#8ed400",
      "sort_bucket": "green",
      "sort_hue": 0.221698,
      "sort_sat": 1.0,
      "sort_val": 0.831373,
      "swatch_file_id": "gid://shopify/MediaImage/49473588494602",
      "swatch_filename": "SR287_Lime_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Lime_Green.jpg?v=1774364345",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Lime_Green.jpg?v=1774364345",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20LIM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_Lime_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554097418",
      "product_title": "Spiro Kids Impact Performance Aircool T-Shirt",
      "product_handle": "sr287b",
      "product_url": "/products/sr287b",
      "product_full_url": "https://oakdenemerch.com/products/sr287b",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "children",
        "kids",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287b",
        "t-shirts",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287B",
      "colour_name": "Lime Green",
      "colour_group": "Green > Lime",
      "rgb": "#8ed400",
      "sort_bucket": "green",
      "sort_hue": 0.221698,
      "sort_sat": 1.0,
      "sort_val": 0.831373,
      "swatch_file_id": "gid://shopify/MediaImage/49474059698442",
      "swatch_filename": "SR287B_Lime_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Lime_Green.jpg?v=1774368252",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Lime_Green.jpg?v=1774368252",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287B/ProductCarouselMain/SR287B%20LIM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287b_Lime_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "Lime Green",
      "colour_group": "Green > Lime",
      "rgb": "#a5d65e",
      "sort_bucket": "green",
      "sort_hue": 0.234722,
      "sort_sat": 0.560748,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49491372540170",
      "swatch_filename": "kb3025ic_Lime_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Lime_Green.jpg?v=1774526626",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Lime_Green.jpg?v=1774526626",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20LIM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Lime_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552557322",
      "product_title": "Proact Ladies Performance T-Shirt",
      "product_handle": "pa439",
      "product_url": "/products/pa439",
      "product_full_url": "https://oakdenemerch.com/products/pa439",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa439",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA439",
      "colour_name": "Lime Green",
      "colour_group": "Green > Lime",
      "rgb": "#a5d65e",
      "sort_bucket": "green",
      "sort_hue": 0.234722,
      "sort_sat": 0.560748,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49471737004298",
      "swatch_filename": "PA439_Lime_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Lime_Green.jpg?v=1774351220",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Lime_Green.jpg?v=1774351220",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA439/ProductCarouselMain/PA439%20LIM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa439_Lime_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552524554",
      "product_title": "Proact Performance T-Shirt",
      "product_handle": "pa438",
      "product_url": "/products/pa438",
      "product_full_url": "https://oakdenemerch.com/products/pa438",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa438",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA438",
      "colour_name": "Lime Green",
      "colour_group": "Green > Lime",
      "rgb": "#a5d65e",
      "sort_bucket": "green",
      "sort_hue": 0.234722,
      "sort_sat": 0.560748,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49471751848202",
      "swatch_filename": "PA438_Lime_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Lime_Green.jpg?v=1774351290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Lime_Green.jpg?v=1774351290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA438/ProductCarouselMain/PA438%20LIM%20FRONT%20HERO.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa438_Lime_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Apple Green",
      "colour_group": "Green > Light Green",
      "rgb": "#a1fc42",
      "sort_bucket": "green",
      "sort_hue": 0.248208,
      "sort_sat": 0.738095,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49474468446474",
      "swatch_filename": "03582_Apple_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Apple_Green.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Apple_Green.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20APL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Apple_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Apple Green",
      "colour_group": "Green > Light Green",
      "rgb": "#a1fc42",
      "sort_bucket": "green",
      "sort_hue": 0.248208,
      "sort_sat": 0.738095,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49474449342730",
      "swatch_filename": "11500_Apple_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Apple_Green.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Apple_Green.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20APL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Apple_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Apple Green",
      "colour_group": "Green > Light Green",
      "rgb": "#a1fc42",
      "sort_bucket": "green",
      "sort_hue": 0.248208,
      "sort_sat": 0.738095,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49468835594506",
      "swatch_filename": "03581_Apple_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Apple_Green.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Apple_Green.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20APL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Apple_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Apple Green",
      "colour_group": "Green > Light Green",
      "rgb": "#a1fc42",
      "sort_bucket": "green",
      "sort_hue": 0.248208,
      "sort_sat": 0.738095,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49468934226186",
      "swatch_filename": "11502_Apple_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Apple_Green.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Apple_Green.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20APL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Apple_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Apple Green",
      "colour_group": "Green > Light Green",
      "rgb": "#a1fc42",
      "sort_bucket": "green",
      "sort_hue": 0.248208,
      "sort_sat": 0.738095,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49473719337226",
      "swatch_filename": "11380_Apple_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Apple_Green.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Apple_Green.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20APL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Apple_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548166410",
      "product_title": "SOL'S Sporty Performance T-Shirt",
      "product_handle": "11939",
      "product_url": "/products/11939",
      "product_full_url": "https://oakdenemerch.com/products/11939",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-11939",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "11939",
      "colour_name": "Apple Green",
      "colour_group": "Green > Light Green",
      "rgb": "#a1fc42",
      "sort_bucket": "green",
      "sort_hue": 0.248208,
      "sort_sat": 0.738095,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49473692795146",
      "swatch_filename": "11939_Apple_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Apple_Green.jpg?v=1774364865",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Apple_Green.jpg?v=1774364865",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11939/ProductCarouselMain/11939%20APL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11939_Apple_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547150602",
      "product_title": "SOL'S Unisex Sprint T-Shirt",
      "product_handle": "02995",
      "product_url": "/products/02995",
      "product_full_url": "https://oakdenemerch.com/products/02995",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-02995",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "02995",
      "colour_name": "Apple Green",
      "colour_group": "Green > Light Green",
      "rgb": "#a1fc42",
      "sort_bucket": "green",
      "sort_hue": 0.248208,
      "sort_sat": 0.738095,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49473768259850",
      "swatch_filename": "02995_Apple_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Apple_Green.jpg?v=1774365179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Apple_Green.jpg?v=1774365179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02995/ProductCarouselMain/02995%20APL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02995_Apple_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Kiwi",
      "colour_group": "Green > Light Green",
      "rgb": "#79d527",
      "sort_bucket": "green",
      "sort_hue": 0.254789,
      "sort_sat": 0.816901,
      "sort_val": 0.835294,
      "swatch_file_id": "gid://shopify/MediaImage/49471384813834",
      "swatch_filename": "GD05_Kiwi.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Kiwi.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Kiwi.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20KIW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Kiwi.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Kiwi",
      "colour_group": "Green > Light Green",
      "rgb": "#79d527",
      "sort_bucket": "green",
      "sort_hue": 0.254789,
      "sort_sat": 0.816901,
      "sort_val": 0.835294,
      "swatch_file_id": "gid://shopify/MediaImage/49474267742474",
      "swatch_filename": "GD01_Kiwi.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Kiwi.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Kiwi.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20KIW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Kiwi.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Lime Green",
      "colour_group": "Green > Lime",
      "rgb": "#75ff00",
      "sort_bucket": "green",
      "sort_hue": 0.256863,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474218852618",
      "swatch_filename": "JC001_Lime_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Lime_Green.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Lime_Green.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20LIM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Lime_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Dark Khaki",
      "colour_group": "Green > Dark Green",
      "rgb": "#345a15",
      "sort_bucket": "green",
      "sort_hue": 0.258454,
      "sort_sat": 0.766667,
      "sort_val": 0.352941,
      "swatch_file_id": "gid://shopify/MediaImage/49474449506570",
      "swatch_filename": "11500_Dark_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Dark_Khaki.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Dark_Khaki.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20DKH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Dark_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "Lime Green",
      "colour_group": "Green > Lime",
      "rgb": "#6eff00",
      "sort_bucket": "green",
      "sort_hue": 0.261438,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471330484490",
      "swatch_filename": "SS12_Lime_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Lime_Green.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Lime_Green.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20LIM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Lime_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Lime Green",
      "colour_group": "Green > Lime",
      "rgb": "#6eff00",
      "sort_bucket": "green",
      "sort_hue": 0.261438,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471322423562",
      "swatch_filename": "SS6_Lime_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Lime_Green.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Lime_Green.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20LIM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Lime_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Khaki",
      "colour_group": "Green > Dark Green",
      "rgb": "#37422f",
      "sort_bucket": "green",
      "sort_hue": 0.263158,
      "sort_sat": 0.287879,
      "sort_val": 0.258824,
      "swatch_file_id": "gid://shopify/MediaImage/49474088796426",
      "swatch_filename": "RX151_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Khaki.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Khaki.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Green Sage",
      "colour_group": "Green > Light Green",
      "rgb": "#bbdea2",
      "sort_bucket": "green",
      "sort_hue": 0.263889,
      "sort_sat": 0.27027,
      "sort_val": 0.870588,
      "swatch_file_id": "gid://shopify/MediaImage/49474449441034",
      "swatch_filename": "11500_Green_Sage.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Green_Sage.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Green_Sage.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20GSA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Green_Sage.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Green Sage",
      "colour_group": "Green > Light Green",
      "rgb": "#bbdea2",
      "sort_bucket": "green",
      "sort_hue": 0.263889,
      "sort_sat": 0.27027,
      "sort_val": 0.870588,
      "swatch_file_id": "gid://shopify/MediaImage/49473719075082",
      "swatch_filename": "11380_Green_Sage.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Green_Sage.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Green_Sage.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20GSA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Green_Sage.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549772042",
      "product_title": "Gildan Ladies SoftStyle® T-Shirt",
      "product_handle": "gd72",
      "product_url": "/products/gd72",
      "product_full_url": "https://oakdenemerch.com/products/gd72",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd72",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD72",
      "colour_name": "Pistachio",
      "colour_group": "Green > Light Green",
      "rgb": "#a6fa6b",
      "sort_bucket": "green",
      "sort_hue": 0.264569,
      "sort_sat": 0.572,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49468940550410",
      "swatch_filename": "GD72_Pistachio.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Pistachio.jpg?v=1774314002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Pistachio.jpg?v=1774314002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD72/ProductCarouselMain/GD72%20PST%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd72_Pistachio.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Pistachio",
      "colour_group": "Green > Light Green",
      "rgb": "#a6fa6b",
      "sort_bucket": "green",
      "sort_hue": 0.264569,
      "sort_sat": 0.572,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49474266890506",
      "swatch_filename": "GD01_Pistachio.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Pistachio.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Pistachio.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20PST%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Pistachio.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Pistachio",
      "colour_group": "Green > Light Green",
      "rgb": "#a6fa6b",
      "sort_bucket": "green",
      "sort_hue": 0.264569,
      "sort_sat": 0.572,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49471397822730",
      "swatch_filename": "GD02_Pistachio.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Pistachio.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Pistachio.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20PST%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Pistachio.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Combat Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#1a2711",
      "sort_bucket": "green",
      "sort_hue": 0.265152,
      "sort_sat": 0.564103,
      "sort_val": 0.152941,
      "swatch_file_id": "gid://shopify/MediaImage/49474218295562",
      "swatch_filename": "JC001_Combat_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Combat_Green.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Combat_Green.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20CBG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Combat_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687228682",
      "product_title": "AWDis Cool Long Sleeve Wicking T-Shirt",
      "product_handle": "jc002",
      "product_url": "/products/jc002",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jc002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC002",
      "colour_name": "Electric Green",
      "colour_group": "Green > Fluro/Neon Green",
      "rgb": "#7dff26",
      "sort_bucket": "green",
      "sort_hue": 0.266513,
      "sort_sat": 0.85098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490477023498",
      "swatch_filename": "jc002_Electric_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Electric_Green.jpg?v=1774522891",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Electric_Green.jpg?v=1774522891",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC002/ProductCarouselMain/JC002%20ELG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc002_Electric_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550361866",
      "product_title": "AWDis Cool Smooth T-Shirt",
      "product_handle": "jc020",
      "product_url": "/products/jc020",
      "product_full_url": "https://oakdenemerch.com/products/jc020",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-jc020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020",
      "colour_name": "Electric Green",
      "colour_group": "Green > Fluro/Neon Green",
      "rgb": "#7dff26",
      "sort_bucket": "green",
      "sort_hue": 0.266513,
      "sort_sat": 0.85098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472871465226",
      "swatch_filename": "JC020_Electric_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Electric_Green.jpg?v=1774359994",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Electric_Green.jpg?v=1774359994",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020/ProductCarouselMain/JC020%20ELG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020_Electric_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Electric Green",
      "colour_group": "Green > Fluro/Neon Green",
      "rgb": "#7dff26",
      "sort_bucket": "green",
      "sort_hue": 0.266513,
      "sort_sat": 0.85098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474218983690",
      "swatch_filename": "JC001_Electric_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Electric_Green.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Electric_Green.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20ELG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Electric_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562003210",
      "product_title": "AWDis Cool Vest",
      "product_handle": "jc007",
      "product_url": "/products/jc007",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc007",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007",
      "colour_name": "Electric Green",
      "colour_group": "Green > Fluro/Neon Green",
      "rgb": "#7dff26",
      "sort_bucket": "green",
      "sort_hue": 0.266513,
      "sort_sat": 0.85098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513923313930",
      "swatch_filename": "jc007_Electric_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Electric_Green.jpg?v=1774618971",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Electric_Green.jpg?v=1774618971",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Just%20Cool/JC007/ProductCarouselMain/JC007%20ELG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007_Electric_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Electric Green",
      "colour_group": "Green > Fluro/Neon Green",
      "rgb": "#7dff26",
      "sort_bucket": "green",
      "sort_hue": 0.266513,
      "sort_sat": 0.85098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474210005258",
      "swatch_filename": "JC001B_Electric_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Electric_Green.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Electric_Green.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20ELG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Electric_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Electric Green",
      "colour_group": "Green > Fluro/Neon Green",
      "rgb": "#7dff26",
      "sort_bucket": "green",
      "sort_hue": 0.266513,
      "sort_sat": 0.85098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473141997834",
      "swatch_filename": "JC005_Electric_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Electric_Green.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Electric_Green.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20ELG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Electric_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562101514",
      "product_title": "AWDis Ladies Cool Vest",
      "product_handle": "jc015",
      "product_url": "/products/jc015",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc015",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC015",
      "colour_name": "Electric Green",
      "colour_group": "Green > Fluro/Neon Green",
      "rgb": "#7dff26",
      "sort_bucket": "green",
      "sort_hue": 0.266513,
      "sort_sat": 0.85098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513927475466",
      "swatch_filename": "jc015_Electric_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Electric_Green.jpg?v=1774619005",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Electric_Green.jpg?v=1774619005",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC015/ProductCarouselMain/JC015%20ELG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc015_Electric_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Classic Olive",
      "colour_group": "Green > Olive/Military",
      "rgb": "#546c44",
      "sort_bucket": "green",
      "sort_hue": 0.266667,
      "sort_sat": 0.37037,
      "sort_val": 0.423529,
      "swatch_file_id": "gid://shopify/MediaImage/49471285920010",
      "swatch_filename": "SS621_Classic_Olive.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Classic_Olive.jpg?v=1774348499",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Classic_Olive.jpg?v=1774348499",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20COL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Classic_Olive.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Classic Olive",
      "colour_group": "Green > Olive/Military",
      "rgb": "#546c44",
      "sort_bucket": "green",
      "sort_hue": 0.266667,
      "sort_sat": 0.37037,
      "sort_val": 0.423529,
      "swatch_file_id": "gid://shopify/MediaImage/49471313150218",
      "swatch_filename": "SS620_Classic_Olive.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Classic_Olive.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Classic_Olive.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20COL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Classic_Olive.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554621706",
      "product_title": "Fruit of the Loom Ladies Iconic 150 T-Shirt",
      "product_handle": "ss721",
      "product_url": "/products/ss721",
      "product_full_url": "https://oakdenemerch.com/products/ss721",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss721",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS721",
      "colour_name": "Classic Olive",
      "colour_group": "Green > Olive/Military",
      "rgb": "#546c44",
      "sort_bucket": "green",
      "sort_hue": 0.266667,
      "sort_sat": 0.37037,
      "sort_val": 0.423529,
      "swatch_file_id": "gid://shopify/MediaImage/49472056099082",
      "swatch_filename": "SS721_Classic_Olive.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Classic_Olive.jpg?v=1774353578",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Classic_Olive.jpg?v=1774353578",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS721/ProductCarouselMain/SS721%20COL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss721_Classic_Olive.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "Classic Olive",
      "colour_group": "Green > Olive/Military",
      "rgb": "#546c44",
      "sort_bucket": "green",
      "sort_hue": 0.266667,
      "sort_sat": 0.37037,
      "sort_val": 0.423529,
      "swatch_file_id": "gid://shopify/MediaImage/49471330746634",
      "swatch_filename": "SS12_Classic_Olive.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Classic_Olive.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Classic_Olive.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20COL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Classic_Olive.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554457866",
      "product_title": "Fruit of the Loom Pure Cotton T-Shirt",
      "product_handle": "ss640",
      "product_url": "/products/ss640",
      "product_full_url": "https://oakdenemerch.com/products/ss640",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss640",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "SS640",
      "colour_name": "Classic Olive",
      "colour_group": "Green > Olive/Military",
      "rgb": "#546c44",
      "sort_bucket": "green",
      "sort_hue": 0.266667,
      "sort_sat": 0.37037,
      "sort_val": 0.423529,
      "swatch_file_id": "gid://shopify/MediaImage/49468957557002",
      "swatch_filename": "SS640_Classic_Olive.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Classic_Olive.jpg?v=1774315114",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Classic_Olive.jpg?v=1774315114",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS640/ProductCarouselMain/SS640%20COL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss640_Classic_Olive.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554195722",
      "product_title": "Fruit of the Loom Super Premium T-Shirt",
      "product_handle": "ss10",
      "product_url": "/products/ss10",
      "product_full_url": "https://oakdenemerch.com/products/ss10",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss10",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS10",
      "colour_name": "Classic Olive",
      "colour_group": "Green > Olive/Military",
      "rgb": "#546c44",
      "sort_bucket": "green",
      "sort_hue": 0.266667,
      "sort_sat": 0.37037,
      "sort_val": 0.423529,
      "swatch_file_id": "gid://shopify/MediaImage/49471341363466",
      "swatch_filename": "SS10_Classic_Olive.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_Classic_Olive.jpg?v=1774348795",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_Classic_Olive.jpg?v=1774348795",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS10/ProductCarouselMain/SS10%20COL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss10_Classic_Olive.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Classic Olive",
      "colour_group": "Green > Olive/Military",
      "rgb": "#546c44",
      "sort_bucket": "green",
      "sort_hue": 0.266667,
      "sort_sat": 0.37037,
      "sort_val": 0.423529,
      "swatch_file_id": "gid://shopify/MediaImage/49471321997578",
      "swatch_filename": "SS6_Classic_Olive.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Classic_Olive.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Classic_Olive.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20COL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Classic_Olive.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552459018",
      "product_title": "Proact Triblend Sports T-Shirt",
      "product_handle": "pa4011",
      "product_url": "/products/pa4011",
      "product_full_url": "https://oakdenemerch.com/products/pa4011",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa4011",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% cotton/25% viscose.",
      "style_code": "PA4011",
      "colour_name": "Dark Khaki Heather",
      "colour_group": "Green > Heather/Effect Green",
      "rgb": "#424e3a",
      "sort_bucket": "green",
      "sort_hue": 0.266667,
      "sort_sat": 0.25641,
      "sort_val": 0.305882,
      "swatch_file_id": "gid://shopify/MediaImage/49471762104586",
      "swatch_filename": "PA4011_Dark_Khaki_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA4011_Dark_Khaki_Heather.jpg?v=1774351357",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA4011_Dark_Khaki_Heather.jpg?v=1774351357",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA4011/ProductCarouselMain/PA4011%20DKHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa4011_Dark_Khaki_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Lime Green",
      "colour_group": "Green > Lime",
      "rgb": "#7aff2e",
      "sort_bucket": "green",
      "sort_hue": 0.272727,
      "sort_sat": 0.819608,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471385534730",
      "swatch_filename": "GD05_Lime_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Lime_Green.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Lime_Green.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20LIM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Lime_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Lime Green",
      "colour_group": "Green > Lime",
      "rgb": "#7aff2e",
      "sort_bucket": "green",
      "sort_hue": 0.272727,
      "sort_sat": 0.819608,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474267906314",
      "swatch_filename": "GD01_Lime_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Lime_Green.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Lime_Green.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20LIM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Lime_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Lime Green",
      "colour_group": "Green > Lime",
      "rgb": "#7aff2e",
      "sort_bucket": "green",
      "sort_hue": 0.272727,
      "sort_sat": 0.819608,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471398609162",
      "swatch_filename": "GD02_Lime_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Lime_Green.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Lime_Green.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20LIM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Lime_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Lime Green",
      "colour_group": "Green > Lime",
      "rgb": "#70ff21",
      "sort_bucket": "green",
      "sort_hue": 0.274024,
      "sort_sat": 0.870588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473718812938",
      "swatch_filename": "11380_Lime_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Lime_Green.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Lime_Green.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20LIM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Lime_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553016074",
      "product_title": "SF Clothing Feel Good Stretch T-Shirt",
      "product_handle": "sf121",
      "product_url": "/products/sf121",
      "product_full_url": "https://oakdenemerch.com/products/sf121",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-sf121",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane single jersey.*",
      "style_code": "SF121",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#5f7b50",
      "sort_bucket": "green",
      "sort_hue": 0.275194,
      "sort_sat": 0.349593,
      "sort_val": 0.482353,
      "swatch_file_id": "gid://shopify/MediaImage/49472270958858",
      "swatch_filename": "SF121_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF121_Khaki.jpg?v=1774354029",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF121_Khaki.jpg?v=1774354029",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF121/ProductCarouselMain/SF121%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf121_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562789642",
      "product_title": "SF Clothing Ladies Sustainable Fashion Cropped Cami Vest Top",
      "product_handle": "sk230",
      "product_url": "/products/sk230",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-sk230",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly/Elastane",
      "shopify_material": "Cotton/Poly/Elastane",
      "csv_material": "48% regenerated cotton/47% recycled polyester/5% elastane.",
      "style_code": "SK230",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#5f7b50",
      "sort_bucket": "green",
      "sort_hue": 0.275194,
      "sort_sat": 0.349593,
      "sort_val": 0.482353,
      "swatch_file_id": "gid://shopify/MediaImage/49513935274250",
      "swatch_filename": "sk230_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk230_Khaki.jpg?v=1774619119",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk230_Khaki.jpg?v=1774619119",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SK230/ProductCarouselMain/SK230%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk230_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685590282",
      "product_title": "SOL'S Sporty Long Sleeve Performance T-Shirt",
      "product_handle": "02071",
      "product_url": "/products/02071",
      "product_full_url": "https://oakdenemerch.com/products/02071",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL",
        "sports",
        "style-02071",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02071",
      "colour_name": "Neon Green",
      "colour_group": "Green > Fluro/Neon Green",
      "rgb": "#5cff0a",
      "sort_bucket": "green",
      "sort_hue": 0.277551,
      "sort_sat": 0.960784,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490365120778",
      "swatch_filename": "02071_Neon_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02071_Neon_Green.jpg?v=1774522694",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02071_Neon_Green.jpg?v=1774522694",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02071/ProductCarouselMain/02071%20NGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02071_Neon_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548166410",
      "product_title": "SOL'S Sporty Performance T-Shirt",
      "product_handle": "11939",
      "product_url": "/products/11939",
      "product_full_url": "https://oakdenemerch.com/products/11939",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-11939",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "11939",
      "colour_name": "Neon Green",
      "colour_group": "Green > Fluro/Neon Green",
      "rgb": "#5cff0a",
      "sort_bucket": "green",
      "sort_hue": 0.277551,
      "sort_sat": 0.960784,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473692860682",
      "swatch_filename": "11939_Neon_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Neon_Green.jpg?v=1774364865",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Neon_Green.jpg?v=1774364865",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11939/ProductCarouselMain/11939%20NGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11939_Neon_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561609994",
      "product_title": "SOL'S Sporty Performance Tank Top",
      "product_handle": "02073",
      "product_url": "/products/02073",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL",
        "sports",
        "style-02073",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02073",
      "colour_name": "Neon Green",
      "colour_group": "Green > Fluro/Neon Green",
      "rgb": "#5cff0a",
      "sort_bucket": "green",
      "sort_hue": 0.277551,
      "sort_sat": 0.960784,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513910501642",
      "swatch_filename": "02073_Neon_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02073_Neon_Green.jpg?v=1774618852",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02073_Neon_Green.jpg?v=1774618852",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02073/ProductCarouselMain/02073%20NGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02073_Neon_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547576586",
      "product_title": "SOL'S Unisex Titan T-Shirt",
      "product_handle": "04728",
      "product_url": "/products/04728",
      "product_full_url": "https://oakdenemerch.com/products/04728",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "knitwear",
        "L",
        "M",
        "S",
        "style-04728",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.",
      "style_code": "04728",
      "colour_name": "Dark Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#285714",
      "sort_bucket": "green",
      "sort_hue": 0.283582,
      "sort_sat": 0.770115,
      "sort_val": 0.341176,
      "swatch_file_id": "gid://shopify/MediaImage/49474457010442",
      "swatch_filename": "04728_Dark_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_Dark_Green.jpg?v=1774371966",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_Dark_Green.jpg?v=1774371966",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04728/ProductCarouselMain/04728%20DGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04728_Dark_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "Flo Green",
      "colour_group": "Green > Fluro/Neon Green",
      "rgb": "#91ff66",
      "sort_bucket": "green",
      "sort_hue": 0.286492,
      "sort_sat": 0.6,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473588429066",
      "swatch_filename": "SR287_Flo_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Flo_Green.jpg?v=1774364345",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Flo_Green.jpg?v=1774364345",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20FLG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_Flo_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554097418",
      "product_title": "Spiro Kids Impact Performance Aircool T-Shirt",
      "product_handle": "sr287b",
      "product_url": "/products/sr287b",
      "product_full_url": "https://oakdenemerch.com/products/sr287b",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "children",
        "kids",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287b",
        "t-shirts",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287B",
      "colour_name": "Flo Green",
      "colour_group": "Green > Fluro/Neon Green",
      "rgb": "#91ff66",
      "sort_bucket": "green",
      "sort_hue": 0.286492,
      "sort_sat": 0.6,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474059763978",
      "swatch_filename": "SR287B_Flo_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Flo_Green.jpg?v=1774368252",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Flo_Green.jpg?v=1774368252",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287B/ProductCarouselMain/SR287B%20FLG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287b_Flo_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549116682",
      "product_title": "Ecologie Cascades Organic T-Shirt",
      "product_handle": "ea001",
      "product_url": "/products/ea001",
      "product_full_url": "https://oakdenemerch.com/products/ea001",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-ea001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001",
      "colour_name": "Olive Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#394a33",
      "sort_bucket": "green",
      "sort_hue": 0.289855,
      "sort_sat": 0.310811,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49474304147722",
      "swatch_filename": "EA001_Olive_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Olive_Green.jpg?v=1774371175",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Olive_Green.jpg?v=1774371175",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001/ProductCarouselMain/EA001%20OLI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001_Olive_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Melon Green",
      "colour_group": "Green > Light Green",
      "rgb": "#b7eda4",
      "sort_bucket": "green",
      "sort_hue": 0.289954,
      "sort_sat": 0.308017,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49474218426634",
      "swatch_filename": "JC001_Melon_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Melon_Green.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Melon_Green.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20MEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Melon_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Melon Green",
      "colour_group": "Green > Light Green",
      "rgb": "#b7eda4",
      "sort_bucket": "green",
      "sort_hue": 0.289954,
      "sort_sat": 0.308017,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49474210693386",
      "swatch_filename": "JC001B_Melon_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Melon_Green.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Melon_Green.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20MEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Melon_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547511050",
      "product_title": "SOL'S Crusader Recycled T-Shirt",
      "product_handle": "04233",
      "product_url": "/products/04233",
      "product_full_url": "https://oakdenemerch.com/products/04233",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04233",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% recycled cotton/50% cotton.*",
      "style_code": "04233",
      "colour_name": "Army",
      "colour_group": "Green > Olive/Military",
      "rgb": "#455440",
      "sort_bucket": "green",
      "sort_hue": 0.291667,
      "sort_sat": 0.238095,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49473285259530",
      "swatch_filename": "04233_Army.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Army.jpg?v=1774363191",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Army.jpg?v=1774363191",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04233/ProductCarouselMain/04233%20ARM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04233_Army.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Army",
      "colour_group": "Green > Olive/Military",
      "rgb": "#455440",
      "sort_bucket": "green",
      "sort_hue": 0.291667,
      "sort_sat": 0.238095,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49474449244426",
      "swatch_filename": "11500_Army.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Army.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Army.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20ARM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Army.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Army",
      "colour_group": "Green > Olive/Military",
      "rgb": "#455440",
      "sort_bucket": "green",
      "sort_hue": 0.291667,
      "sort_sat": 0.238095,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49468822913290",
      "swatch_filename": "01825_Army.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Army.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Army.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20ARM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Army.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547707658",
      "product_title": "SOL'S Ladies Vortex Ripstop Performance T-Shirt",
      "product_handle": "04788",
      "product_url": "/products/04788",
      "product_full_url": "https://oakdenemerch.com/products/04788",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04788",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04788",
      "colour_name": "Army",
      "colour_group": "Green > Olive/Military",
      "rgb": "#455440",
      "sort_bucket": "green",
      "sort_hue": 0.291667,
      "sort_sat": 0.238095,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49472651886858",
      "swatch_filename": "04788_Army.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_Army.jpg?v=1774358494",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_Army.jpg?v=1774358494",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04788/ProductCarouselMain/04788%20ARM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04788_Army.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Army",
      "colour_group": "Green > Olive/Military",
      "rgb": "#455440",
      "sort_bucket": "green",
      "sort_hue": 0.291667,
      "sort_sat": 0.238095,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49473719435530",
      "swatch_filename": "11380_Army.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Army.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Army.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20ARM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Army.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548166410",
      "product_title": "SOL'S Sporty Performance T-Shirt",
      "product_handle": "11939",
      "product_url": "/products/11939",
      "product_full_url": "https://oakdenemerch.com/products/11939",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-11939",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "11939",
      "colour_name": "Army",
      "colour_group": "Green > Olive/Military",
      "rgb": "#455440",
      "sort_bucket": "green",
      "sort_hue": 0.291667,
      "sort_sat": 0.238095,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49473692565770",
      "swatch_filename": "11939_Army.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Army.jpg?v=1774364865",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Army.jpg?v=1774364865",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11939/ProductCarouselMain/11939%20ARM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11939_Army.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547150602",
      "product_title": "SOL'S Unisex Sprint T-Shirt",
      "product_handle": "02995",
      "product_url": "/products/02995",
      "product_full_url": "https://oakdenemerch.com/products/02995",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-02995",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "02995",
      "colour_name": "Army",
      "colour_group": "Green > Olive/Military",
      "rgb": "#455440",
      "sort_bucket": "green",
      "sort_hue": 0.291667,
      "sort_sat": 0.238095,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49473768030474",
      "swatch_filename": "02995_Army.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Army.jpg?v=1774365179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Army.jpg?v=1774365179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02995/ProductCarouselMain/02995%20ARM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02995_Army.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547674890",
      "product_title": "SOL'S Vortex Ripstop Performance T-Shirt",
      "product_handle": "04787",
      "product_url": "/products/04787",
      "product_full_url": "https://oakdenemerch.com/products/04787",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04787",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04787",
      "colour_name": "Army",
      "colour_group": "Green > Olive/Military",
      "rgb": "#455440",
      "sort_bucket": "green",
      "sort_hue": 0.291667,
      "sort_sat": 0.238095,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49472658276618",
      "swatch_filename": "04787_Army.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_Army.jpg?v=1774358538",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_Army.jpg?v=1774358538",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04787/ProductCarouselMain/04787%20ARM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04787_Army.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#758a6f",
      "sort_bucket": "green",
      "sort_hue": 0.296296,
      "sort_sat": 0.195652,
      "sort_val": 0.541176,
      "swatch_file_id": "gid://shopify/MediaImage/49474468544778",
      "swatch_filename": "03582_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Khaki.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Khaki.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#758a6f",
      "sort_bucket": "green",
      "sort_hue": 0.296296,
      "sort_sat": 0.195652,
      "sort_val": 0.541176,
      "swatch_file_id": "gid://shopify/MediaImage/49474448916746",
      "swatch_filename": "11500_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Khaki.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Khaki.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#758a6f",
      "sort_bucket": "green",
      "sort_hue": 0.296296,
      "sort_sat": 0.195652,
      "sort_val": 0.541176,
      "swatch_file_id": "gid://shopify/MediaImage/49468835463434",
      "swatch_filename": "03581_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Khaki.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Khaki.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#758a6f",
      "sort_bucket": "green",
      "sort_hue": 0.296296,
      "sort_sat": 0.195652,
      "sort_val": 0.541176,
      "swatch_file_id": "gid://shopify/MediaImage/49468933931274",
      "swatch_filename": "11502_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Khaki.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Khaki.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547642122",
      "product_title": "SOL'S Ladies Legend T-Shirt",
      "product_handle": "04776",
      "product_url": "/products/04776",
      "product_full_url": "https://oakdenemerch.com/products/04776",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-04776",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "04776",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#758a6f",
      "sort_bucket": "green",
      "sort_hue": 0.296296,
      "sort_sat": 0.195652,
      "sort_val": 0.541176,
      "swatch_file_id": "gid://shopify/MediaImage/49472963576074",
      "swatch_filename": "04776_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Khaki.jpg?v=1774360490",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Khaki.jpg?v=1774360490",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04776/ProductCarouselMain/04776%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04776_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685917962",
      "product_title": "SOL'S Ladies Monarch Long Sleeve T-Shirt",
      "product_handle": "04443",
      "product_url": "/products/04443",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-04443",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.",
      "style_code": "04443",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#758a6f",
      "sort_bucket": "green",
      "sort_hue": 0.296296,
      "sort_sat": 0.195652,
      "sort_val": 0.541176,
      "swatch_file_id": "gid://shopify/MediaImage/49490370199818",
      "swatch_filename": "04443_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04443_Khaki.jpg?v=1774522732",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04443_Khaki.jpg?v=1774522732",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04443/ProductCarouselMain/04443%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04443_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#758a6f",
      "sort_bucket": "green",
      "sort_hue": 0.296296,
      "sort_sat": 0.195652,
      "sort_val": 0.541176,
      "swatch_file_id": "gid://shopify/MediaImage/49468833038602",
      "swatch_filename": "03579_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Khaki.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Khaki.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686049034",
      "product_title": "SOL'S Monarch Long Sleeve T-Shirt",
      "product_handle": "11420",
      "product_url": "/products/11420",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11420",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "11420",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#758a6f",
      "sort_bucket": "green",
      "sort_hue": 0.296296,
      "sort_sat": 0.195652,
      "sort_val": 0.541176,
      "swatch_file_id": "gid://shopify/MediaImage/49490370887946",
      "swatch_filename": "11420_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Khaki.jpg?v=1774522745",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Khaki.jpg?v=1774522745",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11420/ProductCarouselMain/11420%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11420_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03565",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#758a6f",
      "sort_bucket": "green",
      "sort_hue": 0.296296,
      "sort_sat": 0.195652,
      "sort_val": 0.541176,
      "swatch_file_id": "gid://shopify/MediaImage/49473306198282",
      "swatch_filename": "03565_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Khaki.jpg?v=1774363313",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Khaki.jpg?v=1774363313",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#758a6f",
      "sort_bucket": "green",
      "sort_hue": 0.296296,
      "sort_sat": 0.195652,
      "sort_val": 0.541176,
      "swatch_file_id": "gid://shopify/MediaImage/49473718288650",
      "swatch_filename": "11380_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Khaki.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Khaki.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#758a6f",
      "sort_bucket": "green",
      "sort_hue": 0.296296,
      "sort_sat": 0.195652,
      "sort_val": 0.541176,
      "swatch_file_id": "gid://shopify/MediaImage/49473744699658",
      "swatch_filename": "03981_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Khaki.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Khaki.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Earthy Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#476240",
      "sort_bucket": "green",
      "sort_hue": 0.29902,
      "sort_sat": 0.346939,
      "sort_val": 0.384314,
      "swatch_file_id": "gid://shopify/MediaImage/49474217869578",
      "swatch_filename": "JC001_Earthy_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Earthy_Green.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Earthy_Green.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20ERG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Earthy_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Earthy Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#476240",
      "sort_bucket": "green",
      "sort_hue": 0.29902,
      "sort_sat": 0.346939,
      "sort_val": 0.384314,
      "swatch_file_id": "gid://shopify/MediaImage/49474210562314",
      "swatch_filename": "JC001B_Earthy_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Earthy_Green.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Earthy_Green.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20ERG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Earthy_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Earthy Green",
      "colour_group": "Green > Mid Green",
      "rgb": "#476240",
      "sort_bucket": "green",
      "sort_hue": 0.29902,
      "sort_sat": 0.346939,
      "sort_val": 0.384314,
      "swatch_file_id": "gid://shopify/MediaImage/49471442714890",
      "swatch_filename": "AT001_Earthy_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Earthy_Green.jpg?v=1774349536",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Earthy_Green.jpg?v=1774349536",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20ERG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Earthy_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Earthy Green",
      "colour_group": "Green > Mid Green",
      "rgb": "#476240",
      "sort_bucket": "green",
      "sort_hue": 0.29902,
      "sort_sat": 0.346939,
      "sort_val": 0.384314,
      "swatch_file_id": "gid://shopify/MediaImage/49471430295818",
      "swatch_filename": "AT002_Earthy_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Earthy_Green.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Earthy_Green.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20ERG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Earthy_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#17bd09",
      "sort_bucket": "green",
      "sort_hue": 0.32037,
      "sort_sat": 0.952381,
      "sort_val": 0.741176,
      "swatch_file_id": "gid://shopify/MediaImage/49474218787082",
      "swatch_filename": "JC001_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Kelly_Green.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Kelly_Green.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562003210",
      "product_title": "AWDis Cool Vest",
      "product_handle": "jc007",
      "product_url": "/products/jc007",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc007",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#17bd09",
      "sort_bucket": "green",
      "sort_hue": 0.32037,
      "sort_sat": 0.952381,
      "sort_val": 0.741176,
      "swatch_file_id": "gid://shopify/MediaImage/49513923576074",
      "swatch_filename": "jc007_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Kelly_Green.jpg?v=1774618973",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Kelly_Green.jpg?v=1774618973",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC007/ProductCarouselMain/JC007%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#17bd09",
      "sort_bucket": "green",
      "sort_hue": 0.32037,
      "sort_sat": 0.952381,
      "sort_val": 0.741176,
      "swatch_file_id": "gid://shopify/MediaImage/49474210267402",
      "swatch_filename": "JC001B_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Kelly_Green.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Kelly_Green.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#17bd09",
      "sort_bucket": "green",
      "sort_hue": 0.32037,
      "sort_sat": 0.952381,
      "sort_val": 0.741176,
      "swatch_file_id": "gid://shopify/MediaImage/49473142489354",
      "swatch_filename": "JC005_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Kelly_Green.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Kelly_Green.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "65% polyester/35% cotton.",
      "style_code": "GD01",
      "colour_name": "Heather Military Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#5a6659",
      "sort_bucket": "green",
      "sort_hue": 0.320513,
      "sort_sat": 0.127451,
      "sort_val": 0.4,
      "swatch_file_id": "gid://shopify/MediaImage/49474266792202",
      "swatch_filename": "GD01_Heather_Military_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Heather_Military_Green.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Heather_Military_Green.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20HMG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Heather_Military_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Neo Mint",
      "colour_group": "Green > Light Green",
      "rgb": "#9eff96",
      "sort_bucket": "green",
      "sort_hue": 0.320635,
      "sort_sat": 0.411765,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471285330186",
      "swatch_filename": "SS621_Neo_Mint.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Neo_Mint.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Neo_Mint.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20NEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Neo_Mint.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#0b9900",
      "sort_bucket": "green",
      "sort_hue": 0.321351,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49471442551050",
      "swatch_filename": "AT001_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Kelly_Green.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Kelly_Green.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#0b9900",
      "sort_bucket": "green",
      "sort_hue": 0.321351,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49471429673226",
      "swatch_filename": "AT002_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Kelly_Green.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Kelly_Green.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551181066",
      "product_title": "Kustom Kit Regular Fit Cooltex® Plus Wicking T-Shirt",
      "product_handle": "k555",
      "product_url": "/products/k555",
      "product_full_url": "https://oakdenemerch.com/products/k555",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k555",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester mesh.",
      "style_code": "K555",
      "colour_name": "Graphite Grey",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#324031",
      "sort_bucket": "green",
      "sort_hue": 0.322222,
      "sort_sat": 0.234375,
      "sort_val": 0.25098,
      "swatch_file_id": "gid://shopify/MediaImage/49473108574474",
      "swatch_filename": "K555_Graphite_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K555_Graphite_Grey.jpg?v=1774362040",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K555_Graphite_Grey.jpg?v=1774362040",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K555/ProductCarouselMain/K555%20GPH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k555_Graphite_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551148298",
      "product_title": "Kustom Kit Superwash® 60°C Piqué T-Shirt",
      "product_handle": "k530",
      "product_url": "/products/k530",
      "product_full_url": "https://oakdenemerch.com/products/k530",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-k530",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton piqué.",
      "style_code": "K530",
      "colour_name": "Graphite Grey",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#324031",
      "sort_bucket": "green",
      "sort_hue": 0.322222,
      "sort_sat": 0.234375,
      "sort_val": 0.25098,
      "swatch_file_id": "gid://shopify/MediaImage/49472793248010",
      "swatch_filename": "K530_Graphite_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K530_Graphite_Grey.jpg?v=1774359823",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K530_Graphite_Grey.jpg?v=1774359823",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K530/ProductCarouselMain/K530%20GPH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k530_Graphite_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1cf00d",
      "sort_bucket": "green",
      "sort_hue": 0.32232,
      "sort_sat": 0.945833,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49474468675850",
      "swatch_filename": "03582_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Kelly_Green.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Kelly_Green.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1cf00d",
      "sort_bucket": "green",
      "sort_hue": 0.32232,
      "sort_sat": 0.945833,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49474448752906",
      "swatch_filename": "11500_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Kelly_Green.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Kelly_Green.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1cf00d",
      "sort_bucket": "green",
      "sort_hue": 0.32232,
      "sort_sat": 0.945833,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49468835627274",
      "swatch_filename": "03581_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Kelly_Green.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Kelly_Green.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1cf00d",
      "sort_bucket": "green",
      "sort_hue": 0.32232,
      "sort_sat": 0.945833,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49468933832970",
      "swatch_filename": "11502_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Kelly_Green.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Kelly_Green.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685917962",
      "product_title": "SOL'S Ladies Monarch Long Sleeve T-Shirt",
      "product_handle": "04443",
      "product_url": "/products/04443",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-04443",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.",
      "style_code": "04443",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1cf00d",
      "sort_bucket": "green",
      "sort_hue": 0.32232,
      "sort_sat": 0.945833,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49490370265354",
      "swatch_filename": "04443_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04443_Kelly_Green.jpg?v=1774522733",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04443_Kelly_Green.jpg?v=1774522733",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04443/ProductCarouselMain/04443%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04443_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1cf00d",
      "sort_bucket": "green",
      "sort_hue": 0.32232,
      "sort_sat": 0.945833,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49468833497354",
      "swatch_filename": "03579_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Kelly_Green.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Kelly_Green.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1cf00d",
      "sort_bucket": "green",
      "sort_hue": 0.32232,
      "sort_sat": 0.945833,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49468823175434",
      "swatch_filename": "01825_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Kelly_Green.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Kelly_Green.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686049034",
      "product_title": "SOL'S Monarch Long Sleeve T-Shirt",
      "product_handle": "11420",
      "product_url": "/products/11420",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11420",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "11420",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1cf00d",
      "sort_bucket": "green",
      "sort_hue": 0.32232,
      "sort_sat": 0.945833,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49490370953482",
      "swatch_filename": "11420_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Kelly_Green.jpg?v=1774522746",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Kelly_Green.jpg?v=1774522746",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11420/ProductCarouselMain/11420%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11420_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03565",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1cf00d",
      "sort_bucket": "green",
      "sort_hue": 0.32232,
      "sort_sat": 0.945833,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49473305673994",
      "swatch_filename": "03565_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Kelly_Green.jpg?v=1774363313",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Kelly_Green.jpg?v=1774363313",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1cf00d",
      "sort_bucket": "green",
      "sort_hue": 0.32232,
      "sort_sat": 0.945833,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49473718518026",
      "swatch_filename": "11380_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Kelly_Green.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Kelly_Green.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Spring Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#4dff42",
      "sort_bucket": "green",
      "sort_hue": 0.323633,
      "sort_sat": 0.741176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473744601354",
      "swatch_filename": "03981_Spring_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Spring_Green.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Spring_Green.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20SPG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Spring_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Frozen Green",
      "colour_group": "Green > Light Green",
      "rgb": "#9eff99",
      "sort_bucket": "green",
      "sort_hue": 0.325163,
      "sort_sat": 0.4,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473744732426",
      "swatch_filename": "03981_Frozen_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Frozen_Green.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Frozen_Green.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20FZG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Frozen_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD05",
      "colour_name": "Antique Irish Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#09dc00",
      "sort_bucket": "green",
      "sort_hue": 0.326515,
      "sort_sat": 1.0,
      "sort_val": 0.862745,
      "swatch_file_id": "gid://shopify/MediaImage/49471385665802",
      "swatch_filename": "GD05_Antique_Irish_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Antique_Irish_Green.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Antique_Irish_Green.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20AIG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Antique_Irish_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550886154",
      "product_title": "AWDis Camo T-Shirt",
      "product_handle": "jt034",
      "product_url": "/products/jt034",
      "product_full_url": "https://oakdenemerch.com/products/jt034",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jt034",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "JT034",
      "colour_name": "Green Camo",
      "colour_group": "Patterns > Camouflage",
      "rgb": "",
      "sort_bucket": "green",
      "sort_hue": 0.33,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49471810142474",
      "swatch_filename": "JT034_Green_Camo.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT034_Green_Camo.jpg?v=1774351480",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT034_Green_Camo.jpg?v=1774351480",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT034/ProductCarouselMain/JT034%20GNC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt034_Green_Camo.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554294026",
      "product_title": "Fruit of the Loom Contrast Ringer T-Shirt",
      "product_handle": "ss34",
      "product_url": "/products/ss34",
      "product_full_url": "https://oakdenemerch.com/products/ss34",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss34",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "SS34",
      "colour_name": "Sunflower/Kelly Green",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffc700;#14fc26",
      "sort_bucket": "green",
      "sort_hue": 0.33,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49468952969482",
      "swatch_filename": "SS34_SunflowerKelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS34_SunflowerKelly_Green.jpg?v=1774315005",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS34_SunflowerKelly_Green.jpg?v=1774315005",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS34/ProductCarouselMain/SS34%20SU%252fKG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss34_SunflowerKelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Military Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#386338",
      "sort_bucket": "green",
      "sort_hue": 0.333333,
      "sort_sat": 0.434343,
      "sort_val": 0.388235,
      "swatch_file_id": "gid://shopify/MediaImage/49471385174282",
      "swatch_filename": "GD05_Military_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Military_Green.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Military_Green.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20MGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Military_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Military Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#386338",
      "sort_bucket": "green",
      "sort_hue": 0.333333,
      "sort_sat": 0.434343,
      "sort_val": 0.388235,
      "swatch_file_id": "gid://shopify/MediaImage/49474267644170",
      "swatch_filename": "GD01_Military_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Military_Green.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Military_Green.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20MGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Military_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686966538",
      "product_title": "Gildan SoftStyle® Long Sleeve T-Shirt",
      "product_handle": "gd11",
      "product_url": "/products/gd11",
      "product_full_url": "https://oakdenemerch.com/products/gd11",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd11",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD11",
      "colour_name": "Military Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#386338",
      "sort_bucket": "green",
      "sort_hue": 0.333333,
      "sort_sat": 0.434343,
      "sort_val": 0.388235,
      "swatch_file_id": "gid://shopify/MediaImage/49490442780938",
      "swatch_filename": "gd11_Military_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Military_Green.jpg?v=1774522830",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Military_Green.jpg?v=1774522830",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD11/ProductCarouselMain/GD11%20MGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd11_Military_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Military Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#386338",
      "sort_bucket": "green",
      "sort_hue": 0.333333,
      "sort_sat": 0.434343,
      "sort_val": 0.388235,
      "swatch_file_id": "gid://shopify/MediaImage/49471397298442",
      "swatch_filename": "GD02_Military_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Military_Green.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Military_Green.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20MGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Military_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Irish Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1fff24",
      "sort_bucket": "green",
      "sort_hue": 0.337054,
      "sort_sat": 0.878431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471384649994",
      "swatch_filename": "GD05_Irish_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Irish_Green.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Irish_Green.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20IGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Irish_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549837578",
      "product_title": "Gildan Ladies SoftStyle® Midweight T-Shirt",
      "product_handle": "gd92",
      "product_url": "/products/gd92",
      "product_full_url": "https://oakdenemerch.com/products/gd92",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd92",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD92",
      "colour_name": "Irish Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1fff24",
      "sort_bucket": "green",
      "sort_hue": 0.337054,
      "sort_sat": 0.878431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468941959434",
      "swatch_filename": "GD92_Irish_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD92_Irish_Green.jpg?v=1774314177",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD92_Irish_Green.jpg?v=1774314177",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD92/ProductCarouselMain/GD92%20IGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd92_Irish_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549772042",
      "product_title": "Gildan Ladies SoftStyle® T-Shirt",
      "product_handle": "gd72",
      "product_url": "/products/gd72",
      "product_full_url": "https://oakdenemerch.com/products/gd72",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd72",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD72",
      "colour_name": "Irish Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1fff24",
      "sort_bucket": "green",
      "sort_hue": 0.337054,
      "sort_sat": 0.878431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468940583178",
      "swatch_filename": "GD72_Irish_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Irish_Green.jpg?v=1774314002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Irish_Green.jpg?v=1774314002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD72/ProductCarouselMain/GD72%20IGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd72_Irish_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Irish Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1fff24",
      "sort_bucket": "green",
      "sort_hue": 0.337054,
      "sort_sat": 0.878431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474267578634",
      "swatch_filename": "GD01_Irish_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Irish_Green.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Irish_Green.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20IGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Irish_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Irish Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1fff24",
      "sort_bucket": "green",
      "sort_hue": 0.337054,
      "sort_sat": 0.878431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471368724746",
      "swatch_filename": "GD15_Irish_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Irish_Green.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Irish_Green.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20IGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Irish_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD14",
      "colour_name": "Irish Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1fff24",
      "sort_bucket": "green",
      "sort_hue": 0.337054,
      "sort_sat": 0.878431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490461655306",
      "swatch_filename": "gd14_Irish_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Irish_Green.jpg?v=1774522852",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Irish_Green.jpg?v=1774522852",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20IGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Irish_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Irish Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1fff24",
      "sort_bucket": "green",
      "sort_hue": 0.337054,
      "sort_sat": 0.878431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471397757194",
      "swatch_filename": "GD02_Irish_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Irish_Green.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Irish_Green.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20IGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Irish_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547576586",
      "product_title": "SOL'S Unisex Titan T-Shirt",
      "product_handle": "04728",
      "product_url": "/products/04728",
      "product_full_url": "https://oakdenemerch.com/products/04728",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "knitwear",
        "L",
        "M",
        "S",
        "style-04728",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.",
      "style_code": "04728",
      "colour_name": "Green",
      "colour_group": "Green > Mid Green",
      "rgb": "#135515",
      "sort_bucket": "green",
      "sort_hue": 0.338384,
      "sort_sat": 0.776471,
      "sort_val": 0.333333,
      "swatch_file_id": "gid://shopify/MediaImage/49474456846602",
      "swatch_filename": "04728_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_Green.jpg?v=1774371966",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_Green.jpg?v=1774371966",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04728/ProductCarouselMain/04728%20GRN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04728_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1b501d",
      "sort_bucket": "green",
      "sort_hue": 0.339623,
      "sort_sat": 0.6625,
      "sort_val": 0.313725,
      "swatch_file_id": "gid://shopify/MediaImage/49471257739530",
      "swatch_filename": "T520_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Forest_Green.jpg?v=1774348349",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Forest_Green.jpg?v=1774348349",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556587786",
      "product_title": "Tee Jays Ladies Interlock T-Shirt",
      "product_handle": "t580",
      "product_url": "/products/t580",
      "product_full_url": "https://oakdenemerch.com/products/t580",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t580",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T580",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1b501d",
      "sort_bucket": "green",
      "sort_hue": 0.339623,
      "sort_sat": 0.6625,
      "sort_val": 0.313725,
      "swatch_file_id": "gid://shopify/MediaImage/49469002023178",
      "swatch_filename": "T580_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Forest_Green.jpg?v=1774315823",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Forest_Green.jpg?v=1774315823",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T580/ProductCarouselMain/T580%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t580_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557341450",
      "product_title": "Tee Jays Sof T-Shirt",
      "product_handle": "t8000",
      "product_url": "/products/t8000",
      "product_full_url": "https://oakdenemerch.com/products/t8000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t8000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T8000",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1b501d",
      "sort_bucket": "green",
      "sort_hue": 0.339623,
      "sort_sat": 0.6625,
      "sort_val": 0.313725,
      "swatch_file_id": "gid://shopify/MediaImage/49471238734090",
      "swatch_filename": "T8000_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Forest_Green.jpg?v=1774348259",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Forest_Green.jpg?v=1774348259",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8000/ProductCarouselMain/T8000%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8000_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Mint",
      "colour_group": "Green > Light Green",
      "rgb": "#91ff96",
      "sort_bucket": "green",
      "sort_hue": 0.340909,
      "sort_sat": 0.431373,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471385764106",
      "swatch_filename": "GD05_Mint.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Mint.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Mint.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20MIN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Mint.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Mint",
      "colour_group": "Green > Light Green",
      "rgb": "#91ff96",
      "sort_bucket": "green",
      "sort_hue": 0.340909,
      "sort_sat": 0.431373,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474268135690",
      "swatch_filename": "GD01_Mint.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Mint.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Mint.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20MIN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Mint.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#14fc26",
      "sort_bucket": "green",
      "sort_hue": 0.346264,
      "sort_sat": 0.920635,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49471285461258",
      "swatch_filename": "SS621_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Kelly_Green.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Kelly_Green.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#14fc26",
      "sort_bucket": "green",
      "sort_hue": 0.346264,
      "sort_sat": 0.920635,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49471313543434",
      "swatch_filename": "SS620_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Kelly_Green.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Kelly_Green.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS720",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#14fc26",
      "sort_bucket": "green",
      "sort_hue": 0.346264,
      "sort_sat": 0.920635,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49472218628362",
      "swatch_filename": "SS720_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Kelly_Green.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Kelly_Green.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554654474",
      "product_title": "Fruit of the Loom Lady Fit Value T-Shirt",
      "product_handle": "ss77",
      "product_url": "/products/ss77",
      "product_full_url": "https://oakdenemerch.com/products/ss77",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss77",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS77",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#14fc26",
      "sort_bucket": "green",
      "sort_hue": 0.346264,
      "sort_sat": 0.920635,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49472026345738",
      "swatch_filename": "SS77_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Kelly_Green.jpg?v=1774353471",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Kelly_Green.jpg?v=1774353471",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS77/ProductCarouselMain/SS77%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss77_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#14fc26",
      "sort_bucket": "green",
      "sort_hue": 0.346264,
      "sort_sat": 0.920635,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49471330320650",
      "swatch_filename": "SS12_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Kelly_Green.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Kelly_Green.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554490634",
      "product_title": "Fruit of the Loom V Neck Value T-Shirt",
      "product_handle": "ss7",
      "product_url": "/products/ss7",
      "product_full_url": "https://oakdenemerch.com/products/ss7",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss7",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS7",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#14fc26",
      "sort_bucket": "green",
      "sort_hue": 0.346264,
      "sort_sat": 0.920635,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49471272059146",
      "swatch_filename": "SS7_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Kelly_Green.jpg?v=1774348430",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Kelly_Green.jpg?v=1774348430",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS7/ProductCarouselMain/SS7%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss7_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#14fc26",
      "sort_bucket": "green",
      "sort_hue": 0.346264,
      "sort_sat": 0.920635,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49471322095882",
      "swatch_filename": "SS6_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Kelly_Green.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Kelly_Green.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552229642",
      "product_title": "Native Spirit Terry Towel T-Shirt",
      "product_handle": "ns311",
      "product_url": "/products/ns311",
      "product_full_url": "https://oakdenemerch.com/products/ns311",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns311",
        "t-shirts",
        "towels-robes-slippers",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic combed cotton/20% recycled polyester.",
      "style_code": "NS311",
      "colour_name": "Almond Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#869e88",
      "sort_bucket": "green",
      "sort_hue": 0.347222,
      "sort_sat": 0.151899,
      "sort_val": 0.619608,
      "swatch_file_id": "gid://shopify/MediaImage/49472780697866",
      "swatch_filename": "NS311_Almond_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS311_Almond_Green.jpg?v=1774359624",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS311_Almond_Green.jpg?v=1774359624",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS311/ProductCarouselMain/NS311%20ALG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns311_Almond_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550820618",
      "product_title": "AWDis Unisex Oversize 100 T-Shirt",
      "product_handle": "jt009",
      "product_url": "/products/jt009",
      "product_full_url": "https://oakdenemerch.com/products/jt009",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jt009",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.*",
      "style_code": "JT009",
      "colour_name": "Earthy Green",
      "colour_group": "Green > Mid Green",
      "rgb": "#3a4e3c",
      "sort_bucket": "green",
      "sort_hue": 0.35,
      "sort_sat": 0.25641,
      "sort_val": 0.305882,
      "swatch_file_id": "gid://shopify/MediaImage/49471818105098",
      "swatch_filename": "JT009_Earthy_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_Earthy_Green.jpg?v=1774351553",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_Earthy_Green.jpg?v=1774351553",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT009/ProductCarouselMain/JT009%20ERG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt009_Earthy_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#15451a",
      "sort_bucket": "green",
      "sort_hue": 0.350694,
      "sort_sat": 0.695652,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49471313084682",
      "swatch_filename": "SS620_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Bottle_Green.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Bottle_Green.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554654474",
      "product_title": "Fruit of the Loom Lady Fit Value T-Shirt",
      "product_handle": "ss77",
      "product_url": "/products/ss77",
      "product_full_url": "https://oakdenemerch.com/products/ss77",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss77",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS77",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#15451a",
      "sort_bucket": "green",
      "sort_hue": 0.350694,
      "sort_sat": 0.695652,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49472026083594",
      "swatch_filename": "SS77_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Bottle_Green.jpg?v=1774353471",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Bottle_Green.jpg?v=1774353471",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS77/ProductCarouselMain/SS77%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss77_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#15451a",
      "sort_bucket": "green",
      "sort_hue": 0.350694,
      "sort_sat": 0.695652,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49471330648330",
      "swatch_filename": "SS12_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Bottle_Green.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Bottle_Green.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554195722",
      "product_title": "Fruit of the Loom Super Premium T-Shirt",
      "product_handle": "ss10",
      "product_url": "/products/ss10",
      "product_full_url": "https://oakdenemerch.com/products/ss10",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss10",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS10",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#15451a",
      "sort_bucket": "green",
      "sort_hue": 0.350694,
      "sort_sat": 0.695652,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49471341461770",
      "swatch_filename": "SS10_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_Bottle_Green.jpg?v=1774348795",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_Bottle_Green.jpg?v=1774348795",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS10/ProductCarouselMain/SS10%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss10_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#15451a",
      "sort_bucket": "green",
      "sort_hue": 0.350694,
      "sort_sat": 0.695652,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49471322063114",
      "swatch_filename": "SS6_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Bottle_Green.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Bottle_Green.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550361866",
      "product_title": "AWDis Cool Smooth T-Shirt",
      "product_handle": "jc020",
      "product_url": "/products/jc020",
      "product_full_url": "https://oakdenemerch.com/products/jc020",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-jc020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#063e0c",
      "sort_bucket": "green",
      "sort_hue": 0.35119,
      "sort_sat": 0.903226,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49472871334154",
      "swatch_filename": "JC020_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Bottle_Green.jpg?v=1774359994",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Bottle_Green.jpg?v=1774359994",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020/ProductCarouselMain/JC020%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562003210",
      "product_title": "AWDis Cool Vest",
      "product_handle": "jc007",
      "product_url": "/products/jc007",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc007",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#063e0c",
      "sort_bucket": "green",
      "sort_hue": 0.35119,
      "sort_sat": 0.903226,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49513923674378",
      "swatch_filename": "jc007_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Bottle_Green.jpg?v=1774618975",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Bottle_Green.jpg?v=1774618975",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC007/ProductCarouselMain/JC007%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#063e0c",
      "sort_bucket": "green",
      "sort_hue": 0.35119,
      "sort_sat": 0.903226,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49474210431242",
      "swatch_filename": "JC001B_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Bottle_Green.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Bottle_Green.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#063e0c",
      "sort_bucket": "green",
      "sort_hue": 0.35119,
      "sort_sat": 0.903226,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49473142161674",
      "swatch_filename": "JC005_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Bottle_Green.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Bottle_Green.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549116682",
      "product_title": "Ecologie Cascades Organic T-Shirt",
      "product_handle": "ea001",
      "product_url": "/products/ea001",
      "product_full_url": "https://oakdenemerch.com/products/ea001",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-ea001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#063e0c",
      "sort_bucket": "green",
      "sort_hue": 0.35119,
      "sort_sat": 0.903226,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49474304082186",
      "swatch_filename": "EA001_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Bottle_Green.jpg?v=1774371175",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Bottle_Green.jpg?v=1774371175",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001/ProductCarouselMain/EA001%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549149450",
      "product_title": "Ecologie Kids Cascades Organic T-Shirt",
      "product_handle": "ea001b",
      "product_url": "/products/ea001b",
      "product_full_url": "https://oakdenemerch.com/products/ea001b",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "organic",
        "organic-recycled",
        "style-ea001b",
        "t-shirts"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001B",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#063e0c",
      "sort_bucket": "green",
      "sort_hue": 0.35119,
      "sort_sat": 0.903226,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49474280554762",
      "swatch_filename": "EA001B_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001B_Bottle_Green.jpg?v=1774371054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001B_Bottle_Green.jpg?v=1774371054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001B/ProductCarouselMain/EA001B%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001b_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#063e0c",
      "sort_bucket": "green",
      "sort_hue": 0.35119,
      "sort_sat": 0.903226,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49474088861962",
      "swatch_filename": "RX151_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Bottle_Green.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Bottle_Green.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#105017",
      "sort_bucket": "green",
      "sort_hue": 0.351562,
      "sort_sat": 0.8,
      "sort_val": 0.313725,
      "swatch_file_id": "gid://shopify/MediaImage/49471442452746",
      "swatch_filename": "AT001_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Bottle_Green.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Bottle_Green.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#105017",
      "sort_bucket": "green",
      "sort_hue": 0.351562,
      "sort_sat": 0.8,
      "sort_val": 0.313725,
      "swatch_file_id": "gid://shopify/MediaImage/49471430099210",
      "swatch_filename": "AT002_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Bottle_Green.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Bottle_Green.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Fan Dark Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#105017",
      "sort_bucket": "green",
      "sort_hue": 0.351562,
      "sort_sat": 0.8,
      "sort_val": 0.313725,
      "swatch_file_id": "gid://shopify/MediaImage/49471384944906",
      "swatch_filename": "GD05_Fan_Dark_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Fan_Dark_Green.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Fan_Dark_Green.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20FDGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Fan_Dark_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Fan Dark Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#105017",
      "sort_bucket": "green",
      "sort_hue": 0.351562,
      "sort_sat": 0.8,
      "sort_val": 0.313725,
      "swatch_file_id": "gid://shopify/MediaImage/49474267709706",
      "swatch_filename": "GD01_Fan_Dark_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Fan_Dark_Green.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Fan_Dark_Green.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20FDGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Fan_Dark_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686966538",
      "product_title": "Gildan SoftStyle® Long Sleeve T-Shirt",
      "product_handle": "gd11",
      "product_url": "/products/gd11",
      "product_full_url": "https://oakdenemerch.com/products/gd11",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd11",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD11",
      "colour_name": "Fan Dark Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#105017",
      "sort_bucket": "green",
      "sort_hue": 0.351562,
      "sort_sat": 0.8,
      "sort_val": 0.313725,
      "swatch_file_id": "gid://shopify/MediaImage/49490443010314",
      "swatch_filename": "gd11_Fan_Dark_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Fan_Dark_Green.jpg?v=1774522830",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Fan_Dark_Green.jpg?v=1774522830",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD11/ProductCarouselMain/GD11%20FDGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd11_Fan_Dark_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552164106",
      "product_title": "Native Spirit Unisex French Terry T-Shirt",
      "product_handle": "ns308",
      "product_url": "/products/ns308",
      "product_full_url": "https://oakdenemerch.com/products/ns308",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns308",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "NS308",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#445446",
      "sort_bucket": "green",
      "sort_hue": 0.354167,
      "sort_sat": 0.190476,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49472288424202",
      "swatch_filename": "NS308_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS308_Khaki.jpg?v=1774354362",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS308_Khaki.jpg?v=1774354362",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS308/ProductCarouselMain/NS308%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns308_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552360714",
      "product_title": "Native Spirit Unisex Oversized T-Shirt",
      "product_handle": "ns330",
      "product_url": "/products/ns330",
      "product_full_url": "https://oakdenemerch.com/products/ns330",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-ns330",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS330",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#445446",
      "sort_bucket": "green",
      "sort_hue": 0.354167,
      "sort_sat": 0.190476,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49473635156234",
      "swatch_filename": "NS330_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS330_Khaki.jpg?v=1774364535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS330_Khaki.jpg?v=1774364535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS330/ProductCarouselMain/NS330%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns330_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562396426",
      "product_title": "Native Spirit Ladies Ribbed Tank Top",
      "product_handle": "ns344",
      "product_url": "/products/ns344",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns344",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "98% organic combed cotton/2% recycled elastane.",
      "style_code": "NS344",
      "colour_name": "Organic Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#445446",
      "sort_bucket": "green",
      "sort_hue": 0.354167,
      "sort_sat": 0.190476,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49513931604234",
      "swatch_filename": "ns344_Organic_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns344_Organic_Khaki.jpg?v=1774619067",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns344_Organic_Khaki.jpg?v=1774619067",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS344/ProductCarouselMain/NS344%20ORK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns344_Organic_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552295178",
      "product_title": "Native Spirit Ladies T-Shirt",
      "product_handle": "ns324",
      "product_url": "/products/ns324",
      "product_full_url": "https://oakdenemerch.com/products/ns324",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns324",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS324",
      "colour_name": "Organic Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#445446",
      "sort_bucket": "green",
      "sort_hue": 0.354167,
      "sort_sat": 0.190476,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49472283541770",
      "swatch_filename": "NS324_Organic_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Organic_Khaki.jpg?v=1774354240",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Organic_Khaki.jpg?v=1774354240",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS324/ProductCarouselMain/NS324%20ORK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns324_Organic_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562330890",
      "product_title": "Native Spirit Ladies Tank Top",
      "product_handle": "ns341",
      "product_url": "/products/ns341",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns341",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS341",
      "colour_name": "Organic Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#445446",
      "sort_bucket": "green",
      "sort_hue": 0.354167,
      "sort_sat": 0.190476,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49513929900298",
      "swatch_filename": "ns341_Organic_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns341_Organic_Khaki.jpg?v=1774619043",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns341_Organic_Khaki.jpg?v=1774619043",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS341/ProductCarouselMain/NS341%20ORK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns341_Organic_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552393482",
      "product_title": "Native Spirit Oversized T-Shirt",
      "product_handle": "ns332",
      "product_url": "/products/ns332",
      "product_full_url": "https://oakdenemerch.com/products/ns332",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns332",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "NS332",
      "colour_name": "Organic Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#445446",
      "sort_bucket": "green",
      "sort_hue": 0.354167,
      "sort_sat": 0.190476,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49474121269514",
      "swatch_filename": "NS332_Organic_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_Organic_Khaki.jpg?v=1774369280",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_Organic_Khaki.jpg?v=1774369280",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS332/ProductCarouselMain/NS332%20ORK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns332_Organic_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687654666",
      "product_title": "Native Spirit Unisex Crew Neck Long Sleeve T-Shirt",
      "product_handle": "ns333",
      "product_url": "/products/ns333",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-ns333",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS333",
      "colour_name": "Organic Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#445446",
      "sort_bucket": "green",
      "sort_hue": 0.354167,
      "sort_sat": 0.190476,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49490480595210",
      "swatch_filename": "ns333_Organic_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns333_Organic_Khaki.jpg?v=1774522953",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns333_Organic_Khaki.jpg?v=1774522953",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS333/ProductCarouselMain/NS333%20ORK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns333_Organic_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Organic Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#445446",
      "sort_bucket": "green",
      "sort_hue": 0.354167,
      "sort_sat": 0.190476,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49473667236106",
      "swatch_filename": "NS305_Organic_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Organic_Khaki.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Organic_Khaki.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20ORK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Organic_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "Irish Green",
      "colour_group": "Green > Mid Green",
      "rgb": "#2ee045",
      "sort_bucket": "green",
      "sort_hue": 0.354869,
      "sort_sat": 0.794643,
      "sort_val": 0.878431,
      "swatch_file_id": "gid://shopify/MediaImage/49473588658442",
      "swatch_filename": "SR287_Irish_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Irish_Green.jpg?v=1774364345",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Irish_Green.jpg?v=1774364345",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20IGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_Irish_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#2e3d30",
      "sort_bucket": "green",
      "sort_hue": 0.355556,
      "sort_sat": 0.245902,
      "sort_val": 0.239216,
      "swatch_file_id": "gid://shopify/MediaImage/49474342813962",
      "swatch_filename": "AM10_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Forest_Green.jpg?v=1774371249",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Forest_Green.jpg?v=1774371249",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548395786",
      "product_title": "Anthem Unisex Organic Heavyweight T-Shirt",
      "product_handle": "am15",
      "product_url": "/products/am15",
      "product_full_url": "https://oakdenemerch.com/products/am15",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am15",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM15",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#2e3d30",
      "sort_bucket": "green",
      "sort_hue": 0.355556,
      "sort_sat": 0.245902,
      "sort_val": 0.239216,
      "swatch_file_id": "gid://shopify/MediaImage/49472895615242",
      "swatch_filename": "AM15_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Forest_Green.jpg?v=1774360325",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Forest_Green.jpg?v=1774360325",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM15/ProductCarouselMain/AM15%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am15_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548363018",
      "product_title": "Anthem Unisex Organic Midweight T-Shirt",
      "product_handle": "am12",
      "product_url": "/products/am12",
      "product_full_url": "https://oakdenemerch.com/products/am12",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am12",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM12",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#2e3d30",
      "sort_bucket": "green",
      "sort_hue": 0.355556,
      "sort_sat": 0.245902,
      "sort_val": 0.239216,
      "swatch_file_id": "gid://shopify/MediaImage/49472902562058",
      "swatch_filename": "AM12_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Forest_Green.jpg?v=1774360382",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Forest_Green.jpg?v=1774360382",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM12/ProductCarouselMain/AM12%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am12_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "Leaf Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#5d7360",
      "sort_bucket": "green",
      "sort_hue": 0.356061,
      "sort_sat": 0.191304,
      "sort_val": 0.45098,
      "swatch_file_id": "gid://shopify/MediaImage/49471257182474",
      "swatch_filename": "T520_Leaf_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Leaf_Green.jpg?v=1774348349",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Leaf_Green.jpg?v=1774348349",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20LFG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_Leaf_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556587786",
      "product_title": "Tee Jays Ladies Interlock T-Shirt",
      "product_handle": "t580",
      "product_url": "/products/t580",
      "product_full_url": "https://oakdenemerch.com/products/t580",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t580",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T580",
      "colour_name": "Leaf Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#5d7360",
      "sort_bucket": "green",
      "sort_hue": 0.356061,
      "sort_sat": 0.191304,
      "sort_val": 0.45098,
      "swatch_file_id": "gid://shopify/MediaImage/49469002285322",
      "swatch_filename": "T580_Leaf_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Leaf_Green.jpg?v=1774315823",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Leaf_Green.jpg?v=1774315823",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T580/ProductCarouselMain/T580%20LFG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t580_Leaf_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Leaf Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#5d7360",
      "sort_bucket": "green",
      "sort_hue": 0.356061,
      "sort_sat": 0.191304,
      "sort_val": 0.45098,
      "swatch_file_id": "gid://shopify/MediaImage/49474052260106",
      "swatch_filename": "T1150_Leaf_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Leaf_Green.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Leaf_Green.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20LFG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Leaf_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Moss",
      "colour_group": "Green > Olive/Military",
      "rgb": "#6f8572",
      "sort_bucket": "green",
      "sort_hue": 0.356061,
      "sort_sat": 0.165414,
      "sort_val": 0.521569,
      "swatch_file_id": "gid://shopify/MediaImage/49473667072266",
      "swatch_filename": "NS305_Moss.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Moss.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Moss.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20MOS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Moss.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Brook Green",
      "colour_group": "Green > Light Green",
      "rgb": "#abf2b5",
      "sort_bucket": "green",
      "sort_hue": 0.356808,
      "sort_sat": 0.293388,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49473667465482",
      "swatch_filename": "NS305_Brook_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Brook_Green.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Brook_Green.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20BRG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Brook_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Sage",
      "colour_group": "Green > Light Green",
      "rgb": "#829e86",
      "sort_bucket": "green",
      "sort_hue": 0.357143,
      "sort_sat": 0.177215,
      "sort_val": 0.619608,
      "swatch_file_id": "gid://shopify/MediaImage/49474267250954",
      "swatch_filename": "GD01_Sage.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Sage.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Sage.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20SAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Sage.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Sage",
      "colour_group": "Green > Light Green",
      "rgb": "#829e86",
      "sort_bucket": "green",
      "sort_hue": 0.357143,
      "sort_sat": 0.177215,
      "sort_val": 0.619608,
      "swatch_file_id": "gid://shopify/MediaImage/49471368560906",
      "swatch_filename": "GD15_Sage.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Sage.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Sage.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20SAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Sage.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562363658",
      "product_title": "Native Spirit Ladies Cropped Tank Top",
      "product_handle": "ns342",
      "product_url": "/products/ns342",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns342",
        "t-shirts",
        "womens",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS342",
      "colour_name": "Washed Organic Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#526f58",
      "sort_bucket": "green",
      "sort_hue": 0.367816,
      "sort_sat": 0.261261,
      "sort_val": 0.435294,
      "swatch_file_id": "gid://shopify/MediaImage/49513930883338",
      "swatch_filename": "ns342_Washed_Organic_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns342_Washed_Organic_Khaki.jpg?v=1774619057",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns342_Washed_Organic_Khaki.jpg?v=1774619057",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS342/ProductCarouselMain/NS342%20WOK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns342_Washed_Organic_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552262410",
      "product_title": "Native Spirit Ladies Faded T-Shirt",
      "product_handle": "ns316",
      "product_url": "/products/ns316",
      "product_full_url": "https://oakdenemerch.com/products/ns316",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns316",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS316",
      "colour_name": "Washed Organic Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#526f58",
      "sort_bucket": "green",
      "sort_hue": 0.367816,
      "sort_sat": 0.261261,
      "sort_val": 0.435294,
      "swatch_file_id": "gid://shopify/MediaImage/49472286654730",
      "swatch_filename": "NS316_Washed_Organic_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS316_Washed_Organic_Khaki.jpg?v=1774354318",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS316_Washed_Organic_Khaki.jpg?v=1774354318",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS316/ProductCarouselMain/NS316%20WOK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns316_Washed_Organic_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "52% cotton/48% polyester.",
      "style_code": "SS621",
      "colour_name": "Heather Green",
      "colour_group": "Green > Heather/Effect Green",
      "rgb": "#34d156",
      "sort_bucket": "green",
      "sort_hue": 0.369427,
      "sort_sat": 0.751196,
      "sort_val": 0.819608,
      "swatch_file_id": "gid://shopify/MediaImage/49471285559562",
      "swatch_filename": "SS621_Heather_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Heather_Green.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Heather_Green.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20HGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Heather_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "Olive Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#2e4e35",
      "sort_bucket": "green",
      "sort_hue": 0.369792,
      "sort_sat": 0.410256,
      "sort_val": 0.305882,
      "swatch_file_id": "gid://shopify/MediaImage/49473272807690",
      "swatch_filename": "180M_Olive_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Olive_Green.jpg?v=1774363125",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Olive_Green.jpg?v=1774363125",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20OLI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_Olive_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#0d3c19",
      "sort_bucket": "green",
      "sort_hue": 0.375887,
      "sort_sat": 0.783333,
      "sort_val": 0.235294,
      "swatch_file_id": "gid://shopify/MediaImage/49471285854474",
      "swatch_filename": "SS621_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Forest_Green.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Forest_Green.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#188b36",
      "sort_bucket": "green",
      "sort_hue": 0.376812,
      "sort_sat": 0.827338,
      "sort_val": 0.545098,
      "swatch_file_id": "gid://shopify/MediaImage/49474088632586",
      "swatch_filename": "RX151_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Kelly_Green.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Kelly_Green.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "College Green",
      "colour_group": "Green > Mid Green",
      "rgb": "#00a633",
      "sort_bucket": "green",
      "sort_hue": 0.384538,
      "sort_sat": 1.0,
      "sort_val": 0.65098,
      "swatch_file_id": "gid://shopify/MediaImage/49471313772810",
      "swatch_filename": "SS620_College_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_College_Green.jpg?v=1774348567",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_College_Green.jpg?v=1774348567",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20CLG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_College_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#06c240",
      "sort_bucket": "green",
      "sort_hue": 0.384752,
      "sort_sat": 0.969072,
      "sort_val": 0.760784,
      "swatch_file_id": "gid://shopify/MediaImage/49474267218186",
      "swatch_filename": "GD01_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Kelly_Green.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Kelly_Green.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#06c240",
      "sort_bucket": "green",
      "sort_hue": 0.384752,
      "sort_sat": 0.969072,
      "sort_val": 0.760784,
      "swatch_file_id": "gid://shopify/MediaImage/49471397658890",
      "swatch_filename": "GD02_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Kelly_Green.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Kelly_Green.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1f4c2d",
      "sort_bucket": "green",
      "sort_hue": 0.385185,
      "sort_sat": 0.592105,
      "sort_val": 0.298039,
      "swatch_file_id": "gid://shopify/MediaImage/49474468413706",
      "swatch_filename": "03582_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Bottle_Green.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Bottle_Green.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547511050",
      "product_title": "SOL'S Crusader Recycled T-Shirt",
      "product_handle": "04233",
      "product_url": "/products/04233",
      "product_full_url": "https://oakdenemerch.com/products/04233",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04233",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% recycled cotton/50% cotton.*",
      "style_code": "04233",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1f4c2d",
      "sort_bucket": "green",
      "sort_hue": 0.385185,
      "sort_sat": 0.592105,
      "sort_val": 0.298039,
      "swatch_file_id": "gid://shopify/MediaImage/49473285095690",
      "swatch_filename": "04233_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Bottle_Green.jpg?v=1774363191",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Bottle_Green.jpg?v=1774363191",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04233/ProductCarouselMain/04233%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04233_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1f4c2d",
      "sort_bucket": "green",
      "sort_hue": 0.385185,
      "sort_sat": 0.592105,
      "sort_val": 0.298039,
      "swatch_file_id": "gid://shopify/MediaImage/49474448883978",
      "swatch_filename": "11500_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Bottle_Green.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Bottle_Green.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685623050",
      "product_title": "SOL'S Imperial Long Sleeve T-Shirt",
      "product_handle": "02074",
      "product_url": "/products/02074",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-02074",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "02074",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1f4c2d",
      "sort_bucket": "green",
      "sort_hue": 0.385185,
      "sort_sat": 0.592105,
      "sort_val": 0.298039,
      "swatch_file_id": "gid://shopify/MediaImage/49490366791946",
      "swatch_filename": "02074_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02074_Bottle_Green.jpg?v=1774522703",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02074_Bottle_Green.jpg?v=1774522703",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02074/ProductCarouselMain/02074%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02074_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1f4c2d",
      "sort_bucket": "green",
      "sort_hue": 0.385185,
      "sort_sat": 0.592105,
      "sort_val": 0.298039,
      "swatch_file_id": "gid://shopify/MediaImage/49468835692810",
      "swatch_filename": "03581_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Bottle_Green.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Bottle_Green.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1f4c2d",
      "sort_bucket": "green",
      "sort_hue": 0.385185,
      "sort_sat": 0.592105,
      "sort_val": 0.298039,
      "swatch_file_id": "gid://shopify/MediaImage/49468933767434",
      "swatch_filename": "11502_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Bottle_Green.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Bottle_Green.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685688586",
      "product_title": "SOL'S Ladies Imperial Long Sleeve T-Shirt",
      "product_handle": "02075",
      "product_url": "/products/02075",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-02075",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "02075",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1f4c2d",
      "sort_bucket": "green",
      "sort_hue": 0.385185,
      "sort_sat": 0.592105,
      "sort_val": 0.298039,
      "swatch_file_id": "gid://shopify/MediaImage/49490367381770",
      "swatch_filename": "02075_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02075_Bottle_Green.jpg?v=1774522712",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02075_Bottle_Green.jpg?v=1774522712",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02075/ProductCarouselMain/02075%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02075_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1f4c2d",
      "sort_bucket": "green",
      "sort_hue": 0.385185,
      "sort_sat": 0.592105,
      "sort_val": 0.298039,
      "swatch_file_id": "gid://shopify/MediaImage/49468833464586",
      "swatch_filename": "03579_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Bottle_Green.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Bottle_Green.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1f4c2d",
      "sort_bucket": "green",
      "sort_hue": 0.385185,
      "sort_sat": 0.592105,
      "sort_val": 0.298039,
      "swatch_file_id": "gid://shopify/MediaImage/49468823077130",
      "swatch_filename": "01825_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Bottle_Green.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Bottle_Green.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03565",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1f4c2d",
      "sort_bucket": "green",
      "sort_hue": 0.385185,
      "sort_sat": 0.592105,
      "sort_val": 0.298039,
      "swatch_file_id": "gid://shopify/MediaImage/49473305968906",
      "swatch_filename": "03565_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Bottle_Green.jpg?v=1774363313",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Bottle_Green.jpg?v=1774363313",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1f4c2d",
      "sort_bucket": "green",
      "sort_hue": 0.385185,
      "sort_sat": 0.592105,
      "sort_val": 0.298039,
      "swatch_file_id": "gid://shopify/MediaImage/49473718452490",
      "swatch_filename": "11380_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Bottle_Green.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Bottle_Green.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Forest Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#173a23",
      "sort_bucket": "green",
      "sort_hue": 0.390476,
      "sort_sat": 0.603448,
      "sort_val": 0.227451,
      "swatch_file_id": "gid://shopify/MediaImage/49473666613514",
      "swatch_filename": "NS305_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Forest_Green.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Forest_Green.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Sage Green",
      "colour_group": "Green > Light Green",
      "rgb": "#91c2a2",
      "sort_bucket": "green",
      "sort_hue": 0.391156,
      "sort_sat": 0.252577,
      "sort_val": 0.760784,
      "swatch_file_id": "gid://shopify/MediaImage/49473259077898",
      "swatch_filename": "CV3001_Sage_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Sage_Green.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Sage_Green.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20SAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Sage_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548690698",
      "product_title": "Bella Ladies Heavy Boxy T-Shirt",
      "product_handle": "bl6110",
      "product_url": "/products/bl6110",
      "product_full_url": "https://oakdenemerch.com/products/bl6110",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-bl6110",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "BL6110",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1d3f29",
      "sort_bucket": "green",
      "sort_hue": 0.392157,
      "sort_sat": 0.539683,
      "sort_val": 0.247059,
      "swatch_file_id": "gid://shopify/MediaImage/49472881328394",
      "swatch_filename": "BL6110_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_Forest_Green.jpg?v=1774360125",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_Forest_Green.jpg?v=1774360125",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL6110/ProductCarouselMain/BL6110%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl6110_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1d3f29",
      "sort_bucket": "green",
      "sort_hue": 0.392157,
      "sort_sat": 0.539683,
      "sort_val": 0.247059,
      "swatch_file_id": "gid://shopify/MediaImage/49473259634954",
      "swatch_filename": "CV3001_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Forest_Green.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Forest_Green.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548920074",
      "product_title": "Canvas Unisex Heavyweight Boxy T-Shirt",
      "product_handle": "cv3010",
      "product_url": "/products/cv3010",
      "product_full_url": "https://oakdenemerch.com/products/cv3010",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv3010",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3010",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1d3f29",
      "sort_bucket": "green",
      "sort_hue": 0.392157,
      "sort_sat": 0.539683,
      "sort_val": 0.247059,
      "swatch_file_id": "gid://shopify/MediaImage/49472879362314",
      "swatch_filename": "CV3010_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_Forest_Green.jpg?v=1774360083",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_Forest_Green.jpg?v=1774360083",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3010/ProductCarouselMain/CV3010%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3010_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686737162",
      "product_title": "Canvas Unisex Heavyweight Long Sleeve Boxy T-Shirt",
      "product_handle": "cv3511",
      "product_url": "/products/cv3511",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv3511",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3511",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1d3f29",
      "sort_bucket": "green",
      "sort_hue": 0.392157,
      "sort_sat": 0.539683,
      "sort_val": 0.247059,
      "swatch_file_id": "gid://shopify/MediaImage/49490425938186",
      "swatch_filename": "cv3511_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_Forest_Green.jpg?v=1774522802",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_Forest_Green.jpg?v=1774522802",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3511/ProductCarouselMain/CV3511%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3511_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552295178",
      "product_title": "Native Spirit Ladies T-Shirt",
      "product_handle": "ns324",
      "product_url": "/products/ns324",
      "product_full_url": "https://oakdenemerch.com/products/ns324",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns324",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS324",
      "colour_name": "Jade Green",
      "colour_group": "Green > Light Green",
      "rgb": "#87c29c",
      "sort_bucket": "green",
      "sort_hue": 0.392655,
      "sort_sat": 0.304124,
      "sort_val": 0.760784,
      "swatch_file_id": "gid://shopify/MediaImage/49472283312394",
      "swatch_filename": "NS324_Jade_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Jade_Green.jpg?v=1774354240",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Jade_Green.jpg?v=1774354240",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS324/ProductCarouselMain/NS324%20JAD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns324_Jade_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562330890",
      "product_title": "Native Spirit Ladies Tank Top",
      "product_handle": "ns341",
      "product_url": "/products/ns341",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns341",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS341",
      "colour_name": "Jade Green",
      "colour_group": "Green > Light Green",
      "rgb": "#87c29c",
      "sort_bucket": "green",
      "sort_hue": 0.392655,
      "sort_sat": 0.304124,
      "sort_val": 0.760784,
      "swatch_file_id": "gid://shopify/MediaImage/49513930064138",
      "swatch_filename": "ns341_Jade_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns341_Jade_Green.jpg?v=1774619045",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns341_Jade_Green.jpg?v=1774619045",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS341/ProductCarouselMain/NS341%20JAD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns341_Jade_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Jade Green",
      "colour_group": "Green > Light Green",
      "rgb": "#87c29c",
      "sort_bucket": "green",
      "sort_hue": 0.392655,
      "sort_sat": 0.304124,
      "sort_val": 0.760784,
      "swatch_file_id": "gid://shopify/MediaImage/49473667498250",
      "swatch_filename": "NS305_Jade_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Jade_Green.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Jade_Green.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20JAD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Jade_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547478282",
      "product_title": "SOL'S Unisex Tuner T-Shirt",
      "product_handle": "04203",
      "product_url": "/products/04203",
      "product_full_url": "https://oakdenemerch.com/products/04203",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-04203",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.*",
      "style_code": "04203",
      "colour_name": "Irish Green",
      "colour_group": "Green > Mid Green",
      "rgb": "#21a254",
      "sort_bucket": "green",
      "sort_hue": 0.399225,
      "sort_sat": 0.796296,
      "sort_val": 0.635294,
      "swatch_file_id": "gid://shopify/MediaImage/49474458812682",
      "swatch_filename": "04203_Irish_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_Irish_Green.jpg?v=1774372011",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_Irish_Green.jpg?v=1774372011",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04203/ProductCarouselMain/04203%20IGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04203_Irish_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#00461c",
      "sort_bucket": "green",
      "sort_hue": 0.4,
      "sort_sat": 1.0,
      "sort_val": 0.27451,
      "swatch_file_id": "gid://shopify/MediaImage/49473273037066",
      "swatch_filename": "180M_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Bottle_Green.jpg?v=1774363124",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Bottle_Green.jpg?v=1774363124",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546724618",
      "product_title": "Russell Athletic Heavyweight T-Shirt",
      "product_handle": "010m",
      "product_url": "/products/010m",
      "product_full_url": "https://oakdenemerch.com/products/010m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-010m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "010M",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#00461c",
      "sort_bucket": "green",
      "sort_hue": 0.4,
      "sort_sat": 1.0,
      "sort_val": 0.27451,
      "swatch_file_id": "gid://shopify/MediaImage/49468778283274",
      "swatch_filename": "010M_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/010M_Bottle_Green.jpg?v=1774311231",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/010M_Bottle_Green.jpg?v=1774311231",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/010M/ProductCarouselMain/010M%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "010m_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548199178",
      "product_title": "Russell Athletic Kids Classic Ringspun T-Shirt",
      "product_handle": "180b",
      "product_url": "/products/180b",
      "product_full_url": "https://oakdenemerch.com/products/180b",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "PCBest_Seller",
        "performance-activewear",
        "sports",
        "style-180b",
        "t-shirts"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.",
      "style_code": "180B",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#00461c",
      "sort_bucket": "green",
      "sort_hue": 0.4,
      "sort_sat": 1.0,
      "sort_val": 0.27451,
      "swatch_file_id": "gid://shopify/MediaImage/49474443411722",
      "swatch_filename": "180B_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_Bottle_Green.jpg?v=1774371757",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_Bottle_Green.jpg?v=1774371757",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180B/ProductCarouselMain/180B%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180b_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548559626",
      "product_title": "AWDis Heavyweight Boxy 240 T-Shirt",
      "product_handle": "at003",
      "product_url": "/products/at003",
      "product_full_url": "https://oakdenemerch.com/products/at003",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-at003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT003",
      "colour_name": "Moss Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#135e31",
      "sort_bucket": "green",
      "sort_hue": 0.4,
      "sort_sat": 0.797872,
      "sort_val": 0.368627,
      "swatch_file_id": "gid://shopify/MediaImage/49472884441354",
      "swatch_filename": "AT003_Moss_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT003_Moss_Green.jpg?v=1774360179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT003_Moss_Green.jpg?v=1774360179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT003/ProductCarouselMain/AT003%20MOS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at003_Moss_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "Forest Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#23382c",
      "sort_bucket": "green",
      "sort_hue": 0.404762,
      "sort_sat": 0.375,
      "sort_val": 0.219608,
      "swatch_file_id": "gid://shopify/MediaImage/49491372933386",
      "swatch_filename": "kb3025ic_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Forest_Green.jpg?v=1774526627",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Forest_Green.jpg?v=1774526627",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551639818",
      "product_title": "Kariban Unisex 190IC Crew Neck T-Shirt",
      "product_handle": "kb3032ic",
      "product_url": "/products/kb3032ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3032ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3032IC",
      "colour_name": "Forest Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#23382c",
      "sort_bucket": "green",
      "sort_hue": 0.404762,
      "sort_sat": 0.375,
      "sort_val": 0.219608,
      "swatch_file_id": "gid://shopify/MediaImage/49491364839690",
      "swatch_filename": "kb3032ic_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Forest_Green.jpg?v=1774526602",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Forest_Green.jpg?v=1774526602",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3032IC/ProductCarouselMain/KB3032IC%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3032ic_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549247754",
      "product_title": "Ecologie Arrow Recycled Heavy Oversize T-Shirt",
      "product_handle": "ea006",
      "product_url": "/products/ea006",
      "product_full_url": "https://oakdenemerch.com/products/ea006",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ea006",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "48% recycled cotton/47% recycled polyester/5% elastane.",
      "style_code": "EA006",
      "colour_name": "Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#274e38",
      "sort_bucket": "green",
      "sort_hue": 0.405983,
      "sort_sat": 0.5,
      "sort_val": 0.305882,
      "swatch_file_id": "gid://shopify/MediaImage/49472604766474",
      "swatch_filename": "EA006_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA006_Green.jpg?v=1774358065",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA006_Green.jpg?v=1774358065",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA006/ProductCarouselMain/EA006%20GRN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea006_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Mid Green",
      "rgb": "#24ad61",
      "sort_bucket": "green",
      "sort_hue": 0.407543,
      "sort_sat": 0.791908,
      "sort_val": 0.678431,
      "swatch_file_id": "gid://shopify/MediaImage/49473259340042",
      "swatch_filename": "CV3001_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Kelly_Green.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Kelly_Green.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Emerald",
      "colour_group": "Green > Emerald/Jade",
      "rgb": "#035227",
      "sort_bucket": "green",
      "sort_hue": 0.409283,
      "sort_sat": 0.963415,
      "sort_val": 0.321569,
      "swatch_file_id": "gid://shopify/MediaImage/49474448523530",
      "swatch_filename": "11500_Emerald.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Emerald.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Emerald.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20EME%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Emerald.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Emerald",
      "colour_group": "Green > Emerald/Jade",
      "rgb": "#035227",
      "sort_bucket": "green",
      "sort_hue": 0.409283,
      "sort_sat": 0.963415,
      "sort_val": 0.321569,
      "swatch_file_id": "gid://shopify/MediaImage/49468933898506",
      "swatch_filename": "11502_Emerald.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Emerald.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Emerald.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20EME%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Emerald.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Emerald",
      "colour_group": "Green > Emerald/Jade",
      "rgb": "#035227",
      "sort_bucket": "green",
      "sort_hue": 0.409283,
      "sort_sat": 0.963415,
      "sort_val": 0.321569,
      "swatch_file_id": "gid://shopify/MediaImage/49473718223114",
      "swatch_filename": "11380_Emerald.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Emerald.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Emerald.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20EME%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Emerald.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Zinc",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#799184",
      "sort_bucket": "green",
      "sort_hue": 0.409722,
      "sort_sat": 0.165517,
      "sort_val": 0.568627,
      "swatch_file_id": "gid://shopify/MediaImage/49473719271690",
      "swatch_filename": "11380_Zinc.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Zinc.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Zinc.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20ZIN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Zinc.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552885002",
      "product_title": "Regatta Ladies Ada Cotton Stretch T-Shirt",
      "product_handle": "rg810",
      "product_url": "/products/rg810",
      "product_full_url": "https://oakdenemerch.com/products/rg810",
      "vendor": "Regatta Professional",
      "product_type": "T-Shirt",
      "tags": [
        "10",
        "12",
        "14",
        "16",
        "18",
        "20",
        "8",
        "8-10-12-14-16-18-20",
        "style-rg810",
        "t-shirts",
        "womens"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "95% sustainable cotton/5% elastane.",
      "style_code": "RG810",
      "colour_name": "Wilderness Green",
      "colour_group": "Green > Mid Green",
      "rgb": "#45ffa1",
      "sort_bucket": "green",
      "sort_hue": 0.415771,
      "sort_sat": 0.729412,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474093482250",
      "swatch_filename": "RG810_Wilderness_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RG810_Wilderness_Green.jpg?v=1774368984",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RG810_Wilderness_Green.jpg?v=1774368984",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Regatta%20Professional/Product%20Images/RG810/ProductCarouselMain/RG810%20GRN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rg810_Wilderness_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Jade Dome",
      "colour_group": "Green > Emerald/Jade",
      "rgb": "#08cf6d",
      "sort_bucket": "green",
      "sort_hue": 0.417923,
      "sort_sat": 0.961353,
      "sort_val": 0.811765,
      "swatch_file_id": "gid://shopify/MediaImage/49474266956042",
      "swatch_filename": "GD01_Jade_Dome.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Jade_Dome.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Jade_Dome.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20JDD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Jade_Dome.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Jade Dome",
      "colour_group": "Green > Emerald/Jade",
      "rgb": "#08cf6d",
      "sort_bucket": "green",
      "sort_hue": 0.417923,
      "sort_sat": 0.961353,
      "sort_val": 0.811765,
      "swatch_file_id": "gid://shopify/MediaImage/49471397921034",
      "swatch_filename": "GD02_Jade_Dome.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Jade_Dome.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Jade_Dome.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20JDD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Jade_Dome.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548428554",
      "product_title": "Anthem Amplify Heavyweight T-Shirt",
      "product_handle": "am18",
      "product_url": "/products/am18",
      "product_full_url": "https://oakdenemerch.com/products/am18",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-am18",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM18",
      "colour_name": "Green Mist",
      "colour_group": "Green > Mid Green",
      "rgb": "#426f59",
      "sort_bucket": "green",
      "sort_hue": 0.418519,
      "sort_sat": 0.405405,
      "sort_val": 0.435294,
      "swatch_file_id": "gid://shopify/MediaImage/49472893124874",
      "swatch_filename": "AM18_Green_Mist.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_Green_Mist.jpg?v=1774360285",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_Green_Mist.jpg?v=1774360285",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM18/ProductCarouselMain/AM18%20GMT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am18_Green_Mist.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#0c5130",
      "sort_bucket": "green",
      "sort_hue": 0.42029,
      "sort_sat": 0.851852,
      "sort_val": 0.317647,
      "swatch_file_id": "gid://shopify/MediaImage/49473588199690",
      "swatch_filename": "SR287_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Bottle_Green.jpg?v=1774364345",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Bottle_Green.jpg?v=1774364345",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554097418",
      "product_title": "Spiro Kids Impact Performance Aircool T-Shirt",
      "product_handle": "sr287b",
      "product_url": "/products/sr287b",
      "product_full_url": "https://oakdenemerch.com/products/sr287b",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "children",
        "kids",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287b",
        "t-shirts",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287B",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#0c5130",
      "sort_bucket": "green",
      "sort_hue": 0.42029,
      "sort_sat": 0.851852,
      "sort_val": 0.317647,
      "swatch_file_id": "gid://shopify/MediaImage/49474059796746",
      "swatch_filename": "SR287B_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Bottle_Green.jpg?v=1774368252",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Bottle_Green.jpg?v=1774368252",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287B/ProductCarouselMain/SR287B%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287b_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "Dark Olive",
      "colour_group": "Green > Olive/Military",
      "rgb": "#36473f",
      "sort_bucket": "green",
      "sort_hue": 0.421569,
      "sort_sat": 0.239437,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49471257608458",
      "swatch_filename": "T520_Dark_Olive.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Dark_Olive.jpg?v=1774348349",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Dark_Olive.jpg?v=1774348349",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20DLV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_Dark_Olive.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Sage",
      "colour_group": "Green > Light Green",
      "rgb": "#67c398",
      "sort_bucket": "green",
      "sort_hue": 0.422101,
      "sort_sat": 0.471795,
      "sort_val": 0.764706,
      "swatch_file_id": "gid://shopify/MediaImage/49471285952778",
      "swatch_filename": "SS621_Sage.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Sage.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Sage.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20SAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Sage.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Sage",
      "colour_group": "Green > Light Green",
      "rgb": "#67c398",
      "sort_bucket": "green",
      "sort_hue": 0.422101,
      "sort_sat": 0.471795,
      "sort_val": 0.764706,
      "swatch_file_id": "gid://shopify/MediaImage/49471313117450",
      "swatch_filename": "SS620_Sage.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Sage.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Sage.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20SAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Sage.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS720",
      "colour_name": "Sage",
      "colour_group": "Green > Light Green",
      "rgb": "#67c398",
      "sort_bucket": "green",
      "sort_hue": 0.422101,
      "sort_sat": 0.471795,
      "sort_val": 0.764706,
      "swatch_file_id": "gid://shopify/MediaImage/49472218988810",
      "swatch_filename": "SS720_Sage.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Sage.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Sage.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20SAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_Sage.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554457866",
      "product_title": "Fruit of the Loom Pure Cotton T-Shirt",
      "product_handle": "ss640",
      "product_url": "/products/ss640",
      "product_full_url": "https://oakdenemerch.com/products/ss640",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss640",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "SS640",
      "colour_name": "Sage",
      "colour_group": "Green > Light Green",
      "rgb": "#67c398",
      "sort_bucket": "green",
      "sort_hue": 0.422101,
      "sort_sat": 0.471795,
      "sort_val": 0.764706,
      "swatch_file_id": "gid://shopify/MediaImage/49468957950218",
      "swatch_filename": "SS640_Sage.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Sage.jpg?v=1774315114",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Sage.jpg?v=1774315114",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS640/ProductCarouselMain/SS640%20SAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss640_Sage.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Cactus",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#226b49",
      "sort_bucket": "green",
      "sort_hue": 0.422374,
      "sort_sat": 0.682243,
      "sort_val": 0.419608,
      "swatch_file_id": "gid://shopify/MediaImage/49474052391178",
      "swatch_filename": "T1150_Cactus.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Cactus.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Cactus.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20CAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Cactus.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#009c5c",
      "sort_bucket": "green",
      "sort_hue": 0.431624,
      "sort_sat": 1.0,
      "sort_val": 0.611765,
      "swatch_file_id": "gid://shopify/MediaImage/49474343010570",
      "swatch_filename": "AM10_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Kelly_Green.jpg?v=1774371250",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Kelly_Green.jpg?v=1774371250",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#007044",
      "sort_bucket": "green",
      "sort_hue": 0.434524,
      "sort_sat": 1.0,
      "sort_val": 0.439216,
      "swatch_file_id": "gid://shopify/MediaImage/49491373785354",
      "swatch_filename": "kb3025ic_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Kelly_Green.jpg?v=1774526629",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Kelly_Green.jpg?v=1774526629",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551639818",
      "product_title": "Kariban Unisex 190IC Crew Neck T-Shirt",
      "product_handle": "kb3032ic",
      "product_url": "/products/kb3032ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3032ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3032IC",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#007044",
      "sort_bucket": "green",
      "sort_hue": 0.434524,
      "sort_sat": 1.0,
      "sort_val": 0.439216,
      "swatch_file_id": "gid://shopify/MediaImage/49491365593354",
      "swatch_filename": "kb3032ic_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Kelly_Green.jpg?v=1774526603",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Kelly_Green.jpg?v=1774526603",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3032IC/ProductCarouselMain/KB3032IC%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3032ic_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687294218",
      "product_title": "AWDis Cool Long Sleeve Active T-Shirt",
      "product_handle": "jc023",
      "product_url": "/products/jc023",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jc023",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "JC023",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#15221d",
      "sort_bucket": "green",
      "sort_hue": 0.435897,
      "sort_sat": 0.382353,
      "sort_val": 0.133333,
      "swatch_file_id": "gid://shopify/MediaImage/49490478498058",
      "swatch_filename": "jc023_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc023_Charcoal.jpg?v=1774522908",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc023_Charcoal.jpg?v=1774522908",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC023/ProductCarouselMain/JC023%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc023_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687228682",
      "product_title": "AWDis Cool Long Sleeve Wicking T-Shirt",
      "product_handle": "jc002",
      "product_url": "/products/jc002",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jc002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC002",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#15221d",
      "sort_bucket": "green",
      "sort_hue": 0.435897,
      "sort_sat": 0.382353,
      "sort_val": 0.133333,
      "swatch_file_id": "gid://shopify/MediaImage/49490477121802",
      "swatch_filename": "jc002_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Charcoal.jpg?v=1774522893",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Charcoal.jpg?v=1774522893",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC002/ProductCarouselMain/JC002%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc002_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550361866",
      "product_title": "AWDis Cool Smooth T-Shirt",
      "product_handle": "jc020",
      "product_url": "/products/jc020",
      "product_full_url": "https://oakdenemerch.com/products/jc020",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-jc020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#15221d",
      "sort_bucket": "green",
      "sort_hue": 0.435897,
      "sort_sat": 0.382353,
      "sort_val": 0.133333,
      "swatch_file_id": "gid://shopify/MediaImage/49472871694602",
      "swatch_filename": "JC020_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Charcoal.jpg?v=1774359994",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Charcoal.jpg?v=1774359994",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020/ProductCarouselMain/JC020%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#15221d",
      "sort_bucket": "green",
      "sort_hue": 0.435897,
      "sort_sat": 0.382353,
      "sort_val": 0.133333,
      "swatch_file_id": "gid://shopify/MediaImage/49474218459402",
      "swatch_filename": "JC001_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Charcoal.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Charcoal.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562003210",
      "product_title": "AWDis Cool Vest",
      "product_handle": "jc007",
      "product_url": "/products/jc007",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc007",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#15221d",
      "sort_bucket": "green",
      "sort_hue": 0.435897,
      "sort_sat": 0.382353,
      "sort_val": 0.133333,
      "swatch_file_id": "gid://shopify/MediaImage/49513923805450",
      "swatch_filename": "jc007_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Charcoal.jpg?v=1774618976",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Charcoal.jpg?v=1774618976",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC007/ProductCarouselMain/JC007%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#15221d",
      "sort_bucket": "green",
      "sort_hue": 0.435897,
      "sort_sat": 0.382353,
      "sort_val": 0.133333,
      "swatch_file_id": "gid://shopify/MediaImage/49474210464010",
      "swatch_filename": "JC001B_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Charcoal.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Charcoal.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#15221d",
      "sort_bucket": "green",
      "sort_hue": 0.435897,
      "sort_sat": 0.382353,
      "sort_val": 0.133333,
      "swatch_file_id": "gid://shopify/MediaImage/49473142227210",
      "swatch_filename": "JC005_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Charcoal.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Charcoal.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562101514",
      "product_title": "AWDis Ladies Cool Vest",
      "product_handle": "jc015",
      "product_url": "/products/jc015",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc015",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC015",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#15221d",
      "sort_bucket": "green",
      "sort_hue": 0.435897,
      "sort_sat": 0.382353,
      "sort_val": 0.133333,
      "swatch_file_id": "gid://shopify/MediaImage/49513927606538",
      "swatch_filename": "jc015_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Charcoal.jpg?v=1774619006",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Charcoal.jpg?v=1774619006",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC015/ProductCarouselMain/JC015%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc015_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD05",
      "colour_name": "Antique Jade Dome",
      "colour_group": "Green > Emerald/Jade",
      "rgb": "#036e47",
      "sort_bucket": "green",
      "sort_hue": 0.439252,
      "sort_sat": 0.972727,
      "sort_val": 0.431373,
      "swatch_file_id": "gid://shopify/MediaImage/49471384617226",
      "swatch_filename": "GD05_Antique_Jade_Dome.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Antique_Jade_Dome.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Antique_Jade_Dome.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20AJD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Antique_Jade_Dome.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Sour Green",
      "colour_group": "Green > Mid Green",
      "rgb": "#00ffa3",
      "sort_bucket": "green",
      "sort_hue": 0.439869,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474219016458",
      "swatch_filename": "JC001_Sour_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Sour_Green.jpg?v=1774370458",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Sour_Green.jpg?v=1774370458",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20SOU%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Sour_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Sour Green",
      "colour_group": "Green > Mid Green",
      "rgb": "#00ffa3",
      "sort_bucket": "green",
      "sort_hue": 0.439869,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474210038026",
      "swatch_filename": "JC001B_Sour_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Sour_Green.jpg?v=1774370371",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Sour_Green.jpg?v=1774370371",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20SOU%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Sour_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Jade",
      "colour_group": "Green > Emerald/Jade",
      "rgb": "#059967",
      "sort_bucket": "green",
      "sort_hue": 0.443694,
      "sort_sat": 0.96732,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49474218557706",
      "swatch_filename": "JC001_Jade.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Jade.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Jade.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20JAD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Jade.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562003210",
      "product_title": "AWDis Cool Vest",
      "product_handle": "jc007",
      "product_url": "/products/jc007",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc007",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007",
      "colour_name": "Jade",
      "colour_group": "Green > Emerald/Jade",
      "rgb": "#059967",
      "sort_bucket": "green",
      "sort_hue": 0.443694,
      "sort_sat": 0.96732,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49513923870986",
      "swatch_filename": "jc007_Jade.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Jade.jpg?v=1774618977",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Jade.jpg?v=1774618977",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC007/ProductCarouselMain/JC007%20JAD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007_Jade.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Jade",
      "colour_group": "Green > Emerald/Jade",
      "rgb": "#059967",
      "sort_bucket": "green",
      "sort_hue": 0.443694,
      "sort_sat": 0.96732,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49474210136330",
      "swatch_filename": "JC001B_Jade.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Jade.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Jade.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20JAD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Jade.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Jade",
      "colour_group": "Green > Emerald/Jade",
      "rgb": "#059967",
      "sort_bucket": "green",
      "sort_hue": 0.443694,
      "sort_sat": 0.96732,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49473142554890",
      "swatch_filename": "JC005_Jade.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Jade.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Jade.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20JAD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Jade.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Mint",
      "colour_group": "Green > Light Green",
      "rgb": "#9ef5d9",
      "sort_bucket": "green",
      "sort_hue": 0.44636,
      "sort_sat": 0.355102,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49474217672970",
      "swatch_filename": "JC001_Mint.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Mint.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Mint.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20MIN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Mint.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Mint",
      "colour_group": "Green > Light Green",
      "rgb": "#9ef5d9",
      "sort_bucket": "green",
      "sort_hue": 0.44636,
      "sort_sat": 0.355102,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49474210726154",
      "swatch_filename": "JC001B_Mint.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Mint.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Mint.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20MIN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Mint.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550230794",
      "product_title": "AWDis Ladies Cool Open Back T-Shirt",
      "product_handle": "jc013",
      "product_url": "/products/jc013",
      "product_full_url": "https://oakdenemerch.com/products/jc013",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-jc013",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC013",
      "colour_name": "Mint",
      "colour_group": "Green > Light Green",
      "rgb": "#9ef5d9",
      "sort_bucket": "green",
      "sort_hue": 0.44636,
      "sort_sat": 0.355102,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49474195063050",
      "swatch_filename": "JC013_Mint.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC013_Mint.jpg?v=1774370211",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC013_Mint.jpg?v=1774370211",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC013/ProductCarouselMain/JC013%20MIN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc013_Mint.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Mint",
      "colour_group": "Green > Light Green",
      "rgb": "#9ef5d9",
      "sort_bucket": "green",
      "sort_hue": 0.44636,
      "sort_sat": 0.355102,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49473142587658",
      "swatch_filename": "JC005_Mint.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Mint.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Mint.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20MIN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Mint.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Zinc",
      "colour_group": "Grey > Light Grey",
      "rgb": "#9fbbb2",
      "sort_bucket": "green",
      "sort_hue": 0.446429,
      "sort_sat": 0.149733,
      "sort_val": 0.733333,
      "swatch_file_id": "gid://shopify/MediaImage/49471286051082",
      "swatch_filename": "SS621_Zinc.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Zinc.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Zinc.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20ZIN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Zinc.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Zinc",
      "colour_group": "Grey > Light Grey",
      "rgb": "#9fbbb2",
      "sort_bucket": "green",
      "sort_hue": 0.446429,
      "sort_sat": 0.149733,
      "sort_val": 0.733333,
      "swatch_file_id": "gid://shopify/MediaImage/49471313477898",
      "swatch_filename": "SS620_Zinc.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Zinc.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Zinc.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20ZIN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Zinc.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Green Empire",
      "colour_group": "Green > Dark Green",
      "rgb": "#174637",
      "sort_bucket": "green",
      "sort_hue": 0.446809,
      "sort_sat": 0.671429,
      "sort_val": 0.27451,
      "swatch_file_id": "gid://shopify/MediaImage/49473744470282",
      "swatch_filename": "03981_Green_Empire.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Green_Empire.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Green_Empire.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20GMP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Green_Empire.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685786890",
      "product_title": "SOL'S Unisex Pioneer Long Sleeve T-Shirt",
      "product_handle": "03982",
      "product_url": "/products/03982",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03982",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03982",
      "colour_name": "Green Empire",
      "colour_group": "Green > Dark Green",
      "rgb": "#174637",
      "sort_bucket": "green",
      "sort_hue": 0.446809,
      "sort_sat": 0.671429,
      "sort_val": 0.27451,
      "swatch_file_id": "gid://shopify/MediaImage/49490369020170",
      "swatch_filename": "03982_Green_Empire.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03982_Green_Empire.jpg?v=1774522721",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03982_Green_Empire.jpg?v=1774522721",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03982/ProductCarouselMain/03982%20GMP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03982_Green_Empire.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687326986",
      "product_title": "AWDis Long Sleeve Tri-Blend T-Shirt",
      "product_handle": "jt002",
      "product_url": "/products/jt002",
      "product_full_url": "None",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jt002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% viscose/25% cotton.",
      "style_code": "JT002",
      "colour_name": "Heather Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#20332e",
      "sort_bucket": "green",
      "sort_hue": 0.45614,
      "sort_sat": 0.372549,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49490478825738",
      "swatch_filename": "jt002_Heather_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jt002_Heather_Charcoal.jpg?v=1774522915",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jt002_Heather_Charcoal.jpg?v=1774522915",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT002/ProductCarouselMain/JT002%20HCH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt002_Heather_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550722314",
      "product_title": "AWDis Tri-Blend T-Shirt",
      "product_handle": "jt001",
      "product_url": "/products/jt001",
      "product_full_url": "https://oakdenemerch.com/products/jt001",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-jt001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% viscose/25% cotton.*",
      "style_code": "JT001",
      "colour_name": "Heather Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#20332e",
      "sort_bucket": "green",
      "sort_hue": 0.45614,
      "sort_sat": 0.372549,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49468945465610",
      "swatch_filename": "JT001_Heather_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT001_Heather_Charcoal.jpg?v=1774314481",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT001_Heather_Charcoal.jpg?v=1774314481",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT001/ProductCarouselMain/JT001%20HCH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt001_Heather_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556981002",
      "product_title": "Tee Jays CoolDry™ T-Shirt",
      "product_handle": "t7020",
      "product_url": "/products/t7020",
      "product_full_url": "https://oakdenemerch.com/products/t7020",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t7020",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7020",
      "colour_name": "Sage",
      "colour_group": "Green > Light Green",
      "rgb": "#7d918c",
      "sort_bucket": "green",
      "sort_hue": 0.458333,
      "sort_sat": 0.137931,
      "sort_val": 0.568627,
      "swatch_file_id": "gid://shopify/MediaImage/49469012115722",
      "swatch_filename": "T7020_Sage.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_Sage.jpg?v=1774315921",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_Sage.jpg?v=1774315921",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7020/ProductCarouselMain/T7020%20SAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7020_Sage.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557079306",
      "product_title": "Tee Jays Ladies CoolDry™ T-Shirt",
      "product_handle": "t7021",
      "product_url": "/products/t7021",
      "product_full_url": "https://oakdenemerch.com/products/t7021",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-t7021",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7021",
      "colour_name": "Sage",
      "colour_group": "Green > Light Green",
      "rgb": "#7d918c",
      "sort_bucket": "green",
      "sort_hue": 0.458333,
      "sort_sat": 0.137931,
      "sort_val": 0.568627,
      "swatch_file_id": "gid://shopify/MediaImage/49471676481802",
      "swatch_filename": "T7021_Sage.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_Sage.jpg?v=1774350799",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_Sage.jpg?v=1774350799",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7021/ProductCarouselMain/T7021%20SAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7021_Sage.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555244298",
      "product_title": "Tee Jays Ladies Pima Cotton T-Shirt",
      "product_handle": "t1451",
      "product_url": "/products/t1451",
      "product_full_url": "https://oakdenemerch.com/products/t1451",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t1451",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed pima cotton.",
      "style_code": "T1451",
      "colour_name": "Sage",
      "colour_group": "Green > Light Green",
      "rgb": "#7d918c",
      "sort_bucket": "green",
      "sort_hue": 0.458333,
      "sort_sat": 0.137931,
      "sort_val": 0.568627,
      "swatch_file_id": "gid://shopify/MediaImage/49468966306058",
      "swatch_filename": "T1451_Sage.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1451_Sage.jpg?v=1774315339",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1451_Sage.jpg?v=1774315339",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1451/ProductCarouselMain/T1451%20SAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1451_Sage.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557439754",
      "product_title": "Tee Jays Ladies Sof T-Shirt",
      "product_handle": "t8050",
      "product_url": "/products/t8050",
      "product_full_url": "https://oakdenemerch.com/products/t8050",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t8050",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T8050",
      "colour_name": "Sage",
      "colour_group": "Green > Light Green",
      "rgb": "#7d918c",
      "sort_bucket": "green",
      "sort_hue": 0.458333,
      "sort_sat": 0.137931,
      "sort_val": 0.568627,
      "swatch_file_id": "gid://shopify/MediaImage/49470794170634",
      "swatch_filename": "T8050_Sage.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8050_Sage.jpg?v=1774345776",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8050_Sage.jpg?v=1774345776",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8050/ProductCarouselMain/T8050%20SAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8050_Sage.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555178762",
      "product_title": "Tee Jays Pima Cotton T-Shirt",
      "product_handle": "t1450",
      "product_url": "/products/t1450",
      "product_full_url": "https://oakdenemerch.com/products/t1450",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t1450",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed pima cotton.",
      "style_code": "T1450",
      "colour_name": "Sage",
      "colour_group": "Green > Light Green",
      "rgb": "#7d918c",
      "sort_bucket": "green",
      "sort_hue": 0.458333,
      "sort_sat": 0.137931,
      "sort_val": 0.568627,
      "swatch_file_id": "gid://shopify/MediaImage/49468963291402",
      "swatch_filename": "T1450_Sage.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1450_Sage.jpg?v=1774315272",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1450_Sage.jpg?v=1774315272",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1450/ProductCarouselMain/T1450%20SAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1450_Sage.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557341450",
      "product_title": "Tee Jays Sof T-Shirt",
      "product_handle": "t8000",
      "product_url": "/products/t8000",
      "product_full_url": "https://oakdenemerch.com/products/t8000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t8000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T8000",
      "colour_name": "Sage",
      "colour_group": "Green > Light Green",
      "rgb": "#7d918c",
      "sort_bucket": "green",
      "sort_hue": 0.458333,
      "sort_sat": 0.137931,
      "sort_val": 0.568627,
      "swatch_file_id": "gid://shopify/MediaImage/49471238930698",
      "swatch_filename": "T8000_Sage.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Sage.jpg?v=1774348259",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Sage.jpg?v=1774348259",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8000/ProductCarouselMain/T8000%20SAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8000_Sage.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552557322",
      "product_title": "Proact Ladies Performance T-Shirt",
      "product_handle": "pa439",
      "product_url": "/products/pa439",
      "product_full_url": "https://oakdenemerch.com/products/pa439",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa439",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA439",
      "colour_name": "Ice Mint",
      "colour_group": "Green > Light Green",
      "rgb": "#b6e3d8",
      "sort_bucket": "green",
      "sort_hue": 0.459259,
      "sort_sat": 0.198238,
      "sort_val": 0.890196,
      "swatch_file_id": "gid://shopify/MediaImage/49471736840458",
      "swatch_filename": "PA439_Ice_Mint.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Ice_Mint.jpg?v=1774351220",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Ice_Mint.jpg?v=1774351220",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA439/ProductCarouselMain/PA439%20IMT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa439_Ice_Mint.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552524554",
      "product_title": "Proact Performance T-Shirt",
      "product_handle": "pa438",
      "product_url": "/products/pa438",
      "product_full_url": "https://oakdenemerch.com/products/pa438",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa438",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA438",
      "colour_name": "Ice Mint",
      "colour_group": "Green > Light Green",
      "rgb": "#b6e3d8",
      "sort_bucket": "green",
      "sort_hue": 0.459259,
      "sort_sat": 0.198238,
      "sort_val": 0.890196,
      "swatch_file_id": "gid://shopify/MediaImage/49471751815434",
      "swatch_filename": "PA438_Ice_Mint.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Ice_Mint.jpg?v=1774351290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Ice_Mint.jpg?v=1774351290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA438/ProductCarouselMain/PA438%20IMT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa438_Ice_Mint.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557341450",
      "product_title": "Tee Jays Sof T-Shirt",
      "product_handle": "t8000",
      "product_url": "/products/t8000",
      "product_full_url": "https://oakdenemerch.com/products/t8000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t8000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T8000",
      "colour_name": "Dark Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#034537",
      "sort_bucket": "green",
      "sort_hue": 0.464646,
      "sort_sat": 0.956522,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49471238766858",
      "swatch_filename": "T8000_Dark_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Dark_Green.jpg?v=1774348259",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Dark_Green.jpg?v=1774348259",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8000/ProductCarouselMain/T8000%20DGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8000_Dark_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Dark Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#034537",
      "sort_bucket": "green",
      "sort_hue": 0.464646,
      "sort_sat": 0.956522,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49474052194570",
      "swatch_filename": "T1150_Dark_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Dark_Green.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Dark_Green.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20DGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Dark_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Seafoam",
      "colour_group": "Green > Mid Green",
      "rgb": "#61bbaa",
      "sort_bucket": "green",
      "sort_hue": 0.468519,
      "sort_sat": 0.481283,
      "sort_val": 0.733333,
      "swatch_file_id": "gid://shopify/MediaImage/49471442977034",
      "swatch_filename": "AT001_Seafoam.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Seafoam.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Seafoam.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20SEF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Seafoam.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Seafoam",
      "colour_group": "Green > Mid Green",
      "rgb": "#61bbaa",
      "sort_bucket": "green",
      "sort_hue": 0.468519,
      "sort_sat": 0.481283,
      "sort_val": 0.733333,
      "swatch_file_id": "gid://shopify/MediaImage/49471429869834",
      "swatch_filename": "AT002_Seafoam.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Seafoam.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Seafoam.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20SEF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Seafoam.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% organic cotton/40% recycled polyester",
      "style_code": "03582",
      "colour_name": "Heather Light Green",
      "colour_group": "Green > Heather/Effect Green",
      "rgb": "#5cb8b2",
      "sort_bucket": "green",
      "sort_hue": 0.48913,
      "sort_sat": 0.5,
      "sort_val": 0.721569,
      "swatch_file_id": "gid://shopify/MediaImage/49474468249866",
      "swatch_filename": "03582_Heather_Light_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Heather_Light_Green.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Heather_Light_Green.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20HLG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Heather_Light_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% organic cotton/40% recycled polyester",
      "style_code": "03581",
      "colour_name": "Heather Light Green",
      "colour_group": "Green > Heather/Effect Green",
      "rgb": "#5cb8b2",
      "sort_bucket": "green",
      "sort_hue": 0.48913,
      "sort_sat": 0.5,
      "sort_val": 0.721569,
      "swatch_file_id": "gid://shopify/MediaImage/49468835660042",
      "swatch_filename": "03581_Heather_Light_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Heather_Light_Green.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Heather_Light_Green.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20HLG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Heather_Light_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552393482",
      "product_title": "Native Spirit Oversized T-Shirt",
      "product_handle": "ns332",
      "product_url": "/products/ns332",
      "product_full_url": "https://oakdenemerch.com/products/ns332",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns332",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "NS332",
      "colour_name": "Peacock Green",
      "colour_group": "Green > Emerald/Jade",
      "rgb": "#08655f",
      "sort_bucket": "green",
      "sort_hue": 0.489247,
      "sort_sat": 0.920792,
      "sort_val": 0.396078,
      "swatch_file_id": "gid://shopify/MediaImage/49474121367818",
      "swatch_filename": "NS332_Peacock_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_Peacock_Green.jpg?v=1774369280",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_Peacock_Green.jpg?v=1774369280",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS332/ProductCarouselMain/NS332%20PCKG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns332_Peacock_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Peacock Green",
      "colour_group": "Green > Emerald/Jade",
      "rgb": "#08655f",
      "sort_bucket": "green",
      "sort_hue": 0.489247,
      "sort_sat": 0.920792,
      "sort_val": 0.396078,
      "swatch_file_id": "gid://shopify/MediaImage/49473666908426",
      "swatch_filename": "NS305_Peacock_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Peacock_Green.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Peacock_Green.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20PCKG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Peacock_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552360714",
      "product_title": "Native Spirit Unisex Oversized T-Shirt",
      "product_handle": "ns330",
      "product_url": "/products/ns330",
      "product_full_url": "https://oakdenemerch.com/products/ns330",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-ns330",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS330",
      "colour_name": "Peacock Green",
      "colour_group": "Green > Emerald/Jade",
      "rgb": "#08655f",
      "sort_bucket": "green",
      "sort_hue": 0.489247,
      "sort_sat": 0.920792,
      "sort_val": 0.396078,
      "swatch_file_id": "gid://shopify/MediaImage/49473635090698",
      "swatch_filename": "NS330_Peacock_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS330_Peacock_Green.jpg?v=1774364535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS330_Peacock_Green.jpg?v=1774364535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS330/ProductCarouselMain/NS330%20PCKG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns330_Peacock_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Pine Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#255958",
      "sort_bucket": "green",
      "sort_hue": 0.496795,
      "sort_sat": 0.58427,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49474343272714",
      "swatch_filename": "AM10_Pine_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Pine_Green.jpg?v=1774371250",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Pine_Green.jpg?v=1774371250",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20PNG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Pine_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548363018",
      "product_title": "Anthem Unisex Organic Midweight T-Shirt",
      "product_handle": "am12",
      "product_url": "/products/am12",
      "product_full_url": "https://oakdenemerch.com/products/am12",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am12",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM12",
      "colour_name": "Pine Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#255958",
      "sort_bucket": "green",
      "sort_hue": 0.496795,
      "sort_sat": 0.58427,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49472902365450",
      "swatch_filename": "AM12_Pine_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Pine_Green.jpg?v=1774360381",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Pine_Green.jpg?v=1774360381",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM12/ProductCarouselMain/AM12%20PNG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am12_Pine_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548428554",
      "product_title": "Anthem Amplify Heavyweight T-Shirt",
      "product_handle": "am18",
      "product_url": "/products/am18",
      "product_full_url": "https://oakdenemerch.com/products/am18",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-am18",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM18",
      "colour_name": "Petrol",
      "colour_group": "Green > Dark Green",
      "rgb": "#23565a",
      "sort_bucket": "green",
      "sort_hue": 0.512121,
      "sort_sat": 0.611111,
      "sort_val": 0.352941,
      "swatch_file_id": "gid://shopify/MediaImage/49472893255946",
      "swatch_filename": "AM18_Petrol.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_Petrol.jpg?v=1774360285",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_Petrol.jpg?v=1774360285",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM18/ProductCarouselMain/AM18%20PET%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am18_Petrol.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Fan Marine Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#18444a",
      "sort_bucket": "green",
      "sort_hue": 0.52,
      "sort_sat": 0.675676,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49471385370890",
      "swatch_filename": "GD05_Fan_Marine_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Fan_Marine_Green.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Fan_Marine_Green.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20FMRG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Fan_Marine_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Fan Marine Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#18444a",
      "sort_bucket": "green",
      "sort_hue": 0.52,
      "sort_sat": 0.675676,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49474268332298",
      "swatch_filename": "GD01_Fan_Marine_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Fan_Marine_Green.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Fan_Marine_Green.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20FMRG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Fan_Marine_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686966538",
      "product_title": "Gildan SoftStyle® Long Sleeve T-Shirt",
      "product_handle": "gd11",
      "product_url": "/products/gd11",
      "product_full_url": "https://oakdenemerch.com/products/gd11",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd11",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD11",
      "colour_name": "Fan Marine Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#18444a",
      "sort_bucket": "green",
      "sort_hue": 0.52,
      "sort_sat": 0.675676,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49490443206922",
      "swatch_filename": "gd11_Fan_Marine_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Fan_Marine_Green.jpg?v=1774522831",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Fan_Marine_Green.jpg?v=1774522831",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD11/ProductCarouselMain/GD11%20FMRG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd11_Fan_Marine_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Caribbean Blue",
      "colour_group": "Blue > Turquoise",
      "rgb": "#40ff94",
      "sort_bucket": "blue",
      "sort_hue": 0.406632,
      "sort_sat": 0.74902,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474448326922",
      "swatch_filename": "11500_Caribbean_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Caribbean_Blue.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Caribbean_Blue.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20CAB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Caribbean_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Caribbean Blue",
      "colour_group": "Blue > Turquoise",
      "rgb": "#40ff94",
      "sort_bucket": "blue",
      "sort_hue": 0.406632,
      "sort_sat": 0.74902,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468933472522",
      "swatch_filename": "11502_Caribbean_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Caribbean_Blue.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Caribbean_Blue.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20CAB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Caribbean_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547642122",
      "product_title": "SOL'S Ladies Legend T-Shirt",
      "product_handle": "04776",
      "product_url": "/products/04776",
      "product_full_url": "https://oakdenemerch.com/products/04776",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-04776",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "04776",
      "colour_name": "Caribbean Blue",
      "colour_group": "Blue > Turquoise",
      "rgb": "#40ff94",
      "sort_bucket": "blue",
      "sort_hue": 0.406632,
      "sort_sat": 0.74902,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472963445002",
      "swatch_filename": "04776_Caribbean_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Caribbean_Blue.jpg?v=1774360490",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Caribbean_Blue.jpg?v=1774360490",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04776/ProductCarouselMain/04776%20CAB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04776_Caribbean_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Pool Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#57faa3",
      "sort_bucket": "blue",
      "sort_hue": 0.411043,
      "sort_sat": 0.652,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49474469003530",
      "swatch_filename": "03582_Pool_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Pool_Blue.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Pool_Blue.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20POB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Pool_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Pool Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#57faa3",
      "sort_bucket": "blue",
      "sort_hue": 0.411043,
      "sort_sat": 0.652,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49468835365130",
      "swatch_filename": "03581_Pool_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Pool_Blue.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Pool_Blue.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20POB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Pool_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Pool Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#57faa3",
      "sort_bucket": "blue",
      "sort_hue": 0.411043,
      "sort_sat": 0.652,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49473744896266",
      "swatch_filename": "03981_Pool_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Pool_Blue.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Pool_Blue.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20POB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Pool_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547150602",
      "product_title": "SOL'S Unisex Sprint T-Shirt",
      "product_handle": "02995",
      "product_url": "/products/02995",
      "product_full_url": "https://oakdenemerch.com/products/02995",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-02995",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "02995",
      "colour_name": "Pool Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#57faa3",
      "sort_bucket": "blue",
      "sort_hue": 0.411043,
      "sort_sat": 0.652,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49473768128778",
      "swatch_filename": "02995_Pool_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Pool_Blue.jpg?v=1774365179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Pool_Blue.jpg?v=1774365179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02995/ProductCarouselMain/02995%20POB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02995_Pool_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550361866",
      "product_title": "AWDis Cool Smooth T-Shirt",
      "product_handle": "jc020",
      "product_url": "/products/jc020",
      "product_full_url": "https://oakdenemerch.com/products/jc020",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-jc020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020",
      "colour_name": "Turquoise Blue",
      "colour_group": "Blue > Turquoise",
      "rgb": "#27e388",
      "sort_bucket": "blue",
      "sort_hue": 0.419326,
      "sort_sat": 0.828194,
      "sort_val": 0.890196,
      "swatch_file_id": "gid://shopify/MediaImage/49472871563530",
      "swatch_filename": "JC020_Turquoise_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Turquoise_Blue.jpg?v=1774359994",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Turquoise_Blue.jpg?v=1774359994",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020/ProductCarouselMain/JC020%20TUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020_Turquoise_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Turquoise Blue",
      "colour_group": "Blue > Turquoise",
      "rgb": "#27e388",
      "sort_bucket": "blue",
      "sort_hue": 0.419326,
      "sort_sat": 0.828194,
      "sort_val": 0.890196,
      "swatch_file_id": "gid://shopify/MediaImage/49474217541898",
      "swatch_filename": "JC001_Turquoise_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Turquoise_Blue.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Turquoise_Blue.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20TUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Turquoise_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549411594",
      "product_title": "Gildan SoftStyle® EZ T-Shirt",
      "product_handle": "gd04",
      "product_url": "/products/gd04",
      "product_full_url": "https://oakdenemerch.com/products/gd04",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd04",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "GD04",
      "colour_name": "Teal Ice",
      "colour_group": "Blue > Light Blue",
      "rgb": "#c4ffe6",
      "sort_bucket": "blue",
      "sort_hue": 0.429379,
      "sort_sat": 0.231373,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468937306378",
      "swatch_filename": "GD04_Teal_Ice.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Teal_Ice.jpg?v=1774313523",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Teal_Ice.jpg?v=1774313523",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD04/ProductCarouselMain/GD04%20TEI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd04_Teal_Ice.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Ocean Teal",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#00ab68",
      "sort_bucket": "blue",
      "sort_hue": 0.434698,
      "sort_sat": 1.0,
      "sort_val": 0.670588,
      "swatch_file_id": "gid://shopify/MediaImage/49471313641738",
      "swatch_filename": "SS620_Ocean_Teal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Ocean_Teal.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Ocean_Teal.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20OCT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Ocean_Teal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS720",
      "colour_name": "Ocean Teal",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#00ab68",
      "sort_bucket": "blue",
      "sort_hue": 0.434698,
      "sort_sat": 1.0,
      "sort_val": 0.670588,
      "swatch_file_id": "gid://shopify/MediaImage/49472218857738",
      "swatch_filename": "SS720_Ocean_Teal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Ocean_Teal.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Ocean_Teal.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20OCT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_Ocean_Teal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554457866",
      "product_title": "Fruit of the Loom Pure Cotton T-Shirt",
      "product_handle": "ss640",
      "product_url": "/products/ss640",
      "product_full_url": "https://oakdenemerch.com/products/ss640",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss640",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "SS640",
      "colour_name": "Ocean Teal",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#00ab68",
      "sort_bucket": "blue",
      "sort_hue": 0.434698,
      "sort_sat": 1.0,
      "sort_val": 0.670588,
      "swatch_file_id": "gid://shopify/MediaImage/49468957622538",
      "swatch_filename": "SS640_Ocean_Teal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Ocean_Teal.jpg?v=1774315114",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Ocean_Teal.jpg?v=1774315114",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS640/ProductCarouselMain/SS640%20OCT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss640_Ocean_Teal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Teal",
      "colour_group": "Blue > Light Blue",
      "rgb": "#57bb9b",
      "sort_bucket": "blue",
      "sort_hue": 0.446667,
      "sort_sat": 0.534759,
      "sort_val": 0.733333,
      "swatch_file_id": "gid://shopify/MediaImage/49474342945034",
      "swatch_filename": "AM10_Teal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Teal.jpg?v=1774371249",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Teal.jpg?v=1774371249",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20TEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Teal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548395786",
      "product_title": "Anthem Unisex Organic Heavyweight T-Shirt",
      "product_handle": "am15",
      "product_url": "/products/am15",
      "product_full_url": "https://oakdenemerch.com/products/am15",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am15",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM15",
      "colour_name": "Teal",
      "colour_group": "Blue > Light Blue",
      "rgb": "#57bb9b",
      "sort_bucket": "blue",
      "sort_hue": 0.446667,
      "sort_sat": 0.534759,
      "sort_val": 0.733333,
      "swatch_file_id": "gid://shopify/MediaImage/49472896008458",
      "swatch_filename": "AM15_Teal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Teal.jpg?v=1774360325",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Teal.jpg?v=1774360325",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM15/ProductCarouselMain/AM15%20TEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am15_Teal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547478282",
      "product_title": "SOL'S Unisex Tuner T-Shirt",
      "product_handle": "04203",
      "product_url": "/products/04203",
      "product_full_url": "https://oakdenemerch.com/products/04203",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-04203",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.*",
      "style_code": "04203",
      "colour_name": "Light Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#c4ffed",
      "sort_bucket": "blue",
      "sort_hue": 0.449153,
      "sort_sat": 0.231373,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474459009290",
      "swatch_filename": "04203_Light_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_Light_Blue.jpg?v=1774372011",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_Light_Blue.jpg?v=1774372011",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04203/ProductCarouselMain/04203%20LBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04203_Light_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Mint",
      "colour_group": "Blue > Light Blue",
      "rgb": "#8de3d1",
      "sort_bucket": "blue",
      "sort_hue": 0.465116,
      "sort_sat": 0.378855,
      "sort_val": 0.890196,
      "swatch_file_id": "gid://shopify/MediaImage/49474051932426",
      "swatch_filename": "T1150_Mint.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Mint.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Mint.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20MIN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Mint.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Seafoam",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#61bbaa",
      "sort_bucket": "blue",
      "sort_hue": 0.468519,
      "sort_sat": 0.481283,
      "sort_val": 0.733333,
      "swatch_file_id": "gid://shopify/MediaImage/49474218361098",
      "swatch_filename": "JC001_Seafoam.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Seafoam.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Seafoam.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20SEF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Seafoam.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Seafoam",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#61bbaa",
      "sort_bucket": "blue",
      "sort_hue": 0.468519,
      "sort_sat": 0.481283,
      "sort_val": 0.733333,
      "swatch_file_id": "gid://shopify/MediaImage/49474210070794",
      "swatch_filename": "JC001B_Seafoam.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Seafoam.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Seafoam.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20SEF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Seafoam.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Ice Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#a1d4cc",
      "sort_bucket": "blue",
      "sort_hue": 0.473856,
      "sort_sat": 0.240566,
      "sort_val": 0.831373,
      "swatch_file_id": "gid://shopify/MediaImage/49474449211658",
      "swatch_filename": "11500_Ice_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Ice_Blue.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Ice_Blue.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20ICE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Ice_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549411594",
      "product_title": "Gildan SoftStyle® EZ T-Shirt",
      "product_handle": "gd04",
      "product_url": "/products/gd04",
      "product_full_url": "https://oakdenemerch.com/products/gd04",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd04",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "GD04",
      "colour_name": "Caribbean Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#1fffe3",
      "sort_bucket": "blue",
      "sort_hue": 0.479167,
      "sort_sat": 0.878431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468937470218",
      "swatch_filename": "GD04_Caribbean_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Caribbean_Blue.jpg?v=1774313523",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Caribbean_Blue.jpg?v=1774313523",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD04/ProductCarouselMain/GD04%20CAB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd04_Caribbean_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% organic cotton/15% viscose",
      "style_code": "03582",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49474468217098",
      "swatch_filename": "03582_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Grey_Marl.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Grey_Marl.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547511050",
      "product_title": "SOL'S Crusader Recycled T-Shirt",
      "product_handle": "04233",
      "product_url": "/products/04233",
      "product_full_url": "https://oakdenemerch.com/products/04233",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04233",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% recycled cotton/35% cotton/15% viscose.",
      "style_code": "04233",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49473285226762",
      "swatch_filename": "04233_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Grey_Marl.jpg?v=1774363191",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Grey_Marl.jpg?v=1774363191",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04233/ProductCarouselMain/04233%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04233_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547904266",
      "product_title": "SOL'S Imperial Fit T-Shirt",
      "product_handle": "10580",
      "product_url": "/products/10580",
      "product_full_url": "https://oakdenemerch.com/products/10580",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-10580",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "10580",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49471859228938",
      "swatch_filename": "10580_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10580_Grey_Marl.jpg?v=1774352022",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10580_Grey_Marl.jpg?v=1774352022",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/10580/ProductCarouselMain/10580%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "10580_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "11500",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49474448163082",
      "swatch_filename": "11500_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Grey_Marl.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Grey_Marl.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685623050",
      "product_title": "SOL'S Imperial Long Sleeve T-Shirt",
      "product_handle": "02074",
      "product_url": "/products/02074",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-02074",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "02074",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49490366857482",
      "swatch_filename": "02074_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02074_Grey_Marl.jpg?v=1774522704",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02074_Grey_Marl.jpg?v=1774522704",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02074/ProductCarouselMain/02074%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02074_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546953994",
      "product_title": "SOL'S Imperial V Neck T-Shirt",
      "product_handle": "02940",
      "product_url": "/products/02940",
      "product_full_url": "https://oakdenemerch.com/products/02940",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-02940",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "02940",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49468829204746",
      "swatch_filename": "02940_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02940_Grey_Marl.jpg?v=1774312050",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02940_Grey_Marl.jpg?v=1774312050",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02940/ProductCarouselMain/02940%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02940_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561773834",
      "product_title": "SOL'S Justin Tank Top",
      "product_handle": "11465",
      "product_url": "/products/11465",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11465",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "11465",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49513914827018",
      "swatch_filename": "11465_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11465_Grey_Marl.jpg?v=1774618896",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11465_Grey_Marl.jpg?v=1774618896",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11465/ProductCarouselMain/11465%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11465_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% organic cotton/15% viscose",
      "style_code": "03581",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49468835922186",
      "swatch_filename": "03581_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Grey_Marl.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Grey_Marl.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "11502",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49468933374218",
      "swatch_filename": "11502_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Grey_Marl.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Grey_Marl.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685688586",
      "product_title": "SOL'S Ladies Imperial Long Sleeve T-Shirt",
      "product_handle": "02075",
      "product_url": "/products/02075",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-02075",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "02075",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49490367414538",
      "swatch_filename": "02075_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02075_Grey_Marl.jpg?v=1774522713",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02075_Grey_Marl.jpg?v=1774522713",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02075/ProductCarouselMain/02075%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02075_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547052298",
      "product_title": "SOL'S Ladies Imperial V Neck T-Shirt",
      "product_handle": "02941",
      "product_url": "/products/02941",
      "product_full_url": "https://oakdenemerch.com/products/02941",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-02941",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "02941",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49471878365450",
      "swatch_filename": "02941_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02941_Grey_Marl.jpg?v=1774352301",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02941_Grey_Marl.jpg?v=1774352301",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02941/ProductCarouselMain/02941%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02941_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547642122",
      "product_title": "SOL'S Ladies Legend T-Shirt",
      "product_handle": "04776",
      "product_url": "/products/04776",
      "product_full_url": "https://oakdenemerch.com/products/04776",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-04776",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "04776",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49472963281162",
      "swatch_filename": "04776_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Grey_Marl.jpg?v=1774360490",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Grey_Marl.jpg?v=1774360490",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04776/ProductCarouselMain/04776%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04776_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685917962",
      "product_title": "SOL'S Ladies Monarch Long Sleeve T-Shirt",
      "product_handle": "04443",
      "product_url": "/products/04443",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-04443",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.",
      "style_code": "04443",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49490370298122",
      "swatch_filename": "04443_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04443_Grey_Marl.jpg?v=1774522734",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04443_Grey_Marl.jpg?v=1774522734",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04443/ProductCarouselMain/04443%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04443_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548035338",
      "product_title": "SOL'S Ladies Moon V Neck T-Shirt",
      "product_handle": "11388",
      "product_url": "/products/11388",
      "product_full_url": "https://oakdenemerch.com/products/11388",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11388",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "11388",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49468932522250",
      "swatch_filename": "11388_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_Grey_Marl.jpg?v=1774312857",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_Grey_Marl.jpg?v=1774312857",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11388/ProductCarouselMain/11388%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11388_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% organic cotton/15% viscose.",
      "style_code": "03579",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49468833628426",
      "swatch_filename": "03579_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Grey_Marl.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Grey_Marl.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "01825",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49468823437578",
      "swatch_filename": "01825_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Grey_Marl.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Grey_Marl.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547609354",
      "product_title": "SOL'S Ladies Regent V Neck T-Shirt",
      "product_handle": "04766",
      "product_url": "/products/04766",
      "product_full_url": "https://oakdenemerch.com/products/04766",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "S",
        "style-04766",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "04766",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49472664731914",
      "swatch_filename": "04766_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04766_Grey_Marl.jpg?v=1774358606",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04766_Grey_Marl.jpg?v=1774358606",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04766/ProductCarouselMain/04766%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04766_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686049034",
      "product_title": "SOL'S Monarch Long Sleeve T-Shirt",
      "product_handle": "11420",
      "product_url": "/products/11420",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11420",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "11420",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49490371019018",
      "swatch_filename": "11420_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Grey_Marl.jpg?v=1774522747",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Grey_Marl.jpg?v=1774522747",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11420/ProductCarouselMain/11420%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11420_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% organic cotton/15% viscose",
      "style_code": "03565",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49473305542922",
      "swatch_filename": "03565_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Grey_Marl.jpg?v=1774363313",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Grey_Marl.jpg?v=1774363313",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547871498",
      "product_title": "SOL'S Regent Fit T-Shirt",
      "product_handle": "10553",
      "product_url": "/products/10553",
      "product_full_url": "https://oakdenemerch.com/products/10553",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-10553",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "10553",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49472628982026",
      "swatch_filename": "10553_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_Grey_Marl.jpg?v=1774358391",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_Grey_Marl.jpg?v=1774358391",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/10553/ProductCarouselMain/10553%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "10553_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "11380",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49473718157578",
      "swatch_filename": "11380_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Grey_Marl.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Grey_Marl.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547805962",
      "product_title": "SOL'S Unisex Cliff T-Shirt",
      "product_handle": "04813",
      "product_url": "/products/04813",
      "product_full_url": "https://oakdenemerch.com/products/04813",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "S",
        "style-04813",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "04813",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49472952074506",
      "swatch_filename": "04813_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04813_Grey_Marl.jpg?v=1774360433",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04813_Grey_Marl.jpg?v=1774360433",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04813/ProductCarouselMain/04813%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04813_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561675530",
      "product_title": "SOL'S Unisex Crusader Tank Top",
      "product_handle": "03980",
      "product_url": "/products/03980",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03980",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "03980",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49513913385226",
      "swatch_filename": "03980_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03980_Grey_Marl.jpg?v=1774618877",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03980_Grey_Marl.jpg?v=1774618877",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03980/ProductCarouselMain/03980%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03980_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547183370",
      "product_title": "SOL'S Unisex Epic Organic T-Shirt",
      "product_handle": "03564",
      "product_url": "/products/03564",
      "product_full_url": "https://oakdenemerch.com/products/03564",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03564",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% organic cotton/15% viscose.",
      "style_code": "03564",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49473320124682",
      "swatch_filename": "03564_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03564_Grey_Marl.jpg?v=1774363396",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03564_Grey_Marl.jpg?v=1774363396",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03564/ProductCarouselMain/03564%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03564_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% organic cotton/15% viscose.",
      "style_code": "03981",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49473745158410",
      "swatch_filename": "03981_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Grey_Marl.jpg?v=1774365053",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Grey_Marl.jpg?v=1774365053",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685786890",
      "product_title": "SOL'S Unisex Pioneer Long Sleeve T-Shirt",
      "product_handle": "03982",
      "product_url": "/products/03982",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03982",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% organic cotton/15% viscose.",
      "style_code": "03982",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49490369085706",
      "swatch_filename": "03982_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03982_Grey_Marl.jpg?v=1774522722",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03982_Grey_Marl.jpg?v=1774522722",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03982/ProductCarouselMain/03982%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03982_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547576586",
      "product_title": "SOL'S Unisex Titan T-Shirt",
      "product_handle": "04728",
      "product_url": "/products/04728",
      "product_full_url": "https://oakdenemerch.com/products/04728",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "knitwear",
        "L",
        "M",
        "S",
        "style-04728",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.",
      "style_code": "04728",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49474456912138",
      "swatch_filename": "04728_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_Grey_Marl.jpg?v=1774371966",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_Grey_Marl.jpg?v=1774371966",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04728/ProductCarouselMain/04728%20GME%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04728_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Hawaiian Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#66fff7",
      "sort_bucket": "blue",
      "sort_hue": 0.491285,
      "sort_sat": 0.6,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474217509130",
      "swatch_filename": "JC001_Hawaiian_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Hawaiian_Blue.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Hawaiian_Blue.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20HWB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Hawaiian_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "Sea Turquoise",
      "colour_group": "Blue > Turquoise",
      "rgb": "#45d6cf",
      "sort_bucket": "blue",
      "sort_hue": 0.491954,
      "sort_sat": 0.67757,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49491375325450",
      "swatch_filename": "kb3025ic_Sea_Turquoise.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Sea_Turquoise.jpg?v=1774526631",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Sea_Turquoise.jpg?v=1774526631",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20STQ%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Sea_Turquoise.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551639818",
      "product_title": "Kariban Unisex 190IC Crew Neck T-Shirt",
      "product_handle": "kb3032ic",
      "product_url": "/products/kb3032ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3032ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3032IC",
      "colour_name": "Sea Turquoise",
      "colour_group": "Blue > Turquoise",
      "rgb": "#45d6cf",
      "sort_bucket": "blue",
      "sort_hue": 0.491954,
      "sort_sat": 0.67757,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49491366445322",
      "swatch_filename": "kb3032ic_Sea_Turquoise.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Sea_Turquoise.jpg?v=1774526605",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Sea_Turquoise.jpg?v=1774526605",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3032IC/ProductCarouselMain/KB3032IC%20STQ%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3032ic_Sea_Turquoise.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Petroleum Blue",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#09302f",
      "sort_bucket": "blue",
      "sort_hue": 0.495726,
      "sort_sat": 0.8125,
      "sort_val": 0.188235,
      "swatch_file_id": "gid://shopify/MediaImage/49474448228618",
      "swatch_filename": "11500_Petroleum_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Petroleum_Blue.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Petroleum_Blue.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20PBE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Petroleum_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#7afffc",
      "sort_bucket": "blue",
      "sort_hue": 0.496241,
      "sort_sat": 0.521569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471385960714",
      "swatch_filename": "GD05_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Sky_Blue.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Sky_Blue.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549772042",
      "product_title": "Gildan Ladies SoftStyle® T-Shirt",
      "product_handle": "gd72",
      "product_url": "/products/gd72",
      "product_full_url": "https://oakdenemerch.com/products/gd72",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd72",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD72",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#7afffc",
      "sort_bucket": "blue",
      "sort_hue": 0.496241,
      "sort_sat": 0.521569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468940779786",
      "swatch_filename": "GD72_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Sky_Blue.jpg?v=1774314002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Sky_Blue.jpg?v=1774314002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD72/ProductCarouselMain/GD72%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd72_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#7afffc",
      "sort_bucket": "blue",
      "sort_hue": 0.496241,
      "sort_sat": 0.521569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474267054346",
      "swatch_filename": "GD01_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Sky_Blue.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Sky_Blue.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#7afffc",
      "sort_bucket": "blue",
      "sort_hue": 0.496241,
      "sort_sat": 0.521569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471397691658",
      "swatch_filename": "GD02_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Sky_Blue.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Sky_Blue.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#597171",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.212389,
      "sort_val": 0.443137,
      "swatch_file_id": "gid://shopify/MediaImage/49473588625674",
      "swatch_filename": "SR287_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Grey.jpg?v=1774364345",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Grey.jpg?v=1774364345",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20GRE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Light Graphite",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#2f3b3b",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.20339,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49471285297418",
      "swatch_filename": "SS621_Light_Graphite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Light_Graphite.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Light_Graphite.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20LGP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Light_Graphite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Light Graphite",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#2f3b3b",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.20339,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49471313182986",
      "swatch_filename": "SS620_Light_Graphite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Light_Graphite.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Light_Graphite.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20LGP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Light_Graphite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554654474",
      "product_title": "Fruit of the Loom Lady Fit Value T-Shirt",
      "product_handle": "ss77",
      "product_url": "/products/ss77",
      "product_full_url": "https://oakdenemerch.com/products/ss77",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss77",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS77",
      "colour_name": "Light Graphite",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#2f3b3b",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.20339,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49472026116362",
      "swatch_filename": "SS77_Light_Graphite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Light_Graphite.jpg?v=1774353471",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Light_Graphite.jpg?v=1774353471",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS77/ProductCarouselMain/SS77%20LGP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss77_Light_Graphite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687982346",
      "product_title": "Fruit of the Loom Long Sleeve Value T-Shirt",
      "product_handle": "ss21",
      "product_url": "/products/ss21",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "knitwear",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss21",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS21",
      "colour_name": "Light Graphite",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#2f3b3b",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.20339,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49490485444874",
      "swatch_filename": "ss21_Light_Graphite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss21_Light_Graphite.jpg?v=1774523015",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss21_Light_Graphite.jpg?v=1774523015",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS21/ProductCarouselMain/SS21%20LGP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss21_Light_Graphite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "Light Graphite",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#2f3b3b",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.20339,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49471330517258",
      "swatch_filename": "SS12_Light_Graphite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Light_Graphite.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Light_Graphite.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20LGP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Light_Graphite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554457866",
      "product_title": "Fruit of the Loom Pure Cotton T-Shirt",
      "product_handle": "ss640",
      "product_url": "/products/ss640",
      "product_full_url": "https://oakdenemerch.com/products/ss640",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss640",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "SS640",
      "colour_name": "Light Graphite",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#2f3b3b",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.20339,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49468957786378",
      "swatch_filename": "SS640_Light_Graphite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Light_Graphite.jpg?v=1774315114",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Light_Graphite.jpg?v=1774315114",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS640/ProductCarouselMain/SS640%20LGP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss640_Light_Graphite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554195722",
      "product_title": "Fruit of the Loom Super Premium T-Shirt",
      "product_handle": "ss10",
      "product_url": "/products/ss10",
      "product_full_url": "https://oakdenemerch.com/products/ss10",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss10",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS10",
      "colour_name": "Light Graphite",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#2f3b3b",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.20339,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49471341560074",
      "swatch_filename": "SS10_Light_Graphite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_Light_Graphite.jpg?v=1774348795",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_Light_Graphite.jpg?v=1774348795",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS10/ProductCarouselMain/SS10%20LGP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss10_Light_Graphite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554490634",
      "product_title": "Fruit of the Loom V Neck Value T-Shirt",
      "product_handle": "ss7",
      "product_url": "/products/ss7",
      "product_full_url": "https://oakdenemerch.com/products/ss7",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss7",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS7",
      "colour_name": "Light Graphite",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#2f3b3b",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.20339,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49471272386826",
      "swatch_filename": "SS7_Light_Graphite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Light_Graphite.jpg?v=1774348430",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Light_Graphite.jpg?v=1774348430",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS7/ProductCarouselMain/SS7%20LGP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss7_Light_Graphite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Light Graphite",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#2f3b3b",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.20339,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49471322194186",
      "swatch_filename": "SS6_Light_Graphite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Light_Graphite.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Light_Graphite.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20LGP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Light_Graphite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "Ocean Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#2ef0fa",
      "sort_bucket": "blue",
      "sort_hue": 0.50817,
      "sort_sat": 0.816,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49473588560138",
      "swatch_filename": "SR287_Ocean_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Ocean_Blue.jpg?v=1774364345",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Ocean_Blue.jpg?v=1774364345",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20OBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_Ocean_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554097418",
      "product_title": "Spiro Kids Impact Performance Aircool T-Shirt",
      "product_handle": "sr287b",
      "product_url": "/products/sr287b",
      "product_full_url": "https://oakdenemerch.com/products/sr287b",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "children",
        "kids",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287b",
        "t-shirts",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287B",
      "colour_name": "Ocean Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#2ef0fa",
      "sort_bucket": "blue",
      "sort_hue": 0.50817,
      "sort_sat": 0.816,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49474059927818",
      "swatch_filename": "SR287B_Ocean_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Ocean_Blue.jpg?v=1774368252",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Ocean_Blue.jpg?v=1774368252",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287B/ProductCarouselMain/SR287B%20OBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287b_Ocean_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD05",
      "colour_name": "Midnight",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#00565c",
      "sort_bucket": "blue",
      "sort_hue": 0.51087,
      "sort_sat": 1.0,
      "sort_val": 0.360784,
      "swatch_file_id": "gid://shopify/MediaImage/49471384879370",
      "swatch_filename": "GD05_Midnight.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Midnight.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Midnight.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20MID%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Midnight.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "Ice Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#a3cccf",
      "sort_bucket": "blue",
      "sort_hue": 0.511364,
      "sort_sat": 0.21256,
      "sort_val": 0.811765,
      "swatch_file_id": "gid://shopify/MediaImage/49471257477386",
      "swatch_filename": "T520_Ice_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Ice_Blue.jpg?v=1774348349",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Ice_Blue.jpg?v=1774348349",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20ICE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_Ice_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556587786",
      "product_title": "Tee Jays Ladies Interlock T-Shirt",
      "product_handle": "t580",
      "product_url": "/products/t580",
      "product_full_url": "https://oakdenemerch.com/products/t580",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t580",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T580",
      "colour_name": "Ice Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#a3cccf",
      "sort_bucket": "blue",
      "sort_hue": 0.511364,
      "sort_sat": 0.21256,
      "sort_val": 0.811765,
      "swatch_file_id": "gid://shopify/MediaImage/49469002121482",
      "swatch_filename": "T580_Ice_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Ice_Blue.jpg?v=1774315823",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Ice_Blue.jpg?v=1774315823",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T580/ProductCarouselMain/T580%20ICE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t580_Ice_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD05",
      "colour_name": "Antique Sapphire",
      "colour_group": "Blue > Sapphire",
      "rgb": "#007881",
      "sort_bucket": "blue",
      "sort_hue": 0.511628,
      "sort_sat": 1.0,
      "sort_val": 0.505882,
      "swatch_file_id": "gid://shopify/MediaImage/49471385108746",
      "swatch_filename": "GD05_Antique_Sapphire.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Antique_Sapphire.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Antique_Sapphire.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20ASA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Antique_Sapphire.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549772042",
      "product_title": "Gildan Ladies SoftStyle® T-Shirt",
      "product_handle": "gd72",
      "product_url": "/products/gd72",
      "product_full_url": "https://oakdenemerch.com/products/gd72",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd72",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD72",
      "colour_name": "Antique Sapphire",
      "colour_group": "Blue > Sapphire",
      "rgb": "#007881",
      "sort_bucket": "blue",
      "sort_hue": 0.511628,
      "sort_sat": 1.0,
      "sort_val": 0.505882,
      "swatch_file_id": "gid://shopify/MediaImage/49468940419338",
      "swatch_filename": "GD72_Antique_Sapphire.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Antique_Sapphire.jpg?v=1774314002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Antique_Sapphire.jpg?v=1774314002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD72/ProductCarouselMain/GD72%20ASA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd72_Antique_Sapphire.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD01",
      "colour_name": "Antique Sapphire",
      "colour_group": "Blue > Sapphire",
      "rgb": "#007881",
      "sort_bucket": "blue",
      "sort_hue": 0.511628,
      "sort_sat": 1.0,
      "sort_val": 0.505882,
      "swatch_file_id": "gid://shopify/MediaImage/49474268365066",
      "swatch_filename": "GD01_Antique_Sapphire.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Antique_Sapphire.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Antique_Sapphire.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20ASA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Antique_Sapphire.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458563084554",
      "product_title": "Tombo Muscle Vest",
      "product_handle": "tl504",
      "product_url": "/products/tl504",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "sleeveless",
        "style-tl504",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "90% polyester/10% elastane.",
      "style_code": "TL504",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#819799",
      "sort_bucket": "blue",
      "sort_hue": 0.513889,
      "sort_sat": 0.156863,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49513938452746",
      "swatch_filename": "tl504_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl504_Grey_Marl.jpg?v=1774619167",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl504_Grey_Marl.jpg?v=1774619167",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Tombo/TL504/ProductCarouselMain/TL504%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl504_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49474468577546",
      "swatch_filename": "03582_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Aqua.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Aqua.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547511050",
      "product_title": "SOL'S Crusader Recycled T-Shirt",
      "product_handle": "04233",
      "product_url": "/products/04233",
      "product_full_url": "https://oakdenemerch.com/products/04233",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04233",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% recycled cotton/50% cotton.*",
      "style_code": "04233",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49473285030154",
      "swatch_filename": "04233_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Aqua.jpg?v=1774363191",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Aqua.jpg?v=1774363191",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04233/ProductCarouselMain/04233%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04233_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49474448425226",
      "swatch_filename": "11500_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Aqua.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Aqua.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49468835561738",
      "swatch_filename": "03581_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Aqua.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Aqua.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49468933865738",
      "swatch_filename": "11502_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Aqua.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Aqua.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547642122",
      "product_title": "SOL'S Ladies Legend T-Shirt",
      "product_handle": "04776",
      "product_url": "/products/04776",
      "product_full_url": "https://oakdenemerch.com/products/04776",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-04776",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "04776",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49472963412234",
      "swatch_filename": "04776_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Aqua.jpg?v=1774360489",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Aqua.jpg?v=1774360489",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04776/ProductCarouselMain/04776%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04776_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685917962",
      "product_title": "SOL'S Ladies Monarch Long Sleeve T-Shirt",
      "product_handle": "04443",
      "product_url": "/products/04443",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-04443",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.",
      "style_code": "04443",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49490370363658",
      "swatch_filename": "04443_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04443_Aqua.jpg?v=1774522734",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04443_Aqua.jpg?v=1774522734",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04443/ProductCarouselMain/04443%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04443_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49468833399050",
      "swatch_filename": "03579_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Aqua.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Aqua.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49468823404810",
      "swatch_filename": "01825_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Aqua.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Aqua.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546757386",
      "product_title": "SOL'S Ladies Sporty Performance T-Shirt",
      "product_handle": "01159",
      "product_url": "/products/01159",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-01159",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "01159",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49491517899018",
      "swatch_filename": "01159_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01159_Aqua.jpg?v=1774526875",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01159_Aqua.jpg?v=1774526875",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01159/ProductCarouselMain/01159%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01159_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561642762",
      "product_title": "SOL'S Ladies Sporty Performance Tank Top",
      "product_handle": "02117",
      "product_url": "/products/02117",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-02117",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02117",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49513911714058",
      "swatch_filename": "02117_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02117_Aqua.jpg?v=1774618865",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02117_Aqua.jpg?v=1774618865",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02117/ProductCarouselMain/02117%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02117_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547707658",
      "product_title": "SOL'S Ladies Vortex Ripstop Performance T-Shirt",
      "product_handle": "04788",
      "product_url": "/products/04788",
      "product_full_url": "https://oakdenemerch.com/products/04788",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04788",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04788",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49472651919626",
      "swatch_filename": "04788_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_Aqua.jpg?v=1774358494",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_Aqua.jpg?v=1774358494",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04788/ProductCarouselMain/04788%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04788_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686049034",
      "product_title": "SOL'S Monarch Long Sleeve T-Shirt",
      "product_handle": "11420",
      "product_url": "/products/11420",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11420",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "11420",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49490371117322",
      "swatch_filename": "11420_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Aqua.jpg?v=1774522749",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Aqua.jpg?v=1774522749",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11420/ProductCarouselMain/11420%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11420_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03565",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49473305837834",
      "swatch_filename": "03565_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Aqua.jpg?v=1774363313",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Aqua.jpg?v=1774363313",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49473719369994",
      "swatch_filename": "11380_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Aqua.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Aqua.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685590282",
      "product_title": "SOL'S Sporty Long Sleeve Performance T-Shirt",
      "product_handle": "02071",
      "product_url": "/products/02071",
      "product_full_url": "https://oakdenemerch.com/products/02071",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL",
        "sports",
        "style-02071",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02071",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49490365481226",
      "swatch_filename": "02071_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02071_Aqua.jpg?v=1774522696",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02071_Aqua.jpg?v=1774522696",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02071/ProductCarouselMain/02071%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02071_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548166410",
      "product_title": "SOL'S Sporty Performance T-Shirt",
      "product_handle": "11939",
      "product_url": "/products/11939",
      "product_full_url": "https://oakdenemerch.com/products/11939",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-11939",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "11939",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49473692893450",
      "swatch_filename": "11939_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Aqua.jpg?v=1774364865",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Aqua.jpg?v=1774364865",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11939/ProductCarouselMain/11939%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11939_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561609994",
      "product_title": "SOL'S Sporty Performance Tank Top",
      "product_handle": "02073",
      "product_url": "/products/02073",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL",
        "sports",
        "style-02073",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02073",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49513910567178",
      "swatch_filename": "02073_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02073_Aqua.jpg?v=1774618854",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02073_Aqua.jpg?v=1774618854",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02073/ProductCarouselMain/02073%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02073_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49473744535818",
      "swatch_filename": "03981_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Aqua.jpg?v=1774365053",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Aqua.jpg?v=1774365053",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547150602",
      "product_title": "SOL'S Unisex Sprint T-Shirt",
      "product_handle": "02995",
      "product_url": "/products/02995",
      "product_full_url": "https://oakdenemerch.com/products/02995",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-02995",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "02995",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49473768390922",
      "swatch_filename": "02995_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Aqua.jpg?v=1774365179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Aqua.jpg?v=1774365179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02995/ProductCarouselMain/02995%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02995_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547674890",
      "product_title": "SOL'S Vortex Ripstop Performance T-Shirt",
      "product_handle": "04787",
      "product_url": "/products/04787",
      "product_full_url": "https://oakdenemerch.com/products/04787",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04787",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04787",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31b3c1",
      "sort_bucket": "blue",
      "sort_hue": 0.516204,
      "sort_sat": 0.746114,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49472658342154",
      "swatch_filename": "04787_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_Aqua.jpg?v=1774358538",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_Aqua.jpg?v=1774358538",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04787/ProductCarouselMain/04787%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04787_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547707658",
      "product_title": "SOL'S Ladies Vortex Ripstop Performance T-Shirt",
      "product_handle": "04788",
      "product_url": "/products/04788",
      "product_full_url": "https://oakdenemerch.com/products/04788",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04788",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04788",
      "colour_name": "Arctic Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#b8dce0",
      "sort_bucket": "blue",
      "sort_hue": 0.516667,
      "sort_sat": 0.178571,
      "sort_val": 0.878431,
      "swatch_file_id": "gid://shopify/MediaImage/49472651821322",
      "swatch_filename": "04788_Arctic_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_Arctic_Blue.jpg?v=1774358494",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_Arctic_Blue.jpg?v=1774358494",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04788/ProductCarouselMain/04788%20ARB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04788_Arctic_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561675530",
      "product_title": "SOL'S Unisex Crusader Tank Top",
      "product_handle": "03980",
      "product_url": "/products/03980",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03980",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03980",
      "colour_name": "Arctic Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#b8dce0",
      "sort_bucket": "blue",
      "sort_hue": 0.516667,
      "sort_sat": 0.178571,
      "sort_val": 0.878431,
      "swatch_file_id": "gid://shopify/MediaImage/49513913581834",
      "swatch_filename": "03980_Arctic_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03980_Arctic_Blue.jpg?v=1774618878",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03980_Arctic_Blue.jpg?v=1774618878",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03980/ProductCarouselMain/03980%20ARB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03980_Arctic_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Arctic Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#b8dce0",
      "sort_bucket": "blue",
      "sort_hue": 0.516667,
      "sort_sat": 0.178571,
      "sort_val": 0.878431,
      "swatch_file_id": "gid://shopify/MediaImage/49473744371978",
      "swatch_filename": "03981_Arctic_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Arctic_Blue.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Arctic_Blue.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20ARB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Arctic_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547674890",
      "product_title": "SOL'S Vortex Ripstop Performance T-Shirt",
      "product_handle": "04787",
      "product_url": "/products/04787",
      "product_full_url": "https://oakdenemerch.com/products/04787",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04787",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04787",
      "colour_name": "Arctic Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#b8dce0",
      "sort_bucket": "blue",
      "sort_hue": 0.516667,
      "sort_sat": 0.178571,
      "sort_val": 0.878431,
      "swatch_file_id": "gid://shopify/MediaImage/49472658014474",
      "swatch_filename": "04787_Arctic_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_Arctic_Blue.jpg?v=1774358539",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_Arctic_Blue.jpg?v=1774358539",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04787/ProductCarouselMain/04787%20ARB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04787_Arctic_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Azure",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#00dcfa",
      "sort_bucket": "blue",
      "sort_hue": 0.52,
      "sort_sat": 1.0,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49471285657866",
      "swatch_filename": "SS621_Azure.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Azure.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Azure.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20AZR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Azure.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Azure",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#00dcfa",
      "sort_bucket": "blue",
      "sort_hue": 0.52,
      "sort_sat": 1.0,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49471313346826",
      "swatch_filename": "SS620_Azure.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Azure.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Azure.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20AZR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Azure.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS720",
      "colour_name": "Azure",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#00dcfa",
      "sort_bucket": "blue",
      "sort_hue": 0.52,
      "sort_sat": 1.0,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49472218726666",
      "swatch_filename": "SS720_Azure.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Azure.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Azure.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20AZR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_Azure.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554654474",
      "product_title": "Fruit of the Loom Lady Fit Value T-Shirt",
      "product_handle": "ss77",
      "product_url": "/products/ss77",
      "product_full_url": "https://oakdenemerch.com/products/ss77",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss77",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS77",
      "colour_name": "Azure",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#00dcfa",
      "sort_bucket": "blue",
      "sort_hue": 0.52,
      "sort_sat": 1.0,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49472026280202",
      "swatch_filename": "SS77_Azure.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Azure.jpg?v=1774353471",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Azure.jpg?v=1774353471",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS77/ProductCarouselMain/SS77%20AZR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss77_Azure.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "Azure",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#00dcfa",
      "sort_bucket": "blue",
      "sort_hue": 0.52,
      "sort_sat": 1.0,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49471330713866",
      "swatch_filename": "SS12_Azure.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Azure.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Azure.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20AZR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Azure.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554490634",
      "product_title": "Fruit of the Loom V Neck Value T-Shirt",
      "product_handle": "ss7",
      "product_url": "/products/ss7",
      "product_full_url": "https://oakdenemerch.com/products/ss7",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss7",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS7",
      "colour_name": "Azure",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#00dcfa",
      "sort_bucket": "blue",
      "sort_hue": 0.52,
      "sort_sat": 1.0,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49471272190218",
      "swatch_filename": "SS7_Azure.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Azure.jpg?v=1774348430",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Azure.jpg?v=1774348430",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS7/ProductCarouselMain/SS7%20AZR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss7_Azure.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Azure",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#00dcfa",
      "sort_bucket": "blue",
      "sort_hue": 0.52,
      "sort_sat": 1.0,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49471321440522",
      "swatch_filename": "SS6_Azure.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Azure.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Azure.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20AZR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Azure.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Atoll Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#4bc5d6",
      "sort_bucket": "blue",
      "sort_hue": 0.520384,
      "sort_sat": 0.649533,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49474449015050",
      "swatch_filename": "11500_Atoll_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Atoll_Blue.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Atoll_Blue.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20ATO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Atoll_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561773834",
      "product_title": "SOL'S Justin Tank Top",
      "product_handle": "11465",
      "product_url": "/products/11465",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11465",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11465",
      "colour_name": "Atoll Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#4bc5d6",
      "sort_bucket": "blue",
      "sort_hue": 0.520384,
      "sort_sat": 0.649533,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49513914925322",
      "swatch_filename": "11465_Atoll_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11465_Atoll_Blue.jpg?v=1774618897",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11465_Atoll_Blue.jpg?v=1774618897",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11465/ProductCarouselMain/11465%20ATO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11465_Atoll_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Atoll Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#4bc5d6",
      "sort_bucket": "blue",
      "sort_hue": 0.520384,
      "sort_sat": 0.649533,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49468933406986",
      "swatch_filename": "11502_Atoll_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Atoll_Blue.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Atoll_Blue.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20ATO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Atoll_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548035338",
      "product_title": "SOL'S Ladies Moon V Neck T-Shirt",
      "product_handle": "11388",
      "product_url": "/products/11388",
      "product_full_url": "https://oakdenemerch.com/products/11388",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11388",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11388",
      "colour_name": "Atoll Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#4bc5d6",
      "sort_bucket": "blue",
      "sort_hue": 0.520384,
      "sort_sat": 0.649533,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49468932456714",
      "swatch_filename": "11388_Atoll_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_Atoll_Blue.jpg?v=1774312856",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_Atoll_Blue.jpg?v=1774312856",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11388/ProductCarouselMain/11388%20ATO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11388_Atoll_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Atoll Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#4bc5d6",
      "sort_bucket": "blue",
      "sort_hue": 0.520384,
      "sort_sat": 0.649533,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49468823306506",
      "swatch_filename": "01825_Atoll_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Atoll_Blue.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Atoll_Blue.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20ATO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Atoll_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Atoll Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#4bc5d6",
      "sort_bucket": "blue",
      "sort_hue": 0.520384,
      "sort_sat": 0.649533,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49473718386954",
      "swatch_filename": "11380_Atoll_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Atoll_Blue.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Atoll_Blue.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20ATO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Atoll_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547904266",
      "product_title": "SOL'S Imperial Fit T-Shirt",
      "product_handle": "10580",
      "product_url": "/products/10580",
      "product_full_url": "https://oakdenemerch.com/products/10580",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-10580",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% cotton/40% polyester.",
      "style_code": "10580",
      "colour_name": "Charcoal Marl",
      "colour_group": "Grey > Charcoal",
      "rgb": "#3e5356",
      "sort_bucket": "blue",
      "sort_hue": 0.520833,
      "sort_sat": 0.27907,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49471859294474",
      "swatch_filename": "10580_Charcoal_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10580_Charcoal_Marl.jpg?v=1774352022",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10580_Charcoal_Marl.jpg?v=1774352022",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/10580/ProductCarouselMain/10580%20CHM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "10580_Charcoal_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547871498",
      "product_title": "SOL'S Regent Fit T-Shirt",
      "product_handle": "10553",
      "product_url": "/products/10553",
      "product_full_url": "https://oakdenemerch.com/products/10553",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-10553",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% cotton/40% polyester.",
      "style_code": "10553",
      "colour_name": "Charcoal Marl",
      "colour_group": "Grey > Charcoal",
      "rgb": "#3e5356",
      "sort_bucket": "blue",
      "sort_hue": 0.520833,
      "sort_sat": 0.27907,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49472629047562",
      "swatch_filename": "10553_Charcoal_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_Charcoal_Marl.jpg?v=1774358391",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_Charcoal_Marl.jpg?v=1774358391",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/10553/ProductCarouselMain/10553%20CHM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "10553_Charcoal_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547478282",
      "product_title": "SOL'S Unisex Tuner T-Shirt",
      "product_handle": "04203",
      "product_url": "/products/04203",
      "product_full_url": "https://oakdenemerch.com/products/04203",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-04203",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% cotton/40% polyester.",
      "style_code": "04203",
      "colour_name": "Charcoal Marl",
      "colour_group": "Grey > Charcoal",
      "rgb": "#3e5356",
      "sort_bucket": "blue",
      "sort_hue": 0.520833,
      "sort_sat": 0.27907,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49474458714378",
      "swatch_filename": "04203_Charcoal_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_Charcoal_Marl.jpg?v=1774372011",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_Charcoal_Marl.jpg?v=1774372011",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04203/ProductCarouselMain/04203%20CHM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04203_Charcoal_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687720202",
      "product_title": "Regatta Thermal Long Sleeve Vest",
      "product_handle": "rg289",
      "product_url": "/products/rg289",
      "product_full_url": "None",
      "vendor": "Regatta Professional",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "sleeveless",
        "style-rg289",
        "t-shirts",
        "underwear-thermals",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "Polyester/cotton fabric.",
      "style_code": "RG289",
      "colour_name": "Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#99e6f2",
      "sort_bucket": "blue",
      "sort_hue": 0.522472,
      "sort_sat": 0.367769,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49490481348874",
      "swatch_filename": "rg289_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg289_Blue.jpg?v=1774522966",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg289_Blue.jpg?v=1774522966",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Regatta%20Professional/Product%20Images/RG289/ProductCarouselMain/RG289%20BLU%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rg289_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562461962",
      "product_title": "Regatta Thermal Short Sleeve Vest",
      "product_handle": "rg288",
      "product_url": "/products/rg288",
      "product_full_url": "None",
      "vendor": "Regatta Professional",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "sleeveless",
        "style-rg288",
        "t-shirts",
        "underwear-thermals",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "Polyester/cotton fabric.",
      "style_code": "RG288",
      "colour_name": "Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#99e6f2",
      "sort_bucket": "blue",
      "sort_hue": 0.522472,
      "sort_sat": 0.367769,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49513932062986",
      "swatch_filename": "rg288_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg288_Blue.jpg?v=1774619073",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg288_Blue.jpg?v=1774619073",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Regatta%20Professional/Product%20Images/RG288/ProductCarouselMain/RG288%20BLU%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rg288_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Teal",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#43aebf",
      "sort_bucket": "blue",
      "sort_hue": 0.522849,
      "sort_sat": 0.649215,
      "sort_val": 0.74902,
      "swatch_file_id": "gid://shopify/MediaImage/49473259405578",
      "swatch_filename": "CV3001_Teal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Teal.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Teal.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20TEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Teal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Deep Teal",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#2a6d78",
      "sort_bucket": "blue",
      "sort_hue": 0.523504,
      "sort_sat": 0.65,
      "sort_val": 0.470588,
      "swatch_file_id": "gid://shopify/MediaImage/49473259176202",
      "swatch_filename": "CV3001_Deep_Teal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Deep_Teal.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Deep_Teal.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20DTE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Deep_Teal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550787850",
      "product_title": "AWDis Ladies Tri-Blend Cropped T-Shirt",
      "product_handle": "jt006",
      "product_url": "/products/jt006",
      "product_full_url": "https://oakdenemerch.com/products/jt006",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-jt006",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% cotton/25% viscose.*",
      "style_code": "JT006",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#9bafb3",
      "sort_bucket": "blue",
      "sort_hue": 0.527778,
      "sort_sat": 0.134078,
      "sort_val": 0.701961,
      "swatch_file_id": "gid://shopify/MediaImage/49474185953546",
      "swatch_filename": "JT006_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT006_Heather_Grey.jpg?v=1774370028",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT006_Heather_Grey.jpg?v=1774370028",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT006/ProductCarouselMain/JT006%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt006_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550722314",
      "product_title": "AWDis Tri-Blend T-Shirt",
      "product_handle": "jt001",
      "product_url": "/products/jt001",
      "product_full_url": "https://oakdenemerch.com/products/jt001",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-jt001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% viscose/25% cotton.*",
      "style_code": "JT001",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#9bafb3",
      "sort_bucket": "blue",
      "sort_hue": 0.527778,
      "sort_sat": 0.134078,
      "sort_val": 0.701961,
      "swatch_file_id": "gid://shopify/MediaImage/49468945334538",
      "swatch_filename": "JT001_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT001_Heather_Grey.jpg?v=1774314481",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT001_Heather_Grey.jpg?v=1774314481",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT001/ProductCarouselMain/JT001%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt001_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550820618",
      "product_title": "AWDis Unisex Oversize 100 T-Shirt",
      "product_handle": "jt009",
      "product_url": "/products/jt009",
      "product_full_url": "https://oakdenemerch.com/products/jt009",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jt009",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.*",
      "style_code": "JT009",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#9bafb3",
      "sort_bucket": "blue",
      "sort_hue": 0.527778,
      "sort_sat": 0.134078,
      "sort_val": 0.701961,
      "swatch_file_id": "gid://shopify/MediaImage/49471818203402",
      "swatch_filename": "JT009_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_Heather_Grey.jpg?v=1774351553",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_Heather_Grey.jpg?v=1774351553",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT009/ProductCarouselMain/JT009%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt009_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549411594",
      "product_title": "Gildan SoftStyle® EZ T-Shirt",
      "product_handle": "gd04",
      "product_url": "/products/gd04",
      "product_full_url": "https://oakdenemerch.com/products/gd04",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd04",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "GD04",
      "colour_name": "Baby Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#69e3ff",
      "sort_bucket": "blue",
      "sort_hue": 0.531111,
      "sort_sat": 0.588235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468937437450",
      "swatch_filename": "GD04_Baby_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Baby_Blue.jpg?v=1774313523",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Baby_Blue.jpg?v=1774313523",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD04/ProductCarouselMain/GD04%20BBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd04_Baby_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558193418",
      "product_title": "Tombo Medium Impact Core Bra",
      "product_handle": "tl371",
      "product_url": "/products/tl371",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-tl371",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "86% polyester/14% elastane interlock.",
      "style_code": "TL371",
      "colour_name": "Turquoise Blue",
      "colour_group": "Blue > Turquoise",
      "rgb": "#30bfe0",
      "sort_bucket": "blue",
      "sort_hue": 0.53125,
      "sort_sat": 0.785714,
      "sort_val": 0.878431,
      "swatch_file_id": "gid://shopify/MediaImage/49491009011978",
      "swatch_filename": "tl371_Turquoise_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl371_Turquoise_Blue.jpg?v=1774525770",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl371_Turquoise_Blue.jpg?v=1774525770",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Tombo/TL371/ProductCarouselMain/TL371%20TUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl371_Turquoise_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Turquoise Blue",
      "colour_group": "Blue > Turquoise",
      "rgb": "#2cabc9",
      "sort_bucket": "blue",
      "sort_hue": 0.531847,
      "sort_sat": 0.781095,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49474088960266",
      "swatch_filename": "RX151_Turquoise_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Turquoise_Blue.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Turquoise_Blue.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20TUR%20FRONT%202.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Turquoise_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Duck Blue",
      "colour_group": "Green > Emerald/Jade",
      "rgb": "#006780",
      "sort_bucket": "blue",
      "sort_hue": 0.532552,
      "sort_sat": 1.0,
      "sort_val": 0.501961,
      "swatch_file_id": "gid://shopify/MediaImage/49468823044362",
      "swatch_filename": "01825_Duck_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Duck_Blue.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Duck_Blue.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20DUB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Duck_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Duck Blue",
      "colour_group": "Green > Emerald/Jade",
      "rgb": "#006780",
      "sort_bucket": "blue",
      "sort_hue": 0.532552,
      "sort_sat": 1.0,
      "sort_val": 0.501961,
      "swatch_file_id": "gid://shopify/MediaImage/49473718354186",
      "swatch_filename": "11380_Duck_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Duck_Blue.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Duck_Blue.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20DUB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Duck_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#8bd8eb",
      "sort_bucket": "blue",
      "sort_hue": 0.532986,
      "sort_sat": 0.408511,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49474217804042",
      "swatch_filename": "JC001_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Sky_Blue.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Sky_Blue.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#8bd8eb",
      "sort_bucket": "blue",
      "sort_hue": 0.532986,
      "sort_sat": 0.408511,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49474209841418",
      "swatch_filename": "JC001B_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Sky_Blue.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Sky_Blue.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#8bd8eb",
      "sort_bucket": "blue",
      "sort_hue": 0.532986,
      "sort_sat": 0.408511,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49473142063370",
      "swatch_filename": "JC005_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Sky_Blue.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Sky_Blue.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#8bd8eb",
      "sort_bucket": "blue",
      "sort_hue": 0.532986,
      "sort_sat": 0.408511,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49471442419978",
      "swatch_filename": "AT001_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Sky_Blue.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Sky_Blue.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#8bd8eb",
      "sort_bucket": "blue",
      "sort_hue": 0.532986,
      "sort_sat": 0.408511,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49471430000906",
      "swatch_filename": "AT002_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Sky_Blue.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Sky_Blue.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550820618",
      "product_title": "AWDis Unisex Oversize 100 T-Shirt",
      "product_handle": "jt009",
      "product_url": "/products/jt009",
      "product_full_url": "https://oakdenemerch.com/products/jt009",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jt009",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.*",
      "style_code": "JT009",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#8bd8eb",
      "sort_bucket": "blue",
      "sort_hue": 0.532986,
      "sort_sat": 0.408511,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49471818236170",
      "swatch_filename": "JT009_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_Sky_Blue.jpg?v=1774351554",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_Sky_Blue.jpg?v=1774351554",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT009/ProductCarouselMain/JT009%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt009_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#009fcf",
      "sort_bucket": "blue",
      "sort_hue": 0.538647,
      "sort_sat": 1.0,
      "sort_val": 0.811765,
      "swatch_file_id": "gid://shopify/MediaImage/49471385436426",
      "swatch_filename": "GD05_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Sapphire_Blue.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Sapphire_Blue.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#009fcf",
      "sort_bucket": "blue",
      "sort_hue": 0.538647,
      "sort_sat": 1.0,
      "sort_val": 0.811765,
      "swatch_file_id": "gid://shopify/MediaImage/49474267382026",
      "swatch_filename": "GD01_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Sapphire_Blue.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Sapphire_Blue.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#009fcf",
      "sort_bucket": "blue",
      "sort_hue": 0.538647,
      "sort_sat": 1.0,
      "sort_val": 0.811765,
      "swatch_file_id": "gid://shopify/MediaImage/49471368528138",
      "swatch_filename": "GD15_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Sapphire_Blue.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Sapphire_Blue.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#009fcf",
      "sort_bucket": "blue",
      "sort_hue": 0.538647,
      "sort_sat": 1.0,
      "sort_val": 0.811765,
      "swatch_file_id": "gid://shopify/MediaImage/49471398445322",
      "swatch_filename": "GD02_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Sapphire_Blue.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Sapphire_Blue.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Light Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#9fe6fc",
      "sort_bucket": "blue",
      "sort_hue": 0.539427,
      "sort_sat": 0.369048,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49471384584458",
      "swatch_filename": "GD05_Light_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Light_Blue.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Light_Blue.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20LBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Light_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549509898",
      "product_title": "Gildan Heavy Cotton™ Toddler T-Shirt",
      "product_handle": "gd05p",
      "product_url": "/products/gd05p",
      "product_full_url": "https://oakdenemerch.com/products/gd05p",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "2T",
        "2T-3T-4T-5T-6T",
        "3T",
        "4T",
        "5T",
        "6T",
        "baby-toddler",
        "style-gd05p",
        "t-shirts",
        "unisex"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05P",
      "colour_name": "Light Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#9fe6fc",
      "sort_bucket": "blue",
      "sort_hue": 0.539427,
      "sort_sat": 0.369048,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49474248802570",
      "swatch_filename": "GD05P_Light_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05P_Light_Blue.jpg?v=1774370725",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05P_Light_Blue.jpg?v=1774370725",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05P/ProductCarouselMain/GD05P%20LBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05p_Light_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549772042",
      "product_title": "Gildan Ladies SoftStyle® T-Shirt",
      "product_handle": "gd72",
      "product_url": "/products/gd72",
      "product_full_url": "https://oakdenemerch.com/products/gd72",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd72",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD72",
      "colour_name": "Light Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#9fe6fc",
      "sort_bucket": "blue",
      "sort_hue": 0.539427,
      "sort_sat": 0.369048,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49468940714250",
      "swatch_filename": "GD72_Light_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Light_Blue.jpg?v=1774314002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Light_Blue.jpg?v=1774314002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD72/ProductCarouselMain/GD72%20LBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd72_Light_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Light Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#9fe6fc",
      "sort_bucket": "blue",
      "sort_hue": 0.539427,
      "sort_sat": 0.369048,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49474268299530",
      "swatch_filename": "GD01_Light_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Light_Blue.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Light_Blue.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20LBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Light_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Light Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#9fe6fc",
      "sort_bucket": "blue",
      "sort_hue": 0.539427,
      "sort_sat": 0.369048,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49471369216266",
      "swatch_filename": "GD15_Light_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Light_Blue.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Light_Blue.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20LBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Light_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD14",
      "colour_name": "Light Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#9fe6fc",
      "sort_bucket": "blue",
      "sort_hue": 0.539427,
      "sort_sat": 0.369048,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49490461851914",
      "swatch_filename": "gd14_Light_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Light_Blue.jpg?v=1774522854",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Light_Blue.jpg?v=1774522854",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20LBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Light_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Light Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#9fe6fc",
      "sort_bucket": "blue",
      "sort_hue": 0.539427,
      "sort_sat": 0.369048,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49471397462282",
      "swatch_filename": "GD02_Light_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Light_Blue.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Light_Blue.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20LBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Light_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "Tropical Blue",
      "colour_group": "Blue > Turquoise",
      "rgb": "#007499",
      "sort_bucket": "blue",
      "sort_hue": 0.540305,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49491375882506",
      "swatch_filename": "kb3025ic_Tropical_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Tropical_Blue.jpg?v=1774526632",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Tropical_Blue.jpg?v=1774526632",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20TBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Tropical_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548297482",
      "product_title": "Russell Athletic Authentic Heavyweight T-Shirt",
      "product_handle": "215m",
      "product_url": "/products/215m",
      "product_full_url": "https://oakdenemerch.com/products/215m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "sports",
        "style-215m",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "215M",
      "colour_name": "Petrol Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#004961",
      "sort_bucket": "blue",
      "sort_hue": 0.541237,
      "sort_sat": 1.0,
      "sort_val": 0.380392,
      "swatch_file_id": "gid://shopify/MediaImage/49470972756234",
      "swatch_filename": "215M_Petrol_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/215M_Petrol_Blue.jpg?v=1774347211",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/215M_Petrol_Blue.jpg?v=1774347211",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/215M/ProductCarouselMain/215M%20PET%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "215m_Petrol_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687228682",
      "product_title": "AWDis Cool Long Sleeve Wicking T-Shirt",
      "product_handle": "jc002",
      "product_url": "/products/jc002",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jc002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC002",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#26c9ff",
      "sort_bucket": "blue",
      "sort_hue": 0.541475,
      "sort_sat": 0.85098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490477187338",
      "swatch_filename": "jc002_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Sapphire_Blue.jpg?v=1774522893",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Sapphire_Blue.jpg?v=1774522893",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC002/ProductCarouselMain/JC002%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc002_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550361866",
      "product_title": "AWDis Cool Smooth T-Shirt",
      "product_handle": "jc020",
      "product_url": "/products/jc020",
      "product_full_url": "https://oakdenemerch.com/products/jc020",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-jc020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#26c9ff",
      "sort_bucket": "blue",
      "sort_hue": 0.541475,
      "sort_sat": 0.85098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472871301386",
      "swatch_filename": "JC020_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Sapphire_Blue.jpg?v=1774359994",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Sapphire_Blue.jpg?v=1774359994",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020/ProductCarouselMain/JC020%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#26c9ff",
      "sort_bucket": "blue",
      "sort_hue": 0.541475,
      "sort_sat": 0.85098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474218885386",
      "swatch_filename": "JC001_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Sapphire_Blue.jpg?v=1774370458",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Sapphire_Blue.jpg?v=1774370458",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562003210",
      "product_title": "AWDis Cool Vest",
      "product_handle": "jc007",
      "product_url": "/products/jc007",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc007",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#26c9ff",
      "sort_bucket": "blue",
      "sort_hue": 0.541475,
      "sort_sat": 0.85098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513924133130",
      "swatch_filename": "jc007_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Sapphire_Blue.jpg?v=1774618979",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Sapphire_Blue.jpg?v=1774618979",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC007/ProductCarouselMain/JC007%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#26c9ff",
      "sort_bucket": "blue",
      "sort_hue": 0.541475,
      "sort_sat": 0.85098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474209874186",
      "swatch_filename": "JC001B_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Sapphire_Blue.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Sapphire_Blue.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687261450",
      "product_title": "AWDis Ladies Cool Long Sleeve T-Shirt",
      "product_handle": "jc012",
      "product_url": "/products/jc012",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-jc012",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC012",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#26c9ff",
      "sort_bucket": "blue",
      "sort_hue": 0.541475,
      "sort_sat": 0.85098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490477744394",
      "swatch_filename": "jc012_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc012_Sapphire_Blue.jpg?v=1774522901",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc012_Sapphire_Blue.jpg?v=1774522901",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC012/ProductCarouselMain/JC012%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc012_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#26c9ff",
      "sort_bucket": "blue",
      "sort_hue": 0.541475,
      "sort_sat": 0.85098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473141965066",
      "swatch_filename": "JC005_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Sapphire_Blue.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Sapphire_Blue.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562101514",
      "product_title": "AWDis Ladies Cool Vest",
      "product_handle": "jc015",
      "product_url": "/products/jc015",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc015",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC015",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#26c9ff",
      "sort_bucket": "blue",
      "sort_hue": 0.541475,
      "sort_sat": 0.85098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513927770378",
      "swatch_filename": "jc015_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Sapphire_Blue.jpg?v=1774619007",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Sapphire_Blue.jpg?v=1774619007",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC015/ProductCarouselMain/JC015%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc015_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554654474",
      "product_title": "Fruit of the Loom Lady Fit Value T-Shirt",
      "product_handle": "ss77",
      "product_url": "/products/ss77",
      "product_full_url": "https://oakdenemerch.com/products/ss77",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss77",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS77",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#91e3ff",
      "sort_bucket": "blue",
      "sort_hue": 0.542424,
      "sort_sat": 0.431373,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472025919754",
      "swatch_filename": "SS77_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Sky_Blue.jpg?v=1774353471",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Sky_Blue.jpg?v=1774353471",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS77/ProductCarouselMain/SS77%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss77_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#91e3ff",
      "sort_bucket": "blue",
      "sort_hue": 0.542424,
      "sort_sat": 0.431373,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471330386186",
      "swatch_filename": "SS12_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Sky_Blue.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Sky_Blue.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#91e3ff",
      "sort_bucket": "blue",
      "sort_hue": 0.542424,
      "sort_sat": 0.431373,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471321899274",
      "swatch_filename": "SS6_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Sky_Blue.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Sky_Blue.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553016074",
      "product_title": "SF Clothing Feel Good Stretch T-Shirt",
      "product_handle": "sf121",
      "product_url": "/products/sf121",
      "product_full_url": "https://oakdenemerch.com/products/sf121",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-sf121",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane single jersey.*",
      "style_code": "SF121",
      "colour_name": "Heather Charcoal",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#4e636b",
      "sort_bucket": "blue",
      "sort_hue": 0.545977,
      "sort_sat": 0.271028,
      "sort_val": 0.419608,
      "swatch_file_id": "gid://shopify/MediaImage/49472270893322",
      "swatch_filename": "SF121_Heather_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF121_Heather_Charcoal.jpg?v=1774354029",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF121_Heather_Charcoal.jpg?v=1774354029",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF121/ProductCarouselMain/SF121%20HCH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf121_Heather_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548592394",
      "product_title": "Bella Ladies Micro Rib Baby T-Shirt",
      "product_handle": "bl1010",
      "product_url": "/products/bl1010",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "M",
        "S",
        "style-bl1010",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1010",
      "colour_name": "Solid Baby Blue Blend",
      "colour_group": "Blue > Light Blue",
      "rgb": "#89b3c4",
      "sort_bucket": "blue",
      "sort_hue": 0.548023,
      "sort_sat": 0.30102,
      "sort_val": 0.768627,
      "swatch_file_id": "gid://shopify/MediaImage/49491499254026",
      "swatch_filename": "bl1010_Solid_Baby_Blue_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1010_Solid_Baby_Blue_Blend.jpg?v=1774526815",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1010_Solid_Baby_Blue_Blend.jpg?v=1774526815",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1010/ProductCarouselMain/BL1010%20SBB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1010_Solid_Baby_Blue_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561806602",
      "product_title": "Bella Ladies Micro Rib Spaghetti Strap Tank Top",
      "product_handle": "bl1012",
      "product_url": "/products/bl1012",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-bl1012",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1012",
      "colour_name": "Solid Baby Blue Blend",
      "colour_group": "Blue > Light Blue",
      "rgb": "#89b3c4",
      "sort_bucket": "blue",
      "sort_hue": 0.548023,
      "sort_sat": 0.30102,
      "sort_val": 0.768627,
      "swatch_file_id": "gid://shopify/MediaImage/49513916694794",
      "swatch_filename": "bl1012_Solid_Baby_Blue_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1012_Solid_Baby_Blue_Blend.jpg?v=1774618909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1012_Solid_Baby_Blue_Blend.jpg?v=1774618909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1012/ProductCarouselMain/BL1012%20SBB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1012_Solid_Baby_Blue_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552557322",
      "product_title": "Proact Ladies Performance T-Shirt",
      "product_handle": "pa439",
      "product_url": "/products/pa439",
      "product_full_url": "https://oakdenemerch.com/products/pa439",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa439",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA439",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#0076a8",
      "sort_bucket": "blue",
      "sort_hue": 0.549603,
      "sort_sat": 1.0,
      "sort_val": 0.658824,
      "swatch_file_id": "gid://shopify/MediaImage/49471737069834",
      "swatch_filename": "PA439_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Aqua.jpg?v=1774351220",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Aqua.jpg?v=1774351220",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA439/ProductCarouselMain/PA439%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa439_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552524554",
      "product_title": "Proact Performance T-Shirt",
      "product_handle": "pa438",
      "product_url": "/products/pa438",
      "product_full_url": "https://oakdenemerch.com/products/pa438",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa438",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA438",
      "colour_name": "Aqua",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#0076a8",
      "sort_bucket": "blue",
      "sort_hue": 0.549603,
      "sort_sat": 1.0,
      "sort_val": 0.658824,
      "swatch_file_id": "gid://shopify/MediaImage/49471751913738",
      "swatch_filename": "PA438_Aqua.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Aqua.jpg?v=1774351290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Aqua.jpg?v=1774351290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA438/ProductCarouselMain/PA438%20AQA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa438_Aqua.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548297482",
      "product_title": "Russell Athletic Authentic Heavyweight T-Shirt",
      "product_handle": "215m",
      "product_url": "/products/215m",
      "product_full_url": "https://oakdenemerch.com/products/215m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "sports",
        "style-215m",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "215M",
      "colour_name": "Convoy Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#3d464a",
      "sort_bucket": "blue",
      "sort_hue": 0.551282,
      "sort_sat": 0.175676,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49470972625162",
      "swatch_filename": "215M_Convoy_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/215M_Convoy_Grey.jpg?v=1774347211",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/215M_Convoy_Grey.jpg?v=1774347211",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/215M/ProductCarouselMain/215M%20CVY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "215m_Convoy_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686147338",
      "product_title": "Russell Athletic Classic Long Sleeve T-Shirt",
      "product_handle": "180l",
      "product_url": "/products/180l",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-180l",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "180L",
      "colour_name": "Convoy Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#3d464a",
      "sort_bucket": "blue",
      "sort_hue": 0.551282,
      "sort_sat": 0.175676,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49490372886794",
      "swatch_filename": "180l_Convoy_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180l_Convoy_Grey.jpg?v=1774522758",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180l_Convoy_Grey.jpg?v=1774522758",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180L/ProductCarouselMain/180L%20CVY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180l_Convoy_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "Convoy Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#3d464a",
      "sort_bucket": "blue",
      "sort_hue": 0.551282,
      "sort_sat": 0.175676,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49473273200906",
      "swatch_filename": "180M_Convoy_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Convoy_Grey.jpg?v=1774363124",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Convoy_Grey.jpg?v=1774363124",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20CVY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_Convoy_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548231946",
      "product_title": "Russell Athletic Ladies Authentic Classic Ringspun T-Shirt",
      "product_handle": "180f",
      "product_url": "/products/180f",
      "product_full_url": "https://oakdenemerch.com/products/180f",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-180f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180F",
      "colour_name": "Convoy Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#3d464a",
      "sort_bucket": "blue",
      "sort_hue": 0.551282,
      "sort_sat": 0.175676,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49472623608074",
      "swatch_filename": "180F_Convoy_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180F_Convoy_Grey.jpg?v=1774358324",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180F_Convoy_Grey.jpg?v=1774358324",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180F/ProductCarouselMain/180F%20CVY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180f_Convoy_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#007bb3",
      "sort_bucket": "blue",
      "sort_hue": 0.552142,
      "sort_sat": 1.0,
      "sort_val": 0.701961,
      "swatch_file_id": "gid://shopify/MediaImage/49474342781194",
      "swatch_filename": "AM10_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Sapphire_Blue.jpg?v=1774371249",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Sapphire_Blue.jpg?v=1774371249",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548363018",
      "product_title": "Anthem Unisex Organic Midweight T-Shirt",
      "product_handle": "am12",
      "product_url": "/products/am12",
      "product_full_url": "https://oakdenemerch.com/products/am12",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am12",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM12",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#007bb3",
      "sort_bucket": "blue",
      "sort_hue": 0.552142,
      "sort_sat": 1.0,
      "sort_val": 0.701961,
      "swatch_file_id": "gid://shopify/MediaImage/49472902725898",
      "swatch_filename": "AM12_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Sapphire_Blue.jpg?v=1774360382",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Sapphire_Blue.jpg?v=1774360382",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM12/ProductCarouselMain/AM12%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am12_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549935882",
      "product_title": "Henbury HiCool® Performance T-Shirt",
      "product_handle": "h024",
      "product_url": "/products/h024",
      "product_full_url": "https://oakdenemerch.com/products/h024",
      "vendor": "Henbury",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-h024",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% HiCool® polyester interlock.",
      "style_code": "H024",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#3f545e",
      "sort_bucket": "blue",
      "sort_hue": 0.553763,
      "sort_sat": 0.329787,
      "sort_val": 0.368627,
      "swatch_file_id": "gid://shopify/MediaImage/49473151697162",
      "swatch_filename": "H024_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/H024_Charcoal.jpg?v=1774362358",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/H024_Charcoal.jpg?v=1774362358",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H024/ProductCarouselMain/H024%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h024_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550001418",
      "product_title": "Henbury Unisex Coolplus® Wicking Piqué T-Shirt",
      "product_handle": "h075",
      "product_url": "/products/h075",
      "product_full_url": "https://oakdenemerch.com/products/h075",
      "vendor": "Henbury",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-h075",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester micro piqué.",
      "style_code": "H075",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#3f545e",
      "sort_bucket": "blue",
      "sort_hue": 0.553763,
      "sort_sat": 0.329787,
      "sort_val": 0.368627,
      "swatch_file_id": "gid://shopify/MediaImage/49474231304458",
      "swatch_filename": "H075_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/H075_Charcoal.jpg?v=1774370566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/H075_Charcoal.jpg?v=1774370566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H075/ProductCarouselMain/H075%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h075_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD05",
      "colour_name": "Tweed",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#2d373c",
      "sort_bucket": "blue",
      "sort_hue": 0.555556,
      "sort_sat": 0.25,
      "sort_val": 0.235294,
      "swatch_file_id": "gid://shopify/MediaImage/49471385600266",
      "swatch_filename": "GD05_Tweed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Tweed.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Tweed.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20TWD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Tweed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547871498",
      "product_title": "SOL'S Regent Fit T-Shirt",
      "product_handle": "10553",
      "product_url": "/products/10553",
      "product_full_url": "https://oakdenemerch.com/products/10553",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-10553",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% cotton/40% polyester.",
      "style_code": "10553",
      "colour_name": "Heather Denim",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#00273b",
      "sort_bucket": "blue",
      "sort_hue": 0.556497,
      "sort_sat": 1.0,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49472629080330",
      "swatch_filename": "10553_Heather_Denim.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_Heather_Denim.jpg?v=1774358391",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_Heather_Denim.jpg?v=1774358391",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/10553/ProductCarouselMain/10553%20HDM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "10553_Heather_Denim.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD05",
      "colour_name": "Dark Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#315060",
      "sort_bucket": "blue",
      "sort_hue": 0.556738,
      "sort_sat": 0.489583,
      "sort_val": 0.376471,
      "swatch_file_id": "gid://shopify/MediaImage/49471384977674",
      "swatch_filename": "GD05_Dark_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Dark_Heather.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Dark_Heather.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20DHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Dark_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549772042",
      "product_title": "Gildan Ladies SoftStyle® T-Shirt",
      "product_handle": "gd72",
      "product_url": "/products/gd72",
      "product_full_url": "https://oakdenemerch.com/products/gd72",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd72",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "65% polyester/35% cotton.",
      "style_code": "GD72",
      "colour_name": "Dark Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#315060",
      "sort_bucket": "blue",
      "sort_hue": 0.556738,
      "sort_sat": 0.489583,
      "sort_val": 0.376471,
      "swatch_file_id": "gid://shopify/MediaImage/49468940288266",
      "swatch_filename": "GD72_Dark_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Dark_Heather.jpg?v=1774314002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Dark_Heather.jpg?v=1774314002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD72/ProductCarouselMain/GD72%20DHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd72_Dark_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "65% polyester/35% cotton.",
      "style_code": "GD01",
      "colour_name": "Dark Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#315060",
      "sort_bucket": "blue",
      "sort_hue": 0.556738,
      "sort_sat": 0.489583,
      "sort_val": 0.376471,
      "swatch_file_id": "gid://shopify/MediaImage/49474267119882",
      "swatch_filename": "GD01_Dark_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Dark_Heather.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Dark_Heather.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20DHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Dark_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549575434",
      "product_title": "Gildan SoftStyle® V Neck T-Shirt",
      "product_handle": "gd10",
      "product_url": "/products/gd10",
      "product_full_url": "https://oakdenemerch.com/products/gd10",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd10",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "65% polyester/35% cotton.",
      "style_code": "GD10",
      "colour_name": "Dark Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#315060",
      "sort_bucket": "blue",
      "sort_hue": 0.556738,
      "sort_sat": 0.489583,
      "sort_val": 0.376471,
      "swatch_file_id": "gid://shopify/MediaImage/49468938879242",
      "swatch_filename": "GD10_Dark_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD10_Dark_Heather.jpg?v=1774313702",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD10_Dark_Heather.jpg?v=1774313702",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD10/ProductCarouselMain/GD10%20DHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd10_Dark_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD14",
      "colour_name": "Dark Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#315060",
      "sort_bucket": "blue",
      "sort_hue": 0.556738,
      "sort_sat": 0.489583,
      "sort_val": 0.376471,
      "swatch_file_id": "gid://shopify/MediaImage/49490462114058",
      "swatch_filename": "gd14_Dark_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Dark_Heather.jpg?v=1774522855",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Dark_Heather.jpg?v=1774522855",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20DHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Dark_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD02",
      "colour_name": "Dark Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#315060",
      "sort_bucket": "blue",
      "sort_hue": 0.556738,
      "sort_sat": 0.489583,
      "sort_val": 0.376471,
      "swatch_file_id": "gid://shopify/MediaImage/49471397855498",
      "swatch_filename": "GD02_Dark_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Dark_Heather.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Dark_Heather.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20DHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Dark_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552491786",
      "product_title": "Proact Ladies Triblend Sports T-Shirt",
      "product_handle": "pa4021",
      "product_url": "/products/pa4021",
      "product_full_url": "https://oakdenemerch.com/products/pa4021",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-pa4021",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% cotton/25% viscose.",
      "style_code": "PA4021",
      "colour_name": "Duck Blue Heather",
      "colour_group": "Blue > Heather/Effect Blue",
      "rgb": "#346680",
      "sort_bucket": "blue",
      "sort_hue": 0.557018,
      "sort_sat": 0.59375,
      "sort_val": 0.501961,
      "swatch_file_id": "gid://shopify/MediaImage/49474101641482",
      "swatch_filename": "PA4021_Duck_Blue_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA4021_Duck_Blue_Heather.jpg?v=1774369137",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA4021_Duck_Blue_Heather.jpg?v=1774369137",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA4021/ProductCarouselMain/PA4021%20DBH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa4021_Duck_Blue_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552459018",
      "product_title": "Proact Triblend Sports T-Shirt",
      "product_handle": "pa4011",
      "product_url": "/products/pa4011",
      "product_full_url": "https://oakdenemerch.com/products/pa4011",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa4011",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% cotton/25% viscose.",
      "style_code": "PA4011",
      "colour_name": "Duck Blue Heather",
      "colour_group": "Blue > Heather/Effect Blue",
      "rgb": "#346680",
      "sort_bucket": "blue",
      "sort_hue": 0.557018,
      "sort_sat": 0.59375,
      "sort_val": 0.501961,
      "swatch_file_id": "gid://shopify/MediaImage/49471761973514",
      "swatch_filename": "PA4011_Duck_Blue_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA4011_Duck_Blue_Heather.jpg?v=1774351356",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA4011_Duck_Blue_Heather.jpg?v=1774351356",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA4011/ProductCarouselMain/PA4011%20DBH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa4011_Duck_Blue_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552393482",
      "product_title": "Native Spirit Oversized T-Shirt",
      "product_handle": "ns332",
      "product_url": "/products/ns332",
      "product_full_url": "https://oakdenemerch.com/products/ns332",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns332",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "NS332",
      "colour_name": "Aquamarine",
      "colour_group": "Blue > Light Blue",
      "rgb": "#94bfd6",
      "sort_bucket": "blue",
      "sort_hue": 0.558081,
      "sort_sat": 0.308411,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49474121793802",
      "swatch_filename": "NS332_Aquamarine.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_Aquamarine.jpg?v=1774369280",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_Aquamarine.jpg?v=1774369280",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS332/ProductCarouselMain/NS332%20AQM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns332_Aquamarine.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Aquamarine",
      "colour_group": "Blue > Light Blue",
      "rgb": "#94bfd6",
      "sort_bucket": "blue",
      "sort_hue": 0.558081,
      "sort_sat": 0.308411,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49473667039498",
      "swatch_filename": "NS305_Aquamarine.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Aquamarine.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Aquamarine.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20AQM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Aquamarine.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Airforce Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31637f",
      "sort_bucket": "blue",
      "sort_hue": 0.559829,
      "sort_sat": 0.614173,
      "sort_val": 0.498039,
      "swatch_file_id": "gid://shopify/MediaImage/49474218000650",
      "swatch_filename": "JC001_Airforce_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Airforce_Blue.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Airforce_Blue.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20AIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Airforce_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Airforce Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31637f",
      "sort_bucket": "blue",
      "sort_hue": 0.559829,
      "sort_sat": 0.614173,
      "sort_val": 0.498039,
      "swatch_file_id": "gid://shopify/MediaImage/49471442616586",
      "swatch_filename": "AT001_Airforce_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Airforce_Blue.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Airforce_Blue.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20AIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Airforce_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Airforce Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31637f",
      "sort_bucket": "blue",
      "sort_hue": 0.559829,
      "sort_sat": 0.614173,
      "sort_val": 0.498039,
      "swatch_file_id": "gid://shopify/MediaImage/49471429771530",
      "swatch_filename": "AT002_Airforce_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Airforce_Blue.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Airforce_Blue.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20AIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Airforce_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Indigo",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#31637f",
      "sort_bucket": "blue",
      "sort_hue": 0.559829,
      "sort_sat": 0.614173,
      "sort_val": 0.498039,
      "swatch_file_id": "gid://shopify/MediaImage/49471384846602",
      "swatch_filename": "GD05_Indigo.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Indigo.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Indigo.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20IND%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Indigo.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Indigo",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#31637f",
      "sort_bucket": "blue",
      "sort_hue": 0.559829,
      "sort_sat": 0.614173,
      "sort_val": 0.498039,
      "swatch_file_id": "gid://shopify/MediaImage/49474267414794",
      "swatch_filename": "GD01_Indigo.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Indigo.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Indigo.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20IND%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Indigo.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Indigo",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#31637f",
      "sort_bucket": "blue",
      "sort_hue": 0.559829,
      "sort_sat": 0.614173,
      "sort_val": 0.498039,
      "swatch_file_id": "gid://shopify/MediaImage/49471397265674",
      "swatch_filename": "GD02_Indigo.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Indigo.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Indigo.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20IND%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Indigo.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD05",
      "colour_name": "Heather Sapphire",
      "colour_group": "Blue > Sapphire",
      "rgb": "#0d96e6",
      "sort_bucket": "blue",
      "sort_hue": 0.561444,
      "sort_sat": 0.943478,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49471385141514",
      "swatch_filename": "GD05_Heather_Sapphire.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Heather_Sapphire.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Heather_Sapphire.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20HSP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Heather_Sapphire.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687621898",
      "product_title": "Mantis Unisex Essential Heavy Long Sleeve T-Shirt",
      "product_handle": "m06",
      "product_url": "/products/m06",
      "product_full_url": "None",
      "vendor": "Mantis",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-m06",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "M06",
      "colour_name": "Heather Marl",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#96a8b3",
      "sort_bucket": "blue",
      "sort_hue": 0.563218,
      "sort_sat": 0.162011,
      "sort_val": 0.701961,
      "swatch_file_id": "gid://shopify/MediaImage/49490480136458",
      "swatch_filename": "m06_Heather_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m06_Heather_Marl.jpg?v=1774522945",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m06_Heather_Marl.jpg?v=1774522945",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Mantis/M06/ProductCarouselMain/M06%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "m06_Heather_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Mountain Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#00426b",
      "sort_bucket": "blue",
      "sort_hue": 0.563863,
      "sort_sat": 1.0,
      "sort_val": 0.419608,
      "swatch_file_id": "gid://shopify/MediaImage/49471313805578",
      "swatch_filename": "SS620_Mountain_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Mountain_Blue.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Mountain_Blue.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20MNB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Mountain_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554457866",
      "product_title": "Fruit of the Loom Pure Cotton T-Shirt",
      "product_handle": "ss640",
      "product_url": "/products/ss640",
      "product_full_url": "https://oakdenemerch.com/products/ss640",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss640",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "SS640",
      "colour_name": "Mountain Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#00426b",
      "sort_bucket": "blue",
      "sort_hue": 0.563863,
      "sort_sat": 1.0,
      "sort_val": 0.419608,
      "swatch_file_id": "gid://shopify/MediaImage/49468957589770",
      "swatch_filename": "SS640_Mountain_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Mountain_Blue.jpg?v=1774315114",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Mountain_Blue.jpg?v=1774315114",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS640/ProductCarouselMain/SS640%20MNB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss640_Mountain_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550820618",
      "product_title": "AWDis Unisex Oversize 100 T-Shirt",
      "product_handle": "jt009",
      "product_url": "/products/jt009",
      "product_full_url": "https://oakdenemerch.com/products/jt009",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jt009",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.*",
      "style_code": "JT009",
      "colour_name": "Shark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#2a353c",
      "sort_bucket": "blue",
      "sort_hue": 0.564815,
      "sort_sat": 0.3,
      "sort_val": 0.235294,
      "swatch_file_id": "gid://shopify/MediaImage/49471818072330",
      "swatch_filename": "JT009_Shark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_Shark_Grey.jpg?v=1774351553",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_Shark_Grey.jpg?v=1774351553",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT009/ProductCarouselMain/JT009%20SHK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt009_Shark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548559626",
      "product_title": "AWDis Heavyweight Boxy 240 T-Shirt",
      "product_handle": "at003",
      "product_url": "/products/at003",
      "product_full_url": "https://oakdenemerch.com/products/at003",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-at003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT003",
      "colour_name": "Solid Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#2a353c",
      "sort_bucket": "blue",
      "sort_hue": 0.564815,
      "sort_sat": 0.3,
      "sort_val": 0.235294,
      "swatch_file_id": "gid://shopify/MediaImage/49472884637962",
      "swatch_filename": "AT003_Solid_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT003_Solid_Charcoal.jpg?v=1774360179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT003_Solid_Charcoal.jpg?v=1774360179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT003/ProductCarouselMain/AT003%20SDC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at003_Solid_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686409482",
      "product_title": "AWDis Long Sleeve 180 T-Shirt",
      "product_handle": "at012",
      "product_url": "/products/at012",
      "product_full_url": "https://oakdenemerch.com/products/at012",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-shirt",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-at012",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT012",
      "colour_name": "Solid Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#2a353c",
      "sort_bucket": "blue",
      "sort_hue": 0.564815,
      "sort_sat": 0.3,
      "sort_val": 0.235294,
      "swatch_file_id": "gid://shopify/MediaImage/49490397331722",
      "swatch_filename": "at012_Solid_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/at012_Solid_Charcoal.jpg?v=1774522777",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/at012_Solid_Charcoal.jpg?v=1774522777",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT012/ProductCarouselMain/AT012%20SDC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at012_Solid_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Solid Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#2a353c",
      "sort_bucket": "blue",
      "sort_hue": 0.564815,
      "sort_sat": 0.3,
      "sort_val": 0.235294,
      "swatch_file_id": "gid://shopify/MediaImage/49471442845962",
      "swatch_filename": "AT001_Solid_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Solid_Charcoal.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Solid_Charcoal.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20SDC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Solid_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Solid Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#2a353c",
      "sort_bucket": "blue",
      "sort_hue": 0.564815,
      "sort_sat": 0.3,
      "sort_val": 0.235294,
      "swatch_file_id": "gid://shopify/MediaImage/49471430066442",
      "swatch_filename": "AT002_Solid_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Solid_Charcoal.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Solid_Charcoal.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20SDC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Solid_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549935882",
      "product_title": "Henbury HiCool® Performance T-Shirt",
      "product_handle": "h024",
      "product_url": "/products/h024",
      "product_full_url": "https://oakdenemerch.com/products/h024",
      "vendor": "Henbury",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-h024",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% HiCool® polyester interlock.",
      "style_code": "H024",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001c2e",
      "sort_bucket": "blue",
      "sort_hue": 0.565217,
      "sort_sat": 1.0,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49473151729930",
      "swatch_filename": "H024_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/H024_Navy.jpg?v=1774362358",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/H024_Navy.jpg?v=1774362358",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H024/ProductCarouselMain/H024%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h024_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687163146",
      "product_title": "Henbury Long Sleeve Roll Neck Top",
      "product_handle": "h020",
      "product_url": "/products/h020",
      "product_full_url": "None",
      "vendor": "Henbury",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-h020",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane single jersey.",
      "style_code": "H020",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001c2e",
      "sort_bucket": "blue",
      "sort_hue": 0.565217,
      "sort_sat": 1.0,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49490472632586",
      "swatch_filename": "h020_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h020_Navy.jpg?v=1774522881",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h020_Navy.jpg?v=1774522881",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H020/ProductCarouselMain/H020%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h020_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550001418",
      "product_title": "Henbury Unisex Coolplus® Wicking Piqué T-Shirt",
      "product_handle": "h075",
      "product_url": "/products/h075",
      "product_full_url": "https://oakdenemerch.com/products/h075",
      "vendor": "Henbury",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-h075",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester micro piqué.",
      "style_code": "H075",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001c2e",
      "sort_bucket": "blue",
      "sort_hue": 0.565217,
      "sort_sat": 1.0,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49474231271690",
      "swatch_filename": "H075_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/H075_Navy.jpg?v=1774370566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/H075_Navy.jpg?v=1774370566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H075/ProductCarouselMain/H075%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h075_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#7bb0d4",
      "sort_bucket": "blue",
      "sort_hue": 0.567416,
      "sort_sat": 0.419811,
      "sort_val": 0.831373,
      "swatch_file_id": "gid://shopify/MediaImage/49491376505098",
      "swatch_filename": "kb3025ic_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Sky_Blue.jpg?v=1774526634",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Sky_Blue.jpg?v=1774526634",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#0075c5",
      "sort_bucket": "blue",
      "sort_hue": 0.567682,
      "sort_sat": 1.0,
      "sort_val": 0.772549,
      "swatch_file_id": "gid://shopify/MediaImage/49474088403210",
      "swatch_filename": "RX151_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Sapphire_Blue.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Sapphire_Blue.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "Deep Blue",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#435663",
      "sort_bucket": "blue",
      "sort_hue": 0.567708,
      "sort_sat": 0.323232,
      "sort_val": 0.388235,
      "swatch_file_id": "gid://shopify/MediaImage/49491377225994",
      "swatch_filename": "kb3025ic_Deep_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Deep_Blue.jpg?v=1774526635",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Deep_Blue.jpg?v=1774526635",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20DPB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Deep_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Cornflower",
      "colour_group": "Blue > Sapphire",
      "rgb": "#49a9ed",
      "sort_bucket": "blue",
      "sort_hue": 0.569106,
      "sort_sat": 0.691983,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49474218230026",
      "swatch_filename": "JC001_Cornflower.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Cornflower.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Cornflower.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20COR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Cornflower.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Cornflower",
      "colour_group": "Blue > Sapphire",
      "rgb": "#49a9ed",
      "sort_bucket": "blue",
      "sort_hue": 0.569106,
      "sort_sat": 0.691983,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49474210332938",
      "swatch_filename": "JC001B_Cornflower.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Cornflower.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Cornflower.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20COR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Cornflower.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554785546",
      "product_title": "Tee Jays Unlabeled Loose Fit T-Shirt",
      "product_handle": "t1160",
      "product_url": "/products/t1160",
      "product_full_url": "https://oakdenemerch.com/products/t1160",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t1160",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T1160",
      "colour_name": "Ink Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#005c9e",
      "sort_bucket": "blue",
      "sort_hue": 0.56962,
      "sort_sat": 1.0,
      "sort_val": 0.619608,
      "swatch_file_id": "gid://shopify/MediaImage/49468958769418",
      "swatch_filename": "T1160_Ink_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1160_Ink_Blue.jpg?v=1774315207",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1160_Ink_Blue.jpg?v=1774315207",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1160/ProductCarouselMain/T1160%20INK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1160_Ink_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Ink Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#005c9e",
      "sort_bucket": "blue",
      "sort_hue": 0.56962,
      "sort_sat": 1.0,
      "sort_val": 0.619608,
      "swatch_file_id": "gid://shopify/MediaImage/49474052358410",
      "swatch_filename": "T1150_Ink_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Ink_Blue.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Ink_Blue.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20INK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Ink_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549673738",
      "product_title": "Gildan Hammer Maxweight T-Shirt",
      "product_handle": "gd201",
      "product_url": "/products/gd201",
      "product_full_url": "https://oakdenemerch.com/products/gd201",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd201",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD201",
      "colour_name": "Blue Dusk",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#173042",
      "sort_bucket": "blue",
      "sort_hue": 0.569767,
      "sort_sat": 0.651515,
      "sort_val": 0.258824,
      "swatch_file_id": "gid://shopify/MediaImage/49468939337994",
      "swatch_filename": "GD201_Blue_Dusk.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_Blue_Dusk.jpg?v=1774313827",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_Blue_Dusk.jpg?v=1774313827",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD201/ProductCarouselMain/GD201%20BDK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd201_Blue_Dusk.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Blue Dusk",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#173042",
      "sort_bucket": "blue",
      "sort_hue": 0.569767,
      "sort_sat": 0.651515,
      "sort_val": 0.258824,
      "swatch_file_id": "gid://shopify/MediaImage/49471398183178",
      "swatch_filename": "GD02_Blue_Dusk.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Blue_Dusk.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Blue_Dusk.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20BDK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Blue_Dusk.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562363658",
      "product_title": "Native Spirit Ladies Cropped Tank Top",
      "product_handle": "ns342",
      "product_url": "/products/ns342",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns342",
        "t-shirts",
        "womens",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS342",
      "colour_name": "Washed Mineral Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#4b697f",
      "sort_bucket": "blue",
      "sort_hue": 0.570513,
      "sort_sat": 0.409449,
      "sort_val": 0.498039,
      "swatch_file_id": "gid://shopify/MediaImage/49513931047178",
      "swatch_filename": "ns342_Washed_Mineral_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns342_Washed_Mineral_Grey.jpg?v=1774619059",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns342_Washed_Mineral_Grey.jpg?v=1774619059",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS342/ProductCarouselMain/NS342%20WMN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns342_Washed_Mineral_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552262410",
      "product_title": "Native Spirit Ladies Faded T-Shirt",
      "product_handle": "ns316",
      "product_url": "/products/ns316",
      "product_full_url": "https://oakdenemerch.com/products/ns316",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns316",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS316",
      "colour_name": "Washed Mineral Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#4b697f",
      "sort_bucket": "blue",
      "sort_hue": 0.570513,
      "sort_sat": 0.409449,
      "sort_val": 0.498039,
      "swatch_file_id": "gid://shopify/MediaImage/49472286720266",
      "swatch_filename": "NS316_Washed_Mineral_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS316_Washed_Mineral_Grey.jpg?v=1774354318",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS316_Washed_Mineral_Grey.jpg?v=1774354318",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS316/ProductCarouselMain/NS316%20WMN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns316_Washed_Mineral_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686540554",
      "product_title": "Stormtech Equinox Long Sleeve T-Shirt",
      "product_handle": "cpm2",
      "product_url": "/products/cpm2",
      "product_full_url": "https://oakdenemerch.com/products/cpm2",
      "vendor": "Stormtech",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-cpm2",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "60% BCI cotton/40% polyester.",
      "style_code": "CPM2",
      "colour_name": "Dolphin",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#3f5260",
      "sort_bucket": "blue",
      "sort_hue": 0.570707,
      "sort_sat": 0.34375,
      "sort_val": 0.376471,
      "swatch_file_id": "gid://shopify/MediaImage/49490415124746",
      "swatch_filename": "cpm2_Dolphin.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cpm2_Dolphin.jpg?v=1774522790",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cpm2_Dolphin.jpg?v=1774522790",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Stormtech/Product%20Images/CPM2/ProductCarouselMain/CPM2%20DLP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cpm2_Dolphin.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "Powder Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#5b6770",
      "sort_bucket": "blue",
      "sort_hue": 0.571429,
      "sort_sat": 0.1875,
      "sort_val": 0.439216,
      "swatch_file_id": "gid://shopify/MediaImage/49471257411850",
      "swatch_filename": "T520_Powder_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Powder_Grey.jpg?v=1774348349",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Powder_Grey.jpg?v=1774348349",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20PWG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_Powder_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556587786",
      "product_title": "Tee Jays Ladies Interlock T-Shirt",
      "product_handle": "t580",
      "product_url": "/products/t580",
      "product_full_url": "https://oakdenemerch.com/products/t580",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t580",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T580",
      "colour_name": "Powder Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#5b6770",
      "sort_bucket": "blue",
      "sort_hue": 0.571429,
      "sort_sat": 0.1875,
      "sort_val": 0.439216,
      "swatch_file_id": "gid://shopify/MediaImage/49469002187018",
      "swatch_filename": "T580_Powder_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Powder_Grey.jpg?v=1774315823",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Powder_Grey.jpg?v=1774315823",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T580/ProductCarouselMain/T580%20PWG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t580_Powder_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557341450",
      "product_title": "Tee Jays Sof T-Shirt",
      "product_handle": "t8000",
      "product_url": "/products/t8000",
      "product_full_url": "https://oakdenemerch.com/products/t8000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t8000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T8000",
      "colour_name": "Powder Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#5b6770",
      "sort_bucket": "blue",
      "sort_hue": 0.571429,
      "sort_sat": 0.1875,
      "sort_val": 0.439216,
      "swatch_file_id": "gid://shopify/MediaImage/49471238897930",
      "swatch_filename": "T8000_Powder_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Powder_Grey.jpg?v=1774348259",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Powder_Grey.jpg?v=1774348259",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8000/ProductCarouselMain/T8000%20PWG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8000_Powder_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554785546",
      "product_title": "Tee Jays Unlabeled Loose Fit T-Shirt",
      "product_handle": "t1160",
      "product_url": "/products/t1160",
      "product_full_url": "https://oakdenemerch.com/products/t1160",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t1160",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T1160",
      "colour_name": "Powder Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#5b6770",
      "sort_bucket": "blue",
      "sort_hue": 0.571429,
      "sort_sat": 0.1875,
      "sort_val": 0.439216,
      "swatch_file_id": "gid://shopify/MediaImage/49468958638346",
      "swatch_filename": "T1160_Powder_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1160_Powder_Grey.jpg?v=1774315206",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1160_Powder_Grey.jpg?v=1774315206",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1160/ProductCarouselMain/T1160%20PWG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1160_Powder_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Powder Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#5b6770",
      "sort_bucket": "blue",
      "sort_hue": 0.571429,
      "sort_sat": 0.1875,
      "sort_val": 0.439216,
      "swatch_file_id": "gid://shopify/MediaImage/49474052129034",
      "swatch_filename": "T1150_Powder_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Powder_Grey.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Powder_Grey.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20PWG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Powder_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558422794",
      "product_title": "Tombo Ladies Seamless Crop Top",
      "product_handle": "tl696",
      "product_url": "/products/tl696",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "S",
        "style-tl696",
        "t-shirts",
        "womens",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "60% nylon/32% polyester/8% elastane.*",
      "style_code": "TL696",
      "colour_name": "Dark Grey Marl",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#38454f",
      "sort_bucket": "blue",
      "sort_hue": 0.572464,
      "sort_sat": 0.291139,
      "sort_val": 0.309804,
      "swatch_file_id": "gid://shopify/MediaImage/49491004522762",
      "swatch_filename": "tl696_Dark_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl696_Dark_Grey_Marl.jpg?v=1774525757",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl696_Dark_Grey_Marl.jpg?v=1774525757",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL696/ProductCarouselMain/TL696%20DKM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl696_Dark_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552295178",
      "product_title": "Native Spirit Ladies T-Shirt",
      "product_handle": "ns324",
      "product_url": "/products/ns324",
      "product_full_url": "https://oakdenemerch.com/products/ns324",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns324",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS324",
      "colour_name": "Peacock Blue",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#21384a",
      "sort_bucket": "blue",
      "sort_hue": 0.573171,
      "sort_sat": 0.554054,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49472283443466",
      "swatch_filename": "NS324_Peacock_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Peacock_Blue.jpg?v=1774354240",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Peacock_Blue.jpg?v=1774354240",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS324/ProductCarouselMain/NS324%20PKB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns324_Peacock_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Peacock Blue",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#21384a",
      "sort_bucket": "blue",
      "sort_hue": 0.573171,
      "sort_sat": 0.554054,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49473667399946",
      "swatch_filename": "NS305_Peacock_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Peacock_Blue.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Peacock_Blue.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20PKB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Peacock_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548789002",
      "product_title": "Canterbury Club Dry T-Shirt",
      "product_handle": "cn260",
      "product_url": "/products/cn260",
      "product_full_url": "https://oakdenemerch.com/products/cn260",
      "vendor": "Canterbury",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-cn260",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "CN260",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#00223d",
      "sort_bucket": "blue",
      "sort_hue": 0.57377,
      "sort_sat": 1.0,
      "sort_val": 0.239216,
      "swatch_file_id": "gid://shopify/MediaImage/49468934390026",
      "swatch_filename": "CN260_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CN260_Navy.jpg?v=1774313121",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CN260_Navy.jpg?v=1774313121",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Canterbury/Product%20Images/CN260/ProductCarouselMain/CN260%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cn260_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552557322",
      "product_title": "Proact Ladies Performance T-Shirt",
      "product_handle": "pa439",
      "product_url": "/products/pa439",
      "product_full_url": "https://oakdenemerch.com/products/pa439",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa439",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA439",
      "colour_name": "Sporty Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#236091",
      "sort_bucket": "blue",
      "sort_hue": 0.574242,
      "sort_sat": 0.758621,
      "sort_val": 0.568627,
      "swatch_file_id": "gid://shopify/MediaImage/49471736938762",
      "swatch_filename": "PA439_Sporty_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Sporty_Royal_Blue.jpg?v=1774351220",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Sporty_Royal_Blue.jpg?v=1774351220",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA439/ProductCarouselMain/PA439%20SRBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa439_Sporty_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552524554",
      "product_title": "Proact Performance T-Shirt",
      "product_handle": "pa438",
      "product_url": "/products/pa438",
      "product_full_url": "https://oakdenemerch.com/products/pa438",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa438",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA438",
      "colour_name": "Sporty Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#236091",
      "sort_bucket": "blue",
      "sort_hue": 0.574242,
      "sort_sat": 0.758621,
      "sort_val": 0.568627,
      "swatch_file_id": "gid://shopify/MediaImage/49471751946506",
      "swatch_filename": "PA438_Sporty_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Sporty_Royal_Blue.jpg?v=1774351290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Sporty_Royal_Blue.jpg?v=1774351290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA438/ProductCarouselMain/PA438%20SRBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa438_Sporty_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549116682",
      "product_title": "Ecologie Cascades Organic T-Shirt",
      "product_handle": "ea001",
      "product_url": "/products/ea001",
      "product_full_url": "https://oakdenemerch.com/products/ea001",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-ea001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001",
      "colour_name": "Ink Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#005da8",
      "sort_bucket": "blue",
      "sort_hue": 0.574405,
      "sort_sat": 1.0,
      "sort_val": 0.658824,
      "swatch_file_id": "gid://shopify/MediaImage/49474304016650",
      "swatch_filename": "EA001_Ink_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Ink_Blue.jpg?v=1774371175",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Ink_Blue.jpg?v=1774371175",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001/ProductCarouselMain/EA001%20IKB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001_Ink_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549149450",
      "product_title": "Ecologie Kids Cascades Organic T-Shirt",
      "product_handle": "ea001b",
      "product_url": "/products/ea001b",
      "product_full_url": "https://oakdenemerch.com/products/ea001b",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "organic",
        "organic-recycled",
        "style-ea001b",
        "t-shirts"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001B",
      "colour_name": "Ink Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#005da8",
      "sort_bucket": "blue",
      "sort_hue": 0.574405,
      "sort_sat": 1.0,
      "sort_val": 0.658824,
      "swatch_file_id": "gid://shopify/MediaImage/49474280653066",
      "swatch_filename": "EA001B_Ink_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001B_Ink_Blue.jpg?v=1774371054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001B_Ink_Blue.jpg?v=1774371054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001B/ProductCarouselMain/EA001B%20IKB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001b_Ink_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557374218",
      "product_title": "Tee Jays Fashion Sof T-Shirt",
      "product_handle": "t8005",
      "product_url": "/products/t8005",
      "product_full_url": "https://oakdenemerch.com/products/t8005",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t8005",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T8005",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49470730830090",
      "swatch_filename": "T8005_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8005_Dark_Grey.jpg?v=1774345393",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8005_Dark_Grey.jpg?v=1774345393",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8005/ProductCarouselMain/T8005%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8005_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49471257575690",
      "swatch_filename": "T520_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Dark_Grey.jpg?v=1774348349",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Dark_Grey.jpg?v=1774348349",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556587786",
      "product_title": "Tee Jays Ladies Interlock T-Shirt",
      "product_handle": "t580",
      "product_url": "/products/t580",
      "product_full_url": "https://oakdenemerch.com/products/t580",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t580",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T580",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49469002416394",
      "swatch_filename": "T580_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Dark_Grey.jpg?v=1774315823",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Dark_Grey.jpg?v=1774315823",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T580/ProductCarouselMain/T580%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t580_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688703242",
      "product_title": "Tee Jays Ladies Long Sleeve Interlock T-Shirt",
      "product_handle": "t590",
      "product_url": "/products/t590",
      "product_full_url": "https://oakdenemerch.com/products/t590",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t590",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T590",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49490492064010",
      "swatch_filename": "t590_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t590_Dark_Grey.jpg?v=1774523109",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t590_Dark_Grey.jpg?v=1774523109",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T590/ProductCarouselMain/T590%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t590_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557439754",
      "product_title": "Tee Jays Ladies Sof T-Shirt",
      "product_handle": "t8050",
      "product_url": "/products/t8050",
      "product_full_url": "https://oakdenemerch.com/products/t8050",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t8050",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T8050",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49470794236170",
      "swatch_filename": "T8050_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8050_Dark_Grey.jpg?v=1774345776",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8050_Dark_Grey.jpg?v=1774345776",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8050/ProductCarouselMain/T8050%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8050_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688670474",
      "product_title": "Tee Jays Long Sleeve Interlock T-Shirt",
      "product_handle": "t530",
      "product_url": "/products/t530",
      "product_full_url": "https://oakdenemerch.com/products/t530",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t530",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T530",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49490491572490",
      "swatch_filename": "t530_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t530_Dark_Grey.jpg?v=1774523103",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t530_Dark_Grey.jpg?v=1774523103",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T530/ProductCarouselMain/T530%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t530_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555637514",
      "product_title": "Tee Jays Luxury Cotton T-Shirt",
      "product_handle": "t5000",
      "product_url": "/products/t5000",
      "product_full_url": "https://oakdenemerch.com/products/t5000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T5000",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49468986622218",
      "swatch_filename": "T5000_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5000_Dark_Grey.jpg?v=1774315592",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5000_Dark_Grey.jpg?v=1774315592",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5000/ProductCarouselMain/T5000%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5000_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557341450",
      "product_title": "Tee Jays Sof T-Shirt",
      "product_handle": "t8000",
      "product_url": "/products/t8000",
      "product_full_url": "https://oakdenemerch.com/products/t8000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t8000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T8000",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49471238570250",
      "swatch_filename": "T8000_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Dark_Grey.jpg?v=1774348259",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Dark_Grey.jpg?v=1774348259",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8000/ProductCarouselMain/T8000%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8000_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49474052456714",
      "swatch_filename": "T1150_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Dark_Grey.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Dark_Grey.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554720010",
      "product_title": "Tee Jays Unlabelled T-Shirt",
      "product_handle": "t1140",
      "product_url": "/products/t1140",
      "product_full_url": "https://oakdenemerch.com/products/t1140",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1140",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T1140",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49474054684938",
      "swatch_filename": "T1140_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1140_Dark_Grey.jpg?v=1774368141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1140_Dark_Grey.jpg?v=1774368141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1140/ProductCarouselMain/T1140%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1140_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557406986",
      "product_title": "Tee Jays V Neck Sof T-Shirt",
      "product_handle": "t8006",
      "product_url": "/products/t8006",
      "product_full_url": "https://oakdenemerch.com/products/t8006",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t8006",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T8006",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49470768480522",
      "swatch_filename": "T8006_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8006_Dark_Grey.jpg?v=1774345593",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8006_Dark_Grey.jpg?v=1774345593",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8006/ProductCarouselMain/T8006%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8006_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552459018",
      "product_title": "Proact Triblend Sports T-Shirt",
      "product_handle": "pa4011",
      "product_url": "/products/pa4011",
      "product_full_url": "https://oakdenemerch.com/products/pa4011",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa4011",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% cotton/25% viscose.",
      "style_code": "PA4011",
      "colour_name": "French Navy Heather",
      "colour_group": "Blue > Heather/Effect Blue",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49471762039050",
      "swatch_filename": "PA4011_French_Navy_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA4011_French_Navy_Heather.jpg?v=1774351356",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA4011_French_Navy_Heather.jpg?v=1774351356",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA4011/ProductCarouselMain/PA4011%20FNH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa4011_French_Navy_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#92c1e8",
      "sort_bucket": "blue",
      "sort_hue": 0.575581,
      "sort_sat": 0.37069,
      "sort_val": 0.909804,
      "swatch_file_id": "gid://shopify/MediaImage/49474449080586",
      "swatch_filename": "11500_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Sky_Blue.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Sky_Blue.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#92c1e8",
      "sort_bucket": "blue",
      "sort_hue": 0.575581,
      "sort_sat": 0.37069,
      "sort_val": 0.909804,
      "swatch_file_id": "gid://shopify/MediaImage/49468934029578",
      "swatch_filename": "11502_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Sky_Blue.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Sky_Blue.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#92c1e8",
      "sort_bucket": "blue",
      "sort_hue": 0.575581,
      "sort_sat": 0.37069,
      "sort_val": 0.909804,
      "swatch_file_id": "gid://shopify/MediaImage/49473719173386",
      "swatch_filename": "11380_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Sky_Blue.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Sky_Blue.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687785738",
      "product_title": "Pro RTX Pro Long Sleeve T-Shirt",
      "product_handle": "rx152",
      "product_url": "/products/rx152",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx152",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX152",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#14202a",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.52381,
      "sort_val": 0.164706,
      "swatch_file_id": "gid://shopify/MediaImage/49490481971466",
      "swatch_filename": "rx152_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx152_Charcoal.jpg?v=1774522974",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx152_Charcoal.jpg?v=1774522974",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX152/ProductCarouselMain/RX152%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx152_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#14202a",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.52381,
      "sort_val": 0.164706,
      "swatch_file_id": "gid://shopify/MediaImage/49474088501514",
      "swatch_filename": "RX151_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Charcoal.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Charcoal.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "52% cotton/48% polyester.",
      "style_code": "SS621",
      "colour_name": "Dark Heather",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#14202a",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.52381,
      "sort_val": 0.164706,
      "swatch_file_id": "gid://shopify/MediaImage/49471285592330",
      "swatch_filename": "SS621_Dark_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Dark_Heather.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Dark_Heather.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20DHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Dark_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687982346",
      "product_title": "Fruit of the Loom Long Sleeve Value T-Shirt",
      "product_handle": "ss21",
      "product_url": "/products/ss21",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "knitwear",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss21",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "SS21",
      "colour_name": "Dark Heather",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#14202a",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.52381,
      "sort_val": 0.164706,
      "swatch_file_id": "gid://shopify/MediaImage/49490485575946",
      "swatch_filename": "ss21_Dark_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss21_Dark_Heather.jpg?v=1774523017",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss21_Dark_Heather.jpg?v=1774523017",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS21/ProductCarouselMain/SS21%20DHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss21_Dark_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554490634",
      "product_title": "Fruit of the Loom V Neck Value T-Shirt",
      "product_handle": "ss7",
      "product_url": "/products/ss7",
      "product_full_url": "https://oakdenemerch.com/products/ss7",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss7",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "SS7",
      "colour_name": "Dark Heather",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#14202a",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.52381,
      "sort_val": 0.164706,
      "swatch_file_id": "gid://shopify/MediaImage/49471272288522",
      "swatch_filename": "SS7_Dark_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Dark_Heather.jpg?v=1774348430",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Dark_Heather.jpg?v=1774348430",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS7/ProductCarouselMain/SS7%20DHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss7_Dark_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "SS6",
      "colour_name": "Dark Heather",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#14202a",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.52381,
      "sort_val": 0.164706,
      "swatch_file_id": "gid://shopify/MediaImage/49471321768202",
      "swatch_filename": "SS6_Dark_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Dark_Heather.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Dark_Heather.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20DHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Dark_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "65% polyester/35% cotton.",
      "style_code": "GD01",
      "colour_name": "Heather Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#14202a",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.52381,
      "sort_val": 0.164706,
      "swatch_file_id": "gid://shopify/MediaImage/49474267021578",
      "swatch_filename": "GD01_Heather_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Heather_Navy.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Heather_Navy.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20HNY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Heather_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD02",
      "colour_name": "Heather Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#14202a",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.52381,
      "sort_val": 0.164706,
      "swatch_file_id": "gid://shopify/MediaImage/49471398019338",
      "swatch_filename": "GD02_Heather_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Heather_Navy.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Heather_Navy.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20HNY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Heather_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547379978",
      "product_title": "SOL'S Boxy Oversized Organic T-Shirt",
      "product_handle": "03806",
      "product_url": "/products/03806",
      "product_full_url": "https://oakdenemerch.com/products/03806",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL",
        "style-03806",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "03806",
      "colour_name": "Mouse Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#243645",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.478261,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49471864668426",
      "swatch_filename": "03806_Mouse_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03806_Mouse_Grey.jpg?v=1774352127",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03806_Mouse_Grey.jpg?v=1774352127",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03806/ProductCarouselMain/03806%20MGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03806_Mouse_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Mouse Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#243645",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.478261,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49474468839690",
      "swatch_filename": "03582_Mouse_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Mouse_Grey.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Mouse_Grey.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20MGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Mouse_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547511050",
      "product_title": "SOL'S Crusader Recycled T-Shirt",
      "product_handle": "04233",
      "product_url": "/products/04233",
      "product_full_url": "https://oakdenemerch.com/products/04233",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04233",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% recycled cotton/50% cotton.*",
      "style_code": "04233",
      "colour_name": "Mouse Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#243645",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.478261,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49473284964618",
      "swatch_filename": "04233_Mouse_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Mouse_Grey.jpg?v=1774363191",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Mouse_Grey.jpg?v=1774363191",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04233/ProductCarouselMain/04233%20MGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04233_Mouse_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Mouse Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#243645",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.478261,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49474448359690",
      "swatch_filename": "11500_Mouse_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Mouse_Grey.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Mouse_Grey.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20MGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Mouse_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685623050",
      "product_title": "SOL'S Imperial Long Sleeve T-Shirt",
      "product_handle": "02074",
      "product_url": "/products/02074",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-02074",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "02074",
      "colour_name": "Mouse Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#243645",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.478261,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49490366890250",
      "swatch_filename": "02074_Mouse_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02074_Mouse_Grey.jpg?v=1774522705",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02074_Mouse_Grey.jpg?v=1774522705",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02074/ProductCarouselMain/02074%20MGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02074_Mouse_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547412746",
      "product_title": "SOL'S Ladies Boxy Oversized Organic T-Shirt",
      "product_handle": "03807",
      "product_url": "/products/03807",
      "product_full_url": "https://oakdenemerch.com/products/03807",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03807",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "03807",
      "colour_name": "Mouse Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#243645",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.478261,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49474463531274",
      "swatch_filename": "03807_Mouse_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03807_Mouse_Grey.jpg?v=1774372093",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03807_Mouse_Grey.jpg?v=1774372093",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03807/ProductCarouselMain/03807%20MGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03807_Mouse_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Mouse Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#243645",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.478261,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49468835856650",
      "swatch_filename": "03581_Mouse_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Mouse_Grey.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Mouse_Grey.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20MGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Mouse_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Mouse Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#243645",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.478261,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49468933734666",
      "swatch_filename": "11502_Mouse_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Mouse_Grey.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Mouse_Grey.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20MGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Mouse_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "Mouse Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#243645",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.478261,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49468833104138",
      "swatch_filename": "03579_Mouse_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Mouse_Grey.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Mouse_Grey.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20MGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Mouse_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Mouse Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#243645",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.478261,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49468822978826",
      "swatch_filename": "01825_Mouse_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Mouse_Grey.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Mouse_Grey.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20MGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Mouse_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03565",
      "colour_name": "Mouse Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#243645",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.478261,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49473306034442",
      "swatch_filename": "03565_Mouse_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Mouse_Grey.jpg?v=1774363313",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Mouse_Grey.jpg?v=1774363313",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20MGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_Mouse_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Mouse Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#243645",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.478261,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49473718714634",
      "swatch_filename": "11380_Mouse_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Mouse_Grey.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Mouse_Grey.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20MGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Mouse_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547838730",
      "product_title": "SOL'S Ladies Sara T-Shirt",
      "product_handle": "04814",
      "product_url": "/products/04814",
      "product_full_url": "https://oakdenemerch.com/products/04814",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-04814",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% viscose.",
      "style_code": "04814",
      "colour_name": "Light Grey Marl",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#97a3ad",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.127168,
      "sort_val": 0.678431,
      "swatch_file_id": "gid://shopify/MediaImage/49472643072266",
      "swatch_filename": "04814_Light_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04814_Light_Grey_Marl.jpg?v=1774358443",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04814_Light_Grey_Marl.jpg?v=1774358443",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04814/ProductCarouselMain/04814%20LML%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04814_Light_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547478282",
      "product_title": "SOL'S Unisex Tuner T-Shirt",
      "product_handle": "04203",
      "product_url": "/products/04203",
      "product_full_url": "https://oakdenemerch.com/products/04203",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-04203",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "93% cotton/7% viscose.",
      "style_code": "04203",
      "colour_name": "Light Grey Marl",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#97a3ad",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.127168,
      "sort_val": 0.678431,
      "swatch_file_id": "gid://shopify/MediaImage/49474458779914",
      "swatch_filename": "04203_Light_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_Light_Grey_Marl.jpg?v=1774372011",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_Light_Grey_Marl.jpg?v=1774372011",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04203/ProductCarouselMain/04203%20LML%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04203_Light_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Pure Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#97a3ad",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.127168,
      "sort_val": 0.678431,
      "swatch_file_id": "gid://shopify/MediaImage/49474449768714",
      "swatch_filename": "11500_Pure_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Pure_Grey.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Pure_Grey.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20PGE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Pure_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Pure Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#97a3ad",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.127168,
      "sort_val": 0.678431,
      "swatch_file_id": "gid://shopify/MediaImage/49473718845706",
      "swatch_filename": "11380_Pure_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Pure_Grey.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Pure_Grey.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20PGE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Pure_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548166410",
      "product_title": "SOL'S Sporty Performance T-Shirt",
      "product_handle": "11939",
      "product_url": "/products/11939",
      "product_full_url": "https://oakdenemerch.com/products/11939",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-11939",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "11939",
      "colour_name": "Pure Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#97a3ad",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.127168,
      "sort_val": 0.678431,
      "swatch_file_id": "gid://shopify/MediaImage/49473692827914",
      "swatch_filename": "11939_Pure_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Pure_Grey.jpg?v=1774364865",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Pure_Grey.jpg?v=1774364865",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11939/ProductCarouselMain/11939%20PGE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11939_Pure_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Pure Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#97a3ad",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.127168,
      "sort_val": 0.678431,
      "swatch_file_id": "gid://shopify/MediaImage/49473744437514",
      "swatch_filename": "03981_Pure_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Pure_Grey.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Pure_Grey.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20PGE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Pure_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547150602",
      "product_title": "SOL'S Unisex Sprint T-Shirt",
      "product_handle": "02995",
      "product_url": "/products/02995",
      "product_full_url": "https://oakdenemerch.com/products/02995",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-02995",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "02995",
      "colour_name": "Pure Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#97a3ad",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.127168,
      "sort_val": 0.678431,
      "swatch_file_id": "gid://shopify/MediaImage/49473768227082",
      "swatch_filename": "02995_Pure_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Pure_Grey.jpg?v=1774365179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Pure_Grey.jpg?v=1774365179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02995/ProductCarouselMain/02995%20PGE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02995_Pure_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#85c7ff",
      "sort_bucket": "blue",
      "sort_hue": 0.576503,
      "sort_sat": 0.478431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473272840458",
      "swatch_filename": "180M_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Sky_Blue.jpg?v=1774363125",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Sky_Blue.jpg?v=1774363125",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548199178",
      "product_title": "Russell Athletic Kids Classic Ringspun T-Shirt",
      "product_handle": "180b",
      "product_url": "/products/180b",
      "product_full_url": "https://oakdenemerch.com/products/180b",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "PCBest_Seller",
        "performance-activewear",
        "sports",
        "style-180b",
        "t-shirts"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.",
      "style_code": "180B",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#85c7ff",
      "sort_bucket": "blue",
      "sort_hue": 0.576503,
      "sort_sat": 0.478431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474443641098",
      "swatch_filename": "180B_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_Sky_Blue.jpg?v=1774371757",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_Sky_Blue.jpg?v=1774371757",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180B/ProductCarouselMain/180B%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180b_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Ink Blue",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#173f61",
      "sort_bucket": "blue",
      "sort_hue": 0.576577,
      "sort_sat": 0.762887,
      "sort_val": 0.380392,
      "swatch_file_id": "gid://shopify/MediaImage/49474217640202",
      "swatch_filename": "JC001_Ink_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Ink_Blue.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Ink_Blue.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20IKB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Ink_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Carolina Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#69baff",
      "sort_bucket": "blue",
      "sort_hue": 0.576667,
      "sort_sat": 0.588235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471385927946",
      "swatch_filename": "GD05_Carolina_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Carolina_Blue.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Carolina_Blue.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20CNB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Carolina_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Carolina Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#69baff",
      "sort_bucket": "blue",
      "sort_hue": 0.576667,
      "sort_sat": 0.588235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474267545866",
      "swatch_filename": "GD01_Carolina_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Carolina_Blue.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Carolina_Blue.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20CNB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Carolina_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD14",
      "colour_name": "Carolina Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#69baff",
      "sort_bucket": "blue",
      "sort_hue": 0.576667,
      "sort_sat": 0.588235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490462146826",
      "swatch_filename": "gd14_Carolina_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Carolina_Blue.jpg?v=1774522856",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Carolina_Blue.jpg?v=1774522856",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20CNB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Carolina_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Carolina Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#69baff",
      "sort_bucket": "blue",
      "sort_hue": 0.576667,
      "sort_sat": 0.588235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471398248714",
      "swatch_filename": "GD02_Carolina_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Carolina_Blue.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Carolina_Blue.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20CNB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Carolina_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Cornflower Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#69baff",
      "sort_bucket": "blue",
      "sort_hue": 0.576667,
      "sort_sat": 0.588235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471443075338",
      "swatch_filename": "AT001_Cornflower_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Cornflower_Blue.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Cornflower_Blue.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20COR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Cornflower_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Cornflower Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#69baff",
      "sort_bucket": "blue",
      "sort_hue": 0.576667,
      "sort_sat": 0.588235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471430328586",
      "swatch_filename": "AT002_Cornflower_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Cornflower_Blue.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Cornflower_Blue.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20COR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Cornflower_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548428554",
      "product_title": "Anthem Amplify Heavyweight T-Shirt",
      "product_handle": "am18",
      "product_url": "/products/am18",
      "product_full_url": "https://oakdenemerch.com/products/am18",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-am18",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM18",
      "colour_name": "Indigo",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#4677a2",
      "sort_bucket": "blue",
      "sort_hue": 0.577899,
      "sort_sat": 0.567901,
      "sort_val": 0.635294,
      "swatch_file_id": "gid://shopify/MediaImage/49472893026570",
      "swatch_filename": "AM18_Indigo.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_Indigo.jpg?v=1774360285",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_Indigo.jpg?v=1774360285",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM18/ProductCarouselMain/AM18%20IND%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am18_Indigo.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1d262e",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.369565,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49491377422602",
      "swatch_filename": "kb3025ic_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Navy.jpg?v=1774526637",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Navy.jpg?v=1774526637",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551672586",
      "product_title": "Kariban Crew Neck T-Shirt",
      "product_handle": "kb356",
      "product_url": "/products/kb356",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb356",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed cotton.*",
      "style_code": "KB356",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1d262e",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.369565,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49491361300746",
      "swatch_filename": "kb356_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb356_Navy.jpg?v=1774526591",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb356_Navy.jpg?v=1774526591",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB356/ProductCarouselMain/KB356%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb356_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562167050",
      "product_title": "Kariban Eco-Friendly Tank Top",
      "product_handle": "kb3023ic",
      "product_url": "/products/kb3023ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3023ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3023IC",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1d262e",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.369565,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49513928917258",
      "swatch_filename": "kb3023ic_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3023ic_Navy.jpg?v=1774619025",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3023ic_Navy.jpg?v=1774619025",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3023IC/ProductCarouselMain/KB3023IC%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3023ic_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562265354",
      "product_title": "Kariban Ladies Eco-Friendly Tank Top",
      "product_handle": "kb3024ic",
      "product_url": "/products/kb3024ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-kb3024ic",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3024IC",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1d262e",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.369565,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49513929507082",
      "swatch_filename": "kb3024ic_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3024ic_Navy.jpg?v=1774619035",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3024ic_Navy.jpg?v=1774619035",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3024IC/ProductCarouselMain/KB3024IC%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3024ic_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551639818",
      "product_title": "Kariban Unisex 190IC Crew Neck T-Shirt",
      "product_handle": "kb3032ic",
      "product_url": "/products/kb3032ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3032ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3032IC",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1d262e",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.369565,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49491366805770",
      "swatch_filename": "kb3032ic_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Navy.jpg?v=1774526606",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Navy.jpg?v=1774526606",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3032IC/ProductCarouselMain/KB3032IC%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3032ic_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552557322",
      "product_title": "Proact Ladies Performance T-Shirt",
      "product_handle": "pa439",
      "product_url": "/products/pa439",
      "product_full_url": "https://oakdenemerch.com/products/pa439",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa439",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA439",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1d262e",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.369565,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49471737299210",
      "swatch_filename": "PA439_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Navy.jpg?v=1774351220",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Navy.jpg?v=1774351220",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA439/ProductCarouselMain/PA439%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa439_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552524554",
      "product_title": "Proact Performance T-Shirt",
      "product_handle": "pa438",
      "product_url": "/products/pa438",
      "product_full_url": "https://oakdenemerch.com/products/pa438",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa438",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA438",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1d262e",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.369565,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49471752077578",
      "swatch_filename": "PA438_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Navy.jpg?v=1774351290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Navy.jpg?v=1774351290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA438/ProductCarouselMain/PA438%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa438_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558488330",
      "product_title": "WK Designed to Work Anti-Bacterial Short Sleeve T-Shirt",
      "product_handle": "wk306",
      "product_url": "/products/wk306",
      "product_full_url": "https://oakdenemerch.com/products/wk306",
      "vendor": "WK Designed To Work",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-wk306",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% combed cotton.",
      "style_code": "WK306",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1d262e",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.369565,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49470913511690",
      "swatch_filename": "WK306_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/WK306_Navy.jpg?v=1774346721",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/WK306_Navy.jpg?v=1774346721",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/WK%20Designed%20to%20Work/Product%20Images/WK306/ProductCarouselMain/WK306%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "wk306_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#343d45",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.246377,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49474266923274",
      "swatch_filename": "GD01_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Charcoal.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Charcoal.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549411594",
      "product_title": "Gildan SoftStyle® EZ T-Shirt",
      "product_handle": "gd04",
      "product_url": "/products/gd04",
      "product_full_url": "https://oakdenemerch.com/products/gd04",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd04",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "GD04",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#343d45",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.246377,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49468937404682",
      "swatch_filename": "GD04_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Charcoal.jpg?v=1774313523",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Charcoal.jpg?v=1774313523",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD04/ProductCarouselMain/GD04%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd04_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686966538",
      "product_title": "Gildan SoftStyle® Long Sleeve T-Shirt",
      "product_handle": "gd11",
      "product_url": "/products/gd11",
      "product_full_url": "https://oakdenemerch.com/products/gd11",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd11",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD11",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#343d45",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.246377,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49490443272458",
      "swatch_filename": "gd11_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Charcoal.jpg?v=1774522832",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Charcoal.jpg?v=1774522832",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD11/ProductCarouselMain/GD11%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd11_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#343d45",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.246377,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49471368757514",
      "swatch_filename": "GD15_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Charcoal.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Charcoal.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561937674",
      "product_title": "Gildan SoftStyle® Tank Top",
      "product_handle": "gd12",
      "product_url": "/products/gd12",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD12",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#343d45",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.246377,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49513919545610",
      "swatch_filename": "gd12_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd12_Charcoal.jpg?v=1774618940",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd12_Charcoal.jpg?v=1774618940",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD12/ProductCarouselMain/GD12%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd12_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549575434",
      "product_title": "Gildan SoftStyle® V Neck T-Shirt",
      "product_handle": "gd10",
      "product_url": "/products/gd10",
      "product_full_url": "https://oakdenemerch.com/products/gd10",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd10",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD10",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#343d45",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.246377,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49468938912010",
      "swatch_filename": "GD10_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD10_Charcoal.jpg?v=1774313702",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD10_Charcoal.jpg?v=1774313702",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD10/ProductCarouselMain/GD10%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd10_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD14",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#343d45",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.246377,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49490462376202",
      "swatch_filename": "gd14_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Charcoal.jpg?v=1774522858",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Charcoal.jpg?v=1774522858",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#343d45",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.246377,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49471397626122",
      "swatch_filename": "GD02_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Charcoal.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Charcoal.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Solid Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#343d45",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.246377,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49474088730890",
      "swatch_filename": "RX151_Solid_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Solid_Grey.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Solid_Grey.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20SGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Solid_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Mineral Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#82b0da",
      "sort_bucket": "blue",
      "sort_hue": 0.579545,
      "sort_sat": 0.40367,
      "sort_val": 0.854902,
      "swatch_file_id": "gid://shopify/MediaImage/49471285428490",
      "swatch_filename": "SS621_Mineral_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Mineral_Blue.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Mineral_Blue.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20MIB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Mineral_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Mineral Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#82b0da",
      "sort_bucket": "blue",
      "sort_hue": 0.579545,
      "sort_sat": 0.40367,
      "sort_val": 0.854902,
      "swatch_file_id": "gid://shopify/MediaImage/49471313314058",
      "swatch_filename": "SS620_Mineral_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Mineral_Blue.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Mineral_Blue.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20MIB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Mineral_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554457866",
      "product_title": "Fruit of the Loom Pure Cotton T-Shirt",
      "product_handle": "ss640",
      "product_url": "/products/ss640",
      "product_full_url": "https://oakdenemerch.com/products/ss640",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss640",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "SS640",
      "colour_name": "Mineral Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#82b0da",
      "sort_bucket": "blue",
      "sort_hue": 0.579545,
      "sort_sat": 0.40367,
      "sort_val": 0.854902,
      "swatch_file_id": "gid://shopify/MediaImage/49468957884682",
      "swatch_filename": "SS640_Mineral_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Mineral_Blue.jpg?v=1774315114",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Mineral_Blue.jpg?v=1774315114",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS640/ProductCarouselMain/SS640%20MIB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss640_Mineral_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "Mineral Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#82b0da",
      "sort_bucket": "blue",
      "sort_hue": 0.579545,
      "sort_sat": 0.40367,
      "sort_val": 0.854902,
      "swatch_file_id": "gid://shopify/MediaImage/49473272905994",
      "swatch_filename": "180M_Mineral_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Mineral_Blue.jpg?v=1774363124",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Mineral_Blue.jpg?v=1774363124",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20MIB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_Mineral_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557439754",
      "product_title": "Tee Jays Ladies Sof T-Shirt",
      "product_handle": "t8050",
      "product_url": "/products/t8050",
      "product_full_url": "https://oakdenemerch.com/products/t8050",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t8050",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T8050",
      "colour_name": "Misty Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#8094a8",
      "sort_bucket": "blue",
      "sort_hue": 0.583333,
      "sort_sat": 0.238095,
      "sort_val": 0.658824,
      "swatch_file_id": "gid://shopify/MediaImage/49470794268938",
      "swatch_filename": "T8050_Misty_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8050_Misty_Blue.jpg?v=1774345776",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8050_Misty_Blue.jpg?v=1774345776",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8050/ProductCarouselMain/T8050%20MYB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8050_Misty_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557341450",
      "product_title": "Tee Jays Sof T-Shirt",
      "product_handle": "t8000",
      "product_url": "/products/t8000",
      "product_full_url": "https://oakdenemerch.com/products/t8000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t8000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T8000",
      "colour_name": "Misty Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#8094a8",
      "sort_bucket": "blue",
      "sort_hue": 0.583333,
      "sort_sat": 0.238095,
      "sort_val": 0.658824,
      "swatch_file_id": "gid://shopify/MediaImage/49471238832394",
      "swatch_filename": "T8000_Misty_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Misty_Blue.jpg?v=1774348259",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Misty_Blue.jpg?v=1774348259",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8000/ProductCarouselMain/T8000%20MYB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8000_Misty_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Misty Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#8094a8",
      "sort_bucket": "blue",
      "sort_hue": 0.583333,
      "sort_sat": 0.238095,
      "sort_val": 0.658824,
      "swatch_file_id": "gid://shopify/MediaImage/49474052227338",
      "swatch_filename": "T1150_Misty_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Misty_Blue.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Misty_Blue.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20MYB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Misty_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#0380ff",
      "sort_bucket": "blue",
      "sort_hue": 0.583995,
      "sort_sat": 0.988235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471442878730",
      "swatch_filename": "AT001_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Sapphire_Blue.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Sapphire_Blue.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#0380ff",
      "sort_bucket": "blue",
      "sort_hue": 0.583995,
      "sort_sat": 0.988235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471429935370",
      "swatch_filename": "AT002_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Sapphire_Blue.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Sapphire_Blue.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687916810",
      "product_title": "Spiro Ladies Performance Long Sleeve T-Shirt",
      "product_handle": "sr254f",
      "product_url": "/products/sr254f",
      "product_full_url": "None",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr254f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester interlock.",
      "style_code": "SR254F",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#081727",
      "sort_bucket": "blue",
      "sort_hue": 0.586022,
      "sort_sat": 0.794872,
      "sort_val": 0.152941,
      "swatch_file_id": "gid://shopify/MediaImage/49490484789514",
      "swatch_filename": "sr254f_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr254f_Navy.jpg?v=1774522999",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr254f_Navy.jpg?v=1774522999",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR254F/ProductCarouselMain/SR254F%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr254f_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553671434",
      "product_title": "Spiro Ladies Quick Dry Performance T-Shirt",
      "product_handle": "sr253f",
      "product_url": "/products/sr253f",
      "product_full_url": "https://oakdenemerch.com/products/sr253f",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr253f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester interlock.",
      "style_code": "SR253F",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#081727",
      "sort_bucket": "blue",
      "sort_hue": 0.586022,
      "sort_sat": 0.794872,
      "sort_val": 0.152941,
      "swatch_file_id": "gid://shopify/MediaImage/49474072936714",
      "swatch_filename": "SR253F_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR253F_Navy.jpg?v=1774368615",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR253F_Navy.jpg?v=1774368615",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR253F/ProductCarouselMain/SR253F%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr253f_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687949578",
      "product_title": "Spiro Performance Long Sleeve T-Shirt",
      "product_handle": "sr254m",
      "product_url": "/products/sr254m",
      "product_full_url": "None",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-sr254m",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester interlock.",
      "style_code": "SR254M",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#081727",
      "sort_bucket": "blue",
      "sort_hue": 0.586022,
      "sort_sat": 0.794872,
      "sort_val": 0.152941,
      "swatch_file_id": "gid://shopify/MediaImage/49490485084426",
      "swatch_filename": "sr254m_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr254m_Navy.jpg?v=1774523007",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr254m_Navy.jpg?v=1774523007",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR254M/ProductCarouselMain/SR254M%20NAV%20FRONT%20HERO.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr254m_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553704202",
      "product_title": "Spiro Quick Dry Performance T-Shirt",
      "product_handle": "sr253m",
      "product_url": "/products/sr253m",
      "product_full_url": "https://oakdenemerch.com/products/sr253m",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-sr253m",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester interlock.",
      "style_code": "SR253M",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#081727",
      "sort_bucket": "blue",
      "sort_hue": 0.586022,
      "sort_sat": 0.794872,
      "sort_val": 0.152941,
      "swatch_file_id": "gid://shopify/MediaImage/49471706923274",
      "swatch_filename": "SR253M_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR253M_Navy.jpg?v=1774351025",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR253M_Navy.jpg?v=1774351025",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR253M/ProductCarouselMain/SR253M%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr253m_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Blue Sapphire",
      "colour_group": "Blue > Sapphire",
      "rgb": "#0752a3",
      "sort_bucket": "blue",
      "sort_hue": 0.586538,
      "sort_sat": 0.957055,
      "sort_val": 0.639216,
      "swatch_file_id": "gid://shopify/MediaImage/49473666941194",
      "swatch_filename": "NS305_Blue_Sapphire.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Blue_Sapphire.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Blue_Sapphire.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20BSA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Blue_Sapphire.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001e3f",
      "sort_bucket": "blue",
      "sort_hue": 0.587302,
      "sort_sat": 1.0,
      "sort_val": 0.247059,
      "swatch_file_id": "gid://shopify/MediaImage/49474448392458",
      "swatch_filename": "11500_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Navy.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Navy.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001e3f",
      "sort_bucket": "blue",
      "sort_hue": 0.587302,
      "sort_sat": 1.0,
      "sort_val": 0.247059,
      "swatch_file_id": "gid://shopify/MediaImage/49468933800202",
      "swatch_filename": "11502_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Navy.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Navy.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685917962",
      "product_title": "SOL'S Ladies Monarch Long Sleeve T-Shirt",
      "product_handle": "04443",
      "product_url": "/products/04443",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-04443",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.",
      "style_code": "04443",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001e3f",
      "sort_bucket": "blue",
      "sort_hue": 0.587302,
      "sort_sat": 1.0,
      "sort_val": 0.247059,
      "swatch_file_id": "gid://shopify/MediaImage/49490370396426",
      "swatch_filename": "04443_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04443_Navy.jpg?v=1774522735",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04443_Navy.jpg?v=1774522735",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04443/ProductCarouselMain/04443%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04443_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001e3f",
      "sort_bucket": "blue",
      "sort_hue": 0.587302,
      "sort_sat": 1.0,
      "sort_val": 0.247059,
      "swatch_file_id": "gid://shopify/MediaImage/49468822946058",
      "swatch_filename": "01825_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Navy.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Navy.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686049034",
      "product_title": "SOL'S Monarch Long Sleeve T-Shirt",
      "product_handle": "11420",
      "product_url": "/products/11420",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11420",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "11420",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001e3f",
      "sort_bucket": "blue",
      "sort_hue": 0.587302,
      "sort_sat": 1.0,
      "sort_val": 0.247059,
      "swatch_file_id": "gid://shopify/MediaImage/49490371412234",
      "swatch_filename": "11420_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Navy.jpg?v=1774522750",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Navy.jpg?v=1774522750",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11420/ProductCarouselMain/11420%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11420_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001e3f",
      "sort_bucket": "blue",
      "sort_hue": 0.587302,
      "sort_sat": 1.0,
      "sort_val": 0.247059,
      "swatch_file_id": "gid://shopify/MediaImage/49473718649098",
      "swatch_filename": "11380_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Navy.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Navy.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547543818",
      "product_title": "SOL'S Unisex Explorer Recycled T-Shirt",
      "product_handle": "04461",
      "product_url": "/products/04461",
      "product_full_url": "https://oakdenemerch.com/products/04461",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04461",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "60% recycled cotton/40% recycled polyester.",
      "style_code": "04461",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001e3f",
      "sort_bucket": "blue",
      "sort_hue": 0.587302,
      "sort_sat": 1.0,
      "sort_val": 0.247059,
      "swatch_file_id": "gid://shopify/MediaImage/49472969113866",
      "swatch_filename": "04461_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04461_Navy.jpg?v=1774360548",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04461_Navy.jpg?v=1774360548",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04461/ProductCarouselMain/04461%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04461_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547937034",
      "product_title": "SOL'S Victory V Neck T-Shirt",
      "product_handle": "11150",
      "product_url": "/products/11150",
      "product_full_url": "https://oakdenemerch.com/products/11150",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11150",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11150",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001e3f",
      "sort_bucket": "blue",
      "sort_hue": 0.587302,
      "sort_sat": 1.0,
      "sort_val": 0.247059,
      "swatch_file_id": "gid://shopify/MediaImage/49468838215946",
      "swatch_filename": "11150_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11150_Navy.jpg?v=1774312556",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11150_Navy.jpg?v=1774312556",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11150/ProductCarouselMain/11150%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11150_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#69b0ff",
      "sort_bucket": "blue",
      "sort_hue": 0.587778,
      "sort_sat": 0.588235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474088599818",
      "swatch_filename": "RX151_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Sky_Blue.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Sky_Blue.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549116682",
      "product_title": "Ecologie Cascades Organic T-Shirt",
      "product_handle": "ea001",
      "product_url": "/products/ea001",
      "product_full_url": "https://oakdenemerch.com/products/ea001",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-ea001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#21272e",
      "sort_bucket": "blue",
      "sort_hue": 0.589744,
      "sort_sat": 0.282609,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49474304114954",
      "swatch_filename": "EA001_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Charcoal.jpg?v=1774371175",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Charcoal.jpg?v=1774371175",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001/ProductCarouselMain/EA001%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549149450",
      "product_title": "Ecologie Kids Cascades Organic T-Shirt",
      "product_handle": "ea001b",
      "product_url": "/products/ea001b",
      "product_full_url": "https://oakdenemerch.com/products/ea001b",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "organic",
        "organic-recycled",
        "style-ea001b",
        "t-shirts"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001B",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#21272e",
      "sort_bucket": "blue",
      "sort_hue": 0.589744,
      "sort_sat": 0.282609,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49474280620298",
      "swatch_filename": "EA001B_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001B_Charcoal.jpg?v=1774371054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001B_Charcoal.jpg?v=1774371054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001B/ProductCarouselMain/EA001B%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001b_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547379978",
      "product_title": "SOL'S Boxy Oversized Organic T-Shirt",
      "product_handle": "03806",
      "product_url": "/products/03806",
      "product_full_url": "https://oakdenemerch.com/products/03806",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL",
        "style-03806",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "03806",
      "colour_name": "Denim",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#1c3859",
      "sort_bucket": "blue",
      "sort_hue": 0.590164,
      "sort_sat": 0.685393,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49471864537354",
      "swatch_filename": "03806_Denim.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03806_Denim.jpg?v=1774352127",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03806_Denim.jpg?v=1774352127",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03806/ProductCarouselMain/03806%20DNM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03806_Denim.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Denim",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#1c3859",
      "sort_bucket": "blue",
      "sort_hue": 0.590164,
      "sort_sat": 0.685393,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49474468282634",
      "swatch_filename": "03582_Denim.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Denim.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Denim.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20DNM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Denim.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547511050",
      "product_title": "SOL'S Crusader Recycled T-Shirt",
      "product_handle": "04233",
      "product_url": "/products/04233",
      "product_full_url": "https://oakdenemerch.com/products/04233",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04233",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% recycled cotton/50% cotton.*",
      "style_code": "04233",
      "colour_name": "Denim",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#1c3859",
      "sort_bucket": "blue",
      "sort_hue": 0.590164,
      "sort_sat": 0.685393,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49473285128458",
      "swatch_filename": "04233_Denim.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Denim.jpg?v=1774363191",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Denim.jpg?v=1774363191",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04233/ProductCarouselMain/04233%20DNM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04233_Denim.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Denim",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#1c3859",
      "sort_bucket": "blue",
      "sort_hue": 0.590164,
      "sort_sat": 0.685393,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49474448064778",
      "swatch_filename": "11500_Denim.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Denim.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Denim.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20DNM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Denim.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547412746",
      "product_title": "SOL'S Ladies Boxy Oversized Organic T-Shirt",
      "product_handle": "03807",
      "product_url": "/products/03807",
      "product_full_url": "https://oakdenemerch.com/products/03807",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03807",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "03807",
      "colour_name": "Denim",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#1c3859",
      "sort_bucket": "blue",
      "sort_hue": 0.590164,
      "sort_sat": 0.685393,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49474463662346",
      "swatch_filename": "03807_Denim.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03807_Denim.jpg?v=1774372093",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03807_Denim.jpg?v=1774372093",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03807/ProductCarouselMain/03807%20DNM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03807_Denim.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Denim",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#1c3859",
      "sort_bucket": "blue",
      "sort_hue": 0.590164,
      "sort_sat": 0.685393,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49468835266826",
      "swatch_filename": "03581_Denim.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Denim.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Denim.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20DNM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Denim.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Denim",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#1c3859",
      "sort_bucket": "blue",
      "sort_hue": 0.590164,
      "sort_sat": 0.685393,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49468934062346",
      "swatch_filename": "11502_Denim.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Denim.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Denim.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20DNM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Denim.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547642122",
      "product_title": "SOL'S Ladies Legend T-Shirt",
      "product_handle": "04776",
      "product_url": "/products/04776",
      "product_full_url": "https://oakdenemerch.com/products/04776",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-04776",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "04776",
      "colour_name": "Denim",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#1c3859",
      "sort_bucket": "blue",
      "sort_hue": 0.590164,
      "sort_sat": 0.685393,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49472963543306",
      "swatch_filename": "04776_Denim.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Denim.jpg?v=1774360489",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Denim.jpg?v=1774360489",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04776/ProductCarouselMain/04776%20DNM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04776_Denim.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "Denim",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#1c3859",
      "sort_bucket": "blue",
      "sort_hue": 0.590164,
      "sort_sat": 0.685393,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49468833071370",
      "swatch_filename": "03579_Denim.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Denim.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Denim.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20DNM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Denim.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03565",
      "colour_name": "Denim",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#1c3859",
      "sort_bucket": "blue",
      "sort_hue": 0.590164,
      "sort_sat": 0.685393,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49473305936138",
      "swatch_filename": "03565_Denim.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Denim.jpg?v=1774363313",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Denim.jpg?v=1774363313",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20DNM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_Denim.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Denim",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#1c3859",
      "sort_bucket": "blue",
      "sort_hue": 0.590164,
      "sort_sat": 0.685393,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49473718747402",
      "swatch_filename": "11380_Denim.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Denim.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Denim.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20DNM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Denim.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Denim",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#1c3859",
      "sort_bucket": "blue",
      "sort_hue": 0.590164,
      "sort_sat": 0.685393,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49473744666890",
      "swatch_filename": "03981_Denim.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Denim.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Denim.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20DNM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Denim.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562330890",
      "product_title": "Native Spirit Ladies Tank Top",
      "product_handle": "ns341",
      "product_url": "/products/ns341",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns341",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS341",
      "colour_name": "Mineral Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#4e6887",
      "sort_bucket": "blue",
      "sort_hue": 0.590643,
      "sort_sat": 0.422222,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49513930129674",
      "swatch_filename": "ns341_Mineral_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns341_Mineral_Grey.jpg?v=1774619046",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns341_Mineral_Grey.jpg?v=1774619046",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS341/ProductCarouselMain/NS341%20MNL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns341_Mineral_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552229642",
      "product_title": "Native Spirit Terry Towel T-Shirt",
      "product_handle": "ns311",
      "product_url": "/products/ns311",
      "product_full_url": "https://oakdenemerch.com/products/ns311",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns311",
        "t-shirts",
        "towels-robes-slippers",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic combed cotton/20% recycled polyester.",
      "style_code": "NS311",
      "colour_name": "Mineral Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#4e6887",
      "sort_bucket": "blue",
      "sort_hue": 0.590643,
      "sort_sat": 0.422222,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49472780599562",
      "swatch_filename": "NS311_Mineral_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS311_Mineral_Grey.jpg?v=1774359624",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS311_Mineral_Grey.jpg?v=1774359624",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS311/ProductCarouselMain/NS311%20MNL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns311_Mineral_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Mineral Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#4e6887",
      "sort_bucket": "blue",
      "sort_hue": 0.590643,
      "sort_sat": 0.422222,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49473666711818",
      "swatch_filename": "NS305_Mineral_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Mineral_Grey.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Mineral_Grey.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20MNL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Mineral_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550722314",
      "product_title": "AWDis Tri-Blend T-Shirt",
      "product_handle": "jt001",
      "product_url": "/products/jt001",
      "product_full_url": "https://oakdenemerch.com/products/jt001",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-jt001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% viscose/25% cotton.*",
      "style_code": "JT001",
      "colour_name": "Solid Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001228",
      "sort_bucket": "blue",
      "sort_hue": 0.591667,
      "sort_sat": 1.0,
      "sort_val": 0.156863,
      "swatch_file_id": "gid://shopify/MediaImage/49468945367306",
      "swatch_filename": "JT001_Solid_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT001_Solid_Navy.jpg?v=1774314481",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT001_Solid_Navy.jpg?v=1774314481",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT001/ProductCarouselMain/JT001%20SNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt001_Solid_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687097610",
      "product_title": "Gildan Hammer Heavyweight Long Sleeve T-Shirt",
      "product_handle": "gd22",
      "product_url": "/products/gd22",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-gd22",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD22",
      "colour_name": "Sport Dark Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001228",
      "sort_bucket": "blue",
      "sort_hue": 0.591667,
      "sort_sat": 1.0,
      "sort_val": 0.156863,
      "swatch_file_id": "gid://shopify/MediaImage/49490467881226",
      "swatch_filename": "gd22_Sport_Dark_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd22_Sport_Dark_Navy.jpg?v=1774522870",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd22_Sport_Dark_Navy.jpg?v=1774522870",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD22/ProductCarouselMain/GD22%20SDN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd22_Sport_Dark_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549706506",
      "product_title": "Gildan Hammer Heavyweight T-Shirt",
      "product_handle": "gd21",
      "product_url": "/products/gd21",
      "product_full_url": "https://oakdenemerch.com/products/gd21",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-gd21",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD21",
      "colour_name": "Sport Dark Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001228",
      "sort_bucket": "blue",
      "sort_hue": 0.591667,
      "sort_sat": 1.0,
      "sort_val": 0.156863,
      "swatch_file_id": "gid://shopify/MediaImage/49470943559946",
      "swatch_filename": "GD21_Sport_Dark_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD21_Sport_Dark_Navy.jpg?v=1774347003",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD21_Sport_Dark_Navy.jpg?v=1774347003",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD21/ProductCarouselMain/GD21%20SDN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd21_Sport_Dark_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552393482",
      "product_title": "Native Spirit Oversized T-Shirt",
      "product_handle": "ns332",
      "product_url": "/products/ns332",
      "product_full_url": "https://oakdenemerch.com/products/ns332",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns332",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "NS332",
      "colour_name": "Iron Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#3a4757",
      "sort_bucket": "blue",
      "sort_hue": 0.591954,
      "sort_sat": 0.333333,
      "sort_val": 0.341176,
      "swatch_file_id": "gid://shopify/MediaImage/49474121236746",
      "swatch_filename": "NS332_Iron_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_Iron_Grey.jpg?v=1774369280",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_Iron_Grey.jpg?v=1774369280",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS332/ProductCarouselMain/NS332%20IRN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns332_Iron_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552164106",
      "product_title": "Native Spirit Unisex French Terry T-Shirt",
      "product_handle": "ns308",
      "product_url": "/products/ns308",
      "product_full_url": "https://oakdenemerch.com/products/ns308",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns308",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "NS308",
      "colour_name": "Iron Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#3a4757",
      "sort_bucket": "blue",
      "sort_hue": 0.591954,
      "sort_sat": 0.333333,
      "sort_val": 0.341176,
      "swatch_file_id": "gid://shopify/MediaImage/49472288489738",
      "swatch_filename": "NS308_Iron_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS308_Iron_Grey.jpg?v=1774354362",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS308_Iron_Grey.jpg?v=1774354362",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS308/ProductCarouselMain/NS308%20IRN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns308_Iron_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Iron Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#3a4757",
      "sort_bucket": "blue",
      "sort_hue": 0.591954,
      "sort_sat": 0.333333,
      "sort_val": 0.341176,
      "swatch_file_id": "gid://shopify/MediaImage/49473666482442",
      "swatch_filename": "NS305_Iron_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Iron_Grey.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Iron_Grey.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20IRN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Iron_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#1b4d8c",
      "sort_bucket": "blue",
      "sort_hue": 0.59292,
      "sort_sat": 0.807143,
      "sort_val": 0.54902,
      "swatch_file_id": "gid://shopify/MediaImage/49474342977802",
      "swatch_filename": "AM10_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Royal_Blue.jpg?v=1774371250",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Royal_Blue.jpg?v=1774371250",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548363018",
      "product_title": "Anthem Unisex Organic Midweight T-Shirt",
      "product_handle": "am12",
      "product_url": "/products/am12",
      "product_full_url": "https://oakdenemerch.com/products/am12",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am12",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM12",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#1b4d8c",
      "sort_bucket": "blue",
      "sort_hue": 0.59292,
      "sort_sat": 0.807143,
      "sort_val": 0.54902,
      "swatch_file_id": "gid://shopify/MediaImage/49472902693130",
      "swatch_filename": "AM12_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Royal_Blue.jpg?v=1774360382",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Royal_Blue.jpg?v=1774360382",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM12/ProductCarouselMain/AM12%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am12_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "Ocean Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#006df7",
      "sort_bucket": "blue",
      "sort_hue": 0.593117,
      "sort_sat": 1.0,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49471257706762",
      "swatch_filename": "T520_Ocean_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Ocean_Blue.jpg?v=1774348348",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Ocean_Blue.jpg?v=1774348348",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20OBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_Ocean_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556587786",
      "product_title": "Tee Jays Ladies Interlock T-Shirt",
      "product_handle": "t580",
      "product_url": "/products/t580",
      "product_full_url": "https://oakdenemerch.com/products/t580",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t580",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T580",
      "colour_name": "Ocean Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#006df7",
      "sort_bucket": "blue",
      "sort_hue": 0.593117,
      "sort_sat": 1.0,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49469002154250",
      "swatch_filename": "T580_Ocean_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Ocean_Blue.jpg?v=1774315823",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Ocean_Blue.jpg?v=1774315823",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T580/ProductCarouselMain/T580%20OBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t580_Ocean_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557341450",
      "product_title": "Tee Jays Sof T-Shirt",
      "product_handle": "t8000",
      "product_url": "/products/t8000",
      "product_full_url": "https://oakdenemerch.com/products/t8000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t8000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T8000",
      "colour_name": "Ocean Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#006df7",
      "sort_bucket": "blue",
      "sort_hue": 0.593117,
      "sort_sat": 1.0,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49471238603018",
      "swatch_filename": "T8000_Ocean_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Ocean_Blue.jpg?v=1774348259",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Ocean_Blue.jpg?v=1774348259",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8000/ProductCarouselMain/T8000%20OBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8000_Ocean_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554785546",
      "product_title": "Tee Jays Unlabeled Loose Fit T-Shirt",
      "product_handle": "t1160",
      "product_url": "/products/t1160",
      "product_full_url": "https://oakdenemerch.com/products/t1160",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t1160",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T1160",
      "colour_name": "Ocean Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#006df7",
      "sort_bucket": "blue",
      "sort_hue": 0.593117,
      "sort_sat": 1.0,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49468958671114",
      "swatch_filename": "T1160_Ocean_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1160_Ocean_Blue.jpg?v=1774315207",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1160_Ocean_Blue.jpg?v=1774315207",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1160/ProductCarouselMain/T1160%20OBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1160_Ocean_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Ocean Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#006df7",
      "sort_bucket": "blue",
      "sort_hue": 0.593117,
      "sort_sat": 1.0,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49474052096266",
      "swatch_filename": "T1150_Ocean_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Ocean_Blue.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Ocean_Blue.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20OBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Ocean_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "Indigo",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#002f6b",
      "sort_bucket": "blue",
      "sort_hue": 0.593458,
      "sort_sat": 1.0,
      "sort_val": 0.419608,
      "swatch_file_id": "gid://shopify/MediaImage/49471257280778",
      "swatch_filename": "T520_Indigo.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Indigo.jpg?v=1774348349",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Indigo.jpg?v=1774348349",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20IND%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_Indigo.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Iris",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#1f80ff",
      "sort_bucket": "blue",
      "sort_hue": 0.594494,
      "sort_sat": 0.878431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471397101834",
      "swatch_filename": "GD02_Iris.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Iris.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Iris.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20IRS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Iris.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548985610",
      "product_title": "Canvas Unisex Tri-Blend T-Shirt",
      "product_handle": "cv3413",
      "product_url": "/products/cv3413",
      "product_full_url": "https://oakdenemerch.com/products/cv3413",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-cv3413",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Cotton/Rayon",
      "shopify_material": "Poly/Cotton/Rayon",
      "csv_material": "50% polyester/25% airlume combed ringspun cotton/25% rayon.",
      "style_code": "CV3413",
      "colour_name": "Blue Tri-Blend",
      "colour_group": "Blue > Heather/Effect Blue",
      "rgb": "#5ea1fa",
      "sort_bucket": "blue",
      "sort_hue": 0.595085,
      "sort_sat": 0.624,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49472609616138",
      "swatch_filename": "CV3413_Blue_Tri-Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_Blue_Tri-Blend.jpg?v=1774358160",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_Blue_Tri-Blend.jpg?v=1774358160",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3413/ProductCarouselMain/CV3413%20BLU%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3413_Blue_Tri-Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548821770",
      "product_title": "Craghoppers Workwear Wakefield Pocket T-Shirt",
      "product_handle": "cr701",
      "product_url": "/products/cr701",
      "product_full_url": "https://oakdenemerch.com/products/cr701",
      "vendor": "Craghoppers",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-cr701",
        "t-shirts",
        "workwear",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "",
      "style_code": "CR701",
      "colour_name": "Carbon Grey",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#242a32",
      "sort_bucket": "blue",
      "sort_hue": 0.595238,
      "sort_sat": 0.28,
      "sort_val": 0.196078,
      "swatch_file_id": "gid://shopify/MediaImage/49468936192266",
      "swatch_filename": "CR701_Carbon_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CR701_Carbon_Grey.jpg?v=1774313247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CR701_Carbon_Grey.jpg?v=1774313247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Craghoppers/Product%20Images/CR701/ProductCarouselMain/CR701%20CAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cr701_Carbon_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558193418",
      "product_title": "Tombo Medium Impact Core Bra",
      "product_handle": "tl371",
      "product_url": "/products/tl371",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-tl371",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "86% polyester/14% elastane interlock.",
      "style_code": "TL371",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001a3d",
      "sort_bucket": "blue",
      "sort_hue": 0.595628,
      "sort_sat": 1.0,
      "sort_val": 0.239216,
      "swatch_file_id": "gid://shopify/MediaImage/49491009700106",
      "swatch_filename": "tl371_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl371_Navy.jpg?v=1774525772",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl371_Navy.jpg?v=1774525772",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL371/ProductCarouselMain/TL371%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl371_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547347210",
      "product_title": "SOL'S Unisex Odyssey Recycled T-Shirt",
      "product_handle": "03805",
      "product_url": "/products/03805",
      "product_full_url": "https://oakdenemerch.com/products/03805",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-03805",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "55% recycled cotton/45% recycled polyester.",
      "style_code": "03805",
      "colour_name": "Recycled Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#081425",
      "sort_bucket": "blue",
      "sort_hue": 0.597701,
      "sort_sat": 0.783784,
      "sort_val": 0.145098,
      "swatch_file_id": "gid://shopify/MediaImage/49473296040202",
      "swatch_filename": "03805_Recycled_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03805_Recycled_Navy.jpg?v=1774363245",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03805_Recycled_Navy.jpg?v=1774363245",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03805/ProductCarouselMain/03805%20RCN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03805_Recycled_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "Indigo Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#174990",
      "sort_bucket": "blue",
      "sort_hue": 0.597796,
      "sort_sat": 0.840278,
      "sort_val": 0.564706,
      "swatch_file_id": "gid://shopify/MediaImage/49473273004298",
      "swatch_filename": "180M_Indigo_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Indigo_Blue.jpg?v=1774363124",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Indigo_Blue.jpg?v=1774363124",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20IND%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_Indigo_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557374218",
      "product_title": "Tee Jays Fashion Sof T-Shirt",
      "product_handle": "t8005",
      "product_url": "/products/t8005",
      "product_full_url": "https://oakdenemerch.com/products/t8005",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t8005",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T8005",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49470730928394",
      "swatch_filename": "T8005_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8005_Navy.jpg?v=1774345393",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8005_Navy.jpg?v=1774345393",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8005/ProductCarouselMain/T8005%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8005_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49471257542922",
      "swatch_filename": "T520_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Navy.jpg?v=1774348349",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Navy.jpg?v=1774348349",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556587786",
      "product_title": "Tee Jays Ladies Interlock T-Shirt",
      "product_handle": "t580",
      "product_url": "/products/t580",
      "product_full_url": "https://oakdenemerch.com/products/t580",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t580",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T580",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49469002252554",
      "swatch_filename": "T580_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Navy.jpg?v=1774315823",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Navy.jpg?v=1774315823",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T580/ProductCarouselMain/T580%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t580_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688703242",
      "product_title": "Tee Jays Ladies Long Sleeve Interlock T-Shirt",
      "product_handle": "t590",
      "product_url": "/products/t590",
      "product_full_url": "https://oakdenemerch.com/products/t590",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t590",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T590",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49490492096778",
      "swatch_filename": "t590_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t590_Navy.jpg?v=1774523111",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t590_Navy.jpg?v=1774523111",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T590/ProductCarouselMain/T590%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t590_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555244298",
      "product_title": "Tee Jays Ladies Pima Cotton T-Shirt",
      "product_handle": "t1451",
      "product_url": "/products/t1451",
      "product_full_url": "https://oakdenemerch.com/products/t1451",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t1451",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed pima cotton.",
      "style_code": "T1451",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49468966207754",
      "swatch_filename": "T1451_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1451_Navy.jpg?v=1774315339",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1451_Navy.jpg?v=1774315339",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1451/ProductCarouselMain/T1451%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1451_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557439754",
      "product_title": "Tee Jays Ladies Sof T-Shirt",
      "product_handle": "t8050",
      "product_url": "/products/t8050",
      "product_full_url": "https://oakdenemerch.com/products/t8050",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t8050",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T8050",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49470794203402",
      "swatch_filename": "T8050_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8050_Navy.jpg?v=1774345776",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8050_Navy.jpg?v=1774345776",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8050/ProductCarouselMain/T8050%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8050_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555571978",
      "product_title": "Tee Jays Ladies Stretch 3/4 Sleeve T-Shirt",
      "product_handle": "t460",
      "product_url": "/products/t460",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t460",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "90% ringspun combed cotton/10% elastane.",
      "style_code": "T460",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49491211976970",
      "swatch_filename": "t460_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t460_Navy.jpg?v=1774526234",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t460_Navy.jpg?v=1774526234",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T460/ProductCarouselMain/T460%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t460_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555440906",
      "product_title": "Tee Jays Ladies Stretch T-Shirt",
      "product_handle": "t450",
      "product_url": "/products/t450",
      "product_full_url": "https://oakdenemerch.com/products/t450",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t450",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "90% ringspun combed cotton/10% elastane.",
      "style_code": "T450",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49468979904778",
      "swatch_filename": "T450_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T450_Navy.jpg?v=1774315491",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T450_Navy.jpg?v=1774315491",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T450/ProductCarouselMain/T450%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t450_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688670474",
      "product_title": "Tee Jays Long Sleeve Interlock T-Shirt",
      "product_handle": "t530",
      "product_url": "/products/t530",
      "product_full_url": "https://oakdenemerch.com/products/t530",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t530",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T530",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49490491638026",
      "swatch_filename": "t530_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t530_Navy.jpg?v=1774523104",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t530_Navy.jpg?v=1774523104",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T530/ProductCarouselMain/T530%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t530_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555637514",
      "product_title": "Tee Jays Luxury Cotton T-Shirt",
      "product_handle": "t5000",
      "product_url": "/products/t5000",
      "product_full_url": "https://oakdenemerch.com/products/t5000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T5000",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49468986556682",
      "swatch_filename": "T5000_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5000_Navy.jpg?v=1774315591",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5000_Navy.jpg?v=1774315591",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5000/ProductCarouselMain/T5000%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5000_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555178762",
      "product_title": "Tee Jays Pima Cotton T-Shirt",
      "product_handle": "t1450",
      "product_url": "/products/t1450",
      "product_full_url": "https://oakdenemerch.com/products/t1450",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t1450",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed pima cotton.",
      "style_code": "T1450",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49468963193098",
      "swatch_filename": "T1450_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1450_Navy.jpg?v=1774315271",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1450_Navy.jpg?v=1774315271",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1450/ProductCarouselMain/T1450%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1450_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557341450",
      "product_title": "Tee Jays Sof T-Shirt",
      "product_handle": "t8000",
      "product_url": "/products/t8000",
      "product_full_url": "https://oakdenemerch.com/products/t8000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t8000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T8000",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49471238537482",
      "swatch_filename": "T8000_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Navy.jpg?v=1774348259",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Navy.jpg?v=1774348259",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8000/ProductCarouselMain/T8000%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8000_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555342602",
      "product_title": "Tee Jays Stretch T-Shirt",
      "product_handle": "t400",
      "product_url": "/products/t400",
      "product_full_url": "https://oakdenemerch.com/products/t400",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t400",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "90% ringspun combed cotton/10% elastane.",
      "style_code": "T400",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49468974137610",
      "swatch_filename": "T400_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T400_Navy.jpg?v=1774315420",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T400_Navy.jpg?v=1774315420",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T400/ProductCarouselMain/T400%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t400_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49474052325642",
      "swatch_filename": "T1150_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Navy.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Navy.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554720010",
      "product_title": "Tee Jays Unlabelled T-Shirt",
      "product_handle": "t1140",
      "product_url": "/products/t1140",
      "product_full_url": "https://oakdenemerch.com/products/t1140",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1140",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T1140",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49474054652170",
      "swatch_filename": "T1140_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1140_Navy.jpg?v=1774368141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1140_Navy.jpg?v=1774368141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1140/ProductCarouselMain/T1140%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1140_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557406986",
      "product_title": "Tee Jays V Neck Sof T-Shirt",
      "product_handle": "t8006",
      "product_url": "/products/t8006",
      "product_full_url": "https://oakdenemerch.com/products/t8006",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t8006",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T8006",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49470768546058",
      "swatch_filename": "T8006_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8006_Navy.jpg?v=1774345593",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8006_Navy.jpg?v=1774345593",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8006/ProductCarouselMain/T8006%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8006_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548985610",
      "product_title": "Canvas Unisex Tri-Blend T-Shirt",
      "product_handle": "cv3413",
      "product_url": "/products/cv3413",
      "product_full_url": "https://oakdenemerch.com/products/cv3413",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-cv3413",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Cotton/Rayon",
      "shopify_material": "Poly/Cotton/Rayon",
      "csv_material": "50% polyester/25% airlume combed ringspun cotton/25% rayon.",
      "style_code": "CV3413",
      "colour_name": "Navy Tri-Blend",
      "colour_group": "Blue > Navy",
      "rgb": "#053883",
      "sort_bucket": "blue",
      "sort_hue": 0.599206,
      "sort_sat": 0.961832,
      "sort_val": 0.513725,
      "swatch_file_id": "gid://shopify/MediaImage/49472609517834",
      "swatch_filename": "CV3413_Navy_Tri-Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_Navy_Tri-Blend.jpg?v=1774358160",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_Navy_Tri-Blend.jpg?v=1774358160",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3413/ProductCarouselMain/CV3413%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3413_Navy_Tri-Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548559626",
      "product_title": "AWDis Heavyweight Boxy 240 T-Shirt",
      "product_handle": "at003",
      "product_url": "/products/at003",
      "product_full_url": "https://oakdenemerch.com/products/at003",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-at003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT003",
      "colour_name": "Atlantic Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#5174a8",
      "sort_bucket": "blue",
      "sort_hue": 0.599617,
      "sort_sat": 0.517857,
      "sort_val": 0.658824,
      "swatch_file_id": "gid://shopify/MediaImage/49472884572426",
      "swatch_filename": "AT003_Atlantic_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT003_Atlantic_Blue.jpg?v=1774360179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT003_Atlantic_Blue.jpg?v=1774360179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT003/ProductCarouselMain/AT003%20ATB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at003_Atlantic_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687720202",
      "product_title": "Regatta Thermal Long Sleeve Vest",
      "product_handle": "rg289",
      "product_url": "/products/rg289",
      "product_full_url": "None",
      "vendor": "Regatta Professional",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "sleeveless",
        "style-rg289",
        "t-shirts",
        "underwear-thermals",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "Polyester/cotton fabric.",
      "style_code": "RG289",
      "colour_name": "Denim",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#002966",
      "sort_bucket": "blue",
      "sort_hue": 0.599673,
      "sort_sat": 1.0,
      "sort_val": 0.4,
      "swatch_file_id": "gid://shopify/MediaImage/49490481545482",
      "swatch_filename": "rg289_Denim.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg289_Denim.jpg?v=1774522967",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg289_Denim.jpg?v=1774522967",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Regatta%20Professional/Product%20Images/RG289/ProductCarouselMain/RG289%20DNM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rg289_Denim.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562461962",
      "product_title": "Regatta Thermal Short Sleeve Vest",
      "product_handle": "rg288",
      "product_url": "/products/rg288",
      "product_full_url": "None",
      "vendor": "Regatta Professional",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "sleeveless",
        "style-rg288",
        "t-shirts",
        "underwear-thermals",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "Polyester/cotton fabric.",
      "style_code": "RG288",
      "colour_name": "Denim",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#002966",
      "sort_bucket": "blue",
      "sort_hue": 0.599673,
      "sort_sat": 1.0,
      "sort_val": 0.4,
      "swatch_file_id": "gid://shopify/MediaImage/49513932161290",
      "swatch_filename": "rg288_Denim.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg288_Denim.jpg?v=1774619074",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg288_Denim.jpg?v=1774619074",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Regatta%20Professional/Product%20Images/RG288/ProductCarouselMain/RG288%20DNM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rg288_Denim.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549673738",
      "product_title": "Gildan Hammer Maxweight T-Shirt",
      "product_handle": "gd201",
      "product_url": "/products/gd201",
      "product_full_url": "https://oakdenemerch.com/products/gd201",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd201",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD201",
      "colour_name": "Deep Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#003078",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 1.0,
      "sort_val": 0.470588,
      "swatch_file_id": "gid://shopify/MediaImage/49468939174154",
      "swatch_filename": "GD201_Deep_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_Deep_Royal.jpg?v=1774313826",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_Deep_Royal.jpg?v=1774313826",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD201/ProductCarouselMain/GD201%20DPR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd201_Deep_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546790154",
      "product_title": "SOL'S Camo T-Shirt",
      "product_handle": "01188",
      "product_url": "/products/01188",
      "product_full_url": "https://oakdenemerch.com/products/01188",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-01188",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.",
      "style_code": "01188",
      "colour_name": "Blue Camo",
      "colour_group": "Patterns > Camouflage",
      "rgb": "",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49471884230922",
      "swatch_filename": "01188_Blue_Camo.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01188_Blue_Camo.jpg?v=1774352390",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01188_Blue_Camo.jpg?v=1774352390",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01188/ProductCarouselMain/01188%20BLC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01188_Blue_Camo.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550099722",
      "product_title": "AWDis Cool Contrast Wicking T-Shirt",
      "product_handle": "jc003",
      "product_url": "/products/jc003",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003",
      "colour_name": "French Navy/Fire Red",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a;#eb0024",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49491413369098",
      "swatch_filename": "jc003_French_NavyFire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_French_NavyFire_Red.jpg?v=1774526744",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_French_NavyFire_Red.jpg?v=1774526744",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003/ProductCarouselMain/JC003%20FN%252fFR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003_French_NavyFire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550132490",
      "product_title": "AWDis Kids Cool Contrast T-Shirt",
      "product_handle": "jc003b",
      "product_url": "/products/jc003b",
      "product_full_url": "https://oakdenemerch.com/products/jc003b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "style-jc003b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003B",
      "colour_name": "French Navy/Fire Red",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a;#eb0024",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49474198208778",
      "swatch_filename": "JC003B_French_NavyFire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC003B_French_NavyFire_Red.jpg?v=1774370308",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC003B_French_NavyFire_Red.jpg?v=1774370308",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003B/ProductCarouselMain/JC003B%20FN%252fFR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003b_French_NavyFire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547707658",
      "product_title": "SOL'S Ladies Vortex Ripstop Performance T-Shirt",
      "product_handle": "04788",
      "product_url": "/products/04788",
      "product_full_url": "https://oakdenemerch.com/products/04788",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04788",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04788",
      "colour_name": "French Navy/Royal Blue",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e;#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49472651985162",
      "swatch_filename": "04788_French_NavyRoyal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_French_NavyRoyal_Blue.jpg?v=1774358494",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_French_NavyRoyal_Blue.jpg?v=1774358494",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04788/ProductCarouselMain/04788%20FN_RY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04788_French_NavyRoyal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547674890",
      "product_title": "SOL'S Vortex Ripstop Performance T-Shirt",
      "product_handle": "04787",
      "product_url": "/products/04787",
      "product_full_url": "https://oakdenemerch.com/products/04787",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04787",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04787",
      "colour_name": "French Navy/Royal Blue",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e;#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49472658243850",
      "swatch_filename": "04787_French_NavyRoyal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_French_NavyRoyal_Blue.jpg?v=1774358538",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_French_NavyRoyal_Blue.jpg?v=1774358538",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04787/ProductCarouselMain/04787%20FN_RY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04787_French_NavyRoyal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551541514",
      "product_title": "Kustom Kit Cooltex® T-Shirt",
      "product_handle": "k991",
      "product_url": "/products/k991",
      "product_full_url": "https://oakdenemerch.com/products/k991",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-k991",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "K991",
      "colour_name": "Navy/Light Blue",
      "colour_group": "Blue > Navy",
      "rgb": "#001a75;#bde6ff",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49472789446922",
      "swatch_filename": "K991_NavyLight_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K991_NavyLight_Blue.jpg?v=1774359774",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K991_NavyLight_Blue.jpg?v=1774359774",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K991/ProductCarouselMain/K991%20NV%252fLB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k991_NavyLight_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551541514",
      "product_title": "Kustom Kit Cooltex® T-Shirt",
      "product_handle": "k991",
      "product_url": "/products/k991",
      "product_full_url": "https://oakdenemerch.com/products/k991",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-k991",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "K991",
      "colour_name": "Navy/Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001a75;#001a75",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49472789381386",
      "swatch_filename": "K991_NavyNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K991_NavyNavy.jpg?v=1774359774",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K991_NavyNavy.jpg?v=1774359774",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K991/ProductCarouselMain/K991%20NV%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k991_NavyNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551836426",
      "product_title": "Finden + Hales Kids Team T-Shirt",
      "product_handle": "lv292",
      "product_url": "/products/lv292",
      "product_full_url": "https://oakdenemerch.com/products/lv292",
      "vendor": "Finden + Hales",
      "product_type": "T-Shirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-lv292",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "LV292",
      "colour_name": "Navy/Sky blue",
      "colour_group": "Blue > Navy",
      "rgb": "#0c184a;#75cfff",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49474137227530",
      "swatch_filename": "LV292_NavySky_blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV292_NavySky_blue.jpg?v=1774369540",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV292_NavySky_blue.jpg?v=1774369540",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV292/ProductCarouselMain/LV292%20NV%252fSK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv292_NavySky_blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551803658",
      "product_title": "Finden + Hales Unisex Team T-Shirt",
      "product_handle": "lv290",
      "product_url": "/products/lv290",
      "product_full_url": "https://oakdenemerch.com/products/lv290",
      "vendor": "Finden + Hales",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv290",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "LV290",
      "colour_name": "Navy/Sky blue",
      "colour_group": "Blue > Navy",
      "rgb": "#0c184a;#75cfff",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49472784335114",
      "swatch_filename": "LV290_NavySky_blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV290_NavySky_blue.jpg?v=1774359680",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV290_NavySky_blue.jpg?v=1774359680",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV290/ProductCarouselMain/LV290%20NV%252fSK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv290_NavySky_blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552950538",
      "product_title": "Pro RTX High Visibility T-Shirt",
      "product_handle": "rx720",
      "product_url": "/products/rx720",
      "product_full_url": "https://oakdenemerch.com/products/rx720",
      "vendor": "Pro RTX High Visibility",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-rx720",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "RX720",
      "colour_name": "Orange/Navy",
      "colour_group": "Orange > Orange",
      "rgb": "#ff5900;#001228",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49471352176906",
      "swatch_filename": "RX720_OrangeNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX720_OrangeNavy.jpg?v=1774348859",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX720_OrangeNavy.jpg?v=1774348859",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX%20High%20Visibility/Product%20Images/RX720/ProductCarouselMain/RX720%20OR%252fNV%20FRONT%20HERO.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx720_OrangeNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558684938",
      "product_title": "Yoko Hi-Vis Two Tone T-Shirt",
      "product_handle": "yk013",
      "product_url": "/products/yk013",
      "product_full_url": "https://oakdenemerch.com/products/yk013",
      "vendor": "YOKO",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "hi-vis",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "safetywear-ppe",
        "style-yk013",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "YK013",
      "colour_name": "Orange/Navy",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff4000;#000037",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49474015789322",
      "swatch_filename": "YK013_OrangeNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/YK013_OrangeNavy.jpg?v=1774367751",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/YK013_OrangeNavy.jpg?v=1774367751",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/YOKO/Product%20Images/YK013/ProductCarouselMain/YK013%20OR%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "yk013_OrangeNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551836426",
      "product_title": "Finden + Hales Kids Team T-Shirt",
      "product_handle": "lv292",
      "product_url": "/products/lv292",
      "product_full_url": "https://oakdenemerch.com/products/lv292",
      "vendor": "Finden + Hales",
      "product_type": "T-Shirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-lv292",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "LV292",
      "colour_name": "Royal Blue/Navy",
      "colour_group": "Blue > Royal",
      "rgb": "#0746d9;#0c184a",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49474137161994",
      "swatch_filename": "LV292_Royal_BlueNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV292_Royal_BlueNavy.jpg?v=1774369539",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV292_Royal_BlueNavy.jpg?v=1774369539",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV292/ProductCarouselMain/LV292%20RY%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv292_Royal_BlueNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551803658",
      "product_title": "Finden + Hales Unisex Team T-Shirt",
      "product_handle": "lv290",
      "product_url": "/products/lv290",
      "product_full_url": "https://oakdenemerch.com/products/lv290",
      "vendor": "Finden + Hales",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv290",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "LV290",
      "colour_name": "Royal Blue/Navy",
      "colour_group": "Blue > Royal",
      "rgb": "#0746d9;#0c184a",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49472784466186",
      "swatch_filename": "LV290_Royal_BlueNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV290_Royal_BlueNavy.jpg?v=1774359680",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/LV290_Royal_BlueNavy.jpg?v=1774359680",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV290/ProductCarouselMain/LV290%20RY%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv290_Royal_BlueNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552950538",
      "product_title": "Pro RTX High Visibility T-Shirt",
      "product_handle": "rx720",
      "product_url": "/products/rx720",
      "product_full_url": "https://oakdenemerch.com/products/rx720",
      "vendor": "Pro RTX High Visibility",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-rx720",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "RX720",
      "colour_name": "Yellow/Navy",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#ffff00;#001228",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49471352144138",
      "swatch_filename": "RX720_YellowNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX720_YellowNavy.jpg?v=1774348860",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX720_YellowNavy.jpg?v=1774348860",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX%20High%20Visibility/Product%20Images/RX720/ProductCarouselMain/RX720%20YL%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx720_YellowNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558684938",
      "product_title": "Yoko Hi-Vis Two Tone T-Shirt",
      "product_handle": "yk013",
      "product_url": "/products/yk013",
      "product_full_url": "https://oakdenemerch.com/products/yk013",
      "vendor": "YOKO",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "hi-vis",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "safetywear-ppe",
        "style-yk013",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "YK013",
      "colour_name": "Yellow/Navy",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#ffff00;#000037",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49474015854858",
      "swatch_filename": "YK013_YellowNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/YK013_YellowNavy.jpg?v=1774367751",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/YK013_YellowNavy.jpg?v=1774367751",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/YOKO/Product%20Images/YK013/ProductCarouselMain/YK013%20YL%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "yk013_YellowNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Light Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#9fb4d4",
      "sort_bucket": "blue",
      "sort_hue": 0.600629,
      "sort_sat": 0.25,
      "sort_val": 0.831373,
      "swatch_file_id": "gid://shopify/MediaImage/49474343174410",
      "swatch_filename": "AM10_Light_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Light_Blue.jpg?v=1774371250",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Light_Blue.jpg?v=1774371250",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20LBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Light_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548363018",
      "product_title": "Anthem Unisex Organic Midweight T-Shirt",
      "product_handle": "am12",
      "product_url": "/products/am12",
      "product_full_url": "https://oakdenemerch.com/products/am12",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am12",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM12",
      "colour_name": "Light Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#9fb4d4",
      "sort_bucket": "blue",
      "sort_hue": 0.600629,
      "sort_sat": 0.25,
      "sort_val": 0.831373,
      "swatch_file_id": "gid://shopify/MediaImage/49472902856970",
      "swatch_filename": "AM12_Light_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Light_Blue.jpg?v=1774360382",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Light_Blue.jpg?v=1774360382",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM12/ProductCarouselMain/AM12%20LBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am12_Light_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548592394",
      "product_title": "Bella Ladies Micro Rib Baby T-Shirt",
      "product_handle": "bl1010",
      "product_url": "/products/bl1010",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "M",
        "S",
        "style-bl1010",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1010",
      "colour_name": "Solid Navy Blend",
      "colour_group": "Blue > Navy",
      "rgb": "#3b4659",
      "sort_bucket": "blue",
      "sort_hue": 0.605556,
      "sort_sat": 0.337079,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49491499614474",
      "swatch_filename": "bl1010_Solid_Navy_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1010_Solid_Navy_Blend.jpg?v=1774526817",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1010_Solid_Navy_Blend.jpg?v=1774526817",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1010/ProductCarouselMain/BL1010%20SNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1010_Solid_Navy_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561839370",
      "product_title": "Bella Ladies Micro Rib Racer Tank Top",
      "product_handle": "bl1019",
      "product_url": "/products/bl1019",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-bl1019",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1019",
      "colour_name": "Solid Navy Blend",
      "colour_group": "Blue > Navy",
      "rgb": "#3b4659",
      "sort_bucket": "blue",
      "sort_hue": 0.605556,
      "sort_sat": 0.337079,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49513918005514",
      "swatch_filename": "bl1019_Solid_Navy_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1019_Solid_Navy_Blend.jpg?v=1774618922",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1019_Solid_Navy_Blend.jpg?v=1774618922",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1019/ProductCarouselMain/BL1019%20SNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1019_Solid_Navy_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561806602",
      "product_title": "Bella Ladies Micro Rib Spaghetti Strap Tank Top",
      "product_handle": "bl1012",
      "product_url": "/products/bl1012",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-bl1012",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1012",
      "colour_name": "Solid Navy Blend",
      "colour_group": "Blue > Navy",
      "rgb": "#3b4659",
      "sort_bucket": "blue",
      "sort_hue": 0.605556,
      "sort_sat": 0.337079,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49513916858634",
      "swatch_filename": "bl1012_Solid_Navy_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1012_Solid_Navy_Blend.jpg?v=1774618911",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1012_Solid_Navy_Blend.jpg?v=1774618911",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1012/ProductCarouselMain/BL1012%20SNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1012_Solid_Navy_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686475018",
      "product_title": "Bella Micro Rib Long Sleeve Baby T-Shirt",
      "product_handle": "bl1501",
      "product_url": "/products/bl1501",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-bl1501",
        "t-shirts",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1501",
      "colour_name": "Solid Navy Blend",
      "colour_group": "Blue > Navy",
      "rgb": "#3b4659",
      "sort_bucket": "blue",
      "sort_hue": 0.605556,
      "sort_sat": 0.337079,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49490403819786",
      "swatch_filename": "bl1501_Solid_Navy_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1501_Solid_Navy_Blend.jpg?v=1774522784",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1501_Solid_Navy_Blend.jpg?v=1774522784",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1501/ProductCarouselMain/BL1501%20SNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1501_Solid_Navy_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552688394",
      "product_title": "Premier Ladies Long John Roll Sleeve T-Shirt",
      "product_handle": "pr318",
      "product_url": "/products/pr318",
      "product_full_url": "None",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-pr318",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Viscose/Elastane",
      "shopify_material": "Poly/Viscose/Elastane",
      "csv_material": "82% polyester/14% viscose/4% elastane.",
      "style_code": "PR318",
      "colour_name": "Indigo Denim",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#0b234d",
      "sort_bucket": "blue",
      "sort_hue": 0.606061,
      "sort_sat": 0.857143,
      "sort_val": 0.301961,
      "swatch_file_id": "gid://shopify/MediaImage/49491315458314",
      "swatch_filename": "pr318_Indigo_Denim.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr318_Indigo_Denim.jpg?v=1774526500",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr318_Indigo_Denim.jpg?v=1774526500",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR318/ProductCarouselMain/PR318%20IND%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr318_Indigo_Denim.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552622858",
      "product_title": "Premier Long John Roll Sleeve T-Shirt",
      "product_handle": "pr218",
      "product_url": "/products/pr218",
      "product_full_url": "https://oakdenemerch.com/products/pr218",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-pr218",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Viscose/Elastane",
      "shopify_material": "Poly/Viscose/Elastane",
      "csv_material": "82% polyester/14% viscose/4% elastane.",
      "style_code": "PR218",
      "colour_name": "Indigo Denim",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#0b234d",
      "sort_bucket": "blue",
      "sort_hue": 0.606061,
      "sort_sat": 0.857143,
      "sort_val": 0.301961,
      "swatch_file_id": "gid://shopify/MediaImage/49472776962314",
      "swatch_filename": "PR218_Indigo_Denim.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR218_Indigo_Denim.jpg?v=1774359566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR218_Indigo_Denim.jpg?v=1774359566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR218/ProductCarouselMain/PR218%20IND%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr218_Indigo_Denim.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#527ac3",
      "sort_bucket": "blue",
      "sort_hue": 0.60767,
      "sort_sat": 0.579487,
      "sort_val": 0.764706,
      "swatch_file_id": "gid://shopify/MediaImage/49474448490762",
      "swatch_filename": "11500_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Blue.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Blue.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20BLU%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552983306",
      "product_title": "Fruit of the Loom Heavy Cotton T-Shirt",
      "product_handle": "sa101",
      "product_url": "/products/sa101",
      "product_full_url": "https://oakdenemerch.com/products/sa101",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-sa101",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SA101",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#002466",
      "sort_bucket": "blue",
      "sort_hue": 0.607843,
      "sort_sat": 1.0,
      "sort_val": 0.4,
      "swatch_file_id": "gid://shopify/MediaImage/49468678668554",
      "swatch_filename": "SA101_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SA101_Navy.jpg?v=1774309789",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SA101_Navy.jpg?v=1774309789",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SA101/ProductCarouselMain/SA101%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sa101_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#002466",
      "sort_bucket": "blue",
      "sort_hue": 0.607843,
      "sort_sat": 1.0,
      "sort_val": 0.4,
      "swatch_file_id": "gid://shopify/MediaImage/49471285362954",
      "swatch_filename": "SS621_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Navy.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Navy.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#002466",
      "sort_bucket": "blue",
      "sort_hue": 0.607843,
      "sort_sat": 1.0,
      "sort_val": 0.4,
      "swatch_file_id": "gid://shopify/MediaImage/49471313510666",
      "swatch_filename": "SS620_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Navy.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Navy.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554621706",
      "product_title": "Fruit of the Loom Ladies Iconic 150 T-Shirt",
      "product_handle": "ss721",
      "product_url": "/products/ss721",
      "product_full_url": "https://oakdenemerch.com/products/ss721",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss721",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS721",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#002466",
      "sort_bucket": "blue",
      "sort_hue": 0.607843,
      "sort_sat": 1.0,
      "sort_val": 0.4,
      "swatch_file_id": "gid://shopify/MediaImage/49472056361226",
      "swatch_filename": "SS721_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Navy.jpg?v=1774353579",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Navy.jpg?v=1774353579",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS721/ProductCarouselMain/SS721%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss721_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS720",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#002466",
      "sort_bucket": "blue",
      "sort_hue": 0.607843,
      "sort_sat": 1.0,
      "sort_val": 0.4,
      "swatch_file_id": "gid://shopify/MediaImage/49472219054346",
      "swatch_filename": "SS720_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Navy.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Navy.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554654474",
      "product_title": "Fruit of the Loom Lady Fit Value T-Shirt",
      "product_handle": "ss77",
      "product_url": "/products/ss77",
      "product_full_url": "https://oakdenemerch.com/products/ss77",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss77",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS77",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#002466",
      "sort_bucket": "blue",
      "sort_hue": 0.607843,
      "sort_sat": 1.0,
      "sort_val": 0.4,
      "swatch_file_id": "gid://shopify/MediaImage/49472026247434",
      "swatch_filename": "SS77_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Navy.jpg?v=1774353471",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Navy.jpg?v=1774353471",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS77/ProductCarouselMain/SS77%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss77_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#002466",
      "sort_bucket": "blue",
      "sort_hue": 0.607843,
      "sort_sat": 1.0,
      "sort_val": 0.4,
      "swatch_file_id": "gid://shopify/MediaImage/49471330451722",
      "swatch_filename": "SS12_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Navy.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Navy.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554195722",
      "product_title": "Fruit of the Loom Super Premium T-Shirt",
      "product_handle": "ss10",
      "product_url": "/products/ss10",
      "product_full_url": "https://oakdenemerch.com/products/ss10",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss10",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS10",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#002466",
      "sort_bucket": "blue",
      "sort_hue": 0.607843,
      "sort_sat": 1.0,
      "sort_val": 0.4,
      "swatch_file_id": "gid://shopify/MediaImage/49471341494538",
      "swatch_filename": "SS10_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_Navy.jpg?v=1774348795",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_Navy.jpg?v=1774348795",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS10/ProductCarouselMain/SS10%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss10_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554490634",
      "product_title": "Fruit of the Loom V Neck Value T-Shirt",
      "product_handle": "ss7",
      "product_url": "/products/ss7",
      "product_full_url": "https://oakdenemerch.com/products/ss7",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss7",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS7",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#002466",
      "sort_bucket": "blue",
      "sort_hue": 0.607843,
      "sort_sat": 1.0,
      "sort_val": 0.4,
      "swatch_file_id": "gid://shopify/MediaImage/49471272255754",
      "swatch_filename": "SS7_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Navy.jpg?v=1774348430",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Navy.jpg?v=1774348430",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS7/ProductCarouselMain/SS7%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss7_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#002466",
      "sort_bucket": "blue",
      "sort_hue": 0.607843,
      "sort_sat": 1.0,
      "sort_val": 0.4,
      "swatch_file_id": "gid://shopify/MediaImage/49471321604362",
      "swatch_filename": "SS6_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Navy.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Navy.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "Light Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#235cc6",
      "sort_bucket": "blue",
      "sort_hue": 0.608384,
      "sort_sat": 0.823232,
      "sort_val": 0.776471,
      "swatch_file_id": "gid://shopify/MediaImage/49491377946890",
      "swatch_filename": "kb3025ic_Light_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Light_Royal_Blue.jpg?v=1774526638",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Light_Royal_Blue.jpg?v=1774526638",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20LRY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Light_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551639818",
      "product_title": "Kariban Unisex 190IC Crew Neck T-Shirt",
      "product_handle": "kb3032ic",
      "product_url": "/products/kb3032ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3032ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3032IC",
      "colour_name": "Light Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#235cc6",
      "sort_bucket": "blue",
      "sort_hue": 0.608384,
      "sort_sat": 0.823232,
      "sort_val": 0.776471,
      "swatch_file_id": "gid://shopify/MediaImage/49491367198986",
      "swatch_filename": "kb3032ic_Light_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Light_Royal_Blue.jpg?v=1774526608",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Light_Royal_Blue.jpg?v=1774526608",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3032IC/ProductCarouselMain/KB3032IC%20LRY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3032ic_Light_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552655626",
      "product_title": "Premier Cotton Rich Comis T-Shirt",
      "product_handle": "pr219",
      "product_url": "/products/pr219",
      "product_full_url": "https://oakdenemerch.com/products/pr219",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-pr219",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% recycled polyester.*",
      "style_code": "PR219",
      "colour_name": "Navy Marl",
      "colour_group": "Blue > Navy",
      "rgb": "#1d3e7d",
      "sort_bucket": "blue",
      "sort_hue": 0.609375,
      "sort_sat": 0.768,
      "sort_val": 0.490196,
      "swatch_file_id": "gid://shopify/MediaImage/49468947988746",
      "swatch_filename": "PR219_Navy_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR219_Navy_Marl.jpg?v=1774314717",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR219_Navy_Marl.jpg?v=1774314717",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR219/ProductCarouselMain/PR219%20NML%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr219_Navy_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "65% polyester/35% cotton.",
      "style_code": "GD01",
      "colour_name": "Heather Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#4d87ff",
      "sort_bucket": "blue",
      "sort_hue": 0.61236,
      "sort_sat": 0.698039,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474266988810",
      "swatch_filename": "GD01_Heather_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Heather_Royal.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Heather_Royal.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20HRY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Heather_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Metro Blue",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#1a4295",
      "sort_bucket": "blue",
      "sort_hue": 0.612466,
      "sort_sat": 0.825503,
      "sort_val": 0.584314,
      "swatch_file_id": "gid://shopify/MediaImage/49471397789962",
      "swatch_filename": "GD02_Metro_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Metro_Blue.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Metro_Blue.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20MTB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Metro_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552295178",
      "product_title": "Native Spirit Ladies T-Shirt",
      "product_handle": "ns324",
      "product_url": "/products/ns324",
      "product_full_url": "https://oakdenemerch.com/products/ns324",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns324",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS324",
      "colour_name": "Sea Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#023bb2",
      "sort_bucket": "blue",
      "sort_hue": 0.612689,
      "sort_sat": 0.988764,
      "sort_val": 0.698039,
      "swatch_file_id": "gid://shopify/MediaImage/49472283574538",
      "swatch_filename": "NS324_Sea_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Sea_Blue.jpg?v=1774354240",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Sea_Blue.jpg?v=1774354240",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS324/ProductCarouselMain/NS324%20SEB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns324_Sea_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Sea Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#023bb2",
      "sort_bucket": "blue",
      "sort_hue": 0.612689,
      "sort_sat": 0.988764,
      "sort_val": 0.698039,
      "swatch_file_id": "gid://shopify/MediaImage/49473666744586",
      "swatch_filename": "NS305_Sea_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Sea_Blue.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Sea_Blue.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20SEB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Sea_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557341450",
      "product_title": "Tee Jays Sof T-Shirt",
      "product_handle": "t8000",
      "product_url": "/products/t8000",
      "product_full_url": "https://oakdenemerch.com/products/t8000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t8000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T8000",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#0033a1",
      "sort_bucket": "blue",
      "sort_hue": 0.613872,
      "sort_sat": 1.0,
      "sort_val": 0.631373,
      "swatch_file_id": "gid://shopify/MediaImage/49471238865162",
      "swatch_filename": "T8000_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Royal_Blue.jpg?v=1774348259",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Royal_Blue.jpg?v=1774348259",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8000/ProductCarouselMain/T8000%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8000_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#0033a1",
      "sort_bucket": "blue",
      "sort_hue": 0.613872,
      "sort_sat": 1.0,
      "sort_val": 0.631373,
      "swatch_file_id": "gid://shopify/MediaImage/49474052489482",
      "swatch_filename": "T1150_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Royal_Blue.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Royal_Blue.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548985610",
      "product_title": "Canvas Unisex Tri-Blend T-Shirt",
      "product_handle": "cv3413",
      "product_url": "/products/cv3413",
      "product_full_url": "https://oakdenemerch.com/products/cv3413",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-cv3413",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Cotton/Rayon",
      "shopify_material": "Poly/Cotton/Rayon",
      "csv_material": "50% polyester/25% airlume combed ringspun cotton/25% rayon.",
      "style_code": "CV3413",
      "colour_name": "True Royal Tri-Blend",
      "colour_group": "Blue > Royal",
      "rgb": "#0033a1",
      "sort_bucket": "blue",
      "sort_hue": 0.613872,
      "sort_sat": 1.0,
      "sort_val": 0.631373,
      "swatch_file_id": "gid://shopify/MediaImage/49472609648906",
      "swatch_filename": "CV3413_True_Royal_Tri-Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_True_Royal_Tri-Blend.jpg?v=1774358161",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_True_Royal_Tri-Blend.jpg?v=1774358161",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3413/ProductCarouselMain/CV3413%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3413_True_Royal_Tri-Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551017226",
      "product_title": "Kustom Kit Superwash® 60°C T-Shirt",
      "product_handle": "k504",
      "product_url": "/products/k504",
      "product_full_url": "https://oakdenemerch.com/products/k504",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k504",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton.*",
      "style_code": "K504",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#0048e8",
      "sort_bucket": "blue",
      "sort_hue": 0.614943,
      "sort_sat": 1.0,
      "sort_val": 0.909804,
      "swatch_file_id": "gid://shopify/MediaImage/49473127186698",
      "swatch_filename": "K504_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K504_Royal_Blue.jpg?v=1774362160",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K504_Royal_Blue.jpg?v=1774362160",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K504/ProductCarouselMain/K504%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k504_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "52% cotton/48% polyester.",
      "style_code": "SS621",
      "colour_name": "Heather Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#598cff",
      "sort_bucket": "blue",
      "sort_hue": 0.615462,
      "sort_sat": 0.65098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471285625098",
      "swatch_filename": "SS621_Heather_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Heather_Royal.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Heather_Royal.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20HRY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Heather_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "SS6",
      "colour_name": "Heather Royal",
      "colour_group": "Blue > Heather/Effect Blue",
      "rgb": "#598cff",
      "sort_bucket": "blue",
      "sort_hue": 0.615462,
      "sort_sat": 0.65098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471321473290",
      "swatch_filename": "SS6_Heather_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Heather_Royal.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Heather_Royal.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20RHR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Heather_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547379978",
      "product_title": "SOL'S Boxy Oversized Organic T-Shirt",
      "product_handle": "03806",
      "product_url": "/products/03806",
      "product_full_url": "https://oakdenemerch.com/products/03806",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL",
        "style-03806",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "03806",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49471864602890",
      "swatch_filename": "03806_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03806_French_Navy.jpg?v=1774352127",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03806_French_Navy.jpg?v=1774352127",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03806/ProductCarouselMain/03806%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03806_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49474468970762",
      "swatch_filename": "03582_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_French_Navy.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_French_Navy.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547511050",
      "product_title": "SOL'S Crusader Recycled T-Shirt",
      "product_handle": "04233",
      "product_url": "/products/04233",
      "product_full_url": "https://oakdenemerch.com/products/04233",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04233",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% recycled cotton/50% cotton.*",
      "style_code": "04233",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49473284997386",
      "swatch_filename": "04233_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_French_Navy.jpg?v=1774363191",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_French_Navy.jpg?v=1774363191",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04233/ProductCarouselMain/04233%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04233_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547904266",
      "product_title": "SOL'S Imperial Fit T-Shirt",
      "product_handle": "10580",
      "product_url": "/products/10580",
      "product_full_url": "https://oakdenemerch.com/products/10580",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-10580",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "10580",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49471859425546",
      "swatch_filename": "10580_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10580_French_Navy.jpg?v=1774352022",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10580_French_Navy.jpg?v=1774352022",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/10580/ProductCarouselMain/10580%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "10580_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49474448294154",
      "swatch_filename": "11500_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_French_Navy.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_French_Navy.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685623050",
      "product_title": "SOL'S Imperial Long Sleeve T-Shirt",
      "product_handle": "02074",
      "product_url": "/products/02074",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-02074",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "02074",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49490366955786",
      "swatch_filename": "02074_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02074_French_Navy.jpg?v=1774522706",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02074_French_Navy.jpg?v=1774522706",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02074/ProductCarouselMain/02074%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02074_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546953994",
      "product_title": "SOL'S Imperial V Neck T-Shirt",
      "product_handle": "02940",
      "product_url": "/products/02940",
      "product_full_url": "https://oakdenemerch.com/products/02940",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-02940",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "02940",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49468829073674",
      "swatch_filename": "02940_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02940_French_Navy.jpg?v=1774312050",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02940_French_Navy.jpg?v=1774312050",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02940/ProductCarouselMain/02940%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02940_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561773834",
      "product_title": "SOL'S Justin Tank Top",
      "product_handle": "11465",
      "product_url": "/products/11465",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11465",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11465",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49513915384074",
      "swatch_filename": "11465_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11465_French_Navy.jpg?v=1774618899",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11465_French_Navy.jpg?v=1774618899",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11465/ProductCarouselMain/11465%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11465_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547412746",
      "product_title": "SOL'S Ladies Boxy Oversized Organic T-Shirt",
      "product_handle": "03807",
      "product_url": "/products/03807",
      "product_full_url": "https://oakdenemerch.com/products/03807",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03807",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "03807",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49474463727882",
      "swatch_filename": "03807_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03807_French_Navy.jpg?v=1774372092",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03807_French_Navy.jpg?v=1774372092",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03807/ProductCarouselMain/03807%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03807_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49468835397898",
      "swatch_filename": "03581_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_French_Navy.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_French_Navy.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49468933439754",
      "swatch_filename": "11502_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_French_Navy.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_French_Navy.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685688586",
      "product_title": "SOL'S Ladies Imperial Long Sleeve T-Shirt",
      "product_handle": "02075",
      "product_url": "/products/02075",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-02075",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "02075",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49490367480074",
      "swatch_filename": "02075_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02075_French_Navy.jpg?v=1774522714",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02075_French_Navy.jpg?v=1774522714",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02075/ProductCarouselMain/02075%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02075_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547052298",
      "product_title": "SOL'S Ladies Imperial V Neck T-Shirt",
      "product_handle": "02941",
      "product_url": "/products/02941",
      "product_full_url": "https://oakdenemerch.com/products/02941",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-02941",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "02941",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49471878430986",
      "swatch_filename": "02941_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02941_French_Navy.jpg?v=1774352301",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02941_French_Navy.jpg?v=1774352301",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02941/ProductCarouselMain/02941%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02941_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547642122",
      "product_title": "SOL'S Ladies Legend T-Shirt",
      "product_handle": "04776",
      "product_url": "/products/04776",
      "product_full_url": "https://oakdenemerch.com/products/04776",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-04776",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "04776",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49472963379466",
      "swatch_filename": "04776_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_French_Navy.jpg?v=1774360490",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_French_Navy.jpg?v=1774360490",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04776/ProductCarouselMain/04776%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04776_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547117834",
      "product_title": "SOL'S Ladies Millenium Stretch T-Shirt",
      "product_handle": "02946",
      "product_url": "/products/02946",
      "product_full_url": "https://oakdenemerch.com/products/02946",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-02946",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "95% semi-combed ringspun cotton/5% elastane.*",
      "style_code": "02946",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49471871516938",
      "swatch_filename": "02946_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02946_French_Navy.jpg?v=1774352219",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02946_French_Navy.jpg?v=1774352219",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02946/ProductCarouselMain/02946%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02946_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548035338",
      "product_title": "SOL'S Ladies Moon V Neck T-Shirt",
      "product_handle": "11388",
      "product_url": "/products/11388",
      "product_full_url": "https://oakdenemerch.com/products/11388",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11388",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11388",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49468932423946",
      "swatch_filename": "11388_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_French_Navy.jpg?v=1774312856",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_French_Navy.jpg?v=1774312856",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11388/ProductCarouselMain/11388%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11388_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49468832973066",
      "swatch_filename": "03579_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_French_Navy.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_French_Navy.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49468823208202",
      "swatch_filename": "01825_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_French_Navy.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_French_Navy.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547609354",
      "product_title": "SOL'S Ladies Regent V Neck T-Shirt",
      "product_handle": "04766",
      "product_url": "/products/04766",
      "product_full_url": "https://oakdenemerch.com/products/04766",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "S",
        "style-04766",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "04766",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49472664502538",
      "swatch_filename": "04766_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04766_French_Navy.jpg?v=1774358606",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04766_French_Navy.jpg?v=1774358606",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04766/ProductCarouselMain/04766%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04766_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546757386",
      "product_title": "SOL'S Ladies Sporty Performance T-Shirt",
      "product_handle": "01159",
      "product_url": "/products/01159",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-01159",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "01159",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49491518161162",
      "swatch_filename": "01159_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01159_French_Navy.jpg?v=1774526877",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01159_French_Navy.jpg?v=1774526877",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01159/ProductCarouselMain/01159%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01159_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547707658",
      "product_title": "SOL'S Ladies Vortex Ripstop Performance T-Shirt",
      "product_handle": "04788",
      "product_url": "/products/04788",
      "product_full_url": "https://oakdenemerch.com/products/04788",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04788",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04788",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49472652050698",
      "swatch_filename": "04788_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_French_Navy.jpg?v=1774358494",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_French_Navy.jpg?v=1774358494",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04788/ProductCarouselMain/04788%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04788_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03565",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49473306165514",
      "swatch_filename": "03565_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_French_Navy.jpg?v=1774363313",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_French_Navy.jpg?v=1774363313",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547871498",
      "product_title": "SOL'S Regent Fit T-Shirt",
      "product_handle": "10553",
      "product_url": "/products/10553",
      "product_full_url": "https://oakdenemerch.com/products/10553",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-10553",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "10553",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49472628883722",
      "swatch_filename": "10553_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_French_Navy.jpg?v=1774358391",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_French_Navy.jpg?v=1774358391",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/10553/ProductCarouselMain/10553%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "10553_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49473718616330",
      "swatch_filename": "11380_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_French_Navy.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_French_Navy.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548166410",
      "product_title": "SOL'S Sporty Performance T-Shirt",
      "product_handle": "11939",
      "product_url": "/products/11939",
      "product_full_url": "https://oakdenemerch.com/products/11939",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-11939",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "11939",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49473692664074",
      "swatch_filename": "11939_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_French_Navy.jpg?v=1774364865",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_French_Navy.jpg?v=1774364865",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11939/ProductCarouselMain/11939%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11939_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561675530",
      "product_title": "SOL'S Unisex Crusader Tank Top",
      "product_handle": "03980",
      "product_url": "/products/03980",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03980",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03980",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49513913712906",
      "swatch_filename": "03980_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03980_French_Navy.jpg?v=1774618880",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03980_French_Navy.jpg?v=1774618880",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03980/ProductCarouselMain/03980%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03980_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547183370",
      "product_title": "SOL'S Unisex Epic Organic T-Shirt",
      "product_handle": "03564",
      "product_url": "/products/03564",
      "product_full_url": "https://oakdenemerch.com/products/03564",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03564",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03564",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49473320157450",
      "swatch_filename": "03564_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03564_French_Navy.jpg?v=1774363395",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03564_French_Navy.jpg?v=1774363395",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03564/ProductCarouselMain/03564%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03564_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49473744863498",
      "swatch_filename": "03981_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_French_Navy.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_French_Navy.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685786890",
      "product_title": "SOL'S Unisex Pioneer Long Sleeve T-Shirt",
      "product_handle": "03982",
      "product_url": "/products/03982",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03982",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03982",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49490369708298",
      "swatch_filename": "03982_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03982_French_Navy.jpg?v=1774522723",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03982_French_Navy.jpg?v=1774522723",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03982/ProductCarouselMain/03982%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03982_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547150602",
      "product_title": "SOL'S Unisex Sprint T-Shirt",
      "product_handle": "02995",
      "product_url": "/products/02995",
      "product_full_url": "https://oakdenemerch.com/products/02995",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-02995",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "02995",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49473768194314",
      "swatch_filename": "02995_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_French_Navy.jpg?v=1774365179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_French_Navy.jpg?v=1774365179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02995/ProductCarouselMain/02995%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02995_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547576586",
      "product_title": "SOL'S Unisex Titan T-Shirt",
      "product_handle": "04728",
      "product_url": "/products/04728",
      "product_full_url": "https://oakdenemerch.com/products/04728",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "knitwear",
        "L",
        "M",
        "S",
        "style-04728",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.",
      "style_code": "04728",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49474456944906",
      "swatch_filename": "04728_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_French_Navy.jpg?v=1774371966",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_French_Navy.jpg?v=1774371966",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04728/ProductCarouselMain/04728%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04728_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547478282",
      "product_title": "SOL'S Unisex Tuner T-Shirt",
      "product_handle": "04203",
      "product_url": "/products/04203",
      "product_full_url": "https://oakdenemerch.com/products/04203",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-04203",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.*",
      "style_code": "04203",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49474458845450",
      "swatch_filename": "04203_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_French_Navy.jpg?v=1774372011",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_French_Navy.jpg?v=1774372011",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04203/ProductCarouselMain/04203%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04203_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547674890",
      "product_title": "SOL'S Vortex Ripstop Performance T-Shirt",
      "product_handle": "04787",
      "product_url": "/products/04787",
      "product_full_url": "https://oakdenemerch.com/products/04787",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04787",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04787",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49472658211082",
      "swatch_filename": "04787_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_French_Navy.jpg?v=1774358538",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_French_Navy.jpg?v=1774358538",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04787/ProductCarouselMain/04787%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04787_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Fan Deep Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#1c3775",
      "sort_bucket": "blue",
      "sort_hue": 0.616105,
      "sort_sat": 0.760684,
      "sort_val": 0.458824,
      "swatch_file_id": "gid://shopify/MediaImage/49471385829642",
      "swatch_filename": "GD05_Fan_Deep_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Fan_Deep_Royal.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Fan_Deep_Royal.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20FDPR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Fan_Deep_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Fan Deep Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#1c3775",
      "sort_bucket": "blue",
      "sort_hue": 0.616105,
      "sort_sat": 0.760684,
      "sort_val": 0.458824,
      "swatch_file_id": "gid://shopify/MediaImage/49474267447562",
      "swatch_filename": "GD01_Fan_Deep_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Fan_Deep_Royal.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Fan_Deep_Royal.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20FDPR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Fan_Deep_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686966538",
      "product_title": "Gildan SoftStyle® Long Sleeve T-Shirt",
      "product_handle": "gd11",
      "product_url": "/products/gd11",
      "product_full_url": "https://oakdenemerch.com/products/gd11",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd11",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD11",
      "colour_name": "Fan Deep Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#1c3775",
      "sort_bucket": "blue",
      "sort_hue": 0.616105,
      "sort_sat": 0.760684,
      "sort_val": 0.458824,
      "swatch_file_id": "gid://shopify/MediaImage/49490444419338",
      "swatch_filename": "gd11_Fan_Deep_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Fan_Deep_Royal.jpg?v=1774522833",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Fan_Deep_Royal.jpg?v=1774522833",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD11/ProductCarouselMain/GD11%20FDPR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd11_Fan_Deep_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548297482",
      "product_title": "Russell Athletic Authentic Heavyweight T-Shirt",
      "product_handle": "215m",
      "product_url": "/products/215m",
      "product_full_url": "https://oakdenemerch.com/products/215m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "sports",
        "style-215m",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "215M",
      "colour_name": "Bright Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#0049f2",
      "sort_bucket": "blue",
      "sort_hue": 0.616391,
      "sort_sat": 1.0,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49470972592394",
      "swatch_filename": "215M_Bright_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/215M_Bright_Royal.jpg?v=1774347211",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/215M_Bright_Royal.jpg?v=1774347211",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/215M/ProductCarouselMain/215M%20BRO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "215m_Bright_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "Bright Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#0049f2",
      "sort_bucket": "blue",
      "sort_hue": 0.616391,
      "sort_sat": 1.0,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49473273102602",
      "swatch_filename": "180M_Bright_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Bright_Royal.jpg?v=1774363125",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Bright_Royal.jpg?v=1774363125",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20BRO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_Bright_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546724618",
      "product_title": "Russell Athletic Heavyweight T-Shirt",
      "product_handle": "010m",
      "product_url": "/products/010m",
      "product_full_url": "https://oakdenemerch.com/products/010m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-010m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "010M",
      "colour_name": "Bright Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#0049f2",
      "sort_bucket": "blue",
      "sort_hue": 0.616391,
      "sort_sat": 1.0,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49468778316042",
      "swatch_filename": "010M_Bright_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/010M_Bright_Royal.jpg?v=1774311231",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/010M_Bright_Royal.jpg?v=1774311231",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/010M/ProductCarouselMain/010M%20BRO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "010m_Bright_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548199178",
      "product_title": "Russell Athletic Kids Classic Ringspun T-Shirt",
      "product_handle": "180b",
      "product_url": "/products/180b",
      "product_full_url": "https://oakdenemerch.com/products/180b",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "PCBest_Seller",
        "performance-activewear",
        "sports",
        "style-180b",
        "t-shirts"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.",
      "style_code": "180B",
      "colour_name": "Bright Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#0049f2",
      "sort_bucket": "blue",
      "sort_hue": 0.616391,
      "sort_sat": 1.0,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49474443378954",
      "swatch_filename": "180B_Bright_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_Bright_Royal.jpg?v=1774371757",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_Bright_Royal.jpg?v=1774371757",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180B/ProductCarouselMain/180B%20BRO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180b_Bright_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548231946",
      "product_title": "Russell Athletic Ladies Authentic Classic Ringspun T-Shirt",
      "product_handle": "180f",
      "product_url": "/products/180f",
      "product_full_url": "https://oakdenemerch.com/products/180f",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-180f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180F",
      "colour_name": "Bright Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#0049f2",
      "sort_bucket": "blue",
      "sort_hue": 0.616391,
      "sort_sat": 1.0,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49472623575306",
      "swatch_filename": "180F_Bright_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180F_Bright_Royal.jpg?v=1774358324",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180F_Bright_Royal.jpg?v=1774358324",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180F/ProductCarouselMain/180F%20BRO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180f_Bright_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562363658",
      "product_title": "Native Spirit Ladies Cropped Tank Top",
      "product_handle": "ns342",
      "product_url": "/products/ns342",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns342",
        "t-shirts",
        "womens",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS342",
      "colour_name": "Washed Coal Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#3c4864",
      "sort_bucket": "blue",
      "sort_hue": 0.616667,
      "sort_sat": 0.4,
      "sort_val": 0.392157,
      "swatch_file_id": "gid://shopify/MediaImage/49513931145482",
      "swatch_filename": "ns342_Washed_Coal_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns342_Washed_Coal_Grey.jpg?v=1774619060",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns342_Washed_Coal_Grey.jpg?v=1774619060",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS342/ProductCarouselMain/NS342%20WCG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns342_Washed_Coal_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552262410",
      "product_title": "Native Spirit Ladies Faded T-Shirt",
      "product_handle": "ns316",
      "product_url": "/products/ns316",
      "product_full_url": "https://oakdenemerch.com/products/ns316",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns316",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS316",
      "colour_name": "Washed Coal Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#3c4864",
      "sort_bucket": "blue",
      "sort_hue": 0.616667,
      "sort_sat": 0.4,
      "sort_val": 0.392157,
      "swatch_file_id": "gid://shopify/MediaImage/49472286687498",
      "swatch_filename": "NS316_Washed_Coal_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS316_Washed_Coal_Grey.jpg?v=1774354319",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS316_Washed_Coal_Grey.jpg?v=1774354319",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS316/ProductCarouselMain/NS316%20WCG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns316_Washed_Coal_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562953482",
      "product_title": "Fruit of the Loom Athletic Vest",
      "product_handle": "ss18",
      "product_url": "/products/ss18",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "sleeveless",
        "sports",
        "style-ss18",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS18",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513937371402",
      "swatch_filename": "ss18_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss18_Royal_Blue.jpg?v=1774619148",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss18_Royal_Blue.jpg?v=1774619148",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS18/ProductCarouselMain/SS18%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss18_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471286018314",
      "swatch_filename": "SS621_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Royal_Blue.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Royal_Blue.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688047882",
      "product_title": "Fruit of the Loom Iconic 195 Long Sleeve T-Shirt",
      "product_handle": "ss624",
      "product_url": "/products/ss624",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-ss624",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS624",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490487083274",
      "swatch_filename": "ss624_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss624_Royal_Blue.jpg?v=1774523031",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss624_Royal_Blue.jpg?v=1774523031",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS624/ProductCarouselMain/SS624%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss624_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471313248522",
      "swatch_filename": "SS620_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Royal_Blue.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Royal_Blue.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554621706",
      "product_title": "Fruit of the Loom Ladies Iconic 150 T-Shirt",
      "product_handle": "ss721",
      "product_url": "/products/ss721",
      "product_full_url": "https://oakdenemerch.com/products/ss721",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss721",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS721",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472056426762",
      "swatch_filename": "SS721_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Royal_Blue.jpg?v=1774353579",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Royal_Blue.jpg?v=1774353579",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS721/ProductCarouselMain/SS721%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss721_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554654474",
      "product_title": "Fruit of the Loom Lady Fit Value T-Shirt",
      "product_handle": "ss77",
      "product_url": "/products/ss77",
      "product_full_url": "https://oakdenemerch.com/products/ss77",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss77",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS77",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472026018058",
      "swatch_filename": "SS77_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Royal_Blue.jpg?v=1774353471",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Royal_Blue.jpg?v=1774353471",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS77/ProductCarouselMain/SS77%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss77_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687982346",
      "product_title": "Fruit of the Loom Long Sleeve Value T-Shirt",
      "product_handle": "ss21",
      "product_url": "/products/ss21",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "knitwear",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss21",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS21",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49490485772554",
      "swatch_filename": "ss21_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss21_Royal_Blue.jpg?v=1774523017",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss21_Royal_Blue.jpg?v=1774523017",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS21/ProductCarouselMain/SS21%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss21_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471330058506",
      "swatch_filename": "SS12_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Royal_Blue.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Royal_Blue.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554457866",
      "product_title": "Fruit of the Loom Pure Cotton T-Shirt",
      "product_handle": "ss640",
      "product_url": "/products/ss640",
      "product_full_url": "https://oakdenemerch.com/products/ss640",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss640",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "SS640",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468957819146",
      "swatch_filename": "SS640_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Royal_Blue.jpg?v=1774315116",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Royal_Blue.jpg?v=1774315116",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS640/ProductCarouselMain/SS640%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss640_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554195722",
      "product_title": "Fruit of the Loom Super Premium T-Shirt",
      "product_handle": "ss10",
      "product_url": "/products/ss10",
      "product_full_url": "https://oakdenemerch.com/products/ss10",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss10",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS10",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471341429002",
      "swatch_filename": "SS10_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_Royal_Blue.jpg?v=1774348796",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_Royal_Blue.jpg?v=1774348796",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS10/ProductCarouselMain/SS10%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss10_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554490634",
      "product_title": "Fruit of the Loom V Neck Value T-Shirt",
      "product_handle": "ss7",
      "product_url": "/products/ss7",
      "product_full_url": "https://oakdenemerch.com/products/ss7",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss7",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS7",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471272124682",
      "swatch_filename": "SS7_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Royal_Blue.jpg?v=1774348430",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Royal_Blue.jpg?v=1774348430",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS7/ProductCarouselMain/SS7%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss7_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471322390794",
      "swatch_filename": "SS6_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Royal_Blue.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Royal_Blue.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562953482",
      "product_title": "Fruit of the Loom Athletic Vest",
      "product_handle": "ss18",
      "product_url": "/products/ss18",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "sleeveless",
        "sports",
        "style-ss18",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS18",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49513937568010",
      "swatch_filename": "ss18_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss18_Deep_Navy.jpg?v=1774619150",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss18_Deep_Navy.jpg?v=1774619150",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS18/ProductCarouselMain/SS18%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss18_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49471286214922",
      "swatch_filename": "SS621_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Deep_Navy.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Deep_Navy.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688047882",
      "product_title": "Fruit of the Loom Iconic 195 Long Sleeve T-Shirt",
      "product_handle": "ss624",
      "product_url": "/products/ss624",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-ss624",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS624",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49490487148810",
      "swatch_filename": "ss624_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss624_Deep_Navy.jpg?v=1774523032",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss624_Deep_Navy.jpg?v=1774523032",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS624/ProductCarouselMain/SS624%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss624_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49471313379594",
      "swatch_filename": "SS620_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Deep_Navy.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Deep_Navy.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554621706",
      "product_title": "Fruit of the Loom Ladies Iconic 150 T-Shirt",
      "product_handle": "ss721",
      "product_url": "/products/ss721",
      "product_full_url": "https://oakdenemerch.com/products/ss721",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss721",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS721",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49472056459530",
      "swatch_filename": "SS721_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Deep_Navy.jpg?v=1774353579",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Deep_Navy.jpg?v=1774353579",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS721/ProductCarouselMain/SS721%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss721_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS720",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49472219119882",
      "swatch_filename": "SS720_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Deep_Navy.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Deep_Navy.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554654474",
      "product_title": "Fruit of the Loom Lady Fit Value T-Shirt",
      "product_handle": "ss77",
      "product_url": "/products/ss77",
      "product_full_url": "https://oakdenemerch.com/products/ss77",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss77",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS77",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49472026050826",
      "swatch_filename": "SS77_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Deep_Navy.jpg?v=1774353471",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Deep_Navy.jpg?v=1774353471",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS77/ProductCarouselMain/SS77%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss77_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554523402",
      "product_title": "Fruit of the Loom Lady Fit Value V Neck T-Shirt",
      "product_handle": "ss702",
      "product_url": "/products/ss702",
      "product_full_url": "https://oakdenemerch.com/products/ss702",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss702",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS702",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49472224198922",
      "swatch_filename": "SS702_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS702_Deep_Navy.jpg?v=1774353786",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS702_Deep_Navy.jpg?v=1774353786",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS702/ProductCarouselMain/SS702%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss702_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687982346",
      "product_title": "Fruit of the Loom Long Sleeve Value T-Shirt",
      "product_handle": "ss21",
      "product_url": "/products/ss21",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "knitwear",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss21",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS21",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49490485870858",
      "swatch_filename": "ss21_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss21_Deep_Navy.jpg?v=1774523018",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss21_Deep_Navy.jpg?v=1774523018",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS21/ProductCarouselMain/SS21%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss21_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49471330255114",
      "swatch_filename": "SS12_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Deep_Navy.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Deep_Navy.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554457866",
      "product_title": "Fruit of the Loom Pure Cotton T-Shirt",
      "product_handle": "ss640",
      "product_url": "/products/ss640",
      "product_full_url": "https://oakdenemerch.com/products/ss640",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss640",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "SS640",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49468957655306",
      "swatch_filename": "SS640_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Deep_Navy.jpg?v=1774315114",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Deep_Navy.jpg?v=1774315114",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS640/ProductCarouselMain/SS640%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss640_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554195722",
      "product_title": "Fruit of the Loom Super Premium T-Shirt",
      "product_handle": "ss10",
      "product_url": "/products/ss10",
      "product_full_url": "https://oakdenemerch.com/products/ss10",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss10",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS10",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49471341396234",
      "swatch_filename": "SS10_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_Deep_Navy.jpg?v=1774348795",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_Deep_Navy.jpg?v=1774348795",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS10/ProductCarouselMain/SS10%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss10_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554490634",
      "product_title": "Fruit of the Loom V Neck Value T-Shirt",
      "product_handle": "ss7",
      "product_url": "/products/ss7",
      "product_full_url": "https://oakdenemerch.com/products/ss7",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss7",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS7",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49471271960842",
      "swatch_filename": "SS7_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Deep_Navy.jpg?v=1774348430",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Deep_Navy.jpg?v=1774348430",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS7/ProductCarouselMain/SS7%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss7_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49471321538826",
      "swatch_filename": "SS6_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Deep_Navy.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Deep_Navy.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "52% cotton/48% polyester.",
      "style_code": "SS621",
      "colour_name": "Heather Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49471285494026",
      "swatch_filename": "SS621_Heather_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Heather_Navy.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Heather_Navy.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20HNY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Heather_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "SS6",
      "colour_name": "Heather Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49471321833738",
      "swatch_filename": "SS6_Heather_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Heather_Navy.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Heather_Navy.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20VHN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Heather_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552098570",
      "product_title": "Onna by Premier Ladies Unstoppable Fresh Underscrub Base Layer",
      "product_handle": "nn370",
      "product_url": "/products/nn370",
      "product_full_url": "None",
      "vendor": "Onna by Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-nn370",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Nylon",
      "shopify_material": "Nylon",
      "csv_material": "50% recycled nylon/30% nylon/20% polyester.",
      "style_code": "NN370",
      "colour_name": "Heather Navy",
      "colour_group": "Blue > Heather/Effect Blue",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49491321094410",
      "swatch_filename": "nn370_Heather_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/nn370_Heather_Navy.jpg?v=1774526518",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/nn370_Heather_Navy.jpg?v=1774526518",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Onna%20by%20Premier/Product%20Images/NN370/ProductCarouselMain/NN370%20HNY%20FRONT%20HERO.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "nn370_Heather_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552065802",
      "product_title": "Onna by Premier Unstoppable Fresh Underscrub Base Layer",
      "product_handle": "nn270",
      "product_url": "/products/nn270",
      "product_full_url": "None",
      "vendor": "Onna by Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-nn270",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Nylon",
      "shopify_material": "Nylon",
      "csv_material": "50% recycled nylon/30% nylon/20% polyester.",
      "style_code": "NN270",
      "colour_name": "Heather Navy",
      "colour_group": "Blue > Heather/Effect Blue",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49491340689674",
      "swatch_filename": "nn270_Heather_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/nn270_Heather_Navy.jpg?v=1774526527",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/nn270_Heather_Navy.jpg?v=1774526527",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Onna%20by%20Premier/Product%20Images/NN270/ProductCarouselMain/NN270%20HNY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "nn270_Heather_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549509898",
      "product_title": "Gildan Heavy Cotton™ Toddler T-Shirt",
      "product_handle": "gd05p",
      "product_url": "/products/gd05p",
      "product_full_url": "https://oakdenemerch.com/products/gd05p",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "2T",
        "2T-3T-4T-5T-6T",
        "3T",
        "4T",
        "5T",
        "6T",
        "baby-toddler",
        "style-gd05p",
        "t-shirts",
        "unisex"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05P",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49474248769802",
      "swatch_filename": "GD05P_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05P_Navy.jpg?v=1774370725",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05P_Navy.jpg?v=1774370725",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05P/ProductCarouselMain/GD05P%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05p_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549903114",
      "product_title": "Gildan Ladies Heavy Cotton™ T-Shirt",
      "product_handle": "gd95",
      "product_url": "/products/gd95",
      "product_full_url": "https://oakdenemerch.com/products/gd95",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd95",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD95",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49468944220426",
      "swatch_filename": "GD95_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD95_Navy.jpg?v=1774314277",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD95_Navy.jpg?v=1774314277",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD95/ProductCarouselMain/GD95%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd95_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549837578",
      "product_title": "Gildan Ladies SoftStyle® Midweight T-Shirt",
      "product_handle": "gd92",
      "product_url": "/products/gd92",
      "product_full_url": "https://oakdenemerch.com/products/gd92",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd92",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD92",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49468942188810",
      "swatch_filename": "GD92_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD92_Navy.jpg?v=1774314177",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD92_Navy.jpg?v=1774314177",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD92/ProductCarouselMain/GD92%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd92_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549772042",
      "product_title": "Gildan Ladies SoftStyle® T-Shirt",
      "product_handle": "gd72",
      "product_url": "/products/gd72",
      "product_full_url": "https://oakdenemerch.com/products/gd72",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd72",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD72",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49468940321034",
      "swatch_filename": "GD72_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Navy.jpg?v=1774314002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Navy.jpg?v=1774314002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD72/ProductCarouselMain/GD72%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd72_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561970442",
      "product_title": "Gildan Ladies SoftStyle® Tank Top",
      "product_handle": "gd77",
      "product_url": "/products/gd77",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd77",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.",
      "style_code": "GD77",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49513920823562",
      "swatch_filename": "gd77_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd77_Navy.jpg?v=1774618954",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd77_Navy.jpg?v=1774618954",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD77/ProductCarouselMain/GD77%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd77_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549804810",
      "product_title": "Gildan Ladies SoftStyle® V Neck T-Shirt",
      "product_handle": "gd78",
      "product_url": "/products/gd78",
      "product_full_url": "https://oakdenemerch.com/products/gd78",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd78",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD78",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49471832752394",
      "swatch_filename": "GD78_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD78_Navy.jpg?v=1774351724",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD78_Navy.jpg?v=1774351724",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD78/ProductCarouselMain/GD78%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd78_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49474267283722",
      "swatch_filename": "GD01_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Navy.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Navy.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549411594",
      "product_title": "Gildan SoftStyle® EZ T-Shirt",
      "product_handle": "gd04",
      "product_url": "/products/gd04",
      "product_full_url": "https://oakdenemerch.com/products/gd04",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd04",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "GD04",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49468937273610",
      "swatch_filename": "GD04_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Navy.jpg?v=1774313523",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Navy.jpg?v=1774313523",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD04/ProductCarouselMain/GD04%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd04_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686966538",
      "product_title": "Gildan SoftStyle® Long Sleeve T-Shirt",
      "product_handle": "gd11",
      "product_url": "/products/gd11",
      "product_full_url": "https://oakdenemerch.com/products/gd11",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd11",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD11",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49490445566218",
      "swatch_filename": "gd11_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Navy.jpg?v=1774522834",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Navy.jpg?v=1774522834",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD11/ProductCarouselMain/GD11%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd11_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49471368593674",
      "swatch_filename": "GD15_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Navy.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Navy.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561937674",
      "product_title": "Gildan SoftStyle® Tank Top",
      "product_handle": "gd12",
      "product_url": "/products/gd12",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD12",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49513919611146",
      "swatch_filename": "gd12_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd12_Navy.jpg?v=1774618942",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd12_Navy.jpg?v=1774618942",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD12/ProductCarouselMain/GD12%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd12_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549575434",
      "product_title": "Gildan SoftStyle® V Neck T-Shirt",
      "product_handle": "gd10",
      "product_url": "/products/gd10",
      "product_full_url": "https://oakdenemerch.com/products/gd10",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd10",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD10",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49468938846474",
      "swatch_filename": "GD10_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD10_Navy.jpg?v=1774313702",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD10_Navy.jpg?v=1774313702",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD10/ProductCarouselMain/GD10%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd10_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD14",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49490462540042",
      "swatch_filename": "gd14_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Navy.jpg?v=1774522859",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Navy.jpg?v=1774522859",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49471397167370",
      "swatch_filename": "GD02_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Navy.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Navy.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552590090",
      "product_title": "Premier Unisex Utility 2.0 Oversized T-Shirt",
      "product_handle": "pr020",
      "product_url": "/products/pr020",
      "product_full_url": "https://oakdenemerch.com/products/pr020",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-pr020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% BCI cotton.",
      "style_code": "PR020",
      "colour_name": "Stay Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49473100120330",
      "swatch_filename": "PR020_Stay_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR020_Stay_Navy.jpg?v=1774361959",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR020_Stay_Navy.jpg?v=1774361959",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR020/ProductCarouselMain/PR020%20STN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr020_Stay_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687785738",
      "product_title": "Pro RTX Pro Long Sleeve T-Shirt",
      "product_handle": "rx152",
      "product_url": "/products/rx152",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx152",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX152",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041745",
      "sort_bucket": "blue",
      "sort_hue": 0.617949,
      "sort_sat": 0.942029,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49490482004234",
      "swatch_filename": "rx152_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx152_Navy.jpg?v=1774522975",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx152_Navy.jpg?v=1774522975",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX152/ProductCarouselMain/RX152%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx152_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041745",
      "sort_bucket": "blue",
      "sort_hue": 0.617949,
      "sort_sat": 0.942029,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49474088665354",
      "swatch_filename": "RX151_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Navy.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Navy.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#0549f5",
      "sort_bucket": "blue",
      "sort_hue": 0.619444,
      "sort_sat": 0.979592,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49473259012362",
      "swatch_filename": "CV3001_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Royal_Blue.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Royal_Blue.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687621898",
      "product_title": "Mantis Unisex Essential Heavy Long Sleeve T-Shirt",
      "product_handle": "m06",
      "product_url": "/products/m06",
      "product_full_url": "None",
      "vendor": "Mantis",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-m06",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "M06",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#222f50",
      "sort_bucket": "blue",
      "sort_hue": 0.619565,
      "sort_sat": 0.575,
      "sort_val": 0.313725,
      "swatch_file_id": "gid://shopify/MediaImage/49490480201994",
      "swatch_filename": "m06_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m06_Navy.jpg?v=1774522946",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m06_Navy.jpg?v=1774522946",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Mantis/M06/ProductCarouselMain/M06%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "m06_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#0039cc",
      "sort_bucket": "blue",
      "sort_hue": 0.620098,
      "sort_sat": 1.0,
      "sort_val": 0.8,
      "swatch_file_id": "gid://shopify/MediaImage/49474088698122",
      "swatch_filename": "RX151_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Royal_Blue.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Royal_Blue.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549903114",
      "product_title": "Gildan Ladies Heavy Cotton™ T-Shirt",
      "product_handle": "gd95",
      "product_url": "/products/gd95",
      "product_full_url": "https://oakdenemerch.com/products/gd95",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd95",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD95",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003ee6",
      "sort_bucket": "blue",
      "sort_hue": 0.621739,
      "sort_sat": 1.0,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49468944056586",
      "swatch_filename": "GD95_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD95_Royal_Blue.jpg?v=1774314277",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD95_Royal_Blue.jpg?v=1774314277",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD95/ProductCarouselMain/GD95%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd95_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549837578",
      "product_title": "Gildan Ladies SoftStyle® Midweight T-Shirt",
      "product_handle": "gd92",
      "product_url": "/products/gd92",
      "product_full_url": "https://oakdenemerch.com/products/gd92",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd92",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD92",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003ee6",
      "sort_bucket": "blue",
      "sort_hue": 0.621739,
      "sort_sat": 1.0,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49468941926666",
      "swatch_filename": "GD92_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD92_Royal_Blue.jpg?v=1774314177",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD92_Royal_Blue.jpg?v=1774314177",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD92/ProductCarouselMain/GD92%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd92_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549772042",
      "product_title": "Gildan Ladies SoftStyle® T-Shirt",
      "product_handle": "gd72",
      "product_url": "/products/gd72",
      "product_full_url": "https://oakdenemerch.com/products/gd72",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd72",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD72",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003ee6",
      "sort_bucket": "blue",
      "sort_hue": 0.621739,
      "sort_sat": 1.0,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49468940484874",
      "swatch_filename": "GD72_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Royal_Blue.jpg?v=1774314002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Royal_Blue.jpg?v=1774314002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD72/ProductCarouselMain/GD72%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd72_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003ee6",
      "sort_bucket": "blue",
      "sort_hue": 0.621739,
      "sort_sat": 1.0,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49474267349258",
      "swatch_filename": "GD01_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Royal_Blue.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Royal_Blue.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549411594",
      "product_title": "Gildan SoftStyle® EZ T-Shirt",
      "product_handle": "gd04",
      "product_url": "/products/gd04",
      "product_full_url": "https://oakdenemerch.com/products/gd04",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd04",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "GD04",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003ee6",
      "sort_bucket": "blue",
      "sort_hue": 0.621739,
      "sort_sat": 1.0,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49468937535754",
      "swatch_filename": "GD04_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Royal_Blue.jpg?v=1774313523",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Royal_Blue.jpg?v=1774313523",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD04/ProductCarouselMain/GD04%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd04_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686966538",
      "product_title": "Gildan SoftStyle® Long Sleeve T-Shirt",
      "product_handle": "gd11",
      "product_url": "/products/gd11",
      "product_full_url": "https://oakdenemerch.com/products/gd11",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd11",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD11",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003ee6",
      "sort_bucket": "blue",
      "sort_hue": 0.621739,
      "sort_sat": 1.0,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49490446319882",
      "swatch_filename": "gd11_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Royal_Blue.jpg?v=1774522835",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Royal_Blue.jpg?v=1774522835",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD11/ProductCarouselMain/GD11%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd11_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003ee6",
      "sort_bucket": "blue",
      "sort_hue": 0.621739,
      "sort_sat": 1.0,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49471368921354",
      "swatch_filename": "GD15_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Royal_Blue.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Royal_Blue.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549575434",
      "product_title": "Gildan SoftStyle® V Neck T-Shirt",
      "product_handle": "gd10",
      "product_url": "/products/gd10",
      "product_full_url": "https://oakdenemerch.com/products/gd10",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd10",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD10",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003ee6",
      "sort_bucket": "blue",
      "sort_hue": 0.621739,
      "sort_sat": 1.0,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49468938780938",
      "swatch_filename": "GD10_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD10_Royal_Blue.jpg?v=1774313702",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD10_Royal_Blue.jpg?v=1774313702",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD10/ProductCarouselMain/GD10%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd10_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD14",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003ee6",
      "sort_bucket": "blue",
      "sort_hue": 0.621739,
      "sort_sat": 1.0,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49490463392010",
      "swatch_filename": "gd14_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Royal_Blue.jpg?v=1774522860",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Royal_Blue.jpg?v=1774522860",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003ee6",
      "sort_bucket": "blue",
      "sort_hue": 0.621739,
      "sort_sat": 1.0,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49471397200138",
      "swatch_filename": "GD02_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Royal_Blue.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Royal_Blue.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Reflex Blue",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#0034cd",
      "sort_bucket": "blue",
      "sort_hue": 0.62439,
      "sort_sat": 1.0,
      "sort_val": 0.803922,
      "swatch_file_id": "gid://shopify/MediaImage/49474218721546",
      "swatch_filename": "JC001_Reflex_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Reflex_Blue.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Reflex_Blue.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20RBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Reflex_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#0c1f57",
      "sort_bucket": "blue",
      "sort_hue": 0.624444,
      "sort_sat": 0.862069,
      "sort_val": 0.341176,
      "swatch_file_id": "gid://shopify/MediaImage/49473588592906",
      "swatch_filename": "SR287_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Navy.jpg?v=1774364345",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Navy.jpg?v=1774364345",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554097418",
      "product_title": "Spiro Kids Impact Performance Aircool T-Shirt",
      "product_handle": "sr287b",
      "product_url": "/products/sr287b",
      "product_full_url": "https://oakdenemerch.com/products/sr287b",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "children",
        "kids",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287b",
        "t-shirts",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287B",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#0c1f57",
      "sort_bucket": "blue",
      "sort_hue": 0.624444,
      "sort_sat": 0.862069,
      "sort_val": 0.341176,
      "swatch_file_id": "gid://shopify/MediaImage/49474060026122",
      "swatch_filename": "SR287B_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Navy.jpg?v=1774368252",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Navy.jpg?v=1774368252",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287B/ProductCarouselMain/SR287B%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287b_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687294218",
      "product_title": "AWDis Cool Long Sleeve Active T-Shirt",
      "product_handle": "jc023",
      "product_url": "/products/jc023",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jc023",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "JC023",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0",
      "sort_bucket": "blue",
      "sort_hue": 0.625,
      "sort_sat": 1.0,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49490478563594",
      "swatch_filename": "jc023_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc023_Royal_Blue.jpg?v=1774522909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc023_Royal_Blue.jpg?v=1774522909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC023/ProductCarouselMain/JC023%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc023_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687228682",
      "product_title": "AWDis Cool Long Sleeve Wicking T-Shirt",
      "product_handle": "jc002",
      "product_url": "/products/jc002",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jc002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC002",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0",
      "sort_bucket": "blue",
      "sort_hue": 0.625,
      "sort_sat": 1.0,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49490477220106",
      "swatch_filename": "jc002_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Royal_Blue.jpg?v=1774522894",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Royal_Blue.jpg?v=1774522894",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC002/ProductCarouselMain/JC002%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc002_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550361866",
      "product_title": "AWDis Cool Smooth T-Shirt",
      "product_handle": "jc020",
      "product_url": "/products/jc020",
      "product_full_url": "https://oakdenemerch.com/products/jc020",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-jc020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0",
      "sort_bucket": "blue",
      "sort_hue": 0.625,
      "sort_sat": 1.0,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49472871497994",
      "swatch_filename": "JC020_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Royal_Blue.jpg?v=1774359994",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Royal_Blue.jpg?v=1774359994",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020/ProductCarouselMain/JC020%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0",
      "sort_bucket": "blue",
      "sort_hue": 0.625,
      "sort_sat": 1.0,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49474217443594",
      "swatch_filename": "JC001_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Royal_Blue.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Royal_Blue.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562003210",
      "product_title": "AWDis Cool Vest",
      "product_handle": "jc007",
      "product_url": "/products/jc007",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc007",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0",
      "sort_bucket": "blue",
      "sort_hue": 0.625,
      "sort_sat": 1.0,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49513924231434",
      "swatch_filename": "jc007_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Royal_Blue.jpg?v=1774618980",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Royal_Blue.jpg?v=1774618980",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC007/ProductCarouselMain/JC007%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550394634",
      "product_title": "AWDis Kids Cool Smooth T-Shirt",
      "product_handle": "jc020b",
      "product_url": "/products/jc020b",
      "product_full_url": "https://oakdenemerch.com/products/jc020b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "style-jc020b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020B",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0",
      "sort_bucket": "blue",
      "sort_hue": 0.625,
      "sort_sat": 1.0,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49474192965898",
      "swatch_filename": "JC020B_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020B_Royal_Blue.jpg?v=1774370151",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020B_Royal_Blue.jpg?v=1774370151",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020B/ProductCarouselMain/JC020B%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020b_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0",
      "sort_bucket": "blue",
      "sort_hue": 0.625,
      "sort_sat": 1.0,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49474209939722",
      "swatch_filename": "JC001B_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Royal_Blue.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Royal_Blue.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562068746",
      "product_title": "AWDis Kids Cool Vest",
      "product_handle": "jc007b",
      "product_url": "/products/jc007b",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "sleeveless",
        "style-jc007b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007B",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0",
      "sort_bucket": "blue",
      "sort_hue": 0.625,
      "sort_sat": 1.0,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49513925312778",
      "swatch_filename": "jc007b_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007b_Royal_Blue.jpg?v=1774618992",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007b_Royal_Blue.jpg?v=1774618992",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC007B/ProductCarouselMain/JC007B%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007b_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0",
      "sort_bucket": "blue",
      "sort_hue": 0.625,
      "sort_sat": 1.0,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49473142128906",
      "swatch_filename": "JC005_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Royal_Blue.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Royal_Blue.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562101514",
      "product_title": "AWDis Ladies Cool Vest",
      "product_handle": "jc015",
      "product_url": "/products/jc015",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc015",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC015",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0",
      "sort_bucket": "blue",
      "sort_hue": 0.625,
      "sort_sat": 1.0,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49513927966986",
      "swatch_filename": "jc015_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Royal_Blue.jpg?v=1774619009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Royal_Blue.jpg?v=1774619009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC015/ProductCarouselMain/JC015%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc015_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0",
      "sort_bucket": "blue",
      "sort_hue": 0.625,
      "sort_sat": 1.0,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49471443042570",
      "swatch_filename": "AT001_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Royal_Blue.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Royal_Blue.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0",
      "sort_bucket": "blue",
      "sort_hue": 0.625,
      "sort_sat": 1.0,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49471429837066",
      "swatch_filename": "AT002_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Royal_Blue.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Royal_Blue.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548789002",
      "product_title": "Canterbury Club Dry T-Shirt",
      "product_handle": "cn260",
      "product_url": "/products/cn260",
      "product_full_url": "https://oakdenemerch.com/products/cn260",
      "vendor": "Canterbury",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-cn260",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "CN260",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0",
      "sort_bucket": "blue",
      "sort_hue": 0.625,
      "sort_sat": 1.0,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49468934357258",
      "swatch_filename": "CN260_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CN260_Royal_Blue.jpg?v=1774313120",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CN260_Royal_Blue.jpg?v=1774313120",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Canterbury/Product%20Images/CN260/ProductCarouselMain/CN260%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cn260_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552262410",
      "product_title": "Native Spirit Ladies Faded T-Shirt",
      "product_handle": "ns316",
      "product_url": "/products/ns316",
      "product_full_url": "https://oakdenemerch.com/products/ns316",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns316",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS316",
      "colour_name": "Washed Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1d2b57",
      "sort_bucket": "blue",
      "sort_hue": 0.626437,
      "sort_sat": 0.666667,
      "sort_val": 0.341176,
      "swatch_file_id": "gid://shopify/MediaImage/49472286589194",
      "swatch_filename": "NS316_Washed_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS316_Washed_Navy.jpg?v=1774354318",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS316_Washed_Navy.jpg?v=1774354318",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS316/ProductCarouselMain/NS316%20WNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns316_Washed_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49474468151562",
      "swatch_filename": "03582_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Royal_Blue.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Royal_Blue.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547511050",
      "product_title": "SOL'S Crusader Recycled T-Shirt",
      "product_handle": "04233",
      "product_url": "/products/04233",
      "product_full_url": "https://oakdenemerch.com/products/04233",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04233",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% recycled cotton/50% cotton.*",
      "style_code": "04233",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49473285161226",
      "swatch_filename": "04233_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Royal_Blue.jpg?v=1774363191",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Royal_Blue.jpg?v=1774363191",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04233/ProductCarouselMain/04233%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04233_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49474448130314",
      "swatch_filename": "11500_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Royal_Blue.jpg?v=1774371835",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Royal_Blue.jpg?v=1774371835",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546953994",
      "product_title": "SOL'S Imperial V Neck T-Shirt",
      "product_handle": "02940",
      "product_url": "/products/02940",
      "product_full_url": "https://oakdenemerch.com/products/02940",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-02940",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "02940",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49468829171978",
      "swatch_filename": "02940_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02940_Royal_Blue.jpg?v=1774312050",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02940_Royal_Blue.jpg?v=1774312050",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02940/ProductCarouselMain/02940%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02940_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561773834",
      "product_title": "SOL'S Justin Tank Top",
      "product_handle": "11465",
      "product_url": "/products/11465",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11465",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11465",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49513915449610",
      "swatch_filename": "11465_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11465_Royal_Blue.jpg?v=1774618900",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11465_Royal_Blue.jpg?v=1774618900",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11465/ProductCarouselMain/11465%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11465_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49468835954954",
      "swatch_filename": "03581_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Royal_Blue.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Royal_Blue.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49468933308682",
      "swatch_filename": "11502_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Royal_Blue.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Royal_Blue.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547052298",
      "product_title": "SOL'S Ladies Imperial V Neck T-Shirt",
      "product_handle": "02941",
      "product_url": "/products/02941",
      "product_full_url": "https://oakdenemerch.com/products/02941",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-02941",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "02941",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49471878332682",
      "swatch_filename": "02941_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02941_Royal_Blue.jpg?v=1774352301",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02941_Royal_Blue.jpg?v=1774352301",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02941/ProductCarouselMain/02941%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02941_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685917962",
      "product_title": "SOL'S Ladies Monarch Long Sleeve T-Shirt",
      "product_handle": "04443",
      "product_url": "/products/04443",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-04443",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.",
      "style_code": "04443",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49490370494730",
      "swatch_filename": "04443_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04443_Royal_Blue.jpg?v=1774522736",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04443_Royal_Blue.jpg?v=1774522736",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04443/ProductCarouselMain/04443%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04443_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548035338",
      "product_title": "SOL'S Ladies Moon V Neck T-Shirt",
      "product_handle": "11388",
      "product_url": "/products/11388",
      "product_full_url": "https://oakdenemerch.com/products/11388",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11388",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11388",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49468932391178",
      "swatch_filename": "11388_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_Royal_Blue.jpg?v=1774312856",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_Royal_Blue.jpg?v=1774312856",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11388/ProductCarouselMain/11388%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11388_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49468833267978",
      "swatch_filename": "03579_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Royal_Blue.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Royal_Blue.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49468822847754",
      "swatch_filename": "01825_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Royal_Blue.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Royal_Blue.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547609354",
      "product_title": "SOL'S Ladies Regent V Neck T-Shirt",
      "product_handle": "04766",
      "product_url": "/products/04766",
      "product_full_url": "https://oakdenemerch.com/products/04766",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "S",
        "style-04766",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "04766",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49472664666378",
      "swatch_filename": "04766_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04766_Royal_Blue.jpg?v=1774358606",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04766_Royal_Blue.jpg?v=1774358606",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04766/ProductCarouselMain/04766%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04766_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561642762",
      "product_title": "SOL'S Ladies Sporty Performance Tank Top",
      "product_handle": "02117",
      "product_url": "/products/02117",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-02117",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02117",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49513912566026",
      "swatch_filename": "02117_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02117_Royal_Blue.jpg?v=1774618867",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02117_Royal_Blue.jpg?v=1774618867",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02117/ProductCarouselMain/02117%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02117_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547707658",
      "product_title": "SOL'S Ladies Vortex Ripstop Performance T-Shirt",
      "product_handle": "04788",
      "product_url": "/products/04788",
      "product_full_url": "https://oakdenemerch.com/products/04788",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04788",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04788",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49472652083466",
      "swatch_filename": "04788_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_Royal_Blue.jpg?v=1774358494",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04788_Royal_Blue.jpg?v=1774358494",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04788/ProductCarouselMain/04788%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04788_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686049034",
      "product_title": "SOL'S Monarch Long Sleeve T-Shirt",
      "product_handle": "11420",
      "product_url": "/products/11420",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11420",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "11420",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49490371543306",
      "swatch_filename": "11420_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Royal_Blue.jpg?v=1774522751",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Royal_Blue.jpg?v=1774522751",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11420/ProductCarouselMain/11420%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11420_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03565",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49473305608458",
      "swatch_filename": "03565_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Royal_Blue.jpg?v=1774363313",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Royal_Blue.jpg?v=1774363313",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547871498",
      "product_title": "SOL'S Regent Fit T-Shirt",
      "product_handle": "10553",
      "product_url": "/products/10553",
      "product_full_url": "https://oakdenemerch.com/products/10553",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-10553",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "10553",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49472628818186",
      "swatch_filename": "10553_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_Royal_Blue.jpg?v=1774358391",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_Royal_Blue.jpg?v=1774358391",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/10553/ProductCarouselMain/10553%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "10553_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49473718878474",
      "swatch_filename": "11380_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Royal_Blue.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Royal_Blue.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685590282",
      "product_title": "SOL'S Sporty Long Sleeve Performance T-Shirt",
      "product_handle": "02071",
      "product_url": "/products/02071",
      "product_full_url": "https://oakdenemerch.com/products/02071",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL",
        "sports",
        "style-02071",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02071",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49490365513994",
      "swatch_filename": "02071_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02071_Royal_Blue.jpg?v=1774522697",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02071_Royal_Blue.jpg?v=1774522697",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02071/ProductCarouselMain/02071%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02071_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548166410",
      "product_title": "SOL'S Sporty Performance T-Shirt",
      "product_handle": "11939",
      "product_url": "/products/11939",
      "product_full_url": "https://oakdenemerch.com/products/11939",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-11939",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "11939",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49473692598538",
      "swatch_filename": "11939_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Royal_Blue.jpg?v=1774364865",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Royal_Blue.jpg?v=1774364865",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11939/ProductCarouselMain/11939%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11939_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561609994",
      "product_title": "SOL'S Sporty Performance Tank Top",
      "product_handle": "02073",
      "product_url": "/products/02073",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL",
        "sports",
        "style-02073",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02073",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49513910698250",
      "swatch_filename": "02073_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02073_Royal_Blue.jpg?v=1774618855",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02073_Royal_Blue.jpg?v=1774618855",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02073/ProductCarouselMain/02073%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02073_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547543818",
      "product_title": "SOL'S Unisex Explorer Recycled T-Shirt",
      "product_handle": "04461",
      "product_url": "/products/04461",
      "product_full_url": "https://oakdenemerch.com/products/04461",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04461",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "60% recycled cotton/40% recycled polyester.",
      "style_code": "04461",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49472969081098",
      "swatch_filename": "04461_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04461_Royal_Blue.jpg?v=1774360548",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04461_Royal_Blue.jpg?v=1774360548",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04461/ProductCarouselMain/04461%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04461_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49473744404746",
      "swatch_filename": "03981_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Royal_Blue.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Royal_Blue.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547150602",
      "product_title": "SOL'S Unisex Sprint T-Shirt",
      "product_handle": "02995",
      "product_url": "/products/02995",
      "product_full_url": "https://oakdenemerch.com/products/02995",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-02995",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "02995",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49473768325386",
      "swatch_filename": "02995_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Royal_Blue.jpg?v=1774365179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Royal_Blue.jpg?v=1774365179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02995/ProductCarouselMain/02995%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02995_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547576586",
      "product_title": "SOL'S Unisex Titan T-Shirt",
      "product_handle": "04728",
      "product_url": "/products/04728",
      "product_full_url": "https://oakdenemerch.com/products/04728",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "knitwear",
        "L",
        "M",
        "S",
        "style-04728",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.",
      "style_code": "04728",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49474457043210",
      "swatch_filename": "04728_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_Royal_Blue.jpg?v=1774371966",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_Royal_Blue.jpg?v=1774371966",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04728/ProductCarouselMain/04728%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04728_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547478282",
      "product_title": "SOL'S Unisex Tuner T-Shirt",
      "product_handle": "04203",
      "product_url": "/products/04203",
      "product_full_url": "https://oakdenemerch.com/products/04203",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-04203",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.*",
      "style_code": "04203",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49474458910986",
      "swatch_filename": "04203_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_Royal_Blue.jpg?v=1774372011",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04203_Royal_Blue.jpg?v=1774372011",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04203/ProductCarouselMain/04203%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04203_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547937034",
      "product_title": "SOL'S Victory V Neck T-Shirt",
      "product_handle": "11150",
      "product_url": "/products/11150",
      "product_full_url": "https://oakdenemerch.com/products/11150",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11150",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11150",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49468838478090",
      "swatch_filename": "11150_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11150_Royal_Blue.jpg?v=1774312556",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11150_Royal_Blue.jpg?v=1774312556",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11150/ProductCarouselMain/11150%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11150_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547674890",
      "product_title": "SOL'S Vortex Ripstop Performance T-Shirt",
      "product_handle": "04787",
      "product_url": "/products/04787",
      "product_full_url": "https://oakdenemerch.com/products/04787",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-04787",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "04787",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49472658047242",
      "swatch_filename": "04787_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_Royal_Blue.jpg?v=1774358538",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04787_Royal_Blue.jpg?v=1774358538",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04787/ProductCarouselMain/04787%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04787_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548297482",
      "product_title": "Russell Athletic Authentic Heavyweight T-Shirt",
      "product_handle": "215m",
      "product_url": "/products/215m",
      "product_full_url": "https://oakdenemerch.com/products/215m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "sports",
        "style-215m",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "215M",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#00114b",
      "sort_bucket": "blue",
      "sort_hue": 0.628889,
      "sort_sat": 1.0,
      "sort_val": 0.294118,
      "swatch_file_id": "gid://shopify/MediaImage/49470972789002",
      "swatch_filename": "215M_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/215M_French_Navy.jpg?v=1774347211",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/215M_French_Navy.jpg?v=1774347211",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/215M/ProductCarouselMain/215M%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "215m_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686147338",
      "product_title": "Russell Athletic Classic Long Sleeve T-Shirt",
      "product_handle": "180l",
      "product_url": "/products/180l",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-180l",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "180L",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#00114b",
      "sort_bucket": "blue",
      "sort_hue": 0.628889,
      "sort_sat": 1.0,
      "sort_val": 0.294118,
      "swatch_file_id": "gid://shopify/MediaImage/49490374033674",
      "swatch_filename": "180l_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180l_French_Navy.jpg?v=1774522759",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180l_French_Navy.jpg?v=1774522759",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180L/ProductCarouselMain/180L%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180l_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#00114b",
      "sort_bucket": "blue",
      "sort_hue": 0.628889,
      "sort_sat": 1.0,
      "sort_val": 0.294118,
      "swatch_file_id": "gid://shopify/MediaImage/49473272938762",
      "swatch_filename": "180M_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_French_Navy.jpg?v=1774363124",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_French_Navy.jpg?v=1774363124",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546724618",
      "product_title": "Russell Athletic Heavyweight T-Shirt",
      "product_handle": "010m",
      "product_url": "/products/010m",
      "product_full_url": "https://oakdenemerch.com/products/010m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-010m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "010M",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#00114b",
      "sort_bucket": "blue",
      "sort_hue": 0.628889,
      "sort_sat": 1.0,
      "sort_val": 0.294118,
      "swatch_file_id": "gid://shopify/MediaImage/49468778414346",
      "swatch_filename": "010M_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/010M_French_Navy.jpg?v=1774311232",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/010M_French_Navy.jpg?v=1774311232",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/010M/ProductCarouselMain/010M%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "010m_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548199178",
      "product_title": "Russell Athletic Kids Classic Ringspun T-Shirt",
      "product_handle": "180b",
      "product_url": "/products/180b",
      "product_full_url": "https://oakdenemerch.com/products/180b",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "PCBest_Seller",
        "performance-activewear",
        "sports",
        "style-180b",
        "t-shirts"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.",
      "style_code": "180B",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#00114b",
      "sort_bucket": "blue",
      "sort_hue": 0.628889,
      "sort_sat": 1.0,
      "sort_val": 0.294118,
      "swatch_file_id": "gid://shopify/MediaImage/49474443477258",
      "swatch_filename": "180B_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_French_Navy.jpg?v=1774371757",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_French_Navy.jpg?v=1774371757",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180B/ProductCarouselMain/180B%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180b_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548231946",
      "product_title": "Russell Athletic Ladies Authentic Classic Ringspun T-Shirt",
      "product_handle": "180f",
      "product_url": "/products/180f",
      "product_full_url": "https://oakdenemerch.com/products/180f",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-180f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180F",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#00114b",
      "sort_bucket": "blue",
      "sort_hue": 0.628889,
      "sort_sat": 1.0,
      "sort_val": 0.294118,
      "swatch_file_id": "gid://shopify/MediaImage/49472623477002",
      "swatch_filename": "180F_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180F_French_Navy.jpg?v=1774358325",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180F_French_Navy.jpg?v=1774358325",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180F/ProductCarouselMain/180F%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180f_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550984458",
      "product_title": "Kustom Kit Hunky® Superior T-Shirt",
      "product_handle": "k500",
      "product_url": "/products/k500",
      "product_full_url": "https://oakdenemerch.com/products/k500",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-k500",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed cotton.*",
      "style_code": "K500",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001a75",
      "sort_bucket": "blue",
      "sort_hue": 0.62963,
      "sort_sat": 1.0,
      "sort_val": 0.458824,
      "swatch_file_id": "gid://shopify/MediaImage/49474181660938",
      "swatch_filename": "K500_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K500_Navy.jpg?v=1774369965",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K500_Navy.jpg?v=1774369965",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K500/ProductCarouselMain/K500%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k500_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687556362",
      "product_title": "Kustom Kit Long Sleeve Fashion Fit Superwash® 60°C T-Shirt",
      "product_handle": "k510",
      "product_url": "/products/k510",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-k510",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton.",
      "style_code": "K510",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001a75",
      "sort_bucket": "blue",
      "sort_hue": 0.62963,
      "sort_sat": 1.0,
      "sort_val": 0.458824,
      "swatch_file_id": "gid://shopify/MediaImage/49490479382794",
      "swatch_filename": "k510_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k510_Navy.jpg?v=1774522933",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k510_Navy.jpg?v=1774522933",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K510/ProductCarouselMain/K510%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k510_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551181066",
      "product_title": "Kustom Kit Regular Fit Cooltex® Plus Wicking T-Shirt",
      "product_handle": "k555",
      "product_url": "/products/k555",
      "product_full_url": "https://oakdenemerch.com/products/k555",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k555",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester mesh.",
      "style_code": "K555",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001a75",
      "sort_bucket": "blue",
      "sort_hue": 0.62963,
      "sort_sat": 1.0,
      "sort_val": 0.458824,
      "swatch_file_id": "gid://shopify/MediaImage/49473108607242",
      "swatch_filename": "K555_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K555_Navy.jpg?v=1774362040",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K555_Navy.jpg?v=1774362040",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K555/ProductCarouselMain/K555%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k555_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551148298",
      "product_title": "Kustom Kit Superwash® 60°C Piqué T-Shirt",
      "product_handle": "k530",
      "product_url": "/products/k530",
      "product_full_url": "https://oakdenemerch.com/products/k530",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-k530",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton piqué.",
      "style_code": "K530",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001a75",
      "sort_bucket": "blue",
      "sort_hue": 0.62963,
      "sort_sat": 1.0,
      "sort_val": 0.458824,
      "swatch_file_id": "gid://shopify/MediaImage/49472793379082",
      "swatch_filename": "K530_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K530_Navy.jpg?v=1774359824",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K530_Navy.jpg?v=1774359824",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K530/ProductCarouselMain/K530%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k530_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551017226",
      "product_title": "Kustom Kit Superwash® 60°C T-Shirt",
      "product_handle": "k504",
      "product_url": "/products/k504",
      "product_full_url": "https://oakdenemerch.com/products/k504",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k504",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton.*",
      "style_code": "K504",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001a75",
      "sort_bucket": "blue",
      "sort_hue": 0.62963,
      "sort_sat": 1.0,
      "sort_val": 0.458824,
      "swatch_file_id": "gid://shopify/MediaImage/49473127153930",
      "swatch_filename": "K504_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K504_Navy.jpg?v=1774362160",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K504_Navy.jpg?v=1774362160",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K504/ProductCarouselMain/K504%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k504_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687589130",
      "product_title": "Kustom Kit Warmtex® Long Sleeve Base Layer",
      "product_handle": "k979",
      "product_url": "/products/k979",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-k979",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "90% polyester/10% spandex.",
      "style_code": "K979",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001a75",
      "sort_bucket": "blue",
      "sort_hue": 0.62963,
      "sort_sat": 1.0,
      "sort_val": 0.458824,
      "swatch_file_id": "gid://shopify/MediaImage/49490479743242",
      "swatch_filename": "k979_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k979_Navy.jpg?v=1774522940",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k979_Navy.jpg?v=1774522940",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K979/ProductCarouselMain/K979%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k979_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549706506",
      "product_title": "Gildan Hammer Heavyweight T-Shirt",
      "product_handle": "gd21",
      "product_url": "/products/gd21",
      "product_full_url": "https://oakdenemerch.com/products/gd21",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-gd21",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD21",
      "colour_name": "Sport Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#0023a3",
      "sort_bucket": "blue",
      "sort_hue": 0.630879,
      "sort_sat": 1.0,
      "sort_val": 0.639216,
      "swatch_file_id": "gid://shopify/MediaImage/49470943363338",
      "swatch_filename": "GD21_Sport_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD21_Sport_Royal.jpg?v=1774347003",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD21_Sport_Royal.jpg?v=1774347003",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD21/ProductCarouselMain/GD21%20SRO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd21_Sport_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550001418",
      "product_title": "Henbury Unisex Coolplus® Wicking Piqué T-Shirt",
      "product_handle": "h075",
      "product_url": "/products/h075",
      "product_full_url": "https://oakdenemerch.com/products/h075",
      "vendor": "Henbury",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-h075",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester micro piqué.",
      "style_code": "H075",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#0022a1",
      "sort_bucket": "blue",
      "sort_hue": 0.63147,
      "sort_sat": 1.0,
      "sort_val": 0.631373,
      "swatch_file_id": "gid://shopify/MediaImage/49474231238922",
      "swatch_filename": "H075_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/H075_Royal_Blue.jpg?v=1774370566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/H075_Royal_Blue.jpg?v=1774370566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H075/ProductCarouselMain/H075%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h075_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553016074",
      "product_title": "SF Clothing Feel Good Stretch T-Shirt",
      "product_handle": "sf121",
      "product_url": "/products/sf121",
      "product_full_url": "https://oakdenemerch.com/products/sf121",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-sf121",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane single jersey.*",
      "style_code": "SF121",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#0c184a",
      "sort_bucket": "blue",
      "sort_hue": 0.634409,
      "sort_sat": 0.837838,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49472270860554",
      "swatch_filename": "SF121_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF121_Navy.jpg?v=1774354029",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF121_Navy.jpg?v=1774354029",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF121/ProductCarouselMain/SF121%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf121_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#3057ff",
      "sort_bucket": "blue",
      "sort_hue": 0.635266,
      "sort_sat": 0.811765,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473588330762",
      "swatch_filename": "SR287_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Royal_Blue.jpg?v=1774364345",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Royal_Blue.jpg?v=1774364345",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554097418",
      "product_title": "Spiro Kids Impact Performance Aircool T-Shirt",
      "product_handle": "sr287b",
      "product_url": "/products/sr287b",
      "product_full_url": "https://oakdenemerch.com/products/sr287b",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "children",
        "kids",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287b",
        "t-shirts",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287B",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#3057ff",
      "sort_bucket": "blue",
      "sort_hue": 0.635266,
      "sort_sat": 0.811765,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474059895050",
      "swatch_filename": "SR287B_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Royal_Blue.jpg?v=1774368252",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287B_Royal_Blue.jpg?v=1774368252",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287B/ProductCarouselMain/SR287B%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287b_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552295178",
      "product_title": "Native Spirit Ladies T-Shirt",
      "product_handle": "ns324",
      "product_url": "/products/ns324",
      "product_full_url": "https://oakdenemerch.com/products/ns324",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns324",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS324",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#111a41",
      "sort_bucket": "blue",
      "sort_hue": 0.635417,
      "sort_sat": 0.738462,
      "sort_val": 0.254902,
      "swatch_file_id": "gid://shopify/MediaImage/49472283509002",
      "swatch_filename": "NS324_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Navy.jpg?v=1774354240",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Navy.jpg?v=1774354240",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS324/ProductCarouselMain/NS324%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns324_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562330890",
      "product_title": "Native Spirit Ladies Tank Top",
      "product_handle": "ns341",
      "product_url": "/products/ns341",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns341",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS341",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#111a41",
      "sort_bucket": "blue",
      "sort_hue": 0.635417,
      "sort_sat": 0.738462,
      "sort_val": 0.254902,
      "swatch_file_id": "gid://shopify/MediaImage/49513930195210",
      "swatch_filename": "ns341_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns341_Navy.jpg?v=1774619047",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns341_Navy.jpg?v=1774619047",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS341/ProductCarouselMain/NS341%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns341_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552393482",
      "product_title": "Native Spirit Oversized T-Shirt",
      "product_handle": "ns332",
      "product_url": "/products/ns332",
      "product_full_url": "https://oakdenemerch.com/products/ns332",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns332",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "NS332",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#111a41",
      "sort_bucket": "blue",
      "sort_hue": 0.635417,
      "sort_sat": 0.738462,
      "sort_val": 0.254902,
      "swatch_file_id": "gid://shopify/MediaImage/49474121433354",
      "swatch_filename": "NS332_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_Navy.jpg?v=1774369280",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_Navy.jpg?v=1774369280",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS332/ProductCarouselMain/NS332%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns332_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552229642",
      "product_title": "Native Spirit Terry Towel T-Shirt",
      "product_handle": "ns311",
      "product_url": "/products/ns311",
      "product_full_url": "https://oakdenemerch.com/products/ns311",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns311",
        "t-shirts",
        "towels-robes-slippers",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic combed cotton/20% recycled polyester.",
      "style_code": "NS311",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#111a41",
      "sort_bucket": "blue",
      "sort_hue": 0.635417,
      "sort_sat": 0.738462,
      "sort_val": 0.254902,
      "swatch_file_id": "gid://shopify/MediaImage/49472780665098",
      "swatch_filename": "NS311_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS311_Navy.jpg?v=1774359624",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS311_Navy.jpg?v=1774359624",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS311/ProductCarouselMain/NS311%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns311_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687654666",
      "product_title": "Native Spirit Unisex Crew Neck Long Sleeve T-Shirt",
      "product_handle": "ns333",
      "product_url": "/products/ns333",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-ns333",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS333",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#111a41",
      "sort_bucket": "blue",
      "sort_hue": 0.635417,
      "sort_sat": 0.738462,
      "sort_val": 0.254902,
      "swatch_file_id": "gid://shopify/MediaImage/49490480693514",
      "swatch_filename": "ns333_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns333_Navy.jpg?v=1774522954",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns333_Navy.jpg?v=1774522954",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS333/ProductCarouselMain/NS333%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns333_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552164106",
      "product_title": "Native Spirit Unisex French Terry T-Shirt",
      "product_handle": "ns308",
      "product_url": "/products/ns308",
      "product_full_url": "https://oakdenemerch.com/products/ns308",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns308",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "NS308",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#111a41",
      "sort_bucket": "blue",
      "sort_hue": 0.635417,
      "sort_sat": 0.738462,
      "sort_val": 0.254902,
      "swatch_file_id": "gid://shopify/MediaImage/49472288456970",
      "swatch_filename": "NS308_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS308_Navy.jpg?v=1774354362",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS308_Navy.jpg?v=1774354362",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS308/ProductCarouselMain/NS308%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns308_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#111a41",
      "sort_bucket": "blue",
      "sort_hue": 0.635417,
      "sort_sat": 0.738462,
      "sort_val": 0.254902,
      "swatch_file_id": "gid://shopify/MediaImage/49473667105034",
      "swatch_filename": "NS305_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Navy.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Navy.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552360714",
      "product_title": "Native Spirit Unisex Oversized T-Shirt",
      "product_handle": "ns330",
      "product_url": "/products/ns330",
      "product_full_url": "https://oakdenemerch.com/products/ns330",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-ns330",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS330",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#111a41",
      "sort_bucket": "blue",
      "sort_hue": 0.635417,
      "sort_sat": 0.738462,
      "sort_val": 0.254902,
      "swatch_file_id": "gid://shopify/MediaImage/49473635025162",
      "swatch_filename": "NS330_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS330_Navy.jpg?v=1774364536",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS330_Navy.jpg?v=1774364536",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS330/ProductCarouselMain/NS330%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns330_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549116682",
      "product_title": "Ecologie Cascades Organic T-Shirt",
      "product_handle": "ea001",
      "product_url": "/products/ea001",
      "product_full_url": "https://oakdenemerch.com/products/ea001",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-ea001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#1b3ac2",
      "sort_bucket": "blue",
      "sort_hue": 0.635729,
      "sort_sat": 0.860825,
      "sort_val": 0.760784,
      "swatch_file_id": "gid://shopify/MediaImage/49474303754506",
      "swatch_filename": "EA001_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Royal_Blue.jpg?v=1774371175",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Royal_Blue.jpg?v=1774371175",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001/ProductCarouselMain/EA001%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553016074",
      "product_title": "SF Clothing Feel Good Stretch T-Shirt",
      "product_handle": "sf121",
      "product_url": "/products/sf121",
      "product_full_url": "https://oakdenemerch.com/products/sf121",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-sf121",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane single jersey.*",
      "style_code": "SF121",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#1d3abb",
      "sort_bucket": "blue",
      "sort_hue": 0.636076,
      "sort_sat": 0.84492,
      "sort_val": 0.733333,
      "swatch_file_id": "gid://shopify/MediaImage/49472270795018",
      "swatch_filename": "SF121_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF121_Royal_Blue.jpg?v=1774354029",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF121_Royal_Blue.jpg?v=1774354029",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF121/ProductCarouselMain/SF121%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf121_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548690698",
      "product_title": "Bella Ladies Heavy Boxy T-Shirt",
      "product_handle": "bl6110",
      "product_url": "/products/bl6110",
      "product_full_url": "https://oakdenemerch.com/products/bl6110",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-bl6110",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "BL6110",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1c2449",
      "sort_bucket": "blue",
      "sort_hue": 0.637037,
      "sort_sat": 0.616438,
      "sort_val": 0.286275,
      "swatch_file_id": "gid://shopify/MediaImage/49472881492234",
      "swatch_filename": "BL6110_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_Navy.jpg?v=1774360125",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_Navy.jpg?v=1774360125",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL6110/ProductCarouselMain/BL6110%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl6110_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548723466",
      "product_title": "Bella Ladies Relaxed Jersey T-Shirt",
      "product_handle": "bl6400",
      "product_url": "/products/bl6400",
      "product_full_url": "https://oakdenemerch.com/products/bl6400",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-bl6400",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "BL6400",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1c2449",
      "sort_bucket": "blue",
      "sort_hue": 0.637037,
      "sort_sat": 0.616438,
      "sort_val": 0.286275,
      "swatch_file_id": "gid://shopify/MediaImage/49471852839178",
      "swatch_filename": "BL6400_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6400_Navy.jpg?v=1774351968",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6400_Navy.jpg?v=1774351968",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL6400/ProductCarouselMain/BL6400%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl6400_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1c2449",
      "sort_bucket": "blue",
      "sort_hue": 0.637037,
      "sort_sat": 0.616438,
      "sort_val": 0.286275,
      "swatch_file_id": "gid://shopify/MediaImage/49473259274506",
      "swatch_filename": "CV3001_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Navy.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Navy.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548920074",
      "product_title": "Canvas Unisex Heavyweight Boxy T-Shirt",
      "product_handle": "cv3010",
      "product_url": "/products/cv3010",
      "product_full_url": "https://oakdenemerch.com/products/cv3010",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv3010",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3010",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1c2449",
      "sort_bucket": "blue",
      "sort_hue": 0.637037,
      "sort_sat": 0.616438,
      "sort_val": 0.286275,
      "swatch_file_id": "gid://shopify/MediaImage/49472879493386",
      "swatch_filename": "CV3010_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_Navy.jpg?v=1774360083",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_Navy.jpg?v=1774360083",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3010/ProductCarouselMain/CV3010%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3010_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686737162",
      "product_title": "Canvas Unisex Heavyweight Long Sleeve Boxy T-Shirt",
      "product_handle": "cv3511",
      "product_url": "/products/cv3511",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv3511",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3511",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1c2449",
      "sort_bucket": "blue",
      "sort_hue": 0.637037,
      "sort_sat": 0.616438,
      "sort_val": 0.286275,
      "swatch_file_id": "gid://shopify/MediaImage/49490426233098",
      "swatch_filename": "cv3511_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_Navy.jpg?v=1774522803",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_Navy.jpg?v=1774522803",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3511/ProductCarouselMain/CV3511%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3511_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686638858",
      "product_title": "Canvas Unisex Jersey Long Sleeve T-Shirt",
      "product_handle": "cv3501",
      "product_url": "/products/cv3501",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv3501",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3501",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1c2449",
      "sort_bucket": "blue",
      "sort_hue": 0.637037,
      "sort_sat": 0.616438,
      "sort_val": 0.286275,
      "swatch_file_id": "gid://shopify/MediaImage/49490419613962",
      "swatch_filename": "cv3501_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3501_Navy.jpg?v=1774522796",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3501_Navy.jpg?v=1774522796",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3501/ProductCarouselMain/CV3501%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3501_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% organic combed ringspun cotton/40% polyester.",
      "style_code": "AM10",
      "colour_name": "Navy Marl",
      "colour_group": "Blue > Heather/Effect Blue",
      "rgb": "#363a4d",
      "sort_bucket": "blue",
      "sort_hue": 0.637681,
      "sort_sat": 0.298701,
      "sort_val": 0.301961,
      "swatch_file_id": "gid://shopify/MediaImage/49474342650122",
      "swatch_filename": "AM10_Navy_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Navy_Marl.jpg?v=1774371249",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Navy_Marl.jpg?v=1774371249",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20NML%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Navy_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548428554",
      "product_title": "Anthem Amplify Heavyweight T-Shirt",
      "product_handle": "am18",
      "product_url": "/products/am18",
      "product_full_url": "https://oakdenemerch.com/products/am18",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-am18",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM18",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#2b314f",
      "sort_bucket": "blue",
      "sort_hue": 0.638889,
      "sort_sat": 0.455696,
      "sort_val": 0.309804,
      "swatch_file_id": "gid://shopify/MediaImage/49472893059338",
      "swatch_filename": "AM18_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_Navy.jpg?v=1774360285",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_Navy.jpg?v=1774360285",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM18/ProductCarouselMain/AM18%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am18_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686212874",
      "product_title": "Anthem Organic Long Sleeve T-Shirt",
      "product_handle": "am11",
      "product_url": "/products/am11",
      "product_full_url": "None",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-am11",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM11",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#2b314f",
      "sort_bucket": "blue",
      "sort_hue": 0.638889,
      "sort_sat": 0.455696,
      "sort_val": 0.309804,
      "swatch_file_id": "gid://shopify/MediaImage/49490376917258",
      "swatch_filename": "am11_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am11_Navy.jpg?v=1774522764",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am11_Navy.jpg?v=1774522764",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Anthem/AM11/ProductCarouselMain/AM11%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am11_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#2b314f",
      "sort_bucket": "blue",
      "sort_hue": 0.638889,
      "sort_sat": 0.455696,
      "sort_val": 0.309804,
      "swatch_file_id": "gid://shopify/MediaImage/49474343239946",
      "swatch_filename": "AM10_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Navy.jpg?v=1774371250",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Navy.jpg?v=1774371250",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548395786",
      "product_title": "Anthem Unisex Organic Heavyweight T-Shirt",
      "product_handle": "am15",
      "product_url": "/products/am15",
      "product_full_url": "https://oakdenemerch.com/products/am15",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am15",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM15",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#2b314f",
      "sort_bucket": "blue",
      "sort_hue": 0.638889,
      "sort_sat": 0.455696,
      "sort_val": 0.309804,
      "swatch_file_id": "gid://shopify/MediaImage/49472895713546",
      "swatch_filename": "AM15_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Navy.jpg?v=1774360325",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Navy.jpg?v=1774360325",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM15/ProductCarouselMain/AM15%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am15_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548363018",
      "product_title": "Anthem Unisex Organic Midweight T-Shirt",
      "product_handle": "am12",
      "product_url": "/products/am12",
      "product_full_url": "https://oakdenemerch.com/products/am12",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am12",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM12",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#2b314f",
      "sort_bucket": "blue",
      "sort_hue": 0.638889,
      "sort_sat": 0.455696,
      "sort_val": 0.309804,
      "swatch_file_id": "gid://shopify/MediaImage/49472902791434",
      "swatch_filename": "AM12_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Navy.jpg?v=1774360382",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Navy.jpg?v=1774360382",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM12/ProductCarouselMain/AM12%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am12_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Ultramarine",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#0219ae",
      "sort_bucket": "blue",
      "sort_hue": 0.64438,
      "sort_sat": 0.988506,
      "sort_val": 0.682353,
      "swatch_file_id": "gid://shopify/MediaImage/49474448818442",
      "swatch_filename": "11500_Ultramarine.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Ultramarine.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Ultramarine.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20ULM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Ultramarine.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686049034",
      "product_title": "SOL'S Monarch Long Sleeve T-Shirt",
      "product_handle": "11420",
      "product_url": "/products/11420",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11420",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "11420",
      "colour_name": "Ultramarine",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#0219ae",
      "sort_bucket": "blue",
      "sort_hue": 0.64438,
      "sort_sat": 0.988506,
      "sort_val": 0.682353,
      "swatch_file_id": "gid://shopify/MediaImage/49490371608842",
      "swatch_filename": "11420_Ultramarine.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Ultramarine.jpg?v=1774522752",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Ultramarine.jpg?v=1774522752",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11420/ProductCarouselMain/11420%20ULM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11420_Ultramarine.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Oxford Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000635",
      "sort_bucket": "blue",
      "sort_hue": 0.647799,
      "sort_sat": 1.0,
      "sort_val": 0.207843,
      "swatch_file_id": "gid://shopify/MediaImage/49474217771274",
      "swatch_filename": "JC001_Oxford_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Oxford_Navy.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Oxford_Navy.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20OXN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Oxford_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Oxford Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000635",
      "sort_bucket": "blue",
      "sort_hue": 0.647799,
      "sort_sat": 1.0,
      "sort_val": 0.207843,
      "swatch_file_id": "gid://shopify/MediaImage/49474210103562",
      "swatch_filename": "JC001B_Oxford_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Oxford_Navy.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Oxford_Navy.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20OXN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Oxford_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Oxford Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000635",
      "sort_bucket": "blue",
      "sort_hue": 0.647799,
      "sort_sat": 1.0,
      "sort_val": 0.207843,
      "swatch_file_id": "gid://shopify/MediaImage/49473142620426",
      "swatch_filename": "JC005_Oxford_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Oxford_Navy.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Oxford_Navy.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20OXN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Oxford_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556981002",
      "product_title": "Tee Jays CoolDry™ T-Shirt",
      "product_handle": "t7020",
      "product_url": "/products/t7020",
      "product_full_url": "https://oakdenemerch.com/products/t7020",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t7020",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7020",
      "colour_name": "Navy Melange",
      "colour_group": "Blue > Heather/Effect Blue",
      "rgb": "#000a5c",
      "sort_bucket": "blue",
      "sort_hue": 0.648551,
      "sort_sat": 1.0,
      "sort_val": 0.360784,
      "swatch_file_id": "gid://shopify/MediaImage/49469011820810",
      "swatch_filename": "T7020_Navy_Melange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_Navy_Melange.jpg?v=1774315920",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_Navy_Melange.jpg?v=1774315920",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7020/ProductCarouselMain/T7020%20NME%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7020_Navy_Melange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557079306",
      "product_title": "Tee Jays Ladies CoolDry™ T-Shirt",
      "product_handle": "t7021",
      "product_url": "/products/t7021",
      "product_full_url": "https://oakdenemerch.com/products/t7021",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-t7021",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7021",
      "colour_name": "Navy Melange",
      "colour_group": "Blue > Heather/Effect Blue",
      "rgb": "#000a5c",
      "sort_bucket": "blue",
      "sort_hue": 0.648551,
      "sort_sat": 1.0,
      "sort_val": 0.360784,
      "swatch_file_id": "gid://shopify/MediaImage/49471676449034",
      "swatch_filename": "T7021_Navy_Melange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_Navy_Melange.jpg?v=1774350799",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_Navy_Melange.jpg?v=1774350799",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7021/ProductCarouselMain/T7021%20NME%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7021_Navy_Melange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688736010",
      "product_title": "Tee Jays Long Sleeve CoolDry™ T-Shirt",
      "product_handle": "t7022",
      "product_url": "/products/t7022",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-t7022",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7022",
      "colour_name": "Navy Melange",
      "colour_group": "Blue > Heather/Effect Blue",
      "rgb": "#000a5c",
      "sort_bucket": "blue",
      "sort_hue": 0.648551,
      "sort_sat": 1.0,
      "sort_val": 0.360784,
      "swatch_file_id": "gid://shopify/MediaImage/49490492621066",
      "swatch_filename": "t7022_Navy_Melange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t7022_Navy_Melange.jpg?v=1774523119",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t7022_Navy_Melange.jpg?v=1774523119",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7022/ProductCarouselMain/T7022%20NME%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7022_Navy_Melange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Cobalt",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#000894",
      "sort_bucket": "blue",
      "sort_hue": 0.657658,
      "sort_sat": 1.0,
      "sort_val": 0.580392,
      "swatch_file_id": "gid://shopify/MediaImage/49471286149386",
      "swatch_filename": "SS621_Cobalt.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Cobalt.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Cobalt.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20COB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Cobalt.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Cobalt",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#0005ff",
      "sort_bucket": "blue",
      "sort_hue": 0.663399,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471386124554",
      "swatch_filename": "GD05_Cobalt.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Cobalt.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Cobalt.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20COB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Cobalt.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Violet",
      "colour_group": "Purple > Light Purple",
      "rgb": "#73a1ff",
      "sort_bucket": "purple",
      "sort_hue": 0.611905,
      "sort_sat": 0.54902,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471385731338",
      "swatch_filename": "GD05_Violet.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Violet.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Violet.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20VIO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Violet.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549837578",
      "product_title": "Gildan Ladies SoftStyle® Midweight T-Shirt",
      "product_handle": "gd92",
      "product_url": "/products/gd92",
      "product_full_url": "https://oakdenemerch.com/products/gd92",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd92",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD92",
      "colour_name": "Violet",
      "colour_group": "Purple > Light Purple",
      "rgb": "#73a1ff",
      "sort_bucket": "purple",
      "sort_hue": 0.611905,
      "sort_sat": 0.54902,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468942123274",
      "swatch_filename": "GD92_Violet.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD92_Violet.jpg?v=1774314177",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD92_Violet.jpg?v=1774314177",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD92/ProductCarouselMain/GD92%20VIO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd92_Violet.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Violet",
      "colour_group": "Purple > Light Purple",
      "rgb": "#73a1ff",
      "sort_bucket": "purple",
      "sort_hue": 0.611905,
      "sort_sat": 0.54902,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471368659210",
      "swatch_filename": "GD15_Violet.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Violet.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Violet.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20VIO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Violet.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Dusty Lilac",
      "colour_group": "Purple > Light Purple",
      "rgb": "#6b7292",
      "sort_bucket": "purple",
      "sort_hue": 0.636752,
      "sort_sat": 0.267123,
      "sort_val": 0.572549,
      "swatch_file_id": "gid://shopify/MediaImage/49471442911498",
      "swatch_filename": "AT001_Dusty_Lilac.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Dusty_Lilac.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Dusty_Lilac.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20DUL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Dusty_Lilac.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Dusty Lilac",
      "colour_group": "Purple > Light Purple",
      "rgb": "#6b7292",
      "sort_bucket": "purple",
      "sort_hue": 0.636752,
      "sort_sat": 0.267123,
      "sort_val": 0.572549,
      "swatch_file_id": "gid://shopify/MediaImage/49471429640458",
      "swatch_filename": "AT002_Dusty_Lilac.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Dusty_Lilac.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Dusty_Lilac.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20DUL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Dusty_Lilac.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550820618",
      "product_title": "AWDis Unisex Oversize 100 T-Shirt",
      "product_handle": "jt009",
      "product_url": "/products/jt009",
      "product_full_url": "https://oakdenemerch.com/products/jt009",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jt009",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.*",
      "style_code": "JT009",
      "colour_name": "Dusty Lilac",
      "colour_group": "Purple > Light Purple",
      "rgb": "#6b7292",
      "sort_bucket": "purple",
      "sort_hue": 0.636752,
      "sort_sat": 0.267123,
      "sort_val": 0.572549,
      "swatch_file_id": "gid://shopify/MediaImage/49471817941258",
      "swatch_filename": "JT009_Dusty_Lilac.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_Dusty_Lilac.jpg?v=1774351553",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_Dusty_Lilac.jpg?v=1774351553",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT009/ProductCarouselMain/JT009%20DUL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt009_Dusty_Lilac.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Parma",
      "colour_group": "Purple > Light Purple",
      "rgb": "#b8bdf0",
      "sort_bucket": "purple",
      "sort_hue": 0.651786,
      "sort_sat": 0.233333,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49473666580746",
      "swatch_filename": "NS305_Parma.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Parma.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Parma.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20PRM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Parma.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Soft Lavender",
      "colour_group": "Purple > Light Purple",
      "rgb": "#bfc2ff",
      "sort_bucket": "purple",
      "sort_hue": 0.658854,
      "sort_sat": 0.25098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471285264650",
      "swatch_filename": "SS621_Soft_Lavender.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Soft_Lavender.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Soft_Lavender.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20SFL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Soft_Lavender.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Soft Lavender",
      "colour_group": "Purple > Light Purple",
      "rgb": "#bfc2ff",
      "sort_bucket": "purple",
      "sort_hue": 0.658854,
      "sort_sat": 0.25098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471313707274",
      "swatch_filename": "SS620_Soft_Lavender.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Soft_Lavender.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Soft_Lavender.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20SFL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Soft_Lavender.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554621706",
      "product_title": "Fruit of the Loom Ladies Iconic 150 T-Shirt",
      "product_handle": "ss721",
      "product_url": "/products/ss721",
      "product_full_url": "https://oakdenemerch.com/products/ss721",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss721",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS721",
      "colour_name": "Soft Lavender",
      "colour_group": "Purple > Light Purple",
      "rgb": "#bfc2ff",
      "sort_bucket": "purple",
      "sort_hue": 0.658854,
      "sort_sat": 0.25098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472056656138",
      "swatch_filename": "SS721_Soft_Lavender.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Soft_Lavender.jpg?v=1774353579",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Soft_Lavender.jpg?v=1774353579",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS721/ProductCarouselMain/SS721%20SFL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss721_Soft_Lavender.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS720",
      "colour_name": "Soft Lavender",
      "colour_group": "Purple > Light Purple",
      "rgb": "#bfc2ff",
      "sort_bucket": "purple",
      "sort_hue": 0.658854,
      "sort_sat": 0.25098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472219021578",
      "swatch_filename": "SS720_Soft_Lavender.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Soft_Lavender.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Soft_Lavender.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20SFL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_Soft_Lavender.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#1a1c95",
      "sort_bucket": "purple",
      "sort_hue": 0.663957,
      "sort_sat": 0.825503,
      "sort_val": 0.584314,
      "swatch_file_id": "gid://shopify/MediaImage/49471385305354",
      "swatch_filename": "GD05_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Purple.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Purple.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549772042",
      "product_title": "Gildan Ladies SoftStyle® T-Shirt",
      "product_handle": "gd72",
      "product_url": "/products/gd72",
      "product_full_url": "https://oakdenemerch.com/products/gd72",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd72",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD72",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#1a1c95",
      "sort_bucket": "purple",
      "sort_hue": 0.663957,
      "sort_sat": 0.825503,
      "sort_val": 0.584314,
      "swatch_file_id": "gid://shopify/MediaImage/49468940386570",
      "swatch_filename": "GD72_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Purple.jpg?v=1774314002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Purple.jpg?v=1774314002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD72/ProductCarouselMain/GD72%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd72_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#1a1c95",
      "sort_bucket": "purple",
      "sort_hue": 0.663957,
      "sort_sat": 0.825503,
      "sort_val": 0.584314,
      "swatch_file_id": "gid://shopify/MediaImage/49474268037386",
      "swatch_filename": "GD01_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Purple.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Purple.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#1a1c95",
      "sort_bucket": "purple",
      "sort_hue": 0.663957,
      "sort_sat": 0.825503,
      "sort_val": 0.584314,
      "swatch_file_id": "gid://shopify/MediaImage/49471398412554",
      "swatch_filename": "GD02_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Purple.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Purple.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#000093",
      "sort_bucket": "purple",
      "sort_hue": 0.666667,
      "sort_sat": 1.0,
      "sort_val": 0.576471,
      "swatch_file_id": "gid://shopify/MediaImage/49474088534282",
      "swatch_filename": "RX151_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Purple.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Purple.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Dark Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#3029c4",
      "sort_bucket": "purple",
      "sort_hue": 0.674194,
      "sort_sat": 0.790816,
      "sort_val": 0.768627,
      "swatch_file_id": "gid://shopify/MediaImage/49474448621834",
      "swatch_filename": "11500_Dark_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Dark_Purple.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Dark_Purple.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20DKP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Dark_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Dark Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#3029c4",
      "sort_bucket": "purple",
      "sort_hue": 0.674194,
      "sort_sat": 0.790816,
      "sort_val": 0.768627,
      "swatch_file_id": "gid://shopify/MediaImage/49468933538058",
      "swatch_filename": "11502_Dark_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Dark_Purple.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Dark_Purple.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20DKP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Dark_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Dark Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#3029c4",
      "sort_bucket": "purple",
      "sort_hue": 0.674194,
      "sort_sat": 0.790816,
      "sort_val": 0.768627,
      "swatch_file_id": "gid://shopify/MediaImage/49468822814986",
      "swatch_filename": "01825_Dark_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Dark_Purple.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Dark_Purple.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20DKP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Dark_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Dark Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#3029c4",
      "sort_bucket": "purple",
      "sort_hue": 0.674194,
      "sort_sat": 0.790816,
      "sort_val": 0.768627,
      "swatch_file_id": "gid://shopify/MediaImage/49473719402762",
      "swatch_filename": "11380_Dark_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Dark_Purple.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Dark_Purple.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20DKP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Dark_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548166410",
      "product_title": "SOL'S Sporty Performance T-Shirt",
      "product_handle": "11939",
      "product_url": "/products/11939",
      "product_full_url": "https://oakdenemerch.com/products/11939",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-11939",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "11939",
      "colour_name": "Dark Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#3029c4",
      "sort_bucket": "purple",
      "sort_hue": 0.674194,
      "sort_sat": 0.790816,
      "sort_val": 0.768627,
      "swatch_file_id": "gid://shopify/MediaImage/49473692500234",
      "swatch_filename": "11939_Dark_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Dark_Purple.jpg?v=1774364865",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Dark_Purple.jpg?v=1774364865",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11939/ProductCarouselMain/11939%20DKP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11939_Dark_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550361866",
      "product_title": "AWDis Cool Smooth T-Shirt",
      "product_handle": "jc020",
      "product_url": "/products/jc020",
      "product_full_url": "https://oakdenemerch.com/products/jc020",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-jc020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020",
      "colour_name": "Digital Lavender",
      "colour_group": "Purple > Light Purple",
      "rgb": "#7870f5",
      "sort_bucket": "purple",
      "sort_hue": 0.676692,
      "sort_sat": 0.542857,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49472871268618",
      "swatch_filename": "JC020_Digital_Lavender.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Digital_Lavender.jpg?v=1774359995",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Digital_Lavender.jpg?v=1774359995",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020/ProductCarouselMain/JC020%20DTL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020_Digital_Lavender.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Digital Lavender",
      "colour_group": "Purple > Light Purple",
      "rgb": "#7870f5",
      "sort_bucket": "purple",
      "sort_hue": 0.676692,
      "sort_sat": 0.542857,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49474217967882",
      "swatch_filename": "JC001_Digital_Lavender.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Digital_Lavender.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Digital_Lavender.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20DTL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Digital_Lavender.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Digital Lavender",
      "colour_group": "Purple > Light Purple",
      "rgb": "#7870f5",
      "sort_bucket": "purple",
      "sort_hue": 0.676692,
      "sort_sat": 0.542857,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49474210758922",
      "swatch_filename": "JC001B_Digital_Lavender.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Digital_Lavender.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Digital_Lavender.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20DTL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Digital_Lavender.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550230794",
      "product_title": "AWDis Ladies Cool Open Back T-Shirt",
      "product_handle": "jc013",
      "product_url": "/products/jc013",
      "product_full_url": "https://oakdenemerch.com/products/jc013",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-jc013",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC013",
      "colour_name": "Digital Lavender",
      "colour_group": "Purple > Light Purple",
      "rgb": "#7870f5",
      "sort_bucket": "purple",
      "sort_hue": 0.676692,
      "sort_sat": 0.542857,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49474194997514",
      "swatch_filename": "JC013_Digital_Lavender.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC013_Digital_Lavender.jpg?v=1774370210",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC013_Digital_Lavender.jpg?v=1774370210",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC013/ProductCarouselMain/JC013%20DTL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc013_Digital_Lavender.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550624010",
      "product_title": "AWDis Ladies Cool Recycled Tech Sports Bra",
      "product_handle": "jc217",
      "product_url": "/products/jc217",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "performance-activewear",
        "recycled",
        "S",
        "sports",
        "style-jc217",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "80% recycled polyester/20% elastane.",
      "style_code": "JC217",
      "colour_name": "Digital Lavender",
      "colour_group": "Purple > Light Purple",
      "rgb": "#7870f5",
      "sort_bucket": "purple",
      "sort_hue": 0.676692,
      "sort_sat": 0.542857,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49491397542154",
      "swatch_filename": "jc217_Digital_Lavender.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc217_Digital_Lavender.jpg?v=1774526701",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc217_Digital_Lavender.jpg?v=1774526701",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC217/ProductCarouselMain/JC217%20DTL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc217_Digital_Lavender.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Digital Lavender",
      "colour_group": "Purple > Light Purple",
      "rgb": "#7870f5",
      "sort_bucket": "purple",
      "sort_hue": 0.676692,
      "sort_sat": 0.542857,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49473142292746",
      "swatch_filename": "JC005_Digital_Lavender.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Digital_Lavender.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Digital_Lavender.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20DTL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Digital_Lavender.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#3e3c5c",
      "sort_bucket": "purple",
      "sort_hue": 0.677083,
      "sort_sat": 0.347826,
      "sort_val": 0.360784,
      "swatch_file_id": "gid://shopify/MediaImage/49474342748426",
      "swatch_filename": "AM10_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Purple.jpg?v=1774371249",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Purple.jpg?v=1774371249",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548363018",
      "product_title": "Anthem Unisex Organic Midweight T-Shirt",
      "product_handle": "am12",
      "product_url": "/products/am12",
      "product_full_url": "https://oakdenemerch.com/products/am12",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am12",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM12",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#3e3c5c",
      "sort_bucket": "purple",
      "sort_hue": 0.677083,
      "sort_sat": 0.347826,
      "sort_val": 0.360784,
      "swatch_file_id": "gid://shopify/MediaImage/49472902594826",
      "swatch_filename": "AM12_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Purple.jpg?v=1774360382",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Purple.jpg?v=1774360382",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM12/ProductCarouselMain/AM12%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am12_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "52% cotton/48% polyester.",
      "style_code": "SS621",
      "colour_name": "Heather Purple",
      "colour_group": "Purple > Heather/Effect Purple",
      "rgb": "#484299",
      "sort_bucket": "purple",
      "sort_hue": 0.678161,
      "sort_sat": 0.568627,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49471286116618",
      "swatch_filename": "SS621_Heather_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Heather_Purple.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Heather_Purple.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20HPR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Heather_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "SS6",
      "colour_name": "Heather Purple",
      "colour_group": "Purple > Heather/Effect Purple",
      "rgb": "#484299",
      "sort_bucket": "purple",
      "sort_hue": 0.678161,
      "sort_sat": 0.568627,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49471322226954",
      "swatch_filename": "SS6_Heather_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Heather_Purple.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Heather_Purple.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20HPR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Heather_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Team Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#3b2db7",
      "sort_bucket": "purple",
      "sort_hue": 0.683575,
      "sort_sat": 0.754098,
      "sort_val": 0.717647,
      "swatch_file_id": "gid://shopify/MediaImage/49473259110666",
      "swatch_filename": "CV3001_Team_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Team_Purple.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Team_Purple.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Team_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#1500ce",
      "sort_bucket": "purple",
      "sort_hue": 0.683657,
      "sort_sat": 1.0,
      "sort_val": 0.807843,
      "swatch_file_id": "gid://shopify/MediaImage/49471330156810",
      "swatch_filename": "SS12_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Purple.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Purple.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#1500ce",
      "sort_bucket": "purple",
      "sort_hue": 0.683657,
      "sort_sat": 1.0,
      "sort_val": 0.807843,
      "swatch_file_id": "gid://shopify/MediaImage/49471321932042",
      "swatch_filename": "SS6_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Purple.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Purple.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Lavender",
      "colour_group": "Purple > Light Purple",
      "rgb": "#a399f7",
      "sort_bucket": "purple",
      "sort_hue": 0.684397,
      "sort_sat": 0.380567,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49474343305482",
      "swatch_filename": "AM10_Lavender.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Lavender.jpg?v=1774371250",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Lavender.jpg?v=1774371250",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20LAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Lavender.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548395786",
      "product_title": "Anthem Unisex Organic Heavyweight T-Shirt",
      "product_handle": "am15",
      "product_url": "/products/am15",
      "product_full_url": "https://oakdenemerch.com/products/am15",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am15",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM15",
      "colour_name": "Lavender",
      "colour_group": "Purple > Light Purple",
      "rgb": "#a399f7",
      "sort_bucket": "purple",
      "sort_hue": 0.684397,
      "sort_sat": 0.380567,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49472895844618",
      "swatch_filename": "AM15_Lavender.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Lavender.jpg?v=1774360325",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Lavender.jpg?v=1774360325",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM15/ProductCarouselMain/AM15%20LAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am15_Lavender.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548363018",
      "product_title": "Anthem Unisex Organic Midweight T-Shirt",
      "product_handle": "am12",
      "product_url": "/products/am12",
      "product_full_url": "https://oakdenemerch.com/products/am12",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am12",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM12",
      "colour_name": "Lavender",
      "colour_group": "Purple > Light Purple",
      "rgb": "#a399f7",
      "sort_bucket": "purple",
      "sort_hue": 0.684397,
      "sort_sat": 0.380567,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49472902824202",
      "swatch_filename": "AM12_Lavender.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Lavender.jpg?v=1774360382",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Lavender.jpg?v=1774360382",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM12/ProductCarouselMain/AM12%20LAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am12_Lavender.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "Purple",
      "colour_group": "Purple",
      "rgb": "#160098",
      "sort_bucket": "purple",
      "sort_hue": 0.690789,
      "sort_sat": 1.0,
      "sort_val": 0.596078,
      "swatch_file_id": "gid://shopify/MediaImage/49473273364746",
      "swatch_filename": "180M_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Purple.jpg?v=1774363124",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Purple.jpg?v=1774363124",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548199178",
      "product_title": "Russell Athletic Kids Classic Ringspun T-Shirt",
      "product_handle": "180b",
      "product_url": "/products/180b",
      "product_full_url": "https://oakdenemerch.com/products/180b",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "PCBest_Seller",
        "performance-activewear",
        "sports",
        "style-180b",
        "t-shirts"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.",
      "style_code": "180B",
      "colour_name": "Purple",
      "colour_group": "Purple",
      "rgb": "#160098",
      "sort_bucket": "purple",
      "sort_hue": 0.690789,
      "sort_sat": 1.0,
      "sort_val": 0.596078,
      "swatch_file_id": "gid://shopify/MediaImage/49474443542794",
      "swatch_filename": "180B_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_Purple.jpg?v=1774371757",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180B_Purple.jpg?v=1774371757",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180B/ProductCarouselMain/180B%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180b_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#2402e0",
      "sort_bucket": "purple",
      "sort_hue": 0.692192,
      "sort_sat": 0.991071,
      "sort_val": 0.878431,
      "swatch_file_id": "gid://shopify/MediaImage/49471442780426",
      "swatch_filename": "AT001_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Purple.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Purple.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#2402e0",
      "sort_bucket": "purple",
      "sort_hue": 0.692192,
      "sort_sat": 0.991071,
      "sort_val": 0.878431,
      "swatch_file_id": "gid://shopify/MediaImage/49471430263050",
      "swatch_filename": "AT002_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Purple.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Purple.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Orchid",
      "colour_group": "Purple > Light Purple",
      "rgb": "#c2b5ff",
      "sort_bucket": "purple",
      "sort_hue": 0.695946,
      "sort_sat": 0.290196,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471398576394",
      "swatch_filename": "GD02_Orchid.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Orchid.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Orchid.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20ORC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Orchid.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#2500c3",
      "sort_bucket": "purple",
      "sort_hue": 0.698291,
      "sort_sat": 1.0,
      "sort_val": 0.764706,
      "swatch_file_id": "gid://shopify/MediaImage/49473588232458",
      "swatch_filename": "SR287_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Purple.jpg?v=1774364345",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Purple.jpg?v=1774364345",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687228682",
      "product_title": "AWDis Cool Long Sleeve Wicking T-Shirt",
      "product_handle": "jc002",
      "product_url": "/products/jc002",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jc002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC002",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#2504b1",
      "sort_bucket": "purple",
      "sort_hue": 0.698459,
      "sort_sat": 0.977401,
      "sort_val": 0.694118,
      "swatch_file_id": "gid://shopify/MediaImage/49490477285642",
      "swatch_filename": "jc002_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Purple.jpg?v=1774522895",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc002_Purple.jpg?v=1774522895",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC002/ProductCarouselMain/JC002%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc002_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550361866",
      "product_title": "AWDis Cool Smooth T-Shirt",
      "product_handle": "jc020",
      "product_url": "/products/jc020",
      "product_full_url": "https://oakdenemerch.com/products/jc020",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-jc020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC020",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#2504b1",
      "sort_bucket": "purple",
      "sort_hue": 0.698459,
      "sort_sat": 0.977401,
      "sort_val": 0.694118,
      "swatch_file_id": "gid://shopify/MediaImage/49472871760138",
      "swatch_filename": "JC020_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Purple.jpg?v=1774359994",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC020_Purple.jpg?v=1774359994",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC020/ProductCarouselMain/JC020%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc020_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#2504b1",
      "sort_bucket": "purple",
      "sort_hue": 0.698459,
      "sort_sat": 0.977401,
      "sort_val": 0.694118,
      "swatch_file_id": "gid://shopify/MediaImage/49474218590474",
      "swatch_filename": "JC001_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Purple.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Purple.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#2504b1",
      "sort_bucket": "purple",
      "sort_hue": 0.698459,
      "sort_sat": 0.977401,
      "sort_val": 0.694118,
      "swatch_file_id": "gid://shopify/MediaImage/49474210300170",
      "swatch_filename": "JC001B_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Purple.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Purple.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#2504b1",
      "sort_bucket": "purple",
      "sort_hue": 0.698459,
      "sort_sat": 0.977401,
      "sort_val": 0.694118,
      "swatch_file_id": "gid://shopify/MediaImage/49473142096138",
      "swatch_filename": "JC005_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Purple.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Purple.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562101514",
      "product_title": "AWDis Ladies Cool Vest",
      "product_handle": "jc015",
      "product_url": "/products/jc015",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc015",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC015",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#2504b1",
      "sort_bucket": "purple",
      "sort_hue": 0.698459,
      "sort_sat": 0.977401,
      "sort_val": 0.694118,
      "swatch_file_id": "gid://shopify/MediaImage/49513928032522",
      "swatch_filename": "jc015_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Purple.jpg?v=1774619010",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Purple.jpg?v=1774619010",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC015/ProductCarouselMain/JC015%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc015_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547379978",
      "product_title": "SOL'S Boxy Oversized Organic T-Shirt",
      "product_handle": "03806",
      "product_url": "/products/03806",
      "product_full_url": "https://oakdenemerch.com/products/03806",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL",
        "style-03806",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "03806",
      "colour_name": "Lilac",
      "colour_group": "Purple > Light Purple",
      "rgb": "#d1c4e8",
      "sort_bucket": "purple",
      "sort_hue": 0.726852,
      "sort_sat": 0.155172,
      "sort_val": 0.909804,
      "swatch_file_id": "gid://shopify/MediaImage/49471864504586",
      "swatch_filename": "03806_Lilac.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03806_Lilac.jpg?v=1774352127",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03806_Lilac.jpg?v=1774352127",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03806/ProductCarouselMain/03806%20LIL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03806_Lilac.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547412746",
      "product_title": "SOL'S Ladies Boxy Oversized Organic T-Shirt",
      "product_handle": "03807",
      "product_url": "/products/03807",
      "product_full_url": "https://oakdenemerch.com/products/03807",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03807",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "03807",
      "colour_name": "Lilac",
      "colour_group": "Purple > Light Purple",
      "rgb": "#d1c4e8",
      "sort_bucket": "purple",
      "sort_hue": 0.726852,
      "sort_sat": 0.155172,
      "sort_val": 0.909804,
      "swatch_file_id": "gid://shopify/MediaImage/49474463596810",
      "swatch_filename": "03807_Lilac.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03807_Lilac.jpg?v=1774372092",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03807_Lilac.jpg?v=1774372092",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03807/ProductCarouselMain/03807%20LIL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03807_Lilac.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Lilac",
      "colour_group": "Purple > Light Purple",
      "rgb": "#d1c4e8",
      "sort_bucket": "purple",
      "sort_hue": 0.726852,
      "sort_sat": 0.155172,
      "sort_val": 0.909804,
      "swatch_file_id": "gid://shopify/MediaImage/49473744797962",
      "swatch_filename": "03981_Lilac.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Lilac.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Lilac.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20LIL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Lilac.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD05",
      "colour_name": "Lilac",
      "colour_group": "Purple > Light Purple",
      "rgb": "#563d82",
      "sort_bucket": "purple",
      "sort_hue": 0.727053,
      "sort_sat": 0.530769,
      "sort_val": 0.509804,
      "swatch_file_id": "gid://shopify/MediaImage/49471385633034",
      "swatch_filename": "GD05_Lilac.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Lilac.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Lilac.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20LIL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Lilac.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Fan Dark Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#392852",
      "sort_bucket": "purple",
      "sort_hue": 0.734127,
      "sort_sat": 0.512195,
      "sort_val": 0.321569,
      "swatch_file_id": "gid://shopify/MediaImage/49471385469194",
      "swatch_filename": "GD05_Fan_Dark_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Fan_Dark_Purple.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Fan_Dark_Purple.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20FDKP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Fan_Dark_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Fan Dark Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#392852",
      "sort_bucket": "purple",
      "sort_hue": 0.734127,
      "sort_sat": 0.512195,
      "sort_val": 0.321569,
      "swatch_file_id": "gid://shopify/MediaImage/49474267513098",
      "swatch_filename": "GD01_Fan_Dark_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Fan_Dark_Purple.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Fan_Dark_Purple.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20FDKP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Fan_Dark_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686966538",
      "product_title": "Gildan SoftStyle® Long Sleeve T-Shirt",
      "product_handle": "gd11",
      "product_url": "/products/gd11",
      "product_full_url": "https://oakdenemerch.com/products/gd11",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd11",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD11",
      "colour_name": "Fan Dark Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#392852",
      "sort_bucket": "purple",
      "sort_hue": 0.734127,
      "sort_sat": 0.512195,
      "sort_val": 0.321569,
      "swatch_file_id": "gid://shopify/MediaImage/49490448220426",
      "swatch_filename": "gd11_Fan_Dark_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Fan_Dark_Purple.jpg?v=1774522836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Fan_Dark_Purple.jpg?v=1774522836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD11/ProductCarouselMain/GD11%20FDKP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd11_Fan_Dark_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Astral Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#481376",
      "sort_bucket": "purple",
      "sort_hue": 0.755892,
      "sort_sat": 0.838983,
      "sort_val": 0.462745,
      "swatch_file_id": "gid://shopify/MediaImage/49474468806922",
      "swatch_filename": "03582_Astral_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Astral_Purple.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Astral_Purple.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20APUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Astral_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Astral Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#481376",
      "sort_bucket": "purple",
      "sort_hue": 0.755892,
      "sort_sat": 0.838983,
      "sort_val": 0.462745,
      "swatch_file_id": "gid://shopify/MediaImage/49468836020490",
      "swatch_filename": "03581_Astral_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Astral_Purple.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Astral_Purple.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20APUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Astral_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Astral Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#481376",
      "sort_bucket": "purple",
      "sort_hue": 0.755892,
      "sort_sat": 0.838983,
      "sort_val": 0.462745,
      "swatch_file_id": "gid://shopify/MediaImage/49473744961802",
      "swatch_filename": "03981_Astral_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Astral_Purple.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Astral_Purple.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20APUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Astral_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Light Purple",
      "colour_group": "Purple > Light Purple",
      "rgb": "#74489a",
      "sort_bucket": "purple",
      "sort_hue": 0.756098,
      "sort_sat": 0.532468,
      "sort_val": 0.603922,
      "swatch_file_id": "gid://shopify/MediaImage/49474448949514",
      "swatch_filename": "11500_Light_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Light_Purple.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Light_Purple.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20LTP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Light_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Light Purple",
      "colour_group": "Purple > Light Purple",
      "rgb": "#74489a",
      "sort_bucket": "purple",
      "sort_hue": 0.756098,
      "sort_sat": 0.532468,
      "sort_val": 0.603922,
      "swatch_file_id": "gid://shopify/MediaImage/49473719501066",
      "swatch_filename": "11380_Light_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Light_Purple.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Light_Purple.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20LTP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Light_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Plum",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#25073c",
      "sort_bucket": "purple",
      "sort_hue": 0.761006,
      "sort_sat": 0.883333,
      "sort_val": 0.235294,
      "swatch_file_id": "gid://shopify/MediaImage/49474217607434",
      "swatch_filename": "JC001_Plum.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Plum.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Plum.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20PLU%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Plum.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Dark Plum",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#4a3241",
      "sort_bucket": "purple",
      "sort_hue": 0.895833,
      "sort_sat": 0.324324,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49471313740042",
      "swatch_filename": "SS620_Dark_Plum.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Dark_Plum.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Dark_Plum.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20DRP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Dark_Plum.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS720",
      "colour_name": "Dark Plum",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#4a3241",
      "sort_bucket": "purple",
      "sort_hue": 0.895833,
      "sort_sat": 0.324324,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49472218956042",
      "swatch_filename": "SS720_Dark_Plum.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Dark_Plum.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Dark_Plum.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20DRP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_Dark_Plum.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554457866",
      "product_title": "Fruit of the Loom Pure Cotton T-Shirt",
      "product_handle": "ss640",
      "product_url": "/products/ss640",
      "product_full_url": "https://oakdenemerch.com/products/ss640",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss640",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "SS640",
      "colour_name": "Dark Plum",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#4a3241",
      "sort_bucket": "purple",
      "sort_hue": 0.895833,
      "sort_sat": 0.324324,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49468957524234",
      "swatch_filename": "SS640_Dark_Plum.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Dark_Plum.jpg?v=1774315114",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Dark_Plum.jpg?v=1774315114",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS640/ProductCarouselMain/SS640%20DRP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss640_Dark_Plum.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558193418",
      "product_title": "Tombo Medium Impact Core Bra",
      "product_handle": "tl371",
      "product_url": "/products/tl371",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-tl371",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "86% polyester/14% elastane interlock.",
      "style_code": "TL371",
      "colour_name": "Hot Coral",
      "colour_group": "Pink > Coral",
      "rgb": "#ff4f4f",
      "sort_bucket": "pink",
      "sort_hue": 0.0,
      "sort_sat": 0.690196,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491010781450",
      "swatch_filename": "tl371_Hot_Coral.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl371_Hot_Coral.jpg?v=1774525774",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl371_Hot_Coral.jpg?v=1774525774",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Tombo/TL371/ProductCarouselMain/TL371%20HCL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl371_Hot_Coral.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Magenta Magic",
      "colour_group": "Purple > Light Purple",
      "rgb": "#7d36ff",
      "sort_bucket": "pink",
      "sort_hue": 0.725539,
      "sort_sat": 0.788235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474217410826",
      "swatch_filename": "JC001_Magenta_Magic.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Magenta_Magic.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Magenta_Magic.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20MMG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Magenta_Magic.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Magenta Magic",
      "colour_group": "Purple > Light Purple",
      "rgb": "#7d36ff",
      "sort_bucket": "pink",
      "sort_hue": 0.725539,
      "sort_sat": 0.788235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474210234634",
      "swatch_filename": "JC001B_Magenta_Magic.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Magenta_Magic.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Magenta_Magic.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20MMG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Magenta_Magic.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Magenta Magic",
      "colour_group": "Purple > Light Purple",
      "rgb": "#7d36ff",
      "sort_bucket": "pink",
      "sort_hue": 0.725539,
      "sort_sat": 0.788235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473142685962",
      "swatch_filename": "JC005_Magenta_Magic.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Magenta_Magic.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Magenta_Magic.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20MMG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Magenta_Magic.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562789642",
      "product_title": "SF Clothing Ladies Sustainable Fashion Cropped Cami Vest Top",
      "product_handle": "sk230",
      "product_url": "/products/sk230",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-sk230",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly/Elastane",
      "shopify_material": "Cotton/Poly/Elastane",
      "csv_material": "48% regenerated cotton/47% recycled polyester/5% elastane.",
      "style_code": "SK230",
      "colour_name": "Dusky Pink",
      "colour_group": "Pink",
      "rgb": "#aa5ccd",
      "sort_bucket": "pink",
      "sort_hue": 0.781711,
      "sort_sat": 0.55122,
      "sort_val": 0.803922,
      "swatch_file_id": "gid://shopify/MediaImage/49513935372554",
      "swatch_filename": "sk230_Dusky_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk230_Dusky_Pink.jpg?v=1774619121",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk230_Dusky_Pink.jpg?v=1774619121",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SF%20Clothing/SK230/ProductCarouselMain/SK230%20DPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk230_Dusky_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Cherry Purple",
      "colour_group": "Pink > Dark Pink",
      "rgb": "#650072",
      "sort_bucket": "pink",
      "sort_hue": 0.814327,
      "sort_sat": 1.0,
      "sort_val": 0.447059,
      "swatch_file_id": "gid://shopify/MediaImage/49473666777354",
      "swatch_filename": "NS305_Cherry_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Cherry_Purple.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Cherry_Purple.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20CPR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Cherry_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Hyper Pink",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff12ff",
      "sort_bucket": "pink",
      "sort_hue": 0.833333,
      "sort_sat": 0.929412,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474218033418",
      "swatch_filename": "JC001_Hyper_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Hyper_Pink.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Hyper_Pink.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20HYP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Hyper_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Hyper Pink",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff12ff",
      "sort_bucket": "pink",
      "sort_hue": 0.833333,
      "sort_sat": 0.929412,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474210169098",
      "swatch_filename": "JC001B_Hyper_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Hyper_Pink.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Hyper_Pink.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20HYP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Hyper_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Hyper Pink",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff12ff",
      "sort_bucket": "pink",
      "sort_hue": 0.833333,
      "sort_sat": 0.929412,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473142358282",
      "swatch_filename": "JC005_Hyper_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Hyper_Pink.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Hyper_Pink.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20HYP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Hyper_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562887946",
      "product_title": "SF Clothing Ladies Fashion Workout Vest",
      "product_handle": "sk241",
      "product_url": "/products/sk241",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-sk241",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "90% polyester/10% elastane.",
      "style_code": "SK241",
      "colour_name": "Neon Pink",
      "colour_group": "Fluro/Neon > Pink",
      "rgb": "#ff29ff",
      "sort_bucket": "pink",
      "sort_hue": 0.833333,
      "sort_sat": 0.839216,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513936388362",
      "swatch_filename": "sk241_Neon_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk241_Neon_Pink.jpg?v=1774619134",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk241_Neon_Pink.jpg?v=1774619134",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SF%20Clothing/SK241/ProductCarouselMain/SK241%20NPI%20FRONT.png",
      "match_source": "title/style + filename",
      "expected_filename": "sk241_Neon_Pink.png"
    },
    {
      "product_id": "gid://shopify/Product/10455553409290",
      "product_title": "SF Clothing Ladies Workout Crop Top",
      "product_handle": "sk235",
      "product_url": "/products/sk235",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "S",
        "S-M-L",
        "style-sk235",
        "t-shirts",
        "womens"
      ],
      "material": "Nylon/Elastane",
      "shopify_material": "Nylon/Elastane",
      "csv_material": "92% nylon/8% elastane.",
      "style_code": "SK235",
      "colour_name": "Neon Pink",
      "colour_group": "Fluro/Neon > Pink",
      "rgb": "#ff29ff",
      "sort_bucket": "pink",
      "sort_hue": 0.833333,
      "sort_sat": 0.839216,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491300221194",
      "swatch_filename": "sk235_Neon_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk235_Neon_Pink.jpg?v=1774526455",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk235_Neon_Pink.jpg?v=1774526455",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SF%20Clothing/SK235/ProductCarouselMain/SK235%20NPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk235_Neon_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Electric Pink",
      "colour_group": "Pink > Fluro/Neon Pink",
      "rgb": "#ff47ff",
      "sort_bucket": "pink",
      "sort_hue": 0.833333,
      "sort_sat": 0.721569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474217902346",
      "swatch_filename": "JC001_Electric_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Electric_Pink.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Electric_Pink.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20EPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Electric_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562003210",
      "product_title": "AWDis Cool Vest",
      "product_handle": "jc007",
      "product_url": "/products/jc007",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc007",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007",
      "colour_name": "Electric Pink",
      "colour_group": "Pink > Fluro/Neon Pink",
      "rgb": "#ff47ff",
      "sort_bucket": "pink",
      "sort_hue": 0.833333,
      "sort_sat": 0.721569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513924296970",
      "swatch_filename": "jc007_Electric_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Electric_Pink.jpg?v=1774618982",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Electric_Pink.jpg?v=1774618982",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC007/ProductCarouselMain/JC007%20EPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007_Electric_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Electric Pink",
      "colour_group": "Pink > Fluro/Neon Pink",
      "rgb": "#ff47ff",
      "sort_bucket": "pink",
      "sort_hue": 0.833333,
      "sort_sat": 0.721569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474209906954",
      "swatch_filename": "JC001B_Electric_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Electric_Pink.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Electric_Pink.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20EPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Electric_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550329098",
      "product_title": "AWDis Ladies Cool Sports Crop Top",
      "product_handle": "jc017",
      "product_url": "/products/jc017",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-jc017",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XXS",
        "XXS-XS-S-M-L-XL"
      ],
      "material": "Nylon/Elastane",
      "shopify_material": "Nylon/Elastane",
      "csv_material": "90% nylon/10% elastane.",
      "style_code": "JC017",
      "colour_name": "Electric Pink",
      "colour_group": "Pink > Fluro/Neon Pink",
      "rgb": "#ff47ff",
      "sort_bucket": "pink",
      "sort_hue": 0.833333,
      "sort_sat": 0.721569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491401212170",
      "swatch_filename": "jc017_Electric_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc017_Electric_Pink.jpg?v=1774526712",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc017_Electric_Pink.jpg?v=1774526712",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC017/ProductCarouselMain/JC017%20EPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc017_Electric_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Electric Pink",
      "colour_group": "Pink > Fluro/Neon Pink",
      "rgb": "#ff47ff",
      "sort_bucket": "pink",
      "sort_hue": 0.833333,
      "sort_sat": 0.721569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473142325514",
      "swatch_filename": "JC005_Electric_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Electric_Pink.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Electric_Pink.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20EPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Electric_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562101514",
      "product_title": "AWDis Ladies Cool Vest",
      "product_handle": "jc015",
      "product_url": "/products/jc015",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc015",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC015",
      "colour_name": "Electric Pink",
      "colour_group": "Pink > Fluro/Neon Pink",
      "rgb": "#ff47ff",
      "sort_bucket": "pink",
      "sort_hue": 0.833333,
      "sort_sat": 0.721569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513928098058",
      "swatch_filename": "jc015_Electric_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Electric_Pink.jpg?v=1774619012",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Electric_Pink.jpg?v=1774619012",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC015/ProductCarouselMain/JC015%20EPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc015_Electric_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Soft Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#fad1fa",
      "sort_bucket": "pink",
      "sort_hue": 0.833333,
      "sort_sat": 0.164,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49473259471114",
      "swatch_filename": "CV3001_Soft_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Soft_Pink.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Soft_Pink.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20SOP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Soft_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Baby Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#ffb3fa",
      "sort_bucket": "pink",
      "sort_hue": 0.844298,
      "sort_sat": 0.298039,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471442321674",
      "swatch_filename": "AT001_Baby_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Baby_Pink.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Baby_Pink.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20BPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Baby_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Baby Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#ffb3fa",
      "sort_bucket": "pink",
      "sort_hue": 0.844298,
      "sort_sat": 0.298039,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471429705994",
      "swatch_filename": "AT002_Baby_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Baby_Pink.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Baby_Pink.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20BPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Baby_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Orchid Pink",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#ff75f5",
      "sort_bucket": "pink",
      "sort_hue": 0.845411,
      "sort_sat": 0.541176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474449408266",
      "swatch_filename": "11500_Orchid_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Orchid_Pink.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Orchid_Pink.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20ORC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Orchid_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Orchid Pink",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#ff75f5",
      "sort_bucket": "pink",
      "sort_hue": 0.845411,
      "sort_sat": 0.541176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468933603594",
      "swatch_filename": "11502_Orchid_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Orchid_Pink.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Orchid_Pink.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20ORC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Orchid_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548035338",
      "product_title": "SOL'S Ladies Moon V Neck T-Shirt",
      "product_handle": "11388",
      "product_url": "/products/11388",
      "product_full_url": "https://oakdenemerch.com/products/11388",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11388",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11388",
      "colour_name": "Orchid Pink",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#ff75f5",
      "sort_bucket": "pink",
      "sort_hue": 0.845411,
      "sort_sat": 0.541176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468932325642",
      "swatch_filename": "11388_Orchid_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_Orchid_Pink.jpg?v=1774312856",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_Orchid_Pink.jpg?v=1774312856",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11388/ProductCarouselMain/11388%20ORC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11388_Orchid_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Orchid Pink",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#ff75f5",
      "sort_bucket": "pink",
      "sort_hue": 0.845411,
      "sort_sat": 0.541176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468822880522",
      "swatch_filename": "01825_Orchid_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Orchid_Pink.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Orchid_Pink.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20ORC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Orchid_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Orchid Pink",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#ff75f5",
      "sort_bucket": "pink",
      "sort_hue": 0.845411,
      "sort_sat": 0.541176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473718419722",
      "swatch_filename": "11380_Orchid_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Orchid_Pink.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Orchid_Pink.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20ORC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Orchid_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Azalea",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#ff54f2",
      "sort_bucket": "pink",
      "sort_hue": 0.846004,
      "sort_sat": 0.670588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471385895178",
      "swatch_filename": "GD05_Azalea.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Azalea.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Azalea.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20AZA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Azalea.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549903114",
      "product_title": "Gildan Ladies Heavy Cotton™ T-Shirt",
      "product_handle": "gd95",
      "product_url": "/products/gd95",
      "product_full_url": "https://oakdenemerch.com/products/gd95",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd95",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD95",
      "colour_name": "Azalea",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#ff54f2",
      "sort_bucket": "pink",
      "sort_hue": 0.846004,
      "sort_sat": 0.670588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468944253194",
      "swatch_filename": "GD95_Azalea.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD95_Azalea.jpg?v=1774314277",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD95_Azalea.jpg?v=1774314277",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD95/ProductCarouselMain/GD95%20AZA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd95_Azalea.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549772042",
      "product_title": "Gildan Ladies SoftStyle® T-Shirt",
      "product_handle": "gd72",
      "product_url": "/products/gd72",
      "product_full_url": "https://oakdenemerch.com/products/gd72",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd72",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD72",
      "colour_name": "Azalea",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#ff54f2",
      "sort_bucket": "pink",
      "sort_hue": 0.846004,
      "sort_sat": 0.670588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468940255498",
      "swatch_filename": "GD72_Azalea.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Azalea.jpg?v=1774314002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Azalea.jpg?v=1774314002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD72/ProductCarouselMain/GD72%20AZA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd72_Azalea.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561970442",
      "product_title": "Gildan Ladies SoftStyle® Tank Top",
      "product_handle": "gd77",
      "product_url": "/products/gd77",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd77",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.",
      "style_code": "GD77",
      "colour_name": "Azalea",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#ff54f2",
      "sort_bucket": "pink",
      "sort_hue": 0.846004,
      "sort_sat": 0.670588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49513921216778",
      "swatch_filename": "gd77_Azalea.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd77_Azalea.jpg?v=1774618956",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd77_Azalea.jpg?v=1774618956",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD77/ProductCarouselMain/GD77%20AZA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd77_Azalea.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549804810",
      "product_title": "Gildan Ladies SoftStyle® V Neck T-Shirt",
      "product_handle": "gd78",
      "product_url": "/products/gd78",
      "product_full_url": "https://oakdenemerch.com/products/gd78",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd78",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD78",
      "colour_name": "Azalea",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#ff54f2",
      "sort_bucket": "pink",
      "sort_hue": 0.846004,
      "sort_sat": 0.670588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471832686858",
      "swatch_filename": "GD78_Azalea.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD78_Azalea.jpg?v=1774351724",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD78_Azalea.jpg?v=1774351724",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD78/ProductCarouselMain/GD78%20AZA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd78_Azalea.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Azalea",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#ff54f2",
      "sort_bucket": "pink",
      "sort_hue": 0.846004,
      "sort_sat": 0.670588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474267971850",
      "swatch_filename": "GD01_Azalea.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Azalea.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Azalea.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20AZA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Azalea.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Azalea",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#ff54f2",
      "sort_bucket": "pink",
      "sort_hue": 0.846004,
      "sort_sat": 0.670588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471397888266",
      "swatch_filename": "GD02_Azalea.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Azalea.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Azalea.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20AZA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Azalea.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Light Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#fcc5f7",
      "sort_bucket": "pink",
      "sort_hue": 0.848485,
      "sort_sat": 0.218254,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49471386026250",
      "swatch_filename": "GD05_Light_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Light_Pink.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Light_Pink.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20LPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Light_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549509898",
      "product_title": "Gildan Heavy Cotton™ Toddler T-Shirt",
      "product_handle": "gd05p",
      "product_url": "/products/gd05p",
      "product_full_url": "https://oakdenemerch.com/products/gd05p",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "2T",
        "2T-3T-4T-5T-6T",
        "3T",
        "4T",
        "5T",
        "6T",
        "baby-toddler",
        "style-gd05p",
        "t-shirts",
        "unisex"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05P",
      "colour_name": "Light Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#fcc5f7",
      "sort_bucket": "pink",
      "sort_hue": 0.848485,
      "sort_sat": 0.218254,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49474248704266",
      "swatch_filename": "GD05P_Light_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05P_Light_Pink.jpg?v=1774370725",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05P_Light_Pink.jpg?v=1774370725",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05P/ProductCarouselMain/GD05P%20LPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05p_Light_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549903114",
      "product_title": "Gildan Ladies Heavy Cotton™ T-Shirt",
      "product_handle": "gd95",
      "product_url": "/products/gd95",
      "product_full_url": "https://oakdenemerch.com/products/gd95",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd95",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD95",
      "colour_name": "Light Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#fcc5f7",
      "sort_bucket": "pink",
      "sort_hue": 0.848485,
      "sort_sat": 0.218254,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49468944351498",
      "swatch_filename": "GD95_Light_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD95_Light_Pink.jpg?v=1774314277",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD95_Light_Pink.jpg?v=1774314277",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD95/ProductCarouselMain/GD95%20LPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd95_Light_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Light Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#fcc5f7",
      "sort_bucket": "pink",
      "sort_hue": 0.848485,
      "sort_sat": 0.218254,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49474267873546",
      "swatch_filename": "GD01_Light_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Light_Pink.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Light_Pink.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20LPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Light_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD14",
      "colour_name": "Light Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#fcc5f7",
      "sort_bucket": "pink",
      "sort_hue": 0.848485,
      "sort_sat": 0.218254,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49490464702730",
      "swatch_filename": "gd14_Light_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Light_Pink.jpg?v=1774522862",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Light_Pink.jpg?v=1774522862",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20LPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Light_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Light Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#fcc5f7",
      "sort_bucket": "pink",
      "sort_hue": 0.848485,
      "sort_sat": 0.218254,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49471398379786",
      "swatch_filename": "GD02_Light_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Light_Pink.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Light_Pink.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20LPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Light_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546757386",
      "product_title": "SOL'S Ladies Sporty Performance T-Shirt",
      "product_handle": "01159",
      "product_url": "/products/01159",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-01159",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "01159",
      "colour_name": "Neon Pink",
      "colour_group": "Pink > Fluro/Neon Pink",
      "rgb": "#fa3ee1",
      "sort_bucket": "pink",
      "sort_hue": 0.855496,
      "sort_sat": 0.752,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49491518292234",
      "swatch_filename": "01159_Neon_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01159_Neon_Pink.jpg?v=1774526879",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01159_Neon_Pink.jpg?v=1774526879",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01159/ProductCarouselMain/01159%20NPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01159_Neon_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561642762",
      "product_title": "SOL'S Ladies Sporty Performance Tank Top",
      "product_handle": "02117",
      "product_url": "/products/02117",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-02117",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02117",
      "colour_name": "Neon Pink",
      "colour_group": "Pink > Fluro/Neon Pink",
      "rgb": "#fa3ee1",
      "sort_bucket": "pink",
      "sort_hue": 0.855496,
      "sort_sat": 0.752,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49513912697098",
      "swatch_filename": "02117_Neon_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02117_Neon_Pink.jpg?v=1774618869",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02117_Neon_Pink.jpg?v=1774618869",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02117/ProductCarouselMain/02117%20NPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02117_Neon_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548166410",
      "product_title": "SOL'S Sporty Performance T-Shirt",
      "product_handle": "11939",
      "product_url": "/products/11939",
      "product_full_url": "https://oakdenemerch.com/products/11939",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-11939",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "11939",
      "colour_name": "Neon Pink",
      "colour_group": "Pink > Fluro/Neon Pink",
      "rgb": "#fa3ee1",
      "sort_bucket": "pink",
      "sort_hue": 0.855496,
      "sort_sat": 0.752,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49473692696842",
      "swatch_filename": "11939_Neon_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Neon_Pink.jpg?v=1774364865",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11939_Neon_Pink.jpg?v=1774364865",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11939/ProductCarouselMain/11939%20NPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11939_Neon_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561609994",
      "product_title": "SOL'S Sporty Performance Tank Top",
      "product_handle": "02073",
      "product_url": "/products/02073",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL",
        "sports",
        "style-02073",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "02073",
      "colour_name": "Neon Pink",
      "colour_group": "Pink > Fluro/Neon Pink",
      "rgb": "#fa3ee1",
      "sort_bucket": "pink",
      "sort_hue": 0.855496,
      "sort_sat": 0.752,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49513910763786",
      "swatch_filename": "02073_Neon_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02073_Neon_Pink.jpg?v=1774618856",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02073_Neon_Pink.jpg?v=1774618856",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02073/ProductCarouselMain/02073%20NPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02073_Neon_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#cb0ab1",
      "sort_bucket": "pink",
      "sort_hue": 0.855786,
      "sort_sat": 0.950739,
      "sort_val": 0.796078,
      "swatch_file_id": "gid://shopify/MediaImage/49474088435978",
      "swatch_filename": "RX151_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Fuchsia.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Fuchsia.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554654474",
      "product_title": "Fruit of the Loom Lady Fit Value T-Shirt",
      "product_handle": "ss77",
      "product_url": "/products/ss77",
      "product_full_url": "https://oakdenemerch.com/products/ss77",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss77",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS77",
      "colour_name": "Light Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#ffa8f2",
      "sort_bucket": "pink",
      "sort_hue": 0.858238,
      "sort_sat": 0.341176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472025821450",
      "swatch_filename": "SS77_Light_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Light_Pink.jpg?v=1774353471",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Light_Pink.jpg?v=1774353471",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS77/ProductCarouselMain/SS77%20LPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss77_Light_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Light Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#ffa8f2",
      "sort_bucket": "pink",
      "sort_hue": 0.858238,
      "sort_sat": 0.341176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471321866506",
      "swatch_filename": "SS6_Light_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Light_Pink.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Light_Pink.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20LPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Light_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Heliconia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff14d1",
      "sort_bucket": "pink",
      "sort_hue": 0.865957,
      "sort_sat": 0.921569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471384715530",
      "swatch_filename": "GD05_Heliconia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Heliconia.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Heliconia.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20HEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Heliconia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549837578",
      "product_title": "Gildan Ladies SoftStyle® Midweight T-Shirt",
      "product_handle": "gd92",
      "product_url": "/products/gd92",
      "product_full_url": "https://oakdenemerch.com/products/gd92",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd92",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD92",
      "colour_name": "Heliconia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff14d1",
      "sort_bucket": "pink",
      "sort_hue": 0.865957,
      "sort_sat": 0.921569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468942090506",
      "swatch_filename": "GD92_Heliconia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD92_Heliconia.jpg?v=1774314177",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD92_Heliconia.jpg?v=1774314177",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD92/ProductCarouselMain/GD92%20HEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd92_Heliconia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Heliconia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff14d1",
      "sort_bucket": "pink",
      "sort_hue": 0.865957,
      "sort_sat": 0.921569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474268201226",
      "swatch_filename": "GD01_Heliconia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Heliconia.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Heliconia.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20HEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Heliconia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Heliconia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff14d1",
      "sort_bucket": "pink",
      "sort_hue": 0.865957,
      "sort_sat": 0.921569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471368691978",
      "swatch_filename": "GD15_Heliconia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Heliconia.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Heliconia.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20HEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Heliconia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Heliconia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff14d1",
      "sort_bucket": "pink",
      "sort_hue": 0.865957,
      "sort_sat": 0.921569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471398478090",
      "swatch_filename": "GD02_Heliconia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Heliconia.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Heliconia.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20HEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Heliconia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Hot Pink",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#f500ba",
      "sort_bucket": "pink",
      "sort_hue": 0.873469,
      "sort_sat": 1.0,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49474217935114",
      "swatch_filename": "JC001_Hot_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Hot_Pink.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Hot_Pink.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20HPK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Hot_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562003210",
      "product_title": "AWDis Cool Vest",
      "product_handle": "jc007",
      "product_url": "/products/jc007",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc007",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC007",
      "colour_name": "Hot Pink",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#f500ba",
      "sort_bucket": "pink",
      "sort_hue": 0.873469,
      "sort_sat": 1.0,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49513924526346",
      "swatch_filename": "jc007_Hot_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Hot_Pink.jpg?v=1774618983",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc007_Hot_Pink.jpg?v=1774618983",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Just%20Cool/JC007/ProductCarouselMain/JC007%20HPK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc007_Hot_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Hot Pink",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#f500ba",
      "sort_bucket": "pink",
      "sort_hue": 0.873469,
      "sort_sat": 1.0,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49474210365706",
      "swatch_filename": "JC001B_Hot_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Hot_Pink.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Hot_Pink.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20HPK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Hot_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Hot Pink",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#f500ba",
      "sort_bucket": "pink",
      "sort_hue": 0.873469,
      "sort_sat": 1.0,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49473142423818",
      "swatch_filename": "JC005_Hot_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Hot_Pink.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Hot_Pink.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20HPK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Hot_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562101514",
      "product_title": "AWDis Ladies Cool Vest",
      "product_handle": "jc015",
      "product_url": "/products/jc015",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "sleeveless",
        "style-jc015",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC015",
      "colour_name": "Hot Pink",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#f500ba",
      "sort_bucket": "pink",
      "sort_hue": 0.873469,
      "sort_sat": 1.0,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49513928163594",
      "swatch_filename": "jc015_Hot_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Hot_Pink.jpg?v=1774619013",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc015_Hot_Pink.jpg?v=1774619013",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC015/ProductCarouselMain/JC015%20HPK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc015_Hot_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Hot Pink",
      "colour_group": "Pink > Dark Pink",
      "rgb": "#f500ba",
      "sort_bucket": "pink",
      "sort_hue": 0.873469,
      "sort_sat": 1.0,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49471442747658",
      "swatch_filename": "AT001_Hot_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Hot_Pink.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Hot_Pink.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20HPK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Hot_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Hot Pink",
      "colour_group": "Pink > Dark Pink",
      "rgb": "#f500ba",
      "sort_bucket": "pink",
      "sort_hue": 0.873469,
      "sort_sat": 1.0,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49471430131978",
      "swatch_filename": "AT002_Hot_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Hot_Pink.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Hot_Pink.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20HPK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Hot_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549411594",
      "product_title": "Gildan SoftStyle® EZ T-Shirt",
      "product_handle": "gd04",
      "product_url": "/products/gd04",
      "product_full_url": "https://oakdenemerch.com/products/gd04",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd04",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "GD04",
      "colour_name": "Charity Pink",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#ff9ce6",
      "sort_bucket": "pink",
      "sort_hue": 0.875421,
      "sort_sat": 0.388235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468937240842",
      "swatch_filename": "GD04_Charity_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Charity_Pink.jpg?v=1774313523",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Charity_Pink.jpg?v=1774313523",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD04/ProductCarouselMain/GD04%20CPK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd04_Charity_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Baby Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#ffb0eb",
      "sort_bucket": "pink",
      "sort_hue": 0.875527,
      "sort_sat": 0.309804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474218524938",
      "swatch_filename": "JC001_Baby_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Baby_Pink.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Baby_Pink.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20BPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Baby_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff1fc2",
      "sort_bucket": "pink",
      "sort_hue": 0.87872,
      "sort_sat": 0.878431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471313051914",
      "swatch_filename": "SS620_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Fuchsia.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Fuchsia.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554621706",
      "product_title": "Fruit of the Loom Ladies Iconic 150 T-Shirt",
      "product_handle": "ss721",
      "product_url": "/products/ss721",
      "product_full_url": "https://oakdenemerch.com/products/ss721",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss721",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS721",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff1fc2",
      "sort_bucket": "pink",
      "sort_hue": 0.87872,
      "sort_sat": 0.878431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472056590602",
      "swatch_filename": "SS721_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Fuchsia.jpg?v=1774353579",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Fuchsia.jpg?v=1774353579",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS721/ProductCarouselMain/SS721%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss721_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS720",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff1fc2",
      "sort_bucket": "pink",
      "sort_hue": 0.87872,
      "sort_sat": 0.878431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472219152650",
      "swatch_filename": "SS720_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Fuchsia.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Fuchsia.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554556170",
      "product_title": "Fruit of the Loom Lady Fit Original T-Shirt",
      "product_handle": "ss712",
      "product_url": "/products/ss712",
      "product_full_url": "https://oakdenemerch.com/products/ss712",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss712",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS712",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff1fc2",
      "sort_bucket": "pink",
      "sort_hue": 0.87872,
      "sort_sat": 0.878431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472223117578",
      "swatch_filename": "SS712_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS712_Fuchsia.jpg?v=1774353741",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS712_Fuchsia.jpg?v=1774353741",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS712/ProductCarouselMain/SS712%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss712_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554654474",
      "product_title": "Fruit of the Loom Lady Fit Value T-Shirt",
      "product_handle": "ss77",
      "product_url": "/products/ss77",
      "product_full_url": "https://oakdenemerch.com/products/ss77",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss77",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS77",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff1fc2",
      "sort_bucket": "pink",
      "sort_hue": 0.87872,
      "sort_sat": 0.878431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472025952522",
      "swatch_filename": "SS77_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Fuchsia.jpg?v=1774353471",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Fuchsia.jpg?v=1774353471",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS77/ProductCarouselMain/SS77%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss77_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS12",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff1fc2",
      "sort_bucket": "pink",
      "sort_hue": 0.87872,
      "sort_sat": 0.878431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471330615562",
      "swatch_filename": "SS12_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Fuchsia.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Fuchsia.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff1fc2",
      "sort_bucket": "pink",
      "sort_hue": 0.87872,
      "sort_sat": 0.878431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471321669898",
      "swatch_filename": "SS6_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Fuchsia.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Fuchsia.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff00b8",
      "sort_bucket": "pink",
      "sort_hue": 0.879739,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474468479242",
      "swatch_filename": "03582_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Fuchsia.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Fuchsia.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff00b8",
      "sort_bucket": "pink",
      "sort_hue": 0.879739,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474448720138",
      "swatch_filename": "11500_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Fuchsia.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Fuchsia.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff00b8",
      "sort_bucket": "pink",
      "sort_hue": 0.879739,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468835791114",
      "swatch_filename": "03581_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Fuchsia.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Fuchsia.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff00b8",
      "sort_bucket": "pink",
      "sort_hue": 0.879739,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468933570826",
      "swatch_filename": "11502_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Fuchsia.jpg?v=1774313008",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Fuchsia.jpg?v=1774313008",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548035338",
      "product_title": "SOL'S Ladies Moon V Neck T-Shirt",
      "product_handle": "11388",
      "product_url": "/products/11388",
      "product_full_url": "https://oakdenemerch.com/products/11388",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11388",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11388",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff00b8",
      "sort_bucket": "pink",
      "sort_hue": 0.879739,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468932555018",
      "swatch_filename": "11388_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_Fuchsia.jpg?v=1774312856",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_Fuchsia.jpg?v=1774312856",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11388/ProductCarouselMain/11388%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11388_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff00b8",
      "sort_bucket": "pink",
      "sort_hue": 0.879739,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468833169674",
      "swatch_filename": "03579_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Fuchsia.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Fuchsia.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff00b8",
      "sort_bucket": "pink",
      "sort_hue": 0.879739,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468823470346",
      "swatch_filename": "01825_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Fuchsia.jpg?v=1774311910",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Fuchsia.jpg?v=1774311910",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff00b8",
      "sort_bucket": "pink",
      "sort_hue": 0.879739,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473718124810",
      "swatch_filename": "11380_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Fuchsia.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Fuchsia.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552557322",
      "product_title": "Proact Ladies Performance T-Shirt",
      "product_handle": "pa439",
      "product_url": "/products/pa439",
      "product_full_url": "https://oakdenemerch.com/products/pa439",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa439",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA439",
      "colour_name": "Fluorescent Pink",
      "colour_group": "Pink > Fluro/Neon Pink",
      "rgb": "#ff40c9",
      "sort_bucket": "pink",
      "sort_hue": 0.880454,
      "sort_sat": 0.74902,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471736971530",
      "swatch_filename": "PA439_Fluorescent_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Fluorescent_Pink.jpg?v=1774351220",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Fluorescent_Pink.jpg?v=1774351220",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA439/ProductCarouselMain/PA439%20FLP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa439_Fluorescent_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552295178",
      "product_title": "Native Spirit Ladies T-Shirt",
      "product_handle": "ns324",
      "product_url": "/products/ns324",
      "product_full_url": "https://oakdenemerch.com/products/ns324",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns324",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS324",
      "colour_name": "Raspberry Sorbet",
      "colour_group": "Pink > Dark Pink",
      "rgb": "#d9089c",
      "sort_bucket": "pink",
      "sort_hue": 0.881978,
      "sort_sat": 0.963134,
      "sort_val": 0.85098,
      "swatch_file_id": "gid://shopify/MediaImage/49472283279626",
      "swatch_filename": "NS324_Raspberry_Sorbet.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Raspberry_Sorbet.jpg?v=1774354240",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Raspberry_Sorbet.jpg?v=1774354240",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS324/ProductCarouselMain/NS324%20RSB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns324_Raspberry_Sorbet.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Antique Rose",
      "colour_group": "Pink > Dark Pink",
      "rgb": "#a14a87",
      "sort_bucket": "pink",
      "sort_hue": 0.883142,
      "sort_sat": 0.540373,
      "sort_val": 0.631373,
      "swatch_file_id": "gid://shopify/MediaImage/49473667268874",
      "swatch_filename": "NS305_Antique_Rose.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Antique_Rose.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Antique_Rose.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20ARS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Antique_Rose.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552360714",
      "product_title": "Native Spirit Unisex Oversized T-Shirt",
      "product_handle": "ns330",
      "product_url": "/products/ns330",
      "product_full_url": "https://oakdenemerch.com/products/ns330",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-ns330",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS330",
      "colour_name": "Antique Rose",
      "colour_group": "Pink > Dark Pink",
      "rgb": "#a14a87",
      "sort_bucket": "pink",
      "sort_hue": 0.883142,
      "sort_sat": 0.540373,
      "sort_val": 0.631373,
      "swatch_file_id": "gid://shopify/MediaImage/49473635123466",
      "swatch_filename": "NS330_Antique_Rose.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS330_Antique_Rose.jpg?v=1774364536",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS330_Antique_Rose.jpg?v=1774364536",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS330/ProductCarouselMain/NS330%20ARS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns330_Antique_Rose.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Pink",
      "colour_group": "Fluro/Neon > Pink",
      "rgb": "#ffc4ed",
      "sort_bucket": "pink",
      "sort_hue": 0.884181,
      "sort_sat": 0.231373,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473259602186",
      "swatch_filename": "CV3001_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Pink.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Pink.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20PIN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "Flo Pink",
      "colour_group": "Pink > Fluro/Neon Pink",
      "rgb": "#ff1ab3",
      "sort_bucket": "pink",
      "sort_hue": 0.888646,
      "sort_sat": 0.898039,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473588166922",
      "swatch_filename": "SR287_Flo_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Flo_Pink.jpg?v=1774364344",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Flo_Pink.jpg?v=1774364344",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20FLP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_Flo_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Candy Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#ff96db",
      "sort_bucket": "pink",
      "sort_hue": 0.890476,
      "sort_sat": 0.411765,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49474449604874",
      "swatch_filename": "11500_Candy_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Candy_Pink.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Candy_Pink.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20CNP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Candy_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Candy Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#ff96db",
      "sort_bucket": "pink",
      "sort_hue": 0.890476,
      "sort_sat": 0.411765,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49468933996810",
      "swatch_filename": "11502_Candy_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Candy_Pink.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Candy_Pink.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20CNP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Candy_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547642122",
      "product_title": "SOL'S Ladies Legend T-Shirt",
      "product_handle": "04776",
      "product_url": "/products/04776",
      "product_full_url": "https://oakdenemerch.com/products/04776",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-04776",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "04776",
      "colour_name": "Candy Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#ff96db",
      "sort_bucket": "pink",
      "sort_hue": 0.890476,
      "sort_sat": 0.411765,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472963510538",
      "swatch_filename": "04776_Candy_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Candy_Pink.jpg?v=1774360489",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Candy_Pink.jpg?v=1774360489",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04776/ProductCarouselMain/04776%20CNP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04776_Candy_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547609354",
      "product_title": "SOL'S Ladies Regent V Neck T-Shirt",
      "product_handle": "04766",
      "product_url": "/products/04766",
      "product_full_url": "https://oakdenemerch.com/products/04766",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "S",
        "style-04766",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "04766",
      "colour_name": "Candy Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#ff96db",
      "sort_bucket": "pink",
      "sort_hue": 0.890476,
      "sort_sat": 0.411765,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49472664699146",
      "swatch_filename": "04766_Candy_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04766_Candy_Pink.jpg?v=1774358605",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04766_Candy_Pink.jpg?v=1774358605",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04766/ProductCarouselMain/04766%20CNP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04766_Candy_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Candy Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#ff96db",
      "sort_bucket": "pink",
      "sort_hue": 0.890476,
      "sort_sat": 0.411765,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473744634122",
      "swatch_filename": "03981_Candy_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Candy_Pink.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Candy_Pink.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20CNP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Candy_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Dusty Pink",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#ce6ead",
      "sort_bucket": "pink",
      "sort_hue": 0.890625,
      "sort_sat": 0.466019,
      "sort_val": 0.807843,
      "swatch_file_id": "gid://shopify/MediaImage/49474218918154",
      "swatch_filename": "JC001_Dusty_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Dusty_Pink.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Dusty_Pink.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20DYP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Dusty_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687425290",
      "product_title": "AWDis Ladies Long Sleeve Cropped T-Shirt",
      "product_handle": "jt016",
      "product_url": "/products/jt016",
      "product_full_url": "None",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-jt016",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Poly/Viscose",
      "shopify_material": "Poly/Viscose",
      "csv_material": "50% polyester/25% viscose/25% cotton.*",
      "style_code": "JT016",
      "colour_name": "Dusty Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#ce6ead",
      "sort_bucket": "pink",
      "sort_hue": 0.890625,
      "sort_sat": 0.466019,
      "sort_val": 0.807843,
      "swatch_file_id": "gid://shopify/MediaImage/49490479055114",
      "swatch_filename": "jt016_Dusty_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jt016_Dusty_Pink.jpg?v=1774522922",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jt016_Dusty_Pink.jpg?v=1774522922",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT016/ProductCarouselMain/JT016%20DYP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt016_Dusty_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Ancient Pink",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#82446c",
      "sort_bucket": "pink",
      "sort_hue": 0.892473,
      "sort_sat": 0.476923,
      "sort_val": 0.509804,
      "swatch_file_id": "gid://shopify/MediaImage/49474448195850",
      "swatch_filename": "11500_Ancient_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Ancient_Pink.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Ancient_Pink.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20ANP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Ancient_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553966346",
      "product_title": "Spiro Impact Performance Aircool T-Shirt",
      "product_handle": "sr287",
      "product_url": "/products/sr287",
      "product_full_url": "https://oakdenemerch.com/products/sr287",
      "vendor": "Spiro",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-sr287",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% textured polyester.",
      "style_code": "SR287",
      "colour_name": "Super Pink",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#e6279a",
      "sort_bucket": "pink",
      "sort_hue": 0.899651,
      "sort_sat": 0.830435,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49473587314954",
      "swatch_filename": "SR287_Super_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Super_Pink.jpg?v=1774364345",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SR287_Super_Pink.jpg?v=1774364345",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR287/ProductCarouselMain/SR287%20SRP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr287_Super_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547642122",
      "product_title": "SOL'S Ladies Legend T-Shirt",
      "product_handle": "04776",
      "product_url": "/products/04776",
      "product_full_url": "https://oakdenemerch.com/products/04776",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-04776",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "04776",
      "colour_name": "Folk Pink",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#d44995",
      "sort_bucket": "pink",
      "sort_hue": 0.908873,
      "sort_sat": 0.65566,
      "sort_val": 0.831373,
      "swatch_file_id": "gid://shopify/MediaImage/49472963346698",
      "swatch_filename": "04776_Folk_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Folk_Pink.jpg?v=1774360489",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Folk_Pink.jpg?v=1774360489",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04776/ProductCarouselMain/04776%20FKP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04776_Folk_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Folk Pink",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#d44995",
      "sort_bucket": "pink",
      "sort_hue": 0.908873,
      "sort_sat": 0.65566,
      "sort_val": 0.831373,
      "swatch_file_id": "gid://shopify/MediaImage/49473719238922",
      "swatch_filename": "11380_Folk_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Folk_Pink.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Folk_Pink.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20FKP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Folk_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Folk Pink",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#d44995",
      "sort_bucket": "pink",
      "sort_hue": 0.908873,
      "sort_sat": 0.65566,
      "sort_val": 0.831373,
      "swatch_file_id": "gid://shopify/MediaImage/49473744339210",
      "swatch_filename": "03981_Folk_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Folk_Pink.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Folk_Pink.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20FKP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Folk_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Folk Red",
      "colour_group": "Pink > Dark Pink",
      "rgb": "#86104a",
      "sort_bucket": "pink",
      "sort_hue": 0.918079,
      "sort_sat": 0.880597,
      "sort_val": 0.52549,
      "swatch_file_id": "gid://shopify/MediaImage/49474449375498",
      "swatch_filename": "11500_Folk_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Folk_Red.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Folk_Red.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20FKR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Folk_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Folk Red",
      "colour_group": "Pink > Dark Pink",
      "rgb": "#86104a",
      "sort_bucket": "pink",
      "sort_hue": 0.918079,
      "sort_sat": 0.880597,
      "sort_val": 0.52549,
      "swatch_file_id": "gid://shopify/MediaImage/49473745027338",
      "swatch_filename": "03981_Folk_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Folk_Red.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Folk_Red.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20FKR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Folk_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Hot Pink",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#cc4385",
      "sort_bucket": "pink",
      "sort_hue": 0.919708,
      "sort_sat": 0.671569,
      "sort_val": 0.8,
      "swatch_file_id": "gid://shopify/MediaImage/49474343108874",
      "swatch_filename": "AM10_Hot_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Hot_Pink.jpg?v=1774371249",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Hot_Pink.jpg?v=1774371249",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20HPK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Hot_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548363018",
      "product_title": "Anthem Unisex Organic Midweight T-Shirt",
      "product_handle": "am12",
      "product_url": "/products/am12",
      "product_full_url": "https://oakdenemerch.com/products/am12",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am12",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM12",
      "colour_name": "Hot Pink",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#cc4385",
      "sort_bucket": "pink",
      "sort_hue": 0.919708,
      "sort_sat": 0.671569,
      "sort_val": 0.8,
      "swatch_file_id": "gid://shopify/MediaImage/49472902627594",
      "swatch_filename": "AM12_Hot_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Hot_Pink.jpg?v=1774360382",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Hot_Pink.jpg?v=1774360382",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM12/ProductCarouselMain/AM12%20HPK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am12_Hot_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Powder Rose",
      "colour_group": "Pink > Light Pink",
      "rgb": "#e3bdcf",
      "sort_bucket": "pink",
      "sort_hue": 0.921053,
      "sort_sat": 0.167401,
      "sort_val": 0.890196,
      "swatch_file_id": "gid://shopify/MediaImage/49471285723402",
      "swatch_filename": "SS621_Powder_Rose.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Powder_Rose.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Powder_Rose.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20PWR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Powder_Rose.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Powder Rose",
      "colour_group": "Pink > Light Pink",
      "rgb": "#e3bdcf",
      "sort_bucket": "pink",
      "sort_hue": 0.921053,
      "sort_sat": 0.167401,
      "sort_val": 0.890196,
      "swatch_file_id": "gid://shopify/MediaImage/49471313215754",
      "swatch_filename": "SS620_Powder_Rose.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Powder_Rose.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Powder_Rose.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20PWR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Powder_Rose.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554621706",
      "product_title": "Fruit of the Loom Ladies Iconic 150 T-Shirt",
      "product_handle": "ss721",
      "product_url": "/products/ss721",
      "product_full_url": "https://oakdenemerch.com/products/ss721",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss721",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS721",
      "colour_name": "Powder Rose",
      "colour_group": "Pink > Light Pink",
      "rgb": "#e3bdcf",
      "sort_bucket": "pink",
      "sort_hue": 0.921053,
      "sort_sat": 0.167401,
      "sort_val": 0.890196,
      "swatch_file_id": "gid://shopify/MediaImage/49472056525066",
      "swatch_filename": "SS721_Powder_Rose.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Powder_Rose.jpg?v=1774353579",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Powder_Rose.jpg?v=1774353579",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS721/ProductCarouselMain/SS721%20PWR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss721_Powder_Rose.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS720",
      "colour_name": "Powder Rose",
      "colour_group": "Pink > Light Pink",
      "rgb": "#e3bdcf",
      "sort_bucket": "pink",
      "sort_hue": 0.921053,
      "sort_sat": 0.167401,
      "sort_val": 0.890196,
      "swatch_file_id": "gid://shopify/MediaImage/49472218595594",
      "swatch_filename": "SS720_Powder_Rose.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Powder_Rose.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Powder_Rose.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20PWR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_Powder_Rose.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "Powder Rose",
      "colour_group": "Pink > Light Pink",
      "rgb": "#e3bdcf",
      "sort_bucket": "pink",
      "sort_hue": 0.921053,
      "sort_sat": 0.167401,
      "sort_val": 0.890196,
      "swatch_file_id": "gid://shopify/MediaImage/49473272873226",
      "swatch_filename": "180M_Powder_Rose.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Powder_Rose.jpg?v=1774363124",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Powder_Rose.jpg?v=1774363124",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20PWR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_Powder_Rose.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552262410",
      "product_title": "Native Spirit Ladies Faded T-Shirt",
      "product_handle": "ns316",
      "product_url": "/products/ns316",
      "product_full_url": "https://oakdenemerch.com/products/ns316",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns316",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS316",
      "colour_name": "Washed Petal Rose",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#bf91a6",
      "sort_bucket": "pink",
      "sort_hue": 0.923913,
      "sort_sat": 0.240838,
      "sort_val": 0.74902,
      "swatch_file_id": "gid://shopify/MediaImage/49472286556426",
      "swatch_filename": "NS316_Washed_Petal_Rose.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS316_Washed_Petal_Rose.jpg?v=1774354318",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS316_Washed_Petal_Rose.jpg?v=1774354318",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS316/ProductCarouselMain/NS316%20WPR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns316_Washed_Petal_Rose.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Pale Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#f7d9e6",
      "sort_bucket": "pink",
      "sort_hue": 0.927778,
      "sort_sat": 0.121457,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49474468905226",
      "swatch_filename": "03582_Pale_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Pale_Pink.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Pale_Pink.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20PPN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Pale_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Pale Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#f7d9e6",
      "sort_bucket": "pink",
      "sort_hue": 0.927778,
      "sort_sat": 0.121457,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49468836118794",
      "swatch_filename": "03581_Pale_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Pale_Pink.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Pale_Pink.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20PPN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Pale_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "Pale Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#f7d9e6",
      "sort_bucket": "pink",
      "sort_hue": 0.927778,
      "sort_sat": 0.121457,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49468833530122",
      "swatch_filename": "03579_Pale_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Pale_Pink.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Pale_Pink.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20PPN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Pale_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03565",
      "colour_name": "Pale Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#f7d9e6",
      "sort_bucket": "pink",
      "sort_hue": 0.927778,
      "sort_sat": 0.121457,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49473305805066",
      "swatch_filename": "03565_Pale_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Pale_Pink.jpg?v=1774363313",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Pale_Pink.jpg?v=1774363313",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20PPN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_Pale_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Pale Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#f7d9e6",
      "sort_bucket": "pink",
      "sort_hue": 0.927778,
      "sort_sat": 0.121457,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49473718976778",
      "swatch_filename": "11380_Pale_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Pale_Pink.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Pale_Pink.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20PPN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Pale_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547150602",
      "product_title": "SOL'S Unisex Sprint T-Shirt",
      "product_handle": "02995",
      "product_url": "/products/02995",
      "product_full_url": "https://oakdenemerch.com/products/02995",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-02995",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "02995",
      "colour_name": "Ribbon Pink",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#f54e95",
      "sort_bucket": "pink",
      "sort_hue": 0.929142,
      "sort_sat": 0.681633,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49473768423690",
      "swatch_filename": "02995_Ribbon_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Ribbon_Pink.jpg?v=1774365179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02995_Ribbon_Pink.jpg?v=1774365179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02995/ProductCarouselMain/02995%20RBP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02995_Ribbon_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552196874",
      "product_title": "Native Spirit Ladies Roll-Up Sleeve T-Shirt",
      "product_handle": "ns309",
      "product_url": "/products/ns309",
      "product_full_url": "https://oakdenemerch.com/products/ns309",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "S",
        "style-ns309",
        "t-shirts",
        "womens",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS309",
      "colour_name": "Petal Rose",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#c49cad",
      "sort_bucket": "pink",
      "sort_hue": 0.929167,
      "sort_sat": 0.204082,
      "sort_val": 0.768627,
      "swatch_file_id": "gid://shopify/MediaImage/49474128511242",
      "swatch_filename": "NS309_Petal_Rose.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS309_Petal_Rose.jpg?v=1774369419",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS309_Petal_Rose.jpg?v=1774369419",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS309/ProductCarouselMain/NS309%20PEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns309_Petal_Rose.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552295178",
      "product_title": "Native Spirit Ladies T-Shirt",
      "product_handle": "ns324",
      "product_url": "/products/ns324",
      "product_full_url": "https://oakdenemerch.com/products/ns324",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns324",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS324",
      "colour_name": "Petal Rose",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#c49cad",
      "sort_bucket": "pink",
      "sort_hue": 0.929167,
      "sort_sat": 0.204082,
      "sort_val": 0.768627,
      "swatch_file_id": "gid://shopify/MediaImage/49472283738378",
      "swatch_filename": "NS324_Petal_Rose.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Petal_Rose.jpg?v=1774354240",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Petal_Rose.jpg?v=1774354240",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS324/ProductCarouselMain/NS324%20PEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns324_Petal_Rose.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562330890",
      "product_title": "Native Spirit Ladies Tank Top",
      "product_handle": "ns341",
      "product_url": "/products/ns341",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns341",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS341",
      "colour_name": "Petal Rose",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#c49cad",
      "sort_bucket": "pink",
      "sort_hue": 0.929167,
      "sort_sat": 0.204082,
      "sort_val": 0.768627,
      "swatch_file_id": "gid://shopify/MediaImage/49513930326282",
      "swatch_filename": "ns341_Petal_Rose.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns341_Petal_Rose.jpg?v=1774619049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns341_Petal_Rose.jpg?v=1774619049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS341/ProductCarouselMain/NS341%20PEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns341_Petal_Rose.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Fan Candy Pink",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#f0a1c0",
      "sort_bucket": "pink",
      "sort_hue": 0.934599,
      "sort_sat": 0.329167,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49474268233994",
      "swatch_filename": "GD01_Fan_Candy_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Fan_Candy_Pink.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Fan_Candy_Pink.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20FCNP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Fan_Candy_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#e6bccc",
      "sort_bucket": "pink",
      "sort_hue": 0.936508,
      "sort_sat": 0.182609,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49474343371018",
      "swatch_filename": "AM10_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Pink.jpg?v=1774371250",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Pink.jpg?v=1774371250",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20PIN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562330890",
      "product_title": "Native Spirit Ladies Tank Top",
      "product_handle": "ns341",
      "product_url": "/products/ns341",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns341",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS341",
      "colour_name": "Pearl Rose",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#edb3c9",
      "sort_bucket": "pink",
      "sort_hue": 0.936782,
      "sort_sat": 0.244726,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49513930424586",
      "swatch_filename": "ns341_Pearl_Rose.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns341_Pearl_Rose.jpg?v=1774619050",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns341_Pearl_Rose.jpg?v=1774619050",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS341/ProductCarouselMain/NS341%20PLR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns341_Pearl_Rose.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#b52455",
      "sort_bucket": "pink",
      "sort_hue": 0.943678,
      "sort_sat": 0.801105,
      "sort_val": 0.709804,
      "swatch_file_id": "gid://shopify/MediaImage/49491378503946",
      "swatch_filename": "kb3025ic_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Fuchsia.jpg?v=1774526640",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Fuchsia.jpg?v=1774526640",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552557322",
      "product_title": "Proact Ladies Performance T-Shirt",
      "product_handle": "pa439",
      "product_url": "/products/pa439",
      "product_full_url": "https://oakdenemerch.com/products/pa439",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa439",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA439",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#b52455",
      "sort_bucket": "pink",
      "sort_hue": 0.943678,
      "sort_sat": 0.801105,
      "sort_val": 0.709804,
      "swatch_file_id": "gid://shopify/MediaImage/49471737037066",
      "swatch_filename": "PA439_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Fuchsia.jpg?v=1774351220",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Fuchsia.jpg?v=1774351220",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA439/ProductCarouselMain/PA439%20FUS%20FRONT%20HERO.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa439_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552524554",
      "product_title": "Proact Performance T-Shirt",
      "product_handle": "pa438",
      "product_url": "/products/pa438",
      "product_full_url": "https://oakdenemerch.com/products/pa438",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa438",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA438",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#b52455",
      "sort_bucket": "pink",
      "sort_hue": 0.943678,
      "sort_sat": 0.801105,
      "sort_val": 0.709804,
      "swatch_file_id": "gid://shopify/MediaImage/49471752175882",
      "swatch_filename": "PA438_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Fuchsia.jpg?v=1774351290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Fuchsia.jpg?v=1774351290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA438/ProductCarouselMain/PA438%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa438_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Mauve",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#c05a7a",
      "sort_bucket": "pink",
      "sort_hue": 0.947712,
      "sort_sat": 0.53125,
      "sort_val": 0.752941,
      "swatch_file_id": "gid://shopify/MediaImage/49473259045130",
      "swatch_filename": "CV3001_Mauve.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Mauve.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Mauve.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20MVE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Mauve.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Light Coral",
      "colour_group": "Pink > Coral",
      "rgb": "#e65782",
      "sort_bucket": "pink",
      "sort_hue": 0.949883,
      "sort_sat": 0.621739,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49473666547978",
      "swatch_filename": "NS305_Light_Coral.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Light_Coral.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Light_Coral.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20LCR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Light_Coral.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Bubblegum",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#f79eb5",
      "sort_bucket": "pink",
      "sort_hue": 0.956929,
      "sort_sat": 0.360324,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49474051965194",
      "swatch_filename": "T1150_Bubblegum.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Bubblegum.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Bubblegum.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20BGU%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Bubblegum.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Medium Pink",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#fabdcc",
      "sort_bucket": "pink",
      "sort_hue": 0.959016,
      "sort_sat": 0.244,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49473719009546",
      "swatch_filename": "11380_Medium_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Medium_Pink.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Medium_Pink.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20MPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Medium_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548592394",
      "product_title": "Bella Ladies Micro Rib Baby T-Shirt",
      "product_handle": "bl1010",
      "product_url": "/products/bl1010",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "M",
        "S",
        "style-bl1010",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1010",
      "colour_name": "Solid Pink Blend",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#f7cdd7",
      "sort_bucket": "pink",
      "sort_hue": 0.960317,
      "sort_sat": 0.17004,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49491499974922",
      "swatch_filename": "bl1010_Solid_Pink_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1010_Solid_Pink_Blend.jpg?v=1774526818",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1010_Solid_Pink_Blend.jpg?v=1774526818",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1010/ProductCarouselMain/BL1010%20SPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1010_Solid_Pink_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561839370",
      "product_title": "Bella Ladies Micro Rib Racer Tank Top",
      "product_handle": "bl1019",
      "product_url": "/products/bl1019",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-bl1019",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1019",
      "colour_name": "Solid Pink Blend",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#f7cdd7",
      "sort_bucket": "pink",
      "sort_hue": 0.960317,
      "sort_sat": 0.17004,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49513918136586",
      "swatch_filename": "bl1019_Solid_Pink_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1019_Solid_Pink_Blend.jpg?v=1774618923",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1019_Solid_Pink_Blend.jpg?v=1774618923",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1019/ProductCarouselMain/BL1019%20SPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1019_Solid_Pink_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561806602",
      "product_title": "Bella Ladies Micro Rib Spaghetti Strap Tank Top",
      "product_handle": "bl1012",
      "product_url": "/products/bl1012",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-bl1012",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1012",
      "colour_name": "Solid Pink Blend",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#f7cdd7",
      "sort_bucket": "pink",
      "sort_hue": 0.960317,
      "sort_sat": 0.17004,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49513916924170",
      "swatch_filename": "bl1012_Solid_Pink_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1012_Solid_Pink_Blend.jpg?v=1774618912",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1012_Solid_Pink_Blend.jpg?v=1774618912",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1012/ProductCarouselMain/BL1012%20SPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1012_Solid_Pink_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Cranberry",
      "colour_group": "Pink > Coral",
      "rgb": "#cc545a",
      "sort_bucket": "pink",
      "sort_hue": 0.991667,
      "sort_sat": 0.588235,
      "sort_val": 0.8,
      "swatch_file_id": "gid://shopify/MediaImage/49474052161802",
      "swatch_filename": "T1150_Cranberry.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Cranberry.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Cranberry.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20CRA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Cranberry.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552557322",
      "product_title": "Proact Ladies Performance T-Shirt",
      "product_handle": "pa439",
      "product_url": "/products/pa439",
      "product_full_url": "https://oakdenemerch.com/products/pa439",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa439",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA439",
      "colour_name": "Sporty Coral",
      "colour_group": "Pink > Coral",
      "rgb": "#ff595c",
      "sort_bucket": "pink",
      "sort_hue": 0.996988,
      "sort_sat": 0.65098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471737233674",
      "swatch_filename": "PA439_Sporty_Coral.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Sporty_Coral.jpg?v=1774351220",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA439_Sporty_Coral.jpg?v=1774351220",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA439/ProductCarouselMain/PA439%20SPCL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa439_Sporty_Coral.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552524554",
      "product_title": "Proact Performance T-Shirt",
      "product_handle": "pa438",
      "product_url": "/products/pa438",
      "product_full_url": "https://oakdenemerch.com/products/pa438",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa438",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "PA438",
      "colour_name": "Sporty Coral",
      "colour_group": "Pink > Coral",
      "rgb": "#ff595c",
      "sort_bucket": "pink",
      "sort_hue": 0.996988,
      "sort_sat": 0.65098,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471752044810",
      "swatch_filename": "PA438_Sporty_Coral.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Sporty_Coral.jpg?v=1774351291",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA438_Sporty_Coral.jpg?v=1774351291",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA438/ProductCarouselMain/PA438%20SPCL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa438_Sporty_Coral.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Truffle",
      "colour_group": "Brown > Light Brown",
      "rgb": "#70645f",
      "sort_bucket": "brown",
      "sort_hue": 0.04902,
      "sort_sat": 0.151786,
      "sort_val": 0.439216,
      "swatch_file_id": "gid://shopify/MediaImage/49471313674506",
      "swatch_filename": "SS620_Truffle.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Truffle.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Truffle.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20TRF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Truffle.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Desert Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#f0d1c4",
      "sort_bucket": "brown",
      "sort_hue": 0.049242,
      "sort_sat": 0.183333,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49471313608970",
      "swatch_filename": "SS620_Desert_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Desert_Sand.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Desert_Sand.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20DSN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Desert_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS720",
      "colour_name": "Desert Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#f0d1c4",
      "sort_bucket": "brown",
      "sort_hue": 0.049242,
      "sort_sat": 0.183333,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49472218923274",
      "swatch_filename": "SS720_Desert_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Desert_Sand.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Desert_Sand.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20DSN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_Desert_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554457866",
      "product_title": "Fruit of the Loom Pure Cotton T-Shirt",
      "product_handle": "ss640",
      "product_url": "/products/ss640",
      "product_full_url": "https://oakdenemerch.com/products/ss640",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss640",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "SS640",
      "colour_name": "Desert Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#f0d1c4",
      "sort_bucket": "brown",
      "sort_hue": 0.049242,
      "sort_sat": 0.183333,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49468957982986",
      "swatch_filename": "SS640_Desert_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Desert_Sand.jpg?v=1774315114",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Desert_Sand.jpg?v=1774315114",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS640/ProductCarouselMain/SS640%20DSN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss640_Desert_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Tangerine",
      "colour_group": "Orange > Light Orange",
      "rgb": "#ff804a",
      "sort_bucket": "brown",
      "sort_hue": 0.049724,
      "sort_sat": 0.709804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471385698570",
      "swatch_filename": "GD05_Tangerine.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Tangerine.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Tangerine.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20TAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Tangerine.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Tangerine",
      "colour_group": "Orange > Light Orange",
      "rgb": "#ff804a",
      "sort_bucket": "brown",
      "sort_hue": 0.049724,
      "sort_sat": 0.709804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49471397986570",
      "swatch_filename": "GD02_Tangerine.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Tangerine.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Tangerine.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20TAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Tangerine.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Earth",
      "colour_group": "Brown > Mid Brown",
      "rgb": "#261f1c",
      "sort_bucket": "brown",
      "sort_hue": 0.05,
      "sort_sat": 0.263158,
      "sort_val": 0.14902,
      "swatch_file_id": "gid://shopify/MediaImage/49474448556298",
      "swatch_filename": "11500_Earth.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Earth.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Earth.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20ERT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Earth.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Earth",
      "colour_group": "Brown > Mid Brown",
      "rgb": "#261f1c",
      "sort_bucket": "brown",
      "sort_hue": 0.05,
      "sort_sat": 0.263158,
      "sort_val": 0.14902,
      "swatch_file_id": "gid://shopify/MediaImage/49473719566602",
      "swatch_filename": "11380_Earth.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Earth.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Earth.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20ERT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Earth.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Fan Texas Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#9e512f",
      "sort_bucket": "brown",
      "sort_hue": 0.051051,
      "sort_sat": 0.702532,
      "sort_val": 0.619608,
      "swatch_file_id": "gid://shopify/MediaImage/49474266759434",
      "swatch_filename": "GD01_Fan_Texas_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Fan_Texas_Orange.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Fan_Texas_Orange.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20FTOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Fan_Texas_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Tangerine",
      "colour_group": "Orange > Orange",
      "rgb": "#ff731a",
      "sort_bucket": "brown",
      "sort_hue": 0.064774,
      "sort_sat": 0.898039,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49473667137802",
      "swatch_filename": "NS305_Tangerine.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Tangerine.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Tangerine.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20TAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Tangerine.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Brown Savana",
      "colour_group": "Brown > Mid Brown",
      "rgb": "#65554a",
      "sort_bucket": "brown",
      "sort_hue": 0.067901,
      "sort_sat": 0.267327,
      "sort_val": 0.396078,
      "swatch_file_id": "gid://shopify/MediaImage/49471368823050",
      "swatch_filename": "GD15_Brown_Savana.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Brown_Savana.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Brown_Savana.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20BNS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Brown_Savana.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Mocha",
      "colour_group": "Brown > Mid Brown",
      "rgb": "#65554a",
      "sort_bucket": "brown",
      "sort_hue": 0.067901,
      "sort_sat": 0.267327,
      "sort_val": 0.396078,
      "swatch_file_id": "gid://shopify/MediaImage/49471442813194",
      "swatch_filename": "AT001_Mocha.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Mocha.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Mocha.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20MOC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Mocha.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Mocha",
      "colour_group": "Brown > Mid Brown",
      "rgb": "#65554a",
      "sort_bucket": "brown",
      "sort_hue": 0.067901,
      "sort_sat": 0.267327,
      "sort_val": 0.396078,
      "swatch_file_id": "gid://shopify/MediaImage/49471429738762",
      "swatch_filename": "AT002_Mocha.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Mocha.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Mocha.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20MOC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Mocha.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Chocolate",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#332922",
      "sort_bucket": "brown",
      "sort_hue": 0.068627,
      "sort_sat": 0.333333,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49471322292490",
      "swatch_filename": "SS6_Chocolate.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Chocolate.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Chocolate.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20CHO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Chocolate.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549772042",
      "product_title": "Gildan Ladies SoftStyle® T-Shirt",
      "product_handle": "gd72",
      "product_url": "/products/gd72",
      "product_full_url": "https://oakdenemerch.com/products/gd72",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd72",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD72",
      "colour_name": "Sand",
      "colour_group": "Brown > Light Brown",
      "rgb": "#d6c1b2",
      "sort_bucket": "brown",
      "sort_hue": 0.069444,
      "sort_sat": 0.168224,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49468940812554",
      "swatch_filename": "GD72_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Sand.jpg?v=1774314002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Sand.jpg?v=1774314002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD72/ProductCarouselMain/GD72%20SAN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd72_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Sand",
      "colour_group": "Brown > Light Brown",
      "rgb": "#d6c1b2",
      "sort_bucket": "brown",
      "sort_hue": 0.069444,
      "sort_sat": 0.168224,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49474268397834",
      "swatch_filename": "GD01_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Sand.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Sand.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20SAN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Sand",
      "colour_group": "Brown > Light Brown",
      "rgb": "#d6c1b2",
      "sort_bucket": "brown",
      "sort_hue": 0.069444,
      "sort_sat": 0.168224,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49471368888586",
      "swatch_filename": "GD15_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Sand.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Sand.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20SAN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Sand",
      "colour_group": "Brown > Light Brown",
      "rgb": "#d6c1b2",
      "sort_bucket": "brown",
      "sort_hue": 0.069444,
      "sort_sat": 0.168224,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49471398150410",
      "swatch_filename": "GD02_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Sand.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Sand.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20SAN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "Light Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#c7a993",
      "sort_bucket": "brown",
      "sort_hue": 0.070513,
      "sort_sat": 0.261307,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49491378700554",
      "swatch_filename": "kb3025ic_Light_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Light_Sand.jpg?v=1774526642",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Light_Sand.jpg?v=1774526642",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20LSA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Light_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551639818",
      "product_title": "Kariban Unisex 190IC Crew Neck T-Shirt",
      "product_handle": "kb3032ic",
      "product_url": "/products/kb3032ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3032ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3032IC",
      "colour_name": "Light Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#c7a993",
      "sort_bucket": "brown",
      "sort_hue": 0.070513,
      "sort_sat": 0.261307,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49491367428362",
      "swatch_filename": "kb3032ic_Light_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Light_Sand.jpg?v=1774526609",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Light_Sand.jpg?v=1774526609",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3032IC/ProductCarouselMain/KB3032IC%20LSA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3032ic_Light_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549673738",
      "product_title": "Gildan Hammer Maxweight T-Shirt",
      "product_handle": "gd201",
      "product_url": "/products/gd201",
      "product_full_url": "https://oakdenemerch.com/products/gd201",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd201",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD201",
      "colour_name": "Tan",
      "colour_group": "Brown > Light Brown",
      "rgb": "#ba977c",
      "sort_bucket": "brown",
      "sort_hue": 0.072581,
      "sort_sat": 0.333333,
      "sort_val": 0.729412,
      "swatch_file_id": "gid://shopify/MediaImage/49468939239690",
      "swatch_filename": "GD201_Tan.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_Tan.jpg?v=1774313827",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_Tan.jpg?v=1774313827",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD201/ProductCarouselMain/GD201%20TAN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd201_Tan.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Tan",
      "colour_group": "Brown > Light Brown",
      "rgb": "#ba977c",
      "sort_bucket": "brown",
      "sort_hue": 0.072581,
      "sort_sat": 0.333333,
      "sort_val": 0.729412,
      "swatch_file_id": "gid://shopify/MediaImage/49471397396746",
      "swatch_filename": "GD02_Tan.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Tan.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Tan.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20TAN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Tan.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "Kit",
      "colour_group": "Brown > Light Brown",
      "rgb": "#b9ab9f",
      "sort_bucket": "brown",
      "sort_hue": 0.076923,
      "sort_sat": 0.140541,
      "sort_val": 0.72549,
      "swatch_file_id": "gid://shopify/MediaImage/49471257673994",
      "swatch_filename": "T520_Kit.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Kit.jpg?v=1774348349",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Kit.jpg?v=1774348349",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20KIT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_Kit.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556587786",
      "product_title": "Tee Jays Ladies Interlock T-Shirt",
      "product_handle": "t580",
      "product_url": "/products/t580",
      "product_full_url": "https://oakdenemerch.com/products/t580",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t580",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T580",
      "colour_name": "Kit",
      "colour_group": "Brown > Light Brown",
      "rgb": "#b9ab9f",
      "sort_bucket": "brown",
      "sort_hue": 0.076923,
      "sort_sat": 0.140541,
      "sort_val": 0.72549,
      "swatch_file_id": "gid://shopify/MediaImage/49469002449162",
      "swatch_filename": "T580_Kit.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Kit.jpg?v=1774315823",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Kit.jpg?v=1774315823",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T580/ProductCarouselMain/T580%20KIT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t580_Kit.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557341450",
      "product_title": "Tee Jays Sof T-Shirt",
      "product_handle": "t8000",
      "product_url": "/products/t8000",
      "product_full_url": "https://oakdenemerch.com/products/t8000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t8000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T8000",
      "colour_name": "Kit",
      "colour_group": "Brown > Light Brown",
      "rgb": "#b9ab9f",
      "sort_bucket": "brown",
      "sort_hue": 0.076923,
      "sort_sat": 0.140541,
      "sort_val": 0.72549,
      "swatch_file_id": "gid://shopify/MediaImage/49471238668554",
      "swatch_filename": "T8000_Kit.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Kit.jpg?v=1774348259",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Kit.jpg?v=1774348259",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8000/ProductCarouselMain/T8000%20KIT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8000_Kit.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "Clay",
      "colour_group": "Brown > Light Brown",
      "rgb": "#786e65",
      "sort_bucket": "brown",
      "sort_hue": 0.078947,
      "sort_sat": 0.158333,
      "sort_val": 0.470588,
      "swatch_file_id": "gid://shopify/MediaImage/49471257379082",
      "swatch_filename": "T520_Clay.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Clay.jpg?v=1774348349",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Clay.jpg?v=1774348349",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20CLY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_Clay.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556587786",
      "product_title": "Tee Jays Ladies Interlock T-Shirt",
      "product_handle": "t580",
      "product_url": "/products/t580",
      "product_full_url": "https://oakdenemerch.com/products/t580",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t580",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T580",
      "colour_name": "Clay",
      "colour_group": "Brown > Light Brown",
      "rgb": "#786e65",
      "sort_bucket": "brown",
      "sort_hue": 0.078947,
      "sort_sat": 0.158333,
      "sort_val": 0.470588,
      "swatch_file_id": "gid://shopify/MediaImage/49469002318090",
      "swatch_filename": "T580_Clay.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Clay.jpg?v=1774315822",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Clay.jpg?v=1774315822",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T580/ProductCarouselMain/T580%20CLY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t580_Clay.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554818314",
      "product_title": "Tee Jays Unlabeled Baseball T-Shirt",
      "product_handle": "t1170",
      "product_url": "/products/t1170",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-t1170",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T1170",
      "colour_name": "Cement/Clay",
      "colour_group": "Natural > Natural",
      "rgb": "#d1d9d4;#786e65",
      "sort_bucket": "brown",
      "sort_hue": 0.08,
      "sort_sat": 0.4,
      "sort_val": 0.45,
      "swatch_file_id": "gid://shopify/MediaImage/49491279053066",
      "swatch_filename": "t1170_CementClay.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t1170_CementClay.jpg?v=1774526394",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t1170_CementClay.jpg?v=1774526394",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1170/ProductCarouselMain/T1170%20CE_CL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1170_CementClay.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554818314",
      "product_title": "Tee Jays Unlabeled Baseball T-Shirt",
      "product_handle": "t1170",
      "product_url": "/products/t1170",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-t1170",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T1170",
      "colour_name": "Cement/Dark Green",
      "colour_group": "Natural > Natural",
      "rgb": "#d1d9d4;#034537",
      "sort_bucket": "brown",
      "sort_hue": 0.08,
      "sort_sat": 0.4,
      "sort_val": 0.45,
      "swatch_file_id": "gid://shopify/MediaImage/49491279216906",
      "swatch_filename": "t1170_CementDark_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t1170_CementDark_Green.jpg?v=1774526395",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t1170_CementDark_Green.jpg?v=1774526395",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1170/ProductCarouselMain/T1170%20CE_DG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1170_CementDark_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Chocolate",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#221f1c",
      "sort_bucket": "brown",
      "sort_hue": 0.083333,
      "sort_sat": 0.176471,
      "sort_val": 0.133333,
      "swatch_file_id": "gid://shopify/MediaImage/49474448589066",
      "swatch_filename": "11500_Chocolate.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Chocolate.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Chocolate.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20CHO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Chocolate.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Chocolate",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#221f1c",
      "sort_bucket": "brown",
      "sort_hue": 0.083333,
      "sort_sat": 0.176471,
      "sort_val": 0.133333,
      "swatch_file_id": "gid://shopify/MediaImage/49468933636362",
      "swatch_filename": "11502_Chocolate.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Chocolate.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Chocolate.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20CHO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Chocolate.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Chocolate",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#221f1c",
      "sort_bucket": "brown",
      "sort_hue": 0.083333,
      "sort_sat": 0.176471,
      "sort_val": 0.133333,
      "swatch_file_id": "gid://shopify/MediaImage/49473718321418",
      "swatch_filename": "11380_Chocolate.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Chocolate.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Chocolate.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20CHO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Chocolate.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548920074",
      "product_title": "Canvas Unisex Heavyweight Boxy T-Shirt",
      "product_handle": "cv3010",
      "product_url": "/products/cv3010",
      "product_full_url": "https://oakdenemerch.com/products/cv3010",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv3010",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3010",
      "colour_name": "Toast",
      "colour_group": "Yellow > Gold",
      "rgb": "#945a1c",
      "sort_bucket": "brown",
      "sort_hue": 0.086111,
      "sort_sat": 0.810811,
      "sort_val": 0.580392,
      "swatch_file_id": "gid://shopify/MediaImage/49472879395082",
      "swatch_filename": "CV3010_Toast.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_Toast.jpg?v=1774360083",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_Toast.jpg?v=1774360083",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3010/ProductCarouselMain/CV3010%20TST%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3010_Toast.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686737162",
      "product_title": "Canvas Unisex Heavyweight Long Sleeve Boxy T-Shirt",
      "product_handle": "cv3511",
      "product_url": "/products/cv3511",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv3511",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3511",
      "colour_name": "Toast",
      "colour_group": "Yellow > Gold",
      "rgb": "#945a1c",
      "sort_bucket": "brown",
      "sort_hue": 0.086111,
      "sort_sat": 0.810811,
      "sort_val": 0.580392,
      "swatch_file_id": "gid://shopify/MediaImage/49490426528010",
      "swatch_filename": "cv3511_Toast.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_Toast.jpg?v=1774522804",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_Toast.jpg?v=1774522804",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3511/ProductCarouselMain/CV3511%20TST%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3511_Toast.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548690698",
      "product_title": "Bella Ladies Heavy Boxy T-Shirt",
      "product_handle": "bl6110",
      "product_url": "/products/bl6110",
      "product_full_url": "https://oakdenemerch.com/products/bl6110",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-bl6110",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "BL6110",
      "colour_name": "Vintage Brown",
      "colour_group": "Brown > Mid Brown",
      "rgb": "#87725b",
      "sort_bucket": "brown",
      "sort_hue": 0.087121,
      "sort_sat": 0.325926,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49472881393930",
      "swatch_filename": "BL6110_Vintage_Brown.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_Vintage_Brown.jpg?v=1774360125",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_Vintage_Brown.jpg?v=1774360125",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL6110/ProductCarouselMain/BL6110%20VBN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl6110_Vintage_Brown.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548920074",
      "product_title": "Canvas Unisex Heavyweight Boxy T-Shirt",
      "product_handle": "cv3010",
      "product_url": "/products/cv3010",
      "product_full_url": "https://oakdenemerch.com/products/cv3010",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv3010",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3010",
      "colour_name": "Vintage Brown",
      "colour_group": "Brown > Mid Brown",
      "rgb": "#87725b",
      "sort_bucket": "brown",
      "sort_hue": 0.087121,
      "sort_sat": 0.325926,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49472879231242",
      "swatch_filename": "CV3010_Vintage_Brown.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_Vintage_Brown.jpg?v=1774360083",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_Vintage_Brown.jpg?v=1774360083",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV4810/ProductCarouselMain/CV3010%20VBN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3010_Vintage_Brown.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Brown",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#3a2610",
      "sort_bucket": "brown",
      "sort_hue": 0.087302,
      "sort_sat": 0.724138,
      "sort_val": 0.227451,
      "swatch_file_id": "gid://shopify/MediaImage/49473259208970",
      "swatch_filename": "CV3001_Brown.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Brown.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Brown.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20BRN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Brown.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Desert Sand",
      "colour_group": "Brown > Light Brown",
      "rgb": "#bf8a4e",
      "sort_bucket": "brown",
      "sort_hue": 0.088496,
      "sort_sat": 0.591623,
      "sort_val": 0.74902,
      "swatch_file_id": "gid://shopify/MediaImage/49474343403786",
      "swatch_filename": "AM10_Desert_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Desert_Sand.jpg?v=1774371250",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Desert_Sand.jpg?v=1774371250",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20DSN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Desert_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% organic cotton/40% recycled polyester",
      "style_code": "03582",
      "colour_name": "Heather Beige",
      "colour_group": "Natural > Heather/Effect Natural",
      "rgb": "#c4b9ab",
      "sort_bucket": "brown",
      "sort_hue": 0.093333,
      "sort_sat": 0.127551,
      "sort_val": 0.768627,
      "swatch_file_id": "gid://shopify/MediaImage/49474468380938",
      "swatch_filename": "03582_Heather_Beige.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Heather_Beige.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Heather_Beige.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20HBE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Heather_Beige.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% organic cotton/40% recycled polyester",
      "style_code": "03581",
      "colour_name": "Heather Beige",
      "colour_group": "Natural > Heather/Effect Natural",
      "rgb": "#c4b9ab",
      "sort_bucket": "brown",
      "sort_hue": 0.093333,
      "sort_sat": 0.127551,
      "sort_val": 0.768627,
      "swatch_file_id": "gid://shopify/MediaImage/49468835889418",
      "swatch_filename": "03581_Heather_Beige.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Heather_Beige.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Heather_Beige.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20HBE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Heather_Beige.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Dark Beige",
      "colour_group": "Brown > Light Brown",
      "rgb": "#b18a56",
      "sort_bucket": "brown",
      "sort_hue": 0.095238,
      "sort_sat": 0.514124,
      "sort_val": 0.694118,
      "swatch_file_id": "gid://shopify/MediaImage/49473744306442",
      "swatch_filename": "03981_Dark_Beige.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Dark_Beige.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Dark_Beige.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20DBE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Dark_Beige.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457685786890",
      "product_title": "SOL'S Unisex Pioneer Long Sleeve T-Shirt",
      "product_handle": "03982",
      "product_url": "/products/03982",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03982",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03982",
      "colour_name": "Dark Beige",
      "colour_group": "Brown > Light Brown",
      "rgb": "#b18a56",
      "sort_bucket": "brown",
      "sort_hue": 0.095238,
      "sort_sat": 0.514124,
      "sort_val": 0.694118,
      "swatch_file_id": "gid://shopify/MediaImage/49490369773834",
      "swatch_filename": "03982_Dark_Beige.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03982_Dark_Beige.jpg?v=1774522724",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03982_Dark_Beige.jpg?v=1774522724",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03982/ProductCarouselMain/03982%20DBE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03982_Dark_Beige.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687654666",
      "product_title": "Native Spirit Unisex Crew Neck Long Sleeve T-Shirt",
      "product_handle": "ns333",
      "product_url": "/products/ns333",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-ns333",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS333",
      "colour_name": "Dark Camel",
      "colour_group": "Brown > Light Brown",
      "rgb": "#816949",
      "sort_bucket": "brown",
      "sort_hue": 0.095238,
      "sort_sat": 0.434109,
      "sort_val": 0.505882,
      "swatch_file_id": "gid://shopify/MediaImage/49490480726282",
      "swatch_filename": "ns333_Dark_Camel.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns333_Dark_Camel.jpg?v=1774522955",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns333_Dark_Camel.jpg?v=1774522955",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS333/ProductCarouselMain/NS333%20DRC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns333_Dark_Camel.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548297482",
      "product_title": "Russell Athletic Authentic Heavyweight T-Shirt",
      "product_handle": "215m",
      "product_url": "/products/215m",
      "product_full_url": "https://oakdenemerch.com/products/215m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "sports",
        "style-215m",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "215M",
      "colour_name": "Tan",
      "colour_group": "Brown > Light Brown",
      "rgb": "#b39d7e",
      "sort_bucket": "brown",
      "sort_hue": 0.097484,
      "sort_sat": 0.296089,
      "sort_val": 0.701961,
      "swatch_file_id": "gid://shopify/MediaImage/49470972723466",
      "swatch_filename": "215M_Tan.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/215M_Tan.jpg?v=1774347211",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/215M_Tan.jpg?v=1774347211",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/215M/ProductCarouselMain/215M%20%20TAN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "215m_Tan.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "Tan",
      "colour_group": "Brown > Light Brown",
      "rgb": "#b39d7e",
      "sort_bucket": "brown",
      "sort_hue": 0.097484,
      "sort_sat": 0.296089,
      "sort_val": 0.701961,
      "swatch_file_id": "gid://shopify/MediaImage/49473272774922",
      "swatch_filename": "180M_Tan.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Tan.jpg?v=1774363124",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Tan.jpg?v=1774363124",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20TAN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_Tan.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Curcuma",
      "colour_group": "Yellow > Dark Yellow",
      "rgb": "#a66c11",
      "sort_bucket": "brown",
      "sort_hue": 0.10179,
      "sort_sat": 0.89759,
      "sort_val": 0.65098,
      "swatch_file_id": "gid://shopify/MediaImage/49473666515210",
      "swatch_filename": "NS305_Curcuma.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Curcuma.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Curcuma.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20CCM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Curcuma.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552393482",
      "product_title": "Native Spirit Oversized T-Shirt",
      "product_handle": "ns332",
      "product_url": "/products/ns332",
      "product_full_url": "https://oakdenemerch.com/products/ns332",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns332",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "NS332",
      "colour_name": "Toffee",
      "colour_group": "Brown > Mid Brown",
      "rgb": "#615034",
      "sort_bucket": "brown",
      "sort_hue": 0.103704,
      "sort_sat": 0.463918,
      "sort_val": 0.380392,
      "swatch_file_id": "gid://shopify/MediaImage/49474121400586",
      "swatch_filename": "NS332_Toffee.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_Toffee.jpg?v=1774369280",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_Toffee.jpg?v=1774369280",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS332/ProductCarouselMain/NS332%20TOF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns332_Toffee.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "Mocha",
      "colour_group": "Brown > Mid Brown",
      "rgb": "#605542",
      "sort_bucket": "brown",
      "sort_hue": 0.105556,
      "sort_sat": 0.3125,
      "sort_val": 0.376471,
      "swatch_file_id": "gid://shopify/MediaImage/49473273168138",
      "swatch_filename": "180M_Mocha.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Mocha.jpg?v=1774363125",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Mocha.jpg?v=1774363125",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20MOC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_Mocha.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "Wood",
      "colour_group": "Brown > Mid Brown",
      "rgb": "#7d632e",
      "sort_bucket": "brown",
      "sort_hue": 0.111814,
      "sort_sat": 0.632,
      "sort_val": 0.490196,
      "swatch_file_id": "gid://shopify/MediaImage/49471257641226",
      "swatch_filename": "T520_Wood.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Wood.jpg?v=1774348348",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Wood.jpg?v=1774348348",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20WDD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_Wood.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552295178",
      "product_title": "Native Spirit Ladies T-Shirt",
      "product_handle": "ns324",
      "product_url": "/products/ns324",
      "product_full_url": "https://oakdenemerch.com/products/ns324",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns324",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS324",
      "colour_name": "Raw Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#d4c8ac",
      "sort_bucket": "brown",
      "sort_hue": 0.116667,
      "sort_sat": 0.188679,
      "sort_val": 0.831373,
      "swatch_file_id": "gid://shopify/MediaImage/49472283672842",
      "swatch_filename": "NS324_Raw_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Raw_Natural.jpg?v=1774354240",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Raw_Natural.jpg?v=1774354240",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS324/ProductCarouselMain/NS324%20RNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns324_Raw_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552164106",
      "product_title": "Native Spirit Unisex French Terry T-Shirt",
      "product_handle": "ns308",
      "product_url": "/products/ns308",
      "product_full_url": "https://oakdenemerch.com/products/ns308",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns308",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "NS308",
      "colour_name": "Raw Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#d4c8ac",
      "sort_bucket": "brown",
      "sort_hue": 0.116667,
      "sort_sat": 0.188679,
      "sort_val": 0.831373,
      "swatch_file_id": "gid://shopify/MediaImage/49472288358666",
      "swatch_filename": "NS308_Raw_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS308_Raw_Natural.jpg?v=1774354362",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS308_Raw_Natural.jpg?v=1774354362",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS308/ProductCarouselMain/NS308%20RNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns308_Raw_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Raw Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#d4c8ac",
      "sort_bucket": "brown",
      "sort_hue": 0.116667,
      "sort_sat": 0.188679,
      "sort_val": 0.831373,
      "swatch_file_id": "gid://shopify/MediaImage/49473667563786",
      "swatch_filename": "NS305_Raw_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Raw_Natural.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Raw_Natural.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20RNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Raw_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552393482",
      "product_title": "Native Spirit Oversized T-Shirt",
      "product_handle": "ns332",
      "product_url": "/products/ns332",
      "product_full_url": "https://oakdenemerch.com/products/ns332",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns332",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "NS332",
      "colour_name": "Driftwood",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#7a7362",
      "sort_bucket": "brown",
      "sort_hue": 0.118056,
      "sort_sat": 0.196721,
      "sort_val": 0.478431,
      "swatch_file_id": "gid://shopify/MediaImage/49474121335050",
      "swatch_filename": "NS332_Driftwood.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_Driftwood.jpg?v=1774369280",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_Driftwood.jpg?v=1774369280",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS332/ProductCarouselMain/NS332%20DFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns332_Driftwood.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Driftwood",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#7a7362",
      "sort_bucket": "brown",
      "sort_hue": 0.118056,
      "sort_sat": 0.196721,
      "sort_val": 0.478431,
      "swatch_file_id": "gid://shopify/MediaImage/49473666810122",
      "swatch_filename": "NS305_Driftwood.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Driftwood.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Driftwood.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20DFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Driftwood.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Cream",
      "colour_group": "Natural > Natural",
      "rgb": "#f0e6cc",
      "sort_bucket": "brown",
      "sort_hue": 0.12037,
      "sort_sat": 0.15,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49474449735946",
      "swatch_filename": "11500_Cream.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Cream.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Cream.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20CRE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Cream.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549116682",
      "product_title": "Ecologie Cascades Organic T-Shirt",
      "product_handle": "ea001",
      "product_url": "/products/ea001",
      "product_full_url": "https://oakdenemerch.com/products/ea001",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-ea001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001",
      "colour_name": "Mustard",
      "colour_group": "Yellow > Dark Yellow",
      "rgb": "#bc910c",
      "sort_bucket": "brown",
      "sort_hue": 0.125947,
      "sort_sat": 0.93617,
      "sort_val": 0.737255,
      "swatch_file_id": "gid://shopify/MediaImage/49474304180490",
      "swatch_filename": "EA001_Mustard.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Mustard.jpg?v=1774371175",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Mustard.jpg?v=1774371175",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001/ProductCarouselMain/EA001%20MUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001_Mustard.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Desert Sand",
      "colour_group": "Brown > Light Brown",
      "rgb": "#ddca8f",
      "sort_bucket": "brown",
      "sort_hue": 0.126068,
      "sort_sat": 0.352941,
      "sort_val": 0.866667,
      "swatch_file_id": "gid://shopify/MediaImage/49471442649354",
      "swatch_filename": "AT001_Desert_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Desert_Sand.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Desert_Sand.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20DSN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Desert_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Desert Sand",
      "colour_group": "Brown > Light Brown",
      "rgb": "#ddca8f",
      "sort_bucket": "brown",
      "sort_hue": 0.126068,
      "sort_sat": 0.352941,
      "sort_val": 0.866667,
      "swatch_file_id": "gid://shopify/MediaImage/49471430361354",
      "swatch_filename": "AT002_Desert_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Desert_Sand.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Desert_Sand.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20DSN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Desert_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550820618",
      "product_title": "AWDis Unisex Oversize 100 T-Shirt",
      "product_handle": "jt009",
      "product_url": "/products/jt009",
      "product_full_url": "https://oakdenemerch.com/products/jt009",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jt009",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.*",
      "style_code": "JT009",
      "colour_name": "Desert Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#ddca8f",
      "sort_bucket": "brown",
      "sort_hue": 0.126068,
      "sort_sat": 0.352941,
      "sort_val": 0.866667,
      "swatch_file_id": "gid://shopify/MediaImage/49471818039562",
      "swatch_filename": "JT009_Desert_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_Desert_Sand.jpg?v=1774351553",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_Desert_Sand.jpg?v=1774351553",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT009/ProductCarouselMain/JT009%20DSN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt009_Desert_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS621",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#f5e8bf",
      "sort_bucket": "brown",
      "sort_hue": 0.126543,
      "sort_sat": 0.220408,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49471285887242",
      "swatch_filename": "SS621_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Natural.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Natural.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS620",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#f5e8bf",
      "sort_bucket": "brown",
      "sort_hue": 0.126543,
      "sort_sat": 0.220408,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49471313281290",
      "swatch_filename": "SS620_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Natural.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Natural.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "SS720",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#f5e8bf",
      "sort_bucket": "brown",
      "sort_hue": 0.126543,
      "sort_sat": 0.220408,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49472218562826",
      "swatch_filename": "SS720_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Natural.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Natural.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554457866",
      "product_title": "Fruit of the Loom Pure Cotton T-Shirt",
      "product_handle": "ss640",
      "product_url": "/products/ss640",
      "product_full_url": "https://oakdenemerch.com/products/ss640",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss640",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "SS640",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#f5e8bf",
      "sort_bucket": "brown",
      "sort_hue": 0.126543,
      "sort_sat": 0.220408,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49468957851914",
      "swatch_filename": "SS640_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Natural.jpg?v=1774315114",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS640_Natural.jpg?v=1774315114",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS640/ProductCarouselMain/SS640%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss640_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#f5e8bf",
      "sort_bucket": "brown",
      "sort_hue": 0.126543,
      "sort_sat": 0.220408,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49471322030346",
      "swatch_filename": "SS6_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Natural.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Natural.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#f5e8bf",
      "sort_bucket": "brown",
      "sort_hue": 0.126543,
      "sort_sat": 0.220408,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49473272742154",
      "swatch_filename": "180M_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Natural.jpg?v=1774363124",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Natural.jpg?v=1774363124",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548231946",
      "product_title": "Russell Athletic Ladies Authentic Classic Ringspun T-Shirt",
      "product_handle": "180f",
      "product_url": "/products/180f",
      "product_full_url": "https://oakdenemerch.com/products/180f",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-180f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180F",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#f5e8bf",
      "sort_bucket": "brown",
      "sort_hue": 0.126543,
      "sort_sat": 0.220408,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49472623673610",
      "swatch_filename": "180F_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180F_Natural.jpg?v=1774358325",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180F_Natural.jpg?v=1774358325",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180F/ProductCarouselMain/180F%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180f_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548690698",
      "product_title": "Bella Ladies Heavy Boxy T-Shirt",
      "product_handle": "bl6110",
      "product_url": "/products/bl6110",
      "product_full_url": "https://oakdenemerch.com/products/bl6110",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-bl6110",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "BL6110",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#ded1a6",
      "sort_bucket": "brown",
      "sort_hue": 0.127976,
      "sort_sat": 0.252252,
      "sort_val": 0.870588,
      "swatch_file_id": "gid://shopify/MediaImage/49472881525002",
      "swatch_filename": "BL6110_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_Natural.jpg?v=1774360125",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_Natural.jpg?v=1774360125",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL6110/ProductCarouselMain/BL6110%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl6110_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#ded1a6",
      "sort_bucket": "brown",
      "sort_hue": 0.127976,
      "sort_sat": 0.252252,
      "sort_val": 0.870588,
      "swatch_file_id": "gid://shopify/MediaImage/49473259503882",
      "swatch_filename": "CV3001_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Natural.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Natural.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548920074",
      "product_title": "Canvas Unisex Heavyweight Boxy T-Shirt",
      "product_handle": "cv3010",
      "product_url": "/products/cv3010",
      "product_full_url": "https://oakdenemerch.com/products/cv3010",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv3010",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3010",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#ded1a6",
      "sort_bucket": "brown",
      "sort_hue": 0.127976,
      "sort_sat": 0.252252,
      "sort_val": 0.870588,
      "swatch_file_id": "gid://shopify/MediaImage/49472879329546",
      "swatch_filename": "CV3010_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_Natural.jpg?v=1774360083",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_Natural.jpg?v=1774360083",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3010/ProductCarouselMain/CV3010%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3010_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686737162",
      "product_title": "Canvas Unisex Heavyweight Long Sleeve Boxy T-Shirt",
      "product_handle": "cv3511",
      "product_url": "/products/cv3511",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv3511",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3511",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#ded1a6",
      "sort_bucket": "brown",
      "sort_hue": 0.127976,
      "sort_sat": 0.252252,
      "sort_val": 0.870588,
      "swatch_file_id": "gid://shopify/MediaImage/49490427478282",
      "swatch_filename": "cv3511_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_Natural.jpg?v=1774522805",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_Natural.jpg?v=1774522805",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3511/ProductCarouselMain/CV3511%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3511_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548592394",
      "product_title": "Bella Ladies Micro Rib Baby T-Shirt",
      "product_handle": "bl1010",
      "product_url": "/products/bl1010",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "M",
        "S",
        "style-bl1010",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1010",
      "colour_name": "Solid Natural Blend",
      "colour_group": "Natural > Natural",
      "rgb": "#ded1a6",
      "sort_bucket": "brown",
      "sort_hue": 0.127976,
      "sort_sat": 0.252252,
      "sort_val": 0.870588,
      "swatch_file_id": "gid://shopify/MediaImage/49491500728586",
      "swatch_filename": "bl1010_Solid_Natural_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1010_Solid_Natural_Blend.jpg?v=1774526821",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1010_Solid_Natural_Blend.jpg?v=1774526821",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1010/ProductCarouselMain/BL1010%20SNT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1010_Solid_Natural_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561839370",
      "product_title": "Bella Ladies Micro Rib Racer Tank Top",
      "product_handle": "bl1019",
      "product_url": "/products/bl1019",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-bl1019",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1019",
      "colour_name": "Solid Natural Blend",
      "colour_group": "Natural > Natural",
      "rgb": "#ded1a6",
      "sort_bucket": "brown",
      "sort_hue": 0.127976,
      "sort_sat": 0.252252,
      "sort_val": 0.870588,
      "swatch_file_id": "gid://shopify/MediaImage/49513918464266",
      "swatch_filename": "bl1019_Solid_Natural_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1019_Solid_Natural_Blend.jpg?v=1774618926",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1019_Solid_Natural_Blend.jpg?v=1774618926",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1019/ProductCarouselMain/BL1019%20SNT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1019_Solid_Natural_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686475018",
      "product_title": "Bella Micro Rib Long Sleeve Baby T-Shirt",
      "product_handle": "bl1501",
      "product_url": "/products/bl1501",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-bl1501",
        "t-shirts",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1501",
      "colour_name": "Solid Natural Blend",
      "colour_group": "Natural > Natural",
      "rgb": "#ded1a6",
      "sort_bucket": "brown",
      "sort_hue": 0.127976,
      "sort_sat": 0.252252,
      "sort_val": 0.870588,
      "swatch_file_id": "gid://shopify/MediaImage/49490404147466",
      "swatch_filename": "bl1501_Solid_Natural_Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1501_Solid_Natural_Blend.jpg?v=1774522784",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1501_Solid_Natural_Blend.jpg?v=1774522784",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1501/ProductCarouselMain/BL1501%20SNT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1501_Solid_Natural_Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Olive Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#1f1a09",
      "sort_bucket": "brown",
      "sort_hue": 0.128788,
      "sort_sat": 0.709677,
      "sort_val": 0.121569,
      "swatch_file_id": "gid://shopify/MediaImage/49474218131722",
      "swatch_filename": "JC001_Olive_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Olive_Green.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Olive_Green.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20OLI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Olive_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Olive Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#1f1a09",
      "sort_bucket": "brown",
      "sort_hue": 0.128788,
      "sort_sat": 0.709677,
      "sort_val": 0.121569,
      "swatch_file_id": "gid://shopify/MediaImage/49471397331210",
      "swatch_filename": "GD02_Olive_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Olive_Green.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Olive_Green.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20OLI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Olive_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549116682",
      "product_title": "Ecologie Cascades Organic T-Shirt",
      "product_handle": "ea001",
      "product_url": "/products/ea001",
      "product_full_url": "https://oakdenemerch.com/products/ea001",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-ea001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001",
      "colour_name": "Sand Dune",
      "colour_group": "Brown > Light Brown",
      "rgb": "#9c9372",
      "sort_bucket": "brown",
      "sort_hue": 0.130952,
      "sort_sat": 0.269231,
      "sort_val": 0.611765,
      "swatch_file_id": "gid://shopify/MediaImage/49474303787274",
      "swatch_filename": "EA001_Sand_Dune.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Sand_Dune.jpg?v=1774371175",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Sand_Dune.jpg?v=1774371175",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001/ProductCarouselMain/EA001%20SDD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001_Sand_Dune.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552295178",
      "product_title": "Native Spirit Ladies T-Shirt",
      "product_handle": "ns324",
      "product_url": "/products/ns324",
      "product_full_url": "https://oakdenemerch.com/products/ns324",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns324",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS324",
      "colour_name": "Wet Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#9e9986",
      "sort_bucket": "brown",
      "sort_hue": 0.131944,
      "sort_sat": 0.151899,
      "sort_val": 0.619608,
      "swatch_file_id": "gid://shopify/MediaImage/49472283607306",
      "swatch_filename": "NS324_Wet_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Wet_Sand.jpg?v=1774354240",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Wet_Sand.jpg?v=1774354240",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS324/ProductCarouselMain/NS324%20WES%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns324_Wet_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562330890",
      "product_title": "Native Spirit Ladies Tank Top",
      "product_handle": "ns341",
      "product_url": "/products/ns341",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns341",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS341",
      "colour_name": "Wet Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#9e9986",
      "sort_bucket": "brown",
      "sort_hue": 0.131944,
      "sort_sat": 0.151899,
      "sort_val": 0.619608,
      "swatch_file_id": "gid://shopify/MediaImage/49513930490122",
      "swatch_filename": "ns341_Wet_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns341_Wet_Sand.jpg?v=1774619052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns341_Wet_Sand.jpg?v=1774619052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS341/ProductCarouselMain/NS341%20WES%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns341_Wet_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552164106",
      "product_title": "Native Spirit Unisex French Terry T-Shirt",
      "product_handle": "ns308",
      "product_url": "/products/ns308",
      "product_full_url": "https://oakdenemerch.com/products/ns308",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns308",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "NS308",
      "colour_name": "Wet Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#9e9986",
      "sort_bucket": "brown",
      "sort_hue": 0.131944,
      "sort_sat": 0.151899,
      "sort_val": 0.619608,
      "swatch_file_id": "gid://shopify/MediaImage/49472288522506",
      "swatch_filename": "NS308_Wet_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS308_Wet_Sand.jpg?v=1774354362",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS308_Wet_Sand.jpg?v=1774354362",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS308/ProductCarouselMain/NS308%20WES%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns308_Wet_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Wet Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#9e9986",
      "sort_bucket": "brown",
      "sort_hue": 0.131944,
      "sort_sat": 0.151899,
      "sort_val": 0.619608,
      "swatch_file_id": "gid://shopify/MediaImage/49473666646282",
      "swatch_filename": "NS305_Wet_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Wet_Sand.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Wet_Sand.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20WES%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Wet_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552360714",
      "product_title": "Native Spirit Unisex Oversized T-Shirt",
      "product_handle": "ns330",
      "product_url": "/products/ns330",
      "product_full_url": "https://oakdenemerch.com/products/ns330",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-ns330",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS330",
      "colour_name": "Wet Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#9e9986",
      "sort_bucket": "brown",
      "sort_hue": 0.131944,
      "sort_sat": 0.151899,
      "sort_val": 0.619608,
      "swatch_file_id": "gid://shopify/MediaImage/49473635057930",
      "swatch_filename": "NS330_Wet_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS330_Wet_Sand.jpg?v=1774364535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS330_Wet_Sand.jpg?v=1774364535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS330/ProductCarouselMain/NS330%20WES%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns330_Wet_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#bbaf7d",
      "sort_bucket": "brown",
      "sort_hue": 0.134409,
      "sort_sat": 0.331551,
      "sort_val": 0.733333,
      "swatch_file_id": "gid://shopify/MediaImage/49474449146122",
      "swatch_filename": "11500_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Sand.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Sand.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20SAN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#bbaf7d",
      "sort_bucket": "brown",
      "sort_hue": 0.134409,
      "sort_sat": 0.331551,
      "sort_val": 0.733333,
      "swatch_file_id": "gid://shopify/MediaImage/49473719107850",
      "swatch_filename": "11380_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Sand.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Sand.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20SAN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "SS6",
      "colour_name": "Khaki",
      "colour_group": "Brown > Light Brown",
      "rgb": "#9e9779",
      "sort_bucket": "brown",
      "sort_hue": 0.135135,
      "sort_sat": 0.234177,
      "sort_val": 0.619608,
      "swatch_file_id": "gid://shopify/MediaImage/49471322325258",
      "swatch_filename": "SS6_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Khaki.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Khaki.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549116682",
      "product_title": "Ecologie Cascades Organic T-Shirt",
      "product_handle": "ea001",
      "product_url": "/products/ea001",
      "product_full_url": "https://oakdenemerch.com/products/ea001",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-ea001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#f2edc7",
      "sort_bucket": "brown",
      "sort_hue": 0.147287,
      "sort_sat": 0.177686,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49474303820042",
      "swatch_filename": "EA001_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Natural.jpg?v=1774371175",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Natural.jpg?v=1774371175",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001/ProductCarouselMain/EA001%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552655626",
      "product_title": "Premier Cotton Rich Comis T-Shirt",
      "product_handle": "pr219",
      "product_url": "/products/pr219",
      "product_full_url": "https://oakdenemerch.com/products/pr219",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-pr219",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% recycled polyester.*",
      "style_code": "PR219",
      "colour_name": "Khaki",
      "colour_group": "Brown > Light Brown",
      "rgb": "#9a9779",
      "sort_bucket": "brown",
      "sort_hue": 0.151515,
      "sort_sat": 0.214286,
      "sort_val": 0.603922,
      "swatch_file_id": "gid://shopify/MediaImage/49468947955978",
      "swatch_filename": "PR219_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR219_Khaki.jpg?v=1774314717",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR219_Khaki.jpg?v=1774314717",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR219/ProductCarouselMain/PR219%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr219_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552721162",
      "product_title": "Premier Ladies Cotton Rich Comis T-Shirt",
      "product_handle": "pr319",
      "product_url": "/products/pr319",
      "product_full_url": "https://oakdenemerch.com/products/pr319",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-pr319",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% recycled polyester.*",
      "style_code": "PR319",
      "colour_name": "Khaki",
      "colour_group": "Brown > Light Brown",
      "rgb": "#9a9779",
      "sort_bucket": "brown",
      "sort_hue": 0.151515,
      "sort_sat": 0.214286,
      "sort_val": 0.603922,
      "swatch_file_id": "gid://shopify/MediaImage/49472275317002",
      "swatch_filename": "PR319_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR319_Khaki.jpg?v=1774354101",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR319_Khaki.jpg?v=1774354101",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR319/ProductCarouselMain/PR319%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr319_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552590090",
      "product_title": "Premier Unisex Utility 2.0 Oversized T-Shirt",
      "product_handle": "pr020",
      "product_url": "/products/pr020",
      "product_full_url": "https://oakdenemerch.com/products/pr020",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-pr020",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% BCI cotton.",
      "style_code": "PR020",
      "colour_name": "Stay Khaki",
      "colour_group": "Natural > Natural",
      "rgb": "#9a9779",
      "sort_bucket": "brown",
      "sort_hue": 0.151515,
      "sort_sat": 0.214286,
      "sort_val": 0.603922,
      "swatch_file_id": "gid://shopify/MediaImage/49473100185866",
      "swatch_filename": "PR020_Stay_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR020_Stay_Khaki.jpg?v=1774361959",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR020_Stay_Khaki.jpg?v=1774361959",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR020/ProductCarouselMain/PR020%20SKK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr020_Stay_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Desert Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#a1aa69",
      "sort_bucket": "brown",
      "sort_hue": 0.189744,
      "sort_sat": 0.382353,
      "sort_val": 0.666667,
      "swatch_file_id": "gid://shopify/MediaImage/49474218164490",
      "swatch_filename": "JC001_Desert_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Desert_Sand.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Desert_Sand.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20DSN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Desert_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#edf5cc",
      "sort_bucket": "brown",
      "sort_hue": 0.199187,
      "sort_sat": 0.167347,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49474468774154",
      "swatch_filename": "03582_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Natural.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Natural.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547511050",
      "product_title": "SOL'S Crusader Recycled T-Shirt",
      "product_handle": "04233",
      "product_url": "/products/04233",
      "product_full_url": "https://oakdenemerch.com/products/04233",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04233",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% recycled cotton/50% cotton.*",
      "style_code": "04233",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#edf5cc",
      "sort_bucket": "brown",
      "sort_hue": 0.199187,
      "sort_sat": 0.167347,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49473284899082",
      "swatch_filename": "04233_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Natural.jpg?v=1774363191",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04233_Natural.jpg?v=1774363191",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04233/ProductCarouselMain/04233%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04233_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#edf5cc",
      "sort_bucket": "brown",
      "sort_hue": 0.199187,
      "sort_sat": 0.167347,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49474449473802",
      "swatch_filename": "11500_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Natural.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Natural.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#edf5cc",
      "sort_bucket": "brown",
      "sort_hue": 0.199187,
      "sort_sat": 0.167347,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49468836053258",
      "swatch_filename": "03581_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Natural.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Natural.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#edf5cc",
      "sort_bucket": "brown",
      "sort_hue": 0.199187,
      "sort_sat": 0.167347,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49468833136906",
      "swatch_filename": "03579_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Natural.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Natural.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03565",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#edf5cc",
      "sort_bucket": "brown",
      "sort_hue": 0.199187,
      "sort_sat": 0.167347,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49473305739530",
      "swatch_filename": "03565_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Natural.jpg?v=1774363312",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Natural.jpg?v=1774363312",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#edf5cc",
      "sort_bucket": "brown",
      "sort_hue": 0.199187,
      "sort_sat": 0.167347,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49473719206154",
      "swatch_filename": "11380_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Natural.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Natural.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547805962",
      "product_title": "SOL'S Unisex Cliff T-Shirt",
      "product_handle": "04813",
      "product_url": "/products/04813",
      "product_full_url": "https://oakdenemerch.com/products/04813",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "S",
        "style-04813",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "04813",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#edf5cc",
      "sort_bucket": "brown",
      "sort_hue": 0.199187,
      "sort_sat": 0.167347,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49472952107274",
      "swatch_filename": "04813_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04813_Natural.jpg?v=1774360433",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04813_Natural.jpg?v=1774360433",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04813/ProductCarouselMain/04813%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04813_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03582",
      "colour_name": "Rope",
      "colour_group": "Brown > Light Brown",
      "rgb": "#bcc3ab",
      "sort_bucket": "brown",
      "sort_hue": 0.215278,
      "sort_sat": 0.123077,
      "sort_val": 0.764706,
      "swatch_file_id": "gid://shopify/MediaImage/49474468937994",
      "swatch_filename": "03582_Rope.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Rope.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Rope.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20ROP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Rope.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Rope",
      "colour_group": "Brown > Light Brown",
      "rgb": "#bcc3ab",
      "sort_bucket": "brown",
      "sort_hue": 0.215278,
      "sort_sat": 0.123077,
      "sort_val": 0.764706,
      "swatch_file_id": "gid://shopify/MediaImage/49474448654602",
      "swatch_filename": "11500_Rope.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Rope.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Rope.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20ROP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Rope.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03581",
      "colour_name": "Rope",
      "colour_group": "Brown > Light Brown",
      "rgb": "#bcc3ab",
      "sort_bucket": "brown",
      "sort_hue": 0.215278,
      "sort_sat": 0.123077,
      "sort_val": 0.764706,
      "swatch_file_id": "gid://shopify/MediaImage/49468835725578",
      "swatch_filename": "03581_Rope.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Rope.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Rope.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20ROP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Rope.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03579",
      "colour_name": "Rope",
      "colour_group": "Brown > Light Brown",
      "rgb": "#bcc3ab",
      "sort_bucket": "brown",
      "sort_hue": 0.215278,
      "sort_sat": 0.123077,
      "sort_val": 0.764706,
      "swatch_file_id": "gid://shopify/MediaImage/49468833235210",
      "swatch_filename": "03579_Rope.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Rope.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Rope.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20ROP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Rope.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.*",
      "style_code": "03565",
      "colour_name": "Rope",
      "colour_group": "Brown > Light Brown",
      "rgb": "#bcc3ab",
      "sort_bucket": "brown",
      "sort_hue": 0.215278,
      "sort_sat": 0.123077,
      "sort_val": 0.764706,
      "swatch_file_id": "gid://shopify/MediaImage/49473305641226",
      "swatch_filename": "03565_Rope.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Rope.jpg?v=1774363313",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Rope.jpg?v=1774363313",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20ROP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_Rope.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Rope",
      "colour_group": "Brown > Light Brown",
      "rgb": "#bcc3ab",
      "sort_bucket": "brown",
      "sort_hue": 0.215278,
      "sort_sat": 0.123077,
      "sort_val": 0.764706,
      "swatch_file_id": "gid://shopify/MediaImage/49473719533834",
      "swatch_filename": "11380_Rope.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Rope.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Rope.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20ROP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Rope.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Rope",
      "colour_group": "Brown > Light Brown",
      "rgb": "#bcc3ab",
      "sort_bucket": "brown",
      "sort_hue": 0.215278,
      "sort_sat": 0.123077,
      "sort_val": 0.764706,
      "swatch_file_id": "gid://shopify/MediaImage/49473744830730",
      "swatch_filename": "03981_Rope.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Rope.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Rope.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20ROP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Rope.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Gemstone Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#22ba67",
      "sort_bucket": "brown",
      "sort_hue": 0.408991,
      "sort_sat": 0.817204,
      "sort_val": 0.729412,
      "swatch_file_id": "gid://shopify/MediaImage/49473666679050",
      "swatch_filename": "NS305_Gemstone_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Gemstone_Green.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Gemstone_Green.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20GEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Gemstone_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Stone Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#68a8b5",
      "sort_bucket": "brown",
      "sort_hue": 0.528139,
      "sort_sat": 0.425414,
      "sort_val": 0.709804,
      "swatch_file_id": "gid://shopify/MediaImage/49471369085194",
      "swatch_filename": "GD15_Stone_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Stone_Blue.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Stone_Blue.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20SNB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Stone_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Stone Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#68a8b5",
      "sort_bucket": "brown",
      "sort_hue": 0.528139,
      "sort_sat": 0.425414,
      "sort_val": 0.709804,
      "swatch_file_id": "gid://shopify/MediaImage/49471397134602",
      "swatch_filename": "GD02_Stone_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Stone_Blue.jpg?v=1774349246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Stone_Blue.jpg?v=1774349246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20SNB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Stone_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "Flintstone",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#547495",
      "sort_bucket": "brown",
      "sort_hue": 0.584615,
      "sort_sat": 0.436242,
      "sort_val": 0.584314,
      "swatch_file_id": "gid://shopify/MediaImage/49471257149706",
      "swatch_filename": "T520_Flintstone.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Flintstone.jpg?v=1774348349",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Flintstone.jpg?v=1774348349",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20FLS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_Flintstone.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556587786",
      "product_title": "Tee Jays Ladies Interlock T-Shirt",
      "product_handle": "t580",
      "product_url": "/products/t580",
      "product_full_url": "https://oakdenemerch.com/products/t580",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t580",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T580",
      "colour_name": "Flintstone",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#547495",
      "sort_bucket": "brown",
      "sort_hue": 0.584615,
      "sort_sat": 0.436242,
      "sort_val": 0.584314,
      "swatch_file_id": "gid://shopify/MediaImage/49469001990410",
      "swatch_filename": "T580_Flintstone.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Flintstone.jpg?v=1774315823",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Flintstone.jpg?v=1774315823",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T580/ProductCarouselMain/T580%20FLS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t580_Flintstone.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Flintstone",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#547495",
      "sort_bucket": "brown",
      "sort_hue": 0.584615,
      "sort_sat": 0.436242,
      "sort_val": 0.584314,
      "swatch_file_id": "gid://shopify/MediaImage/49474052292874",
      "swatch_filename": "T1150_Flintstone.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Flintstone.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Flintstone.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20FLS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Flintstone.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Hot Chocolate",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#1f070a",
      "sort_bucket": "brown",
      "sort_hue": 0.979167,
      "sort_sat": 0.774194,
      "sort_val": 0.121569,
      "swatch_file_id": "gid://shopify/MediaImage/49474218262794",
      "swatch_filename": "JC001_Hot_Chocolate.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Hot_Chocolate.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Hot_Chocolate.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20HOC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Hot_Chocolate.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Tango Red",
      "colour_group": "Red > Dark Red",
      "rgb": "#821420",
      "sort_bucket": "brown",
      "sort_hue": 0.981818,
      "sort_sat": 0.846154,
      "sort_val": 0.509804,
      "swatch_file_id": "gid://shopify/MediaImage/49474448851210",
      "swatch_filename": "11500_Tango_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Tango_Red.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Tango_Red.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20TGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Tango_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Tango Red",
      "colour_group": "Red > Dark Red",
      "rgb": "#821420",
      "sort_bucket": "brown",
      "sort_hue": 0.981818,
      "sort_sat": 0.846154,
      "sort_val": 0.509804,
      "swatch_file_id": "gid://shopify/MediaImage/49473719042314",
      "swatch_filename": "11380_Tango_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Tango_Red.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Tango_Red.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20TGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Tango_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Storm",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#c0b7b7",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.046875,
      "sort_val": 0.752941,
      "swatch_file_id": "gid://shopify/MediaImage/49473259241738",
      "swatch_filename": "CV3001_Storm.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Storm.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Storm.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20STM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Storm.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547543818",
      "product_title": "SOL'S Unisex Explorer Recycled T-Shirt",
      "product_handle": "04461",
      "product_url": "/products/04461",
      "product_full_url": "https://oakdenemerch.com/products/04461",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-04461",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "60% recycled cotton/40% recycled polyester.",
      "style_code": "04461",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#b3b3b3",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.701961,
      "swatch_file_id": "gid://shopify/MediaImage/49472969179402",
      "swatch_filename": "04461_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04461_Heather_Grey.jpg?v=1774360549",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04461_Heather_Grey.jpg?v=1774360549",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04461/ProductCarouselMain/04461%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04461_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551017226",
      "product_title": "Kustom Kit Superwash® 60°C T-Shirt",
      "product_handle": "k504",
      "product_url": "/products/k504",
      "product_full_url": "https://oakdenemerch.com/products/k504",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k504",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton.*",
      "style_code": "K504",
      "colour_name": "Light Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#ababab",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.670588,
      "swatch_file_id": "gid://shopify/MediaImage/49473127088394",
      "swatch_filename": "K504_Light_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K504_Light_Grey_Marl.jpg?v=1774362160",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K504_Light_Grey_Marl.jpg?v=1774362160",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K504/ProductCarouselMain/K504%20LML%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k504_Light_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555768586",
      "product_title": "Tee Jays Ladies Roll-Up T-Shirt",
      "product_handle": "t5063",
      "product_url": "/products/t5063",
      "product_full_url": "https://oakdenemerch.com/products/t5063",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "hospitality",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-t5063",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "T5063",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#999999",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49471686017290",
      "swatch_filename": "T5063_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5063_Heather_Grey.jpg?v=1774350893",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5063_Heather_Grey.jpg?v=1774350893",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5063/ProductCarouselMain/T5063%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5063_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555735818",
      "product_title": "Tee Jays Roll-Up T-Shirt",
      "product_handle": "t5062",
      "product_url": "/products/t5062",
      "product_full_url": "https://oakdenemerch.com/products/t5062",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "hospitality",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5062",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "T5062",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#999999",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49468994322698",
      "swatch_filename": "T5062_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5062_Heather_Grey.jpg?v=1774315684",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T5062_Heather_Grey.jpg?v=1774315684",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5062/ProductCarouselMain/T5062%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5062_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557341450",
      "product_title": "Tee Jays Sof T-Shirt",
      "product_handle": "t8000",
      "product_url": "/products/t8000",
      "product_full_url": "https://oakdenemerch.com/products/t8000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t8000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "T8000",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#999999",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49471239061770",
      "swatch_filename": "T8000_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Heather_Grey.jpg?v=1774348260",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Heather_Grey.jpg?v=1774348260",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8000/ProductCarouselMain/T8000%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8000_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#999999",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49474052522250",
      "swatch_filename": "T1150_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Heather_Grey.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Heather_Grey.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554720010",
      "product_title": "Tee Jays Unlabelled T-Shirt",
      "product_handle": "t1140",
      "product_url": "/products/t1140",
      "product_full_url": "https://oakdenemerch.com/products/t1140",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1140",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T1140",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#999999",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49474054750474",
      "swatch_filename": "T1140_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1140_Heather_Grey.jpg?v=1774368141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1140_Heather_Grey.jpg?v=1774368141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1140/ProductCarouselMain/T1140%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1140_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546790154",
      "product_title": "SOL'S Camo T-Shirt",
      "product_handle": "01188",
      "product_url": "/products/01188",
      "product_full_url": "https://oakdenemerch.com/products/01188",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-01188",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.",
      "style_code": "01188",
      "colour_name": "Grey Camo",
      "colour_group": "Patterns > Camouflage",
      "rgb": "",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49471884198154",
      "swatch_filename": "01188_Grey_Camo.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01188_Grey_Camo.jpg?v=1774352390",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01188_Grey_Camo.jpg?v=1774352390",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01188/ProductCarouselMain/01188%20GCM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01188_Grey_Camo.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688637706",
      "product_title": "Tee Jays Long Sleeve Baseball T-Shirt",
      "product_handle": "t5072",
      "product_url": "/products/t5072",
      "product_full_url": "https://oakdenemerch.com/products/t5072",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5072",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "Body 85% cotton/15% viscose. Sleeves 100% ringspun combed cotton.",
      "style_code": "T5072",
      "colour_name": "Heather Grey/Navy",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#999999;#12294a",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49490491277578",
      "swatch_filename": "t5072_Heather_GreyNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5072_Heather_GreyNavy.jpg?v=1774523098",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5072_Heather_GreyNavy.jpg?v=1774523098",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Tee%20Jays/T5072/ProductCarouselMain/T5072%20HE%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5072_Heather_GreyNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550099722",
      "product_title": "AWDis Cool Contrast Wicking T-Shirt",
      "product_handle": "jc003",
      "product_url": "/products/jc003",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC003",
      "colour_name": "Sapphire Blue/Charcoal",
      "colour_group": "Blue > Sapphire",
      "rgb": "#26c9ff;#15221d",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49491413762314",
      "swatch_filename": "jc003_Sapphire_BlueCharcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Sapphire_BlueCharcoal.jpg?v=1774526745",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc003_Sapphire_BlueCharcoal.jpg?v=1774526745",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC003/ProductCarouselMain/JC003%20SA%252fCH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc003_Sapphire_BlueCharcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556981002",
      "product_title": "Tee Jays CoolDry™ T-Shirt",
      "product_handle": "t7020",
      "product_url": "/products/t7020",
      "product_full_url": "https://oakdenemerch.com/products/t7020",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t7020",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7020",
      "colour_name": "Grey Melange",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#737373",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.45098,
      "swatch_file_id": "gid://shopify/MediaImage/49469011951882",
      "swatch_filename": "T7020_Grey_Melange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_Grey_Melange.jpg?v=1774315920",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_Grey_Melange.jpg?v=1774315920",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7020/ProductCarouselMain/T7020%20GME%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7020_Grey_Melange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557079306",
      "product_title": "Tee Jays Ladies CoolDry™ T-Shirt",
      "product_handle": "t7021",
      "product_url": "/products/t7021",
      "product_full_url": "https://oakdenemerch.com/products/t7021",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-t7021",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7021",
      "colour_name": "Grey Melange",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#737373",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.45098,
      "swatch_file_id": "gid://shopify/MediaImage/49471676186890",
      "swatch_filename": "T7021_Grey_Melange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_Grey_Melange.jpg?v=1774350799",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_Grey_Melange.jpg?v=1774350799",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7021/ProductCarouselMain/T7021%20GME%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7021_Grey_Melange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688736010",
      "product_title": "Tee Jays Long Sleeve CoolDry™ T-Shirt",
      "product_handle": "t7022",
      "product_url": "/products/t7022",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-t7022",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7022",
      "colour_name": "Grey Melange",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#737373",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.45098,
      "swatch_file_id": "gid://shopify/MediaImage/49490492653834",
      "swatch_filename": "t7022_Grey_Melange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t7022_Grey_Melange.jpg?v=1774523120",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t7022_Grey_Melange.jpg?v=1774523120",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7022/ProductCarouselMain/T7022%20GME%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7022_Grey_Melange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547576586",
      "product_title": "SOL'S Unisex Titan T-Shirt",
      "product_handle": "04728",
      "product_url": "/products/04728",
      "product_full_url": "https://oakdenemerch.com/products/04728",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "knitwear",
        "L",
        "M",
        "S",
        "style-04728",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.",
      "style_code": "04728",
      "colour_name": "Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#707070",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.439216,
      "swatch_file_id": "gid://shopify/MediaImage/49474456748298",
      "swatch_filename": "04728_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_Grey.jpg?v=1774371966",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04728_Grey.jpg?v=1774371966",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04728/ProductCarouselMain/04728%20GRE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04728_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686835466",
      "product_title": "Canvas Unisex Heavyweight Long Sleeve T-Shirt",
      "product_handle": "cv4651",
      "product_url": "/products/cv4651",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv4651",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV4651",
      "colour_name": "Asphalt",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#3b3b3b",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49490434851082",
      "swatch_filename": "cv4651_Asphalt.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4651_Asphalt.jpg?v=1774522813",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4651_Asphalt.jpg?v=1774522813",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV4651/ProductCarouselMain/CV4651%20ASP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv4651_Asphalt.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549018378",
      "product_title": "Canvas Unisex Heavyweight T-Shirt",
      "product_handle": "cv4610",
      "product_url": "/products/cv4610",
      "product_full_url": "https://oakdenemerch.com/products/cv4610",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv4610",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV4610",
      "colour_name": "Asphalt",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#3b3b3b",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49473247510794",
      "swatch_filename": "CV4610_Asphalt.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV4610_Asphalt.jpg?v=1774362974",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV4610_Asphalt.jpg?v=1774362974",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV4610/ProductCarouselMain/CV4610%20ASP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv4610_Asphalt.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548690698",
      "product_title": "Bella Ladies Heavy Boxy T-Shirt",
      "product_handle": "bl6110",
      "product_url": "/products/bl6110",
      "product_full_url": "https://oakdenemerch.com/products/bl6110",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-bl6110",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "BL6110",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#3b3b3b",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49472881557770",
      "swatch_filename": "BL6110_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_Dark_Grey.jpg?v=1774360125",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_Dark_Grey.jpg?v=1774360125",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL6110/ProductCarouselMain/BL6110%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl6110_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686737162",
      "product_title": "Canvas Unisex Heavyweight Long Sleeve Boxy T-Shirt",
      "product_handle": "cv3511",
      "product_url": "/products/cv3511",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv3511",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3511",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#3b3b3b",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49490429182218",
      "swatch_filename": "cv3511_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_Dark_Grey.jpg?v=1774522806",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_Dark_Grey.jpg?v=1774522806",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3511/ProductCarouselMain/CV3511%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3511_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551017226",
      "product_title": "Kustom Kit Superwash® 60°C T-Shirt",
      "product_handle": "k504",
      "product_url": "/products/k504",
      "product_full_url": "https://oakdenemerch.com/products/k504",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k504",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton.*",
      "style_code": "K504",
      "colour_name": "Dark Grey Marl",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#3b3b3b",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49473127252234",
      "swatch_filename": "K504_Dark_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K504_Dark_Grey_Marl.jpg?v=1774362160",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K504_Dark_Grey_Marl.jpg?v=1774362160",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K504/ProductCarouselMain/K504%20DKM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k504_Dark_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Dark Grey Solid",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#3b3b3b",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49473259667722",
      "swatch_filename": "CV3001_Dark_Grey_Solid.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Dark_Grey_Solid.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Dark_Grey_Solid.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20DGS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Dark_Grey_Solid.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Eco Raw",
      "colour_group": "Natural > Natural",
      "rgb": "#ebdbcf",
      "sort_bucket": "grey",
      "sort_hue": 0.071429,
      "sort_sat": 0.119149,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49474343338250",
      "swatch_filename": "AM10_Eco_Raw.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Eco_Raw.jpg?v=1774371250",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Eco_Raw.jpg?v=1774371250",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20ERW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Eco_Raw.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548395786",
      "product_title": "Anthem Unisex Organic Heavyweight T-Shirt",
      "product_handle": "am15",
      "product_url": "/products/am15",
      "product_full_url": "https://oakdenemerch.com/products/am15",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am15",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM15",
      "colour_name": "Eco Raw",
      "colour_group": "Natural > Natural",
      "rgb": "#ebdbcf",
      "sort_bucket": "grey",
      "sort_hue": 0.071429,
      "sort_sat": 0.119149,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49472895779082",
      "swatch_filename": "AM15_Eco_Raw.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Eco_Raw.jpg?v=1774360325",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Eco_Raw.jpg?v=1774360325",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM15/ProductCarouselMain/AM15%20ERW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am15_Eco_Raw.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Ice Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#ede6df",
      "sort_bucket": "grey",
      "sort_hue": 0.083333,
      "sort_sat": 0.059072,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49474266824970",
      "swatch_filename": "GD01_Ice_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Ice_Grey.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Ice_Grey.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20IGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Ice_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Ice Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#ede6df",
      "sort_bucket": "grey",
      "sort_hue": 0.083333,
      "sort_sat": 0.059072,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49471398805770",
      "swatch_filename": "GD02_Ice_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Ice_Grey.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Ice_Grey.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20IGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Ice_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11500",
      "colour_name": "Light Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#9c958c",
      "sort_bucket": "grey",
      "sort_hue": 0.09375,
      "sort_sat": 0.102564,
      "sort_val": 0.611765,
      "swatch_file_id": "gid://shopify/MediaImage/49474449277194",
      "swatch_filename": "11500_Light_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Light_Grey.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Light_Grey.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20LGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Light_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Light Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#9c958c",
      "sort_bucket": "grey",
      "sort_hue": 0.09375,
      "sort_sat": 0.102564,
      "sort_val": 0.611765,
      "swatch_file_id": "gid://shopify/MediaImage/49473718911242",
      "swatch_filename": "11380_Light_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Light_Grey.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Light_Grey.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20LGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Light_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547379978",
      "product_title": "SOL'S Boxy Oversized Organic T-Shirt",
      "product_handle": "03806",
      "product_url": "/products/03806",
      "product_full_url": "https://oakdenemerch.com/products/03806",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL",
        "style-03806",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "03806",
      "colour_name": "Linen",
      "colour_group": "Natural",
      "rgb": "#cfc7ba",
      "sort_bucket": "grey",
      "sort_hue": 0.103175,
      "sort_sat": 0.101449,
      "sort_val": 0.811765,
      "swatch_file_id": "gid://shopify/MediaImage/49471864635658",
      "swatch_filename": "03806_Linen.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03806_Linen.jpg?v=1774352127",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03806_Linen.jpg?v=1774352127",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03806/ProductCarouselMain/03806%20LNN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03806_Linen.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547412746",
      "product_title": "SOL'S Ladies Boxy Oversized Organic T-Shirt",
      "product_handle": "03807",
      "product_url": "/products/03807",
      "product_full_url": "https://oakdenemerch.com/products/03807",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03807",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "03807",
      "colour_name": "Linen",
      "colour_group": "Natural",
      "rgb": "#cfc7ba",
      "sort_bucket": "grey",
      "sort_hue": 0.103175,
      "sort_sat": 0.101449,
      "sort_val": 0.811765,
      "swatch_file_id": "gid://shopify/MediaImage/49474463793418",
      "swatch_filename": "03807_Linen.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03807_Linen.jpg?v=1774372092",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03807_Linen.jpg?v=1774372092",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03807/ProductCarouselMain/03807%20LNN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03807_Linen.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547642122",
      "product_title": "SOL'S Ladies Legend T-Shirt",
      "product_handle": "04776",
      "product_url": "/products/04776",
      "product_full_url": "https://oakdenemerch.com/products/04776",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-04776",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "04776",
      "colour_name": "Linen",
      "colour_group": "Green > Olive/Military",
      "rgb": "#cfc7ba",
      "sort_bucket": "grey",
      "sort_hue": 0.103175,
      "sort_sat": 0.101449,
      "sort_val": 0.811765,
      "swatch_file_id": "gid://shopify/MediaImage/49472963248394",
      "swatch_filename": "04776_Linen.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Linen.jpg?v=1774360489",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04776_Linen.jpg?v=1774360489",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04776/ProductCarouselMain/04776%20LIN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04776_Linen.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547445514",
      "product_title": "SOL'S Unisex Legend Organic T-Shirt",
      "product_handle": "03981",
      "product_url": "/products/03981",
      "product_full_url": "https://oakdenemerch.com/products/03981",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03981",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "03981",
      "colour_name": "Linen",
      "colour_group": "Natural",
      "rgb": "#cfc7ba",
      "sort_bucket": "grey",
      "sort_hue": 0.103175,
      "sort_sat": 0.101449,
      "sort_val": 0.811765,
      "swatch_file_id": "gid://shopify/MediaImage/49473745092874",
      "swatch_filename": "03981_Linen.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Linen.jpg?v=1774365052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03981_Linen.jpg?v=1774365052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03981/ProductCarouselMain/03981%20LNN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03981_Linen.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Vanilla",
      "colour_group": "Natural > Natural",
      "rgb": "#f0e8d6",
      "sort_bucket": "grey",
      "sort_hue": 0.115385,
      "sort_sat": 0.108333,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49474218197258",
      "swatch_filename": "JC001_Vanilla.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Vanilla.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Vanilla.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20VAN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Vanilla.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Ecru",
      "colour_group": "Grey > Light Grey",
      "rgb": "#d6d2c5",
      "sort_bucket": "grey",
      "sort_hue": 0.127451,
      "sort_sat": 0.079439,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49474051997962",
      "swatch_filename": "T1150_Ecru.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Ecru.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Ecru.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20ECR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Ecru.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552196874",
      "product_title": "Native Spirit Ladies Roll-Up Sleeve T-Shirt",
      "product_handle": "ns309",
      "product_url": "/products/ns309",
      "product_full_url": "https://oakdenemerch.com/products/ns309",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "S",
        "style-ns309",
        "t-shirts",
        "womens",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS309",
      "colour_name": "Ivory",
      "colour_group": "Natural > Natural",
      "rgb": "#edebe0",
      "sort_bucket": "grey",
      "sort_hue": 0.141026,
      "sort_sat": 0.054852,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49474128576778",
      "swatch_filename": "NS309_Ivory.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS309_Ivory.jpg?v=1774369419",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS309_Ivory.jpg?v=1774369419",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS309/ProductCarouselMain/NS309%20IVO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns309_Ivory.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552295178",
      "product_title": "Native Spirit Ladies T-Shirt",
      "product_handle": "ns324",
      "product_url": "/products/ns324",
      "product_full_url": "https://oakdenemerch.com/products/ns324",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns324",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS324",
      "colour_name": "Ivory",
      "colour_group": "Natural > Natural",
      "rgb": "#edebe0",
      "sort_bucket": "grey",
      "sort_hue": 0.141026,
      "sort_sat": 0.054852,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49472283377930",
      "swatch_filename": "NS324_Ivory.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Ivory.jpg?v=1774354240",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Ivory.jpg?v=1774354240",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS324/ProductCarouselMain/NS324%20IVO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns324_Ivory.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552393482",
      "product_title": "Native Spirit Oversized T-Shirt",
      "product_handle": "ns332",
      "product_url": "/products/ns332",
      "product_full_url": "https://oakdenemerch.com/products/ns332",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns332",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "NS332",
      "colour_name": "Ivory",
      "colour_group": "Natural > Natural",
      "rgb": "#edebe0",
      "sort_bucket": "grey",
      "sort_hue": 0.141026,
      "sort_sat": 0.054852,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49474121695498",
      "swatch_filename": "NS332_Ivory.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_Ivory.jpg?v=1774369280",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS332_Ivory.jpg?v=1774369280",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS332/ProductCarouselMain/NS332%20IVO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns332_Ivory.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552229642",
      "product_title": "Native Spirit Terry Towel T-Shirt",
      "product_handle": "ns311",
      "product_url": "/products/ns311",
      "product_full_url": "https://oakdenemerch.com/products/ns311",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns311",
        "t-shirts",
        "towels-robes-slippers",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic combed cotton/20% recycled polyester.",
      "style_code": "NS311",
      "colour_name": "Ivory",
      "colour_group": "Natural > Natural",
      "rgb": "#edebe0",
      "sort_bucket": "grey",
      "sort_hue": 0.141026,
      "sort_sat": 0.054852,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49472780632330",
      "swatch_filename": "NS311_Ivory.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS311_Ivory.jpg?v=1774359624",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS311_Ivory.jpg?v=1774359624",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS311/ProductCarouselMain/NS311%20IVO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns311_Ivory.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552164106",
      "product_title": "Native Spirit Unisex French Terry T-Shirt",
      "product_handle": "ns308",
      "product_url": "/products/ns308",
      "product_full_url": "https://oakdenemerch.com/products/ns308",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns308",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "NS308",
      "colour_name": "Ivory",
      "colour_group": "Natural > Natural",
      "rgb": "#edebe0",
      "sort_bucket": "grey",
      "sort_hue": 0.141026,
      "sort_sat": 0.054852,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49472288293130",
      "swatch_filename": "NS308_Ivory.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS308_Ivory.jpg?v=1774354362",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS308_Ivory.jpg?v=1774354362",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS308/ProductCarouselMain/NS308%20IVO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns308_Ivory.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Ivory",
      "colour_group": "Natural > Natural",
      "rgb": "#edebe0",
      "sort_bucket": "grey",
      "sort_hue": 0.141026,
      "sort_sat": 0.054852,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49473666973962",
      "swatch_filename": "NS305_Ivory.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Ivory.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Ivory.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20IVO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Ivory.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552360714",
      "product_title": "Native Spirit Unisex Oversized T-Shirt",
      "product_handle": "ns330",
      "product_url": "/products/ns330",
      "product_full_url": "https://oakdenemerch.com/products/ns330",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-ns330",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS330",
      "colour_name": "Ivory",
      "colour_group": "Natural > Natural",
      "rgb": "#edebe0",
      "sort_bucket": "grey",
      "sort_hue": 0.141026,
      "sort_sat": 0.054852,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49473635221770",
      "swatch_filename": "NS330_Ivory.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS330_Ivory.jpg?v=1774364535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS330_Ivory.jpg?v=1774364535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS330/ProductCarouselMain/NS330%20IVO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns330_Ivory.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686835466",
      "product_title": "Canvas Unisex Heavyweight Long Sleeve T-Shirt",
      "product_handle": "cv4651",
      "product_url": "/products/cv4651",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv4651",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV4651",
      "colour_name": "Dust",
      "colour_group": "Natural > Natural",
      "rgb": "#dbd9cc",
      "sort_bucket": "grey",
      "sort_hue": 0.144444,
      "sort_sat": 0.068493,
      "sort_val": 0.858824,
      "swatch_file_id": "gid://shopify/MediaImage/49490435080458",
      "swatch_filename": "cv4651_Dust.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4651_Dust.jpg?v=1774522814",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4651_Dust.jpg?v=1774522814",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV4651/ProductCarouselMain/CV4651%20DUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv4651_Dust.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549018378",
      "product_title": "Canvas Unisex Heavyweight T-Shirt",
      "product_handle": "cv4610",
      "product_url": "/products/cv4610",
      "product_full_url": "https://oakdenemerch.com/products/cv4610",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv4610",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV4610",
      "colour_name": "Dust",
      "colour_group": "Natural > Natural",
      "rgb": "#dbd9cc",
      "sort_bucket": "grey",
      "sort_hue": 0.144444,
      "sort_sat": 0.068493,
      "sort_val": 0.858824,
      "swatch_file_id": "gid://shopify/MediaImage/49473247641866",
      "swatch_filename": "CV4610_Dust.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV4610_Dust.jpg?v=1774362975",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV4610_Dust.jpg?v=1774362975",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV4610/ProductCarouselMain/CV4610%20DUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv4610_Dust.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD05",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#e4e1ca",
      "sort_bucket": "grey",
      "sort_hue": 0.147436,
      "sort_sat": 0.114035,
      "sort_val": 0.894118,
      "swatch_file_id": "gid://shopify/MediaImage/49471386190090",
      "swatch_filename": "GD05_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Natural.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Natural.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#e4e1ca",
      "sort_bucket": "grey",
      "sort_hue": 0.147436,
      "sort_sat": 0.114035,
      "sort_val": 0.894118,
      "swatch_file_id": "gid://shopify/MediaImage/49474268430602",
      "swatch_filename": "GD01_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Natural.jpg?v=1774370890",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Natural.jpg?v=1774370890",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.*",
      "style_code": "GD02",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#e4e1ca",
      "sort_bucket": "grey",
      "sort_hue": 0.147436,
      "sort_sat": 0.114035,
      "sort_val": 0.894118,
      "swatch_file_id": "gid://shopify/MediaImage/49471398871306",
      "swatch_filename": "GD02_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Natural.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Natural.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548559626",
      "product_title": "AWDis Heavyweight Boxy 240 T-Shirt",
      "product_handle": "at003",
      "product_url": "/products/at003",
      "product_full_url": "https://oakdenemerch.com/products/at003",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-at003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT003",
      "colour_name": "Natural Stone",
      "colour_group": "Natural > Natural",
      "rgb": "#f2f2eb",
      "sort_bucket": "grey",
      "sort_hue": 0.166667,
      "sort_sat": 0.028926,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49472884605194",
      "swatch_filename": "AT003_Natural_Stone.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT003_Natural_Stone.jpg?v=1774360180",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT003_Natural_Stone.jpg?v=1774360180",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT003/ProductCarouselMain/AT003%20NTS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at003_Natural_Stone.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT001",
      "colour_name": "Natural Stone",
      "colour_group": "Natural > Natural",
      "rgb": "#f2f2eb",
      "sort_bucket": "grey",
      "sort_hue": 0.166667,
      "sort_sat": 0.028926,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49471442354442",
      "swatch_filename": "AT001_Natural_Stone.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Natural_Stone.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Natural_Stone.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20NTS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Natural_Stone.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% better cotton.*",
      "style_code": "AT002",
      "colour_name": "Natural Stone",
      "colour_group": "Natural > Natural",
      "rgb": "#f2f2eb",
      "sort_bucket": "grey",
      "sort_hue": 0.166667,
      "sort_sat": 0.028926,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49471429607690",
      "swatch_filename": "AT002_Natural_Stone.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Natural_Stone.jpg?v=1774349456",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Natural_Stone.jpg?v=1774349456",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20NTS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Natural_Stone.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "70% organic combed cotton/30% polyester.",
      "style_code": "KB3025IC",
      "colour_name": "Grey Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#65665c",
      "sort_bucket": "grey",
      "sort_hue": 0.183333,
      "sort_sat": 0.098039,
      "sort_val": 0.4,
      "swatch_file_id": "gid://shopify/MediaImage/49491379224842",
      "swatch_filename": "kb3025ic_Grey_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Grey_Heather.jpg?v=1774526644",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Grey_Heather.jpg?v=1774526644",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20GYH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Grey_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552295178",
      "product_title": "Native Spirit Ladies T-Shirt",
      "product_handle": "ns324",
      "product_url": "/products/ns324",
      "product_full_url": "https://oakdenemerch.com/products/ns324",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns324",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS324",
      "colour_name": "Moon Grey Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a0a395",
      "sort_bucket": "grey",
      "sort_hue": 0.202381,
      "sort_sat": 0.08589,
      "sort_val": 0.639216,
      "swatch_file_id": "gid://shopify/MediaImage/49472283705610",
      "swatch_filename": "NS324_Moon_Grey_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Moon_Grey_Heather.jpg?v=1774354240",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS324_Moon_Grey_Heather.jpg?v=1774354240",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS324/ProductCarouselMain/NS324%20MGH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns324_Moon_Grey_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552131338",
      "product_title": "Native Spirit Unisex Heavyweight T-Shirt",
      "product_handle": "ns305",
      "product_url": "/products/ns305",
      "product_full_url": "https://oakdenemerch.com/products/ns305",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-ns305",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS305",
      "colour_name": "Moon Grey Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a0a395",
      "sort_bucket": "grey",
      "sort_hue": 0.202381,
      "sort_sat": 0.08589,
      "sort_val": 0.639216,
      "swatch_file_id": "gid://shopify/MediaImage/49473667301642",
      "swatch_filename": "NS305_Moon_Grey_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Moon_Grey_Heather.jpg?v=1774364708",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/NS305_Moon_Grey_Heather.jpg?v=1774364708",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS305/ProductCarouselMain/NS305%20MGH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns305_Moon_Grey_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549247754",
      "product_title": "Ecologie Arrow Recycled Heavy Oversize T-Shirt",
      "product_handle": "ea006",
      "product_url": "/products/ea006",
      "product_full_url": "https://oakdenemerch.com/products/ea006",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ea006",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "48% recycled cotton/47% recycled polyester/5% elastane.",
      "style_code": "EA006",
      "colour_name": "Stone",
      "colour_group": "Natural > Natural",
      "rgb": "#c9cfb8",
      "sort_bucket": "grey",
      "sort_hue": 0.210145,
      "sort_sat": 0.111111,
      "sort_val": 0.811765,
      "swatch_file_id": "gid://shopify/MediaImage/49472604799242",
      "swatch_filename": "EA006_Stone.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA006_Stone.jpg?v=1774358065",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA006_Stone.jpg?v=1774358065",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA006/ProductCarouselMain/EA006%20STO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea006_Stone.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "Coconut Milk",
      "colour_group": "Natural > Natural",
      "rgb": "#d1d9c2",
      "sort_bucket": "grey",
      "sort_hue": 0.224638,
      "sort_sat": 0.105991,
      "sort_val": 0.85098,
      "swatch_file_id": "gid://shopify/MediaImage/49491379323146",
      "swatch_filename": "kb3025ic_Coconut_Milk.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Coconut_Milk.jpg?v=1774526645",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Coconut_Milk.jpg?v=1774526645",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20CMK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Coconut_Milk.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551639818",
      "product_title": "Kariban Unisex 190IC Crew Neck T-Shirt",
      "product_handle": "kb3032ic",
      "product_url": "/products/kb3032ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3032ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3032IC",
      "colour_name": "Coconut Milk",
      "colour_group": "Natural > Natural",
      "rgb": "#d1d9c2",
      "sort_bucket": "grey",
      "sort_hue": 0.224638,
      "sort_sat": 0.105991,
      "sort_val": 0.85098,
      "swatch_file_id": "gid://shopify/MediaImage/49491367788810",
      "swatch_filename": "kb3032ic_Coconut_Milk.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Coconut_Milk.jpg?v=1774526611",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Coconut_Milk.jpg?v=1774526611",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3032IC/ProductCarouselMain/KB3032IC%20CMK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3032ic_Coconut_Milk.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558193418",
      "product_title": "Tombo Medium Impact Core Bra",
      "product_handle": "tl371",
      "product_url": "/products/tl371",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-tl371",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "86% polyester/14% elastane interlock.",
      "style_code": "TL371",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#212420",
      "sort_bucket": "grey",
      "sort_hue": 0.291667,
      "sort_sat": 0.111111,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49491011698954",
      "swatch_filename": "tl371_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl371_Charcoal.jpg?v=1774525776",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl371_Charcoal.jpg?v=1774525776",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL371/ProductCarouselMain/TL371%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl371_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558357258",
      "product_title": "Tombo Unisex Recycled Performance T-Shirt",
      "product_handle": "tl545",
      "product_url": "/products/tl545",
      "product_full_url": "https://oakdenemerch.com/products/tl545",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "recycled",
        "S",
        "sports",
        "style-tl545",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester interlock.",
      "style_code": "TL545",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#212420",
      "sort_bucket": "grey",
      "sort_hue": 0.291667,
      "sort_sat": 0.111111,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49472019366154",
      "swatch_filename": "TL545_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/TL545_Charcoal.jpg?v=1774353321",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/TL545_Charcoal.jpg?v=1774353321",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL545/ProductCarouselMain/TL545%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl545_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#383b37",
      "sort_bucket": "grey",
      "sort_hue": 0.291667,
      "sort_sat": 0.067797,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49491379847434",
      "swatch_filename": "kb3025ic_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Dark_Grey.jpg?v=1774526646",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Dark_Grey.jpg?v=1774526646",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551639818",
      "product_title": "Kariban Unisex 190IC Crew Neck T-Shirt",
      "product_handle": "kb3032ic",
      "product_url": "/products/kb3032ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3032ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3032IC",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#383b37",
      "sort_bucket": "grey",
      "sort_hue": 0.291667,
      "sort_sat": 0.067797,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49491367985418",
      "swatch_filename": "kb3032ic_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Dark_Grey.jpg?v=1774526613",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Dark_Grey.jpg?v=1774526613",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3032IC/ProductCarouselMain/KB3032IC%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3032ic_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558488330",
      "product_title": "WK Designed to Work Anti-Bacterial Short Sleeve T-Shirt",
      "product_handle": "wk306",
      "product_url": "/products/wk306",
      "product_full_url": "https://oakdenemerch.com/products/wk306",
      "vendor": "WK Designed To Work",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-wk306",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% combed cotton.",
      "style_code": "WK306",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#383b37",
      "sort_bucket": "grey",
      "sort_hue": 0.291667,
      "sort_sat": 0.067797,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49470913544458",
      "swatch_filename": "WK306_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/WK306_Dark_Grey.jpg?v=1774346721",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/WK306_Dark_Grey.jpg?v=1774346721",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/WK%20Designed%20to%20Work/Product%20Images/WK306/ProductCarouselMain/WK306%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "wk306_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552459018",
      "product_title": "Proact Triblend Sports T-Shirt",
      "product_handle": "pa4011",
      "product_url": "/products/pa4011",
      "product_full_url": "https://oakdenemerch.com/products/pa4011",
      "vendor": "Proact",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "sports",
        "style-pa4011",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton/Viscose",
      "shopify_material": "Poly/Cotton/Viscose",
      "csv_material": "50% polyester/25% cotton/25% viscose.",
      "style_code": "PA4011",
      "colour_name": "Dark Grey Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#383b37",
      "sort_bucket": "grey",
      "sort_hue": 0.291667,
      "sort_sat": 0.067797,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49471762071818",
      "swatch_filename": "PA4011_Dark_Grey_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA4011_Dark_Grey_Heather.jpg?v=1774351357",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PA4011_Dark_Grey_Heather.jpg?v=1774351357",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Proact/Product%20Images/PA4011/ProductCarouselMain/PA4011%20DGH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pa4011_Dark_Grey_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Ash",
      "colour_group": "Grey > Light Grey",
      "rgb": "#e1e6e1",
      "sort_bucket": "grey",
      "sort_hue": 0.333333,
      "sort_sat": 0.021739,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49474218393866",
      "swatch_filename": "JC001_Ash.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Ash.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Ash.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20ASH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Ash.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.*",
      "style_code": "KB3025IC",
      "colour_name": "Snow Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#b3b5b3",
      "sort_bucket": "grey",
      "sort_hue": 0.333333,
      "sort_sat": 0.01105,
      "sort_val": 0.709804,
      "swatch_file_id": "gid://shopify/MediaImage/49491380994314",
      "swatch_filename": "kb3025ic_Snow_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Snow_Grey.jpg?v=1774526648",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Snow_Grey.jpg?v=1774526648",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20SNWG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Snow_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562363658",
      "product_title": "Native Spirit Ladies Cropped Tank Top",
      "product_handle": "ns342",
      "product_url": "/products/ns342",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns342",
        "t-shirts",
        "womens",
        "XS",
        "XS-S-M-L"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS342",
      "colour_name": "Washed Ivory",
      "colour_group": "Natural > Natural",
      "rgb": "#d9e3db",
      "sort_bucket": "grey",
      "sort_hue": 0.366667,
      "sort_sat": 0.044053,
      "sort_val": 0.890196,
      "swatch_file_id": "gid://shopify/MediaImage/49513931243786",
      "swatch_filename": "ns342_Washed_Ivory.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns342_Washed_Ivory.jpg?v=1774619061",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns342_Washed_Ivory.jpg?v=1774619061",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS342/ProductCarouselMain/NS342%20WIV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns342_Washed_Ivory.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550820618",
      "product_title": "AWDis Unisex Oversize 100 T-Shirt",
      "product_handle": "jt009",
      "product_url": "/products/jt009",
      "product_full_url": "https://oakdenemerch.com/products/jt009",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jt009",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.*",
      "style_code": "JT009",
      "colour_name": "Natural Stone",
      "colour_group": "Natural > Natural",
      "rgb": "#a4ada6",
      "sort_bucket": "grey",
      "sort_hue": 0.37037,
      "sort_sat": 0.052023,
      "sort_val": 0.678431,
      "swatch_file_id": "gid://shopify/MediaImage/49471818006794",
      "swatch_filename": "JT009_Natural_Stone.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_Natural_Stone.jpg?v=1774351553",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT009_Natural_Stone.jpg?v=1774351553",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT009/ProductCarouselMain/JT009%20NTS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt009_Natural_Stone.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548428554",
      "product_title": "Anthem Amplify Heavyweight T-Shirt",
      "product_handle": "am18",
      "product_url": "/products/am18",
      "product_full_url": "https://oakdenemerch.com/products/am18",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-am18",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM18",
      "colour_name": "Stone",
      "colour_group": "Natural > Natural",
      "rgb": "#a4ada6",
      "sort_bucket": "grey",
      "sort_hue": 0.37037,
      "sort_sat": 0.052023,
      "sort_val": 0.678431,
      "swatch_file_id": "gid://shopify/MediaImage/49472893157642",
      "swatch_filename": "AM18_Stone.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_Stone.jpg?v=1774360285",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_Stone.jpg?v=1774360285",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM18/ProductCarouselMain/AM18%20STO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am18_Stone.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548395786",
      "product_title": "Anthem Unisex Organic Heavyweight T-Shirt",
      "product_handle": "am15",
      "product_url": "/products/am15",
      "product_full_url": "https://oakdenemerch.com/products/am15",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am15",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM15",
      "colour_name": "Stone",
      "colour_group": "Natural > Natural",
      "rgb": "#a4ada6",
      "sort_bucket": "grey",
      "sort_hue": 0.37037,
      "sort_sat": 0.052023,
      "sort_val": 0.678431,
      "swatch_file_id": "gid://shopify/MediaImage/49472895811850",
      "swatch_filename": "AM15_Stone.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Stone.jpg?v=1774360325",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Stone.jpg?v=1774360325",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM15/ProductCarouselMain/AM15%20STO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am15_Stone.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548363018",
      "product_title": "Anthem Unisex Organic Midweight T-Shirt",
      "product_handle": "am12",
      "product_url": "/products/am12",
      "product_full_url": "https://oakdenemerch.com/products/am12",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am12",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM12",
      "colour_name": "Stone",
      "colour_group": "Natural > Natural",
      "rgb": "#a4ada6",
      "sort_bucket": "grey",
      "sort_hue": 0.37037,
      "sort_sat": 0.052023,
      "sort_val": 0.678431,
      "swatch_file_id": "gid://shopify/MediaImage/49472902660362",
      "swatch_filename": "AM12_Stone.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Stone.jpg?v=1774360382",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Stone.jpg?v=1774360382",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM12/ProductCarouselMain/AM12%20STO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am12_Stone.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Stone",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#a4ada6",
      "sort_bucket": "grey",
      "sort_hue": 0.37037,
      "sort_sat": 0.052023,
      "sort_val": 0.678431,
      "swatch_file_id": "gid://shopify/MediaImage/49474088993034",
      "swatch_filename": "RX151_Stone.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Stone.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Stone.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20STO%20FRONT%202.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Stone.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556981002",
      "product_title": "Tee Jays CoolDry™ T-Shirt",
      "product_handle": "t7020",
      "product_url": "/products/t7020",
      "product_full_url": "https://oakdenemerch.com/products/t7020",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t7020",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7020",
      "colour_name": "Cement",
      "colour_group": "Grey > Light Grey",
      "rgb": "#d1d9d4",
      "sort_bucket": "grey",
      "sort_hue": 0.395833,
      "sort_sat": 0.036866,
      "sort_val": 0.85098,
      "swatch_file_id": "gid://shopify/MediaImage/49469012082954",
      "swatch_filename": "T7020_Cement.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_Cement.jpg?v=1774315920",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7020_Cement.jpg?v=1774315920",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7020/ProductCarouselMain/T7020%20CEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7020_Cement.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "Cement",
      "colour_group": "Grey > Light Grey",
      "rgb": "#d1d9d4",
      "sort_bucket": "grey",
      "sort_hue": 0.395833,
      "sort_sat": 0.036866,
      "sort_val": 0.85098,
      "swatch_file_id": "gid://shopify/MediaImage/49471257215242",
      "swatch_filename": "T520_Cement.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Cement.jpg?v=1774348349",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Cement.jpg?v=1774348349",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20CEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_Cement.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557079306",
      "product_title": "Tee Jays Ladies CoolDry™ T-Shirt",
      "product_handle": "t7021",
      "product_url": "/products/t7021",
      "product_full_url": "https://oakdenemerch.com/products/t7021",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-t7021",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Poly/Spandex",
      "shopify_material": "Poly/Spandex",
      "csv_material": "95% CoolDry™ micro polyester/5% spandex.",
      "style_code": "T7021",
      "colour_name": "Cement",
      "colour_group": "Grey > Light Grey",
      "rgb": "#d1d9d4",
      "sort_bucket": "grey",
      "sort_hue": 0.395833,
      "sort_sat": 0.036866,
      "sort_val": 0.85098,
      "swatch_file_id": "gid://shopify/MediaImage/49471676350730",
      "swatch_filename": "T7021_Cement.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_Cement.jpg?v=1774350799",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T7021_Cement.jpg?v=1774350799",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T7021/ProductCarouselMain/T7021%20CEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t7021_Cement.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556587786",
      "product_title": "Tee Jays Ladies Interlock T-Shirt",
      "product_handle": "t580",
      "product_url": "/products/t580",
      "product_full_url": "https://oakdenemerch.com/products/t580",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t580",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T580",
      "colour_name": "Cement",
      "colour_group": "Grey > Light Grey",
      "rgb": "#d1d9d4",
      "sort_bucket": "grey",
      "sort_hue": 0.395833,
      "sort_sat": 0.036866,
      "sort_val": 0.85098,
      "swatch_file_id": "gid://shopify/MediaImage/49469002481930",
      "swatch_filename": "T580_Cement.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Cement.jpg?v=1774315823",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T580_Cement.jpg?v=1774315823",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T580/ProductCarouselMain/T580%20CEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t580_Cement.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555244298",
      "product_title": "Tee Jays Ladies Pima Cotton T-Shirt",
      "product_handle": "t1451",
      "product_url": "/products/t1451",
      "product_full_url": "https://oakdenemerch.com/products/t1451",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t1451",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed pima cotton.",
      "style_code": "T1451",
      "colour_name": "Cement",
      "colour_group": "Grey > Light Grey",
      "rgb": "#d1d9d4",
      "sort_bucket": "grey",
      "sort_hue": 0.395833,
      "sort_sat": 0.036866,
      "sort_val": 0.85098,
      "swatch_file_id": "gid://shopify/MediaImage/49468966273290",
      "swatch_filename": "T1451_Cement.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1451_Cement.jpg?v=1774315339",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1451_Cement.jpg?v=1774315339",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1451/ProductCarouselMain/T1451%20CEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1451_Cement.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557439754",
      "product_title": "Tee Jays Ladies Sof T-Shirt",
      "product_handle": "t8050",
      "product_url": "/products/t8050",
      "product_full_url": "https://oakdenemerch.com/products/t8050",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t8050",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "T8050",
      "colour_name": "Cement",
      "colour_group": "Grey > Light Grey",
      "rgb": "#d1d9d4",
      "sort_bucket": "grey",
      "sort_hue": 0.395833,
      "sort_sat": 0.036866,
      "sort_val": 0.85098,
      "swatch_file_id": "gid://shopify/MediaImage/49470794367242",
      "swatch_filename": "T8050_Cement.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8050_Cement.jpg?v=1774345776",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8050_Cement.jpg?v=1774345776",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8050/ProductCarouselMain/T8050%20CEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8050_Cement.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555178762",
      "product_title": "Tee Jays Pima Cotton T-Shirt",
      "product_handle": "t1450",
      "product_url": "/products/t1450",
      "product_full_url": "https://oakdenemerch.com/products/t1450",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t1450",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed pima cotton.",
      "style_code": "T1450",
      "colour_name": "Cement",
      "colour_group": "Grey > Light Grey",
      "rgb": "#d1d9d4",
      "sort_bucket": "grey",
      "sort_hue": 0.395833,
      "sort_sat": 0.036866,
      "sort_val": 0.85098,
      "swatch_file_id": "gid://shopify/MediaImage/49468963258634",
      "swatch_filename": "T1450_Cement.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1450_Cement.jpg?v=1774315272",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1450_Cement.jpg?v=1774315272",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1450/ProductCarouselMain/T1450%20CEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1450_Cement.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455557341450",
      "product_title": "Tee Jays Sof T-Shirt",
      "product_handle": "t8000",
      "product_url": "/products/t8000",
      "product_full_url": "https://oakdenemerch.com/products/t8000",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t8000",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "T8000",
      "colour_name": "Cement",
      "colour_group": "Grey > Light Grey",
      "rgb": "#d1d9d4",
      "sort_bucket": "grey",
      "sort_hue": 0.395833,
      "sort_sat": 0.036866,
      "sort_val": 0.85098,
      "swatch_file_id": "gid://shopify/MediaImage/49471239094538",
      "swatch_filename": "T8000_Cement.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Cement.jpg?v=1774348259",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T8000_Cement.jpg?v=1774348259",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T8000/ProductCarouselMain/T8000%20CEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t8000_Cement.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554785546",
      "product_title": "Tee Jays Unlabeled Loose Fit T-Shirt",
      "product_handle": "t1160",
      "product_url": "/products/t1160",
      "product_full_url": "https://oakdenemerch.com/products/t1160",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t1160",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T1160",
      "colour_name": "Cement",
      "colour_group": "Grey > Light Grey",
      "rgb": "#d1d9d4",
      "sort_bucket": "grey",
      "sort_hue": 0.395833,
      "sort_sat": 0.036866,
      "sort_val": 0.85098,
      "swatch_file_id": "gid://shopify/MediaImage/49468958802186",
      "swatch_filename": "T1160_Cement.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1160_Cement.jpg?v=1774315207",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1160_Cement.jpg?v=1774315207",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1160/ProductCarouselMain/T1160%20CEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1160_Cement.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554752778",
      "product_title": "Tee Jays Unlabelled Luxury T-Shirt",
      "product_handle": "t1150",
      "product_url": "/products/t1150",
      "product_full_url": "https://oakdenemerch.com/products/t1150",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "style-t1150",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "T1150",
      "colour_name": "Cement",
      "colour_group": "Grey > Light Grey",
      "rgb": "#d1d9d4",
      "sort_bucket": "grey",
      "sort_hue": 0.395833,
      "sort_sat": 0.036866,
      "sort_val": 0.85098,
      "swatch_file_id": "gid://shopify/MediaImage/49474052423946",
      "swatch_filename": "T1150_Cement.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Cement.jpg?v=1774368049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T1150_Cement.jpg?v=1774368049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T1150/ProductCarouselMain/T1150%20CEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t1150_Cement.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548985610",
      "product_title": "Canvas Unisex Tri-Blend T-Shirt",
      "product_handle": "cv3413",
      "product_url": "/products/cv3413",
      "product_full_url": "https://oakdenemerch.com/products/cv3413",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-cv3413",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Cotton/Rayon",
      "shopify_material": "Poly/Cotton/Rayon",
      "csv_material": "50% polyester/25% airlume combed ringspun cotton/25% rayon.",
      "style_code": "CV3413",
      "colour_name": "Athletic Grey Tri-Blend",
      "colour_group": "Grey > Light Grey",
      "rgb": "#6d7973",
      "sort_bucket": "grey",
      "sort_hue": 0.416667,
      "sort_sat": 0.099174,
      "sort_val": 0.47451,
      "swatch_file_id": "gid://shopify/MediaImage/49472609681674",
      "swatch_filename": "CV3413_Athletic_Grey_Tri-Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_Athletic_Grey_Tri-Blend.jpg?v=1774358160",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_Athletic_Grey_Tri-Blend.jpg?v=1774358160",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3413/ProductCarouselMain/CV3413%20ATG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3413_Athletic_Grey_Tri-Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549411594",
      "product_title": "Gildan SoftStyle® EZ T-Shirt",
      "product_handle": "gd04",
      "product_url": "/products/gd04",
      "product_full_url": "https://oakdenemerch.com/products/gd04",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd04",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "GD04",
      "colour_name": "Storm Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#6d7973",
      "sort_bucket": "grey",
      "sort_hue": 0.416667,
      "sort_sat": 0.099174,
      "sort_val": 0.47451,
      "swatch_file_id": "gid://shopify/MediaImage/49468937175306",
      "swatch_filename": "GD04_Storm_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Storm_Grey.jpg?v=1774313523",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD04_Storm_Grey.jpg?v=1774313523",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD04/ProductCarouselMain/GD04%20SRM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd04_Storm_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549116682",
      "product_title": "Ecologie Cascades Organic T-Shirt",
      "product_handle": "ea001",
      "product_url": "/products/ea001",
      "product_full_url": "https://oakdenemerch.com/products/ea001",
      "vendor": "Ecologie",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "style-ea001",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic cotton.",
      "style_code": "EA001",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#adb5b3",
      "sort_bucket": "grey",
      "sort_hue": 0.458333,
      "sort_sat": 0.044199,
      "sort_val": 0.709804,
      "swatch_file_id": "gid://shopify/MediaImage/49474303951114",
      "swatch_filename": "EA001_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Heather_Grey.jpg?v=1774371175",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/EA001_Heather_Grey.jpg?v=1774371175",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Ecologie/Product%20Images/EA001/ProductCarouselMain/EA001%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ea001_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458563150090",
      "product_title": "Tombo Ladies Open Back Vest",
      "product_handle": "tl507",
      "product_url": "/products/tl507",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-tl507",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Rayon",
      "shopify_material": "Poly/Rayon",
      "csv_material": "65% polyester/35% rayon.",
      "style_code": "TL507",
      "colour_name": "Light Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#adc1be",
      "sort_bucket": "grey",
      "sort_hue": 0.475,
      "sort_sat": 0.103627,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49513938714890",
      "swatch_filename": "tl507_Light_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl507_Light_Grey.jpg?v=1774619172",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl507_Light_Grey.jpg?v=1774619172",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Tombo/TL507/ProductCarouselMain/TL507%20LGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl507_Light_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548559626",
      "product_title": "AWDis Heavyweight Boxy 240 T-Shirt",
      "product_handle": "at003",
      "product_url": "/products/at003",
      "product_full_url": "https://oakdenemerch.com/products/at003",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-at003",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% better cotton/10% viscose.",
      "style_code": "AT003",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a2a9a8",
      "sort_bucket": "grey",
      "sort_hue": 0.47619,
      "sort_sat": 0.04142,
      "sort_val": 0.662745,
      "swatch_file_id": "gid://shopify/MediaImage/49472884474122",
      "swatch_filename": "AT003_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT003_Heather_Grey.jpg?v=1774360179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT003_Heather_Grey.jpg?v=1774360179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT003/ProductCarouselMain/AT003%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at003_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686409482",
      "product_title": "AWDis Long Sleeve 180 T-Shirt",
      "product_handle": "at012",
      "product_url": "/products/at012",
      "product_full_url": "https://oakdenemerch.com/products/at012",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-shirt",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-at012",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% better cotton/10% viscose.",
      "style_code": "AT012",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a2a9a8",
      "sort_bucket": "grey",
      "sort_hue": 0.47619,
      "sort_sat": 0.04142,
      "sort_val": 0.662745,
      "swatch_file_id": "gid://shopify/MediaImage/49490399658250",
      "swatch_filename": "at012_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/at012_Heather_Grey.jpg?v=1774522778",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/at012_Heather_Grey.jpg?v=1774522778",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT012/ProductCarouselMain/AT012%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at012_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548494090",
      "product_title": "AWDis Unisex 150 T-Shirt",
      "product_handle": "at001",
      "product_url": "/products/at001",
      "product_full_url": "https://oakdenemerch.com/products/at001",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "children",
        "kids",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at001",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% viscose.",
      "style_code": "AT001",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a2a9a8",
      "sort_bucket": "grey",
      "sort_hue": 0.47619,
      "sort_sat": 0.04142,
      "sort_val": 0.662745,
      "swatch_file_id": "gid://shopify/MediaImage/49471442682122",
      "swatch_filename": "AT001_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Heather_Grey.jpg?v=1774349535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT001_Heather_Grey.jpg?v=1774349535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT001/ProductCarouselMain/AT001%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at001_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548526858",
      "product_title": "AWDis Unisex 180 T-Shirt",
      "product_handle": "at002",
      "product_url": "/products/at002",
      "product_full_url": "https://oakdenemerch.com/products/at002",
      "vendor": "AWDis",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-at002",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% viscose.",
      "style_code": "AT002",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a2a9a8",
      "sort_bucket": "grey",
      "sort_hue": 0.47619,
      "sort_sat": 0.04142,
      "sort_val": 0.662745,
      "swatch_file_id": "gid://shopify/MediaImage/49471430197514",
      "swatch_filename": "AT002_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Heather_Grey.jpg?v=1774349457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AT002_Heather_Grey.jpg?v=1774349457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/AWDis/Product%20Images/AT002/ProductCarouselMain/AT002%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "at002_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552917770",
      "product_title": "Pro RTX Pro T-Shirt",
      "product_handle": "rx151",
      "product_url": "/products/rx151",
      "product_full_url": "https://oakdenemerch.com/products/rx151",
      "vendor": "Pro RTX",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx151",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "RX151",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c5d3d3",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.066351,
      "sort_val": 0.827451,
      "swatch_file_id": "gid://shopify/MediaImage/49474088829194",
      "swatch_filename": "RX151_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Heather_Grey.jpg?v=1774368913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/RX151_Heather_Grey.jpg?v=1774368913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX151/ProductCarouselMain/RX151%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx151_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550034186",
      "product_title": "AWDis Cool T-Shirt",
      "product_handle": "jc001",
      "product_url": "/products/jc001",
      "product_full_url": "https://oakdenemerch.com/products/jc001",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jc001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#9ca6a6",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.060241,
      "sort_val": 0.65098,
      "swatch_file_id": "gid://shopify/MediaImage/49474218492170",
      "swatch_filename": "JC001_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Heather_Grey.jpg?v=1774370457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001_Heather_Grey.jpg?v=1774370457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001/ProductCarouselMain/JC001%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550066954",
      "product_title": "AWDis Kids Cool T-Shirt",
      "product_handle": "jc001b",
      "product_url": "/products/jc001b",
      "product_full_url": "https://oakdenemerch.com/products/jc001b",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "12-13",
        "12-13-3-4-5-6-7-8-9-11",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "kids",
        "PCBest_Seller",
        "style-jc001b",
        "t-shirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC001B",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#9ca6a6",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.060241,
      "sort_val": 0.65098,
      "swatch_file_id": "gid://shopify/MediaImage/49474210201866",
      "swatch_filename": "JC001B_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Heather_Grey.jpg?v=1774370370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC001B_Heather_Grey.jpg?v=1774370370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC001B/ProductCarouselMain/JC001B%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc001b_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550165258",
      "product_title": "AWDis Ladies Cool T-Shirt",
      "product_handle": "jc005",
      "product_url": "/products/jc005",
      "product_full_url": "https://oakdenemerch.com/products/jc005",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-jc005",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "JC005",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#9ca6a6",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.060241,
      "sort_val": 0.65098,
      "swatch_file_id": "gid://shopify/MediaImage/49473142751498",
      "swatch_filename": "JC005_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Heather_Grey.jpg?v=1774362290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC005_Heather_Grey.jpg?v=1774362290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC005/ProductCarouselMain/JC005%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc005_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548264714",
      "product_title": "Russell Athletic Classic Ringspun T-Shirt",
      "product_handle": "180m",
      "product_url": "/products/180m",
      "product_full_url": "https://oakdenemerch.com/products/180m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "knitwear",
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "sports",
        "style-180m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180M",
      "colour_name": "Light Oxford",
      "colour_group": "Grey > Light Grey",
      "rgb": "#919999",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.052288,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49473273331978",
      "swatch_filename": "180M_Light_Oxford.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Light_Oxford.jpg?v=1774363125",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180M_Light_Oxford.jpg?v=1774363125",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180M/ProductCarouselMain/180M%20LXF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180m_Light_Oxford.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546724618",
      "product_title": "Russell Athletic Heavyweight T-Shirt",
      "product_handle": "010m",
      "product_url": "/products/010m",
      "product_full_url": "https://oakdenemerch.com/products/010m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-010m",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.*",
      "style_code": "010M",
      "colour_name": "Light Oxford",
      "colour_group": "Grey > Light Grey",
      "rgb": "#919999",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.052288,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49468778217738",
      "swatch_filename": "010M_Light_Oxford.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/010M_Light_Oxford.jpg?v=1774311231",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/010M_Light_Oxford.jpg?v=1774311231",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/010M/ProductCarouselMain/010M%20LXF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "010m_Light_Oxford.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548231946",
      "product_title": "Russell Athletic Ladies Authentic Classic Ringspun T-Shirt",
      "product_handle": "180f",
      "product_url": "/products/180f",
      "product_full_url": "https://oakdenemerch.com/products/180f",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "knitwear",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-180f",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "180F",
      "colour_name": "Light Oxford",
      "colour_group": "Grey > Light Grey",
      "rgb": "#919999",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.052288,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49472623640842",
      "swatch_filename": "180F_Light_Oxford.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180F_Light_Oxford.jpg?v=1774358324",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/180F_Light_Oxford.jpg?v=1774358324",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/180F/ProductCarouselMain/180F%20LXF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "180f_Light_Oxford.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548428554",
      "product_title": "Anthem Amplify Heavyweight T-Shirt",
      "product_handle": "am18",
      "product_url": "/products/am18",
      "product_full_url": "https://oakdenemerch.com/products/am18",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-am18",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM18",
      "colour_name": "Carbon",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#3d4040",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.046875,
      "sort_val": 0.25098,
      "swatch_file_id": "gid://shopify/MediaImage/49472893190410",
      "swatch_filename": "AM18_Carbon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_Carbon.jpg?v=1774360285",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_Carbon.jpg?v=1774360285",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM18/ProductCarouselMain/AM18%20CBO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am18_Carbon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Carbon",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#3d4040",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.046875,
      "sort_val": 0.25098,
      "swatch_file_id": "gid://shopify/MediaImage/49474343436554",
      "swatch_filename": "AM10_Carbon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Carbon.jpg?v=1774371250",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Carbon.jpg?v=1774371250",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20CBO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Carbon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548395786",
      "product_title": "Anthem Unisex Organic Heavyweight T-Shirt",
      "product_handle": "am15",
      "product_url": "/products/am15",
      "product_full_url": "https://oakdenemerch.com/products/am15",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am15",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM15",
      "colour_name": "Carbon",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#3d4040",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.046875,
      "sort_val": 0.25098,
      "swatch_file_id": "gid://shopify/MediaImage/49472895648010",
      "swatch_filename": "AM15_Carbon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Carbon.jpg?v=1774360325",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Carbon.jpg?v=1774360325",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM15/ProductCarouselMain/AM15%20CBO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am15_Carbon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548363018",
      "product_title": "Anthem Unisex Organic Midweight T-Shirt",
      "product_handle": "am12",
      "product_url": "/products/am12",
      "product_full_url": "https://oakdenemerch.com/products/am12",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am12",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM12",
      "colour_name": "Carbon",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#3d4040",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.046875,
      "sort_val": 0.25098,
      "swatch_file_id": "gid://shopify/MediaImage/49472902398218",
      "swatch_filename": "AM12_Carbon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Carbon.jpg?v=1774360382",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Carbon.jpg?v=1774360382",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM12/ProductCarouselMain/AM12%20CBO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am12_Carbon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556063498",
      "product_title": "Tee Jays Interlock T-Shirt",
      "product_handle": "t520",
      "product_url": "/products/t520",
      "product_full_url": "https://oakdenemerch.com/products/t520",
      "vendor": "Tee Jays",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t520",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "T520",
      "colour_name": "Stone",
      "colour_group": "Grey > Light Grey",
      "rgb": "#888c8c",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.028571,
      "sort_val": 0.54902,
      "swatch_file_id": "gid://shopify/MediaImage/49471257444618",
      "swatch_filename": "T520_Stone.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Stone.jpg?v=1774348349",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/T520_Stone.jpg?v=1774348349",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T520/ProductCarouselMain/T520%20STO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t520_Stone.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562953482",
      "product_title": "Fruit of the Loom Athletic Vest",
      "product_handle": "ss18",
      "product_url": "/products/ss18",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "sleeveless",
        "sports",
        "style-ss18",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "97% cotton/3% polyester.",
      "style_code": "SS18",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49513937699082",
      "swatch_filename": "ss18_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss18_Heather_Grey.jpg?v=1774619151",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss18_Heather_Grey.jpg?v=1774619151",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS18/ProductCarouselMain/SS18%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss18_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552983306",
      "product_title": "Fruit of the Loom Heavy Cotton T-Shirt",
      "product_handle": "sa101",
      "product_url": "/products/sa101",
      "product_full_url": "https://oakdenemerch.com/products/sa101",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-sa101",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "97% cotton/3% polyester.",
      "style_code": "SA101",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49468678635786",
      "swatch_filename": "SA101_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SA101_Heather_Grey.jpg?v=1774309789",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SA101_Heather_Grey.jpg?v=1774309789",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SA101/ProductCarouselMain/SA101%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sa101_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "97% cotton/3% polyester.",
      "style_code": "SS621",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49471286182154",
      "swatch_filename": "SS621_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Heather_Grey.jpg?v=1774348498",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Heather_Grey.jpg?v=1774348498",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457688047882",
      "product_title": "Fruit of the Loom Iconic 195 Long Sleeve T-Shirt",
      "product_handle": "ss624",
      "product_url": "/products/ss624",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-ss624",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "97% cotton/3% polyester.",
      "style_code": "SS624",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49490487181578",
      "swatch_filename": "ss624_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss624_Heather_Grey.jpg?v=1774523033",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss624_Heather_Grey.jpg?v=1774523033",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS624/ProductCarouselMain/SS624%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss624_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554359562",
      "product_title": "Fruit of the Loom Iconic 195 T-Shirt",
      "product_handle": "ss620",
      "product_url": "/products/ss620",
      "product_full_url": "https://oakdenemerch.com/products/ss620",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss620",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "97% cotton/3% polyester.",
      "style_code": "SS620",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49471312986378",
      "swatch_filename": "SS620_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Heather_Grey.jpg?v=1774348566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS620_Heather_Grey.jpg?v=1774348566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS620/ProductCarouselMain/SS620%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss620_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554621706",
      "product_title": "Fruit of the Loom Ladies Iconic 150 T-Shirt",
      "product_handle": "ss721",
      "product_url": "/products/ss721",
      "product_full_url": "https://oakdenemerch.com/products/ss721",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss721",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "97% cotton/3% polyester.",
      "style_code": "SS721",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49472056393994",
      "swatch_filename": "SS721_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Heather_Grey.jpg?v=1774353579",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Heather_Grey.jpg?v=1774353579",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS721/ProductCarouselMain/SS721%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss721_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554588938",
      "product_title": "Fruit of the Loom Ladies Iconic 195 T-Shirt",
      "product_handle": "ss720",
      "product_url": "/products/ss720",
      "product_full_url": "https://oakdenemerch.com/products/ss720",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss720",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "97% cotton/3% polyester.",
      "style_code": "SS720",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49472218824970",
      "swatch_filename": "SS720_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Heather_Grey.jpg?v=1774353681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS720_Heather_Grey.jpg?v=1774353681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS720/ProductCarouselMain/SS720%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss720_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554556170",
      "product_title": "Fruit of the Loom Lady Fit Original T-Shirt",
      "product_handle": "ss712",
      "product_url": "/products/ss712",
      "product_full_url": "https://oakdenemerch.com/products/ss712",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss712",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "97% cotton/3% polyester.",
      "style_code": "SS712",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49472223150346",
      "swatch_filename": "SS712_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS712_Heather_Grey.jpg?v=1774353741",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS712_Heather_Grey.jpg?v=1774353741",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS712/ProductCarouselMain/SS712%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss712_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554654474",
      "product_title": "Fruit of the Loom Lady Fit Value T-Shirt",
      "product_handle": "ss77",
      "product_url": "/products/ss77",
      "product_full_url": "https://oakdenemerch.com/products/ss77",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss77",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "97% cotton/3% polyester.",
      "style_code": "SS77",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49472026149130",
      "swatch_filename": "SS77_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Heather_Grey.jpg?v=1774353471",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS77_Heather_Grey.jpg?v=1774353471",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS77/ProductCarouselMain/SS77%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss77_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554523402",
      "product_title": "Fruit of the Loom Lady Fit Value V Neck T-Shirt",
      "product_handle": "ss702",
      "product_url": "/products/ss702",
      "product_full_url": "https://oakdenemerch.com/products/ss702",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss702",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "97% cotton/3% polyester.",
      "style_code": "SS702",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49472224133386",
      "swatch_filename": "SS702_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS702_Heather_Grey.jpg?v=1774353786",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS702_Heather_Grey.jpg?v=1774353786",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS702/ProductCarouselMain/SS702%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss702_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687982346",
      "product_title": "Fruit of the Loom Long Sleeve Value T-Shirt",
      "product_handle": "ss21",
      "product_url": "/products/ss21",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "knitwear",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss21",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "97% cotton/3% polyester.",
      "style_code": "SS21",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49490486133002",
      "swatch_filename": "ss21_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss21_Heather_Grey.jpg?v=1774523019",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss21_Heather_Grey.jpg?v=1774523019",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS21/ProductCarouselMain/SS21%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss21_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554228490",
      "product_title": "Fruit of the Loom Original T-Shirt",
      "product_handle": "ss12",
      "product_url": "/products/ss12",
      "product_full_url": "https://oakdenemerch.com/products/ss12",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "97% cotton/3% polyester.",
      "style_code": "SS12",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49471330353418",
      "swatch_filename": "SS12_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Heather_Grey.jpg?v=1774348718",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS12_Heather_Grey.jpg?v=1774348718",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS12/ProductCarouselMain/SS12%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss12_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554195722",
      "product_title": "Fruit of the Loom Super Premium T-Shirt",
      "product_handle": "ss10",
      "product_url": "/products/ss10",
      "product_full_url": "https://oakdenemerch.com/products/ss10",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss10",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "97% cotton/3% polyester.",
      "style_code": "SS10",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49471341592842",
      "swatch_filename": "SS10_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_Heather_Grey.jpg?v=1774348796",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS10_Heather_Grey.jpg?v=1774348796",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS10/ProductCarouselMain/SS10%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss10_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554490634",
      "product_title": "Fruit of the Loom V Neck Value T-Shirt",
      "product_handle": "ss7",
      "product_url": "/products/ss7",
      "product_full_url": "https://oakdenemerch.com/products/ss7",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss7",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "97% cotton/3% polyester.",
      "style_code": "SS7",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49471272091914",
      "swatch_filename": "SS7_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Heather_Grey.jpg?v=1774348430",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS7_Heather_Grey.jpg?v=1774348430",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS7/ProductCarouselMain/SS7%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss7_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554326794",
      "product_title": "Fruit of the Loom Value T-Shirt",
      "product_handle": "ss6",
      "product_url": "/products/ss6",
      "product_full_url": "https://oakdenemerch.com/products/ss6",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss6",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "97% cotton/3% polyester.",
      "style_code": "SS6",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49471321964810",
      "swatch_filename": "SS6_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Heather_Grey.jpg?v=1774348652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS6_Heather_Grey.jpg?v=1774348652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS6/ProductCarouselMain/SS6%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss6_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554392330",
      "product_title": "Fruit of the Loom Iconic 150 T-Shirt",
      "product_handle": "ss621",
      "product_url": "/products/ss621",
      "product_full_url": "https://oakdenemerch.com/products/ss621",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss621",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% recycled polyester",
      "style_code": "SS621",
      "colour_name": "Athletic Heather",
      "colour_group": "Grey > Light Grey",
      "rgb": "#a6b5b8",
      "sort_bucket": "grey",
      "sort_hue": 0.527778,
      "sort_sat": 0.097826,
      "sort_val": 0.721569,
      "swatch_file_id": "gid://shopify/MediaImage/49471286313226",
      "swatch_filename": "SS621_Athletic_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Athletic_Heather.jpg?v=1774348499",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS621_Athletic_Heather.jpg?v=1774348499",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS621/ProductCarouselMain/SS621%20AHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss621_Athletic_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455554621706",
      "product_title": "Fruit of the Loom Ladies Iconic 150 T-Shirt",
      "product_handle": "ss721",
      "product_url": "/products/ss721",
      "product_full_url": "https://oakdenemerch.com/products/ss721",
      "vendor": "Fruit of the Loom",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ss721",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% recycled polyester.",
      "style_code": "SS721",
      "colour_name": "Athletic Heather",
      "colour_group": "Grey > Light Grey",
      "rgb": "#a6b5b8",
      "sort_bucket": "grey",
      "sort_hue": 0.527778,
      "sort_sat": 0.097826,
      "sort_val": 0.721569,
      "swatch_file_id": "gid://shopify/MediaImage/49472056131850",
      "swatch_filename": "SS721_Athletic_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Athletic_Heather.jpg?v=1774353578",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SS721_Athletic_Heather.jpg?v=1774353578",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Fruit%20of%20the%20Loom/SS721/ProductCarouselMain/SS721%20AHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss721_Athletic_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551607050",
      "product_title": "Kariban BIO150IC Crew Neck T-Shirt",
      "product_handle": "kb3025ic",
      "product_url": "/products/kb3025ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3025ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% organic combed cotton/10% viscose.",
      "style_code": "KB3025IC",
      "colour_name": "Oxford Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#9fa8aa",
      "sort_bucket": "grey",
      "sort_hue": 0.530303,
      "sort_sat": 0.064706,
      "sort_val": 0.666667,
      "swatch_file_id": "gid://shopify/MediaImage/49491381715210",
      "swatch_filename": "kb3025ic_Oxford_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Oxford_Grey.jpg?v=1774526650",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3025ic_Oxford_Grey.jpg?v=1774526650",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3025IC/ProductCarouselMain/KB3025IC%20OXF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3025ic_Oxford_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551672586",
      "product_title": "Kariban Crew Neck T-Shirt",
      "product_handle": "kb356",
      "product_url": "/products/kb356",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb356",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% viscose.",
      "style_code": "KB356",
      "colour_name": "Oxford Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#9fa8aa",
      "sort_bucket": "grey",
      "sort_hue": 0.530303,
      "sort_sat": 0.064706,
      "sort_val": 0.666667,
      "swatch_file_id": "gid://shopify/MediaImage/49491362054410",
      "swatch_filename": "kb356_Oxford_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb356_Oxford_Grey.jpg?v=1774526593",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb356_Oxford_Grey.jpg?v=1774526593",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB356/ProductCarouselMain/KB356%20OXF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb356_Oxford_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562167050",
      "product_title": "Kariban Eco-Friendly Tank Top",
      "product_handle": "kb3023ic",
      "product_url": "/products/kb3023ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3023ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% organic combed cotton/10% viscose.",
      "style_code": "KB3023IC",
      "colour_name": "Oxford Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#9fa8aa",
      "sort_bucket": "grey",
      "sort_hue": 0.530303,
      "sort_sat": 0.064706,
      "sort_val": 0.666667,
      "swatch_file_id": "gid://shopify/MediaImage/49513929015562",
      "swatch_filename": "kb3023ic_Oxford_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3023ic_Oxford_Grey.jpg?v=1774619027",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3023ic_Oxford_Grey.jpg?v=1774619027",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3023IC/ProductCarouselMain/KB3023IC%20OXF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3023ic_Oxford_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562265354",
      "product_title": "Kariban Ladies Eco-Friendly Tank Top",
      "product_handle": "kb3024ic",
      "product_url": "/products/kb3024ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-kb3024ic",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% organic combed cotton/10% viscose.",
      "style_code": "KB3024IC",
      "colour_name": "Oxford Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#9fa8aa",
      "sort_bucket": "grey",
      "sort_hue": 0.530303,
      "sort_sat": 0.064706,
      "sort_val": 0.666667,
      "swatch_file_id": "gid://shopify/MediaImage/49513929605386",
      "swatch_filename": "kb3024ic_Oxford_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3024ic_Oxford_Grey.jpg?v=1774619036",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3024ic_Oxford_Grey.jpg?v=1774619036",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3024IC/ProductCarouselMain/KB3024IC%20OXF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3024ic_Oxford_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551639818",
      "product_title": "Kariban Unisex 190IC Crew Neck T-Shirt",
      "product_handle": "kb3032ic",
      "product_url": "/products/kb3032ic",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-kb3032ic",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% viscose.",
      "style_code": "KB3032IC",
      "colour_name": "Oxford Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#9fa8aa",
      "sort_bucket": "grey",
      "sort_hue": 0.530303,
      "sort_sat": 0.064706,
      "sort_val": 0.666667,
      "swatch_file_id": "gid://shopify/MediaImage/49491368509706",
      "swatch_filename": "kb3032ic_Oxford_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Oxford_Grey.jpg?v=1774526614",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb3032ic_Oxford_Grey.jpg?v=1774526614",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB3032IC/ProductCarouselMain/KB3032IC%20OXF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb3032ic_Oxford_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455558488330",
      "product_title": "WK Designed to Work Anti-Bacterial Short Sleeve T-Shirt",
      "product_handle": "wk306",
      "product_url": "/products/wk306",
      "product_full_url": "https://oakdenemerch.com/products/wk306",
      "vendor": "WK Designed To Work",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-wk306",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% combed cotton.",
      "style_code": "WK306",
      "colour_name": "Oxford Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#9fa8aa",
      "sort_bucket": "grey",
      "sort_hue": 0.530303,
      "sort_sat": 0.064706,
      "sort_val": 0.666667,
      "swatch_file_id": "gid://shopify/MediaImage/49470913446154",
      "swatch_filename": "WK306_Oxford_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/WK306_Oxford_Grey.jpg?v=1774346721",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/WK306_Oxford_Grey.jpg?v=1774346721",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/WK%20Designed%20to%20Work/Product%20Images/WK306/ProductCarouselMain/WK306%20OXF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "wk306_Oxford_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548690698",
      "product_title": "Bella Ladies Heavy Boxy T-Shirt",
      "product_handle": "bl6110",
      "product_url": "/products/bl6110",
      "product_full_url": "https://oakdenemerch.com/products/bl6110",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-bl6110",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "BL6110",
      "colour_name": "Athletic Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#97a7ab",
      "sort_bucket": "grey",
      "sort_hue": 0.533333,
      "sort_sat": 0.116959,
      "sort_val": 0.670588,
      "swatch_file_id": "gid://shopify/MediaImage/49472881590538",
      "swatch_filename": "BL6110_Athletic_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_Athletic_Heather.jpg?v=1774360125",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/BL6110_Athletic_Heather.jpg?v=1774360125",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL6110/ProductCarouselMain/BL6110%20AHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl6110_Athletic_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548592394",
      "product_title": "Bella Ladies Micro Rib Baby T-Shirt",
      "product_handle": "bl1010",
      "product_url": "/products/bl1010",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "M",
        "S",
        "style-bl1010",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1010",
      "colour_name": "Athletic Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#97a7ab",
      "sort_bucket": "grey",
      "sort_hue": 0.533333,
      "sort_sat": 0.116959,
      "sort_val": 0.670588,
      "swatch_file_id": "gid://shopify/MediaImage/49491501089034",
      "swatch_filename": "bl1010_Athletic_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1010_Athletic_Heather.jpg?v=1774526823",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1010_Athletic_Heather.jpg?v=1774526823",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1010/ProductCarouselMain/BL1010%20AHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1010_Athletic_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561839370",
      "product_title": "Bella Ladies Micro Rib Racer Tank Top",
      "product_handle": "bl1019",
      "product_url": "/products/bl1019",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-bl1019",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1019",
      "colour_name": "Athletic Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#97a7ab",
      "sort_bucket": "grey",
      "sort_hue": 0.533333,
      "sort_sat": 0.116959,
      "sort_val": 0.670588,
      "swatch_file_id": "gid://shopify/MediaImage/49513918529802",
      "swatch_filename": "bl1019_Athletic_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1019_Athletic_Heather.jpg?v=1774618927",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1019_Athletic_Heather.jpg?v=1774618927",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1019/ProductCarouselMain/BL1019%20AHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1019_Athletic_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561806602",
      "product_title": "Bella Ladies Micro Rib Spaghetti Strap Tank Top",
      "product_handle": "bl1012",
      "product_url": "/products/bl1012",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-bl1012",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1012",
      "colour_name": "Athletic Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#97a7ab",
      "sort_bucket": "grey",
      "sort_hue": 0.533333,
      "sort_sat": 0.116959,
      "sort_val": 0.670588,
      "swatch_file_id": "gid://shopify/MediaImage/49513917055242",
      "swatch_filename": "bl1012_Athletic_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1012_Athletic_Heather.jpg?v=1774618914",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1012_Athletic_Heather.jpg?v=1774618914",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1012/ProductCarouselMain/BL1012%20AHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1012_Athletic_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686475018",
      "product_title": "Bella Micro Rib Long Sleeve Baby T-Shirt",
      "product_handle": "bl1501",
      "product_url": "/products/bl1501",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "baby",
        "baby-toddler",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-bl1501",
        "t-shirts",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% airlume combed ringspun cotton/48% polyester.*",
      "style_code": "BL1501",
      "colour_name": "Athletic Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#97a7ab",
      "sort_bucket": "grey",
      "sort_hue": 0.533333,
      "sort_sat": 0.116959,
      "sort_val": 0.670588,
      "swatch_file_id": "gid://shopify/MediaImage/49490405163274",
      "swatch_filename": "bl1501_Athletic_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1501_Athletic_Heather.jpg?v=1774522785",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bl1501_Athletic_Heather.jpg?v=1774522785",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/BL1501/ProductCarouselMain/BL1501%20AHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bl1501_Athletic_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548920074",
      "product_title": "Canvas Unisex Heavyweight Boxy T-Shirt",
      "product_handle": "cv3010",
      "product_url": "/products/cv3010",
      "product_full_url": "https://oakdenemerch.com/products/cv3010",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv3010",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3010",
      "colour_name": "Athletic Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#97a7ab",
      "sort_bucket": "grey",
      "sort_hue": 0.533333,
      "sort_sat": 0.116959,
      "sort_val": 0.670588,
      "swatch_file_id": "gid://shopify/MediaImage/49472879526154",
      "swatch_filename": "CV3010_Athletic_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_Athletic_Heather.jpg?v=1774360083",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_Athletic_Heather.jpg?v=1774360083",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3010/ProductCarouselMain/CV3010%20AHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3010_Athletic_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686737162",
      "product_title": "Canvas Unisex Heavyweight Long Sleeve Boxy T-Shirt",
      "product_handle": "cv3511",
      "product_url": "/products/cv3511",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv3511",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3511",
      "colour_name": "Athletic Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#97a7ab",
      "sort_bucket": "grey",
      "sort_hue": 0.533333,
      "sort_sat": 0.116959,
      "sort_val": 0.670588,
      "swatch_file_id": "gid://shopify/MediaImage/49490429411594",
      "swatch_filename": "cv3511_Athletic_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_Athletic_Heather.jpg?v=1774522808",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_Athletic_Heather.jpg?v=1774522808",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3511/ProductCarouselMain/CV3511%20AHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3511_Athletic_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548985610",
      "product_title": "Canvas Unisex Tri-Blend T-Shirt",
      "product_handle": "cv3413",
      "product_url": "/products/cv3413",
      "product_full_url": "https://oakdenemerch.com/products/cv3413",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-cv3413",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Cotton/Rayon",
      "shopify_material": "Poly/Cotton/Rayon",
      "csv_material": "50% polyester/25% airlume combed ringspun cotton/25% rayon.",
      "style_code": "CV3413",
      "colour_name": "Grey Tri-Blend",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#a7b8bd",
      "sort_bucket": "grey",
      "sort_hue": 0.537879,
      "sort_sat": 0.116402,
      "sort_val": 0.741176,
      "swatch_file_id": "gid://shopify/MediaImage/49472609812746",
      "swatch_filename": "CV3413_Grey_Tri-Blend.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_Grey_Tri-Blend.jpg?v=1774358161",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3413_Grey_Tri-Blend.jpg?v=1774358161",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3413/ProductCarouselMain/CV3413%20GRE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3413_Grey_Tri-Blend.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549706506",
      "product_title": "Gildan Hammer Heavyweight T-Shirt",
      "product_handle": "gd21",
      "product_url": "/products/gd21",
      "product_full_url": "https://oakdenemerch.com/products/gd21",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-gd21",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD21",
      "colour_name": "Sport Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8487",
      "sort_bucket": "grey",
      "sort_hue": 0.538462,
      "sort_sat": 0.096296,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49470943232266",
      "swatch_filename": "GD21_Sport_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD21_Sport_Grey.jpg?v=1774347003",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD21_Sport_Grey.jpg?v=1774347003",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD21/ProductCarouselMain/GD21%20SGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd21_Sport_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549509898",
      "product_title": "Gildan Heavy Cotton™ Toddler T-Shirt",
      "product_handle": "gd05p",
      "product_url": "/products/gd05p",
      "product_full_url": "https://oakdenemerch.com/products/gd05p",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "2T",
        "2T-3T-4T-5T-6T",
        "3T",
        "4T",
        "5T",
        "6T",
        "baby-toddler",
        "style-gd05p",
        "t-shirts",
        "unisex"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD05P",
      "colour_name": "Sport Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8487",
      "sort_bucket": "grey",
      "sort_hue": 0.538462,
      "sort_sat": 0.096296,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49474248868106",
      "swatch_filename": "GD05P_Sport_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05P_Sport_Grey.jpg?v=1774370725",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05P_Sport_Grey.jpg?v=1774370725",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05P/ProductCarouselMain/GD05P%20SGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05p_Sport_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549903114",
      "product_title": "Gildan Ladies Heavy Cotton™ T-Shirt",
      "product_handle": "gd95",
      "product_url": "/products/gd95",
      "product_full_url": "https://oakdenemerch.com/products/gd95",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd95",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD95",
      "colour_name": "Sport Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8487",
      "sort_bucket": "grey",
      "sort_hue": 0.538462,
      "sort_sat": 0.096296,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49468944154890",
      "swatch_filename": "GD95_Sport_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD95_Sport_Grey.jpg?v=1774314277",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD95_Sport_Grey.jpg?v=1774314277",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD95/ProductCarouselMain/GD95%20SGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd95_Sport_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549837578",
      "product_title": "Gildan Ladies SoftStyle® Midweight T-Shirt",
      "product_handle": "gd92",
      "product_url": "/products/gd92",
      "product_full_url": "https://oakdenemerch.com/products/gd92",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd92",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD92",
      "colour_name": "Sport Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8487",
      "sort_bucket": "grey",
      "sort_hue": 0.538462,
      "sort_sat": 0.096296,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49468942156042",
      "swatch_filename": "GD92_Sport_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD92_Sport_Grey.jpg?v=1774314178",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD92_Sport_Grey.jpg?v=1774314178",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD92/ProductCarouselMain/GD92%20SGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd92_Sport_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549772042",
      "product_title": "Gildan Ladies SoftStyle® T-Shirt",
      "product_handle": "gd72",
      "product_url": "/products/gd72",
      "product_full_url": "https://oakdenemerch.com/products/gd72",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd72",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD72",
      "colour_name": "Sport Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8487",
      "sort_bucket": "grey",
      "sort_hue": 0.538462,
      "sort_sat": 0.096296,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49468940648714",
      "swatch_filename": "GD72_Sport_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Sport_Grey.jpg?v=1774314002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Sport_Grey.jpg?v=1774314002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD72/ProductCarouselMain/GD72%20SGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd72_Sport_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561970442",
      "product_title": "Gildan Ladies SoftStyle® Tank Top",
      "product_handle": "gd77",
      "product_url": "/products/gd77",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd77",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD77",
      "colour_name": "Sport Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8487",
      "sort_bucket": "grey",
      "sort_hue": 0.538462,
      "sort_sat": 0.096296,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49513921446154",
      "swatch_filename": "gd77_Sport_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd77_Sport_Grey.jpg?v=1774618957",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd77_Sport_Grey.jpg?v=1774618957",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD77/ProductCarouselMain/GD77%20SGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd77_Sport_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549804810",
      "product_title": "Gildan Ladies SoftStyle® V Neck T-Shirt",
      "product_handle": "gd78",
      "product_url": "/products/gd78",
      "product_full_url": "https://oakdenemerch.com/products/gd78",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd78",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD78",
      "colour_name": "Sport Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8487",
      "sort_bucket": "grey",
      "sort_hue": 0.538462,
      "sort_sat": 0.096296,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49471832719626",
      "swatch_filename": "GD78_Sport_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD78_Sport_Grey.jpg?v=1774351724",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD78_Sport_Grey.jpg?v=1774351724",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD78/ProductCarouselMain/GD78%20SGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd78_Sport_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester",
      "style_code": "GD01",
      "colour_name": "Sport Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8487",
      "sort_bucket": "grey",
      "sort_hue": 0.538462,
      "sort_sat": 0.096296,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49474266726666",
      "swatch_filename": "GD01_Sport_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Sport_Grey.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Sport_Grey.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20SGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Sport_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686966538",
      "product_title": "Gildan SoftStyle® Long Sleeve T-Shirt",
      "product_handle": "gd11",
      "product_url": "/products/gd11",
      "product_full_url": "https://oakdenemerch.com/products/gd11",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd11",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD11",
      "colour_name": "Sport Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8487",
      "sort_bucket": "grey",
      "sort_hue": 0.538462,
      "sort_sat": 0.096296,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49490450153738",
      "swatch_filename": "gd11_Sport_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Sport_Grey.jpg?v=1774522837",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd11_Sport_Grey.jpg?v=1774522837",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD11/ProductCarouselMain/GD11%20SGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd11_Sport_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD15",
      "colour_name": "Sport Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8487",
      "sort_bucket": "grey",
      "sort_hue": 0.538462,
      "sort_sat": 0.096296,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49471368986890",
      "swatch_filename": "GD15_Sport_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Sport_Grey.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Sport_Grey.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20SGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Sport_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458561937674",
      "product_title": "Gildan SoftStyle® Tank Top",
      "product_handle": "gd12",
      "product_url": "/products/gd12",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd12",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD12",
      "colour_name": "Sport Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8487",
      "sort_bucket": "grey",
      "sort_hue": 0.538462,
      "sort_sat": 0.096296,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49513919709450",
      "swatch_filename": "gd12_Sport_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd12_Sport_Grey.jpg?v=1774618945",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd12_Sport_Grey.jpg?v=1774618945",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD12/ProductCarouselMain/GD12%20SGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd12_Sport_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549575434",
      "product_title": "Gildan SoftStyle® V Neck T-Shirt",
      "product_handle": "gd10",
      "product_url": "/products/gd10",
      "product_full_url": "https://oakdenemerch.com/products/gd10",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd10",
        "t-shirts",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD10",
      "colour_name": "Sport Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8487",
      "sort_bucket": "grey",
      "sort_hue": 0.538462,
      "sort_sat": 0.096296,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49468938682634",
      "swatch_filename": "GD10_Sport_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD10_Sport_Grey.jpg?v=1774313702",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD10_Sport_Grey.jpg?v=1774313702",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD10/ProductCarouselMain/GD10%20SGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd10_Sport_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD14",
      "colour_name": "Sport Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8487",
      "sort_bucket": "grey",
      "sort_hue": 0.538462,
      "sort_sat": 0.096296,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49490464866570",
      "swatch_filename": "gd14_Sport_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Sport_Grey.jpg?v=1774522864",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Sport_Grey.jpg?v=1774522864",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20SGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Sport_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "GD02",
      "colour_name": "Sport Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8487",
      "sort_bucket": "grey",
      "sort_hue": 0.538462,
      "sort_sat": 0.096296,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49471398773002",
      "swatch_filename": "GD02_Sport_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Sport_Grey.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Sport_Grey.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20SGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Sport_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "98% organic cotton/2% viscose",
      "style_code": "03582",
      "colour_name": "Ash",
      "colour_group": "Grey > Light Grey",
      "rgb": "#bfc5c7",
      "sort_bucket": "grey",
      "sort_hue": 0.541667,
      "sort_sat": 0.040201,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49474468184330",
      "swatch_filename": "03582_Ash.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Ash.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Ash.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20ASH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Ash.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548068106",
      "product_title": "SOL'S Imperial Heavy T-Shirt",
      "product_handle": "11500",
      "product_url": "/products/11500",
      "product_full_url": "https://oakdenemerch.com/products/11500",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11500",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "98% cotton/2% viscose.",
      "style_code": "11500",
      "colour_name": "Ash",
      "colour_group": "Grey > Light Grey",
      "rgb": "#bfc5c7",
      "sort_bucket": "grey",
      "sort_hue": 0.541667,
      "sort_sat": 0.040201,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49474448097546",
      "swatch_filename": "11500_Ash.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Ash.jpg?v=1774371836",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11500_Ash.jpg?v=1774371836",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11500/ProductCarouselMain/11500%20ASH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11500_Ash.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "98% organic cotton/2% viscose",
      "style_code": "03581",
      "colour_name": "Ash",
      "colour_group": "Grey > Light Grey",
      "rgb": "#bfc5c7",
      "sort_bucket": "grey",
      "sort_hue": 0.541667,
      "sort_sat": 0.040201,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49468835823882",
      "swatch_filename": "03581_Ash.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Ash.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Ash.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20ASH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Ash.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "98% cotton/2% viscose.",
      "style_code": "11502",
      "colour_name": "Ash",
      "colour_group": "Grey > Light Grey",
      "rgb": "#bfc5c7",
      "sort_bucket": "grey",
      "sort_hue": 0.541667,
      "sort_sat": 0.040201,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49468933243146",
      "swatch_filename": "11502_Ash.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Ash.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Ash.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20ASH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Ash.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547248906",
      "product_title": "SOL'S Ladies Pioneer Organic T-Shirt",
      "product_handle": "03579",
      "product_url": "/products/03579",
      "product_full_url": "https://oakdenemerch.com/products/03579",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03579",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "98% organic cotton/2% viscose.",
      "style_code": "03579",
      "colour_name": "Ash",
      "colour_group": "Grey > Light Grey",
      "rgb": "#bfc5c7",
      "sort_bucket": "grey",
      "sort_hue": 0.541667,
      "sort_sat": 0.040201,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49468833595658",
      "swatch_filename": "03579_Ash.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Ash.jpg?v=1774312230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03579_Ash.jpg?v=1774312230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03579/ProductCarouselMain/03579%20ASH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03579_Ash.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547216138",
      "product_title": "SOL'S Pioneer Organic T-Shirt",
      "product_handle": "03565",
      "product_url": "/products/03565",
      "product_full_url": "https://oakdenemerch.com/products/03565",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03565",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "98% organic cotton/2% viscose",
      "style_code": "03565",
      "colour_name": "Ash",
      "colour_group": "Grey > Light Grey",
      "rgb": "#bfc5c7",
      "sort_bucket": "grey",
      "sort_hue": 0.541667,
      "sort_sat": 0.040201,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49473305772298",
      "swatch_filename": "03565_Ash.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Ash.jpg?v=1774363313",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03565_Ash.jpg?v=1774363313",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03565/ProductCarouselMain/03565%20ASH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03565_Ash.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "98% cotton/2% viscose.",
      "style_code": "11380",
      "colour_name": "Ash",
      "colour_group": "Grey > Light Grey",
      "rgb": "#bfc5c7",
      "sort_bucket": "grey",
      "sort_hue": 0.541667,
      "sort_sat": 0.040201,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49473718190346",
      "swatch_filename": "11380_Ash.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Ash.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Ash.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20ASH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Ash.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548887306",
      "product_title": "Canvas Unisex Crew Neck T-Shirt",
      "product_handle": "cv3001",
      "product_url": "/products/cv3001",
      "product_full_url": "https://oakdenemerch.com/products/cv3001",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-cv3001",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.",
      "style_code": "CV3001",
      "colour_name": "Asphalt",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#535759",
      "sort_bucket": "grey",
      "sort_hue": 0.555556,
      "sort_sat": 0.067416,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49473258881290",
      "swatch_filename": "CV3001_Asphalt.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Asphalt.jpg?v=1774363054",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3001_Asphalt.jpg?v=1774363054",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3001/ProductCarouselMain/CV3001%20ASP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3001_Asphalt.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548100874",
      "product_title": "SOL'S Ladies Imperial Heavy T-Shirt",
      "product_handle": "11502",
      "product_url": "/products/11502",
      "product_full_url": "https://oakdenemerch.com/products/11502",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11502",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11502",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#535759",
      "sort_bucket": "grey",
      "sort_hue": 0.555556,
      "sort_sat": 0.067416,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49468933701898",
      "swatch_filename": "11502_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Dark_Grey.jpg?v=1774313009",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11502_Dark_Grey.jpg?v=1774313009",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11502/ProductCarouselMain/11502%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11502_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548035338",
      "product_title": "SOL'S Ladies Moon V Neck T-Shirt",
      "product_handle": "11388",
      "product_url": "/products/11388",
      "product_full_url": "https://oakdenemerch.com/products/11388",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-11388",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11388",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#535759",
      "sort_bucket": "grey",
      "sort_hue": 0.555556,
      "sort_sat": 0.067416,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49468932260106",
      "swatch_filename": "11388_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_Dark_Grey.jpg?v=1774312856",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11388_Dark_Grey.jpg?v=1774312856",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11388/ProductCarouselMain/11388%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11388_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546888458",
      "product_title": "SOL'S Ladies Regent T-Shirt",
      "product_handle": "01825",
      "product_url": "/products/01825",
      "product_full_url": "https://oakdenemerch.com/products/01825",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-01825",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "01825",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#535759",
      "sort_bucket": "grey",
      "sort_hue": 0.555556,
      "sort_sat": 0.067416,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49468823339274",
      "swatch_filename": "01825_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Dark_Grey.jpg?v=1774311909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01825_Dark_Grey.jpg?v=1774311909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01825/ProductCarouselMain/01825%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01825_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686049034",
      "product_title": "SOL'S Monarch Long Sleeve T-Shirt",
      "product_handle": "11420",
      "product_url": "/products/11420",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-11420",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% semi-combed ringspun cotton.*",
      "style_code": "11420",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#535759",
      "sort_bucket": "grey",
      "sort_hue": 0.555556,
      "sort_sat": 0.067416,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49490371674378",
      "swatch_filename": "11420_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Dark_Grey.jpg?v=1774522752",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11420_Dark_Grey.jpg?v=1774522752",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11420/ProductCarouselMain/11420%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11420_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547871498",
      "product_title": "SOL'S Regent Fit T-Shirt",
      "product_handle": "10553",
      "product_url": "/products/10553",
      "product_full_url": "https://oakdenemerch.com/products/10553",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-10553",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "10553",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#535759",
      "sort_bucket": "grey",
      "sort_hue": 0.555556,
      "sort_sat": 0.067416,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49472628850954",
      "swatch_filename": "10553_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_Dark_Grey.jpg?v=1774358391",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/10553_Dark_Grey.jpg?v=1774358391",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/10553/ProductCarouselMain/10553%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "10553_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548002570",
      "product_title": "SOL'S Regent T-Shirt",
      "product_handle": "11380",
      "product_url": "/products/11380",
      "product_full_url": "https://oakdenemerch.com/products/11380",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-11380",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL-5XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.*",
      "style_code": "11380",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#535759",
      "sort_bucket": "grey",
      "sort_hue": 0.555556,
      "sort_sat": 0.067416,
      "sort_val": 0.34902,
      "swatch_file_id": "gid://shopify/MediaImage/49473718944010",
      "swatch_filename": "11380_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Dark_Grey.jpg?v=1774364943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/11380_Dark_Grey.jpg?v=1774364943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/11380/ProductCarouselMain/11380%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "11380_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687097610",
      "product_title": "Gildan Hammer Heavyweight Long Sleeve T-Shirt",
      "product_handle": "gd22",
      "product_url": "/products/gd22",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-gd22",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD22",
      "colour_name": "Graphite Heather",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#74787a",
      "sort_bucket": "grey",
      "sort_hue": 0.555556,
      "sort_sat": 0.04918,
      "sort_val": 0.478431,
      "swatch_file_id": "gid://shopify/MediaImage/49490468569354",
      "swatch_filename": "gd22_Graphite_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd22_Graphite_Heather.jpg?v=1774522873",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd22_Graphite_Heather.jpg?v=1774522873",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD22/ProductCarouselMain/GD22%20GHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd22_Graphite_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549706506",
      "product_title": "Gildan Hammer Heavyweight T-Shirt",
      "product_handle": "gd21",
      "product_url": "/products/gd21",
      "product_full_url": "https://oakdenemerch.com/products/gd21",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-gd21",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD21",
      "colour_name": "Graphite Heather",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#74787a",
      "sort_bucket": "grey",
      "sort_hue": 0.555556,
      "sort_sat": 0.04918,
      "sort_val": 0.478431,
      "swatch_file_id": "gid://shopify/MediaImage/49470943396106",
      "swatch_filename": "GD21_Graphite_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD21_Graphite_Heather.jpg?v=1774347002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD21_Graphite_Heather.jpg?v=1774347002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD21/ProductCarouselMain/GD21%20GHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd21_Graphite_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549673738",
      "product_title": "Gildan Hammer Maxweight T-Shirt",
      "product_handle": "gd201",
      "product_url": "/products/gd201",
      "product_full_url": "https://oakdenemerch.com/products/gd201",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd201",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD201",
      "colour_name": "Graphite Heather",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#74787a",
      "sort_bucket": "grey",
      "sort_hue": 0.555556,
      "sort_sat": 0.04918,
      "sort_val": 0.478431,
      "swatch_file_id": "gid://shopify/MediaImage/49468939206922",
      "swatch_filename": "GD201_Graphite_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_Graphite_Heather.jpg?v=1774313827",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD201_Graphite_Heather.jpg?v=1774313827",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD201/ProductCarouselMain/GD201%20GHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd201_Graphite_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD05",
      "colour_name": "Graphite Heather",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#74787a",
      "sort_bucket": "grey",
      "sort_hue": 0.555556,
      "sort_sat": 0.04918,
      "sort_val": 0.478431,
      "swatch_file_id": "gid://shopify/MediaImage/49471384682762",
      "swatch_filename": "GD05_Graphite_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Graphite_Heather.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Graphite_Heather.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20GHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Graphite_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549772042",
      "product_title": "Gildan Ladies SoftStyle® T-Shirt",
      "product_handle": "gd72",
      "product_url": "/products/gd72",
      "product_full_url": "https://oakdenemerch.com/products/gd72",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd72",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD72",
      "colour_name": "Graphite Heather",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#74787a",
      "sort_bucket": "grey",
      "sort_hue": 0.555556,
      "sort_sat": 0.04918,
      "sort_val": 0.478431,
      "swatch_file_id": "gid://shopify/MediaImage/49468940747018",
      "swatch_filename": "GD72_Graphite_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Graphite_Heather.jpg?v=1774314002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Graphite_Heather.jpg?v=1774314002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD72/ProductCarouselMain/GD72%20GHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd72_Graphite_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD01",
      "colour_name": "Graphite Heather",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#74787a",
      "sort_bucket": "grey",
      "sort_hue": 0.555556,
      "sort_sat": 0.04918,
      "sort_val": 0.478431,
      "swatch_file_id": "gid://shopify/MediaImage/49474267185418",
      "swatch_filename": "GD01_Graphite_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Graphite_Heather.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Graphite_Heather.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20GHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Graphite_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "50% cotton/20% polyester/30% black polyester.",
      "style_code": "GD15",
      "colour_name": "Graphite Heather",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#74787a",
      "sort_bucket": "grey",
      "sort_hue": 0.555556,
      "sort_sat": 0.04918,
      "sort_val": 0.478431,
      "swatch_file_id": "gid://shopify/MediaImage/49471369052426",
      "swatch_filename": "GD15_Graphite_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Graphite_Heather.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Graphite_Heather.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20GHE%20%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Graphite_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549477130",
      "product_title": "Gildan Heavy Cotton™ T-Shirt",
      "product_handle": "gd05",
      "product_url": "/products/gd05",
      "product_full_url": "https://oakdenemerch.com/products/gd05",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd05",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "99% cotton/1% polyester.",
      "style_code": "GD05",
      "colour_name": "Ash",
      "colour_group": "Grey > Light Grey",
      "rgb": "#d1dee6",
      "sort_bucket": "grey",
      "sort_hue": 0.563492,
      "sort_sat": 0.091304,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49471385010442",
      "swatch_filename": "GD05_Ash.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Ash.jpg?v=1774349141",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD05_Ash.jpg?v=1774349141",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD05/ProductCarouselMain/GD05%20ASH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd05_Ash.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457687032074",
      "product_title": "Gildan Ultra Cotton™ Long Sleeve T-Shirt",
      "product_handle": "gd14",
      "product_url": "/products/gd14",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd14",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "99% cotton/1% polyester.",
      "style_code": "GD14",
      "colour_name": "Ash",
      "colour_group": "Grey > Light Grey",
      "rgb": "#d1dee6",
      "sort_bucket": "grey",
      "sort_hue": 0.563492,
      "sort_sat": 0.091304,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49490465423626",
      "swatch_filename": "gd14_Ash.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Ash.jpg?v=1774522864",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd14_Ash.jpg?v=1774522864",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD14/ProductCarouselMain/GD14%20ASH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd14_Ash.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549378826",
      "product_title": "Gildan Ultra Cotton™ T-Shirt",
      "product_handle": "gd02",
      "product_url": "/products/gd02",
      "product_full_url": "https://oakdenemerch.com/products/gd02",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd02",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "99% cotton/1% polyester.",
      "style_code": "GD02",
      "colour_name": "Ash",
      "colour_group": "Grey > Light Grey",
      "rgb": "#d1dee6",
      "sort_bucket": "grey",
      "sort_hue": 0.563492,
      "sort_sat": 0.091304,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49471398543626",
      "swatch_filename": "GD02_Ash.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Ash.jpg?v=1774349247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD02_Ash.jpg?v=1774349247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD02/ProductCarouselMain/GD02%20ASH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd02_Ash.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548821770",
      "product_title": "Craghoppers Workwear Wakefield Pocket T-Shirt",
      "product_handle": "cr701",
      "product_url": "/products/cr701",
      "product_full_url": "https://oakdenemerch.com/products/cr701",
      "vendor": "Craghoppers",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-cr701",
        "t-shirts",
        "workwear",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "",
      "style_code": "CR701",
      "colour_name": "Soft Grey Marl",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#bfc2c4",
      "sort_bucket": "grey",
      "sort_hue": 0.566667,
      "sort_sat": 0.02551,
      "sort_val": 0.768627,
      "swatch_file_id": "gid://shopify/MediaImage/49468936225034",
      "swatch_filename": "CR701_Soft_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CR701_Soft_Grey_Marl.jpg?v=1774313247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CR701_Soft_Grey_Marl.jpg?v=1774313247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Craghoppers/Product%20Images/CR701/ProductCarouselMain/CR701%20SFGM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cr701_Soft_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552098570",
      "product_title": "Onna by Premier Ladies Unstoppable Fresh Underscrub Base Layer",
      "product_handle": "nn370",
      "product_url": "/products/nn370",
      "product_full_url": "None",
      "vendor": "Onna by Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-nn370",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Nylon",
      "shopify_material": "Nylon",
      "csv_material": "50% recycled nylon/30% nylon/20% polyester.",
      "style_code": "NN370",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#6a7278",
      "sort_bucket": "grey",
      "sort_hue": 0.571429,
      "sort_sat": 0.116667,
      "sort_val": 0.470588,
      "swatch_file_id": "gid://shopify/MediaImage/49491321127178",
      "swatch_filename": "nn370_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/nn370_Heather_Grey.jpg?v=1774526519",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/nn370_Heather_Grey.jpg?v=1774526519",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Onna%20by%20Premier/Product%20Images/NN370/ProductCarouselMain/NN370%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "nn370_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552065802",
      "product_title": "Onna by Premier Unstoppable Fresh Underscrub Base Layer",
      "product_handle": "nn270",
      "product_url": "/products/nn270",
      "product_full_url": "None",
      "vendor": "Onna by Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-nn270",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Nylon",
      "shopify_material": "Nylon",
      "csv_material": "50% recycled nylon/30% nylon/20% polyester.",
      "style_code": "NN270",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#6a7278",
      "sort_bucket": "grey",
      "sort_hue": 0.571429,
      "sort_sat": 0.116667,
      "sort_val": 0.470588,
      "swatch_file_id": "gid://shopify/MediaImage/49491341279498",
      "swatch_filename": "nn270_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/nn270_Heather_Grey.jpg?v=1774526528",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/nn270_Heather_Grey.jpg?v=1774526528",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Onna%20by%20Premier/Product%20Images/NN270/ProductCarouselMain/NN270%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "nn270_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552655626",
      "product_title": "Premier Cotton Rich Comis T-Shirt",
      "product_handle": "pr219",
      "product_url": "/products/pr219",
      "product_full_url": "https://oakdenemerch.com/products/pr219",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-pr219",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "90% cotton/10% viscose.",
      "style_code": "PR219",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8288",
      "sort_bucket": "grey",
      "sort_hue": 0.571429,
      "sort_sat": 0.102941,
      "sort_val": 0.533333,
      "swatch_file_id": "gid://shopify/MediaImage/49468948021514",
      "swatch_filename": "PR219_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR219_Grey_Marl.jpg?v=1774314717",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR219_Grey_Marl.jpg?v=1774314717",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR219/ProductCarouselMain/PR219%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr219_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455552721162",
      "product_title": "Premier Ladies Cotton Rich Comis T-Shirt",
      "product_handle": "pr319",
      "product_url": "/products/pr319",
      "product_full_url": "https://oakdenemerch.com/products/pr319",
      "vendor": "Premier",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-pr319",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "90% cotton/10% viscose.",
      "style_code": "PR319",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8288",
      "sort_bucket": "grey",
      "sort_hue": 0.571429,
      "sort_sat": 0.102941,
      "sort_val": 0.533333,
      "swatch_file_id": "gid://shopify/MediaImage/49472275349770",
      "swatch_filename": "PR319_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR319_Grey_Marl.jpg?v=1774354101",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/PR319_Grey_Marl.jpg?v=1774354101",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR319/ProductCarouselMain/PR319%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr319_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455553016074",
      "product_title": "SF Clothing Feel Good Stretch T-Shirt",
      "product_handle": "sf121",
      "product_url": "/products/sf121",
      "product_full_url": "https://oakdenemerch.com/products/sf121",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-sf121",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Elastane",
      "shopify_material": "Cotton/Elastane",
      "csv_material": "96% cotton/4% elastane single jersey.*",
      "style_code": "SF121",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#989a9c",
      "sort_bucket": "grey",
      "sort_hue": 0.583333,
      "sort_sat": 0.025641,
      "sort_val": 0.611765,
      "swatch_file_id": "gid://shopify/MediaImage/49472270926090",
      "swatch_filename": "SF121_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF121_Heather_Grey.jpg?v=1774354029",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/SF121_Heather_Grey.jpg?v=1774354029",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF121/ProductCarouselMain/SF121%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf121_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562527498",
      "product_title": "SF Clothing High Neck Vest",
      "product_handle": "sf232",
      "product_url": "/products/sf232",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-sf232",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% polyester.*",
      "style_code": "SF232",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#989a9c",
      "sort_bucket": "grey",
      "sort_hue": 0.583333,
      "sort_sat": 0.025641,
      "sort_val": 0.611765,
      "swatch_file_id": "gid://shopify/MediaImage/49513933439242",
      "swatch_filename": "sf232_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf232_Heather_Grey.jpg?v=1774619086",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf232_Heather_Grey.jpg?v=1774619086",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF232/ProductCarouselMain/SF232%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf232_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562789642",
      "product_title": "SF Clothing Ladies Sustainable Fashion Cropped Cami Vest Top",
      "product_handle": "sk230",
      "product_url": "/products/sk230",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "sleeveless",
        "style-sk230",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly/Elastane",
      "shopify_material": "Cotton/Poly/Elastane",
      "csv_material": "48% regenerated cotton/47% recycled polyester/5% elastane.",
      "style_code": "SK230",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#989a9c",
      "sort_bucket": "grey",
      "sort_hue": 0.583333,
      "sort_sat": 0.025641,
      "sort_val": 0.611765,
      "swatch_file_id": "gid://shopify/MediaImage/49513935536394",
      "swatch_filename": "sk230_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk230_Heather_Grey.jpg?v=1774619122",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sk230_Heather_Grey.jpg?v=1774619122",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SF%20Clothing/SK230/ProductCarouselMain/SK230%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sk230_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10458562593034",
      "product_title": "SF Clothing Muscle Vest",
      "product_handle": "sf236",
      "product_url": "/products/sf236",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "sleeveless",
        "style-sf236",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% polyester.*",
      "style_code": "SF236",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#989a9c",
      "sort_bucket": "grey",
      "sort_hue": 0.583333,
      "sort_sat": 0.025641,
      "sort_val": 0.611765,
      "swatch_file_id": "gid://shopify/MediaImage/49513933963530",
      "swatch_filename": "sf236_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf236_Heather_Grey.jpg?v=1774619093",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf236_Heather_Grey.jpg?v=1774619093",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF236/ProductCarouselMain/SF236%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf236_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550591242",
      "product_title": "AWDis Ladies Cool Recycled Cropped T-Shirt",
      "product_handle": "jc215",
      "product_url": "/products/jc215",
      "product_full_url": "https://oakdenemerch.com/products/jc215",
      "vendor": "Just Cool",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-jc215",
        "t-shirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "80% recycled polyester/20% elastane.",
      "style_code": "JC215",
      "colour_name": "Platinum Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#838487",
      "sort_bucket": "grey",
      "sort_hue": 0.625,
      "sort_sat": 0.02963,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49473132921098",
      "swatch_filename": "JC215_Platinum_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC215_Platinum_Grey.jpg?v=1774362217",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JC215_Platinum_Grey.jpg?v=1774362217",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC215/ProductCarouselMain/JC215%20PLA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc215_Platinum_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548297482",
      "product_title": "Russell Athletic Authentic Heavyweight T-Shirt",
      "product_handle": "215m",
      "product_url": "/products/215m",
      "product_full_url": "https://oakdenemerch.com/products/215m",
      "vendor": "Russell Athletic",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "sports",
        "style-215m",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun combed cotton.",
      "style_code": "215M",
      "colour_name": "Sport Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#6e6e70",
      "sort_bucket": "grey",
      "sort_hue": 0.666667,
      "sort_sat": 0.017857,
      "sort_val": 0.439216,
      "swatch_file_id": "gid://shopify/MediaImage/49470972821770",
      "swatch_filename": "215M_Sport_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/215M_Sport_Heather.jpg?v=1774347211",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/215M_Sport_Heather.jpg?v=1774347211",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/215M/ProductCarouselMain/215M%20SHR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "215m_Sport_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548428554",
      "product_title": "Anthem Amplify Heavyweight T-Shirt",
      "product_handle": "am18",
      "product_url": "/products/am18",
      "product_full_url": "https://oakdenemerch.com/products/am18",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-am18",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% organic ringspun combed cotton/40% recycled polyester.",
      "style_code": "AM18",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a29fa6",
      "sort_bucket": "grey",
      "sort_hue": 0.738095,
      "sort_sat": 0.042169,
      "sort_val": 0.65098,
      "swatch_file_id": "gid://shopify/MediaImage/49472892993802",
      "swatch_filename": "AM18_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_Grey_Marl.jpg?v=1774360285",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM18_Grey_Marl.jpg?v=1774360285",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM18/ProductCarouselMain/AM18%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am18_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686212874",
      "product_title": "Anthem Organic Long Sleeve T-Shirt",
      "product_handle": "am11",
      "product_url": "/products/am11",
      "product_full_url": "None",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-am11",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% organic combed ringspun cotton/40% polyester.",
      "style_code": "AM11",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a29fa6",
      "sort_bucket": "grey",
      "sort_hue": 0.738095,
      "sort_sat": 0.042169,
      "sort_val": 0.65098,
      "swatch_file_id": "gid://shopify/MediaImage/49490380914954",
      "swatch_filename": "am11_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am11_Grey_Marl.jpg?v=1774522766",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am11_Grey_Marl.jpg?v=1774522766",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM11/ProductCarouselMain/AM11%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am11_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% organic combed ringspun cotton/40% polyester.",
      "style_code": "AM10",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a29fa6",
      "sort_bucket": "grey",
      "sort_hue": 0.738095,
      "sort_sat": 0.042169,
      "sort_val": 0.65098,
      "swatch_file_id": "gid://shopify/MediaImage/49474342617354",
      "swatch_filename": "AM10_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Grey_Marl.jpg?v=1774371250",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Grey_Marl.jpg?v=1774371250",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548395786",
      "product_title": "Anthem Unisex Organic Heavyweight T-Shirt",
      "product_handle": "am15",
      "product_url": "/products/am15",
      "product_full_url": "https://oakdenemerch.com/products/am15",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am15",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% organic combed ringspun cotton/40% polyester.",
      "style_code": "AM15",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a29fa6",
      "sort_bucket": "grey",
      "sort_hue": 0.738095,
      "sort_sat": 0.042169,
      "sort_val": 0.65098,
      "swatch_file_id": "gid://shopify/MediaImage/49472895877386",
      "swatch_filename": "AM15_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Grey_Marl.jpg?v=1774360326",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Grey_Marl.jpg?v=1774360326",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM15/ProductCarouselMain/AM15%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am15_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548363018",
      "product_title": "Anthem Unisex Organic Midweight T-Shirt",
      "product_handle": "am12",
      "product_url": "/products/am12",
      "product_full_url": "https://oakdenemerch.com/products/am12",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am12",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% organic ringspun combed cotton/40% recycled polyester.",
      "style_code": "AM12",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a29fa6",
      "sort_bucket": "grey",
      "sort_hue": 0.738095,
      "sort_sat": 0.042169,
      "sort_val": 0.65098,
      "swatch_file_id": "gid://shopify/MediaImage/49472902430986",
      "swatch_filename": "AM12_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Grey_Marl.jpg?v=1774360382",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Grey_Marl.jpg?v=1774360382",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM12/ProductCarouselMain/AM12%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am12_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% organic combed ringspun cotton/40% polyester.",
      "style_code": "AM10",
      "colour_name": "Dark Grey Marl",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#4d4b4f",
      "sort_bucket": "grey",
      "sort_hue": 0.75,
      "sort_sat": 0.050633,
      "sort_val": 0.309804,
      "swatch_file_id": "gid://shopify/MediaImage/49474342846730",
      "swatch_filename": "AM10_Dark_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Dark_Grey_Marl.jpg?v=1774371250",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Dark_Grey_Marl.jpg?v=1774371250",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20DKM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Dark_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548920074",
      "product_title": "Canvas Unisex Heavyweight Boxy T-Shirt",
      "product_handle": "cv3010",
      "product_url": "/products/cv3010",
      "product_full_url": "https://oakdenemerch.com/products/cv3010",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv3010",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3010",
      "colour_name": "Soft Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#fae3fa",
      "sort_bucket": "grey",
      "sort_hue": 0.833333,
      "sort_sat": 0.092,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49472879427850",
      "swatch_filename": "CV3010_Soft_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_Soft_Pink.jpg?v=1774360083",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/CV3010_Soft_Pink.jpg?v=1774360083",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3010/ProductCarouselMain/CV3010%20SOP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3010_Soft_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686737162",
      "product_title": "Canvas Unisex Heavyweight Long Sleeve Boxy T-Shirt",
      "product_handle": "cv3511",
      "product_url": "/products/cv3511",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "S",
        "style-cv3511",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% airlume combed ringspun cotton.*",
      "style_code": "CV3511",
      "colour_name": "Soft Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#fae3fa",
      "sort_bucket": "grey",
      "sort_hue": 0.833333,
      "sort_sat": 0.092,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49490430460170",
      "swatch_filename": "cv3511_Soft_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_Soft_Pink.jpg?v=1774522808",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv3511_Soft_Pink.jpg?v=1774522808",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV3511/ProductCarouselMain/CV3511%20SOP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv3511_Soft_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549772042",
      "product_title": "Gildan Ladies SoftStyle® T-Shirt",
      "product_handle": "gd72",
      "product_url": "/products/gd72",
      "product_full_url": "https://oakdenemerch.com/products/gd72",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd72",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD72",
      "colour_name": "Paragon",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#948794",
      "sort_bucket": "grey",
      "sort_hue": 0.833333,
      "sort_sat": 0.087838,
      "sort_val": 0.580392,
      "swatch_file_id": "gid://shopify/MediaImage/49468940615946",
      "swatch_filename": "GD72_Paragon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Paragon.jpg?v=1774314002",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD72_Paragon.jpg?v=1774314002",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD72/ProductCarouselMain/GD72%20PGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd72_Paragon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549346058",
      "product_title": "Gildan SoftStyle® Adult T-Shirt",
      "product_handle": "gd01",
      "product_url": "/products/gd01",
      "product_full_url": "https://oakdenemerch.com/products/gd01",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-gd01",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD01",
      "colour_name": "Paragon",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#948794",
      "sort_bucket": "grey",
      "sort_hue": 0.833333,
      "sort_sat": 0.087838,
      "sort_val": 0.580392,
      "swatch_file_id": "gid://shopify/MediaImage/49474267611402",
      "swatch_filename": "GD01_Paragon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Paragon.jpg?v=1774370889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD01_Paragon.jpg?v=1774370889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD01/ProductCarouselMain/GD01%20PGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd01_Paragon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455549608202",
      "product_title": "Gildan SoftStyle® Midweight T-Shirt",
      "product_handle": "gd15",
      "product_url": "/products/gd15",
      "product_full_url": "https://oakdenemerch.com/products/gd15",
      "vendor": "Gildan",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd15",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.*",
      "style_code": "GD15",
      "colour_name": "Paragon",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#948794",
      "sort_bucket": "grey",
      "sort_hue": 0.833333,
      "sort_sat": 0.087838,
      "sort_val": 0.580392,
      "swatch_file_id": "gid://shopify/MediaImage/49471368954122",
      "swatch_filename": "GD15_Paragon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Paragon.jpg?v=1774349030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/GD15_Paragon.jpg?v=1774349030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD15/ProductCarouselMain/GD15%20PGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd15_Paragon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551148298",
      "product_title": "Kustom Kit Superwash® 60°C Piqué T-Shirt",
      "product_handle": "k530",
      "product_url": "/products/k530",
      "product_full_url": "https://oakdenemerch.com/products/k530",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-k530",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton piqué.",
      "style_code": "K530",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#525052",
      "sort_bucket": "grey",
      "sort_hue": 0.833333,
      "sort_sat": 0.02439,
      "sort_val": 0.321569,
      "swatch_file_id": "gid://shopify/MediaImage/49472793280778",
      "swatch_filename": "K530_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K530_Charcoal.jpg?v=1774359824",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K530_Charcoal.jpg?v=1774359824",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K530/ProductCarouselMain/K530%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k530_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455551181066",
      "product_title": "Kustom Kit Regular Fit Cooltex® Plus Wicking T-Shirt",
      "product_handle": "k555",
      "product_url": "/products/k555",
      "product_full_url": "https://oakdenemerch.com/products/k555",
      "vendor": "Kustom Kit",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k555",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester mesh.",
      "style_code": "K555",
      "colour_name": "Heather Solid",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#919091",
      "sort_bucket": "grey",
      "sort_hue": 0.833333,
      "sort_sat": 0.006897,
      "sort_val": 0.568627,
      "swatch_file_id": "gid://shopify/MediaImage/49473108640010",
      "swatch_filename": "K555_Heather_Solid.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K555_Heather_Solid.jpg?v=1774362040",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/K555_Heather_Solid.jpg?v=1774362040",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K555/ProductCarouselMain/K555%20HES%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k555_Heather_Solid.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547314442",
      "product_title": "SOL'S Crusader Organic T-Shirt",
      "product_handle": "03582",
      "product_url": "/products/03582",
      "product_full_url": "https://oakdenemerch.com/products/03582",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-03582",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% organic cotton/40% recycled polyester",
      "style_code": "03582",
      "colour_name": "Heather Pink",
      "colour_group": "Pink > Heather/Effect Pink",
      "rgb": "#f5dadf",
      "sort_bucket": "grey",
      "sort_hue": 0.969136,
      "sort_sat": 0.110204,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49474468610314",
      "swatch_filename": "03582_Heather_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Heather_Pink.jpg?v=1774372186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03582_Heather_Pink.jpg?v=1774372186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03582/ProductCarouselMain/03582%20HEP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03582_Heather_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455547281674",
      "product_title": "SOL'S Ladies Crusader Organic T-Shirt",
      "product_handle": "03581",
      "product_url": "/products/03581",
      "product_full_url": "https://oakdenemerch.com/products/03581",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-03581",
        "t-shirts",
        "womens",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "60% organic cotton/40% recycled polyester",
      "style_code": "03581",
      "colour_name": "Heather Pink",
      "colour_group": "Pink > Heather/Effect Pink",
      "rgb": "#f5dadf",
      "sort_bucket": "grey",
      "sort_hue": 0.969136,
      "sort_sat": 0.110204,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49468835987722",
      "swatch_filename": "03581_Heather_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Heather_Pink.jpg?v=1774312353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03581_Heather_Pink.jpg?v=1774312353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03581/ProductCarouselMain/03581%20HEP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03581_Heather_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457686212874",
      "product_title": "Anthem Organic Long Sleeve T-Shirt",
      "product_handle": "am11",
      "product_url": "/products/am11",
      "product_full_url": "None",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "Long Sleeve T-Shirt",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-am11",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM11",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#615a5b",
      "sort_bucket": "grey",
      "sort_hue": 0.97619,
      "sort_sat": 0.072165,
      "sort_val": 0.380392,
      "swatch_file_id": "gid://shopify/MediaImage/49490384879882",
      "swatch_filename": "am11_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am11_Charcoal.jpg?v=1774522766",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am11_Charcoal.jpg?v=1774522766",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM11/ProductCarouselMain/AM11%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am11_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548330250",
      "product_title": "Anthem Organic T-Shirt",
      "product_handle": "am10",
      "product_url": "/products/am10",
      "product_full_url": "https://oakdenemerch.com/products/am10",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am10",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM10",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#615a5b",
      "sort_bucket": "grey",
      "sort_hue": 0.97619,
      "sort_sat": 0.072165,
      "sort_val": 0.380392,
      "swatch_file_id": "gid://shopify/MediaImage/49474342879498",
      "swatch_filename": "AM10_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Charcoal.jpg?v=1774371249",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM10_Charcoal.jpg?v=1774371249",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM10/ProductCarouselMain/AM10%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am10_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548395786",
      "product_title": "Anthem Unisex Organic Heavyweight T-Shirt",
      "product_handle": "am15",
      "product_url": "/products/am15",
      "product_full_url": "https://oakdenemerch.com/products/am15",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "heavyweight",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am15",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM15",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#615a5b",
      "sort_bucket": "grey",
      "sort_hue": 0.97619,
      "sort_sat": 0.072165,
      "sort_val": 0.380392,
      "swatch_file_id": "gid://shopify/MediaImage/49472895975690",
      "swatch_filename": "AM15_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Charcoal.jpg?v=1774360325",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM15_Charcoal.jpg?v=1774360325",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM15/ProductCarouselMain/AM15%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am15_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455548363018",
      "product_title": "Anthem Unisex Organic Midweight T-Shirt",
      "product_handle": "am12",
      "product_url": "/products/am12",
      "product_full_url": "https://oakdenemerch.com/products/am12",
      "vendor": "Anthem",
      "product_type": "T-Shirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "PCBest_Seller",
        "S",
        "style-am12",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.*",
      "style_code": "AM12",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#615a5b",
      "sort_bucket": "grey",
      "sort_hue": 0.97619,
      "sort_sat": 0.072165,
      "sort_val": 0.380392,
      "swatch_file_id": "gid://shopify/MediaImage/49472902889738",
      "swatch_filename": "AM12_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Charcoal.jpg?v=1774360382",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/AM12_Charcoal.jpg?v=1774360382",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM12/ProductCarouselMain/AM12%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am12_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455546790154",
      "product_title": "SOL'S Camo T-Shirt",
      "product_handle": "01188",
      "product_url": "/products/01188",
      "product_full_url": "https://oakdenemerch.com/products/01188",
      "vendor": "SOL'S",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-01188",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun semi-combed cotton.",
      "style_code": "01188",
      "colour_name": "Camouflage",
      "colour_group": "Patterns > Camouflage",
      "rgb": "",
      "sort_bucket": "other",
      "sort_hue": 0.99,
      "sort_sat": 0.0,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49471884165386",
      "swatch_filename": "01188_Camouflage.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01188_Camouflage.jpg?v=1774352390",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/01188_Camouflage.jpg?v=1774352390",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/01188/ProductCarouselMain/01188%20CMF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "01188_Camouflage.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455550853386",
      "product_title": "AWDis Tie-Dye T-Shirt",
      "product_handle": "jt022",
      "product_url": "/products/jt022",
      "product_full_url": "https://oakdenemerch.com/products/jt022",
      "vendor": "Just Ts",
      "product_type": "T-Shirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-jt022",
        "t-shirts",
        "ties",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% combed ringspun cotton.",
      "style_code": "JT022",
      "colour_name": "Tie Dye Swirl",
      "colour_group": "Patterns > Other",
      "rgb": "",
      "sort_bucket": "other",
      "sort_hue": 0.99,
      "sort_sat": 0.0,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49472514654474",
      "swatch_filename": "JT022_Tie_Dye_Swirl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT022_Tie_Dye_Swirl.jpg?v=1774357201",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/JT022_Tie_Dye_Swirl.jpg?v=1774357201",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Ts/Product%20Images/JT022/ProductCarouselMain/JT022%20TDS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jt022_Tie_Dye_Swirl.jpg"
    },

    {
      "product_id": "gid://shopify/Product/10457948160266",
      "product_title": "AWDis Academy Kids V Neck Sweatshirt",
      "product_handle": "ac003b",
      "product_url": "/products/ac003b",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-ac003b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC003B",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494304882954",
      "swatch_filename": "ac003b_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003b_Black.jpg?v=1774540508",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003b_Black.jpg?v=1774540508",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC003B/ProductCarouselMain/AC003B%20ABK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac003b_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947898122",
      "product_title": "AWDis Academy Senior Raglan Sweatshirt",
      "product_handle": "ac001",
      "product_url": "/products/ac001",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ac001",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC001",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494302720266",
      "swatch_filename": "ac001_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Black.jpg?v=1774540480",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Black.jpg?v=1774540480",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC001/ProductCarouselMain/AC001%20ABK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac001_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948061962",
      "product_title": "AWDis Academy Senior V Neck Sweatshirt",
      "product_handle": "ac003",
      "product_url": "/products/ac003",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "S",
        "S-XL-XXL",
        "style-ac003",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC003",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494304522506",
      "swatch_filename": "ac003_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003_Black.jpg?v=1774540501",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003_Black.jpg?v=1774540501",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC003/ProductCarouselMain/AC003%20ABK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac003_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457956483338",
      "product_title": "Canvas Unisex Heavyweight Crew Neck Sweatshirt",
      "product_handle": "cv4711",
      "product_url": "/products/cv4711",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv4711",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% airlume combed ringspun cotton/40% polyester.",
      "style_code": "CV4711",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494465118474",
      "swatch_filename": "cv4711_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4711_Black.jpg?v=1774541746",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4711_Black.jpg?v=1774541746",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV4711/ProductCarouselMain/CV4711%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv4711_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963626762",
      "product_title": "Finden + Hales 1/4 Zip Tracksuit Top",
      "product_handle": "lv874",
      "product_url": "/products/lv874",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv874",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV874",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495553605898",
      "swatch_filename": "lv874_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_Black.jpg?v=1774542657",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_Black.jpg?v=1774542657",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV874/ProductCarouselMain/LV874%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv874_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457957826826",
      "product_title": "Front Row Premium Piqué 1/4 Zip Top",
      "product_handle": "fr045",
      "product_url": "/products/fr045",
      "product_full_url": "None",
      "vendor": "Front Row",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-fr045",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "FR045",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494472327434",
      "swatch_filename": "fr045_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/fr045_Black.jpg?v=1774541859",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/fr045_Black.jpg?v=1774541859",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Front%20Row/Product%20Images/FR045/ProductCarouselMain/FR045%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "fr045_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457959727370",
      "product_title": "Henbury Unisex Sustainable 1/4 Zip Sweatshirt",
      "product_handle": "h842",
      "product_url": "/products/h842",
      "product_full_url": "None",
      "vendor": "Henbury",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "security",
        "style-h842",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% regenerated cotton/40% recycled polyester.",
      "style_code": "H842",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494490022154",
      "swatch_filename": "h842_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h842_Black.jpg?v=1774542164",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h842_Black.jpg?v=1774542164",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H842/ProductCarouselMain/H842%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h842_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457959596298",
      "product_title": "Henbury Unisex Sustainable Sweatshirt",
      "product_handle": "h840",
      "product_url": "/products/h840",
      "product_full_url": "None",
      "vendor": "Henbury",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-h840",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% regenerated cotton/40% recycled polyester.",
      "style_code": "H840",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494489399562",
      "swatch_filename": "h840_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h840_Black.jpg?v=1774542157",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h840_Black.jpg?v=1774542157",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H840/ProductCarouselMain/H840%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h840_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457959792906",
      "product_title": "Henbury Zip Neck Wicking Top",
      "product_handle": "h862",
      "product_url": "/products/h862",
      "product_full_url": "None",
      "vendor": "Henbury",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-h862",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester fleece back single jersey.",
      "style_code": "H862",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494490415370",
      "swatch_filename": "h862_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h862_Black.jpg?v=1774542171",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h862_Black.jpg?v=1774542171",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H862/ProductCarouselMain/H862%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h862_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962971402",
      "product_title": "Kariban Crew Neck Sweatshirt",
      "product_handle": "kb442",
      "product_url": "/products/kb442",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-kb442",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed cotton/20% polyester.",
      "style_code": "KB442",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495419912458",
      "swatch_filename": "kb442_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb442_Black.jpg?v=1774542581",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb442_Black.jpg?v=1774542581",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB442/ProductCarouselMain/KB442%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb442_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963200778",
      "product_title": "Kariban Crew Neck Sweatshirt",
      "product_handle": "kb488",
      "product_url": "/products/kb488",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb488",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed cotton/20% polyester.",
      "style_code": "KB442",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495496687882",
      "swatch_filename": "kb488_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb488_Black.jpg?v=1774542617",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb488_Black.jpg?v=1774542617",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB442/ProductCarouselMain/KB442%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb488_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963036938",
      "product_title": "Kariban Ladies Oversized Sweatshirt",
      "product_handle": "kb471",
      "product_url": "/products/kb471",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "l-xl",
        "L-XL-S-M",
        "s-m",
        "style-kb471",
        "sweatshirts",
        "womens"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "91% cotton/9% polyester.*",
      "style_code": "KB471",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495432134922",
      "swatch_filename": "kb471_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb471_Black.jpg?v=1774542592",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb471_Black.jpg?v=1774542592",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB471/ProductCarouselMain/KB471%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb471_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495318954250",
      "swatch_filename": "kb4025_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Black.jpg?v=1774542547",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Black.jpg?v=1774542547",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963135242",
      "product_title": "Kariban Zip Neck Sweatshirt",
      "product_handle": "kb487",
      "product_url": "/products/kb487",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb487",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "KB487",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495456350474",
      "swatch_filename": "kb487_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb487_Black.jpg?v=1774542603",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb487_Black.jpg?v=1774542603",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB487/ProductCarouselMain/KB487%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb487_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961758986",
      "product_title": "Kustom Kit Klassic Sweatshirt",
      "product_handle": "k302",
      "product_url": "/products/k302",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k302",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton.",
      "style_code": "K302",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495178412298",
      "swatch_filename": "k302_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k302_Black.jpg?v=1774542482",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k302_Black.jpg?v=1774542482",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K302/ProductCarouselMain/K302%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k302_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962184970",
      "product_title": "Kustom Kit Regular Fit 1/4 Zip Piqué Sweatshirt",
      "product_handle": "k339",
      "product_url": "/products/k339",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-k339",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "K339",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495253844234",
      "swatch_filename": "k339_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k339_Black.jpg?v=1774542515",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k339_Black.jpg?v=1774542515",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K339/ProductCarouselMain/K339%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k339_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962053898",
      "product_title": "Kustom Kit Regular Fit Piqué Sweatshirt",
      "product_handle": "k337",
      "product_url": "/products/k337",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-k337",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "K337",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495248961802",
      "swatch_filename": "k337_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k337_Black.jpg?v=1774542508",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k337_Black.jpg?v=1774542508",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K337/ProductCarouselMain/K337%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k337_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961791754",
      "product_title": "Kustom Kit Regular Fit Sweatshirt",
      "product_handle": "k332",
      "product_url": "/products/k332",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k332",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "K332",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495192240394",
      "swatch_filename": "k332_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k332_Black.jpg?v=1774542490",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k332_Black.jpg?v=1774542490",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K332/ProductCarouselMain/K332%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k332_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961890058",
      "product_title": "Kustom Kit Sweat Jacket",
      "product_handle": "k334",
      "product_url": "/products/k334",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "jackets",
        "L",
        "M",
        "S",
        "style-k334",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "K334",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495246274826",
      "swatch_filename": "k334_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k334_Black.jpg?v=1774542500",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k334_Black.jpg?v=1774542500",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K334/ProductCarouselMain/K334%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k334_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963790602",
      "product_title": "Mantis Unisex Essential Sweatshirt",
      "product_handle": "m05",
      "product_url": "/products/m05",
      "product_full_url": "None",
      "vendor": "Mantis",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-m05",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "80% organic cotton/20% recycled polyester.",
      "style_code": "M05",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495642865930",
      "swatch_filename": "m05_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m05_Black.jpg?v=1774542698",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m05_Black.jpg?v=1774542698",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Mantis/M05/ProductCarouselMain/M05%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "m05_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457965789450",
      "product_title": "Premier Ladies Spun Dyed Recycled Zip Through Sweat Jacket",
      "product_handle": "pr809",
      "product_url": "/products/pr809",
      "product_full_url": "None",
      "vendor": "Premier",
      "product_type": "Sweatshirt",
      "tags": [
        "jackets",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-pr809",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "PR809",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49496207360266",
      "swatch_filename": "pr809_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr809_Black.jpg?v=1774542943",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr809_Black.jpg?v=1774542943",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR809/ProductCarouselMain/PR809%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr809_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457965723914",
      "product_title": "Premier Spun Dyed Recycled Zip Through Sweat Jacket",
      "product_handle": "pr808",
      "product_url": "/products/pr808",
      "product_full_url": "None",
      "vendor": "Premier",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "jackets",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-pr808",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "PR808",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49496192057610",
      "swatch_filename": "pr808_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr808_Black.jpg?v=1774542935",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr808_Black.jpg?v=1774542935",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR808/ProductCarouselMain/PR808%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr808_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968705802",
      "product_title": "Pro RTX Pro 1/4 Neck Zip Sweatshirt",
      "product_handle": "rx305",
      "product_url": "/products/rx305",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx305",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX305",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49496992186634",
      "swatch_filename": "rx305_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx305_Black.jpg?v=1774543283",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx305_Black.jpg?v=1774543283",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX305/ProductCarouselMain/RX305%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx305_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968738570",
      "product_title": "Pro RTX Pro Full Zip Sweatshirt",
      "product_handle": "rx310",
      "product_url": "/products/rx310",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-rx310",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX310",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497039634698",
      "swatch_filename": "rx310_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx310_Black.jpg?v=1774543292",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx310_Black.jpg?v=1774543292",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX310/ProductCarouselMain/RX310%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx310_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49496937464074",
      "swatch_filename": "rx301_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Black.jpg?v=1774543249",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Black.jpg?v=1774543249",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457967231242",
      "product_title": "Regatta Core Stretch Half Zip Midlayer Top",
      "product_handle": "rg441",
      "product_url": "/products/rg441",
      "product_full_url": "None",
      "vendor": "Regatta Professional",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "security",
        "style-rg441",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "95% recycled polyester/5% elastane.",
      "style_code": "RG441",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49496600707338",
      "swatch_filename": "rg441_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg441_Black.jpg?v=1774543103",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg441_Black.jpg?v=1774543103",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Regatta%20Professional/Product%20Images/RG441/ProductCarouselMain/RG441%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rg441_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946521866",
      "product_title": "Russell Athletic Authentic Sweat Jacket",
      "product_handle": "267m",
      "product_url": "/products/267m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "jackets",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-267m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun combed cotton/20% polyester.",
      "style_code": "267M",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494289875210",
      "swatch_filename": "267m_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/267m_Black.jpg?v=1774540371",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/267m_Black.jpg?v=1774540371",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/267M/ProductCarouselMain/267M%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "267m_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494286303498",
      "swatch_filename": "262m_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Black.jpg?v=1774540337",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Black.jpg?v=1774540337",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946587402",
      "product_title": "Russell Athletic Authentic Zip Neck Sweatshirt",
      "product_handle": "270m",
      "product_url": "/products/270m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-270m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "270M",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494293577994",
      "swatch_filename": "270m_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/270m_Black.jpg?v=1774540386",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/270m_Black.jpg?v=1774540386",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/270M/ProductCarouselMain/270M%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "270m_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947308298",
      "product_title": "Russell Athletic Kids Raglan Sweatshirt",
      "product_handle": "762b",
      "product_url": "/products/762b",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "performance-activewear",
        "sports",
        "style-762b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762B",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494298755338",
      "swatch_filename": "762b_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Black.jpg?v=1774540424",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Black.jpg?v=1774540424",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762B/ProductCarouselMain/762B%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762b_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947472138",
      "product_title": "Russell Athletic Raglan Sweatshirt",
      "product_handle": "762m",
      "product_url": "/products/762m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-762m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762M",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494300164362",
      "swatch_filename": "762m_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762m_Black.jpg?v=1774540444",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762m_Black.jpg?v=1774540444",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762M/ProductCarouselMain/762M%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762m_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968902410",
      "product_title": "SF Clothing Unisex Slim Fit Sweatshirt",
      "product_handle": "sf525",
      "product_url": "/products/sf525",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-sf525",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% polyester.*",
      "style_code": "SF525",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497061556490",
      "swatch_filename": "sf525_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf525_Black.jpg?v=1774543305",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf525_Black.jpg?v=1774543305",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SF%20Clothing/SF525/ProductCarouselMain/SF525%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf525_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968935178",
      "product_title": "SF Clothing Unisex Sustainable Fashion Sweatshirt",
      "product_handle": "sf530",
      "product_url": "/products/sf530",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-sf530",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% regenerated cotton/40% recycled polyester.",
      "style_code": "SF530",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497061622026",
      "swatch_filename": "sf530_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf530_Black.jpg?v=1774543309",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf530_Black.jpg?v=1774543309",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF530/ProductCarouselMain/SF530%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf530_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556325642",
      "product_title": "Tee Jays Full Zip Sweat Jacket",
      "product_handle": "t5440",
      "product_url": "/products/t5440",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "jackets",
        "L",
        "M",
        "S",
        "style-t5440",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/30% polyester.",
      "style_code": "T5440",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491111870730",
      "swatch_filename": "t5440_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5440_Black.jpg?v=1774526064",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5440_Black.jpg?v=1774526064",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5440/ProductCarouselMain/T5440%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5440_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556292874",
      "product_title": "Tee Jays Half Zip Sweatshirt",
      "product_handle": "t5438",
      "product_url": "/products/t5438",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5438",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/30% polyester.",
      "style_code": "T5438",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491113476362",
      "swatch_filename": "t5438_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5438_Black.jpg?v=1774526071",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5438_Black.jpg?v=1774526071",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5438/ProductCarouselMain/T5438%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5438_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556161802",
      "product_title": "Tee Jays Heavy Sweatshirt",
      "product_handle": "t5429",
      "product_url": "/products/t5429",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t5429",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/30% polyester.",
      "style_code": "T5429",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491169706250",
      "swatch_filename": "t5429_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5429_Black.jpg?v=1774526128",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5429_Black.jpg?v=1774526128",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5429/ProductCarouselMain/T5429%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5429_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555801354",
      "product_title": "Tee Jays Power Organic Sweatshirt",
      "product_handle": "t5100",
      "product_url": "/products/t5100",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-t5100",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% organic cotton/30% polyester.",
      "style_code": "T5100",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491205685514",
      "swatch_filename": "t5100_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5100_Black.jpg?v=1774526216",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5100_Black.jpg?v=1774526216",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Tee%20Jays/T5100/ProductCarouselMain/T5100%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5100_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556358410",
      "product_title": "Tee Jays Ribbed Interlock Crew Neck Sweatshirt",
      "product_handle": "t5504",
      "product_url": "/products/t5504",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5504",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "T5504",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491108954378",
      "swatch_filename": "t5504_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5504_Black.jpg?v=1774526056",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5504_Black.jpg?v=1774526056",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5504/ProductCarouselMain/T5504%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5504_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556391178",
      "product_title": "Tee Jays Ribbed Interlock Half Zip Sweatshirt",
      "product_handle": "t5506",
      "product_url": "/products/t5506",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5506",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "T5506",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491106038026",
      "swatch_filename": "t5506_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5506_Black.jpg?v=1774526049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5506_Black.jpg?v=1774526049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5506/ProductCarouselMain/T5506%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5506_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555866890",
      "product_title": "Tee Jays Unlabeled Sweatshirt",
      "product_handle": "t5150",
      "product_url": "/products/t5150",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-t5150",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% organic ringspun cotton/30% recycled polyester.",
      "style_code": "T5150",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49491202867466",
      "swatch_filename": "t5150_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5150_Black.jpg?v=1774526207",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5150_Black.jpg?v=1774526207",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5150/ProductCarouselMain/T5150%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5150_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970835722",
      "product_title": "Tombo Ladies Long Sleeve Zip Neck Performance Top",
      "product_handle": "tl563",
      "product_url": "/products/tl563",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "security",
        "sports",
        "style-tl563",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "88% polyester/12% elastane peached interlock.",
      "style_code": "TL563",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497581814026",
      "swatch_filename": "tl563_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl563_Black.jpg?v=1774543566",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl563_Black.jpg?v=1774543566",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL563/ProductCarouselMain/TL563%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl563_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970802954",
      "product_title": "Tombo Long Sleeve Zip Neck Performance Top",
      "product_handle": "tl562",
      "product_url": "/products/tl562",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "security",
        "sports",
        "style-tl562",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "88% polyester/12% elastane peached interlock.",
      "style_code": "TL562",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497581715722",
      "swatch_filename": "tl562_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl562_Black.jpg?v=1774543561",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl562_Black.jpg?v=1774543561",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL562/ProductCarouselMain/TL562%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl562_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970868490",
      "product_title": "Tombo Technical 1/4 Zip Top",
      "product_handle": "tl577",
      "product_url": "/products/tl577",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "security",
        "style-tl577",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "90% polyester/10% elastane.",
      "style_code": "TL577",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497587712266",
      "swatch_filename": "tl577_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl577_Black.jpg?v=1774543572",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl577_Black.jpg?v=1774543572",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL577/ProductCarouselMain/TL577%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl577_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457971294474",
      "product_title": "Yoko Hi-Vis Sweatshirt",
      "product_handle": "yk030",
      "product_url": "/products/yk030",
      "product_full_url": "None",
      "vendor": "YOKO",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "hi-vis",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "safetywear-ppe",
        "style-yk030",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "YK030",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497661997322",
      "swatch_filename": "yk030_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk030_Black.jpg?v=1774543600",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk030_Black.jpg?v=1774543600",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/YOKO/Product%20Images/YK030/ProductCarouselMain/YK030%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "yk030_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963626762",
      "product_title": "Finden + Hales 1/4 Zip Tracksuit Top",
      "product_handle": "lv874",
      "product_url": "/products/lv874",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv874",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV874",
      "colour_name": "Black/Emerald",
      "colour_group": "Black > Black",
      "rgb": "#000000;#1c8b38",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495553638666",
      "swatch_filename": "lv874_BlackEmerald.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_BlackEmerald.jpg?v=1774542659",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_BlackEmerald.jpg?v=1774542659",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV874/ProductCarouselMain/LV874%20BK%252fEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv874_BlackEmerald.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963725066",
      "product_title": "Finden + Hales Kids 1/4 Zip Tracksuit Top",
      "product_handle": "lv875",
      "product_url": "/products/lv875",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-lv875",
        "sweatshirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV875",
      "colour_name": "Black/Emerald",
      "colour_group": "Black > Black",
      "rgb": "#000000;#1c8b38",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495613112586",
      "swatch_filename": "lv875_BlackEmerald.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_BlackEmerald.jpg?v=1774542679",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_BlackEmerald.jpg?v=1774542679",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV875/ProductCarouselMain/LV875%20BK%252fEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv875_BlackEmerald.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963626762",
      "product_title": "Finden + Hales 1/4 Zip Tracksuit Top",
      "product_handle": "lv874",
      "product_url": "/products/lv874",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv874",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV874",
      "colour_name": "Black/Gold",
      "colour_group": "Black > Black",
      "rgb": "#000000;#ffa312",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495562322186",
      "swatch_filename": "lv874_BlackGold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_BlackGold.jpg?v=1774542661",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_BlackGold.jpg?v=1774542661",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV874/ProductCarouselMain/LV874%20BK%252fGO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv874_BlackGold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963725066",
      "product_title": "Finden + Hales Kids 1/4 Zip Tracksuit Top",
      "product_handle": "lv875",
      "product_url": "/products/lv875",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-lv875",
        "sweatshirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV875",
      "colour_name": "Black/Gold",
      "colour_group": "Black > Black",
      "rgb": "#000000;#ffa312",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495613178122",
      "swatch_filename": "lv875_BlackGold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_BlackGold.jpg?v=1774542681",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_BlackGold.jpg?v=1774542681",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV875/ProductCarouselMain/LV875%20BK%252fGO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv875_BlackGold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969164554",
      "product_title": "Spiro Unisex Zip Neck Trial Training Top",
      "product_handle": "sr178m",
      "product_url": "/products/sr178m",
      "product_full_url": "None",
      "vendor": "Spiro",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "security",
        "sports",
        "style-sr178m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "SR178M",
      "colour_name": "Black/Grey/White",
      "colour_group": "Black > Black",
      "rgb": "#000000;#4b6978;#ffffff",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497106612490",
      "swatch_filename": "sr178m_BlackGreyWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr178m_BlackGreyWhite.jpg?v=1774543326",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr178m_BlackGreyWhite.jpg?v=1774543326",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR178M/ProductCarouselMain/SR178M%20B.G.W%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr178m_BlackGreyWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963626762",
      "product_title": "Finden + Hales 1/4 Zip Tracksuit Top",
      "product_handle": "lv874",
      "product_url": "/products/lv874",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv874",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV874",
      "colour_name": "Black/Gunmetal",
      "colour_group": "Black > Black",
      "rgb": "#000000;#445156",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495571038474",
      "swatch_filename": "lv874_BlackGunmetal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_BlackGunmetal.jpg?v=1774542662",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_BlackGunmetal.jpg?v=1774542662",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV874/ProductCarouselMain/LV874%20BK%252fGT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv874_BlackGunmetal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963495690",
      "product_title": "Finden + Hales Contrast Zip Neck Midlayer Top",
      "product_handle": "lv571",
      "product_url": "/products/lv571",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-lv571",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester single jersey.",
      "style_code": "LV571",
      "colour_name": "Black/Gunmetal",
      "colour_group": "Black > Black",
      "rgb": "#000000;#445156",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495545151754",
      "swatch_filename": "lv571_BlackGunmetal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv571_BlackGunmetal.jpg?v=1774542650",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv571_BlackGunmetal.jpg?v=1774542650",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV571/ProductCarouselMain/LV571%20BK%252fGT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv571_BlackGunmetal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963725066",
      "product_title": "Finden + Hales Kids 1/4 Zip Tracksuit Top",
      "product_handle": "lv875",
      "product_url": "/products/lv875",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-lv875",
        "sweatshirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV875",
      "colour_name": "Black/Gunmetal",
      "colour_group": "Black > Black",
      "rgb": "#000000;#445156",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495613243658",
      "swatch_filename": "lv875_BlackGunmetal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_BlackGunmetal.jpg?v=1774542684",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_BlackGunmetal.jpg?v=1774542684",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV875/ProductCarouselMain/LV875%20BK%252fGT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv875_BlackGunmetal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963626762",
      "product_title": "Finden + Hales 1/4 Zip Tracksuit Top",
      "product_handle": "lv874",
      "product_url": "/products/lv874",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv874",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV874",
      "colour_name": "Black/Red",
      "colour_group": "Black > Black",
      "rgb": "#000000;#f5002f",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495572840714",
      "swatch_filename": "lv874_BlackRed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_BlackRed.jpg?v=1774542664",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_BlackRed.jpg?v=1774542664",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV874/ProductCarouselMain/LV874%20BK%252fRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv874_BlackRed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963495690",
      "product_title": "Finden + Hales Contrast Zip Neck Midlayer Top",
      "product_handle": "lv571",
      "product_url": "/products/lv571",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-lv571",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester single jersey.",
      "style_code": "LV571",
      "colour_name": "Black/Red",
      "colour_group": "Black > Black",
      "rgb": "#000000;#f5002f",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495545282826",
      "swatch_filename": "lv571_BlackRed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv571_BlackRed.jpg?v=1774542652",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv571_BlackRed.jpg?v=1774542652",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV571/ProductCarouselMain/LV571%20BK%252fRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv571_BlackRed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963725066",
      "product_title": "Finden + Hales Kids 1/4 Zip Tracksuit Top",
      "product_handle": "lv875",
      "product_url": "/products/lv875",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-lv875",
        "sweatshirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV875",
      "colour_name": "Black/Red",
      "colour_group": "Black > Black",
      "rgb": "#000000;#f5002f",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495613276426",
      "swatch_filename": "lv875_BlackRed.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_BlackRed.jpg?v=1774542684",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_BlackRed.jpg?v=1774542684",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV875/ProductCarouselMain/LV875%20BK%252fRD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv875_BlackRed.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963626762",
      "product_title": "Finden + Hales 1/4 Zip Tracksuit Top",
      "product_handle": "lv874",
      "product_url": "/products/lv874",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv874",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV874",
      "colour_name": "Black/White",
      "colour_group": "Black > Black",
      "rgb": "#000000;#ffffff",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495572873482",
      "swatch_filename": "lv874_BlackWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_BlackWhite.jpg?v=1774542666",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_BlackWhite.jpg?v=1774542666",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV874/ProductCarouselMain/LV874%20BK%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv874_BlackWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963725066",
      "product_title": "Finden + Hales Kids 1/4 Zip Tracksuit Top",
      "product_handle": "lv875",
      "product_url": "/products/lv875",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-lv875",
        "sweatshirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV875",
      "colour_name": "Black/White",
      "colour_group": "Black > Black",
      "rgb": "#000000;#ffffff",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495625171210",
      "swatch_filename": "lv875_BlackWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_BlackWhite.jpg?v=1774542685",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_BlackWhite.jpg?v=1774542685",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV875/ProductCarouselMain/LV875%20BK%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv875_BlackWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457959989514",
      "product_title": "AWDis Cool Half Zip Sweat Top",
      "product_handle": "jc031",
      "product_url": "/products/jc031",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "security",
        "sports",
        "style-jc031",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "87% polyester/13% elastane.",
      "style_code": "JC031",
      "colour_name": "Charcoal/Jet Black",
      "colour_group": "Grey > Charcoal",
      "rgb": "#15221d;#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494547726602",
      "swatch_filename": "jc031_CharcoalJet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc031_CharcoalJet_Black.jpg?v=1774542186",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc031_CharcoalJet_Black.jpg?v=1774542186",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC031/ProductCarouselMain/JC031%20CH%252fJB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc031_CharcoalJet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961201930",
      "product_title": "AWDis Graduate Heavyweight Sweatshirt",
      "product_handle": "jh130",
      "product_url": "/products/jh130",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-jh130",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/30% polyester.*",
      "style_code": "JH130",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495107240202",
      "swatch_filename": "jh130_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh130_Jet_Black.jpg?v=1774542432",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh130_Jet_Black.jpg?v=1774542432",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH130/ProductCarouselMain/JH130%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh130_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494811836682",
      "swatch_filename": "jh030b_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Jet_Black.jpg?v=1774542324",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Jet_Black.jpg?v=1774542324",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960874250",
      "product_title": "AWDis Sophomore Zip Neck Sweatshirt",
      "product_handle": "jh046",
      "product_url": "/products/jh046",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL",
        "style-jh046",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH046",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495012344074",
      "swatch_filename": "jh046_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh046_Jet_Black.jpg?v=1774542394",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh046_Jet_Black.jpg?v=1774542394",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH046/ProductCarouselMain/JH046%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh046_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#000000",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494605758730",
      "swatch_filename": "jh030_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Jet_Black.jpg?v=1774542218",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Jet_Black.jpg?v=1774542218",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457959989514",
      "product_title": "AWDis Cool Half Zip Sweat Top",
      "product_handle": "jc031",
      "product_url": "/products/jc031",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "security",
        "sports",
        "style-jc031",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "87% polyester/13% elastane.",
      "style_code": "JC031",
      "colour_name": "Jet Black/Arctic White",
      "colour_group": "Black > Black",
      "rgb": "#171c21;#ffffff",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494552543498",
      "swatch_filename": "jc031_Jet_BlackArctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc031_Jet_BlackArctic_White.jpg?v=1774542190",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc031_Jet_BlackArctic_White.jpg?v=1774542190",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC031/ProductCarouselMain/JC031%20JB%252fAW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc031_Jet_BlackArctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960186122",
      "product_title": "AWDis Ladies Cool Half Zip Sweat Top",
      "product_handle": "jc036",
      "product_url": "/products/jc036",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "security",
        "sports",
        "style-jc036",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "87% polyester/13% elastane.",
      "style_code": "JC036",
      "colour_name": "Jet Black/Arctic White",
      "colour_group": "Black > Black",
      "rgb": "#171c21;#ffffff",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494605234442",
      "swatch_filename": "jc036_Jet_BlackArctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc036_Jet_BlackArctic_White.jpg?v=1774542204",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc036_Jet_BlackArctic_White.jpg?v=1774542204",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC036/ProductCarouselMain/JC036%20JB%252fAW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc036_Jet_BlackArctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457959989514",
      "product_title": "AWDis Cool Half Zip Sweat Top",
      "product_handle": "jc031",
      "product_url": "/products/jc031",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "security",
        "sports",
        "style-jc031",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "87% polyester/13% elastane.",
      "style_code": "JC031",
      "colour_name": "Jet Black/Fire Red",
      "colour_group": "Black > Black",
      "rgb": "#171c21;#eb0024",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494587212042",
      "swatch_filename": "jc031_Jet_BlackFire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc031_Jet_BlackFire_Red.jpg?v=1774542190",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc031_Jet_BlackFire_Red.jpg?v=1774542190",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC031/ProductCarouselMain/JC031%20JB%252fFR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc031_Jet_BlackFire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960186122",
      "product_title": "AWDis Ladies Cool Half Zip Sweat Top",
      "product_handle": "jc036",
      "product_url": "/products/jc036",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "security",
        "sports",
        "style-jc036",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "87% polyester/13% elastane.",
      "style_code": "JC036",
      "colour_name": "Jet Black/Fire Red",
      "colour_group": "Black > Black",
      "rgb": "#171c21;#eb0024",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494605267210",
      "swatch_filename": "jc036_Jet_BlackFire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc036_Jet_BlackFire_Red.jpg?v=1774542205",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc036_Jet_BlackFire_Red.jpg?v=1774542205",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC036/ProductCarouselMain/JC036%20JB%252fFR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc036_Jet_BlackFire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969164554",
      "product_title": "Spiro Unisex Zip Neck Trial Training Top",
      "product_handle": "sr178m",
      "product_url": "/products/sr178m",
      "product_full_url": "None",
      "vendor": "Spiro",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "security",
        "sports",
        "style-sr178m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "SR178M",
      "colour_name": "Red/Black/White",
      "colour_group": "Red > Red",
      "rgb": "#e10037;#000000;#ffffff",
      "sort_bucket": "black",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497115296010",
      "swatch_filename": "sr178m_RedBlackWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr178m_RedBlackWhite.jpg?v=1774543328",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr178m_RedBlackWhite.jpg?v=1774543328",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR178M/ProductCarouselMain/SR178M%20R-B-W%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr178m_RedBlackWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948225802",
      "product_title": "Anthem Organic Sweatshirt",
      "product_handle": "am20",
      "product_url": "/products/am20",
      "product_full_url": "None",
      "vendor": "Anthem",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-am20",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "AM20",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#424236",
      "sort_bucket": "black",
      "sort_hue": 0.166667,
      "sort_sat": 0.181818,
      "sort_val": 0.258824,
      "swatch_file_id": "gid://shopify/MediaImage/49494306521354",
      "swatch_filename": "am20_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Black.jpg?v=1774540525",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Black.jpg?v=1774540525",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM20/ProductCarouselMain/AM20%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am20_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457957990666",
      "product_title": "Gildan DryBlend® Sweatshirt",
      "product_handle": "gd52",
      "product_url": "/products/gd52",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd52",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD52",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#091b10",
      "sort_bucket": "black",
      "sort_hue": 0.398148,
      "sort_sat": 0.666667,
      "sort_val": 0.105882,
      "swatch_file_id": "gid://shopify/MediaImage/49494473179402",
      "swatch_filename": "gd52_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd52_Forest_Green.jpg?v=1774541871",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd52_Forest_Green.jpg?v=1774541871",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD52/ProductCarouselMain/GD52%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd52_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#091b10",
      "sort_bucket": "black",
      "sort_hue": 0.398148,
      "sort_sat": 0.666667,
      "sort_val": 0.105882,
      "swatch_file_id": "gid://shopify/MediaImage/49494473703690",
      "swatch_filename": "gd56_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Forest_Green.jpg?v=1774541883",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Forest_Green.jpg?v=1774541883",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#091b10",
      "sort_bucket": "black",
      "sort_hue": 0.398148,
      "sort_sat": 0.666667,
      "sort_val": 0.105882,
      "swatch_file_id": "gid://shopify/MediaImage/49494479339786",
      "swatch_filename": "gd67_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Forest_Green.jpg?v=1774542015",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Forest_Green.jpg?v=1774542015",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#031a0c",
      "sort_bucket": "black",
      "sort_hue": 0.398551,
      "sort_sat": 0.884615,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49494606086410",
      "swatch_filename": "jh030_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Forest_Green.jpg?v=1774542219",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Forest_Green.jpg?v=1774542219",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961300234",
      "product_title": "AWDis Campus Full Zip Sweatshirt",
      "product_handle": "jh147",
      "product_url": "/products/jh147",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "college-uni",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jh147",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% ringspun cotton/48% polyester.",
      "style_code": "JH147",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#0d120f",
      "sort_bucket": "black",
      "sort_hue": 0.4,
      "sort_sat": 0.277778,
      "sort_val": 0.070588,
      "swatch_file_id": "gid://shopify/MediaImage/49495110484234",
      "swatch_filename": "jh147_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh147_Charcoal.jpg?v=1774542441",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh147_Charcoal.jpg?v=1774542441",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH147/ProductCarouselMain/JH147%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh147_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961201930",
      "product_title": "AWDis Graduate Heavyweight Sweatshirt",
      "product_handle": "jh130",
      "product_url": "/products/jh130",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-jh130",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "Charcoal 55% polyester/45% ringspun cotton.",
      "style_code": "JH130",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#0d120f",
      "sort_bucket": "black",
      "sort_hue": 0.4,
      "sort_sat": 0.277778,
      "sort_val": 0.070588,
      "swatch_file_id": "gid://shopify/MediaImage/49495108124938",
      "swatch_filename": "jh130_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh130_Charcoal.jpg?v=1774542434",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh130_Charcoal.jpg?v=1774542434",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH130/ProductCarouselMain/JH130%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh130_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% ringspun cotton/48% polyester.",
      "style_code": "JH030B",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#0d120f",
      "sort_bucket": "black",
      "sort_hue": 0.4,
      "sort_sat": 0.277778,
      "sort_val": 0.070588,
      "swatch_file_id": "gid://shopify/MediaImage/49494812098826",
      "swatch_filename": "jh030b_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Charcoal.jpg?v=1774542325",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Charcoal.jpg?v=1774542325",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960874250",
      "product_title": "AWDis Sophomore Zip Neck Sweatshirt",
      "product_handle": "jh046",
      "product_url": "/products/jh046",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL",
        "style-jh046",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "Charcoal 52% ringspun cotton/48% polyester.",
      "style_code": "JH046",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#0d120f",
      "sort_bucket": "black",
      "sort_hue": 0.4,
      "sort_sat": 0.277778,
      "sort_val": 0.070588,
      "swatch_file_id": "gid://shopify/MediaImage/49495022600458",
      "swatch_filename": "jh046_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh046_Charcoal.jpg?v=1774542396",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh046_Charcoal.jpg?v=1774542396",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH046/ProductCarouselMain/JH046%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh046_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "52% ringspun cotton/48% polyester.",
      "style_code": "JH030",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#0d120f",
      "sort_bucket": "black",
      "sort_hue": 0.4,
      "sort_sat": 0.277778,
      "sort_val": 0.070588,
      "swatch_file_id": "gid://shopify/MediaImage/49494606151946",
      "swatch_filename": "jh030_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Charcoal.jpg?v=1774542221",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Charcoal.jpg?v=1774542221",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961398538",
      "product_title": "AWDis Unisex Organic Sweatshirt",
      "product_handle": "jh230",
      "product_url": "/products/jh230",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-jh230",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "JH230",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#0d120f",
      "sort_bucket": "black",
      "sort_hue": 0.4,
      "sort_sat": 0.277778,
      "sort_val": 0.070588,
      "swatch_file_id": "gid://shopify/MediaImage/49495118348554",
      "swatch_filename": "jh230_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_Charcoal.jpg?v=1774542451",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_Charcoal.jpg?v=1774542451",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH230/ProductCarouselMain/JH230%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh230_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970311434",
      "product_title": "Fruit of the Loom Classic Drop Shoulder Sweatshirt",
      "product_handle": "ss9",
      "product_url": "/products/ss9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS9",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49497443107082",
      "swatch_filename": "ss9_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Black.jpg?v=1774543488",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Black.jpg?v=1774543488",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS9/ProductCarouselMain/SS9%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss9_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970213130",
      "product_title": "Fruit of the Loom Classic Raglan Sweatshirt",
      "product_handle": "ss8",
      "product_url": "/products/ss8",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss8",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS8",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49497374851338",
      "swatch_filename": "ss8_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Black.jpg?v=1774543458",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Black.jpg?v=1774543458",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS8/ProductCarouselMain/SS8%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss8_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970082058",
      "product_title": "Fruit of the Loom Classic Zip Neck Sweatshirt",
      "product_handle": "ss17",
      "product_url": "/products/ss17",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss17",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "SS17",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49497322848522",
      "swatch_filename": "ss17_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss17_Black.jpg?v=1774543442",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss17_Black.jpg?v=1774543442",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS17/ProductCarouselMain/SS17%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss17_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969819914",
      "product_title": "Fruit of the Loom Iconic Premium Set-In Sweatshirt",
      "product_handle": "ss151",
      "product_url": "/products/ss151",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss151",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS151",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49497254592778",
      "swatch_filename": "ss151_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_Black.jpg?v=1774543398",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_Black.jpg?v=1774543398",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS151/ProductCarouselMain/SS151%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss151_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969983754",
      "product_title": "Fruit of the Loom Iconic Premium Sweat Jacket",
      "product_handle": "ss155",
      "product_url": "/products/ss155",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "jackets",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss155",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS155",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49497311183114",
      "swatch_filename": "ss155_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss155_Black.jpg?v=1774543433",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss155_Black.jpg?v=1774543433",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS155/ProductCarouselMain/SS155%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss155_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969885450",
      "product_title": "Fruit of the Loom Iconic Premium Zip Neck Sweatshirt",
      "product_handle": "ss154",
      "product_url": "/products/ss154",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss154",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS154",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49497271140618",
      "swatch_filename": "ss154_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss154_Black.jpg?v=1774543417",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss154_Black.jpg?v=1774543417",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS154/ProductCarouselMain/SS154%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss154_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970180362",
      "product_title": "Fruit of the Loom Lady Fit Lightweight Raglan Sweatshirt",
      "product_handle": "ss180",
      "product_url": "/products/ss180",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "lightweight",
        "S",
        "style-ss180",
        "sweatshirts",
        "womens",
        "XS",
        "XS-S-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "SS180",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49497352405258",
      "swatch_filename": "ss180_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss180_Black.jpg?v=1774543450",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss180_Black.jpg?v=1774543450",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Fruit%20of%20the%20Loom/SS180/ProductCarouselMain/SS180%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss180_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969623306",
      "product_title": "Fruit of the Loom Lightweight Drop Shoulder Sweatshirt",
      "product_handle": "ss123",
      "product_url": "/products/ss123",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-ss123",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "SS123",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49497202327818",
      "swatch_filename": "ss123_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss123_Black.jpg?v=1774543376",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss123_Black.jpg?v=1774543376",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Fruit%20of%20the%20Loom/SS123/ProductCarouselMain/SS123%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss123_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969557770",
      "product_title": "Fruit of the Loom Lightweight Raglan Sweatshirt",
      "product_handle": "ss120",
      "product_url": "/products/ss120",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-ss120",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "SS120",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49497182503178",
      "swatch_filename": "ss120_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss120_Black.jpg?v=1774543364",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss120_Black.jpg?v=1774543364",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS120/ProductCarouselMain/SS120%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss120_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970508042",
      "product_title": "Fruit of the Loom Premium Drop Shoulder Sweatshirt",
      "product_handle": "sse9",
      "product_url": "/products/sse9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-sse9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE9",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49497532825866",
      "swatch_filename": "sse9_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse9_Black.jpg?v=1774543532",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse9_Black.jpg?v=1774543532",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SSE9/ProductCarouselMain/SSE9%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse9_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970606346",
      "product_title": "Fruit of the Loom Premium Sweat Jacket",
      "product_handle": "sse92",
      "product_url": "/products/sse92",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "jackets",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-sse92",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE92",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49497541378314",
      "swatch_filename": "sse92_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse92_Black.jpg?v=1774543547",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse92_Black.jpg?v=1774543547",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SSE92/ProductCarouselMain/SSE92%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse92_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970409738",
      "product_title": "Fruit of the Loom Premium Zip Neck Sweatshirt",
      "product_handle": "sse17",
      "product_url": "/products/sse17",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-sse17",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE17",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49497518309642",
      "swatch_filename": "sse17_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse17_Black.jpg?v=1774543518",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse17_Black.jpg?v=1774543518",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SSE17/ProductCarouselMain/SSE17%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse17_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969721610",
      "product_title": "Fruit of the Loom Supercotton™ Sweatshirt",
      "product_handle": "ss141",
      "product_url": "/products/ss141",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss141",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS141",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0f1315",
      "sort_bucket": "black",
      "sort_hue": 0.555556,
      "sort_sat": 0.285714,
      "sort_val": 0.082353,
      "swatch_file_id": "gid://shopify/MediaImage/49497218449674",
      "swatch_filename": "ss141_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss141_Black.jpg?v=1774543385",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss141_Black.jpg?v=1774543385",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS141/ProductCarouselMain/SS141%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss141_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964347658",
      "product_title": "Native Spirit 1/4 Zip Sweatshirt",
      "product_handle": "ns428",
      "product_url": "/products/ns428",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns428",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "NS428",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0b1013",
      "sort_bucket": "black",
      "sort_hue": 0.5625,
      "sort_sat": 0.421053,
      "sort_val": 0.07451,
      "swatch_file_id": "gid://shopify/MediaImage/49495856382218",
      "swatch_filename": "ns428_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns428_Black.jpg?v=1774542782",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns428_Black.jpg?v=1774542782",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS428/ProductCarouselMain/NS428%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns428_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964544266",
      "product_title": "Native Spirit Ladies Crew Neck Sweatshirt",
      "product_handle": "ns439",
      "product_url": "/products/ns439",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns439",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "NS439",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0b1013",
      "sort_bucket": "black",
      "sort_hue": 0.5625,
      "sort_sat": 0.421053,
      "sort_val": 0.07451,
      "swatch_file_id": "gid://shopify/MediaImage/49495899799818",
      "swatch_filename": "ns439_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns439_Black.jpg?v=1774542805",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns439_Black.jpg?v=1774542805",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS439/ProductCarouselMain/NS439%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns439_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964445962",
      "product_title": "Native Spirit Ladies Oversized Cropped Sweatshirt",
      "product_handle": "ns429",
      "product_url": "/products/ns429",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns429",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "65% organic combed cotton/35% recycled polyester.",
      "style_code": "NS429",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0b1013",
      "sort_bucket": "black",
      "sort_hue": 0.5625,
      "sort_sat": 0.421053,
      "sort_val": 0.07451,
      "swatch_file_id": "gid://shopify/MediaImage/49495886889226",
      "swatch_filename": "ns429_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns429_Black.jpg?v=1774542793",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns429_Black.jpg?v=1774542793",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS429/ProductCarouselMain/NS429%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns429_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964642570",
      "product_title": "Native Spirit Unisex Crew Neck Sweatshirt",
      "product_handle": "ns443",
      "product_url": "/products/ns443",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns443",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS400",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0b1013",
      "sort_bucket": "black",
      "sort_hue": 0.5625,
      "sort_sat": 0.421053,
      "sort_val": 0.07451,
      "swatch_file_id": "gid://shopify/MediaImage/49495928570122",
      "swatch_filename": "ns443_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns443_Black.jpg?v=1774542824",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns443_Black.jpg?v=1774542824",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS400/ProductCarouselMain/NS400%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns443_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964085514",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns407",
      "product_url": "/products/ns407",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns407",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0b1013",
      "sort_bucket": "black",
      "sort_hue": 0.5625,
      "sort_sat": 0.421053,
      "sort_val": 0.07451,
      "swatch_file_id": "gid://shopify/MediaImage/49495728718090",
      "swatch_filename": "ns407_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Black.jpg?v=1774542730",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Black.jpg?v=1774542730",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns407_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964609802",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns440",
      "product_url": "/products/ns440",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-ns440",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#0b1013",
      "sort_bucket": "black",
      "sort_hue": 0.5625,
      "sort_sat": 0.421053,
      "sort_val": 0.07451,
      "swatch_file_id": "gid://shopify/MediaImage/49495910023434",
      "swatch_filename": "ns440_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns440_Black.jpg?v=1774542815",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns440_Black.jpg?v=1774542815",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns440_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944621322",
      "product_title": "NEOBLU Nelson French Terry Sweatshirt",
      "product_handle": "03194",
      "product_url": "/products/03194",
      "product_full_url": "None",
      "vendor": "NEOBLU",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-03194",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% combed cotton/15% polyester.",
      "style_code": "03194",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171a1c",
      "sort_bucket": "black",
      "sort_hue": 0.566667,
      "sort_sat": 0.178571,
      "sort_val": 0.109804,
      "swatch_file_id": "gid://shopify/MediaImage/49494217523466",
      "swatch_filename": "03194_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03194_Deep_Black.jpg?v=1774540185",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03194_Deep_Black.jpg?v=1774540185",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/NEOBLU/Product%20Images/03194/ProductCarouselMain/03194%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03194_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#010407",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.857143,
      "sort_val": 0.027451,
      "swatch_file_id": "gid://shopify/MediaImage/49494473736458",
      "swatch_filename": "gd56_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Black.jpg?v=1774541885",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Black.jpg?v=1774541885",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#010407",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.857143,
      "sort_val": 0.027451,
      "swatch_file_id": "gid://shopify/MediaImage/49494479470858",
      "swatch_filename": "gd67_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Black.jpg?v=1774542018",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Black.jpg?v=1774542018",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958187274",
      "product_title": "Gildan SoftStyle® Midweight Fleece 1/4 Zip Sweatshirt",
      "product_handle": "gd612",
      "product_url": "/products/gd612",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd612",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD612",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#010407",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.857143,
      "sort_val": 0.027451,
      "swatch_file_id": "gid://shopify/MediaImage/49494476456202",
      "swatch_filename": "gd612_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Black.jpg?v=1774541939",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Black.jpg?v=1774541939",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD612/ProductCarouselMain/GD612%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd612_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961300234",
      "product_title": "AWDis Campus Full Zip Sweatshirt",
      "product_handle": "jh147",
      "product_url": "/products/jh147",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "college-uni",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jh147",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/30% polyester.*",
      "style_code": "JH147",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49495110713610",
      "swatch_filename": "jh147_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh147_Deep_Black.jpg?v=1774542442",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh147_Deep_Black.jpg?v=1774542442",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH147/ProductCarouselMain/JH147%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh147_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49494812164362",
      "swatch_filename": "jh030b_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Deep_Black.jpg?v=1774542328",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Deep_Black.jpg?v=1774542328",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960743178",
      "product_title": "AWDis Ladies Cropped 1/4 Zip Sweatshirt",
      "product_handle": "jh037",
      "product_url": "/products/jh037",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-jh037",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XXS",
        "XXS-XS-S-M-L-XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "JH037",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49495001006346",
      "swatch_filename": "jh037_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh037_Deep_Black.jpg?v=1774542384",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh037_Deep_Black.jpg?v=1774542384",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH037/ProductCarouselMain/JH037%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh037_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960644874",
      "product_title": "AWDis Ladies Sweatshirt",
      "product_handle": "jh030f",
      "product_url": "/products/jh030f",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-jh030f",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030F",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49494957588746",
      "swatch_filename": "jh030f_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030f_Deep_Black.jpg?v=1774542372",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030f_Deep_Black.jpg?v=1774542372",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030F/ProductCarouselMain/JH030F%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030f_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961070858",
      "product_title": "AWDis Signature Heavyweight Sweatshirt",
      "product_handle": "jh123",
      "product_url": "/products/jh123",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-jh123",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/20% polyester/10% recycled polyester.*",
      "style_code": "JH123",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49495076765962",
      "swatch_filename": "jh123_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_Deep_Black.jpg?v=1774542415",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_Deep_Black.jpg?v=1774542415",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH123/ProductCarouselMain/JH123%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh123_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960874250",
      "product_title": "AWDis Sophomore Zip Neck Sweatshirt",
      "product_handle": "jh046",
      "product_url": "/products/jh046",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL",
        "style-jh046",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH046",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49495024206090",
      "swatch_filename": "jh046_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh046_Deep_Black.jpg?v=1774542398",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh046_Deep_Black.jpg?v=1774542398",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH046/ProductCarouselMain/JH046%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh046_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49494606184714",
      "swatch_filename": "jh030_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Deep_Black.jpg?v=1774542223",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Deep_Black.jpg?v=1774542223",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961398538",
      "product_title": "AWDis Unisex Organic Sweatshirt",
      "product_handle": "jh230",
      "product_url": "/products/jh230",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-jh230",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "JH230",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49495118414090",
      "swatch_filename": "jh230_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_Deep_Black.jpg?v=1774542452",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_Deep_Black.jpg?v=1774542452",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH230/ProductCarouselMain/JH230%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh230_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960972554",
      "product_title": "AWDis Vision Heavyweight Sweatshirt",
      "product_handle": "jh113",
      "product_url": "/products/jh113",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-jh113",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/20% polyester/10% recycled polyester.*",
      "style_code": "JH113",
      "colour_name": "Deep Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49495056056586",
      "swatch_filename": "jh113_Deep_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh113_Deep_Black.jpg?v=1774542406",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh113_Deep_Black.jpg?v=1774542406",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH113/ProductCarouselMain/JH113%20DBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh113_Deep_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960284426",
      "product_title": "AWDis Cool Lightweight Active 1/4 Zip Top",
      "product_handle": "jc230",
      "product_url": "/products/jc230",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "style-jc230",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "92% recycled polyester/8% elastane.",
      "style_code": "JC230",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49494605529354",
      "swatch_filename": "jc230_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc230_Jet_Black.jpg?v=1774542212",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc230_Jet_Black.jpg?v=1774542212",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC230/ProductCarouselMain/JC230%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc230_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457959891210",
      "product_title": "AWDis Cool-Flex™ Half Zip Top",
      "product_handle": "jc030",
      "product_url": "/products/jc030",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "security",
        "style-jc030",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "86% polyester/14% elastane.",
      "style_code": "JC030",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49494490710282",
      "swatch_filename": "jc030_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc030_Jet_Black.jpg?v=1774542179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc030_Jet_Black.jpg?v=1774542179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC030/ProductCarouselMain/JC030%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc030_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960087818",
      "product_title": "AWDis Ladies Cool-Flex™ Half Zip Top",
      "product_handle": "jc035",
      "product_url": "/products/jc035",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "security",
        "style-jc035",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "86% polyester/14% elastane.",
      "style_code": "JC035",
      "colour_name": "Jet Black",
      "colour_group": "Black > Black",
      "rgb": "#171c21",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.30303,
      "sort_val": 0.129412,
      "swatch_file_id": "gid://shopify/MediaImage/49494605005066",
      "swatch_filename": "jc035_Jet_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc035_Jet_Black.jpg?v=1774542197",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc035_Jet_Black.jpg?v=1774542197",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC035/ProductCarouselMain/JC035%20JBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc035_Jet_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Hot Chocolate",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#0b0c0d",
      "sort_bucket": "black",
      "sort_hue": 0.583333,
      "sort_sat": 0.153846,
      "sort_val": 0.05098,
      "swatch_file_id": "gid://shopify/MediaImage/49494606283018",
      "swatch_filename": "jh030_Hot_Chocolate.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Hot_Chocolate.jpg?v=1774542224",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Hot_Chocolate.jpg?v=1774542224",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20HOC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Hot_Chocolate.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961300234",
      "product_title": "AWDis Campus Full Zip Sweatshirt",
      "product_handle": "jh147",
      "product_url": "/products/jh147",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "college-uni",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jh147",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/30% polyester.*",
      "style_code": "JH147",
      "colour_name": "New French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000710",
      "sort_bucket": "black",
      "sort_hue": 0.59375,
      "sort_sat": 1.0,
      "sort_val": 0.062745,
      "swatch_file_id": "gid://shopify/MediaImage/49495110844682",
      "swatch_filename": "jh147_New_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh147_New_French_Navy.jpg?v=1774542445",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh147_New_French_Navy.jpg?v=1774542445",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH147/ProductCarouselMain/JH147%20NFN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh147_New_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961201930",
      "product_title": "AWDis Graduate Heavyweight Sweatshirt",
      "product_handle": "jh130",
      "product_url": "/products/jh130",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-jh130",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/30% polyester.*",
      "style_code": "JH130",
      "colour_name": "New French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000710",
      "sort_bucket": "black",
      "sort_hue": 0.59375,
      "sort_sat": 1.0,
      "sort_val": 0.062745,
      "swatch_file_id": "gid://shopify/MediaImage/49495108419850",
      "swatch_filename": "jh130_New_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh130_New_French_Navy.jpg?v=1774542435",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh130_New_French_Navy.jpg?v=1774542435",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH130/ProductCarouselMain/JH130%20NFN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh130_New_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "New French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000710",
      "sort_bucket": "black",
      "sort_hue": 0.59375,
      "sort_sat": 1.0,
      "sort_val": 0.062745,
      "swatch_file_id": "gid://shopify/MediaImage/49494823993610",
      "swatch_filename": "jh030b_New_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_New_French_Navy.jpg?v=1774542329",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_New_French_Navy.jpg?v=1774542329",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20NFN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_New_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960644874",
      "product_title": "AWDis Ladies Sweatshirt",
      "product_handle": "jh030f",
      "product_url": "/products/jh030f",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-jh030f",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030F",
      "colour_name": "New French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000710",
      "sort_bucket": "black",
      "sort_hue": 0.59375,
      "sort_sat": 1.0,
      "sort_val": 0.062745,
      "swatch_file_id": "gid://shopify/MediaImage/49494977315082",
      "swatch_filename": "jh030f_New_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030f_New_French_Navy.jpg?v=1774542374",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030f_New_French_Navy.jpg?v=1774542374",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030F/ProductCarouselMain/JH030F%20NFN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030f_New_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961070858",
      "product_title": "AWDis Signature Heavyweight Sweatshirt",
      "product_handle": "jh123",
      "product_url": "/products/jh123",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-jh123",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/20% polyester/10% recycled polyester.*",
      "style_code": "JH123",
      "colour_name": "New French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000710",
      "sort_bucket": "black",
      "sort_hue": 0.59375,
      "sort_sat": 1.0,
      "sort_val": 0.062745,
      "swatch_file_id": "gid://shopify/MediaImage/49495076962570",
      "swatch_filename": "jh123_New_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_New_French_Navy.jpg?v=1774542417",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_New_French_Navy.jpg?v=1774542417",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH123/ProductCarouselMain/JH123%20NFN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh123_New_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960874250",
      "product_title": "AWDis Sophomore Zip Neck Sweatshirt",
      "product_handle": "jh046",
      "product_url": "/products/jh046",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL",
        "style-jh046",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH046",
      "colour_name": "New French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000710",
      "sort_bucket": "black",
      "sort_hue": 0.59375,
      "sort_sat": 1.0,
      "sort_val": 0.062745,
      "swatch_file_id": "gid://shopify/MediaImage/49495030661386",
      "swatch_filename": "jh046_New_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh046_New_French_Navy.jpg?v=1774542399",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh046_New_French_Navy.jpg?v=1774542399",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH046/ProductCarouselMain/JH046%20NFN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh046_New_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "New French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000710",
      "sort_bucket": "black",
      "sort_hue": 0.59375,
      "sort_sat": 1.0,
      "sort_val": 0.062745,
      "swatch_file_id": "gid://shopify/MediaImage/49494606315786",
      "swatch_filename": "jh030_New_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_New_French_Navy.jpg?v=1774542225",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_New_French_Navy.jpg?v=1774542225",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20NFN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_New_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961398538",
      "product_title": "AWDis Unisex Organic Sweatshirt",
      "product_handle": "jh230",
      "product_url": "/products/jh230",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-jh230",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "JH230",
      "colour_name": "New French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000710",
      "sort_bucket": "black",
      "sort_hue": 0.59375,
      "sort_sat": 1.0,
      "sort_val": 0.062745,
      "swatch_file_id": "gid://shopify/MediaImage/49495118479626",
      "swatch_filename": "jh230_New_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_New_French_Navy.jpg?v=1774542454",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_New_French_Navy.jpg?v=1774542454",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH230/ProductCarouselMain/JH230%20NFN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh230_New_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960972554",
      "product_title": "AWDis Vision Heavyweight Sweatshirt",
      "product_handle": "jh113",
      "product_url": "/products/jh113",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-jh113",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/20% polyester/10% recycled polyester.*",
      "style_code": "JH113",
      "colour_name": "New French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000710",
      "sort_bucket": "black",
      "sort_hue": 0.59375,
      "sort_sat": 1.0,
      "sort_val": 0.062745,
      "swatch_file_id": "gid://shopify/MediaImage/49495064740106",
      "swatch_filename": "jh113_New_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh113_New_French_Navy.jpg?v=1774542407",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh113_New_French_Navy.jpg?v=1774542407",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH113/ProductCarouselMain/JH113%20NFN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh113_New_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944391946",
      "product_title": "SOL'S Stan Contrast Zip Neck Sweatshirt",
      "product_handle": "02088",
      "product_url": "/products/02088",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-02088",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "02088",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49494214344970",
      "swatch_filename": "02088_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02088_Black.jpg?v=1774540156",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02088_Black.jpg?v=1774540156",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02088/ProductCarouselMain/02088%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02088_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946751242",
      "product_title": "SOL'S Sundae Sweat Jacket",
      "product_handle": "47200",
      "product_url": "/products/47200",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "jackets",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-47200",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "47200",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49494295544074",
      "swatch_filename": "47200_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/47200_Black.jpg?v=1774540396",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/47200_Black.jpg?v=1774540396",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/47200/ProductCarouselMain/47200%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "47200_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "03814",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49494223487242",
      "swatch_filename": "03814_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Black.jpg?v=1774540233",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Black.jpg?v=1774540233",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03814/ProductCarouselMain/03814%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944785162",
      "product_title": "SOL'S Unisex Comet Organic Sweatshirt",
      "product_handle": "03574",
      "product_url": "/products/03574",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03574",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "03574",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49494219489546",
      "swatch_filename": "03574_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03574_Black.jpg?v=1774540217",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03574_Black.jpg?v=1774540217",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03574/ProductCarouselMain/03574%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03574_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457945178378",
      "product_title": "SOL'S Unisex Conrad 1/4 Zip Sweatshirt",
      "product_handle": "04234",
      "product_url": "/products/04234",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-04234",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "04234",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49494278865162",
      "swatch_filename": "04234_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04234_Black.jpg?v=1774540268",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04234_Black.jpg?v=1774540268",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04234/ProductCarouselMain/04234%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04234_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457945440522",
      "product_title": "SOL'S Unisex Cooper Full Zip Sweat Jacket",
      "product_handle": "04240",
      "product_url": "/products/04240",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "jackets",
        "L",
        "M",
        "S",
        "style-04240",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "04240",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49494280110346",
      "swatch_filename": "04240_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04240_Black.jpg?v=1774540281",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04240_Black.jpg?v=1774540281",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04240/ProductCarouselMain/04240%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04240_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946259722",
      "product_title": "SOL'S Unisex New Supreme Sweatshirt",
      "product_handle": "13250",
      "product_url": "/products/13250",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-13250",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "13250",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49494282600714",
      "swatch_filename": "13250_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_Black.jpg?v=1774540318",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_Black.jpg?v=1774540318",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/13250/ProductCarouselMain/13250%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "13250_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944686858",
      "product_title": "SOL'S Unisex Space Organic Raglan Sweatshirt",
      "product_handle": "03567",
      "product_url": "/products/03567",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03567",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "03567",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49494217851146",
      "swatch_filename": "03567_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Black.jpg?v=1774540193",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Black.jpg?v=1774540193",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03567/ProductCarouselMain/03567%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03567_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944490250",
      "product_title": "SOL'S Unisex Sully Sweatshirt",
      "product_handle": "02990",
      "product_url": "/products/02990",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-02990",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "02990",
      "colour_name": "Black",
      "colour_group": "Black > Black",
      "rgb": "#131a24",
      "sort_bucket": "black",
      "sort_hue": 0.598039,
      "sort_sat": 0.472222,
      "sort_val": 0.141176,
      "swatch_file_id": "gid://shopify/MediaImage/49494215819530",
      "swatch_filename": "02990_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02990_Black.jpg?v=1774540170",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02990_Black.jpg?v=1774540170",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02990/ProductCarouselMain/02990%20BLK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02990_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960284426",
      "product_title": "AWDis Cool Lightweight Active 1/4 Zip Top",
      "product_handle": "jc230",
      "product_url": "/products/jc230",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "style-jc230",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "92% recycled polyester/8% elastane.",
      "style_code": "JC230",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49494605627658",
      "swatch_filename": "jc230_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc230_French_Navy.jpg?v=1774542213",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc230_French_Navy.jpg?v=1774542213",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC230/ProductCarouselMain/JC230%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc230_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457959891210",
      "product_title": "AWDis Cool-Flex™ Half Zip Top",
      "product_handle": "jc030",
      "product_url": "/products/jc030",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "security",
        "style-jc030",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "86% polyester/14% elastane.",
      "style_code": "JC030",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49494490841354",
      "swatch_filename": "jc030_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc030_French_Navy.jpg?v=1774542180",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc030_French_Navy.jpg?v=1774542180",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC030/ProductCarouselMain/JC030%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc030_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960087818",
      "product_title": "AWDis Ladies Cool-Flex™ Half Zip Top",
      "product_handle": "jc035",
      "product_url": "/products/jc035",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "security",
        "style-jc035",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "86% polyester/14% elastane.",
      "style_code": "JC035",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49494605070602",
      "swatch_filename": "jc035_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc035_French_Navy.jpg?v=1774542198",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc035_French_Navy.jpg?v=1774542198",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC035/ProductCarouselMain/JC035%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc035_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948160266",
      "product_title": "AWDis Academy Kids V Neck Sweatshirt",
      "product_handle": "ac003b",
      "product_url": "/products/ac003b",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-ac003b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC003B",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49494305374474",
      "swatch_filename": "ac003b_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003b_Navy.jpg?v=1774540510",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003b_Navy.jpg?v=1774540510",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC003B/ProductCarouselMain/AC003B%20ANY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac003b_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947898122",
      "product_title": "AWDis Academy Senior Raglan Sweatshirt",
      "product_handle": "ac001",
      "product_url": "/products/ac001",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ac001",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC001",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49494302818570",
      "swatch_filename": "ac001_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Navy.jpg?v=1774540482",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Navy.jpg?v=1774540482",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC001/ProductCarouselMain/AC001%20ANY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac001_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948061962",
      "product_title": "AWDis Academy Senior V Neck Sweatshirt",
      "product_handle": "ac003",
      "product_url": "/products/ac003",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "S",
        "S-XL-XXL",
        "style-ac003",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC003",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49494304555274",
      "swatch_filename": "ac003_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003_Navy.jpg?v=1774540503",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003_Navy.jpg?v=1774540503",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC003/ProductCarouselMain/AC003%20ANY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac003_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457957826826",
      "product_title": "Front Row Premium Piqué 1/4 Zip Top",
      "product_handle": "fr045",
      "product_url": "/products/fr045",
      "product_full_url": "None",
      "vendor": "Front Row",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-fr045",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "FR045",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a",
      "sort_bucket": "black",
      "sort_hue": 0.602564,
      "sort_sat": 1.0,
      "sort_val": 0.101961,
      "swatch_file_id": "gid://shopify/MediaImage/49494472360202",
      "swatch_filename": "fr045_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/fr045_Navy.jpg?v=1774541860",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/fr045_Navy.jpg?v=1774541860",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Front%20Row/Product%20Images/FR045/ProductCarouselMain/FR045%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "fr045_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/30% polyester.",
      "style_code": "JH030",
      "colour_name": "Black Smoke",
      "colour_group": "Black > Heather/Effect Black",
      "rgb": "#202631",
      "sort_bucket": "black",
      "sort_hue": 0.607843,
      "sort_sat": 0.346939,
      "sort_val": 0.192157,
      "swatch_file_id": "gid://shopify/MediaImage/49494606348554",
      "swatch_filename": "jh030_Black_Smoke.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Black_Smoke.jpg?v=1774542227",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Black_Smoke.jpg?v=1774542227",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20BSE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Black_Smoke.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946259722",
      "product_title": "SOL'S Unisex New Supreme Sweatshirt",
      "product_handle": "13250",
      "product_url": "/products/13250",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-13250",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "13250",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#0b0e14",
      "sort_bucket": "black",
      "sort_hue": 0.611111,
      "sort_sat": 0.45,
      "sort_val": 0.078431,
      "swatch_file_id": "gid://shopify/MediaImage/49494282666250",
      "swatch_filename": "13250_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_Charcoal.jpg?v=1774540320",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_Charcoal.jpg?v=1774540320",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/13250/ProductCarouselMain/13250%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "13250_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Heather Black",
      "colour_group": "Black > Heather/Effect Black",
      "rgb": "#393d47",
      "sort_bucket": "black",
      "sort_hue": 0.619048,
      "sort_sat": 0.197183,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49494480027914",
      "swatch_filename": "gd67_Heather_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Heather_Black.jpg?v=1774542020",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Heather_Black.jpg?v=1774542020",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20HBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Heather_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964282122",
      "product_title": "Native Spirit Unisex Terry 280 Oversized Sweatshirt",
      "product_handle": "ns415",
      "product_url": "/products/ns415",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns415",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS415",
      "colour_name": "Washed Black",
      "colour_group": "Black > Black",
      "rgb": "#141a2b",
      "sort_bucket": "black",
      "sort_hue": 0.623188,
      "sort_sat": 0.534884,
      "sort_val": 0.168627,
      "swatch_file_id": "gid://shopify/MediaImage/49495826039050",
      "swatch_filename": "ns415_Washed_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns415_Washed_Black.jpg?v=1774542769",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns415_Washed_Black.jpg?v=1774542769",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Native%20Spirit/NS415/ProductCarouselMain/NS415%20WBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns415_Washed_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964183818",
      "product_title": "Native Spirit Unisex Terry 280 Sweatshirt",
      "product_handle": "ns414",
      "product_url": "/products/ns414",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns414",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS414",
      "colour_name": "Washed Black",
      "colour_group": "Black > Black",
      "rgb": "#141a2b",
      "sort_bucket": "black",
      "sort_hue": 0.623188,
      "sort_sat": 0.534884,
      "sort_val": 0.168627,
      "swatch_file_id": "gid://shopify/MediaImage/49495795663114",
      "swatch_filename": "ns414_Washed_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns414_Washed_Black.jpg?v=1774542757",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns414_Washed_Black.jpg?v=1774542757",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Native%20Spirit/NS414/ProductCarouselMain/NS414%20WBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns414_Washed_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964740874",
      "product_title": "Native Spirit Unisex Washed Effect Oversize Sweatshirt",
      "product_handle": "ns447",
      "product_url": "/products/ns447",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "style-ns447",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS447",
      "colour_name": "Washed Black",
      "colour_group": "Black > Black",
      "rgb": "#141a2b",
      "sort_bucket": "black",
      "sort_hue": 0.623188,
      "sort_sat": 0.534884,
      "sort_val": 0.168627,
      "swatch_file_id": "gid://shopify/MediaImage/49495947477258",
      "swatch_filename": "ns447_Washed_Black.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns447_Washed_Black.jpg?v=1774542834",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns447_Washed_Black.jpg?v=1774542834",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Native%20Spirit/NS447/ProductCarouselMain/NS447%20WBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns447_Washed_Black.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Storm Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#0d0d0e",
      "sort_bucket": "black",
      "sort_hue": 0.666667,
      "sort_sat": 0.071429,
      "sort_val": 0.054902,
      "swatch_file_id": "gid://shopify/MediaImage/49494824059146",
      "swatch_filename": "jh030b_Storm_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Storm_Grey.jpg?v=1774542331",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Storm_Grey.jpg?v=1774542331",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20SRM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Storm_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Storm Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#0d0d0e",
      "sort_bucket": "black",
      "sort_hue": 0.666667,
      "sort_sat": 0.071429,
      "sort_val": 0.054902,
      "swatch_file_id": "gid://shopify/MediaImage/49494606414090",
      "swatch_filename": "jh030_Storm_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Storm_Grey.jpg?v=1774542228",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Storm_Grey.jpg?v=1774542228",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20SRM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Storm_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Dark Chocolate",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#0c0a0e",
      "sort_bucket": "black",
      "sort_hue": 0.75,
      "sort_sat": 0.285714,
      "sort_val": 0.054902,
      "swatch_file_id": "gid://shopify/MediaImage/49494473867530",
      "swatch_filename": "gd56_Dark_Chocolate.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Dark_Chocolate.jpg?v=1774541886",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Dark_Chocolate.jpg?v=1774541886",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20DCH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Dark_Chocolate.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494835134730",
      "swatch_filename": "jh030b_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Arctic_White.jpg?v=1774542333",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Arctic_White.jpg?v=1774542333",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960743178",
      "product_title": "AWDis Ladies Cropped 1/4 Zip Sweatshirt",
      "product_handle": "jh037",
      "product_url": "/products/jh037",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-jh037",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XXS",
        "XXS-XS-S-M-L-XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "JH037",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495001039114",
      "swatch_filename": "jh037_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh037_Arctic_White.jpg?v=1774542386",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh037_Arctic_White.jpg?v=1774542386",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Just%20Hoods/JH037/ProductCarouselMain/JH037%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh037_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960644874",
      "product_title": "AWDis Ladies Sweatshirt",
      "product_handle": "jh030f",
      "product_url": "/products/jh030f",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-jh030f",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030F",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494978429194",
      "swatch_filename": "jh030f_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030f_Arctic_White.jpg?v=1774542376",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030f_Arctic_White.jpg?v=1774542376",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030F/ProductCarouselMain/JH030F%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030f_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961070858",
      "product_title": "AWDis Signature Heavyweight Sweatshirt",
      "product_handle": "jh123",
      "product_url": "/products/jh123",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-jh123",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/20% polyester/10% recycled polyester.*",
      "style_code": "JH123",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495076995338",
      "swatch_filename": "jh123_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_Arctic_White.jpg?v=1774542418",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_Arctic_White.jpg?v=1774542418",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH123/ProductCarouselMain/JH123%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh123_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494606446858",
      "swatch_filename": "jh030_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Arctic_White.jpg?v=1774542230",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Arctic_White.jpg?v=1774542230",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961398538",
      "product_title": "AWDis Unisex Organic Sweatshirt",
      "product_handle": "jh230",
      "product_url": "/products/jh230",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-jh230",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "JH230",
      "colour_name": "Arctic White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495121723658",
      "swatch_filename": "jh230_Arctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_Arctic_White.jpg?v=1774542455",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_Arctic_White.jpg?v=1774542455",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH230/ProductCarouselMain/JH230%20ACW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh230_Arctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457959989514",
      "product_title": "AWDis Cool Half Zip Sweat Top",
      "product_handle": "jc031",
      "product_url": "/products/jc031",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "security",
        "sports",
        "style-jc031",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "87% polyester/13% elastane.",
      "style_code": "JC031",
      "colour_name": "French Navy/Arctic White",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494604611850",
      "swatch_filename": "jc031_French_NavyArctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc031_French_NavyArctic_White.jpg?v=1774542191",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc031_French_NavyArctic_White.jpg?v=1774542191",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC031/ProductCarouselMain/JC031%20FN%252fAW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc031_French_NavyArctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960186122",
      "product_title": "AWDis Ladies Cool Half Zip Sweat Top",
      "product_handle": "jc036",
      "product_url": "/products/jc036",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "security",
        "sports",
        "style-jc036",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "87% polyester/13% elastane.",
      "style_code": "JC036",
      "colour_name": "French Navy/Arctic White",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494605398282",
      "swatch_filename": "jc036_French_NavyArctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc036_French_NavyArctic_White.jpg?v=1774542207",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc036_French_NavyArctic_White.jpg?v=1774542207",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC036/ProductCarouselMain/JC036%20FN%252fAW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc036_French_NavyArctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969164554",
      "product_title": "Spiro Unisex Zip Neck Trial Training Top",
      "product_handle": "sr178m",
      "product_url": "/products/sr178m",
      "product_full_url": "None",
      "vendor": "Spiro",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "security",
        "sports",
        "style-sr178m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "SR178M",
      "colour_name": "Grey/Lime Green/White",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#4b6978;#bfd600;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497115361546",
      "swatch_filename": "sr178m_GreyLime_GreenWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr178m_GreyLime_GreenWhite.jpg?v=1774543329",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr178m_GreyLime_GreenWhite.jpg?v=1774543329",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR178M/ProductCarouselMain/SR178M%20G%252fL%252fW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr178m_GreyLime_GreenWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969164554",
      "product_title": "Spiro Unisex Zip Neck Trial Training Top",
      "product_handle": "sr178m",
      "product_url": "/products/sr178m",
      "product_full_url": "None",
      "vendor": "Spiro",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "security",
        "sports",
        "style-sr178m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "SR178M",
      "colour_name": "Navy/Royal Blue/White",
      "colour_group": "Blue > Navy",
      "rgb": "#081727;#001da8;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497115394314",
      "swatch_filename": "sr178m_NavyRoyal_BlueWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr178m_NavyRoyal_BlueWhite.jpg?v=1774543330",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr178m_NavyRoyal_BlueWhite.jpg?v=1774543330",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR178M/ProductCarouselMain/SR178M%20N-R-W%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr178m_NavyRoyal_BlueWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963626762",
      "product_title": "Finden + Hales 1/4 Zip Tracksuit Top",
      "product_handle": "lv874",
      "product_url": "/products/lv874",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv874",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV874",
      "colour_name": "Navy/White",
      "colour_group": "Blue > Navy",
      "rgb": "#0c184a;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495583162634",
      "swatch_filename": "lv874_NavyWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_NavyWhite.jpg?v=1774542667",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_NavyWhite.jpg?v=1774542667",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV874/ProductCarouselMain/LV874%20NV%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv874_NavyWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963725066",
      "product_title": "Finden + Hales Kids 1/4 Zip Tracksuit Top",
      "product_handle": "lv875",
      "product_url": "/products/lv875",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-lv875",
        "sweatshirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV875",
      "colour_name": "Navy/White",
      "colour_group": "Blue > Navy",
      "rgb": "#0c184a;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495625203978",
      "swatch_filename": "lv875_NavyWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_NavyWhite.jpg?v=1774542687",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_NavyWhite.jpg?v=1774542687",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV875/ProductCarouselMain/LV875%20NV%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv875_NavyWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457957728522",
      "product_title": "Front Row Panelled 1/4 Zip Neck Top",
      "product_handle": "fr006",
      "product_url": "/products/fr006",
      "product_full_url": "None",
      "vendor": "Front Row",
      "product_type": "Sweatshirt",
      "tags": [
        "heavyweight",
        "L",
        "M",
        "S",
        "style-fr006",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% ringspun cotton.",
      "style_code": "FR006",
      "colour_name": "Navy/White",
      "colour_group": "Blue > Navy",
      "rgb": "#000a1a;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494472196362",
      "swatch_filename": "fr006_NavyWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/fr006_NavyWhite.jpg?v=1774541855",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/fr006_NavyWhite.jpg?v=1774541855",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Front%20Row/Product%20Images/FR006/ProductCarouselMain/FR006%20NV%252fWH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "fr006_NavyWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963036938",
      "product_title": "Kariban Ladies Oversized Sweatshirt",
      "product_handle": "kb471",
      "product_url": "/products/kb471",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "l-xl",
        "L-XL-S-M",
        "s-m",
        "style-kb471",
        "sweatshirts",
        "womens"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "91% cotton/9% polyester.*",
      "style_code": "KB471",
      "colour_name": "Off White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495432233226",
      "swatch_filename": "kb471_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb471_Off_White.jpg?v=1774542594",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb471_Off_White.jpg?v=1774542594",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB471/ProductCarouselMain/KB471%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb471_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457959989514",
      "product_title": "AWDis Cool Half Zip Sweat Top",
      "product_handle": "jc031",
      "product_url": "/products/jc031",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "PCBest_Seller",
        "performance-activewear",
        "S",
        "S-M-L-XL-XXL",
        "security",
        "sports",
        "style-jc031",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "87% polyester/13% elastane.",
      "style_code": "JC031",
      "colour_name": "Royal Blue/Arctic White",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494604677386",
      "swatch_filename": "jc031_Royal_BlueArctic_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc031_Royal_BlueArctic_White.jpg?v=1774542192",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc031_Royal_BlueArctic_White.jpg?v=1774542192",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC031/ProductCarouselMain/JC031%20RY%252fAW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc031_Royal_BlueArctic_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969164554",
      "product_title": "Spiro Unisex Zip Neck Trial Training Top",
      "product_handle": "sr178m",
      "product_url": "/products/sr178m",
      "product_full_url": "None",
      "vendor": "Spiro",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "security",
        "sports",
        "style-sr178m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "SR178M",
      "colour_name": "Royal Blue/Navy/White",
      "colour_group": "Blue > Royal",
      "rgb": "#001da8;#081727;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497115427082",
      "swatch_filename": "sr178m_Royal_BlueNavyWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr178m_Royal_BlueNavyWhite.jpg?v=1774543332",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr178m_Royal_BlueNavyWhite.jpg?v=1774543332",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR178M/ProductCarouselMain/SR178M%20R-N-W%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr178m_Royal_BlueNavyWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948225802",
      "product_title": "Anthem Organic Sweatshirt",
      "product_handle": "am20",
      "product_url": "/products/am20",
      "product_full_url": "None",
      "vendor": "Anthem",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-am20",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "AM20",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494306652426",
      "swatch_filename": "am20_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_White.jpg?v=1774540526",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_White.jpg?v=1774540526",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM20/ProductCarouselMain/AM20%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am20_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457956483338",
      "product_title": "Canvas Unisex Heavyweight Crew Neck Sweatshirt",
      "product_handle": "cv4711",
      "product_url": "/products/cv4711",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv4711",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% airlume combed ringspun cotton/40% polyester.",
      "style_code": "CV4711",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494465151242",
      "swatch_filename": "cv4711_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4711_White.jpg?v=1774541747",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4711_White.jpg?v=1774541747",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV4711/ProductCarouselMain/CV4711%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv4711_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970311434",
      "product_title": "Fruit of the Loom Classic Drop Shoulder Sweatshirt",
      "product_handle": "ss9",
      "product_url": "/products/ss9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS9",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497443959050",
      "swatch_filename": "ss9_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_White.jpg?v=1774543489",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_White.jpg?v=1774543489",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS9/ProductCarouselMain/SS9%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss9_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970213130",
      "product_title": "Fruit of the Loom Classic Raglan Sweatshirt",
      "product_handle": "ss8",
      "product_url": "/products/ss8",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss8",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS8",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497380847882",
      "swatch_filename": "ss8_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_White.jpg?v=1774543460",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_White.jpg?v=1774543460",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS8/ProductCarouselMain/SS8%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss8_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969819914",
      "product_title": "Fruit of the Loom Iconic Premium Set-In Sweatshirt",
      "product_handle": "ss151",
      "product_url": "/products/ss151",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss151",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS151",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497254658314",
      "swatch_filename": "ss151_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_White.jpg?v=1774543400",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_White.jpg?v=1774543400",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS151/ProductCarouselMain/SS151%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss151_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969983754",
      "product_title": "Fruit of the Loom Iconic Premium Sweat Jacket",
      "product_handle": "ss155",
      "product_url": "/products/ss155",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "jackets",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss155",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS155",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497311215882",
      "swatch_filename": "ss155_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss155_White.jpg?v=1774543434",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss155_White.jpg?v=1774543434",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS155/ProductCarouselMain/SS155%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss155_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969885450",
      "product_title": "Fruit of the Loom Iconic Premium Zip Neck Sweatshirt",
      "product_handle": "ss154",
      "product_url": "/products/ss154",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss154",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS154",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497271238922",
      "swatch_filename": "ss154_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss154_White.jpg?v=1774543418",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss154_White.jpg?v=1774543418",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS154/ProductCarouselMain/SS154%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss154_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970180362",
      "product_title": "Fruit of the Loom Lady Fit Lightweight Raglan Sweatshirt",
      "product_handle": "ss180",
      "product_url": "/products/ss180",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "lightweight",
        "S",
        "style-ss180",
        "sweatshirts",
        "womens",
        "XS",
        "XS-S-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "SS180",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497352470794",
      "swatch_filename": "ss180_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss180_White.jpg?v=1774543451",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss180_White.jpg?v=1774543451",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Fruit%20of%20the%20Loom/SS180/ProductCarouselMain/SS180%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss180_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969557770",
      "product_title": "Fruit of the Loom Lightweight Raglan Sweatshirt",
      "product_handle": "ss120",
      "product_url": "/products/ss120",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-ss120",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "SS120",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497182535946",
      "swatch_filename": "ss120_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss120_White.jpg?v=1774543366",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss120_White.jpg?v=1774543366",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Fruit%20of%20the%20Loom/SS120/ProductCarouselMain/SS120%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss120_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970409738",
      "product_title": "Fruit of the Loom Premium Zip Neck Sweatshirt",
      "product_handle": "sse17",
      "product_url": "/products/sse17",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-sse17",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE17",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497519915274",
      "swatch_filename": "sse17_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse17_White.jpg?v=1774543520",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse17_White.jpg?v=1774543520",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SSE17/ProductCarouselMain/SSE17%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse17_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969721610",
      "product_title": "Fruit of the Loom Supercotton™ Sweatshirt",
      "product_handle": "ss141",
      "product_url": "/products/ss141",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss141",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS141",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497225560330",
      "swatch_filename": "ss141_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss141_White.jpg?v=1774543387",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss141_White.jpg?v=1774543387",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS141/ProductCarouselMain/SS141%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss141_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457957990666",
      "product_title": "Gildan DryBlend® Sweatshirt",
      "product_handle": "gd52",
      "product_url": "/products/gd52",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd52",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD52",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494473244938",
      "swatch_filename": "gd52_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd52_White.jpg?v=1774541873",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd52_White.jpg?v=1774541873",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD52/ProductCarouselMain/GD52%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd52_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494473965834",
      "swatch_filename": "gd56_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_White.jpg?v=1774541888",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_White.jpg?v=1774541888",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494480060682",
      "swatch_filename": "gd67_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_White.jpg?v=1774542023",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_White.jpg?v=1774542023",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963200778",
      "product_title": "Kariban Crew Neck Sweatshirt",
      "product_handle": "kb488",
      "product_url": "/products/kb488",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb488",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "KB488",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495499440394",
      "swatch_filename": "kb488_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb488_White.jpg?v=1774542619",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb488_White.jpg?v=1774542619",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB488/ProductCarouselMain/KB488%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb488_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495329210634",
      "swatch_filename": "kb4025_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_White.jpg?v=1774542550",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_White.jpg?v=1774542550",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963135242",
      "product_title": "Kariban Zip Neck Sweatshirt",
      "product_handle": "kb487",
      "product_url": "/products/kb487",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb487",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "KB487",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495471325450",
      "swatch_filename": "kb487_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb487_White.jpg?v=1774542604",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb487_White.jpg?v=1774542604",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB487/ProductCarouselMain/KB487%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb487_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49496939331850",
      "swatch_filename": "rx301_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_White.jpg?v=1774543250",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_White.jpg?v=1774543250",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494286631178",
      "swatch_filename": "262m_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_White.jpg?v=1774540338",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_White.jpg?v=1774540338",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946587402",
      "product_title": "Russell Athletic Authentic Zip Neck Sweatshirt",
      "product_handle": "270m",
      "product_url": "/products/270m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-270m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "270M",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494293741834",
      "swatch_filename": "270m_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/270m_White.jpg?v=1774540387",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/270m_White.jpg?v=1774540387",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/270M/ProductCarouselMain/270M%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "270m_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "03814",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494223618314",
      "swatch_filename": "03814_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_White.jpg?v=1774540235",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_White.jpg?v=1774540235",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03814/ProductCarouselMain/03814%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944785162",
      "product_title": "SOL'S Unisex Comet Organic Sweatshirt",
      "product_handle": "03574",
      "product_url": "/products/03574",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03574",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "03574",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494219555082",
      "swatch_filename": "03574_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03574_White.jpg?v=1774540219",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03574_White.jpg?v=1774540219",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03574/ProductCarouselMain/03574%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03574_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946259722",
      "product_title": "SOL'S Unisex New Supreme Sweatshirt",
      "product_handle": "13250",
      "product_url": "/products/13250",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-13250",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "13250",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494282961162",
      "swatch_filename": "13250_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_White.jpg?v=1774540321",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_White.jpg?v=1774540321",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/13250/ProductCarouselMain/13250%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "13250_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944686858",
      "product_title": "SOL'S Unisex Space Organic Raglan Sweatshirt",
      "product_handle": "03567",
      "product_url": "/products/03567",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03567",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "03567",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494217949450",
      "swatch_filename": "03567_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_White.jpg?v=1774540195",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_White.jpg?v=1774540195",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03567/ProductCarouselMain/03567%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03567_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944490250",
      "product_title": "SOL'S Unisex Sully Sweatshirt",
      "product_handle": "02990",
      "product_url": "/products/02990",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-02990",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "02990",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494216081674",
      "swatch_filename": "02990_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02990_White.jpg?v=1774540172",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02990_White.jpg?v=1774540172",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SOL%27S/02990/ProductCarouselMain/02990%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02990_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969164554",
      "product_title": "Spiro Unisex Zip Neck Trial Training Top",
      "product_handle": "sr178m",
      "product_url": "/products/sr178m",
      "product_full_url": "None",
      "vendor": "Spiro",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "security",
        "sports",
        "style-sr178m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "SR178M",
      "colour_name": "White/Red/White",
      "colour_group": "White > White",
      "rgb": "#ffffff;#e10037;#ffffff",
      "sort_bucket": "white",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497121063178",
      "swatch_filename": "sr178m_WhiteRedWhite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr178m_WhiteRedWhite.jpg?v=1774543333",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sr178m_WhiteRedWhite.jpg?v=1774543333",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Spiro/Product%20Images/SR178M/ProductCarouselMain/SR178M%20W%252fR%252fW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sr178m_WhiteRedWhite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Off White",
      "colour_group": "White > White",
      "rgb": "#f5ebd3",
      "sort_bucket": "white",
      "sort_hue": 0.117647,
      "sort_sat": 0.138776,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49494480421130",
      "swatch_filename": "gd67_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Off_White.jpg?v=1774542024",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Off_White.jpg?v=1774542024",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958187274",
      "product_title": "Gildan SoftStyle® Midweight Fleece 1/4 Zip Sweatshirt",
      "product_handle": "gd612",
      "product_url": "/products/gd612",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd612",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD612",
      "colour_name": "Off White",
      "colour_group": "White > White",
      "rgb": "#f5ebd3",
      "sort_bucket": "white",
      "sort_hue": 0.117647,
      "sort_sat": 0.138776,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49494476718346",
      "swatch_filename": "gd612_Off_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Off_White.jpg?v=1774541940",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Off_White.jpg?v=1774541940",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD612/ProductCarouselMain/GD612%20OFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd612_Off_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964642570",
      "product_title": "Native Spirit Unisex Crew Neck Sweatshirt",
      "product_handle": "ns443",
      "product_url": "/products/ns443",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns443",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS400",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ededff",
      "sort_bucket": "white",
      "sort_hue": 0.666667,
      "sort_sat": 0.070588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495935680778",
      "swatch_filename": "ns443_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns443_White.jpg?v=1774542825",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns443_White.jpg?v=1774542825",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS400/ProductCarouselMain/NS400%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns443_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964085514",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns407",
      "product_url": "/products/ns407",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns407",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "White",
      "colour_group": "White > White",
      "rgb": "#ededff",
      "sort_bucket": "white",
      "sort_hue": 0.666667,
      "sort_sat": 0.070588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495740547338",
      "swatch_filename": "ns407_White.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_White.jpg?v=1774542732",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_White.jpg?v=1774542732",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20WHI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns407_White.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947308298",
      "product_title": "Russell Athletic Kids Raglan Sweatshirt",
      "product_handle": "762b",
      "product_url": "/products/762b",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "performance-activewear",
        "sports",
        "style-762b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762B",
      "colour_name": "Bright Red",
      "colour_group": "Red > Red",
      "rgb": "#ff0000",
      "sort_bucket": "red",
      "sort_hue": 0.0,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494298853642",
      "swatch_filename": "762b_Bright_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Bright_Red.jpg?v=1774540425",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Bright_Red.jpg?v=1774540425",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762B/ProductCarouselMain/762B%20BRE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762b_Bright_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947472138",
      "product_title": "Russell Athletic Raglan Sweatshirt",
      "product_handle": "762m",
      "product_url": "/products/762m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-762m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762M",
      "colour_name": "Bright Red",
      "colour_group": "Red > Red",
      "rgb": "#ff0000",
      "sort_bucket": "red",
      "sort_hue": 0.0,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494300197130",
      "swatch_filename": "762m_Bright_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762m_Bright_Red.jpg?v=1774540446",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762m_Bright_Red.jpg?v=1774540446",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762M/ProductCarouselMain/762M%20BRE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762m_Bright_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "03814",
      "colour_name": "Bright Red",
      "colour_group": "Red > Red",
      "rgb": "#f70000",
      "sort_bucket": "red",
      "sort_hue": 0.0,
      "sort_sat": 1.0,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49494223683850",
      "swatch_filename": "03814_Bright_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Bright_Red.jpg?v=1774540237",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Bright_Red.jpg?v=1774540237",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SOL%27S/03814/ProductCarouselMain/03814%20BRE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_Bright_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457945178378",
      "product_title": "SOL'S Unisex Conrad 1/4 Zip Sweatshirt",
      "product_handle": "04234",
      "product_url": "/products/04234",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-04234",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "04234",
      "colour_name": "Bright Red",
      "colour_group": "Red > Red",
      "rgb": "#f70000",
      "sort_bucket": "red",
      "sort_hue": 0.0,
      "sort_sat": 1.0,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49494279291146",
      "swatch_filename": "04234_Bright_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04234_Bright_Red.jpg?v=1774540270",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04234_Bright_Red.jpg?v=1774540270",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04234/ProductCarouselMain/04234%20BRE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04234_Bright_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457945440522",
      "product_title": "SOL'S Unisex Cooper Full Zip Sweat Jacket",
      "product_handle": "04240",
      "product_url": "/products/04240",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "jackets",
        "L",
        "M",
        "S",
        "style-04240",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "04240",
      "colour_name": "Bright Red",
      "colour_group": "Red > Red",
      "rgb": "#f70000",
      "sort_bucket": "red",
      "sort_hue": 0.0,
      "sort_sat": 1.0,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49494280175882",
      "swatch_filename": "04240_Bright_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04240_Bright_Red.jpg?v=1774540282",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04240_Bright_Red.jpg?v=1774540282",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04240/ProductCarouselMain/04240%20BRE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04240_Bright_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963626762",
      "product_title": "Finden + Hales 1/4 Zip Tracksuit Top",
      "product_handle": "lv874",
      "product_url": "/products/lv874",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv874",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV874",
      "colour_name": "Burgundy/Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#872435;#872435",
      "sort_bucket": "red",
      "sort_hue": 0.0,
      "sort_sat": 0.7,
      "sort_val": 0.7,
      "swatch_file_id": "gid://shopify/MediaImage/49495585063178",
      "swatch_filename": "lv874_BurgundyBurgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_BurgundyBurgundy.jpg?v=1774542669",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_BurgundyBurgundy.jpg?v=1774542669",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV874/ProductCarouselMain/LV874%20BG_BG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv874_BurgundyBurgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963725066",
      "product_title": "Finden + Hales Kids 1/4 Zip Tracksuit Top",
      "product_handle": "lv875",
      "product_url": "/products/lv875",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-lv875",
        "sweatshirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV875",
      "colour_name": "Burgundy/Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#872435;#872435",
      "sort_bucket": "red",
      "sort_hue": 0.0,
      "sort_sat": 0.7,
      "sort_val": 0.7,
      "swatch_file_id": "gid://shopify/MediaImage/49495625269514",
      "swatch_filename": "lv875_BurgundyBurgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_BurgundyBurgundy.jpg?v=1774542688",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_BurgundyBurgundy.jpg?v=1774542688",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV875/ProductCarouselMain/LV875%20BG_BG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv875_BurgundyBurgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Maroon",
      "colour_group": "Red > Burgundy",
      "rgb": "#360a36",
      "sort_bucket": "red",
      "sort_hue": 0.833333,
      "sort_sat": 0.814815,
      "sort_val": 0.211765,
      "swatch_file_id": "gid://shopify/MediaImage/49494474129674",
      "swatch_filename": "gd56_Maroon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Maroon.jpg?v=1774541889",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Maroon.jpg?v=1774541889",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20MAR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Maroon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Maroon",
      "colour_group": "Red > Burgundy",
      "rgb": "#360a36",
      "sort_bucket": "red",
      "sort_hue": 0.833333,
      "sort_sat": 0.814815,
      "sort_val": 0.211765,
      "swatch_file_id": "gid://shopify/MediaImage/49494480519434",
      "swatch_filename": "gd67_Maroon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Maroon.jpg?v=1774542026",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Maroon.jpg?v=1774542026",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20MAR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Maroon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958187274",
      "product_title": "Gildan SoftStyle® Midweight Fleece 1/4 Zip Sweatshirt",
      "product_handle": "gd612",
      "product_url": "/products/gd612",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd612",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD612",
      "colour_name": "Maroon",
      "colour_group": "Red > Burgundy",
      "rgb": "#360a36",
      "sort_bucket": "red",
      "sort_hue": 0.833333,
      "sort_sat": 0.814815,
      "sort_val": 0.211765,
      "swatch_file_id": "gid://shopify/MediaImage/49494476751114",
      "swatch_filename": "gd612_Maroon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Maroon.jpg?v=1774541942",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Maroon.jpg?v=1774541942",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD612/ProductCarouselMain/GD612%20MAR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd612_Maroon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970311434",
      "product_title": "Fruit of the Loom Classic Drop Shoulder Sweatshirt",
      "product_handle": "ss9",
      "product_url": "/products/ss9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS9",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#560d55",
      "sort_bucket": "red",
      "sort_hue": 0.835616,
      "sort_sat": 0.848837,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49497451102474",
      "swatch_filename": "ss9_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Burgundy.jpg?v=1774543492",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Burgundy.jpg?v=1774543492",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS9/ProductCarouselMain/SS9%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss9_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970213130",
      "product_title": "Fruit of the Loom Classic Raglan Sweatshirt",
      "product_handle": "ss8",
      "product_url": "/products/ss8",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss8",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS8",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#560d55",
      "sort_bucket": "red",
      "sort_hue": 0.835616,
      "sort_sat": 0.848837,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49497380880650",
      "swatch_filename": "ss8_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Burgundy.jpg?v=1774543462",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Burgundy.jpg?v=1774543462",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS8/ProductCarouselMain/SS8%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss8_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969819914",
      "product_title": "Fruit of the Loom Iconic Premium Set-In Sweatshirt",
      "product_handle": "ss151",
      "product_url": "/products/ss151",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss151",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS151",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#560d55",
      "sort_bucket": "red",
      "sort_hue": 0.835616,
      "sort_sat": 0.848837,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49497254723850",
      "swatch_filename": "ss151_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_Burgundy.jpg?v=1774543402",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_Burgundy.jpg?v=1774543402",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS151/ProductCarouselMain/SS151%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss151_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970508042",
      "product_title": "Fruit of the Loom Premium Drop Shoulder Sweatshirt",
      "product_handle": "sse9",
      "product_url": "/products/sse9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-sse9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE9",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#560d55",
      "sort_bucket": "red",
      "sort_hue": 0.835616,
      "sort_sat": 0.848837,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49497537577226",
      "swatch_filename": "sse9_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse9_Burgundy.jpg?v=1774543533",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse9_Burgundy.jpg?v=1774543533",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Fruit%20of%20the%20Loom/SSE9/ProductCarouselMain/SSE9%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse9_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964347658",
      "product_title": "Native Spirit 1/4 Zip Sweatshirt",
      "product_handle": "ns428",
      "product_url": "/products/ns428",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns428",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "NS428",
      "colour_name": "Dark Cherry",
      "colour_group": "Red > Dark Red",
      "rgb": "#3d0a39",
      "sort_bucket": "red",
      "sort_hue": 0.846405,
      "sort_sat": 0.836066,
      "sort_val": 0.239216,
      "swatch_file_id": "gid://shopify/MediaImage/49495869128970",
      "swatch_filename": "ns428_Dark_Cherry.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns428_Dark_Cherry.jpg?v=1774542784",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns428_Dark_Cherry.jpg?v=1774542784",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS428/ProductCarouselMain/NS428%20DCY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns428_Dark_Cherry.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963790602",
      "product_title": "Mantis Unisex Essential Sweatshirt",
      "product_handle": "m05",
      "product_url": "/products/m05",
      "product_full_url": "None",
      "vendor": "Mantis",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-m05",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "80% organic cotton/20% recycled polyester.",
      "style_code": "M05",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#62054f",
      "sort_bucket": "red",
      "sort_hue": 0.867384,
      "sort_sat": 0.94898,
      "sort_val": 0.384314,
      "swatch_file_id": "gid://shopify/MediaImage/49495664165130",
      "swatch_filename": "m05_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m05_Burgundy.jpg?v=1774542699",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m05_Burgundy.jpg?v=1774542699",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Mantis/M05/ProductCarouselMain/M05%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "m05_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Cranberry",
      "colour_group": "Red > Dark Red",
      "rgb": "#b6008f",
      "sort_bucket": "red",
      "sort_hue": 0.869048,
      "sort_sat": 1.0,
      "sort_val": 0.713725,
      "swatch_file_id": "gid://shopify/MediaImage/49494606741770",
      "swatch_filename": "jh030_Cranberry.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Cranberry.jpg?v=1774542232",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Cranberry.jpg?v=1774542232",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20CRA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Cranberry.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#560340",
      "sort_bucket": "red",
      "sort_hue": 0.87751,
      "sort_sat": 0.965116,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49496939364618",
      "swatch_filename": "rx301_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Burgundy.jpg?v=1774543252",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Burgundy.jpg?v=1774543252",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "03814",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#340426",
      "sort_bucket": "red",
      "sort_hue": 0.881944,
      "sort_sat": 0.923077,
      "sort_val": 0.203922,
      "swatch_file_id": "gid://shopify/MediaImage/49494223749386",
      "swatch_filename": "03814_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Burgundy.jpg?v=1774540238",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Burgundy.jpg?v=1774540238",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SOL%27S/03814/ProductCarouselMain/03814%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946259722",
      "product_title": "SOL'S Unisex New Supreme Sweatshirt",
      "product_handle": "13250",
      "product_url": "/products/13250",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-13250",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "13250",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#340426",
      "sort_bucket": "red",
      "sort_hue": 0.881944,
      "sort_sat": 0.923077,
      "sort_val": 0.203922,
      "swatch_file_id": "gid://shopify/MediaImage/49494283026698",
      "swatch_filename": "13250_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_Burgundy.jpg?v=1774540323",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_Burgundy.jpg?v=1774540323",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/13250/ProductCarouselMain/13250%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "13250_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944686858",
      "product_title": "SOL'S Unisex Space Organic Raglan Sweatshirt",
      "product_handle": "03567",
      "product_url": "/products/03567",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03567",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "03567",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#340426",
      "sort_bucket": "red",
      "sort_hue": 0.881944,
      "sort_sat": 0.923077,
      "sort_val": 0.203922,
      "swatch_file_id": "gid://shopify/MediaImage/49494218014986",
      "swatch_filename": "03567_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Burgundy.jpg?v=1774540197",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Burgundy.jpg?v=1774540197",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03567/ProductCarouselMain/03567%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03567_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947898122",
      "product_title": "AWDis Academy Senior Raglan Sweatshirt",
      "product_handle": "ac001",
      "product_url": "/products/ac001",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ac001",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC001",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#45002e",
      "sort_bucket": "red",
      "sort_hue": 0.888889,
      "sort_sat": 1.0,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49494303179018",
      "swatch_filename": "ac001_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Burgundy.jpg?v=1774540484",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Burgundy.jpg?v=1774540484",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC001/ProductCarouselMain/AC001%20ABY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac001_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#45002e",
      "sort_bucket": "red",
      "sort_hue": 0.888889,
      "sort_sat": 1.0,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49494846177546",
      "swatch_filename": "jh030b_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Burgundy.jpg?v=1774542334",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Burgundy.jpg?v=1774542334",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960874250",
      "product_title": "AWDis Sophomore Zip Neck Sweatshirt",
      "product_handle": "jh046",
      "product_url": "/products/jh046",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL",
        "style-jh046",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH046",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#45002e",
      "sort_bucket": "red",
      "sort_hue": 0.888889,
      "sort_sat": 1.0,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49495041802506",
      "swatch_filename": "jh046_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh046_Burgundy.jpg?v=1774542400",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh046_Burgundy.jpg?v=1774542400",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH046/ProductCarouselMain/JH046%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh046_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#45002e",
      "sort_bucket": "red",
      "sort_hue": 0.888889,
      "sort_sat": 1.0,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49494606774538",
      "swatch_filename": "jh030_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Burgundy.jpg?v=1774542233",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Burgundy.jpg?v=1774542233",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961398538",
      "product_title": "AWDis Unisex Organic Sweatshirt",
      "product_handle": "jh230",
      "product_url": "/products/jh230",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-jh230",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "JH230",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#45002e",
      "sort_bucket": "red",
      "sort_hue": 0.888889,
      "sort_sat": 1.0,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49495121756426",
      "swatch_filename": "jh230_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_Burgundy.jpg?v=1774542457",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_Burgundy.jpg?v=1774542457",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH230/ProductCarouselMain/JH230%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh230_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946521866",
      "product_title": "Russell Athletic Authentic Sweat Jacket",
      "product_handle": "267m",
      "product_url": "/products/267m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "jackets",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-267m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun combed cotton/20% polyester.",
      "style_code": "267M",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#46002a",
      "sort_bucket": "red",
      "sort_hue": 0.9,
      "sort_sat": 1.0,
      "sort_val": 0.27451,
      "swatch_file_id": "gid://shopify/MediaImage/49494289907978",
      "swatch_filename": "267m_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/267m_Burgundy.jpg?v=1774540372",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/267m_Burgundy.jpg?v=1774540372",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/267M/ProductCarouselMain/267M%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "267m_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#46002a",
      "sort_bucket": "red",
      "sort_hue": 0.9,
      "sort_sat": 1.0,
      "sort_val": 0.27451,
      "swatch_file_id": "gid://shopify/MediaImage/49494286958858",
      "swatch_filename": "262m_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Burgundy.jpg?v=1774540340",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Burgundy.jpg?v=1774540340",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946587402",
      "product_title": "Russell Athletic Authentic Zip Neck Sweatshirt",
      "product_handle": "270m",
      "product_url": "/products/270m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-270m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "270M",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#46002a",
      "sort_bucket": "red",
      "sort_hue": 0.9,
      "sort_sat": 1.0,
      "sort_val": 0.27451,
      "swatch_file_id": "gid://shopify/MediaImage/49494293840138",
      "swatch_filename": "270m_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/270m_Burgundy.jpg?v=1774540389",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/270m_Burgundy.jpg?v=1774540389",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/270M/ProductCarouselMain/270M%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "270m_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947308298",
      "product_title": "Russell Athletic Kids Raglan Sweatshirt",
      "product_handle": "762b",
      "product_url": "/products/762b",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "performance-activewear",
        "sports",
        "style-762b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762B",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#46002a",
      "sort_bucket": "red",
      "sort_hue": 0.9,
      "sort_sat": 1.0,
      "sort_val": 0.27451,
      "swatch_file_id": "gid://shopify/MediaImage/49494298951946",
      "swatch_filename": "762b_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Burgundy.jpg?v=1774540427",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Burgundy.jpg?v=1774540427",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762B/ProductCarouselMain/762B%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762b_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947472138",
      "product_title": "Russell Athletic Raglan Sweatshirt",
      "product_handle": "762m",
      "product_url": "/products/762m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-762m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762M",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#46002a",
      "sort_bucket": "red",
      "sort_hue": 0.9,
      "sort_sat": 1.0,
      "sort_val": 0.27451,
      "swatch_file_id": "gid://shopify/MediaImage/49494300262666",
      "swatch_filename": "762m_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762m_Burgundy.jpg?v=1774540447",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762m_Burgundy.jpg?v=1774540447",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762M/ProductCarouselMain/762M%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762m_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Red Hot Chilli",
      "colour_group": "Red > Dark Red",
      "rgb": "#ae0053",
      "sort_bucket": "red",
      "sort_hue": 0.920498,
      "sort_sat": 1.0,
      "sort_val": 0.682353,
      "swatch_file_id": "gid://shopify/MediaImage/49494606840074",
      "swatch_filename": "jh030_Red_Hot_Chilli.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Red_Hot_Chilli.jpg?v=1774542235",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Red_Hot_Chilli.jpg?v=1774542235",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20RHC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Red_Hot_Chilli.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948225802",
      "product_title": "Anthem Organic Sweatshirt",
      "product_handle": "am20",
      "product_url": "/products/am20",
      "product_full_url": "None",
      "vendor": "Anthem",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-am20",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "AM20",
      "colour_name": "Burgundy",
      "colour_group": "Red > Burgundy",
      "rgb": "#633a4c",
      "sort_bucket": "red",
      "sort_hue": 0.926829,
      "sort_sat": 0.414141,
      "sort_val": 0.388235,
      "swatch_file_id": "gid://shopify/MediaImage/49494307078410",
      "swatch_filename": "am20_Burgundy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Burgundy.jpg?v=1774540528",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Burgundy.jpg?v=1774540528",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM20/ProductCarouselMain/AM20%20BUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am20_Burgundy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Garnet",
      "colour_group": "Red > Dark Red",
      "rgb": "#5a0025",
      "sort_bucket": "red",
      "sort_hue": 0.931481,
      "sort_sat": 1.0,
      "sort_val": 0.352941,
      "swatch_file_id": "gid://shopify/MediaImage/49494474326282",
      "swatch_filename": "gd56_Garnet.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Garnet.jpg?v=1774541891",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Garnet.jpg?v=1774541891",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20GAR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Garnet.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944391946",
      "product_title": "SOL'S Stan Contrast Zip Neck Sweatshirt",
      "product_handle": "02088",
      "product_url": "/products/02088",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-02088",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "02088",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49494214541578",
      "swatch_filename": "02088_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02088_Red.jpg?v=1774540157",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02088_Red.jpg?v=1774540157",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02088/ProductCarouselMain/02088%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02088_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944785162",
      "product_title": "SOL'S Unisex Comet Organic Sweatshirt",
      "product_handle": "03574",
      "product_url": "/products/03574",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03574",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "03574",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49494219653386",
      "swatch_filename": "03574_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03574_Red.jpg?v=1774540220",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03574_Red.jpg?v=1774540220",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SOL%27S/03574/ProductCarouselMain/03574%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03574_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946259722",
      "product_title": "SOL'S Unisex New Supreme Sweatshirt",
      "product_handle": "13250",
      "product_url": "/products/13250",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-13250",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "13250",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49494284665098",
      "swatch_filename": "13250_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_Red.jpg?v=1774540324",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_Red.jpg?v=1774540324",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/13250/ProductCarouselMain/13250%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "13250_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944686858",
      "product_title": "SOL'S Unisex Space Organic Raglan Sweatshirt",
      "product_handle": "03567",
      "product_url": "/products/03567",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03567",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "03567",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c90546",
      "sort_bucket": "red",
      "sort_hue": 0.944728,
      "sort_sat": 0.975124,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49494218047754",
      "swatch_filename": "03567_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Red.jpg?v=1774540199",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Red.jpg?v=1774540199",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SOL%27S/03567/ProductCarouselMain/03567%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03567_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Antique Cherry Red",
      "colour_group": "Red > Dark Red",
      "rgb": "#9d0033",
      "sort_bucket": "red",
      "sort_hue": 0.94586,
      "sort_sat": 1.0,
      "sort_val": 0.615686,
      "swatch_file_id": "gid://shopify/MediaImage/49494474555658",
      "swatch_filename": "gd56_Antique_Cherry_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Antique_Cherry_Red.jpg?v=1774541892",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Antique_Cherry_Red.jpg?v=1774541892",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD56/ProductCarouselMain/GD56%20ACY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Antique_Cherry_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Fire Red",
      "colour_group": "Red > Red",
      "rgb": "#da0043",
      "sort_bucket": "red",
      "sort_hue": 0.948777,
      "sort_sat": 1.0,
      "sort_val": 0.854902,
      "swatch_file_id": "gid://shopify/MediaImage/49494846210314",
      "swatch_filename": "jh030b_Fire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Fire_Red.jpg?v=1774542336",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Fire_Red.jpg?v=1774542336",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20FIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Fire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Fire Red",
      "colour_group": "Red > Red",
      "rgb": "#da0043",
      "sort_bucket": "red",
      "sort_hue": 0.948777,
      "sort_sat": 1.0,
      "sort_val": 0.854902,
      "swatch_file_id": "gid://shopify/MediaImage/49494606905610",
      "swatch_filename": "jh030_Fire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Fire_Red.jpg?v=1774542236",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Fire_Red.jpg?v=1774542236",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20FIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Fire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961398538",
      "product_title": "AWDis Unisex Organic Sweatshirt",
      "product_handle": "jh230",
      "product_url": "/products/jh230",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-jh230",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "JH230",
      "colour_name": "Fire Red",
      "colour_group": "Red > Red",
      "rgb": "#da0043",
      "sort_bucket": "red",
      "sort_hue": 0.948777,
      "sort_sat": 1.0,
      "sort_val": 0.854902,
      "swatch_file_id": "gid://shopify/MediaImage/49495129719050",
      "swatch_filename": "jh230_Fire_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_Fire_Red.jpg?v=1774542458",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_Fire_Red.jpg?v=1774542458",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH230/ProductCarouselMain/JH230%20FIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh230_Fire_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948160266",
      "product_title": "AWDis Academy Kids V Neck Sweatshirt",
      "product_handle": "ac003b",
      "product_url": "/products/ac003b",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-ac003b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC003B",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#da0043",
      "sort_bucket": "red",
      "sort_hue": 0.948777,
      "sort_sat": 1.0,
      "sort_val": 0.854902,
      "swatch_file_id": "gid://shopify/MediaImage/49494305603850",
      "swatch_filename": "ac003b_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003b_Red.jpg?v=1774540511",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003b_Red.jpg?v=1774540511",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC003B/ProductCarouselMain/AC003B%20ARD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac003b_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947898122",
      "product_title": "AWDis Academy Senior Raglan Sweatshirt",
      "product_handle": "ac001",
      "product_url": "/products/ac001",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ac001",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC001",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#da0043",
      "sort_bucket": "red",
      "sort_hue": 0.948777,
      "sort_sat": 1.0,
      "sort_val": 0.854902,
      "swatch_file_id": "gid://shopify/MediaImage/49494303310090",
      "swatch_filename": "ac001_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Red.jpg?v=1774540486",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Red.jpg?v=1774540486",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC001/ProductCarouselMain/AC001%20ARD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac001_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff0047",
      "sort_bucket": "red",
      "sort_hue": 0.953595,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494474588426",
      "swatch_filename": "gd56_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Red.jpg?v=1774541894",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Red.jpg?v=1774541894",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff0047",
      "sort_bucket": "red",
      "sort_hue": 0.953595,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494480617738",
      "swatch_filename": "gd67_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Red.jpg?v=1774542027",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Red.jpg?v=1774542027",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff0047",
      "sort_bucket": "red",
      "sort_hue": 0.953595,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49496939462922",
      "swatch_filename": "rx301_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Red.jpg?v=1774543253",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Red.jpg?v=1774543253",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962971402",
      "product_title": "Kariban Crew Neck Sweatshirt",
      "product_handle": "kb442",
      "product_url": "/products/kb442",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-kb442",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed cotton/20% polyester.",
      "style_code": "KB442",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ba0b2f",
      "sort_bucket": "red",
      "sort_hue": 0.965714,
      "sort_sat": 0.94086,
      "sort_val": 0.729412,
      "swatch_file_id": "gid://shopify/MediaImage/49495419945226",
      "swatch_filename": "kb442_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb442_Red.jpg?v=1774542583",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb442_Red.jpg?v=1774542583",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB442/ProductCarouselMain/KB442%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb442_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963200778",
      "product_title": "Kariban Crew Neck Sweatshirt",
      "product_handle": "kb488",
      "product_url": "/products/kb488",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb488",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed cotton/20% polyester.",
      "style_code": "KB442",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ba0b2f",
      "sort_bucket": "red",
      "sort_hue": 0.965714,
      "sort_sat": 0.94086,
      "sort_val": 0.729412,
      "swatch_file_id": "gid://shopify/MediaImage/49495499505930",
      "swatch_filename": "kb488_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb488_Red.jpg?v=1774542620",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb488_Red.jpg?v=1774542620",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB442/ProductCarouselMain/KB442%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb488_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ba0b2f",
      "sort_bucket": "red",
      "sort_hue": 0.965714,
      "sort_sat": 0.94086,
      "sort_val": 0.729412,
      "swatch_file_id": "gid://shopify/MediaImage/49495330029834",
      "swatch_filename": "kb4025_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Red.jpg?v=1774542552",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Red.jpg?v=1774542552",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963135242",
      "product_title": "Kariban Zip Neck Sweatshirt",
      "product_handle": "kb487",
      "product_url": "/products/kb487",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb487",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "KB487",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ba0b2f",
      "sort_bucket": "red",
      "sort_hue": 0.965714,
      "sort_sat": 0.94086,
      "sort_val": 0.729412,
      "swatch_file_id": "gid://shopify/MediaImage/49495476076810",
      "swatch_filename": "kb487_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb487_Red.jpg?v=1774542606",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb487_Red.jpg?v=1774542606",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB487/ProductCarouselMain/KB487%20RED%20FRONT%20HERO.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb487_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946521866",
      "product_title": "Russell Athletic Authentic Sweat Jacket",
      "product_handle": "267m",
      "product_url": "/products/267m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "jackets",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-267m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun combed cotton/20% polyester.",
      "style_code": "267M",
      "colour_name": "Classic Red",
      "colour_group": "Red > Red",
      "rgb": "#bf0026",
      "sort_bucket": "red",
      "sort_hue": 0.966841,
      "sort_sat": 1.0,
      "sort_val": 0.74902,
      "swatch_file_id": "gid://shopify/MediaImage/49494289973514",
      "swatch_filename": "267m_Classic_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/267m_Classic_Red.jpg?v=1774540374",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/267m_Classic_Red.jpg?v=1774540374",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/267M/ProductCarouselMain/267M%20CSR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "267m_Classic_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "Classic Red",
      "colour_group": "Red > Red",
      "rgb": "#bf0026",
      "sort_bucket": "red",
      "sort_hue": 0.966841,
      "sort_sat": 1.0,
      "sort_val": 0.74902,
      "swatch_file_id": "gid://shopify/MediaImage/49494287286538",
      "swatch_filename": "262m_Classic_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Classic_Red.jpg?v=1774540341",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Classic_Red.jpg?v=1774540341",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20CSR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_Classic_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947308298",
      "product_title": "Russell Athletic Kids Raglan Sweatshirt",
      "product_handle": "762b",
      "product_url": "/products/762b",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "performance-activewear",
        "sports",
        "style-762b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762B",
      "colour_name": "Classic Red",
      "colour_group": "Red > Red",
      "rgb": "#bf0026",
      "sort_bucket": "red",
      "sort_hue": 0.966841,
      "sort_sat": 1.0,
      "sort_val": 0.74902,
      "swatch_file_id": "gid://shopify/MediaImage/49494299050250",
      "swatch_filename": "762b_Classic_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Classic_Red.jpg?v=1774540428",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Classic_Red.jpg?v=1774540428",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762B/ProductCarouselMain/762B%20CSR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762b_Classic_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947472138",
      "product_title": "Russell Athletic Raglan Sweatshirt",
      "product_handle": "762m",
      "product_url": "/products/762m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-762m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762M",
      "colour_name": "Classic Red",
      "colour_group": "Red > Red",
      "rgb": "#bf0026",
      "sort_bucket": "red",
      "sort_hue": 0.966841,
      "sort_sat": 1.0,
      "sort_val": 0.74902,
      "swatch_file_id": "gid://shopify/MediaImage/49494300295434",
      "swatch_filename": "762m_Classic_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762m_Classic_Red.jpg?v=1774540449",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762m_Classic_Red.jpg?v=1774540449",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762M/ProductCarouselMain/762M%20CSR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762m_Classic_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970311434",
      "product_title": "Fruit of the Loom Classic Drop Shoulder Sweatshirt",
      "product_handle": "ss9",
      "product_url": "/products/ss9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS9",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497451200778",
      "swatch_filename": "ss9_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Red.jpg?v=1774543493",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Red.jpg?v=1774543493",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS9/ProductCarouselMain/SS9%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss9_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970213130",
      "product_title": "Fruit of the Loom Classic Raglan Sweatshirt",
      "product_handle": "ss8",
      "product_url": "/products/ss8",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss8",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS8",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497380913418",
      "swatch_filename": "ss8_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Red.jpg?v=1774543463",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Red.jpg?v=1774543463",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS8/ProductCarouselMain/SS8%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss8_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969819914",
      "product_title": "Fruit of the Loom Iconic Premium Set-In Sweatshirt",
      "product_handle": "ss151",
      "product_url": "/products/ss151",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss151",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS151",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497254822154",
      "swatch_filename": "ss151_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_Red.jpg?v=1774543403",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_Red.jpg?v=1774543403",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS151/ProductCarouselMain/SS151%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss151_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969885450",
      "product_title": "Fruit of the Loom Iconic Premium Zip Neck Sweatshirt",
      "product_handle": "ss154",
      "product_url": "/products/ss154",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss154",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS154",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497271271690",
      "swatch_filename": "ss154_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss154_Red.jpg?v=1774543419",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss154_Red.jpg?v=1774543419",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS154/ProductCarouselMain/SS154%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss154_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970508042",
      "product_title": "Fruit of the Loom Premium Drop Shoulder Sweatshirt",
      "product_handle": "sse9",
      "product_url": "/products/sse9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-sse9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE9",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497537839370",
      "swatch_filename": "sse9_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse9_Red.jpg?v=1774543535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse9_Red.jpg?v=1774543535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Fruit%20of%20the%20Loom/SSE9/ProductCarouselMain/SSE9%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse9_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970409738",
      "product_title": "Fruit of the Loom Premium Zip Neck Sweatshirt",
      "product_handle": "sse17",
      "product_url": "/products/sse17",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-sse17",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE17",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#ff002e",
      "sort_bucket": "red",
      "sort_hue": 0.969935,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497524699402",
      "swatch_filename": "sse17_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse17_Red.jpg?v=1774543521",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse17_Red.jpg?v=1774543521",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SSE17/ProductCarouselMain/SSE17%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse17_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Cherry Red",
      "colour_group": "Red > Red",
      "rgb": "#bd0022",
      "sort_bucket": "red",
      "sort_hue": 0.970018,
      "sort_sat": 1.0,
      "sort_val": 0.741176,
      "swatch_file_id": "gid://shopify/MediaImage/49494474686730",
      "swatch_filename": "gd56_Cherry_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Cherry_Red.jpg?v=1774541895",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Cherry_Red.jpg?v=1774541895",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20CHY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Cherry_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "Wine",
      "colour_group": "Red > Dark Red",
      "rgb": "#572931",
      "sort_bucket": "red",
      "sort_hue": 0.971014,
      "sort_sat": 0.528736,
      "sort_val": 0.341176,
      "swatch_file_id": "gid://shopify/MediaImage/49495337173258",
      "swatch_filename": "kb4025_Wine.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Wine.jpg?v=1774542553",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Wine.jpg?v=1774542553",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20WIN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_Wine.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555801354",
      "product_title": "Tee Jays Power Organic Sweatshirt",
      "product_handle": "t5100",
      "product_url": "/products/t5100",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-t5100",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% organic cotton/30% polyester.",
      "style_code": "T5100",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#c7102e",
      "sort_bucket": "red",
      "sort_hue": 0.972678,
      "sort_sat": 0.919598,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49491206308106",
      "swatch_filename": "t5100_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5100_Red.jpg?v=1774526218",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5100_Red.jpg?v=1774526218",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Tee%20Jays/T5100/ProductCarouselMain/T5100%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5100_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948225802",
      "product_title": "Anthem Organic Sweatshirt",
      "product_handle": "am20",
      "product_url": "/products/am20",
      "product_full_url": "None",
      "vendor": "Anthem",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-am20",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "AM20",
      "colour_name": "Red",
      "colour_group": "Red > Red",
      "rgb": "#cc3541",
      "sort_bucket": "red",
      "sort_hue": 0.986755,
      "sort_sat": 0.740196,
      "sort_val": 0.8,
      "swatch_file_id": "gid://shopify/MediaImage/49494307242250",
      "swatch_filename": "am20_Red.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Red.jpg?v=1774540530",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Red.jpg?v=1774540530",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM20/ProductCarouselMain/AM20%20RED%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am20_Red.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff523d",
      "sort_bucket": "orange",
      "sort_hue": 0.018041,
      "sort_sat": 0.760784,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494474752266",
      "swatch_filename": "gd56_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Orange.jpg?v=1774541898",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Orange.jpg?v=1774541898",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964445962",
      "product_title": "Native Spirit Ladies Oversized Cropped Sweatshirt",
      "product_handle": "ns429",
      "product_url": "/products/ns429",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns429",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "65% organic combed cotton/35% recycled polyester.",
      "style_code": "NS429",
      "colour_name": "Apricot",
      "colour_group": "Orange > Light Orange",
      "rgb": "#ff9687",
      "sort_bucket": "orange",
      "sort_hue": 0.020833,
      "sort_sat": 0.470588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495886954762",
      "swatch_filename": "ns429_Apricot.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns429_Apricot.jpg?v=1774542794",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns429_Apricot.jpg?v=1774542794",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS429/ProductCarouselMain/NS429%20APR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns429_Apricot.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Burnt Orange",
      "colour_group": "Orange > Dark Orange",
      "rgb": "#fa2d0f",
      "sort_bucket": "orange",
      "sort_hue": 0.021277,
      "sort_sat": 0.94,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49494607003914",
      "swatch_filename": "jh030_Burnt_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Burnt_Orange.jpg?v=1774542238",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Burnt_Orange.jpg?v=1774542238",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20BOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Burnt_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944391946",
      "product_title": "SOL'S Stan Contrast Zip Neck Sweatshirt",
      "product_handle": "02088",
      "product_url": "/products/02088",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-02088",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "02088",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff380f",
      "sort_bucket": "orange",
      "sort_hue": 0.028472,
      "sort_sat": 0.941176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494214738186",
      "swatch_filename": "02088_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02088_Orange.jpg?v=1774540159",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02088_Orange.jpg?v=1774540159",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02088/ProductCarouselMain/02088%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02088_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "03814",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff380f",
      "sort_bucket": "orange",
      "sort_hue": 0.028472,
      "sort_sat": 0.941176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494223880458",
      "swatch_filename": "03814_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Orange.jpg?v=1774540240",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Orange.jpg?v=1774540240",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SOL%27S/03814/ProductCarouselMain/03814%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457971294474",
      "product_title": "Yoko Hi-Vis Sweatshirt",
      "product_handle": "yk030",
      "product_url": "/products/yk030",
      "product_full_url": "None",
      "vendor": "YOKO",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "hi-vis",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "safetywear-ppe",
        "style-yk030",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "YK030",
      "colour_name": "Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff4000",
      "sort_bucket": "orange",
      "sort_hue": 0.04183,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497662161162",
      "swatch_filename": "yk030_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk030_Orange.jpg?v=1774543602",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk030_Orange.jpg?v=1774543602",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/YOKO/Product%20Images/YK030/ProductCarouselMain/YK030%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "yk030_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457971360010",
      "product_title": "Yoko Hi-Vis Zip Neck Sweatshirt",
      "product_handle": "yk033",
      "product_url": "/products/yk033",
      "product_full_url": "None",
      "vendor": "YOKO",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "hi-vis",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "safetywear-ppe",
        "style-yk033",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "YK033",
      "colour_name": "Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff4000",
      "sort_bucket": "orange",
      "sort_hue": 0.04183,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497684082954",
      "swatch_filename": "yk033_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk033_Orange.jpg?v=1774543612",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk033_Orange.jpg?v=1774543612",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/YOKO/Product%20Images/YK033/ProductCarouselMain/YK033%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "yk033_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457971228938",
      "product_title": "Warrior Hi-Vis Sweatshirt",
      "product_handle": "wr011",
      "product_url": "/products/wr011",
      "product_full_url": "None",
      "vendor": "Warrior",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "hi-vis",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "safetywear-ppe",
        "style-wr011",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "WR011",
      "colour_name": "Fluorescent Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#f75e16",
      "sort_bucket": "orange",
      "sort_hue": 0.053333,
      "sort_sat": 0.910931,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49497659113738",
      "swatch_filename": "wr011_Fluorescent_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/wr011_Fluorescent_Orange.jpg?v=1774543595",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/wr011_Fluorescent_Orange.jpg?v=1774543595",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Warrior/Product%20Images/WR011/ProductCarouselMain/WR011%20FLO%20FRONT%202.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "wr011_Fluorescent_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "S Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff5900",
      "sort_bucket": "orange",
      "sort_hue": 0.05817,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494474817802",
      "swatch_filename": "gd56_S_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_S_Orange.jpg?v=1774541899",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_S_Orange.jpg?v=1774541899",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD56/ProductCarouselMain/GD56%20SYO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_S_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Orange",
      "colour_group": "Orange > Orange",
      "rgb": "#ff701a",
      "sort_bucket": "orange",
      "sort_hue": 0.062591,
      "sort_sat": 0.898039,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49496941887754",
      "swatch_filename": "rx301_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Orange.jpg?v=1774543256",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Orange.jpg?v=1774543256",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Orange Crush",
      "colour_group": "Orange > Orange",
      "rgb": "#ff701a",
      "sort_bucket": "orange",
      "sort_hue": 0.062591,
      "sort_sat": 0.898039,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494607036682",
      "swatch_filename": "jh030_Orange_Crush.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Orange_Crush.jpg?v=1774542239",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Orange_Crush.jpg?v=1774542239",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20OCR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Orange_Crush.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457967689994",
      "product_title": "Regatta High Visibility Pro Contract Crew Neck Sweatshirt",
      "product_handle": "rg563",
      "product_url": "/products/rg563",
      "product_full_url": "None",
      "vendor": "Regatta High Visibility",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-rg563",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "50% recycled polyester/50% polyester.",
      "style_code": "RG563",
      "colour_name": "Orange",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff8000",
      "sort_bucket": "orange",
      "sort_hue": 0.08366,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49496683774218",
      "swatch_filename": "rg563_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg563_Orange.jpg?v=1774543146",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg563_Orange.jpg?v=1774543146",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Regatta%20High%20Visibility/Product%20Images/RG563/ProductCarouselMain/RG563%20ORA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rg563_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964282122",
      "product_title": "Native Spirit Unisex Terry 280 Oversized Sweatshirt",
      "product_handle": "ns415",
      "product_url": "/products/ns415",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns415",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS415",
      "colour_name": "Washed Pomelo",
      "colour_group": "Orange > Light Orange",
      "rgb": "#ae4953",
      "sort_bucket": "orange",
      "sort_hue": 0.983498,
      "sort_sat": 0.58046,
      "sort_val": 0.682353,
      "swatch_file_id": "gid://shopify/MediaImage/49495826497802",
      "swatch_filename": "ns415_Washed_Pomelo.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns415_Washed_Pomelo.jpg?v=1774542771",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns415_Washed_Pomelo.jpg?v=1774542771",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Native%20Spirit/NS415/ProductCarouselMain/NS415%20WPO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns415_Washed_Pomelo.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964183818",
      "product_title": "Native Spirit Unisex Terry 280 Sweatshirt",
      "product_handle": "ns414",
      "product_url": "/products/ns414",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns414",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS414",
      "colour_name": "Washed Pomelo",
      "colour_group": "Orange > Light Orange",
      "rgb": "#ae4953",
      "sort_bucket": "orange",
      "sort_hue": 0.983498,
      "sort_sat": 0.58046,
      "sort_val": 0.682353,
      "swatch_file_id": "gid://shopify/MediaImage/49495797432586",
      "swatch_filename": "ns414_Washed_Pomelo.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns414_Washed_Pomelo.jpg?v=1774542759",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns414_Washed_Pomelo.jpg?v=1774542759",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Native%20Spirit/NS414/ProductCarouselMain/NS414%20WPO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns414_Washed_Pomelo.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964085514",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns407",
      "product_url": "/products/ns407",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns407",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "Burnt Brick",
      "colour_group": "Orange > Dark Orange",
      "rgb": "#a12f31",
      "sort_bucket": "orange",
      "sort_hue": 0.997076,
      "sort_sat": 0.708075,
      "sort_val": 0.631373,
      "swatch_file_id": "gid://shopify/MediaImage/49495740743946",
      "swatch_filename": "ns407_Burnt_Brick.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Burnt_Brick.jpg?v=1774542733",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Burnt_Brick.jpg?v=1774542733",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20BBK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns407_Burnt_Brick.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944686858",
      "product_title": "SOL'S Unisex Space Organic Raglan Sweatshirt",
      "product_handle": "03567",
      "product_url": "/products/03567",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03567",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "03567",
      "colour_name": "Burnt Orange",
      "colour_group": "Orange > Dark Orange",
      "rgb": "#f23b3d",
      "sort_bucket": "orange",
      "sort_hue": 0.998179,
      "sort_sat": 0.756198,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49494218146058",
      "swatch_filename": "03567_Burnt_Orange.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Burnt_Orange.jpg?v=1774540201",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Burnt_Orange.jpg?v=1774540201",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03567/ProductCarouselMain/03567%20BOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03567_Burnt_Orange.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Gold",
      "colour_group": "Yellow > Gold",
      "rgb": "#ffb821",
      "sort_bucket": "yellow",
      "sort_hue": 0.113363,
      "sort_sat": 0.870588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494607069450",
      "swatch_filename": "jh030_Gold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Gold.jpg?v=1774542241",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Gold.jpg?v=1774542241",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20GOL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Gold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Gold",
      "colour_group": "Yellow > Gold",
      "rgb": "#ffb005",
      "sort_bucket": "yellow",
      "sort_hue": 0.114,
      "sort_sat": 0.980392,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494474883338",
      "swatch_filename": "gd56_Gold.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Gold.jpg?v=1774541900",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Gold.jpg?v=1774541900",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20GOL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Gold.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Mustard",
      "colour_group": "Yellow > Dark Yellow",
      "rgb": "#c58802",
      "sort_bucket": "yellow",
      "sort_hue": 0.11453,
      "sort_sat": 0.989848,
      "sort_val": 0.772549,
      "swatch_file_id": "gid://shopify/MediaImage/49494846243082",
      "swatch_filename": "jh030b_Mustard.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Mustard.jpg?v=1774542337",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Mustard.jpg?v=1774542337",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20MUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Mustard.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Mustard",
      "colour_group": "Yellow > Dark Yellow",
      "rgb": "#c58802",
      "sort_bucket": "yellow",
      "sort_hue": 0.11453,
      "sort_sat": 0.989848,
      "sort_val": 0.772549,
      "swatch_file_id": "gid://shopify/MediaImage/49494607134986",
      "swatch_filename": "jh030_Mustard.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Mustard.jpg?v=1774542242",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Mustard.jpg?v=1774542242",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20MUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Mustard.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffb81c",
      "sort_bucket": "yellow",
      "sort_hue": 0.114537,
      "sort_sat": 0.890196,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495337206026",
      "swatch_filename": "kb4025_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Yellow.jpg?v=1774542555",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Yellow.jpg?v=1774542555",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20YEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964544266",
      "product_title": "Native Spirit Ladies Crew Neck Sweatshirt",
      "product_handle": "ns439",
      "product_url": "/products/ns439",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns439",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "NS439",
      "colour_name": "Sun Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#f2bf49",
      "sort_bucket": "yellow",
      "sort_hue": 0.116371,
      "sort_sat": 0.698347,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49495900750090",
      "swatch_filename": "ns439_Sun_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns439_Sun_Yellow.jpg?v=1774542806",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns439_Sun_Yellow.jpg?v=1774542806",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS439/ProductCarouselMain/NS439%20SNY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns439_Sun_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "Mustard",
      "colour_group": "Yellow > Yellow",
      "rgb": "#fac511",
      "sort_bucket": "yellow",
      "sort_hue": 0.128755,
      "sort_sat": 0.932,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49494287483146",
      "swatch_filename": "262m_Mustard.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Mustard.jpg?v=1774540343",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Mustard.jpg?v=1774540343",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20MUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_Mustard.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970311434",
      "product_title": "Fruit of the Loom Classic Drop Shoulder Sweatshirt",
      "product_handle": "ss9",
      "product_url": "/products/ss9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS9",
      "colour_name": "Sunflower",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffc700",
      "sort_bucket": "yellow",
      "sort_hue": 0.130065,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497461457162",
      "swatch_filename": "ss9_Sunflower.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Sunflower.jpg?v=1774543494",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Sunflower.jpg?v=1774543494",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS9/ProductCarouselMain/SS9%20SUN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss9_Sunflower.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Yellow Haze",
      "colour_group": "Yellow > Light Yellow",
      "rgb": "#fff5ba",
      "sort_bucket": "yellow",
      "sort_hue": 0.142512,
      "sort_sat": 0.270588,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494480650506",
      "swatch_filename": "gd67_Yellow_Haze.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Yellow_Haze.jpg?v=1774542029",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Yellow_Haze.jpg?v=1774542029",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20YHZ%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Yellow_Haze.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffe338",
      "sort_bucket": "yellow",
      "sort_hue": 0.143216,
      "sort_sat": 0.780392,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49496942018826",
      "swatch_filename": "rx301_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Yellow.jpg?v=1774543257",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Yellow.jpg?v=1774543257",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20YEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Sun Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffe800",
      "sort_bucket": "yellow",
      "sort_hue": 0.151634,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494846275850",
      "swatch_filename": "jh030b_Sun_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Sun_Yellow.jpg?v=1774542339",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Sun_Yellow.jpg?v=1774542339",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20SNY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Sun_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Sun Yellow",
      "colour_group": "Yellow > Yellow",
      "rgb": "#ffe800",
      "sort_bucket": "yellow",
      "sort_hue": 0.151634,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494607233290",
      "swatch_filename": "jh030_Sun_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Sun_Yellow.jpg?v=1774542244",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Sun_Yellow.jpg?v=1774542244",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20SNY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Sun_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457971294474",
      "product_title": "Yoko Hi-Vis Sweatshirt",
      "product_handle": "yk030",
      "product_url": "/products/yk030",
      "product_full_url": "None",
      "vendor": "YOKO",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "hi-vis",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "safetywear-ppe",
        "style-yk030",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "YK030",
      "colour_name": "Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#ffff00",
      "sort_bucket": "yellow",
      "sort_hue": 0.166667,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497662193930",
      "swatch_filename": "yk030_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk030_Yellow.jpg?v=1774543603",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk030_Yellow.jpg?v=1774543603",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/YOKO/Product%20Images/YK030/ProductCarouselMain/YK030%20YEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "yk030_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457971360010",
      "product_title": "Yoko Hi-Vis Zip Neck Sweatshirt",
      "product_handle": "yk033",
      "product_url": "/products/yk033",
      "product_full_url": "None",
      "vendor": "YOKO",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "hi-vis",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "safetywear-ppe",
        "style-yk033",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "YK033",
      "colour_name": "Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#ffff00",
      "sort_bucket": "yellow",
      "sort_hue": 0.166667,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497698795786",
      "swatch_filename": "yk033_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk033_Yellow.jpg?v=1774543614",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk033_Yellow.jpg?v=1774543614",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/YOKO/Product%20Images/YK033/ProductCarouselMain/YK033%20YEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "yk033_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457967689994",
      "product_title": "Regatta High Visibility Pro Contract Crew Neck Sweatshirt",
      "product_handle": "rg563",
      "product_url": "/products/rg563",
      "product_full_url": "None",
      "vendor": "Regatta High Visibility",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-rg563",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "50% recycled polyester/50% polyester.",
      "style_code": "RG563",
      "colour_name": "Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#f7ff38",
      "sort_bucket": "yellow",
      "sort_hue": 0.173367,
      "sort_sat": 0.780392,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49496696062218",
      "swatch_filename": "rg563_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg563_Yellow.jpg?v=1774543147",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg563_Yellow.jpg?v=1774543147",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Regatta%20High%20Visibility/Product%20Images/RG563/ProductCarouselMain/RG563%20YEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rg563_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457971228938",
      "product_title": "Warrior Hi-Vis Sweatshirt",
      "product_handle": "wr011",
      "product_url": "/products/wr011",
      "product_full_url": "None",
      "vendor": "Warrior",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "hi-vis",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "safetywear-ppe",
        "style-wr011",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "WR011",
      "colour_name": "Fluorescent Yellow",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#f0ff03",
      "sort_bucket": "yellow",
      "sort_hue": 0.176587,
      "sort_sat": 0.988235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497661899018",
      "swatch_filename": "wr011_Fluorescent_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/wr011_Fluorescent_Yellow.jpg?v=1774543596",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/wr011_Fluorescent_Yellow.jpg?v=1774543596",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Warrior/Product%20Images/WR011/ProductCarouselMain/WR011%20FLY%20FRONT%202.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "wr011_Fluorescent_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "03814",
      "colour_name": "Light Yellow",
      "colour_group": "Yellow > Light Yellow",
      "rgb": "#f2ff7a",
      "sort_bucket": "yellow",
      "sort_hue": 0.182957,
      "sort_sat": 0.521569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494223945994",
      "swatch_filename": "03814_Light_Yellow.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Light_Yellow.jpg?v=1774540241",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Light_Yellow.jpg?v=1774540241",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03814/ProductCarouselMain/03814%20LYL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_Light_Yellow.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#737533",
      "sort_bucket": "green",
      "sort_hue": 0.171717,
      "sort_sat": 0.564103,
      "sort_val": 0.458824,
      "swatch_file_id": "gid://shopify/MediaImage/49494608052490",
      "swatch_filename": "jh030_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Khaki.jpg?v=1774542245",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Khaki.jpg?v=1774542245",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963790602",
      "product_title": "Mantis Unisex Essential Sweatshirt",
      "product_handle": "m05",
      "product_url": "/products/m05",
      "product_full_url": "None",
      "vendor": "Mantis",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-m05",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "80% organic cotton/20% recycled polyester.",
      "style_code": "M05",
      "colour_name": "Soft Olive",
      "colour_group": "Green > Olive/Military",
      "rgb": "#848a62",
      "sort_bucket": "green",
      "sort_hue": 0.191667,
      "sort_sat": 0.289855,
      "sort_val": 0.541176,
      "swatch_file_id": "gid://shopify/MediaImage/49495666557194",
      "swatch_filename": "m05_Soft_Olive.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m05_Soft_Olive.jpg?v=1774542701",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m05_Soft_Olive.jpg?v=1774542701",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Mantis/M05/ProductCarouselMain/M05%20SOL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "m05_Soft_Olive.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556161802",
      "product_title": "Tee Jays Heavy Sweatshirt",
      "product_handle": "t5429",
      "product_url": "/products/t5429",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t5429",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/30% polyester.",
      "style_code": "T5429",
      "colour_name": "Deep Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#484a3e",
      "sort_bucket": "green",
      "sort_hue": 0.194444,
      "sort_sat": 0.162162,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49491170066698",
      "swatch_filename": "t5429_Deep_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5429_Deep_Green.jpg?v=1774526129",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5429_Deep_Green.jpg?v=1774526129",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5429/ProductCarouselMain/T5429%20DPG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5429_Deep_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Safety Green",
      "colour_group": "Green > Fluro/Neon Green",
      "rgb": "#b8ff00",
      "sort_bucket": "green",
      "sort_hue": 0.213072,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494475178250",
      "swatch_filename": "gd56_Safety_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Safety_Green.jpg?v=1774541902",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Safety_Green.jpg?v=1774541902",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20SYG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Safety_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Khaki",
      "colour_group": "Green > Dark Green",
      "rgb": "#37422f",
      "sort_bucket": "green",
      "sort_hue": 0.263158,
      "sort_sat": 0.287879,
      "sort_val": 0.258824,
      "swatch_file_id": "gid://shopify/MediaImage/49496946016522",
      "swatch_filename": "rx301_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Khaki.jpg?v=1774543259",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Khaki.jpg?v=1774543259",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20KHA%20FRONT%202.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970311434",
      "product_title": "Fruit of the Loom Classic Drop Shoulder Sweatshirt",
      "product_handle": "ss9",
      "product_url": "/products/ss9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS9",
      "colour_name": "Classic Olive",
      "colour_group": "Green > Olive/Military",
      "rgb": "#546c44",
      "sort_bucket": "green",
      "sort_hue": 0.266667,
      "sort_sat": 0.37037,
      "sort_val": 0.423529,
      "swatch_file_id": "gid://shopify/MediaImage/49497465487626",
      "swatch_filename": "ss9_Classic_Olive.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Classic_Olive.jpg?v=1774543496",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Classic_Olive.jpg?v=1774543496",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS9/ProductCarouselMain/SS9%20COL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss9_Classic_Olive.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970213130",
      "product_title": "Fruit of the Loom Classic Raglan Sweatshirt",
      "product_handle": "ss8",
      "product_url": "/products/ss8",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss8",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS8",
      "colour_name": "Classic Olive",
      "colour_group": "Green > Olive/Military",
      "rgb": "#546c44",
      "sort_bucket": "green",
      "sort_hue": 0.266667,
      "sort_sat": 0.37037,
      "sort_val": 0.423529,
      "swatch_file_id": "gid://shopify/MediaImage/49497392546058",
      "swatch_filename": "ss8_Classic_Olive.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Classic_Olive.jpg?v=1774543465",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Classic_Olive.jpg?v=1774543465",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS8/ProductCarouselMain/SS8%20COL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss8_Classic_Olive.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969819914",
      "product_title": "Fruit of the Loom Iconic Premium Set-In Sweatshirt",
      "product_handle": "ss151",
      "product_url": "/products/ss151",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss151",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS151",
      "colour_name": "Classic Olive",
      "colour_group": "Green > Olive/Military",
      "rgb": "#546c44",
      "sort_bucket": "green",
      "sort_hue": 0.266667,
      "sort_sat": 0.37037,
      "sort_val": 0.423529,
      "swatch_file_id": "gid://shopify/MediaImage/49497257607434",
      "swatch_filename": "ss151_Classic_Olive.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_Classic_Olive.jpg?v=1774543405",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_Classic_Olive.jpg?v=1774543405",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS151/ProductCarouselMain/SS151%20COL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss151_Classic_Olive.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970508042",
      "product_title": "Fruit of the Loom Premium Drop Shoulder Sweatshirt",
      "product_handle": "sse9",
      "product_url": "/products/sse9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-sse9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE9",
      "colour_name": "Classic Olive",
      "colour_group": "Green > Olive/Military",
      "rgb": "#546c44",
      "sort_bucket": "green",
      "sort_hue": 0.266667,
      "sort_sat": 0.37037,
      "sort_val": 0.423529,
      "swatch_file_id": "gid://shopify/MediaImage/49497537904906",
      "swatch_filename": "sse9_Classic_Olive.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse9_Classic_Olive.jpg?v=1774543536",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse9_Classic_Olive.jpg?v=1774543536",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Fruit%20of%20the%20Loom/SSE9/ProductCarouselMain/SSE9%20COL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse9_Classic_Olive.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968935178",
      "product_title": "SF Clothing Unisex Sustainable Fashion Sweatshirt",
      "product_handle": "sf530",
      "product_url": "/products/sf530",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-sf530",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% regenerated cotton/40% recycled polyester.",
      "style_code": "SF530",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#5f7b50",
      "sort_bucket": "green",
      "sort_hue": 0.275194,
      "sort_sat": 0.349593,
      "sort_val": 0.482353,
      "swatch_file_id": "gid://shopify/MediaImage/49497062080778",
      "swatch_filename": "sf530_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf530_Khaki.jpg?v=1774543311",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf530_Khaki.jpg?v=1774543311",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF530/ProductCarouselMain/SF530%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf530_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Lime Green",
      "colour_group": "Green > Lime",
      "rgb": "#6eff30",
      "sort_bucket": "green",
      "sort_hue": 0.283414,
      "sort_sat": 0.811765,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494869901578",
      "swatch_filename": "jh030b_Lime_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Lime_Green.jpg?v=1774542340",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Lime_Green.jpg?v=1774542340",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20LIM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Lime_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Lime Green",
      "colour_group": "Green > Lime",
      "rgb": "#6eff30",
      "sort_bucket": "green",
      "sort_hue": 0.283414,
      "sort_sat": 0.811765,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494668640522",
      "swatch_filename": "jh030_Lime_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Lime_Green.jpg?v=1774542247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Lime_Green.jpg?v=1774542247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20LIM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Lime_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "03814",
      "colour_name": "Army",
      "colour_group": "Green > Olive/Military",
      "rgb": "#455440",
      "sort_bucket": "green",
      "sort_hue": 0.291667,
      "sort_sat": 0.238095,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49494224011530",
      "swatch_filename": "03814_Army.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Army.jpg?v=1774540243",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Army.jpg?v=1774540243",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03814/ProductCarouselMain/03814%20ARM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_Army.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Pistachio",
      "colour_group": "Green > Light Green",
      "rgb": "#98c18c",
      "sort_bucket": "green",
      "sort_hue": 0.295597,
      "sort_sat": 0.274611,
      "sort_val": 0.756863,
      "swatch_file_id": "gid://shopify/MediaImage/49494668706058",
      "swatch_filename": "jh030_Pistachio.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Pistachio.jpg?v=1774542249",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Pistachio.jpg?v=1774542249",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20PST%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Pistachio.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944686858",
      "product_title": "SOL'S Unisex Space Organic Raglan Sweatshirt",
      "product_handle": "03567",
      "product_url": "/products/03567",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03567",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "03567",
      "colour_name": "Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#758a6f",
      "sort_bucket": "green",
      "sort_hue": 0.296296,
      "sort_sat": 0.195652,
      "sort_val": 0.541176,
      "swatch_file_id": "gid://shopify/MediaImage/49494218277130",
      "swatch_filename": "03567_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Khaki.jpg?v=1774540203",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Khaki.jpg?v=1774540203",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03567/ProductCarouselMain/03567%20KHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03567_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961070858",
      "product_title": "AWDis Signature Heavyweight Sweatshirt",
      "product_handle": "jh123",
      "product_url": "/products/jh123",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-jh123",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/20% polyester/10% recycled polyester.*",
      "style_code": "JH123",
      "colour_name": "Earthy Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#476240",
      "sort_bucket": "green",
      "sort_hue": 0.29902,
      "sort_sat": 0.346939,
      "sort_val": 0.384314,
      "swatch_file_id": "gid://shopify/MediaImage/49495077028106",
      "swatch_filename": "jh123_Earthy_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_Earthy_Green.jpg?v=1774542419",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_Earthy_Green.jpg?v=1774542419",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH123/ProductCarouselMain/JH123%20ERG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh123_Earthy_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Earthy Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#476240",
      "sort_bucket": "green",
      "sort_hue": 0.29902,
      "sort_sat": 0.346939,
      "sort_val": 0.384314,
      "swatch_file_id": "gid://shopify/MediaImage/49494669590794",
      "swatch_filename": "jh030_Earthy_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Earthy_Green.jpg?v=1774542250",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Earthy_Green.jpg?v=1774542250",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20ERG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Earthy_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#0b9900",
      "sort_bucket": "green",
      "sort_hue": 0.321351,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494869934346",
      "swatch_filename": "jh030b_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Kelly_Green.jpg?v=1774542342",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Kelly_Green.jpg?v=1774542342",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#0b9900",
      "sort_bucket": "green",
      "sort_hue": 0.321351,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494688497930",
      "swatch_filename": "jh030_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Kelly_Green.jpg?v=1774542251",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Kelly_Green.jpg?v=1774542251",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "03814",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1cf00d",
      "sort_bucket": "green",
      "sort_hue": 0.32232,
      "sort_sat": 0.945833,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49494224077066",
      "swatch_filename": "03814_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Kelly_Green.jpg?v=1774540244",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Kelly_Green.jpg?v=1774540244",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SOL%27S/03814/ProductCarouselMain/03814%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Military Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#386338",
      "sort_bucket": "green",
      "sort_hue": 0.333333,
      "sort_sat": 0.434343,
      "sort_val": 0.388235,
      "swatch_file_id": "gid://shopify/MediaImage/49494475276554",
      "swatch_filename": "gd56_Military_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Military_Green.jpg?v=1774541904",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Military_Green.jpg?v=1774541904",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20MGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Military_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Military Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#386338",
      "sort_bucket": "green",
      "sort_hue": 0.333333,
      "sort_sat": 0.434343,
      "sort_val": 0.388235,
      "swatch_file_id": "gid://shopify/MediaImage/49494480912650",
      "swatch_filename": "gd67_Military_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Military_Green.jpg?v=1774542030",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Military_Green.jpg?v=1774542030",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20MGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Military_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958187274",
      "product_title": "Gildan SoftStyle® Midweight Fleece 1/4 Zip Sweatshirt",
      "product_handle": "gd612",
      "product_url": "/products/gd612",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd612",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD612",
      "colour_name": "Military Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#386338",
      "sort_bucket": "green",
      "sort_hue": 0.333333,
      "sort_sat": 0.434343,
      "sort_val": 0.388235,
      "swatch_file_id": "gid://shopify/MediaImage/49494476816650",
      "swatch_filename": "gd612_Military_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Military_Green.jpg?v=1774541944",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Military_Green.jpg?v=1774541944",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD612/ProductCarouselMain/GD612%20MGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd612_Military_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Irish Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#1fff24",
      "sort_bucket": "green",
      "sort_hue": 0.337054,
      "sort_sat": 0.878431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494475342090",
      "swatch_filename": "gd56_Irish_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Irish_Green.jpg?v=1774541905",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Irish_Green.jpg?v=1774541905",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20IGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Irish_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "Eucalyptus Green",
      "colour_group": "Green > Light Green",
      "rgb": "#8fd491",
      "sort_bucket": "green",
      "sort_hue": 0.338164,
      "sort_sat": 0.325472,
      "sort_val": 0.831373,
      "swatch_file_id": "gid://shopify/MediaImage/49494287843594",
      "swatch_filename": "262m_Eucalyptus_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Eucalyptus_Green.jpg?v=1774540345",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Eucalyptus_Green.jpg?v=1774540345",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20EGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_Eucalyptus_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555801354",
      "product_title": "Tee Jays Power Organic Sweatshirt",
      "product_handle": "t5100",
      "product_url": "/products/t5100",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-t5100",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% organic cotton/30% polyester.",
      "style_code": "T5100",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1b501d",
      "sort_bucket": "green",
      "sort_hue": 0.339623,
      "sort_sat": 0.6625,
      "sort_val": 0.313725,
      "swatch_file_id": "gid://shopify/MediaImage/49491206832394",
      "swatch_filename": "t5100_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5100_Forest_Green.jpg?v=1774526220",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5100_Forest_Green.jpg?v=1774526220",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Tee%20Jays/T5100/ProductCarouselMain/T5100%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5100_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970213130",
      "product_title": "Fruit of the Loom Classic Raglan Sweatshirt",
      "product_handle": "ss8",
      "product_url": "/products/ss8",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss8",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS8",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#14fc26",
      "sort_bucket": "green",
      "sort_hue": 0.346264,
      "sort_sat": 0.920635,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49497392808202",
      "swatch_filename": "ss8_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Kelly_Green.jpg?v=1774543466",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Kelly_Green.jpg?v=1774543466",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS8/ProductCarouselMain/SS8%20KEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss8_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970311434",
      "product_title": "Fruit of the Loom Classic Drop Shoulder Sweatshirt",
      "product_handle": "ss9",
      "product_url": "/products/ss9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS9",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#15451a",
      "sort_bucket": "green",
      "sort_hue": 0.350694,
      "sort_sat": 0.695652,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49497473417482",
      "swatch_filename": "ss9_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Bottle_Green.jpg?v=1774543497",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Bottle_Green.jpg?v=1774543497",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS9/ProductCarouselMain/SS9%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss9_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970213130",
      "product_title": "Fruit of the Loom Classic Raglan Sweatshirt",
      "product_handle": "ss8",
      "product_url": "/products/ss8",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss8",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS8",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#15451a",
      "sort_bucket": "green",
      "sort_hue": 0.350694,
      "sort_sat": 0.695652,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49497392873738",
      "swatch_filename": "ss8_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Bottle_Green.jpg?v=1774543468",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Bottle_Green.jpg?v=1774543468",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS8/ProductCarouselMain/SS8%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss8_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970409738",
      "product_title": "Fruit of the Loom Premium Zip Neck Sweatshirt",
      "product_handle": "sse17",
      "product_url": "/products/sse17",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-sse17",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE17",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#15451a",
      "sort_bucket": "green",
      "sort_hue": 0.350694,
      "sort_sat": 0.695652,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49497531089162",
      "swatch_filename": "sse17_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse17_Bottle_Green.jpg?v=1774543523",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse17_Bottle_Green.jpg?v=1774543523",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SSE17/ProductCarouselMain/SSE17%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse17_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#063e0c",
      "sort_bucket": "green",
      "sort_hue": 0.35119,
      "sort_sat": 0.903226,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49496957485322",
      "swatch_filename": "rx301_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Bottle_Green.jpg?v=1774543260",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Bottle_Green.jpg?v=1774543260",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#105017",
      "sort_bucket": "green",
      "sort_hue": 0.351562,
      "sort_sat": 0.8,
      "sort_val": 0.313725,
      "swatch_file_id": "gid://shopify/MediaImage/49494877045002",
      "swatch_filename": "jh030b_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Bottle_Green.jpg?v=1774542343",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Bottle_Green.jpg?v=1774542343",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#105017",
      "sort_bucket": "green",
      "sort_hue": 0.351562,
      "sort_sat": 0.8,
      "sort_val": 0.313725,
      "swatch_file_id": "gid://shopify/MediaImage/49494716088586",
      "swatch_filename": "jh030_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Bottle_Green.jpg?v=1774542252",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Bottle_Green.jpg?v=1774542252",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961398538",
      "product_title": "AWDis Unisex Organic Sweatshirt",
      "product_handle": "jh230",
      "product_url": "/products/jh230",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-jh230",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "JH230",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#105017",
      "sort_bucket": "green",
      "sort_hue": 0.351562,
      "sort_sat": 0.8,
      "sort_val": 0.313725,
      "swatch_file_id": "gid://shopify/MediaImage/49495130046730",
      "swatch_filename": "jh230_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_Bottle_Green.jpg?v=1774542460",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_Bottle_Green.jpg?v=1774542460",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH230/ProductCarouselMain/JH230%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh230_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Fan Dark Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#105017",
      "sort_bucket": "green",
      "sort_hue": 0.351562,
      "sort_sat": 0.8,
      "sort_val": 0.313725,
      "swatch_file_id": "gid://shopify/MediaImage/49494475374858",
      "swatch_filename": "gd56_Fan_Dark_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Fan_Dark_Green.jpg?v=1774541907",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Fan_Dark_Green.jpg?v=1774541907",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20FDGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Fan_Dark_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964085514",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns407",
      "product_url": "/products/ns407",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns407",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "Organic Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#445446",
      "sort_bucket": "green",
      "sort_hue": 0.354167,
      "sort_sat": 0.190476,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49495740842250",
      "swatch_filename": "ns407_Organic_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Organic_Khaki.jpg?v=1774542735",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Organic_Khaki.jpg?v=1774542735",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20ORK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns407_Organic_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964609802",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns440",
      "product_url": "/products/ns440",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-ns440",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "Organic Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#445446",
      "sort_bucket": "green",
      "sort_hue": 0.354167,
      "sort_sat": 0.190476,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49495916347658",
      "swatch_filename": "ns440_Organic_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns440_Organic_Khaki.jpg?v=1774542816",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns440_Organic_Khaki.jpg?v=1774542816",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20ORK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns440_Organic_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948225802",
      "product_title": "Anthem Organic Sweatshirt",
      "product_handle": "am20",
      "product_url": "/products/am20",
      "product_full_url": "None",
      "vendor": "Anthem",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-am20",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "AM20",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#2e3d30",
      "sort_bucket": "green",
      "sort_hue": 0.355556,
      "sort_sat": 0.245902,
      "sort_val": 0.239216,
      "swatch_file_id": "gid://shopify/MediaImage/49494307373322",
      "swatch_filename": "am20_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Forest_Green.jpg?v=1774540531",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Forest_Green.jpg?v=1774540531",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM20/ProductCarouselMain/AM20%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am20_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964347658",
      "product_title": "Native Spirit 1/4 Zip Sweatshirt",
      "product_handle": "ns428",
      "product_url": "/products/ns428",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns428",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "NS428",
      "colour_name": "Moss",
      "colour_group": "Green > Olive/Military",
      "rgb": "#6f8572",
      "sort_bucket": "green",
      "sort_hue": 0.356061,
      "sort_sat": 0.165414,
      "sort_val": 0.521569,
      "swatch_file_id": "gid://shopify/MediaImage/49495870767370",
      "swatch_filename": "ns428_Moss.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns428_Moss.jpg?v=1774542785",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns428_Moss.jpg?v=1774542785",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS428/ProductCarouselMain/NS428%20MOS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns428_Moss.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964085514",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns407",
      "product_url": "/products/ns407",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns407",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "Brook Green",
      "colour_group": "Green > Light Green",
      "rgb": "#abf2b5",
      "sort_bucket": "green",
      "sort_hue": 0.356808,
      "sort_sat": 0.293388,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49495741104394",
      "swatch_filename": "ns407_Brook_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Brook_Green.jpg?v=1774542736",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Brook_Green.jpg?v=1774542736",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20BRG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns407_Brook_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Sage",
      "colour_group": "Green > Light Green",
      "rgb": "#829e86",
      "sort_bucket": "green",
      "sort_hue": 0.357143,
      "sort_sat": 0.177215,
      "sort_val": 0.619608,
      "swatch_file_id": "gid://shopify/MediaImage/49494481109258",
      "swatch_filename": "gd67_Sage.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Sage.jpg?v=1774542032",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Sage.jpg?v=1774542032",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20SAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Sage.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964282122",
      "product_title": "Native Spirit Unisex Terry 280 Oversized Sweatshirt",
      "product_handle": "ns415",
      "product_url": "/products/ns415",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns415",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS415",
      "colour_name": "Washed Organic Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#526f58",
      "sort_bucket": "green",
      "sort_hue": 0.367816,
      "sort_sat": 0.261261,
      "sort_val": 0.435294,
      "swatch_file_id": "gid://shopify/MediaImage/49495826858250",
      "swatch_filename": "ns415_Washed_Organic_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns415_Washed_Organic_Khaki.jpg?v=1774542773",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns415_Washed_Organic_Khaki.jpg?v=1774542773",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Native%20Spirit/NS415/ProductCarouselMain/NS415%20WOK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns415_Washed_Organic_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964183818",
      "product_title": "Native Spirit Unisex Terry 280 Sweatshirt",
      "product_handle": "ns414",
      "product_url": "/products/ns414",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns414",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS414",
      "colour_name": "Washed Organic Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#526f58",
      "sort_bucket": "green",
      "sort_hue": 0.367816,
      "sort_sat": 0.261261,
      "sort_val": 0.435294,
      "swatch_file_id": "gid://shopify/MediaImage/49495817126154",
      "swatch_filename": "ns414_Washed_Organic_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns414_Washed_Organic_Khaki.jpg?v=1774542760",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns414_Washed_Organic_Khaki.jpg?v=1774542760",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Native%20Spirit/NS414/ProductCarouselMain/NS414%20WOK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns414_Washed_Organic_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970311434",
      "product_title": "Fruit of the Loom Classic Drop Shoulder Sweatshirt",
      "product_handle": "ss9",
      "product_url": "/products/ss9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% polyester.",
      "style_code": "SS9",
      "colour_name": "Heather Green",
      "colour_group": "Green > Heather/Effect Green",
      "rgb": "#34d156",
      "sort_bucket": "green",
      "sort_hue": 0.369427,
      "sort_sat": 0.751196,
      "sort_val": 0.819608,
      "swatch_file_id": "gid://shopify/MediaImage/49497485279498",
      "swatch_filename": "ss9_Heather_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Heather_Green.jpg?v=1774543499",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Heather_Green.jpg?v=1774543499",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS9/ProductCarouselMain/SS9%20HGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss9_Heather_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970213130",
      "product_title": "Fruit of the Loom Classic Raglan Sweatshirt",
      "product_handle": "ss8",
      "product_url": "/products/ss8",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss8",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% polyester.",
      "style_code": "SS8",
      "colour_name": "Heather Green",
      "colour_group": "Green > Heather/Effect Green",
      "rgb": "#34d156",
      "sort_bucket": "green",
      "sort_hue": 0.369427,
      "sort_sat": 0.751196,
      "sort_val": 0.819608,
      "swatch_file_id": "gid://shopify/MediaImage/49497392906506",
      "swatch_filename": "ss8_Heather_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Heather_Green.jpg?v=1774543470",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Heather_Green.jpg?v=1774543470",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS8/ProductCarouselMain/SS8%20HGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss8_Heather_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "Olive Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#2e4e35",
      "sort_bucket": "green",
      "sort_hue": 0.369792,
      "sort_sat": 0.410256,
      "sort_val": 0.305882,
      "swatch_file_id": "gid://shopify/MediaImage/49494288040202",
      "swatch_filename": "262m_Olive_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Olive_Green.jpg?v=1774540347",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Olive_Green.jpg?v=1774540347",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20OLI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_Olive_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Kelly Green",
      "colour_group": "Green > Kelly/Irish",
      "rgb": "#188b36",
      "sort_bucket": "green",
      "sort_hue": 0.376812,
      "sort_sat": 0.827338,
      "sort_val": 0.545098,
      "swatch_file_id": "gid://shopify/MediaImage/49496959910154",
      "swatch_filename": "rx301_Kelly_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Kelly_Green.jpg?v=1774543261",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Kelly_Green.jpg?v=1774543261",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20KEL%20FRONT%202.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Kelly_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969721610",
      "product_title": "Fruit of the Loom Supercotton™ Sweatshirt",
      "product_handle": "ss141",
      "product_url": "/products/ss141",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss141",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS141",
      "colour_name": "College Green",
      "colour_group": "Green > Mid Green",
      "rgb": "#00a633",
      "sort_bucket": "green",
      "sort_hue": 0.384538,
      "sort_sat": 1.0,
      "sort_val": 0.65098,
      "swatch_file_id": "gid://shopify/MediaImage/49497225593098",
      "swatch_filename": "ss141_College_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss141_College_Green.jpg?v=1774543388",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss141_College_Green.jpg?v=1774543388",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS141/ProductCarouselMain/SS141%20CLG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss141_College_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944391946",
      "product_title": "SOL'S Stan Contrast Zip Neck Sweatshirt",
      "product_handle": "02088",
      "product_url": "/products/02088",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-02088",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "02088",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1f4c2d",
      "sort_bucket": "green",
      "sort_hue": 0.385185,
      "sort_sat": 0.592105,
      "sort_val": 0.298039,
      "swatch_file_id": "gid://shopify/MediaImage/49494214967562",
      "swatch_filename": "02088_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02088_Bottle_Green.jpg?v=1774540161",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02088_Bottle_Green.jpg?v=1774540161",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02088/ProductCarouselMain/02088%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02088_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "03814",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1f4c2d",
      "sort_bucket": "green",
      "sort_hue": 0.385185,
      "sort_sat": 0.592105,
      "sort_val": 0.298039,
      "swatch_file_id": "gid://shopify/MediaImage/49494224339210",
      "swatch_filename": "03814_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Bottle_Green.jpg?v=1774540246",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Bottle_Green.jpg?v=1774540246",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03814/ProductCarouselMain/03814%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944785162",
      "product_title": "SOL'S Unisex Comet Organic Sweatshirt",
      "product_handle": "03574",
      "product_url": "/products/03574",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03574",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "03574",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1f4c2d",
      "sort_bucket": "green",
      "sort_hue": 0.385185,
      "sort_sat": 0.592105,
      "sort_val": 0.298039,
      "swatch_file_id": "gid://shopify/MediaImage/49494219882762",
      "swatch_filename": "03574_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03574_Bottle_Green.jpg?v=1774540222",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03574_Bottle_Green.jpg?v=1774540222",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03574/ProductCarouselMain/03574%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03574_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457945178378",
      "product_title": "SOL'S Unisex Conrad 1/4 Zip Sweatshirt",
      "product_handle": "04234",
      "product_url": "/products/04234",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-04234",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "04234",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1f4c2d",
      "sort_bucket": "green",
      "sort_hue": 0.385185,
      "sort_sat": 0.592105,
      "sort_val": 0.298039,
      "swatch_file_id": "gid://shopify/MediaImage/49494279454986",
      "swatch_filename": "04234_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04234_Bottle_Green.jpg?v=1774540272",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04234_Bottle_Green.jpg?v=1774540272",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04234/ProductCarouselMain/04234%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04234_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457945440522",
      "product_title": "SOL'S Unisex Cooper Full Zip Sweat Jacket",
      "product_handle": "04240",
      "product_url": "/products/04240",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "jackets",
        "L",
        "M",
        "S",
        "style-04240",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "04240",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1f4c2d",
      "sort_bucket": "green",
      "sort_hue": 0.385185,
      "sort_sat": 0.592105,
      "sort_val": 0.298039,
      "swatch_file_id": "gid://shopify/MediaImage/49494280241418",
      "swatch_filename": "04240_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04240_Bottle_Green.jpg?v=1774540284",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04240_Bottle_Green.jpg?v=1774540284",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04240/ProductCarouselMain/04240%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04240_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944686858",
      "product_title": "SOL'S Unisex Space Organic Raglan Sweatshirt",
      "product_handle": "03567",
      "product_url": "/products/03567",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03567",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "03567",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1f4c2d",
      "sort_bucket": "green",
      "sort_hue": 0.385185,
      "sort_sat": 0.592105,
      "sort_val": 0.298039,
      "swatch_file_id": "gid://shopify/MediaImage/49494218342666",
      "swatch_filename": "03567_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Bottle_Green.jpg?v=1774540205",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Bottle_Green.jpg?v=1774540205",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03567/ProductCarouselMain/03567%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03567_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948160266",
      "product_title": "AWDis Academy Kids V Neck Sweatshirt",
      "product_handle": "ac003b",
      "product_url": "/products/ac003b",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-ac003b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC003B",
      "colour_name": "Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#0b2b15",
      "sort_bucket": "green",
      "sort_hue": 0.385417,
      "sort_sat": 0.744186,
      "sort_val": 0.168627,
      "swatch_file_id": "gid://shopify/MediaImage/49494305702154",
      "swatch_filename": "ac003b_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003b_Green.jpg?v=1774540513",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003b_Green.jpg?v=1774540513",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC003B/ProductCarouselMain/AC003B%20AGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac003b_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947898122",
      "product_title": "AWDis Academy Senior Raglan Sweatshirt",
      "product_handle": "ac001",
      "product_url": "/products/ac001",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ac001",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC001",
      "colour_name": "Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#0b2b15",
      "sort_bucket": "green",
      "sort_hue": 0.385417,
      "sort_sat": 0.744186,
      "sort_val": 0.168627,
      "swatch_file_id": "gid://shopify/MediaImage/49494303375626",
      "swatch_filename": "ac001_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Green.jpg?v=1774540488",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Green.jpg?v=1774540488",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC001/ProductCarouselMain/AC001%20AGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac001_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "03814",
      "colour_name": "Creamy Green",
      "colour_group": "Green > Light Green",
      "rgb": "#baf2cc",
      "sort_bucket": "green",
      "sort_hue": 0.386905,
      "sort_sat": 0.231405,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49494224437514",
      "swatch_filename": "03814_Creamy_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Creamy_Green.jpg?v=1774540247",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Creamy_Green.jpg?v=1774540247",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03814/ProductCarouselMain/03814%20CMG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_Creamy_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457956483338",
      "product_title": "Canvas Unisex Heavyweight Crew Neck Sweatshirt",
      "product_handle": "cv4711",
      "product_url": "/products/cv4711",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv4711",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% airlume combed ringspun cotton/40% polyester.",
      "style_code": "CV4711",
      "colour_name": "Forest Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#1d3f29",
      "sort_bucket": "green",
      "sort_hue": 0.392157,
      "sort_sat": 0.539683,
      "sort_val": 0.247059,
      "swatch_file_id": "gid://shopify/MediaImage/49494465216778",
      "swatch_filename": "cv4711_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4711_Forest_Green.jpg?v=1774541749",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4711_Forest_Green.jpg?v=1774541749",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV4711/ProductCarouselMain/CV4711%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv4711_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964085514",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns407",
      "product_url": "/products/ns407",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns407",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "Jade Green",
      "colour_group": "Green > Light Green",
      "rgb": "#87c29c",
      "sort_bucket": "green",
      "sort_hue": 0.392655,
      "sort_sat": 0.304124,
      "sort_val": 0.760784,
      "swatch_file_id": "gid://shopify/MediaImage/49495741464842",
      "swatch_filename": "ns407_Jade_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Jade_Green.jpg?v=1774542738",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Jade_Green.jpg?v=1774542738",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20JAD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns407_Jade_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946521866",
      "product_title": "Russell Athletic Authentic Sweat Jacket",
      "product_handle": "267m",
      "product_url": "/products/267m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "jackets",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-267m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun combed cotton/20% polyester.",
      "style_code": "267M",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#00461c",
      "sort_bucket": "green",
      "sort_hue": 0.4,
      "sort_sat": 1.0,
      "sort_val": 0.27451,
      "swatch_file_id": "gid://shopify/MediaImage/49494290006282",
      "swatch_filename": "267m_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/267m_Bottle_Green.jpg?v=1774540375",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/267m_Bottle_Green.jpg?v=1774540375",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/267M/ProductCarouselMain/267M%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "267m_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#00461c",
      "sort_bucket": "green",
      "sort_hue": 0.4,
      "sort_sat": 1.0,
      "sort_val": 0.27451,
      "swatch_file_id": "gid://shopify/MediaImage/49494288105738",
      "swatch_filename": "262m_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Bottle_Green.jpg?v=1774540348",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Bottle_Green.jpg?v=1774540348",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947308298",
      "product_title": "Russell Athletic Kids Raglan Sweatshirt",
      "product_handle": "762b",
      "product_url": "/products/762b",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "performance-activewear",
        "sports",
        "style-762b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762B",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#00461c",
      "sort_bucket": "green",
      "sort_hue": 0.4,
      "sort_sat": 1.0,
      "sort_val": 0.27451,
      "swatch_file_id": "gid://shopify/MediaImage/49494299214090",
      "swatch_filename": "762b_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Bottle_Green.jpg?v=1774540430",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Bottle_Green.jpg?v=1774540430",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762B/ProductCarouselMain/762B%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762b_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947472138",
      "product_title": "Russell Athletic Raglan Sweatshirt",
      "product_handle": "762m",
      "product_url": "/products/762m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-762m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762M",
      "colour_name": "Bottle Green",
      "colour_group": "Green > Forest/Bottle",
      "rgb": "#00461c",
      "sort_bucket": "green",
      "sort_hue": 0.4,
      "sort_sat": 1.0,
      "sort_val": 0.27451,
      "swatch_file_id": "gid://shopify/MediaImage/49494300754186",
      "swatch_filename": "762m_Bottle_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762m_Bottle_Green.jpg?v=1774540450",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762m_Bottle_Green.jpg?v=1774540450",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762M/ProductCarouselMain/762M%20BOT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762m_Bottle_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963200778",
      "product_title": "Kariban Crew Neck Sweatshirt",
      "product_handle": "kb488",
      "product_url": "/products/kb488",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb488",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "KB488",
      "colour_name": "Forest Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#23382c",
      "sort_bucket": "green",
      "sort_hue": 0.404762,
      "sort_sat": 0.375,
      "sort_val": 0.219608,
      "swatch_file_id": "gid://shopify/MediaImage/49495499571466",
      "swatch_filename": "kb488_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb488_Forest_Green.jpg?v=1774542622",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb488_Forest_Green.jpg?v=1774542622",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB488/ProductCarouselMain/KB488%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb488_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "Forest Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#23382c",
      "sort_bucket": "green",
      "sort_hue": 0.404762,
      "sort_sat": 0.375,
      "sort_val": 0.219608,
      "swatch_file_id": "gid://shopify/MediaImage/49495337402634",
      "swatch_filename": "kb4025_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Forest_Green.jpg?v=1774542556",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Forest_Green.jpg?v=1774542556",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963135242",
      "product_title": "Kariban Zip Neck Sweatshirt",
      "product_handle": "kb487",
      "product_url": "/products/kb487",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb487",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "KB487",
      "colour_name": "Forest Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#23382c",
      "sort_bucket": "green",
      "sort_hue": 0.404762,
      "sort_sat": 0.375,
      "sort_val": 0.219608,
      "swatch_file_id": "gid://shopify/MediaImage/49495487971594",
      "swatch_filename": "kb487_Forest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb487_Forest_Green.jpg?v=1774542607",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb487_Forest_Green.jpg?v=1774542607",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB487/ProductCarouselMain/KB487%20FOR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb487_Forest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Jade",
      "colour_group": "Green > Emerald/Jade",
      "rgb": "#007034",
      "sort_bucket": "green",
      "sort_hue": 0.410714,
      "sort_sat": 1.0,
      "sort_val": 0.439216,
      "swatch_file_id": "gid://shopify/MediaImage/49494716154122",
      "swatch_filename": "jh030_Jade.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Jade.jpg?v=1774542254",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Jade.jpg?v=1774542254",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20JAD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Jade.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947308298",
      "product_title": "Russell Athletic Kids Raglan Sweatshirt",
      "product_handle": "762b",
      "product_url": "/products/762b",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "performance-activewear",
        "sports",
        "style-762b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762B",
      "colour_name": "Winter Emerald",
      "colour_group": "Green",
      "rgb": "#00e673",
      "sort_bucket": "green",
      "sort_hue": 0.416667,
      "sort_sat": 1.0,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49494299377930",
      "swatch_filename": "762b_Winter_Emerald.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Winter_Emerald.jpg?v=1774540432",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Winter_Emerald.jpg?v=1774540432",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762B/ProductCarouselMain/762B%20WTE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762b_Winter_Emerald.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Peppermint",
      "colour_group": "Green > Light Green",
      "rgb": "#8fffcc",
      "sort_bucket": "green",
      "sort_hue": 0.424107,
      "sort_sat": 0.439216,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494888907018",
      "swatch_filename": "jh030b_Peppermint.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Peppermint.jpg?v=1774542345",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Peppermint.jpg?v=1774542345",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20PPM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Peppermint.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Peppermint",
      "colour_group": "Green > Light Green",
      "rgb": "#8fffcc",
      "sort_bucket": "green",
      "sort_hue": 0.424107,
      "sort_sat": 0.439216,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494716350730",
      "swatch_filename": "jh030_Peppermint.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Peppermint.jpg?v=1774542255",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Peppermint.jpg?v=1774542255",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20PPM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Peppermint.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457959792906",
      "product_title": "Henbury Zip Neck Wicking Top",
      "product_handle": "h862",
      "product_url": "/products/h862",
      "product_full_url": "None",
      "vendor": "Henbury",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-h862",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester fleece back single jersey.",
      "style_code": "H862",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#1b2621",
      "sort_bucket": "green",
      "sort_hue": 0.424242,
      "sort_sat": 0.289474,
      "sort_val": 0.14902,
      "swatch_file_id": "gid://shopify/MediaImage/49494490480906",
      "swatch_filename": "h862_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h862_Grey_Marl.jpg?v=1774542173",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h862_Grey_Marl.jpg?v=1774542173",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H862/ProductCarouselMain/H862%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h862_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Dusty Green",
      "colour_group": "Green > Light Green",
      "rgb": "#759d8b",
      "sort_bucket": "green",
      "sort_hue": 0.425,
      "sort_sat": 0.254777,
      "sort_val": 0.615686,
      "swatch_file_id": "gid://shopify/MediaImage/49494888939786",
      "swatch_filename": "jh030b_Dusty_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Dusty_Green.jpg?v=1774542346",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Dusty_Green.jpg?v=1774542346",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20DUG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Dusty_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960644874",
      "product_title": "AWDis Ladies Sweatshirt",
      "product_handle": "jh030f",
      "product_url": "/products/jh030f",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-jh030f",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030F",
      "colour_name": "Dusty Green",
      "colour_group": "Green > Light Green",
      "rgb": "#759d8b",
      "sort_bucket": "green",
      "sort_hue": 0.425,
      "sort_sat": 0.254777,
      "sort_val": 0.615686,
      "swatch_file_id": "gid://shopify/MediaImage/49494978593034",
      "swatch_filename": "jh030f_Dusty_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030f_Dusty_Green.jpg?v=1774542377",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030f_Dusty_Green.jpg?v=1774542377",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030F/ProductCarouselMain/JH030F%20DUG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030f_Dusty_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Dusty Green",
      "colour_group": "Green > Light Green",
      "rgb": "#759d8b",
      "sort_bucket": "green",
      "sort_hue": 0.425,
      "sort_sat": 0.254777,
      "sort_val": 0.615686,
      "swatch_file_id": "gid://shopify/MediaImage/49494747939082",
      "swatch_filename": "jh030_Dusty_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Dusty_Green.jpg?v=1774542257",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Dusty_Green.jpg?v=1774542257",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20DUG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Dusty_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964282122",
      "product_title": "Native Spirit Unisex Terry 280 Oversized Sweatshirt",
      "product_handle": "ns415",
      "product_url": "/products/ns415",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns415",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS415",
      "colour_name": "Washed Jade Green",
      "colour_group": "Green > Mid Green",
      "rgb": "#94c4b3",
      "sort_bucket": "green",
      "sort_hue": 0.440972,
      "sort_sat": 0.244898,
      "sort_val": 0.768627,
      "swatch_file_id": "gid://shopify/MediaImage/49495826891018",
      "swatch_filename": "ns415_Washed_Jade_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns415_Washed_Jade_Green.jpg?v=1774542773",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns415_Washed_Jade_Green.jpg?v=1774542773",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Native%20Spirit/NS415/ProductCarouselMain/NS415%20WJG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns415_Washed_Jade_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964183818",
      "product_title": "Native Spirit Unisex Terry 280 Sweatshirt",
      "product_handle": "ns414",
      "product_url": "/products/ns414",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns414",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS414",
      "colour_name": "Washed Jade Green",
      "colour_group": "Green > Mid Green",
      "rgb": "#94c4b3",
      "sort_bucket": "green",
      "sort_hue": 0.440972,
      "sort_sat": 0.244898,
      "sort_val": 0.768627,
      "swatch_file_id": "gid://shopify/MediaImage/49495817158922",
      "swatch_filename": "ns414_Washed_Jade_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns414_Washed_Jade_Green.jpg?v=1774542762",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns414_Washed_Jade_Green.jpg?v=1774542762",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Native%20Spirit/NS414/ProductCarouselMain/NS414%20WJG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns414_Washed_Jade_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Rainforest Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#0b5e44",
      "sort_bucket": "green",
      "sort_hue": 0.447791,
      "sort_sat": 0.882979,
      "sort_val": 0.368627,
      "swatch_file_id": "gid://shopify/MediaImage/49494889169162",
      "swatch_filename": "jh030b_Rainforest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Rainforest_Green.jpg?v=1774542348",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Rainforest_Green.jpg?v=1774542348",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20RFG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Rainforest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Rainforest Green",
      "colour_group": "Green > Dark Green",
      "rgb": "#0b5e44",
      "sort_bucket": "green",
      "sort_hue": 0.447791,
      "sort_sat": 0.882979,
      "sort_val": 0.368627,
      "swatch_file_id": "gid://shopify/MediaImage/49494751183114",
      "swatch_filename": "jh030_Rainforest_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Rainforest_Green.jpg?v=1774542259",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Rainforest_Green.jpg?v=1774542259",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20RFG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Rainforest_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "Ice Mint",
      "colour_group": "Green > Light Green",
      "rgb": "#b6e3d8",
      "sort_bucket": "green",
      "sort_hue": 0.459259,
      "sort_sat": 0.198238,
      "sort_val": 0.890196,
      "swatch_file_id": "gid://shopify/MediaImage/49495337468170",
      "swatch_filename": "kb4025_Ice_Mint.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Ice_Mint.jpg?v=1774542557",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Ice_Mint.jpg?v=1774542557",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20IMT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_Ice_Mint.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964085514",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns407",
      "product_url": "/products/ns407",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns407",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "Peacock Green",
      "colour_group": "Green > Emerald/Jade",
      "rgb": "#08655f",
      "sort_bucket": "green",
      "sort_hue": 0.489247,
      "sort_sat": 0.920792,
      "sort_val": 0.396078,
      "swatch_file_id": "gid://shopify/MediaImage/49495747363082",
      "swatch_filename": "ns407_Peacock_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Peacock_Green.jpg?v=1774542739",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Peacock_Green.jpg?v=1774542739",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20PCKG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns407_Peacock_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "03814",
      "colour_name": "Pool Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#57faa3",
      "sort_bucket": "blue",
      "sort_hue": 0.411043,
      "sort_sat": 0.652,
      "sort_val": 0.980392,
      "swatch_file_id": "gid://shopify/MediaImage/49494224503050",
      "swatch_filename": "03814_Pool_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Pool_Blue.jpg?v=1774540249",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Pool_Blue.jpg?v=1774540249",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03814/ProductCarouselMain/03814%20POB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_Pool_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Turquoise Surf",
      "colour_group": "Blue > Turquoise",
      "rgb": "#52ffde",
      "sort_bucket": "blue",
      "sort_hue": 0.468208,
      "sort_sat": 0.678431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494751248650",
      "swatch_filename": "jh030_Turquoise_Surf.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Turquoise_Surf.jpg?v=1774542260",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Turquoise_Surf.jpg?v=1774542260",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20TQS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Turquoise_Surf.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Seafoam",
      "colour_group": "Blue > Turquoise",
      "rgb": "#61bbaa",
      "sort_bucket": "blue",
      "sort_hue": 0.468519,
      "sort_sat": 0.481283,
      "sort_val": 0.733333,
      "swatch_file_id": "gid://shopify/MediaImage/49494889595146",
      "swatch_filename": "jh030b_Seafoam.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Seafoam.jpg?v=1774542349",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Seafoam.jpg?v=1774542349",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20SEF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Seafoam.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Seafoam",
      "colour_group": "Blue > Turquoise",
      "rgb": "#61bbaa",
      "sort_bucket": "blue",
      "sort_hue": 0.468519,
      "sort_sat": 0.481283,
      "sort_val": 0.733333,
      "swatch_file_id": "gid://shopify/MediaImage/49494751346954",
      "swatch_filename": "jh030_Seafoam.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Seafoam.jpg?v=1774542262",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Seafoam.jpg?v=1774542262",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20SEF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Seafoam.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Lagoon Blue",
      "colour_group": "Blue > Turquoise",
      "rgb": "#29a891",
      "sort_bucket": "blue",
      "sort_hue": 0.469816,
      "sort_sat": 0.755952,
      "sort_val": 0.658824,
      "swatch_file_id": "gid://shopify/MediaImage/49494751445258",
      "swatch_filename": "jh030_Lagoon_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Lagoon_Blue.jpg?v=1774542263",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Lagoon_Blue.jpg?v=1774542263",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20LAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Lagoon_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "03814",
      "colour_name": "Creamy Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#ade8e0",
      "sort_bucket": "blue",
      "sort_hue": 0.477401,
      "sort_sat": 0.25431,
      "sort_val": 0.909804,
      "swatch_file_id": "gid://shopify/MediaImage/49494224634122",
      "swatch_filename": "03814_Creamy_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Creamy_Blue.jpg?v=1774540251",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Creamy_Blue.jpg?v=1774540251",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03814/ProductCarouselMain/03814%20CYB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_Creamy_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944490250",
      "product_title": "SOL'S Unisex Sully Sweatshirt",
      "product_handle": "02990",
      "product_url": "/products/02990",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-02990",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "02990",
      "colour_name": "Creamy Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#ade8e0",
      "sort_bucket": "blue",
      "sort_hue": 0.477401,
      "sort_sat": 0.25431,
      "sort_val": 0.909804,
      "swatch_file_id": "gid://shopify/MediaImage/49494216147210",
      "swatch_filename": "02990_Creamy_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02990_Creamy_Blue.jpg?v=1774540174",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02990_Creamy_Blue.jpg?v=1774540174",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SOL%27S/02990/ProductCarouselMain/02990%20CYB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02990_Creamy_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944621322",
      "product_title": "NEOBLU Nelson French Terry Sweatshirt",
      "product_handle": "03194",
      "product_url": "/products/03194",
      "product_full_url": "None",
      "vendor": "NEOBLU",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-03194",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% combed cotton/15% polyester.",
      "style_code": "03194",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494217589002",
      "swatch_filename": "03194_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03194_Grey_Marl.jpg?v=1774540188",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03194_Grey_Marl.jpg?v=1774540188",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/NEOBLU/03194/ProductCarouselMain/03194%20GME%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03194_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944391946",
      "product_title": "SOL'S Stan Contrast Zip Neck Sweatshirt",
      "product_handle": "02088",
      "product_url": "/products/02088",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-02088",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "02088",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494215131402",
      "swatch_filename": "02088_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02088_Grey_Marl.jpg?v=1774540163",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02088_Grey_Marl.jpg?v=1774540163",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02088/ProductCarouselMain/02088%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02088_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "73% cotton/20% recycled polyester/7% viscose",
      "style_code": "03814",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494224732426",
      "swatch_filename": "03814_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Grey_Marl.jpg?v=1774540253",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Grey_Marl.jpg?v=1774540253",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03815/ProductCarouselMain/03814%20GME%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944785162",
      "product_title": "SOL'S Unisex Comet Organic Sweatshirt",
      "product_handle": "03574",
      "product_url": "/products/03574",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03574",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "75% organic cotton/20% recycled polyester/5% viscose",
      "style_code": "03574",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494219981066",
      "swatch_filename": "03574_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03574_Grey_Marl.jpg?v=1774540224",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03574_Grey_Marl.jpg?v=1774540224",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03574/ProductCarouselMain/03574%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03574_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457945178378",
      "product_title": "SOL'S Unisex Conrad 1/4 Zip Sweatshirt",
      "product_handle": "04234",
      "product_url": "/products/04234",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-04234",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "73% cotton/20% recycled polyester/7% viscose.",
      "style_code": "04234",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494279553290",
      "swatch_filename": "04234_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04234_Grey_Marl.jpg?v=1774540274",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04234_Grey_Marl.jpg?v=1774540274",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04234/ProductCarouselMain/04234%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04234_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457945440522",
      "product_title": "SOL'S Unisex Cooper Full Zip Sweat Jacket",
      "product_handle": "04240",
      "product_url": "/products/04240",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "jackets",
        "L",
        "M",
        "S",
        "style-04240",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "73% cotton/20% recycled polyester/7% viscose.",
      "style_code": "04240",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494280405258",
      "swatch_filename": "04240_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04240_Grey_Marl.jpg?v=1774540285",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04240_Grey_Marl.jpg?v=1774540285",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04240/ProductCarouselMain/04240%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04240_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946259722",
      "product_title": "SOL'S Unisex New Supreme Sweatshirt",
      "product_handle": "13250",
      "product_url": "/products/13250",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-13250",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "13250",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494284828938",
      "swatch_filename": "13250_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_Grey_Marl.jpg?v=1774540326",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_Grey_Marl.jpg?v=1774540326",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/13250/ProductCarouselMain/13250%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "13250_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944686858",
      "product_title": "SOL'S Unisex Space Organic Raglan Sweatshirt",
      "product_handle": "03567",
      "product_url": "/products/03567",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03567",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "75% organic cotton/20% recycled polyester/5% viscose",
      "style_code": "03567",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494218408202",
      "swatch_filename": "03567_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Grey_Marl.jpg?v=1774540206",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Grey_Marl.jpg?v=1774540206",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03567/ProductCarouselMain/03567%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03567_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944490250",
      "product_title": "SOL'S Unisex Sully Sweatshirt",
      "product_handle": "02990",
      "product_url": "/products/02990",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-02990",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "75% cotton/20% polyester/5% viscose.",
      "style_code": "02990",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#839997",
      "sort_bucket": "blue",
      "sort_hue": 0.484848,
      "sort_sat": 0.143791,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494216802570",
      "swatch_filename": "02990_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02990_Grey_Marl.jpg?v=1774540176",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02990_Grey_Marl.jpg?v=1774540176",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02990/ProductCarouselMain/02990%20GYM%20FRONT%20HERO.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02990_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457959891210",
      "product_title": "AWDis Cool-Flex™ Half Zip Top",
      "product_handle": "jc030",
      "product_url": "/products/jc030",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "security",
        "style-jc030",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "86% polyester/14% elastane.",
      "style_code": "JC030",
      "colour_name": "Silver Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#9dbab8",
      "sort_bucket": "blue",
      "sort_hue": 0.488506,
      "sort_sat": 0.155914,
      "sort_val": 0.729412,
      "swatch_file_id": "gid://shopify/MediaImage/49494490874122",
      "swatch_filename": "jc030_Silver_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc030_Silver_Grey.jpg?v=1774542182",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc030_Silver_Grey.jpg?v=1774542182",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC030/ProductCarouselMain/JC030%20SIL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc030_Silver_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960087818",
      "product_title": "AWDis Ladies Cool-Flex™ Half Zip Top",
      "product_handle": "jc035",
      "product_url": "/products/jc035",
      "product_full_url": "None",
      "vendor": "Just Cool",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "security",
        "style-jc035",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "86% polyester/14% elastane.",
      "style_code": "JC035",
      "colour_name": "Silver Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#9dbab8",
      "sort_bucket": "blue",
      "sort_hue": 0.488506,
      "sort_sat": 0.155914,
      "sort_val": 0.729412,
      "swatch_file_id": "gid://shopify/MediaImage/49494605103370",
      "swatch_filename": "jc035_Silver_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc035_Silver_Grey.jpg?v=1774542200",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jc035_Silver_Grey.jpg?v=1774542200",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Cool/Product%20Images/JC035/ProductCarouselMain/JC035%20SIL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jc035_Silver_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#7afffc",
      "sort_bucket": "blue",
      "sort_hue": 0.496241,
      "sort_sat": 0.521569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494481174794",
      "swatch_filename": "gd67_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Sky_Blue.jpg?v=1774542033",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Sky_Blue.jpg?v=1774542033",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947898122",
      "product_title": "AWDis Academy Senior Raglan Sweatshirt",
      "product_handle": "ac001",
      "product_url": "/products/ac001",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ac001",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC001",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#364747",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.239437,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49494303441162",
      "swatch_filename": "ac001_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Charcoal.jpg?v=1774540489",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Charcoal.jpg?v=1774540489",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC001/ProductCarouselMain/AC001%20ACH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac001_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970311434",
      "product_title": "Fruit of the Loom Classic Drop Shoulder Sweatshirt",
      "product_handle": "ss9",
      "product_url": "/products/ss9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS9",
      "colour_name": "Light Graphite",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#2f3b3b",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.20339,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49497485312266",
      "swatch_filename": "ss9_Light_Graphite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Light_Graphite.jpg?v=1774543500",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Light_Graphite.jpg?v=1774543500",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS9/ProductCarouselMain/SS9%20LGP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss9_Light_Graphite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970213130",
      "product_title": "Fruit of the Loom Classic Raglan Sweatshirt",
      "product_handle": "ss8",
      "product_url": "/products/ss8",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss8",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS8",
      "colour_name": "Light Graphite",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#2f3b3b",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.20339,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49497416565002",
      "swatch_filename": "ss8_Light_Graphite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Light_Graphite.jpg?v=1774543471",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Light_Graphite.jpg?v=1774543471",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS8/ProductCarouselMain/SS8%20LGP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss8_Light_Graphite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969819914",
      "product_title": "Fruit of the Loom Iconic Premium Set-In Sweatshirt",
      "product_handle": "ss151",
      "product_url": "/products/ss151",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss151",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS151",
      "colour_name": "Light Graphite",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#2f3b3b",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.20339,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49497264718090",
      "swatch_filename": "ss151_Light_Graphite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_Light_Graphite.jpg?v=1774543406",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_Light_Graphite.jpg?v=1774543406",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS151/ProductCarouselMain/SS151%20LGP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss151_Light_Graphite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969983754",
      "product_title": "Fruit of the Loom Iconic Premium Sweat Jacket",
      "product_handle": "ss155",
      "product_url": "/products/ss155",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "jackets",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss155",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS155",
      "colour_name": "Light Graphite",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#2f3b3b",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.20339,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49497311248650",
      "swatch_filename": "ss155_Light_Graphite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss155_Light_Graphite.jpg?v=1774543435",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss155_Light_Graphite.jpg?v=1774543435",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS155/ProductCarouselMain/SS155%20LGP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss155_Light_Graphite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969885450",
      "product_title": "Fruit of the Loom Iconic Premium Zip Neck Sweatshirt",
      "product_handle": "ss154",
      "product_url": "/products/ss154",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss154",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS154",
      "colour_name": "Light Graphite",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#2f3b3b",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.20339,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49497282347274",
      "swatch_filename": "ss154_Light_Graphite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss154_Light_Graphite.jpg?v=1774543421",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss154_Light_Graphite.jpg?v=1774543421",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS154/ProductCarouselMain/SS154%20LGP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss154_Light_Graphite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969623306",
      "product_title": "Fruit of the Loom Lightweight Drop Shoulder Sweatshirt",
      "product_handle": "ss123",
      "product_url": "/products/ss123",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-ss123",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "SS123",
      "colour_name": "Light Graphite",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#2f3b3b",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.20339,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49497202393354",
      "swatch_filename": "ss123_Light_Graphite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss123_Light_Graphite.jpg?v=1774543377",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss123_Light_Graphite.jpg?v=1774543377",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Fruit%20of%20the%20Loom/SS123/ProductCarouselMain/SS123%20LGP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss123_Light_Graphite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969557770",
      "product_title": "Fruit of the Loom Lightweight Raglan Sweatshirt",
      "product_handle": "ss120",
      "product_url": "/products/ss120",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-ss120",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "SS120",
      "colour_name": "Light Graphite",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#2f3b3b",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.20339,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49497182601482",
      "swatch_filename": "ss120_Light_Graphite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss120_Light_Graphite.jpg?v=1774543367",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss120_Light_Graphite.jpg?v=1774543367",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Fruit%20of%20the%20Loom/SS120/ProductCarouselMain/SS120%20LGP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss120_Light_Graphite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970606346",
      "product_title": "Fruit of the Loom Premium Sweat Jacket",
      "product_handle": "sse92",
      "product_url": "/products/sse92",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "jackets",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-sse92",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE92",
      "colour_name": "Light Graphite",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#2f3b3b",
      "sort_bucket": "blue",
      "sort_hue": 0.5,
      "sort_sat": 0.20339,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49497541411082",
      "swatch_filename": "sse92_Light_Graphite.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse92_Light_Graphite.jpg?v=1774543548",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse92_Light_Graphite.jpg?v=1774543548",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SSE92/ProductCarouselMain/SSE92%20LGP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse92_Light_Graphite.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Hawaiian Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#2bfcff",
      "sort_bucket": "blue",
      "sort_hue": 0.502358,
      "sort_sat": 0.831373,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494751609098",
      "swatch_filename": "jh030_Hawaiian_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Hawaiian_Blue.jpg?v=1774542265",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Hawaiian_Blue.jpg?v=1774542265",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20HWB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Hawaiian_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964085514",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns407",
      "product_url": "/products/ns407",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns407",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "Adriatic Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#459ea6",
      "sort_bucket": "blue",
      "sort_hue": 0.513746,
      "sort_sat": 0.584337,
      "sort_val": 0.65098,
      "swatch_file_id": "gid://shopify/MediaImage/49495747920138",
      "swatch_filename": "ns407_Adriatic_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Adriatic_Blue.jpg?v=1774542741",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Adriatic_Blue.jpg?v=1774542741",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20ADB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns407_Adriatic_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970835722",
      "product_title": "Tombo Ladies Long Sleeve Zip Neck Performance Top",
      "product_handle": "tl563",
      "product_url": "/products/tl563",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "security",
        "sports",
        "style-tl563",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "88% polyester/12% elastane peached interlock.",
      "style_code": "TL563",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#819799",
      "sort_bucket": "blue",
      "sort_hue": 0.513889,
      "sort_sat": 0.156863,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49497581846794",
      "swatch_filename": "tl563_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl563_Grey_Marl.jpg?v=1774543568",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl563_Grey_Marl.jpg?v=1774543568",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL563/ProductCarouselMain/TL563%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl563_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970802954",
      "product_title": "Tombo Long Sleeve Zip Neck Performance Top",
      "product_handle": "tl562",
      "product_url": "/products/tl562",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "performance-activewear",
        "S",
        "security",
        "sports",
        "style-tl562",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "88% polyester/12% elastane peached interlock.",
      "style_code": "TL562",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Light Grey",
      "rgb": "#819799",
      "sort_bucket": "blue",
      "sort_hue": 0.513889,
      "sort_sat": 0.156863,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49497581748490",
      "swatch_filename": "tl562_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl562_Grey_Marl.jpg?v=1774543562",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl562_Grey_Marl.jpg?v=1774543562",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Tombo/TL562/ProductCarouselMain/TL562%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl562_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Graphite Heather",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#4e5f61",
      "sort_bucket": "blue",
      "sort_hue": 0.517544,
      "sort_sat": 0.195876,
      "sort_val": 0.380392,
      "swatch_file_id": "gid://shopify/MediaImage/49494762651914",
      "swatch_filename": "jh030_Graphite_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Graphite_Heather.jpg?v=1774542266",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Graphite_Heather.jpg?v=1774542266",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20GHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Graphite_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% recycled polyester",
      "style_code": "03814",
      "colour_name": "Charcoal Marl",
      "colour_group": "Grey > Charcoal",
      "rgb": "#3e5356",
      "sort_bucket": "blue",
      "sort_hue": 0.520833,
      "sort_sat": 0.27907,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49494225223946",
      "swatch_filename": "03814_Charcoal_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Charcoal_Marl.jpg?v=1774540255",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Charcoal_Marl.jpg?v=1774540255",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03814/ProductCarouselMain/03814%20CME%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_Charcoal_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944686858",
      "product_title": "SOL'S Unisex Space Organic Raglan Sweatshirt",
      "product_handle": "03567",
      "product_url": "/products/03567",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03567",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% organic cotton/40% recycled polyester",
      "style_code": "03567",
      "colour_name": "Charcoal Marl",
      "colour_group": "Grey > Charcoal",
      "rgb": "#3e5356",
      "sort_bucket": "blue",
      "sort_hue": 0.520833,
      "sort_sat": 0.27907,
      "sort_val": 0.337255,
      "swatch_file_id": "gid://shopify/MediaImage/49494218506506",
      "swatch_filename": "03567_Charcoal_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Charcoal_Marl.jpg?v=1774540208",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Charcoal_Marl.jpg?v=1774540208",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03567/ProductCarouselMain/03567%20CHM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03567_Charcoal_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Steel Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#202b2d",
      "sort_bucket": "blue",
      "sort_hue": 0.525641,
      "sort_sat": 0.288889,
      "sort_val": 0.176471,
      "swatch_file_id": "gid://shopify/MediaImage/49494764355850",
      "swatch_filename": "jh030_Steel_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Steel_Grey.jpg?v=1774542267",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Steel_Grey.jpg?v=1774542267",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20STE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Steel_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948160266",
      "product_title": "AWDis Academy Kids V Neck Sweatshirt",
      "product_handle": "ac003b",
      "product_url": "/products/ac003b",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-ac003b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC003B",
      "colour_name": "Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#9bafb3",
      "sort_bucket": "blue",
      "sort_hue": 0.527778,
      "sort_sat": 0.134078,
      "sort_val": 0.701961,
      "swatch_file_id": "gid://shopify/MediaImage/49494305898762",
      "swatch_filename": "ac003b_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003b_Grey.jpg?v=1774540515",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003b_Grey.jpg?v=1774540515",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC003B/ProductCarouselMain/AC003B%20ACG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac003b_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947898122",
      "product_title": "AWDis Academy Senior Raglan Sweatshirt",
      "product_handle": "ac001",
      "product_url": "/products/ac001",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ac001",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC001",
      "colour_name": "Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#9bafb3",
      "sort_bucket": "blue",
      "sort_hue": 0.527778,
      "sort_sat": 0.134078,
      "sort_val": 0.701961,
      "swatch_file_id": "gid://shopify/MediaImage/49494303506698",
      "swatch_filename": "ac001_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Grey.jpg?v=1774540491",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Grey.jpg?v=1774540491",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC001/ProductCarouselMain/AC001%20ACG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac001_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Turquoise Blue",
      "colour_group": "Blue > Turquoise",
      "rgb": "#2cabc9",
      "sort_bucket": "blue",
      "sort_hue": 0.531847,
      "sort_sat": 0.781095,
      "sort_val": 0.788235,
      "swatch_file_id": "gid://shopify/MediaImage/49496960073994",
      "swatch_filename": "rx301_Turquoise_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Turquoise_Blue.jpg?v=1774543263",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Turquoise_Blue.jpg?v=1774543263",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20TUR%20FRONT%202.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Turquoise_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#8bd8eb",
      "sort_bucket": "blue",
      "sort_hue": 0.532986,
      "sort_sat": 0.408511,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49494889988362",
      "swatch_filename": "jh030b_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Sky_Blue.jpg?v=1774542351",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Sky_Blue.jpg?v=1774542351",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960743178",
      "product_title": "AWDis Ladies Cropped 1/4 Zip Sweatshirt",
      "product_handle": "jh037",
      "product_url": "/products/jh037",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-jh037",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XXS",
        "XXS-XS-S-M-L-XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "JH037",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#8bd8eb",
      "sort_bucket": "blue",
      "sort_hue": 0.532986,
      "sort_sat": 0.408511,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49495001137418",
      "swatch_filename": "jh037_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh037_Sky_Blue.jpg?v=1774542387",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh037_Sky_Blue.jpg?v=1774542387",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH037/ProductCarouselMain/JH037%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh037_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#8bd8eb",
      "sort_bucket": "blue",
      "sort_hue": 0.532986,
      "sort_sat": 0.408511,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49494765240586",
      "swatch_filename": "jh030_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Sky_Blue.jpg?v=1774542269",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Sky_Blue.jpg?v=1774542269",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Ice Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#b1ebfc",
      "sort_bucket": "blue",
      "sort_hue": 0.537778,
      "sort_sat": 0.297619,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49494901817610",
      "swatch_filename": "jh030b_Ice_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Ice_Blue.jpg?v=1774542352",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Ice_Blue.jpg?v=1774542352",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20ICE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Ice_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Ice Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#b1ebfc",
      "sort_bucket": "blue",
      "sort_hue": 0.537778,
      "sort_sat": 0.297619,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49494765273354",
      "swatch_filename": "jh030_Ice_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Ice_Blue.jpg?v=1774542270",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Ice_Blue.jpg?v=1774542270",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20ICE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Ice_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#009fcf",
      "sort_bucket": "blue",
      "sort_hue": 0.538647,
      "sort_sat": 1.0,
      "sort_val": 0.811765,
      "swatch_file_id": "gid://shopify/MediaImage/49494475407626",
      "swatch_filename": "gd56_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Sapphire_Blue.jpg?v=1774541909",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Sapphire_Blue.jpg?v=1774541909",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Light Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#9fe6fc",
      "sort_bucket": "blue",
      "sort_hue": 0.539427,
      "sort_sat": 0.369048,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49494475440394",
      "swatch_filename": "gd56_Light_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Light_Blue.jpg?v=1774541910",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Light_Blue.jpg?v=1774541910",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20LBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Light_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970311434",
      "product_title": "Fruit of the Loom Classic Drop Shoulder Sweatshirt",
      "product_handle": "ss9",
      "product_url": "/products/ss9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS9",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#91e3ff",
      "sort_bucket": "blue",
      "sort_hue": 0.542424,
      "sort_sat": 0.431373,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497485345034",
      "swatch_filename": "ss9_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Sky_Blue.jpg?v=1774543502",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Sky_Blue.jpg?v=1774543502",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS9/ProductCarouselMain/SS9%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss9_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947898122",
      "product_title": "AWDis Academy Senior Raglan Sweatshirt",
      "product_handle": "ac001",
      "product_url": "/products/ac001",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ac001",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC001",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#a1e3ff",
      "sort_bucket": "blue",
      "sort_hue": 0.549645,
      "sort_sat": 0.368627,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494303572234",
      "swatch_filename": "ac001_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Sky_Blue.jpg?v=1774540492",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Sky_Blue.jpg?v=1774540492",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC001/ProductCarouselMain/AC001%20ASK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac001_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946521866",
      "product_title": "Russell Athletic Authentic Sweat Jacket",
      "product_handle": "267m",
      "product_url": "/products/267m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "jackets",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-267m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun combed cotton/20% polyester.",
      "style_code": "267M",
      "colour_name": "Convoy Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#3d464a",
      "sort_bucket": "blue",
      "sort_hue": 0.551282,
      "sort_sat": 0.175676,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49494290071818",
      "swatch_filename": "267m_Convoy_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/267m_Convoy_Grey.jpg?v=1774540377",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/267m_Convoy_Grey.jpg?v=1774540377",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/267M/ProductCarouselMain/267M%20CVY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "267m_Convoy_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "Convoy Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#3d464a",
      "sort_bucket": "blue",
      "sort_hue": 0.551282,
      "sort_sat": 0.175676,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49494288367882",
      "swatch_filename": "262m_Convoy_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Convoy_Grey.jpg?v=1774540350",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Convoy_Grey.jpg?v=1774540350",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20CVY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_Convoy_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946587402",
      "product_title": "Russell Athletic Authentic Zip Neck Sweatshirt",
      "product_handle": "270m",
      "product_url": "/products/270m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-270m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "270M",
      "colour_name": "Convoy Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#3d464a",
      "sort_bucket": "blue",
      "sort_hue": 0.551282,
      "sort_sat": 0.175676,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49494294069514",
      "swatch_filename": "270m_Convoy_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/270m_Convoy_Grey.jpg?v=1774540390",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/270m_Convoy_Grey.jpg?v=1774540390",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/270M/ProductCarouselMain/270M%20CVY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "270m_Convoy_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Dark Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#315060",
      "sort_bucket": "blue",
      "sort_hue": 0.556738,
      "sort_sat": 0.489583,
      "sort_val": 0.376471,
      "swatch_file_id": "gid://shopify/MediaImage/49494475473162",
      "swatch_filename": "gd56_Dark_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Dark_Heather.jpg?v=1774541912",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Dark_Heather.jpg?v=1774541912",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20DHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Dark_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD67",
      "colour_name": "Dark Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#315060",
      "sort_bucket": "blue",
      "sort_hue": 0.556738,
      "sort_sat": 0.489583,
      "sort_val": 0.376471,
      "swatch_file_id": "gid://shopify/MediaImage/49494481240330",
      "swatch_filename": "gd67_Dark_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Dark_Heather.jpg?v=1774542035",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Dark_Heather.jpg?v=1774542035",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20DHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Dark_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964085514",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns407",
      "product_url": "/products/ns407",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns407",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "Aquamarine",
      "colour_group": "Blue > Light Blue",
      "rgb": "#94bfd6",
      "sort_bucket": "blue",
      "sort_hue": 0.558081,
      "sort_sat": 0.308411,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49495750410506",
      "swatch_filename": "ns407_Aquamarine.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Aquamarine.jpg?v=1774542743",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Aquamarine.jpg?v=1774542743",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20AQM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns407_Aquamarine.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457959727370",
      "product_title": "Henbury Unisex Sustainable 1/4 Zip Sweatshirt",
      "product_handle": "h842",
      "product_url": "/products/h842",
      "product_full_url": "None",
      "vendor": "Henbury",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "security",
        "style-h842",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% regenerated cotton/40% recycled polyester.",
      "style_code": "H842",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#96acb8",
      "sort_bucket": "blue",
      "sort_hue": 0.558824,
      "sort_sat": 0.184783,
      "sort_val": 0.721569,
      "swatch_file_id": "gid://shopify/MediaImage/49494490054922",
      "swatch_filename": "h842_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h842_Heather_Grey.jpg?v=1774542166",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h842_Heather_Grey.jpg?v=1774542166",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H842/ProductCarouselMain/H842%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h842_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457959596298",
      "product_title": "Henbury Unisex Sustainable Sweatshirt",
      "product_handle": "h840",
      "product_url": "/products/h840",
      "product_full_url": "None",
      "vendor": "Henbury",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-h840",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% regenerated cotton/40% recycled polyester.",
      "style_code": "H840",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#96acb8",
      "sort_bucket": "blue",
      "sort_hue": 0.558824,
      "sort_sat": 0.184783,
      "sort_val": 0.721569,
      "swatch_file_id": "gid://shopify/MediaImage/49494489432330",
      "swatch_filename": "h840_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h840_Heather_Grey.jpg?v=1774542159",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h840_Heather_Grey.jpg?v=1774542159",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H840/ProductCarouselMain/H840%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h840_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961070858",
      "product_title": "AWDis Signature Heavyweight Sweatshirt",
      "product_handle": "jh123",
      "product_url": "/products/jh123",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-jh123",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/20% polyester/10% recycled polyester.*",
      "style_code": "JH123",
      "colour_name": "Airforce Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31637f",
      "sort_bucket": "blue",
      "sort_hue": 0.559829,
      "sort_sat": 0.614173,
      "sort_val": 0.498039,
      "swatch_file_id": "gid://shopify/MediaImage/49495077060874",
      "swatch_filename": "jh123_Airforce_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_Airforce_Blue.jpg?v=1774542421",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_Airforce_Blue.jpg?v=1774542421",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH123/ProductCarouselMain/JH123%20AIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh123_Airforce_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Airforce Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#31637f",
      "sort_bucket": "blue",
      "sort_hue": 0.559829,
      "sort_sat": 0.614173,
      "sort_val": 0.498039,
      "swatch_file_id": "gid://shopify/MediaImage/49494776316170",
      "swatch_filename": "jh030_Airforce_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Airforce_Blue.jpg?v=1774542272",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Airforce_Blue.jpg?v=1774542272",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20AIR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Airforce_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Indigo",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#31637f",
      "sort_bucket": "blue",
      "sort_hue": 0.559829,
      "sort_sat": 0.614173,
      "sort_val": 0.498039,
      "swatch_file_id": "gid://shopify/MediaImage/49494475538698",
      "swatch_filename": "gd56_Indigo.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Indigo.jpg?v=1774541913",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Indigo.jpg?v=1774541913",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20IND%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Indigo.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963790602",
      "product_title": "Mantis Unisex Essential Sweatshirt",
      "product_handle": "m05",
      "product_url": "/products/m05",
      "product_full_url": "None",
      "vendor": "Mantis",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-m05",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "80% organic cotton/20% recycled polyester.",
      "style_code": "M05",
      "colour_name": "Heather Marl",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#96a8b3",
      "sort_bucket": "blue",
      "sort_hue": 0.563218,
      "sort_sat": 0.162011,
      "sort_val": 0.701961,
      "swatch_file_id": "gid://shopify/MediaImage/49495666622730",
      "swatch_filename": "m05_Heather_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m05_Heather_Marl.jpg?v=1774542702",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m05_Heather_Marl.jpg?v=1774542702",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Mantis/M05/ProductCarouselMain/M05%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "m05_Heather_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969721610",
      "product_title": "Fruit of the Loom Supercotton™ Sweatshirt",
      "product_handle": "ss141",
      "product_url": "/products/ss141",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss141",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS141",
      "colour_name": "Mountain Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#00426b",
      "sort_bucket": "blue",
      "sort_hue": 0.563863,
      "sort_sat": 1.0,
      "sort_val": 0.419608,
      "swatch_file_id": "gid://shopify/MediaImage/49497231950090",
      "swatch_filename": "ss141_Mountain_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss141_Mountain_Blue.jpg?v=1774543389",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss141_Mountain_Blue.jpg?v=1774543389",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS141/ProductCarouselMain/SS141%20MNB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss141_Mountain_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Shark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#2a353c",
      "sort_bucket": "blue",
      "sort_hue": 0.564815,
      "sort_sat": 0.3,
      "sort_val": 0.235294,
      "swatch_file_id": "gid://shopify/MediaImage/49494776348938",
      "swatch_filename": "jh030_Shark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Shark_Grey.jpg?v=1774542273",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Shark_Grey.jpg?v=1774542273",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20SHK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Shark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961070858",
      "product_title": "AWDis Signature Heavyweight Sweatshirt",
      "product_handle": "jh123",
      "product_url": "/products/jh123",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-jh123",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/20% polyester/10% recycled polyester.*",
      "style_code": "JH123",
      "colour_name": "Solid Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#2a353c",
      "sort_bucket": "blue",
      "sort_hue": 0.564815,
      "sort_sat": 0.3,
      "sort_val": 0.235294,
      "swatch_file_id": "gid://shopify/MediaImage/49495086563594",
      "swatch_filename": "jh123_Solid_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_Solid_Charcoal.jpg?v=1774542422",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_Solid_Charcoal.jpg?v=1774542422",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH123/ProductCarouselMain/JH123%20SDC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh123_Solid_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960972554",
      "product_title": "AWDis Vision Heavyweight Sweatshirt",
      "product_handle": "jh113",
      "product_url": "/products/jh113",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-jh113",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/20% polyester/10% recycled polyester.*",
      "style_code": "JH113",
      "colour_name": "Solid Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#2a353c",
      "sort_bucket": "blue",
      "sort_hue": 0.564815,
      "sort_sat": 0.3,
      "sort_val": 0.235294,
      "swatch_file_id": "gid://shopify/MediaImage/49495064805642",
      "swatch_filename": "jh113_Solid_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh113_Solid_Charcoal.jpg?v=1774542409",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh113_Solid_Charcoal.jpg?v=1774542409",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH113/ProductCarouselMain/JH113%20SDC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh113_Solid_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457959727370",
      "product_title": "Henbury Unisex Sustainable 1/4 Zip Sweatshirt",
      "product_handle": "h842",
      "product_url": "/products/h842",
      "product_full_url": "None",
      "vendor": "Henbury",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "security",
        "style-h842",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% regenerated cotton/40% recycled polyester.",
      "style_code": "H842",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001c2e",
      "sort_bucket": "blue",
      "sort_hue": 0.565217,
      "sort_sat": 1.0,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49494490185994",
      "swatch_filename": "h842_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h842_Navy.jpg?v=1774542167",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h842_Navy.jpg?v=1774542167",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H842/ProductCarouselMain/H842%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h842_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457959596298",
      "product_title": "Henbury Unisex Sustainable Sweatshirt",
      "product_handle": "h840",
      "product_url": "/products/h840",
      "product_full_url": "None",
      "vendor": "Henbury",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-h840",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% regenerated cotton/40% recycled polyester.",
      "style_code": "H840",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001c2e",
      "sort_bucket": "blue",
      "sort_hue": 0.565217,
      "sort_sat": 1.0,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49494489596170",
      "swatch_filename": "h840_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h840_Navy.jpg?v=1774542160",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h840_Navy.jpg?v=1774542160",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H840/ProductCarouselMain/H840%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h840_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457959792906",
      "product_title": "Henbury Zip Neck Wicking Top",
      "product_handle": "h862",
      "product_url": "/products/h862",
      "product_full_url": "None",
      "vendor": "Henbury",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-h862",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester fleece back single jersey.",
      "style_code": "H862",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001c2e",
      "sort_bucket": "blue",
      "sort_hue": 0.565217,
      "sort_sat": 1.0,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49494490579210",
      "swatch_filename": "h862_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h862_Navy.jpg?v=1774542175",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/h862_Navy.jpg?v=1774542175",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Henbury/Product%20Images/H862/ProductCarouselMain/H862%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "h862_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#7bb0d4",
      "sort_bucket": "blue",
      "sort_hue": 0.567416,
      "sort_sat": 0.419811,
      "sort_val": 0.831373,
      "swatch_file_id": "gid://shopify/MediaImage/49495337500938",
      "swatch_filename": "kb4025_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Sky_Blue.jpg?v=1774542559",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Sky_Blue.jpg?v=1774542559",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#0075c5",
      "sort_bucket": "blue",
      "sort_hue": 0.567682,
      "sort_sat": 1.0,
      "sort_val": 0.772549,
      "swatch_file_id": "gid://shopify/MediaImage/49496960139530",
      "swatch_filename": "rx301_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Sapphire_Blue.jpg?v=1774543264",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Sapphire_Blue.jpg?v=1774543264",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "Deep Blue",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#435663",
      "sort_bucket": "blue",
      "sort_hue": 0.567708,
      "sort_sat": 0.323232,
      "sort_val": 0.388235,
      "swatch_file_id": "gid://shopify/MediaImage/49495345430794",
      "swatch_filename": "kb4025_Deep_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Deep_Blue.jpg?v=1774542560",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Deep_Blue.jpg?v=1774542560",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20DPB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_Deep_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457965789450",
      "product_title": "Premier Ladies Spun Dyed Recycled Zip Through Sweat Jacket",
      "product_handle": "pr809",
      "product_url": "/products/pr809",
      "product_full_url": "None",
      "vendor": "Premier",
      "product_type": "Sweatshirt",
      "tags": [
        "jackets",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-pr809",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "PR809",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#5b6770",
      "sort_bucket": "blue",
      "sort_hue": 0.571429,
      "sort_sat": 0.1875,
      "sort_val": 0.439216,
      "swatch_file_id": "gid://shopify/MediaImage/49496219812106",
      "swatch_filename": "pr809_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr809_Dark_Grey.jpg?v=1774542945",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr809_Dark_Grey.jpg?v=1774542945",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR809/ProductCarouselMain/PR809%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr809_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457965723914",
      "product_title": "Premier Spun Dyed Recycled Zip Through Sweat Jacket",
      "product_handle": "pr808",
      "product_url": "/products/pr808",
      "product_full_url": "None",
      "vendor": "Premier",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "jackets",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-pr808",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "PR808",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#5b6770",
      "sort_bucket": "blue",
      "sort_hue": 0.571429,
      "sort_sat": 0.1875,
      "sort_val": 0.439216,
      "swatch_file_id": "gid://shopify/MediaImage/49496192712970",
      "swatch_filename": "pr808_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr808_Dark_Grey.jpg?v=1774542937",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr808_Dark_Grey.jpg?v=1774542937",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR808/ProductCarouselMain/PR808%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr808_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556325642",
      "product_title": "Tee Jays Full Zip Sweat Jacket",
      "product_handle": "t5440",
      "product_url": "/products/t5440",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "jackets",
        "L",
        "M",
        "S",
        "style-t5440",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/30% polyester.",
      "style_code": "T5440",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49491111903498",
      "swatch_filename": "t5440_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5440_Dark_Grey.jpg?v=1774526065",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5440_Dark_Grey.jpg?v=1774526065",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5440/ProductCarouselMain/T5440%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5440_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556292874",
      "product_title": "Tee Jays Half Zip Sweatshirt",
      "product_handle": "t5438",
      "product_url": "/products/t5438",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5438",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/30% polyester.",
      "style_code": "T5438",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49491114524938",
      "swatch_filename": "t5438_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5438_Dark_Grey.jpg?v=1774526072",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5438_Dark_Grey.jpg?v=1774526072",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5438/ProductCarouselMain/T5438%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5438_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556161802",
      "product_title": "Tee Jays Heavy Sweatshirt",
      "product_handle": "t5429",
      "product_url": "/products/t5429",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t5429",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/30% polyester.",
      "style_code": "T5429",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49491170427146",
      "swatch_filename": "t5429_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5429_Dark_Grey.jpg?v=1774526131",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5429_Dark_Grey.jpg?v=1774526131",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5429/ProductCarouselMain/T5429%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5429_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555801354",
      "product_title": "Tee Jays Power Organic Sweatshirt",
      "product_handle": "t5100",
      "product_url": "/products/t5100",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-t5100",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% organic cotton/30% polyester.",
      "style_code": "T5100",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49491207782666",
      "swatch_filename": "t5100_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5100_Dark_Grey.jpg?v=1774526221",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5100_Dark_Grey.jpg?v=1774526221",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Tee%20Jays/T5100/ProductCarouselMain/T5100%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5100_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556358410",
      "product_title": "Tee Jays Ribbed Interlock Crew Neck Sweatshirt",
      "product_handle": "t5504",
      "product_url": "/products/t5504",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5504",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "T5504",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49491109740810",
      "swatch_filename": "t5504_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5504_Dark_Grey.jpg?v=1774526058",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5504_Dark_Grey.jpg?v=1774526058",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5504/ProductCarouselMain/T5504%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5504_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556391178",
      "product_title": "Tee Jays Ribbed Interlock Half Zip Sweatshirt",
      "product_handle": "t5506",
      "product_url": "/products/t5506",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5506",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "T5506",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49491106431242",
      "swatch_filename": "t5506_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5506_Dark_Grey.jpg?v=1774526051",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5506_Dark_Grey.jpg?v=1774526051",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5506/ProductCarouselMain/T5506%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5506_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555866890",
      "product_title": "Tee Jays Unlabeled Sweatshirt",
      "product_handle": "t5150",
      "product_url": "/products/t5150",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-t5150",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% organic ringspun cotton/30% recycled polyester.",
      "style_code": "T5150",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49491203064074",
      "swatch_filename": "t5150_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5150_Dark_Grey.jpg?v=1774526209",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5150_Dark_Grey.jpg?v=1774526209",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5150/ProductCarouselMain/T5150%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5150_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "French Navy Heather",
      "colour_group": "Blue > Navy",
      "rgb": "#333e47",
      "sort_bucket": "blue",
      "sort_hue": 0.575,
      "sort_sat": 0.28169,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49495364337930",
      "swatch_filename": "kb4025_French_Navy_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_French_Navy_Heather.jpg?v=1774542562",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_French_Navy_Heather.jpg?v=1774542562",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20FNH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_French_Navy_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968705802",
      "product_title": "Pro RTX Pro 1/4 Neck Zip Sweatshirt",
      "product_handle": "rx305",
      "product_url": "/products/rx305",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx305",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX305",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#14202a",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.52381,
      "sort_val": 0.164706,
      "swatch_file_id": "gid://shopify/MediaImage/49496992317706",
      "swatch_filename": "rx305_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx305_Charcoal.jpg?v=1774543286",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx305_Charcoal.jpg?v=1774543286",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX305/ProductCarouselMain/RX305%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx305_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#14202a",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.52381,
      "sort_val": 0.164706,
      "swatch_file_id": "gid://shopify/MediaImage/49496960205066",
      "swatch_filename": "rx301_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Charcoal.jpg?v=1774543266",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Charcoal.jpg?v=1774543266",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970311434",
      "product_title": "Fruit of the Loom Classic Drop Shoulder Sweatshirt",
      "product_handle": "ss9",
      "product_url": "/products/ss9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% polyester.",
      "style_code": "SS9",
      "colour_name": "Dark Heather",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#14202a",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.52381,
      "sort_val": 0.164706,
      "swatch_file_id": "gid://shopify/MediaImage/49497485410570",
      "swatch_filename": "ss9_Dark_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Dark_Heather.jpg?v=1774543504",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Dark_Heather.jpg?v=1774543504",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS9/ProductCarouselMain/SS9%20DHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss9_Dark_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970213130",
      "product_title": "Fruit of the Loom Classic Raglan Sweatshirt",
      "product_handle": "ss8",
      "product_url": "/products/ss8",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss8",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% cotton/40% polyester.",
      "style_code": "SS8",
      "colour_name": "Dark Heather",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#14202a",
      "sort_bucket": "blue",
      "sort_hue": 0.575758,
      "sort_sat": 0.52381,
      "sort_val": 0.164706,
      "swatch_file_id": "gid://shopify/MediaImage/49497416663306",
      "swatch_filename": "ss8_Dark_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Dark_Heather.jpg?v=1774543473",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Dark_Heather.jpg?v=1774543473",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS8/ProductCarouselMain/SS8%20DHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss8_Dark_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947308298",
      "product_title": "Russell Athletic Kids Raglan Sweatshirt",
      "product_handle": "762b",
      "product_url": "/products/762b",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "performance-activewear",
        "sports",
        "style-762b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762B",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#85c7ff",
      "sort_bucket": "blue",
      "sort_hue": 0.576503,
      "sort_sat": 0.478431,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494299443466",
      "swatch_filename": "762b_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Sky_Blue.jpg?v=1774540433",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Sky_Blue.jpg?v=1774540433",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762B/ProductCarouselMain/762B%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762b_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Carolina Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#69baff",
      "sort_bucket": "blue",
      "sort_hue": 0.576667,
      "sort_sat": 0.588235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494475571466",
      "swatch_filename": "gd56_Carolina_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Carolina_Blue.jpg?v=1774541915",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Carolina_Blue.jpg?v=1774541915",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20CNB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Carolina_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Cornflower Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#69baff",
      "sort_bucket": "blue",
      "sort_hue": 0.576667,
      "sort_sat": 0.588235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494779625738",
      "swatch_filename": "jh030_Cornflower_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Cornflower_Blue.jpg?v=1774542275",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Cornflower_Blue.jpg?v=1774542275",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20COR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Cornflower_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962971402",
      "product_title": "Kariban Crew Neck Sweatshirt",
      "product_handle": "kb442",
      "product_url": "/products/kb442",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-kb442",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed cotton/20% polyester.",
      "style_code": "KB442",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1d262e",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.369565,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49495419977994",
      "swatch_filename": "kb442_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb442_Navy.jpg?v=1774542585",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb442_Navy.jpg?v=1774542585",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB442/ProductCarouselMain/KB442%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb442_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963200778",
      "product_title": "Kariban Crew Neck Sweatshirt",
      "product_handle": "kb488",
      "product_url": "/products/kb488",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb488",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed cotton/20% polyester.",
      "style_code": "KB442",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1d262e",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.369565,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49495499637002",
      "swatch_filename": "kb488_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb488_Navy.jpg?v=1774542623",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb488_Navy.jpg?v=1774542623",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB442/ProductCarouselMain/KB442%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb488_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963036938",
      "product_title": "Kariban Ladies Oversized Sweatshirt",
      "product_handle": "kb471",
      "product_url": "/products/kb471",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "l-xl",
        "L-XL-S-M",
        "s-m",
        "style-kb471",
        "sweatshirts",
        "womens"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "91% cotton/9% polyester.*",
      "style_code": "KB471",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1d262e",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.369565,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49495440228618",
      "swatch_filename": "kb471_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb471_Navy.jpg?v=1774542595",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb471_Navy.jpg?v=1774542595",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB471/ProductCarouselMain/KB471%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb471_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1d262e",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.369565,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49495364370698",
      "swatch_filename": "kb4025_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Navy.jpg?v=1774542564",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Navy.jpg?v=1774542564",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963135242",
      "product_title": "Kariban Zip Neck Sweatshirt",
      "product_handle": "kb487",
      "product_url": "/products/kb487",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb487",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "KB487",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1d262e",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.369565,
      "sort_val": 0.180392,
      "swatch_file_id": "gid://shopify/MediaImage/49495488299274",
      "swatch_filename": "kb487_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb487_Navy.jpg?v=1774542609",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb487_Navy.jpg?v=1774542609",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB487/ProductCarouselMain/KB487%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb487_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#343d45",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.246377,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49494475637002",
      "swatch_filename": "gd56_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Charcoal.jpg?v=1774541916",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Charcoal.jpg?v=1774541916",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#343d45",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.246377,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49494481273098",
      "swatch_filename": "gd67_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Charcoal.jpg?v=1774542036",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Charcoal.jpg?v=1774542036",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958187274",
      "product_title": "Gildan SoftStyle® Midweight Fleece 1/4 Zip Sweatshirt",
      "product_handle": "gd612",
      "product_url": "/products/gd612",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd612",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD612",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#343d45",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.246377,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49494476882186",
      "swatch_filename": "gd612_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Charcoal.jpg?v=1774541945",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Charcoal.jpg?v=1774541945",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD612/ProductCarouselMain/GD612%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd612_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968738570",
      "product_title": "Pro RTX Pro Full Zip Sweatshirt",
      "product_handle": "rx310",
      "product_url": "/products/rx310",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-rx310",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX310",
      "colour_name": "Solid Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#343d45",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.246377,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49497039700234",
      "swatch_filename": "rx310_Solid_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx310_Solid_Grey.jpg?v=1774543294",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx310_Solid_Grey.jpg?v=1774543294",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX310/ProductCarouselMain/RX310%20SGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx310_Solid_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Solid Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#343d45",
      "sort_bucket": "blue",
      "sort_hue": 0.578431,
      "sort_sat": 0.246377,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49496960270602",
      "swatch_filename": "rx301_Solid_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Solid_Grey.jpg?v=1774543268",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Solid_Grey.jpg?v=1774543268",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20SGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Solid_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970311434",
      "product_title": "Fruit of the Loom Classic Drop Shoulder Sweatshirt",
      "product_handle": "ss9",
      "product_url": "/products/ss9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS9",
      "colour_name": "Mineral Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#82b0da",
      "sort_bucket": "blue",
      "sort_hue": 0.579545,
      "sort_sat": 0.40367,
      "sort_val": 0.854902,
      "swatch_file_id": "gid://shopify/MediaImage/49497485705482",
      "swatch_filename": "ss9_Mineral_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Mineral_Blue.jpg?v=1774543505",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Mineral_Blue.jpg?v=1774543505",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS9/ProductCarouselMain/SS9%20MIB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss9_Mineral_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970213130",
      "product_title": "Fruit of the Loom Classic Raglan Sweatshirt",
      "product_handle": "ss8",
      "product_url": "/products/ss8",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss8",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS8",
      "colour_name": "Mineral Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#82b0da",
      "sort_bucket": "blue",
      "sort_hue": 0.579545,
      "sort_sat": 0.40367,
      "sort_val": 0.854902,
      "swatch_file_id": "gid://shopify/MediaImage/49497416696074",
      "swatch_filename": "ss8_Mineral_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Mineral_Blue.jpg?v=1774543474",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Mineral_Blue.jpg?v=1774543474",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS8/ProductCarouselMain/SS8%20MIB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss8_Mineral_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "Mineral Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#82b0da",
      "sort_bucket": "blue",
      "sort_hue": 0.579545,
      "sort_sat": 0.40367,
      "sort_val": 0.854902,
      "swatch_file_id": "gid://shopify/MediaImage/49494288531722",
      "swatch_filename": "262m_Mineral_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Mineral_Blue.jpg?v=1774540351",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Mineral_Blue.jpg?v=1774540351",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20MIB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_Mineral_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#0380ff",
      "sort_bucket": "blue",
      "sort_hue": 0.583995,
      "sort_sat": 0.988235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494911090954",
      "swatch_filename": "jh030b_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Sapphire_Blue.jpg?v=1774542354",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Sapphire_Blue.jpg?v=1774542354",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Sapphire Blue",
      "colour_group": "Blue > Sapphire",
      "rgb": "#0380ff",
      "sort_bucket": "blue",
      "sort_hue": 0.583995,
      "sort_sat": 0.988235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494779658506",
      "swatch_filename": "jh030_Sapphire_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Sapphire_Blue.jpg?v=1774542276",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Sapphire_Blue.jpg?v=1774542276",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20SAP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Sapphire_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946751242",
      "product_title": "SOL'S Sundae Sweat Jacket",
      "product_handle": "47200",
      "product_url": "/products/47200",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "jackets",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-47200",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "47200",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001e3f",
      "sort_bucket": "blue",
      "sort_hue": 0.587302,
      "sort_sat": 1.0,
      "sort_val": 0.247059,
      "swatch_file_id": "gid://shopify/MediaImage/49494295970058",
      "swatch_filename": "47200_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/47200_Navy.jpg?v=1774540398",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/47200_Navy.jpg?v=1774540398",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/47200/ProductCarouselMain/47200%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "47200_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946259722",
      "product_title": "SOL'S Unisex New Supreme Sweatshirt",
      "product_handle": "13250",
      "product_url": "/products/13250",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-13250",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "13250",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001e3f",
      "sort_bucket": "blue",
      "sort_hue": 0.587302,
      "sort_sat": 1.0,
      "sort_val": 0.247059,
      "swatch_file_id": "gid://shopify/MediaImage/49494284927242",
      "swatch_filename": "13250_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_Navy.jpg?v=1774540328",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_Navy.jpg?v=1774540328",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/13250/ProductCarouselMain/13250%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "13250_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Sky Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#69b0ff",
      "sort_bucket": "blue",
      "sort_hue": 0.587778,
      "sort_sat": 0.588235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49496972198154",
      "swatch_filename": "rx301_Sky_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Sky_Blue.jpg?v=1774543270",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Sky_Blue.jpg?v=1774543270",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20SKY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Sky_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964085514",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns407",
      "product_url": "/products/ns407",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns407",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "Iron Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#3a4757",
      "sort_bucket": "blue",
      "sort_hue": 0.591954,
      "sort_sat": 0.333333,
      "sort_val": 0.341176,
      "swatch_file_id": "gid://shopify/MediaImage/49495750607114",
      "swatch_filename": "ns407_Iron_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Iron_Grey.jpg?v=1774542744",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Iron_Grey.jpg?v=1774542744",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20IRN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns407_Iron_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970868490",
      "product_title": "Tombo Technical 1/4 Zip Top",
      "product_handle": "tl577",
      "product_url": "/products/tl577",
      "product_full_url": "None",
      "vendor": "Tombo",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "security",
        "style-tl577",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "90% polyester/10% elastane.",
      "style_code": "TL577",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001a3d",
      "sort_bucket": "blue",
      "sort_hue": 0.595628,
      "sort_sat": 1.0,
      "sort_val": 0.239216,
      "swatch_file_id": "gid://shopify/MediaImage/49497587745034",
      "swatch_filename": "tl577_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl577_Navy.jpg?v=1774543574",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/tl577_Navy.jpg?v=1774543574",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tombo/Product%20Images/TL577/ProductCarouselMain/TL577%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "tl577_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "Indigo Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#174990",
      "sort_bucket": "blue",
      "sort_hue": 0.597796,
      "sort_sat": 0.840278,
      "sort_val": 0.564706,
      "swatch_file_id": "gid://shopify/MediaImage/49494288728330",
      "swatch_filename": "262m_Indigo_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Indigo_Blue.jpg?v=1774540353",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Indigo_Blue.jpg?v=1774540353",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20IND%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_Indigo_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556325642",
      "product_title": "Tee Jays Full Zip Sweat Jacket",
      "product_handle": "t5440",
      "product_url": "/products/t5440",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "jackets",
        "L",
        "M",
        "S",
        "style-t5440",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/30% polyester.",
      "style_code": "T5440",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49491112427786",
      "swatch_filename": "t5440_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5440_Navy.jpg?v=1774526066",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5440_Navy.jpg?v=1774526066",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5440/ProductCarouselMain/T5440%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5440_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556292874",
      "product_title": "Tee Jays Half Zip Sweatshirt",
      "product_handle": "t5438",
      "product_url": "/products/t5438",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5438",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/30% polyester.",
      "style_code": "T5438",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49491114885386",
      "swatch_filename": "t5438_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5438_Navy.jpg?v=1774526074",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5438_Navy.jpg?v=1774526074",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5438/ProductCarouselMain/T5438%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5438_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556161802",
      "product_title": "Tee Jays Heavy Sweatshirt",
      "product_handle": "t5429",
      "product_url": "/products/t5429",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t5429",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/30% polyester.",
      "style_code": "T5429",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49491170820362",
      "swatch_filename": "t5429_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5429_Navy.jpg?v=1774526132",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5429_Navy.jpg?v=1774526132",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5429/ProductCarouselMain/T5429%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5429_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555801354",
      "product_title": "Tee Jays Power Organic Sweatshirt",
      "product_handle": "t5100",
      "product_url": "/products/t5100",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-t5100",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% organic cotton/30% polyester.",
      "style_code": "T5100",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49491208864010",
      "swatch_filename": "t5100_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5100_Navy.jpg?v=1774526222",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5100_Navy.jpg?v=1774526222",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Tee%20Jays/T5100/ProductCarouselMain/T5100%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5100_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556358410",
      "product_title": "Tee Jays Ribbed Interlock Crew Neck Sweatshirt",
      "product_handle": "t5504",
      "product_url": "/products/t5504",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5504",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "T5504",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49491110297866",
      "swatch_filename": "t5504_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5504_Navy.jpg?v=1774526059",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5504_Navy.jpg?v=1774526059",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5504/ProductCarouselMain/T5504%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5504_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556391178",
      "product_title": "Tee Jays Ribbed Interlock Half Zip Sweatshirt",
      "product_handle": "t5506",
      "product_url": "/products/t5506",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "knitwear",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-t5506",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "T5506",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49491107217674",
      "swatch_filename": "t5506_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5506_Navy.jpg?v=1774526052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5506_Navy.jpg?v=1774526052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5506/ProductCarouselMain/T5506%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5506_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555866890",
      "product_title": "Tee Jays Unlabeled Sweatshirt",
      "product_handle": "t5150",
      "product_url": "/products/t5150",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-t5150",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% organic ringspun cotton/30% recycled polyester.",
      "style_code": "T5150",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#12294a",
      "sort_bucket": "blue",
      "sort_hue": 0.598214,
      "sort_sat": 0.756757,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49491203621130",
      "swatch_filename": "t5150_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5150_Navy.jpg?v=1774526211",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5150_Navy.jpg?v=1774526211",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5150/ProductCarouselMain/T5150%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5150_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "True Indigo",
      "colour_group": "Blue > Royal",
      "rgb": "#1b355c",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.706522,
      "sort_val": 0.360784,
      "swatch_file_id": "gid://shopify/MediaImage/49495364403466",
      "swatch_filename": "kb4025_True_Indigo.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_True_Indigo.jpg?v=1774542565",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_True_Indigo.jpg?v=1774542565",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20TRI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_True_Indigo.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963626762",
      "product_title": "Finden + Hales 1/4 Zip Tracksuit Top",
      "product_handle": "lv874",
      "product_url": "/products/lv874",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv874",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV874",
      "colour_name": "Navy/Royal Blue",
      "colour_group": "Blue > Navy",
      "rgb": "#0c184a;#0746d9",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49495585128714",
      "swatch_filename": "lv874_NavyRoyal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_NavyRoyal_Blue.jpg?v=1774542670",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_NavyRoyal_Blue.jpg?v=1774542670",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV874/ProductCarouselMain/LV874%20NV%252fRY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv874_NavyRoyal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963495690",
      "product_title": "Finden + Hales Contrast Zip Neck Midlayer Top",
      "product_handle": "lv571",
      "product_url": "/products/lv571",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-lv571",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester single jersey.",
      "style_code": "LV571",
      "colour_name": "Navy/Royal Blue",
      "colour_group": "Blue > Navy",
      "rgb": "#0c184a;#0746d9",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49495545577738",
      "swatch_filename": "lv571_NavyRoyal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv571_NavyRoyal_Blue.jpg?v=1774542653",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv571_NavyRoyal_Blue.jpg?v=1774542653",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV571/ProductCarouselMain/LV571%20NV%252fRY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv571_NavyRoyal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963725066",
      "product_title": "Finden + Hales Kids 1/4 Zip Tracksuit Top",
      "product_handle": "lv875",
      "product_url": "/products/lv875",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-lv875",
        "sweatshirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV875",
      "colour_name": "Navy/Royal Blue",
      "colour_group": "Blue > Navy",
      "rgb": "#0c184a;#0746d9",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49495625892106",
      "swatch_filename": "lv875_NavyRoyal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_NavyRoyal_Blue.jpg?v=1774542690",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_NavyRoyal_Blue.jpg?v=1774542690",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV875/ProductCarouselMain/LV875%20NV%252fRY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv875_NavyRoyal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963626762",
      "product_title": "Finden + Hales 1/4 Zip Tracksuit Top",
      "product_handle": "lv874",
      "product_url": "/products/lv874",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv874",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV874",
      "colour_name": "Navy/Sky blue",
      "colour_group": "Blue > Navy",
      "rgb": "#0c184a;#75cfff",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49495589093642",
      "swatch_filename": "lv874_NavySky_blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_NavySky_blue.jpg?v=1774542672",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_NavySky_blue.jpg?v=1774542672",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV874/ProductCarouselMain/LV874%20NV%252fSK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv874_NavySky_blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963725066",
      "product_title": "Finden + Hales Kids 1/4 Zip Tracksuit Top",
      "product_handle": "lv875",
      "product_url": "/products/lv875",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-lv875",
        "sweatshirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV875",
      "colour_name": "Navy/Sky blue",
      "colour_group": "Blue > Navy",
      "rgb": "#0c184a;#75cfff",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49495642538250",
      "swatch_filename": "lv875_NavySky_blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_NavySky_blue.jpg?v=1774542691",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_NavySky_blue.jpg?v=1774542691",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV875/ProductCarouselMain/LV875%20NV%252fSK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv875_NavySky_blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968836874",
      "product_title": "Pro RTX High Visibility Two Tone Sweatshirt",
      "product_handle": "rx730",
      "product_url": "/products/rx730",
      "product_full_url": "None",
      "vendor": "Pro RTX High Visibility",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-rx730",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "RX730",
      "colour_name": "Orange/Navy",
      "colour_group": "Orange > Orange",
      "rgb": "#ff5900;#001228",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49497057460490",
      "swatch_filename": "rx730_OrangeNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx730_OrangeNavy.jpg?v=1774543299",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx730_OrangeNavy.jpg?v=1774543299",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX%20High%20Visibility/Product%20Images/RX730/ProductCarouselMain/RX730%20OR%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx730_OrangeNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457967296778",
      "product_title": "Regatta High Visibility Pro 1/4 Zip Sweatshirt",
      "product_handle": "rg460",
      "product_url": "/products/rg460",
      "product_full_url": "None",
      "vendor": "Regatta High Visibility",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-rg460",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "RG460",
      "colour_name": "Orange/Navy",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff8000;#152038",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49496609882378",
      "swatch_filename": "rg460_OrangeNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg460_OrangeNavy.jpg?v=1774543111",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg460_OrangeNavy.jpg?v=1774543111",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Regatta%20High%20Visibility/Product%20Images/RG460/ProductCarouselMain/RG460%20OR%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rg460_OrangeNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457971294474",
      "product_title": "Yoko Hi-Vis Sweatshirt",
      "product_handle": "yk030",
      "product_url": "/products/yk030",
      "product_full_url": "None",
      "vendor": "YOKO",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "hi-vis",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "safetywear-ppe",
        "style-yk030",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "YK030",
      "colour_name": "Orange/Navy",
      "colour_group": "Orange > Fluro/Neon Orange",
      "rgb": "#ff4000;#000037",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49497662587146",
      "swatch_filename": "yk030_OrangeNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk030_OrangeNavy.jpg?v=1774543605",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk030_OrangeNavy.jpg?v=1774543605",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/YOKO/Product%20Images/YK030/ProductCarouselMain/YK030%20OR%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "yk030_OrangeNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968836874",
      "product_title": "Pro RTX High Visibility Two Tone Sweatshirt",
      "product_handle": "rx730",
      "product_url": "/products/rx730",
      "product_full_url": "None",
      "vendor": "Pro RTX High Visibility",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-rx730",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "RX730",
      "colour_name": "Yellow/Navy",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#ffff00;#001228",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49497057493258",
      "swatch_filename": "rx730_YellowNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx730_YellowNavy.jpg?v=1774543301",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx730_YellowNavy.jpg?v=1774543301",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX%20High%20Visibility/Product%20Images/RX730/ProductCarouselMain/RX730%20YL%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx730_YellowNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457967296778",
      "product_title": "Regatta High Visibility Pro 1/4 Zip Sweatshirt",
      "product_handle": "rg460",
      "product_url": "/products/rg460",
      "product_full_url": "None",
      "vendor": "Regatta High Visibility",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-rg460",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "RG460",
      "colour_name": "Yellow/Navy",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#f7ff38;#152038",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49496610144522",
      "swatch_filename": "rg460_YellowNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg460_YellowNavy.jpg?v=1774543112",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg460_YellowNavy.jpg?v=1774543112",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Regatta%20High%20Visibility/Product%20Images/RG460/ProductCarouselMain/RG460%20YL%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rg460_YellowNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457971294474",
      "product_title": "Yoko Hi-Vis Sweatshirt",
      "product_handle": "yk030",
      "product_url": "/products/yk030",
      "product_full_url": "None",
      "vendor": "YOKO",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "hi-vis",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "safetywear-ppe",
        "style-yk030",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "YK030",
      "colour_name": "Yellow/Navy",
      "colour_group": "Yellow > Fluro/Neon Yellow",
      "rgb": "#ffff00;#000037",
      "sort_bucket": "blue",
      "sort_hue": 0.6,
      "sort_sat": 0.5,
      "sort_val": 0.5,
      "swatch_file_id": "gid://shopify/MediaImage/49497663930634",
      "swatch_filename": "yk030_YellowNavy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk030_YellowNavy.jpg?v=1774543607",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk030_YellowNavy.jpg?v=1774543607",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/YOKO/Product%20Images/YK030/ProductCarouselMain/YK030%20YL%252fNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "yk030_YellowNavy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948225802",
      "product_title": "Anthem Organic Sweatshirt",
      "product_handle": "am20",
      "product_url": "/products/am20",
      "product_full_url": "None",
      "vendor": "Anthem",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-am20",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "AM20",
      "colour_name": "Light Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#9fb4d4",
      "sort_bucket": "blue",
      "sort_hue": 0.600629,
      "sort_sat": 0.25,
      "sort_val": 0.831373,
      "swatch_file_id": "gid://shopify/MediaImage/49494308094218",
      "swatch_filename": "am20_Light_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Light_Blue.jpg?v=1774540533",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Light_Blue.jpg?v=1774540533",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM20/ProductCarouselMain/AM20%20LBL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am20_Light_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944621322",
      "product_title": "NEOBLU Nelson French Terry Sweatshirt",
      "product_handle": "03194",
      "product_url": "/products/03194",
      "product_full_url": "None",
      "vendor": "NEOBLU",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-03194",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% combed cotton/15% polyester.",
      "style_code": "03194",
      "colour_name": "Night Blue",
      "colour_group": "Blue > Dark Blue",
      "rgb": "#151d2a",
      "sort_bucket": "blue",
      "sort_hue": 0.603175,
      "sort_sat": 0.5,
      "sort_val": 0.164706,
      "swatch_file_id": "gid://shopify/MediaImage/49494217687306",
      "swatch_filename": "03194_Night_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03194_Night_Blue.jpg?v=1774540189",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03194_Night_Blue.jpg?v=1774540189",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/NEOBLU/Product%20Images/03194/ProductCarouselMain/03194%20NGT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03194_Night_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457967231242",
      "product_title": "Regatta Core Stretch Half Zip Midlayer Top",
      "product_handle": "rg441",
      "product_url": "/products/rg441",
      "product_full_url": "None",
      "vendor": "Regatta Professional",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "security",
        "style-rg441",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "95% recycled polyester/5% elastane.",
      "style_code": "RG441",
      "colour_name": "Seal Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#2c3647",
      "sort_bucket": "blue",
      "sort_hue": 0.604938,
      "sort_sat": 0.380282,
      "sort_val": 0.278431,
      "swatch_file_id": "gid://shopify/MediaImage/49496601493770",
      "swatch_filename": "rg441_Seal_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg441_Seal_Grey.jpg?v=1774543105",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg441_Seal_Grey.jpg?v=1774543105",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Regatta%20Professional/Product%20Images/RG441/ProductCarouselMain/RG441%20SEG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rg441_Seal_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "03814",
      "colour_name": "Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#527ac3",
      "sort_bucket": "blue",
      "sort_hue": 0.60767,
      "sort_sat": 0.579487,
      "sort_val": 0.764706,
      "swatch_file_id": "gid://shopify/MediaImage/49494225256714",
      "swatch_filename": "03814_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Blue.jpg?v=1774540256",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Blue.jpg?v=1774540256",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03814/ProductCarouselMain/03814%20BLU%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944686858",
      "product_title": "SOL'S Unisex Space Organic Raglan Sweatshirt",
      "product_handle": "03567",
      "product_url": "/products/03567",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03567",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "03567",
      "colour_name": "Blue",
      "colour_group": "Blue > Light Blue",
      "rgb": "#527ac3",
      "sort_bucket": "blue",
      "sort_hue": 0.60767,
      "sort_sat": 0.579487,
      "sort_val": 0.764706,
      "swatch_file_id": "gid://shopify/MediaImage/49494219129098",
      "swatch_filename": "03567_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Blue.jpg?v=1774540210",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Blue.jpg?v=1774540210",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03567/ProductCarouselMain/03567%20BLU%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03567_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970311434",
      "product_title": "Fruit of the Loom Classic Drop Shoulder Sweatshirt",
      "product_handle": "ss9",
      "product_url": "/products/ss9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS9",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#002466",
      "sort_bucket": "blue",
      "sort_hue": 0.607843,
      "sort_sat": 1.0,
      "sort_val": 0.4,
      "swatch_file_id": "gid://shopify/MediaImage/49497485738250",
      "swatch_filename": "ss9_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Navy.jpg?v=1774543507",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Navy.jpg?v=1774543507",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS9/ProductCarouselMain/SS9%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss9_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970213130",
      "product_title": "Fruit of the Loom Classic Raglan Sweatshirt",
      "product_handle": "ss8",
      "product_url": "/products/ss8",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss8",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS8",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#002466",
      "sort_bucket": "blue",
      "sort_hue": 0.607843,
      "sort_sat": 1.0,
      "sort_val": 0.4,
      "swatch_file_id": "gid://shopify/MediaImage/49497416761610",
      "swatch_filename": "ss8_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Navy.jpg?v=1774543476",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Navy.jpg?v=1774543476",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS8/ProductCarouselMain/SS8%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss8_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963200778",
      "product_title": "Kariban Crew Neck Sweatshirt",
      "product_handle": "kb488",
      "product_url": "/products/kb488",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb488",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "KB488",
      "colour_name": "Light Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#235cc6",
      "sort_bucket": "blue",
      "sort_hue": 0.608384,
      "sort_sat": 0.823232,
      "sort_val": 0.776471,
      "swatch_file_id": "gid://shopify/MediaImage/49495513858314",
      "swatch_filename": "kb488_Light_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb488_Light_Royal_Blue.jpg?v=1774542625",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb488_Light_Royal_Blue.jpg?v=1774542625",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB488/ProductCarouselMain/KB488%20LRY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb488_Light_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963135242",
      "product_title": "Kariban Zip Neck Sweatshirt",
      "product_handle": "kb487",
      "product_url": "/products/kb487",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb487",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "KB487",
      "colour_name": "Light Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#235cc6",
      "sort_bucket": "blue",
      "sort_hue": 0.608384,
      "sort_sat": 0.823232,
      "sort_val": 0.776471,
      "swatch_file_id": "gid://shopify/MediaImage/49495496294666",
      "swatch_filename": "kb487_Light_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb487_Light_Royal_Blue.jpg?v=1774542610",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb487_Light_Royal_Blue.jpg?v=1774542610",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB487/ProductCarouselMain/KB487%20LRY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb487_Light_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962971402",
      "product_title": "Kariban Crew Neck Sweatshirt",
      "product_handle": "kb442",
      "product_url": "/products/kb442",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-kb442",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed cotton/20% polyester.",
      "style_code": "KB442",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#1d428a",
      "sort_bucket": "blue",
      "sort_hue": 0.610092,
      "sort_sat": 0.789855,
      "sort_val": 0.541176,
      "swatch_file_id": "gid://shopify/MediaImage/49495431184650",
      "swatch_filename": "kb442_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb442_Royal_Blue.jpg?v=1774542586",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb442_Royal_Blue.jpg?v=1774542586",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB442/ProductCarouselMain/KB442%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb442_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944391946",
      "product_title": "SOL'S Stan Contrast Zip Neck Sweatshirt",
      "product_handle": "02088",
      "product_url": "/products/02088",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-02088",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "02088",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49494215262474",
      "swatch_filename": "02088_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02088_French_Navy.jpg?v=1774540164",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02088_French_Navy.jpg?v=1774540164",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02088/ProductCarouselMain/02088%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02088_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "03814",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49494225322250",
      "swatch_filename": "03814_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_French_Navy.jpg?v=1774540258",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_French_Navy.jpg?v=1774540258",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03814/ProductCarouselMain/03814%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944785162",
      "product_title": "SOL'S Unisex Comet Organic Sweatshirt",
      "product_handle": "03574",
      "product_url": "/products/03574",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03574",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "03574",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49494220079370",
      "swatch_filename": "03574_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03574_French_Navy.jpg?v=1774540226",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03574_French_Navy.jpg?v=1774540226",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03574/ProductCarouselMain/03574%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03574_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457945178378",
      "product_title": "SOL'S Unisex Conrad 1/4 Zip Sweatshirt",
      "product_handle": "04234",
      "product_url": "/products/04234",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-04234",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "04234",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49494279651594",
      "swatch_filename": "04234_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04234_French_Navy.jpg?v=1774540275",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04234_French_Navy.jpg?v=1774540275",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04234/ProductCarouselMain/04234%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04234_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457945440522",
      "product_title": "SOL'S Unisex Cooper Full Zip Sweat Jacket",
      "product_handle": "04240",
      "product_url": "/products/04240",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "jackets",
        "L",
        "M",
        "S",
        "style-04240",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "04240",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49494280503562",
      "swatch_filename": "04240_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04240_French_Navy.jpg?v=1774540287",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04240_French_Navy.jpg?v=1774540287",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04240/ProductCarouselMain/04240%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04240_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944686858",
      "product_title": "SOL'S Unisex Space Organic Raglan Sweatshirt",
      "product_handle": "03567",
      "product_url": "/products/03567",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03567",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "03567",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49494219292938",
      "swatch_filename": "03567_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_French_Navy.jpg?v=1774540211",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_French_Navy.jpg?v=1774540211",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03567/ProductCarouselMain/03567%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03567_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944490250",
      "product_title": "SOL'S Unisex Sully Sweatshirt",
      "product_handle": "02990",
      "product_url": "/products/02990",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-02990",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "02990",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#101e3e",
      "sort_bucket": "blue",
      "sort_hue": 0.615942,
      "sort_sat": 0.741935,
      "sort_val": 0.243137,
      "swatch_file_id": "gid://shopify/MediaImage/49494216933642",
      "swatch_filename": "02990_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02990_French_Navy.jpg?v=1774540179",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02990_French_Navy.jpg?v=1774540179",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02990/ProductCarouselMain/02990%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02990_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Fan Deep Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#1c3775",
      "sort_bucket": "blue",
      "sort_hue": 0.616105,
      "sort_sat": 0.760684,
      "sort_val": 0.458824,
      "swatch_file_id": "gid://shopify/MediaImage/49494475669770",
      "swatch_filename": "gd56_Fan_Deep_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Fan_Deep_Royal.jpg?v=1774541918",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Fan_Deep_Royal.jpg?v=1774541918",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20FDPR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Fan_Deep_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946521866",
      "product_title": "Russell Athletic Authentic Sweat Jacket",
      "product_handle": "267m",
      "product_url": "/products/267m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "jackets",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-267m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun combed cotton/20% polyester.",
      "style_code": "267M",
      "colour_name": "Bright Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#0049f2",
      "sort_bucket": "blue",
      "sort_hue": 0.616391,
      "sort_sat": 1.0,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49494290137354",
      "swatch_filename": "267m_Bright_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/267m_Bright_Royal.jpg?v=1774540378",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/267m_Bright_Royal.jpg?v=1774540378",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/267M/ProductCarouselMain/267M%20BRO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "267m_Bright_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "Bright Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#0049f2",
      "sort_bucket": "blue",
      "sort_hue": 0.616391,
      "sort_sat": 1.0,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49494288859402",
      "swatch_filename": "262m_Bright_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Bright_Royal.jpg?v=1774540355",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Bright_Royal.jpg?v=1774540355",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20BRO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_Bright_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947308298",
      "product_title": "Russell Athletic Kids Raglan Sweatshirt",
      "product_handle": "762b",
      "product_url": "/products/762b",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "performance-activewear",
        "sports",
        "style-762b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762B",
      "colour_name": "Bright Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#0049f2",
      "sort_bucket": "blue",
      "sort_hue": 0.616391,
      "sort_sat": 1.0,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49494299574538",
      "swatch_filename": "762b_Bright_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Bright_Royal.jpg?v=1774540436",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Bright_Royal.jpg?v=1774540436",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762B/ProductCarouselMain/762B%20BRO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762b_Bright_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947472138",
      "product_title": "Russell Athletic Raglan Sweatshirt",
      "product_handle": "762m",
      "product_url": "/products/762m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-762m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762M",
      "colour_name": "Bright Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#0049f2",
      "sort_bucket": "blue",
      "sort_hue": 0.616391,
      "sort_sat": 1.0,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49494300885258",
      "swatch_filename": "762m_Bright_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762m_Bright_Royal.jpg?v=1774540452",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762m_Bright_Royal.jpg?v=1774540452",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762M/ProductCarouselMain/762M%20BRO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762m_Bright_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970311434",
      "product_title": "Fruit of the Loom Classic Drop Shoulder Sweatshirt",
      "product_handle": "ss9",
      "product_url": "/products/ss9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS9",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497485771018",
      "swatch_filename": "ss9_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Royal_Blue.jpg?v=1774543508",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Royal_Blue.jpg?v=1774543508",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS9/ProductCarouselMain/SS9%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss9_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970213130",
      "product_title": "Fruit of the Loom Classic Raglan Sweatshirt",
      "product_handle": "ss8",
      "product_url": "/products/ss8",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss8",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS8",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497417253130",
      "swatch_filename": "ss8_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Royal_Blue.jpg?v=1774543477",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Royal_Blue.jpg?v=1774543477",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS8/ProductCarouselMain/SS8%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss8_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969819914",
      "product_title": "Fruit of the Loom Iconic Premium Set-In Sweatshirt",
      "product_handle": "ss151",
      "product_url": "/products/ss151",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss151",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS151",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497264783626",
      "swatch_filename": "ss151_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_Royal_Blue.jpg?v=1774543408",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_Royal_Blue.jpg?v=1774543408",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS151/ProductCarouselMain/SS151%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss151_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969885450",
      "product_title": "Fruit of the Loom Iconic Premium Zip Neck Sweatshirt",
      "product_handle": "ss154",
      "product_url": "/products/ss154",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss154",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS154",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497294274826",
      "swatch_filename": "ss154_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss154_Royal_Blue.jpg?v=1774543422",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss154_Royal_Blue.jpg?v=1774543422",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS154/ProductCarouselMain/SS154%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss154_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969557770",
      "product_title": "Fruit of the Loom Lightweight Raglan Sweatshirt",
      "product_handle": "ss120",
      "product_url": "/products/ss120",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-ss120",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "SS120",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497183060234",
      "swatch_filename": "ss120_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss120_Royal_Blue.jpg?v=1774543368",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss120_Royal_Blue.jpg?v=1774543368",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Fruit%20of%20the%20Loom/SS120/ProductCarouselMain/SS120%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss120_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970508042",
      "product_title": "Fruit of the Loom Premium Drop Shoulder Sweatshirt",
      "product_handle": "sse9",
      "product_url": "/products/sse9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-sse9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE9",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497537937674",
      "swatch_filename": "sse9_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse9_Royal_Blue.jpg?v=1774543538",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse9_Royal_Blue.jpg?v=1774543538",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Fruit%20of%20the%20Loom/SSE9/ProductCarouselMain/SSE9%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse9_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970409738",
      "product_title": "Fruit of the Loom Premium Zip Neck Sweatshirt",
      "product_handle": "sse17",
      "product_url": "/products/sse17",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-sse17",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE17",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#175cff",
      "sort_bucket": "blue",
      "sort_hue": 0.617098,
      "sort_sat": 0.909804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497531908362",
      "swatch_filename": "sse17_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse17_Royal_Blue.jpg?v=1774543524",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse17_Royal_Blue.jpg?v=1774543524",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SSE17/ProductCarouselMain/SSE17%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse17_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970311434",
      "product_title": "Fruit of the Loom Classic Drop Shoulder Sweatshirt",
      "product_handle": "ss9",
      "product_url": "/products/ss9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS9",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49497485803786",
      "swatch_filename": "ss9_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Deep_Navy.jpg?v=1774543509",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Deep_Navy.jpg?v=1774543509",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS9/ProductCarouselMain/SS9%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss9_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970213130",
      "product_title": "Fruit of the Loom Classic Raglan Sweatshirt",
      "product_handle": "ss8",
      "product_url": "/products/ss8",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss8",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS8",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49497429377290",
      "swatch_filename": "ss8_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Deep_Navy.jpg?v=1774543479",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Deep_Navy.jpg?v=1774543479",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS8/ProductCarouselMain/SS8%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss8_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970082058",
      "product_title": "Fruit of the Loom Classic Zip Neck Sweatshirt",
      "product_handle": "ss17",
      "product_url": "/products/ss17",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss17",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "SS17",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49497331532042",
      "swatch_filename": "ss17_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss17_Deep_Navy.jpg?v=1774543444",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss17_Deep_Navy.jpg?v=1774543444",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS17/ProductCarouselMain/SS17%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss17_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969819914",
      "product_title": "Fruit of the Loom Iconic Premium Set-In Sweatshirt",
      "product_handle": "ss151",
      "product_url": "/products/ss151",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss151",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS151",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49497264816394",
      "swatch_filename": "ss151_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_Deep_Navy.jpg?v=1774543409",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_Deep_Navy.jpg?v=1774543409",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS151/ProductCarouselMain/SS151%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss151_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969983754",
      "product_title": "Fruit of the Loom Iconic Premium Sweat Jacket",
      "product_handle": "ss155",
      "product_url": "/products/ss155",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "jackets",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss155",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS155",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49497311281418",
      "swatch_filename": "ss155_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss155_Deep_Navy.jpg?v=1774543437",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss155_Deep_Navy.jpg?v=1774543437",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS155/ProductCarouselMain/SS155%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss155_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969885450",
      "product_title": "Fruit of the Loom Iconic Premium Zip Neck Sweatshirt",
      "product_handle": "ss154",
      "product_url": "/products/ss154",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss154",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS154",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49497294504202",
      "swatch_filename": "ss154_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss154_Deep_Navy.jpg?v=1774543424",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss154_Deep_Navy.jpg?v=1774543424",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS154/ProductCarouselMain/SS154%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss154_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970180362",
      "product_title": "Fruit of the Loom Lady Fit Lightweight Raglan Sweatshirt",
      "product_handle": "ss180",
      "product_url": "/products/ss180",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "lightweight",
        "S",
        "style-ss180",
        "sweatshirts",
        "womens",
        "XS",
        "XS-S-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "SS180",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49497354076426",
      "swatch_filename": "ss180_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss180_Deep_Navy.jpg?v=1774543453",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss180_Deep_Navy.jpg?v=1774543453",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Fruit%20of%20the%20Loom/SS180/ProductCarouselMain/SS180%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss180_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969623306",
      "product_title": "Fruit of the Loom Lightweight Drop Shoulder Sweatshirt",
      "product_handle": "ss123",
      "product_url": "/products/ss123",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-ss123",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "SS123",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49497202426122",
      "swatch_filename": "ss123_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss123_Deep_Navy.jpg?v=1774543379",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss123_Deep_Navy.jpg?v=1774543379",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Fruit%20of%20the%20Loom/SS123/ProductCarouselMain/SS123%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss123_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969557770",
      "product_title": "Fruit of the Loom Lightweight Raglan Sweatshirt",
      "product_handle": "ss120",
      "product_url": "/products/ss120",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-ss120",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "SS120",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49497183093002",
      "swatch_filename": "ss120_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss120_Deep_Navy.jpg?v=1774543370",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss120_Deep_Navy.jpg?v=1774543370",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS120/ProductCarouselMain/SS120%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss120_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970508042",
      "product_title": "Fruit of the Loom Premium Drop Shoulder Sweatshirt",
      "product_handle": "sse9",
      "product_url": "/products/sse9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-sse9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE9",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49497537970442",
      "swatch_filename": "sse9_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse9_Deep_Navy.jpg?v=1774543539",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse9_Deep_Navy.jpg?v=1774543539",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SSE9/ProductCarouselMain/SSE9%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse9_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970606346",
      "product_title": "Fruit of the Loom Premium Sweat Jacket",
      "product_handle": "sse92",
      "product_url": "/products/sse92",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "jackets",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-sse92",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE92",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49497549340938",
      "swatch_filename": "sse92_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse92_Deep_Navy.jpg?v=1774543550",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse92_Deep_Navy.jpg?v=1774543550",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SSE92/ProductCarouselMain/SSE92%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse92_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970409738",
      "product_title": "Fruit of the Loom Premium Zip Neck Sweatshirt",
      "product_handle": "sse17",
      "product_url": "/products/sse17",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-sse17",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE17",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49497532268810",
      "swatch_filename": "sse17_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse17_Deep_Navy.jpg?v=1774543526",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse17_Deep_Navy.jpg?v=1774543526",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SSE17/ProductCarouselMain/SSE17%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse17_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969721610",
      "product_title": "Fruit of the Loom Supercotton™ Sweatshirt",
      "product_handle": "ss141",
      "product_url": "/products/ss141",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss141",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS141",
      "colour_name": "Deep Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000f33",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 1.0,
      "sort_val": 0.2,
      "swatch_file_id": "gid://shopify/MediaImage/49497239879946",
      "swatch_filename": "ss141_Deep_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss141_Deep_Navy.jpg?v=1774543391",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss141_Deep_Navy.jpg?v=1774543391",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS141/ProductCarouselMain/SS141%20DNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss141_Deep_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457957990666",
      "product_title": "Gildan DryBlend® Sweatshirt",
      "product_handle": "gd52",
      "product_url": "/products/gd52",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd52",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD52",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49494473277706",
      "swatch_filename": "gd52_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd52_Navy.jpg?v=1774541874",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd52_Navy.jpg?v=1774541874",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD52/ProductCarouselMain/GD52%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd52_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49494475702538",
      "swatch_filename": "gd56_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Navy.jpg?v=1774541919",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Navy.jpg?v=1774541919",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49494481371402",
      "swatch_filename": "gd67_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Navy.jpg?v=1774542038",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Navy.jpg?v=1774542038",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958187274",
      "product_title": "Gildan SoftStyle® Midweight Fleece 1/4 Zip Sweatshirt",
      "product_handle": "gd612",
      "product_url": "/products/gd612",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd612",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD612",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49494476947722",
      "swatch_filename": "gd612_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Navy.jpg?v=1774541946",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Navy.jpg?v=1774541946",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD612/ProductCarouselMain/GD612%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd612_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Oxford Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49494914269450",
      "swatch_filename": "jh030b_Oxford_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Oxford_Navy.jpg?v=1774542355",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Oxford_Navy.jpg?v=1774542355",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20OXN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Oxford_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Oxford Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041848",
      "sort_bucket": "blue",
      "sort_hue": 0.617647,
      "sort_sat": 0.944444,
      "sort_val": 0.282353,
      "swatch_file_id": "gid://shopify/MediaImage/49494780543242",
      "swatch_filename": "jh030_Oxford_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Oxford_Navy.jpg?v=1774542278",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Oxford_Navy.jpg?v=1774542278",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20OXN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Oxford_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968705802",
      "product_title": "Pro RTX Pro 1/4 Neck Zip Sweatshirt",
      "product_handle": "rx305",
      "product_url": "/products/rx305",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx305",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX305",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041745",
      "sort_bucket": "blue",
      "sort_hue": 0.617949,
      "sort_sat": 0.942029,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49496996282634",
      "swatch_filename": "rx305_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx305_Navy.jpg?v=1774543288",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx305_Navy.jpg?v=1774543288",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX305/ProductCarouselMain/RX305%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx305_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968738570",
      "product_title": "Pro RTX Pro Full Zip Sweatshirt",
      "product_handle": "rx310",
      "product_url": "/products/rx310",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-rx310",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX310",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041745",
      "sort_bucket": "blue",
      "sort_hue": 0.617949,
      "sort_sat": 0.942029,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49497051660554",
      "swatch_filename": "rx310_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx310_Navy.jpg?v=1774543295",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx310_Navy.jpg?v=1774543295",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX310/ProductCarouselMain/RX310%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx310_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#041745",
      "sort_bucket": "blue",
      "sort_hue": 0.617949,
      "sort_sat": 0.942029,
      "sort_val": 0.270588,
      "swatch_file_id": "gid://shopify/MediaImage/49496984092938",
      "swatch_filename": "rx301_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Navy.jpg?v=1774543271",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Navy.jpg?v=1774543271",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963790602",
      "product_title": "Mantis Unisex Essential Sweatshirt",
      "product_handle": "m05",
      "product_url": "/products/m05",
      "product_full_url": "None",
      "vendor": "Mantis",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-m05",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "80% organic cotton/20% recycled polyester.",
      "style_code": "M05",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#222f50",
      "sort_bucket": "blue",
      "sort_hue": 0.619565,
      "sort_sat": 0.575,
      "sort_val": 0.313725,
      "swatch_file_id": "gid://shopify/MediaImage/49495666917642",
      "swatch_filename": "m05_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m05_Navy.jpg?v=1774542704",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m05_Navy.jpg?v=1774542704",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Mantis/M05/ProductCarouselMain/M05%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "m05_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#0039cc",
      "sort_bucket": "blue",
      "sort_hue": 0.620098,
      "sort_sat": 1.0,
      "sort_val": 0.8,
      "swatch_file_id": "gid://shopify/MediaImage/49496984191242",
      "swatch_filename": "rx301_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Royal_Blue.jpg?v=1774543273",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Royal_Blue.jpg?v=1774543273",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948160266",
      "product_title": "AWDis Academy Kids V Neck Sweatshirt",
      "product_handle": "ac003b",
      "product_url": "/products/ac003b",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-ac003b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC003B",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#0d4fff",
      "sort_bucket": "blue",
      "sort_hue": 0.621212,
      "sort_sat": 0.94902,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494305997066",
      "swatch_filename": "ac003b_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003b_Royal_Blue.jpg?v=1774540517",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003b_Royal_Blue.jpg?v=1774540517",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC003B/ProductCarouselMain/AC003B%20ARO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac003b_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947898122",
      "product_title": "AWDis Academy Senior Raglan Sweatshirt",
      "product_handle": "ac001",
      "product_url": "/products/ac001",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ac001",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC001",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#0d4fff",
      "sort_bucket": "blue",
      "sort_hue": 0.621212,
      "sort_sat": 0.94902,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494303768842",
      "swatch_filename": "ac001_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Royal_Blue.jpg?v=1774540494",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Royal_Blue.jpg?v=1774540494",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC001/ProductCarouselMain/AC001%20ARO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac001_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948160266",
      "product_title": "AWDis Academy Kids V Neck Sweatshirt",
      "product_handle": "ac003b",
      "product_url": "/products/ac003b",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-ac003b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC003B",
      "colour_name": "Deep Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#003ee6",
      "sort_bucket": "blue",
      "sort_hue": 0.621739,
      "sort_sat": 1.0,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49494306226442",
      "swatch_filename": "ac003b_Deep_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003b_Deep_Royal.jpg?v=1774540519",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003b_Deep_Royal.jpg?v=1774540519",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC003B/ProductCarouselMain/AC003B%20ADR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac003b_Deep_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947898122",
      "product_title": "AWDis Academy Senior Raglan Sweatshirt",
      "product_handle": "ac001",
      "product_url": "/products/ac001",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ac001",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC001",
      "colour_name": "Deep Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#003ee6",
      "sort_bucket": "blue",
      "sort_hue": 0.621739,
      "sort_sat": 1.0,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49494303834378",
      "swatch_filename": "ac001_Deep_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Deep_Royal.jpg?v=1774540495",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Deep_Royal.jpg?v=1774540495",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC001/ProductCarouselMain/AC001%20ADR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac001_Deep_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457957990666",
      "product_title": "Gildan DryBlend® Sweatshirt",
      "product_handle": "gd52",
      "product_url": "/products/gd52",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd52",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD52",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003ee6",
      "sort_bucket": "blue",
      "sort_hue": 0.621739,
      "sort_sat": 1.0,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49494473310474",
      "swatch_filename": "gd52_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd52_Royal_Blue.jpg?v=1774541876",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd52_Royal_Blue.jpg?v=1774541876",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD52/ProductCarouselMain/GD52%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd52_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003ee6",
      "sort_bucket": "blue",
      "sort_hue": 0.621739,
      "sort_sat": 1.0,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49494475768074",
      "swatch_filename": "gd56_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Royal_Blue.jpg?v=1774541921",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Royal_Blue.jpg?v=1774541921",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003ee6",
      "sort_bucket": "blue",
      "sort_hue": 0.621739,
      "sort_sat": 1.0,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49494481436938",
      "swatch_filename": "gd67_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Royal_Blue.jpg?v=1774542039",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Royal_Blue.jpg?v=1774542039",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958187274",
      "product_title": "Gildan SoftStyle® Midweight Fleece 1/4 Zip Sweatshirt",
      "product_handle": "gd612",
      "product_url": "/products/gd612",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd612",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD612",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003ee6",
      "sort_bucket": "blue",
      "sort_hue": 0.621739,
      "sort_sat": 1.0,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49494476980490",
      "swatch_filename": "gd612_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Royal_Blue.jpg?v=1774541948",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Royal_Blue.jpg?v=1774541948",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD612/ProductCarouselMain/GD612%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd612_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0",
      "sort_bucket": "blue",
      "sort_hue": 0.625,
      "sort_sat": 1.0,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49494914302218",
      "swatch_filename": "jh030b_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Royal_Blue.jpg?v=1774542357",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Royal_Blue.jpg?v=1774542357",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0",
      "sort_bucket": "blue",
      "sort_hue": 0.625,
      "sort_sat": 1.0,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49494781362442",
      "swatch_filename": "jh030_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Royal_Blue.jpg?v=1774542279",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Royal_Blue.jpg?v=1774542279",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961398538",
      "product_title": "AWDis Unisex Organic Sweatshirt",
      "product_handle": "jh230",
      "product_url": "/products/jh230",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-jh230",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "JH230",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#003cf0",
      "sort_bucket": "blue",
      "sort_hue": 0.625,
      "sort_sat": 1.0,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49495130145034",
      "swatch_filename": "jh230_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_Royal_Blue.jpg?v=1774542461",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_Royal_Blue.jpg?v=1774542461",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH230/ProductCarouselMain/JH230%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh230_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964282122",
      "product_title": "Native Spirit Unisex Terry 280 Oversized Sweatshirt",
      "product_handle": "ns415",
      "product_url": "/products/ns415",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns415",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS415",
      "colour_name": "Washed Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1d2b57",
      "sort_bucket": "blue",
      "sort_hue": 0.626437,
      "sort_sat": 0.666667,
      "sort_val": 0.341176,
      "swatch_file_id": "gid://shopify/MediaImage/49495838785802",
      "swatch_filename": "ns415_Washed_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns415_Washed_Navy.jpg?v=1774542775",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns415_Washed_Navy.jpg?v=1774542775",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Native%20Spirit/NS415/ProductCarouselMain/NS415%20WNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns415_Washed_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964183818",
      "product_title": "Native Spirit Unisex Terry 280 Sweatshirt",
      "product_handle": "ns414",
      "product_url": "/products/ns414",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns414",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS414",
      "colour_name": "Washed Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1d2b57",
      "sort_bucket": "blue",
      "sort_hue": 0.626437,
      "sort_sat": 0.666667,
      "sort_val": 0.341176,
      "swatch_file_id": "gid://shopify/MediaImage/49495825056010",
      "swatch_filename": "ns414_Washed_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns414_Washed_Navy.jpg?v=1774542764",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns414_Washed_Navy.jpg?v=1774542764",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Native%20Spirit/NS414/ProductCarouselMain/NS414%20WNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns414_Washed_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964740874",
      "product_title": "Native Spirit Unisex Washed Effect Oversize Sweatshirt",
      "product_handle": "ns447",
      "product_url": "/products/ns447",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "style-ns447",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic combed cotton.",
      "style_code": "NS447",
      "colour_name": "Washed Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1d2b57",
      "sort_bucket": "blue",
      "sort_hue": 0.626437,
      "sort_sat": 0.666667,
      "sort_val": 0.341176,
      "swatch_file_id": "gid://shopify/MediaImage/49495947673866",
      "swatch_filename": "ns447_Washed_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns447_Washed_Navy.jpg?v=1774542837",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns447_Washed_Navy.jpg?v=1774542837",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Native%20Spirit/NS447/ProductCarouselMain/NS447%20WNV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns447_Washed_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944391946",
      "product_title": "SOL'S Stan Contrast Zip Neck Sweatshirt",
      "product_handle": "02088",
      "product_url": "/products/02088",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-02088",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "02088",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494215426314",
      "swatch_filename": "02088_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02088_Royal_Blue.jpg?v=1774540165",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02088_Royal_Blue.jpg?v=1774540165",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/02088/ProductCarouselMain/02088%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02088_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "03814",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494225944842",
      "swatch_filename": "03814_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Royal_Blue.jpg?v=1774540259",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Royal_Blue.jpg?v=1774540259",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SOL%27S/03814/ProductCarouselMain/03814%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944785162",
      "product_title": "SOL'S Unisex Comet Organic Sweatshirt",
      "product_handle": "03574",
      "product_url": "/products/03574",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03574",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "03574",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494220144906",
      "swatch_filename": "03574_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03574_Royal_Blue.jpg?v=1774540227",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03574_Royal_Blue.jpg?v=1774540227",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03574/ProductCarouselMain/03574%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03574_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457945178378",
      "product_title": "SOL'S Unisex Conrad 1/4 Zip Sweatshirt",
      "product_handle": "04234",
      "product_url": "/products/04234",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-04234",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "04234",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494279749898",
      "swatch_filename": "04234_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04234_Royal_Blue.jpg?v=1774540276",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04234_Royal_Blue.jpg?v=1774540276",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04234/ProductCarouselMain/04234%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04234_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457945440522",
      "product_title": "SOL'S Unisex Cooper Full Zip Sweat Jacket",
      "product_handle": "04240",
      "product_url": "/products/04240",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "jackets",
        "L",
        "M",
        "S",
        "style-04240",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "04240",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494280569098",
      "swatch_filename": "04240_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04240_Royal_Blue.jpg?v=1774540288",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/04240_Royal_Blue.jpg?v=1774540288",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/04240/ProductCarouselMain/04240%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "04240_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946259722",
      "product_title": "SOL'S Unisex New Supreme Sweatshirt",
      "product_handle": "13250",
      "product_url": "/products/13250",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-13250",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "13250",
      "colour_name": "Royal Blue",
      "colour_group": "Blue > Royal",
      "rgb": "#002399",
      "sort_bucket": "blue",
      "sort_hue": 0.62854,
      "sort_sat": 1.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494284992778",
      "swatch_filename": "13250_Royal_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_Royal_Blue.jpg?v=1774540329",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_Royal_Blue.jpg?v=1774540329",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/13250/ProductCarouselMain/13250%20ROY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "13250_Royal_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946521866",
      "product_title": "Russell Athletic Authentic Sweat Jacket",
      "product_handle": "267m",
      "product_url": "/products/267m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "jackets",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-267m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun combed cotton/20% polyester.",
      "style_code": "267M",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#00114b",
      "sort_bucket": "blue",
      "sort_hue": 0.628889,
      "sort_sat": 1.0,
      "sort_val": 0.294118,
      "swatch_file_id": "gid://shopify/MediaImage/49494290202890",
      "swatch_filename": "267m_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/267m_French_Navy.jpg?v=1774540380",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/267m_French_Navy.jpg?v=1774540380",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/267M/ProductCarouselMain/267M%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "267m_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#00114b",
      "sort_bucket": "blue",
      "sort_hue": 0.628889,
      "sort_sat": 1.0,
      "sort_val": 0.294118,
      "swatch_file_id": "gid://shopify/MediaImage/49494288990474",
      "swatch_filename": "262m_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_French_Navy.jpg?v=1774540356",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_French_Navy.jpg?v=1774540356",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946587402",
      "product_title": "Russell Athletic Authentic Zip Neck Sweatshirt",
      "product_handle": "270m",
      "product_url": "/products/270m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-270m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "270M",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#00114b",
      "sort_bucket": "blue",
      "sort_hue": 0.628889,
      "sort_sat": 1.0,
      "sort_val": 0.294118,
      "swatch_file_id": "gid://shopify/MediaImage/49494294233354",
      "swatch_filename": "270m_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/270m_French_Navy.jpg?v=1774540392",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/270m_French_Navy.jpg?v=1774540392",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/270M/ProductCarouselMain/270M%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "270m_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947308298",
      "product_title": "Russell Athletic Kids Raglan Sweatshirt",
      "product_handle": "762b",
      "product_url": "/products/762b",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "performance-activewear",
        "sports",
        "style-762b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762B",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#00114b",
      "sort_bucket": "blue",
      "sort_hue": 0.628889,
      "sort_sat": 1.0,
      "sort_val": 0.294118,
      "swatch_file_id": "gid://shopify/MediaImage/49494299640074",
      "swatch_filename": "762b_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_French_Navy.jpg?v=1774540437",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_French_Navy.jpg?v=1774540437",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762B/ProductCarouselMain/762B%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762b_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947472138",
      "product_title": "Russell Athletic Raglan Sweatshirt",
      "product_handle": "762m",
      "product_url": "/products/762m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-762m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762M",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#00114b",
      "sort_bucket": "blue",
      "sort_hue": 0.628889,
      "sort_sat": 1.0,
      "sort_val": 0.294118,
      "swatch_file_id": "gid://shopify/MediaImage/49494301180170",
      "swatch_filename": "762m_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762m_French_Navy.jpg?v=1774540454",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762m_French_Navy.jpg?v=1774540454",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762M/ProductCarouselMain/762M%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762m_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961758986",
      "product_title": "Kustom Kit Klassic Sweatshirt",
      "product_handle": "k302",
      "product_url": "/products/k302",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k302",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton.",
      "style_code": "K302",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001a75",
      "sort_bucket": "blue",
      "sort_hue": 0.62963,
      "sort_sat": 1.0,
      "sort_val": 0.458824,
      "swatch_file_id": "gid://shopify/MediaImage/49495178445066",
      "swatch_filename": "k302_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k302_Navy.jpg?v=1774542484",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k302_Navy.jpg?v=1774542484",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K302/ProductCarouselMain/K302%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k302_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962184970",
      "product_title": "Kustom Kit Regular Fit 1/4 Zip Piqué Sweatshirt",
      "product_handle": "k339",
      "product_url": "/products/k339",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-k339",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "K339",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001a75",
      "sort_bucket": "blue",
      "sort_hue": 0.62963,
      "sort_sat": 1.0,
      "sort_val": 0.458824,
      "swatch_file_id": "gid://shopify/MediaImage/49495265083658",
      "swatch_filename": "k339_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k339_Navy.jpg?v=1774542517",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k339_Navy.jpg?v=1774542517",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K339/ProductCarouselMain/K339%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k339_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962053898",
      "product_title": "Kustom Kit Regular Fit Piqué Sweatshirt",
      "product_handle": "k337",
      "product_url": "/products/k337",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-k337",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "K337",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001a75",
      "sort_bucket": "blue",
      "sort_hue": 0.62963,
      "sort_sat": 1.0,
      "sort_val": 0.458824,
      "swatch_file_id": "gid://shopify/MediaImage/49495249223946",
      "swatch_filename": "k337_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k337_Navy.jpg?v=1774542509",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k337_Navy.jpg?v=1774542509",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K337/ProductCarouselMain/K337%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k337_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961791754",
      "product_title": "Kustom Kit Regular Fit Sweatshirt",
      "product_handle": "k332",
      "product_url": "/products/k332",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k332",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "K332",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001a75",
      "sort_bucket": "blue",
      "sort_hue": 0.62963,
      "sort_sat": 1.0,
      "sort_val": 0.458824,
      "swatch_file_id": "gid://shopify/MediaImage/49495203315978",
      "swatch_filename": "k332_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k332_Navy.jpg?v=1774542491",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k332_Navy.jpg?v=1774542491",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K332/ProductCarouselMain/K332%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k332_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961890058",
      "product_title": "Kustom Kit Sweat Jacket",
      "product_handle": "k334",
      "product_url": "/products/k334",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "jackets",
        "L",
        "M",
        "S",
        "style-k334",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "K334",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#001a75",
      "sort_bucket": "blue",
      "sort_hue": 0.62963,
      "sort_sat": 1.0,
      "sort_val": 0.458824,
      "swatch_file_id": "gid://shopify/MediaImage/49495246405898",
      "swatch_filename": "k334_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k334_Navy.jpg?v=1774542501",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k334_Navy.jpg?v=1774542501",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K334/ProductCarouselMain/K334%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k334_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Bright Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#002dcb",
      "sort_bucket": "blue",
      "sort_hue": 0.629721,
      "sort_sat": 1.0,
      "sort_val": 0.796078,
      "swatch_file_id": "gid://shopify/MediaImage/49494918267146",
      "swatch_filename": "jh030b_Bright_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Bright_Royal.jpg?v=1774542358",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Bright_Royal.jpg?v=1774542358",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20BRO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Bright_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961070858",
      "product_title": "AWDis Signature Heavyweight Sweatshirt",
      "product_handle": "jh123",
      "product_url": "/products/jh123",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-jh123",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/20% polyester/10% recycled polyester.*",
      "style_code": "JH123",
      "colour_name": "Bright Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#002dcb",
      "sort_bucket": "blue",
      "sort_hue": 0.629721,
      "sort_sat": 1.0,
      "sort_val": 0.796078,
      "swatch_file_id": "gid://shopify/MediaImage/49495087382794",
      "swatch_filename": "jh123_Bright_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_Bright_Royal.jpg?v=1774542424",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_Bright_Royal.jpg?v=1774542424",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH123/ProductCarouselMain/JH123%20BRO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh123_Bright_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Bright Royal",
      "colour_group": "Blue > Royal",
      "rgb": "#002dcb",
      "sort_bucket": "blue",
      "sort_hue": 0.629721,
      "sort_sat": 1.0,
      "sort_val": 0.796078,
      "swatch_file_id": "gid://shopify/MediaImage/49494781427978",
      "swatch_filename": "jh030_Bright_Royal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Bright_Royal.jpg?v=1774542281",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Bright_Royal.jpg?v=1774542281",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20BRO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Bright_Royal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963626762",
      "product_title": "Finden + Hales 1/4 Zip Tracksuit Top",
      "product_handle": "lv874",
      "product_url": "/products/lv874",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "style-lv874",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV874",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#0c184a",
      "sort_bucket": "blue",
      "sort_hue": 0.634409,
      "sort_sat": 0.837838,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49495589126410",
      "swatch_filename": "lv874_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_Navy.jpg?v=1774542673",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv874_Navy.jpg?v=1774542673",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV874/ProductCarouselMain/LV874%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv874_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963725066",
      "product_title": "Finden + Hales Kids 1/4 Zip Tracksuit Top",
      "product_handle": "lv875",
      "product_url": "/products/lv875",
      "product_full_url": "None",
      "vendor": "Finden + Hales",
      "product_type": "Sweatshirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-lv875",
        "sweatshirts"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester interlock.",
      "style_code": "LV875",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#0c184a",
      "sort_bucket": "blue",
      "sort_hue": 0.634409,
      "sort_sat": 0.837838,
      "sort_val": 0.290196,
      "swatch_file_id": "gid://shopify/MediaImage/49495642636554",
      "swatch_filename": "lv875_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_Navy.jpg?v=1774542693",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/lv875_Navy.jpg?v=1774542693",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Finden%20%26%20Hales/Product%20Images/LV875/ProductCarouselMain/LV875%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "lv875_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964347658",
      "product_title": "Native Spirit 1/4 Zip Sweatshirt",
      "product_handle": "ns428",
      "product_url": "/products/ns428",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns428",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "NS428",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#111a41",
      "sort_bucket": "blue",
      "sort_hue": 0.635417,
      "sort_sat": 0.738462,
      "sort_val": 0.254902,
      "swatch_file_id": "gid://shopify/MediaImage/49495879024906",
      "swatch_filename": "ns428_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns428_Navy.jpg?v=1774542787",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns428_Navy.jpg?v=1774542787",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS428/ProductCarouselMain/NS428%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns428_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964642570",
      "product_title": "Native Spirit Unisex Crew Neck Sweatshirt",
      "product_handle": "ns443",
      "product_url": "/products/ns443",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns443",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS400",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#111a41",
      "sort_bucket": "blue",
      "sort_hue": 0.635417,
      "sort_sat": 0.738462,
      "sort_val": 0.254902,
      "swatch_file_id": "gid://shopify/MediaImage/49495936499978",
      "swatch_filename": "ns443_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns443_Navy.jpg?v=1774542827",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns443_Navy.jpg?v=1774542827",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS400/ProductCarouselMain/NS400%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns443_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964085514",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns407",
      "product_url": "/products/ns407",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns407",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#111a41",
      "sort_bucket": "blue",
      "sort_hue": 0.635417,
      "sort_sat": 0.738462,
      "sort_val": 0.254902,
      "swatch_file_id": "gid://shopify/MediaImage/49495760109834",
      "swatch_filename": "ns407_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Navy.jpg?v=1774542746",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Navy.jpg?v=1774542746",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns407_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964609802",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns440",
      "product_url": "/products/ns440",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-ns440",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#111a41",
      "sort_bucket": "blue",
      "sort_hue": 0.635417,
      "sort_sat": 0.738462,
      "sort_val": 0.254902,
      "swatch_file_id": "gid://shopify/MediaImage/49495916380426",
      "swatch_filename": "ns440_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns440_Navy.jpg?v=1774542818",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns440_Navy.jpg?v=1774542818",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns440_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457956483338",
      "product_title": "Canvas Unisex Heavyweight Crew Neck Sweatshirt",
      "product_handle": "cv4711",
      "product_url": "/products/cv4711",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv4711",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% airlume combed ringspun cotton/40% polyester.",
      "style_code": "CV4711",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#1c2449",
      "sort_bucket": "blue",
      "sort_hue": 0.637037,
      "sort_sat": 0.616438,
      "sort_val": 0.286275,
      "swatch_file_id": "gid://shopify/MediaImage/49494465249546",
      "swatch_filename": "cv4711_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4711_Navy.jpg?v=1774541751",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4711_Navy.jpg?v=1774541751",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV4711/ProductCarouselMain/CV4711%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv4711_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948225802",
      "product_title": "Anthem Organic Sweatshirt",
      "product_handle": "am20",
      "product_url": "/products/am20",
      "product_full_url": "None",
      "vendor": "Anthem",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-am20",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "AM20",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#2b314f",
      "sort_bucket": "blue",
      "sort_hue": 0.638889,
      "sort_sat": 0.455696,
      "sort_val": 0.309804,
      "swatch_file_id": "gid://shopify/MediaImage/49494308421898",
      "swatch_filename": "am20_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Navy.jpg?v=1774540535",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Navy.jpg?v=1774540535",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM20/ProductCarouselMain/AM20%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am20_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457965789450",
      "product_title": "Premier Ladies Spun Dyed Recycled Zip Through Sweat Jacket",
      "product_handle": "pr809",
      "product_url": "/products/pr809",
      "product_full_url": "None",
      "vendor": "Premier",
      "product_type": "Sweatshirt",
      "tags": [
        "jackets",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-pr809",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "PR809",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#00199d",
      "sort_bucket": "blue",
      "sort_hue": 0.640127,
      "sort_sat": 1.0,
      "sort_val": 0.615686,
      "swatch_file_id": "gid://shopify/MediaImage/49496232984842",
      "swatch_filename": "pr809_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr809_French_Navy.jpg?v=1774542946",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr809_French_Navy.jpg?v=1774542946",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR809/ProductCarouselMain/PR809%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr809_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457965723914",
      "product_title": "Premier Spun Dyed Recycled Zip Through Sweat Jacket",
      "product_handle": "pr808",
      "product_url": "/products/pr808",
      "product_full_url": "None",
      "vendor": "Premier",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "jackets",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-pr808",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% recycled polyester.",
      "style_code": "PR808",
      "colour_name": "French Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#00199d",
      "sort_bucket": "blue",
      "sort_hue": 0.640127,
      "sort_sat": 1.0,
      "sort_val": 0.615686,
      "swatch_file_id": "gid://shopify/MediaImage/49496193106186",
      "swatch_filename": "pr808_French_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr808_French_Navy.jpg?v=1774542938",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/pr808_French_Navy.jpg?v=1774542938",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Premier/Product%20Images/PR808/ProductCarouselMain/PR808%20FNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "pr808_French_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457967231242",
      "product_title": "Regatta Core Stretch Half Zip Midlayer Top",
      "product_handle": "rg441",
      "product_url": "/products/rg441",
      "product_full_url": "None",
      "vendor": "Regatta Professional",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "security",
        "style-rg441",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Poly/Elastane",
      "shopify_material": "Poly/Elastane",
      "csv_material": "95% recycled polyester/5% elastane.",
      "style_code": "RG441",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#00094e",
      "sort_bucket": "blue",
      "sort_hue": 0.647436,
      "sort_sat": 1.0,
      "sort_val": 0.305882,
      "swatch_file_id": "gid://shopify/MediaImage/49496604901642",
      "swatch_filename": "rg441_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg441_Navy.jpg?v=1774543107",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rg441_Navy.jpg?v=1774543107",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Regatta%20Professional/Product%20Images/RG441/ProductCarouselMain/RG441%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rg441_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457971294474",
      "product_title": "Yoko Hi-Vis Sweatshirt",
      "product_handle": "yk030",
      "product_url": "/products/yk030",
      "product_full_url": "None",
      "vendor": "YOKO",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "hi-vis",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "safetywear-ppe",
        "style-yk030",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "YK030",
      "colour_name": "Navy",
      "colour_group": "Blue > Navy",
      "rgb": "#000037",
      "sort_bucket": "blue",
      "sort_hue": 0.666667,
      "sort_sat": 1.0,
      "sort_val": 0.215686,
      "swatch_file_id": "gid://shopify/MediaImage/49497664684298",
      "swatch_filename": "yk030_Navy.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk030_Navy.jpg?v=1774543608",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/yk030_Navy.jpg?v=1774543608",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/YOKO/Product%20Images/YK030/ProductCarouselMain/YK030%20NAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "yk030_Navy.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964282122",
      "product_title": "Native Spirit Unisex Terry 280 Oversized Sweatshirt",
      "product_handle": "ns415",
      "product_url": "/products/ns415",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns415",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS415",
      "colour_name": "Washed Parma",
      "colour_group": "Purple > Light Purple",
      "rgb": "#b3bfeb",
      "sort_bucket": "purple",
      "sort_hue": 0.630952,
      "sort_sat": 0.238298,
      "sort_val": 0.921569,
      "swatch_file_id": "gid://shopify/MediaImage/49495843537162",
      "swatch_filename": "ns415_Washed_Parma.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns415_Washed_Parma.jpg?v=1774542777",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns415_Washed_Parma.jpg?v=1774542777",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Native%20Spirit/NS415/ProductCarouselMain/NS415%20WPA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns415_Washed_Parma.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Dusty Lilac",
      "colour_group": "Purple > Light Purple",
      "rgb": "#6b7292",
      "sort_bucket": "purple",
      "sort_hue": 0.636752,
      "sort_sat": 0.267123,
      "sort_val": 0.572549,
      "swatch_file_id": "gid://shopify/MediaImage/49494781460746",
      "swatch_filename": "jh030_Dusty_Lilac.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Dusty_Lilac.jpg?v=1774542282",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Dusty_Lilac.jpg?v=1774542282",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20DUL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Dusty_Lilac.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#1a1c95",
      "sort_bucket": "purple",
      "sort_hue": 0.663957,
      "sort_sat": 0.825503,
      "sort_val": 0.584314,
      "swatch_file_id": "gid://shopify/MediaImage/49494475800842",
      "swatch_filename": "gd56_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Purple.jpg?v=1774541922",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Purple.jpg?v=1774541922",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#1a1c95",
      "sort_bucket": "purple",
      "sort_hue": 0.663957,
      "sort_sat": 0.825503,
      "sort_val": 0.584314,
      "swatch_file_id": "gid://shopify/MediaImage/49494481469706",
      "swatch_filename": "gd67_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Purple.jpg?v=1774542041",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Purple.jpg?v=1774542041",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#000093",
      "sort_bucket": "purple",
      "sort_hue": 0.666667,
      "sort_sat": 1.0,
      "sort_val": 0.576471,
      "swatch_file_id": "gid://shopify/MediaImage/49496984322314",
      "swatch_filename": "rx301_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Purple.jpg?v=1774543274",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Purple.jpg?v=1774543274",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Digital Lavender",
      "colour_group": "Purple > Light Purple",
      "rgb": "#7870f5",
      "sort_bucket": "purple",
      "sort_hue": 0.676692,
      "sort_sat": 0.542857,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49494923837706",
      "swatch_filename": "jh030b_Digital_Lavender.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Digital_Lavender.jpg?v=1774542360",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Digital_Lavender.jpg?v=1774542360",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20DTL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Digital_Lavender.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Digital Lavender",
      "colour_group": "Purple > Light Purple",
      "rgb": "#7870f5",
      "sort_bucket": "purple",
      "sort_hue": 0.676692,
      "sort_sat": 0.542857,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49494781526282",
      "swatch_filename": "jh030_Digital_Lavender.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Digital_Lavender.jpg?v=1774542284",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Digital_Lavender.jpg?v=1774542284",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20DTL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Digital_Lavender.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948160266",
      "product_title": "AWDis Academy Kids V Neck Sweatshirt",
      "product_handle": "ac003b",
      "product_url": "/products/ac003b",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "11-12",
        "13",
        "13-11-12-3-4-5-6-7-8-9-10",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "style-ac003b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC003B",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#090060",
      "sort_bucket": "purple",
      "sort_hue": 0.682292,
      "sort_sat": 1.0,
      "sort_val": 0.376471,
      "swatch_file_id": "gid://shopify/MediaImage/49494306291978",
      "swatch_filename": "ac003b_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003b_Purple.jpg?v=1774540520",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac003b_Purple.jpg?v=1774540520",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC003B/ProductCarouselMain/AC003B%20APU%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac003b_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947898122",
      "product_title": "AWDis Academy Senior Raglan Sweatshirt",
      "product_handle": "ac001",
      "product_url": "/products/ac001",
      "product_full_url": "None",
      "vendor": "AWDis Academy",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ac001",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "AC001",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#090060",
      "sort_bucket": "purple",
      "sort_hue": 0.682292,
      "sort_sat": 1.0,
      "sort_val": 0.376471,
      "swatch_file_id": "gid://shopify/MediaImage/49494303899914",
      "swatch_filename": "ac001_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Purple.jpg?v=1774540497",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ac001_Purple.jpg?v=1774540497",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/AWDis%20Academy/AC001/ProductCarouselMain/AC001%20APU%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ac001_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970213130",
      "product_title": "Fruit of the Loom Classic Raglan Sweatshirt",
      "product_handle": "ss8",
      "product_url": "/products/ss8",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss8",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS8",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#1500ce",
      "sort_bucket": "purple",
      "sort_hue": 0.683657,
      "sort_sat": 1.0,
      "sort_val": 0.807843,
      "swatch_file_id": "gid://shopify/MediaImage/49497429442826",
      "swatch_filename": "ss8_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Purple.jpg?v=1774543480",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Purple.jpg?v=1774543480",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS8/ProductCarouselMain/SS8%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss8_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947308298",
      "product_title": "Russell Athletic Kids Raglan Sweatshirt",
      "product_handle": "762b",
      "product_url": "/products/762b",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "performance-activewear",
        "sports",
        "style-762b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762B",
      "colour_name": "Purple",
      "colour_group": "Purple",
      "rgb": "#160098",
      "sort_bucket": "purple",
      "sort_hue": 0.690789,
      "sort_sat": 1.0,
      "sort_val": 0.596078,
      "swatch_file_id": "gid://shopify/MediaImage/49494299705610",
      "swatch_filename": "762b_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Purple.jpg?v=1774540439",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Purple.jpg?v=1774540439",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762B/ProductCarouselMain/762B%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762b_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#2402e0",
      "sort_bucket": "purple",
      "sort_hue": 0.692192,
      "sort_sat": 0.991071,
      "sort_val": 0.878431,
      "swatch_file_id": "gid://shopify/MediaImage/49494926229770",
      "swatch_filename": "jh030b_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Purple.jpg?v=1774542361",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Purple.jpg?v=1774542361",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Purple",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#2402e0",
      "sort_bucket": "purple",
      "sort_hue": 0.692192,
      "sort_sat": 0.991071,
      "sort_val": 0.878431,
      "swatch_file_id": "gid://shopify/MediaImage/49494781591818",
      "swatch_filename": "jh030_Purple.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Purple.jpg?v=1774542285",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Purple.jpg?v=1774542285",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20PUR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Purple.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "03814",
      "colour_name": "Lilac",
      "colour_group": "Purple > Light Purple",
      "rgb": "#d1c4e8",
      "sort_bucket": "purple",
      "sort_hue": 0.726852,
      "sort_sat": 0.155172,
      "sort_val": 0.909804,
      "swatch_file_id": "gid://shopify/MediaImage/49494226108682",
      "swatch_filename": "03814_Lilac.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Lilac.jpg?v=1774540261",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Lilac.jpg?v=1774540261",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03814/ProductCarouselMain/03814%20LIL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_Lilac.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960743178",
      "product_title": "AWDis Ladies Cropped 1/4 Zip Sweatshirt",
      "product_handle": "jh037",
      "product_url": "/products/jh037",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-jh037",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XXS",
        "XXS-XS-S-M-L-XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "JH037",
      "colour_name": "Lavender",
      "colour_group": "Purple > Light Purple",
      "rgb": "#c79cff",
      "sort_bucket": "purple",
      "sort_hue": 0.739057,
      "sort_sat": 0.388235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495001170186",
      "swatch_filename": "jh037_Lavender.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh037_Lavender.jpg?v=1774542389",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh037_Lavender.jpg?v=1774542389",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH037/ProductCarouselMain/JH037%20LAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh037_Lavender.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Lavender",
      "colour_group": "Purple > Light Purple",
      "rgb": "#c79cff",
      "sort_bucket": "purple",
      "sort_hue": 0.739057,
      "sort_sat": 0.388235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494781657354",
      "swatch_filename": "jh030_Lavender.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Lavender.jpg?v=1774542287",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Lavender.jpg?v=1774542287",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20LAV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Lavender.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Plum",
      "colour_group": "Purple > Dark Purple",
      "rgb": "#34015f",
      "sort_bucket": "purple",
      "sort_hue": 0.757092,
      "sort_sat": 0.989474,
      "sort_val": 0.372549,
      "swatch_file_id": "gid://shopify/MediaImage/49494781722890",
      "swatch_filename": "jh030_Plum.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Plum.jpg?v=1774542288",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Plum.jpg?v=1774542288",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20PLU%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Plum.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Festival Fuchsia",
      "colour_group": "Pink > Dark Pink",
      "rgb": "#8f10af",
      "sort_bucket": "pink",
      "sort_hue": 0.79979,
      "sort_sat": 0.908571,
      "sort_val": 0.686275,
      "swatch_file_id": "gid://shopify/MediaImage/49494781788426",
      "swatch_filename": "jh030_Festival_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Festival_Fuchsia.jpg?v=1774542290",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Festival_Fuchsia.jpg?v=1774542290",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20FEF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Festival_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Baby Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#ffb3fa",
      "sort_bucket": "pink",
      "sort_hue": 0.844298,
      "sort_sat": 0.298039,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494935699722",
      "swatch_filename": "jh030b_Baby_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Baby_Pink.jpg?v=1774542363",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Baby_Pink.jpg?v=1774542363",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20BPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Baby_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Baby Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#ffb3fa",
      "sort_bucket": "pink",
      "sort_hue": 0.844298,
      "sort_sat": 0.298039,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494781886730",
      "swatch_filename": "jh030_Baby_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Baby_Pink.jpg?v=1774542291",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Baby_Pink.jpg?v=1774542291",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20BPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Baby_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961398538",
      "product_title": "AWDis Unisex Organic Sweatshirt",
      "product_handle": "jh230",
      "product_url": "/products/jh230",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-jh230",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "JH230",
      "colour_name": "Baby Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#ffb3fa",
      "sort_bucket": "pink",
      "sort_hue": 0.844298,
      "sort_sat": 0.298039,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49495134273802",
      "swatch_filename": "jh230_Baby_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_Baby_Pink.jpg?v=1774542463",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_Baby_Pink.jpg?v=1774542463",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH230/ProductCarouselMain/JH230%20BPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh230_Baby_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#ff00ed",
      "sort_bucket": "pink",
      "sort_hue": 0.845098,
      "sort_sat": 1.0,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494289121546",
      "swatch_filename": "262m_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Fuchsia.jpg?v=1774540358",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Fuchsia.jpg?v=1774540358",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20FUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Candyfloss Pink",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#ff69f2",
      "sort_bucket": "pink",
      "sort_hue": 0.847778,
      "sort_sat": 0.588235,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494782083338",
      "swatch_filename": "jh030_Candyfloss_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Candyfloss_Pink.jpg?v=1774542293",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Candyfloss_Pink.jpg?v=1774542293",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20CFP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Candyfloss_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Light Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#fcc5f7",
      "sort_bucket": "pink",
      "sort_hue": 0.848485,
      "sort_sat": 0.218254,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49494475866378",
      "swatch_filename": "gd56_Light_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Light_Pink.jpg?v=1774541924",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Light_Pink.jpg?v=1774541924",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20LPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Light_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Light Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#fcc5f7",
      "sort_bucket": "pink",
      "sort_hue": 0.848485,
      "sort_sat": 0.218254,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49494481535242",
      "swatch_filename": "gd67_Light_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Light_Pink.jpg?v=1774542042",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Light_Pink.jpg?v=1774542042",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20LPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Light_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Fuchsia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#cb0ab1",
      "sort_bucket": "pink",
      "sort_hue": 0.855786,
      "sort_sat": 0.950739,
      "sort_val": 0.796078,
      "swatch_file_id": "gid://shopify/MediaImage/49496984748298",
      "swatch_filename": "rx301_Fuchsia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Fuchsia.jpg?v=1774543276",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Fuchsia.jpg?v=1774543276",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20FUS%20FRONT%202.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Fuchsia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970213130",
      "product_title": "Fruit of the Loom Classic Raglan Sweatshirt",
      "product_handle": "ss8",
      "product_url": "/products/ss8",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss8",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS8",
      "colour_name": "Light Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#ffa8f2",
      "sort_bucket": "pink",
      "sort_hue": 0.858238,
      "sort_sat": 0.341176,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49497431179530",
      "swatch_filename": "ss8_Light_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Light_Pink.jpg?v=1774543482",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Light_Pink.jpg?v=1774543482",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS8/ProductCarouselMain/SS8%20LPI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss8_Light_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Heliconia",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#ff14d1",
      "sort_bucket": "pink",
      "sort_hue": 0.865957,
      "sort_sat": 0.921569,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494475931914",
      "swatch_filename": "gd56_Heliconia.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Heliconia.jpg?v=1774541926",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Heliconia.jpg?v=1774541926",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20HEL%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Heliconia.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Hot Pink",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#f500ba",
      "sort_bucket": "pink",
      "sort_hue": 0.873469,
      "sort_sat": 1.0,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49494938910986",
      "swatch_filename": "jh030b_Hot_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Hot_Pink.jpg?v=1774542364",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Hot_Pink.jpg?v=1774542364",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20HPK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Hot_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Hot Pink",
      "colour_group": "Pink > Bright Pink",
      "rgb": "#f500ba",
      "sort_bucket": "pink",
      "sort_hue": 0.873469,
      "sort_sat": 1.0,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49494782312714",
      "swatch_filename": "jh030_Hot_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Hot_Pink.jpg?v=1774542295",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Hot_Pink.jpg?v=1774542295",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20HPK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Hot_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964544266",
      "product_title": "Native Spirit Ladies Crew Neck Sweatshirt",
      "product_handle": "ns439",
      "product_url": "/products/ns439",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns439",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "NS439",
      "colour_name": "Antique Rose",
      "colour_group": "Pink > Dark Pink",
      "rgb": "#a14a87",
      "sort_bucket": "pink",
      "sort_hue": 0.883142,
      "sort_sat": 0.540373,
      "sort_val": 0.631373,
      "swatch_file_id": "gid://shopify/MediaImage/49495901602058",
      "swatch_filename": "ns439_Antique_Rose.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns439_Antique_Rose.jpg?v=1774542808",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns439_Antique_Rose.jpg?v=1774542808",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS439/ProductCarouselMain/NS439%20ARS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns439_Antique_Rose.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963790602",
      "product_title": "Mantis Unisex Essential Sweatshirt",
      "product_handle": "m05",
      "product_url": "/products/m05",
      "product_full_url": "None",
      "vendor": "Mantis",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-m05",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "80% organic cotton/20% recycled polyester.",
      "style_code": "M05",
      "colour_name": "Soft Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#edc4de",
      "sort_bucket": "pink",
      "sort_hue": 0.894309,
      "sort_sat": 0.172996,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49495667015946",
      "swatch_filename": "m05_Soft_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m05_Soft_Pink.jpg?v=1774542705",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m05_Soft_Pink.jpg?v=1774542705",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Mantis/M05/ProductCarouselMain/M05%20SPK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "m05_Soft_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960743178",
      "product_title": "AWDis Ladies Cropped 1/4 Zip Sweatshirt",
      "product_handle": "jh037",
      "product_url": "/products/jh037",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-jh037",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XXS",
        "XXS-XS-S-M-L-XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.",
      "style_code": "JH037",
      "colour_name": "Dusty Rose",
      "colour_group": "Pink > Light Pink",
      "rgb": "#af628d",
      "sort_bucket": "pink",
      "sort_hue": 0.906926,
      "sort_sat": 0.44,
      "sort_val": 0.686275,
      "swatch_file_id": "gid://shopify/MediaImage/49495008280842",
      "swatch_filename": "jh037_Dusty_Rose.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh037_Dusty_Rose.jpg?v=1774542390",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh037_Dusty_Rose.jpg?v=1774542390",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Just%20Hoods/JH037/ProductCarouselMain/JH037%20DRO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh037_Dusty_Rose.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Dusty Rose",
      "colour_group": "Pink > Light Pink",
      "rgb": "#af628d",
      "sort_bucket": "pink",
      "sort_hue": 0.906926,
      "sort_sat": 0.44,
      "sort_val": 0.686275,
      "swatch_file_id": "gid://shopify/MediaImage/49494782738698",
      "swatch_filename": "jh030_Dusty_Rose.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Dusty_Rose.jpg?v=1774542296",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Dusty_Rose.jpg?v=1774542296",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20DRO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Dusty_Rose.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970311434",
      "product_title": "Fruit of the Loom Classic Drop Shoulder Sweatshirt",
      "product_handle": "ss9",
      "product_url": "/products/ss9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS9",
      "colour_name": "Powder Rose",
      "colour_group": "Pink > Light Pink",
      "rgb": "#e3bdcf",
      "sort_bucket": "pink",
      "sort_hue": 0.921053,
      "sort_sat": 0.167401,
      "sort_val": 0.890196,
      "swatch_file_id": "gid://shopify/MediaImage/49497489834250",
      "swatch_filename": "ss9_Powder_Rose.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Powder_Rose.jpg?v=1774543511",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Powder_Rose.jpg?v=1774543511",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS9/ProductCarouselMain/SS9%20PWR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss9_Powder_Rose.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Pink Lemonade",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#f04d97",
      "sort_bucket": "pink",
      "sort_hue": 0.924335,
      "sort_sat": 0.679167,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49494481633546",
      "swatch_filename": "gd67_Pink_Lemonade.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Pink_Lemonade.jpg?v=1774542044",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Pink_Lemonade.jpg?v=1774542044",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20PLM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Pink_Lemonade.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944686858",
      "product_title": "SOL'S Unisex Space Organic Raglan Sweatshirt",
      "product_handle": "03567",
      "product_url": "/products/03567",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03567",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "03567",
      "colour_name": "Pale Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#f7d9e6",
      "sort_bucket": "pink",
      "sort_hue": 0.927778,
      "sort_sat": 0.121457,
      "sort_val": 0.968627,
      "swatch_file_id": "gid://shopify/MediaImage/49494219325706",
      "swatch_filename": "03567_Pale_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Pale_Pink.jpg?v=1774540213",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03567_Pale_Pink.jpg?v=1774540213",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03567/ProductCarouselMain/03567%20PPN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03567_Pale_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948225802",
      "product_title": "Anthem Organic Sweatshirt",
      "product_handle": "am20",
      "product_url": "/products/am20",
      "product_full_url": "None",
      "vendor": "Anthem",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-am20",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "AM20",
      "colour_name": "Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#e6bccc",
      "sort_bucket": "pink",
      "sort_hue": 0.936508,
      "sort_sat": 0.182609,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49494308552970",
      "swatch_filename": "am20_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Pink.jpg?v=1774540536",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Pink.jpg?v=1774540536",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM20/ProductCarouselMain/AM20%20PIN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am20_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Dusty Rose",
      "colour_group": "Pink > Light Pink",
      "rgb": "#f5bfd0",
      "sort_bucket": "pink",
      "sort_hue": 0.947531,
      "sort_sat": 0.220408,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49494481731850",
      "swatch_filename": "gd67_Dusty_Rose.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Dusty_Rose.jpg?v=1774542046",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Dusty_Rose.jpg?v=1774542046",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20DRO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Dusty_Rose.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Dusty Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#de96a3",
      "sort_bucket": "pink",
      "sort_hue": 0.969907,
      "sort_sat": 0.324324,
      "sort_val": 0.870588,
      "swatch_file_id": "gid://shopify/MediaImage/49494939173130",
      "swatch_filename": "jh030b_Dusty_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Dusty_Pink.jpg?v=1774542366",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Dusty_Pink.jpg?v=1774542366",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20DYP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Dusty_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960644874",
      "product_title": "AWDis Ladies Sweatshirt",
      "product_handle": "jh030f",
      "product_url": "/products/jh030f",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-jh030f",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030F",
      "colour_name": "Dusty Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#de96a3",
      "sort_bucket": "pink",
      "sort_hue": 0.969907,
      "sort_sat": 0.324324,
      "sort_val": 0.870588,
      "swatch_file_id": "gid://shopify/MediaImage/49494978691338",
      "swatch_filename": "jh030f_Dusty_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030f_Dusty_Pink.jpg?v=1774542379",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030f_Dusty_Pink.jpg?v=1774542379",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030F/ProductCarouselMain/JH030F%20DYP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030f_Dusty_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Dusty Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#de96a3",
      "sort_bucket": "pink",
      "sort_hue": 0.969907,
      "sort_sat": 0.324324,
      "sort_val": 0.870588,
      "swatch_file_id": "gid://shopify/MediaImage/49494782837002",
      "swatch_filename": "jh030_Dusty_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Dusty_Pink.jpg?v=1774542298",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Dusty_Pink.jpg?v=1774542298",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20DYP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Dusty_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963036938",
      "product_title": "Kariban Ladies Oversized Sweatshirt",
      "product_handle": "kb471",
      "product_url": "/products/kb471",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "l-xl",
        "L-XL-S-M",
        "s-m",
        "style-kb471",
        "sweatshirts",
        "womens"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "91% cotton/9% polyester.*",
      "style_code": "KB471",
      "colour_name": "Pale Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#e3bcc3",
      "sort_bucket": "pink",
      "sort_hue": 0.970085,
      "sort_sat": 0.171806,
      "sort_val": 0.890196,
      "swatch_file_id": "gid://shopify/MediaImage/49495452057866",
      "swatch_filename": "kb471_Pale_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb471_Pale_Pink.jpg?v=1774542597",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb471_Pale_Pink.jpg?v=1774542597",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB471/ProductCarouselMain/KB471%20PPN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb471_Pale_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Chocolate Fudge Brownie",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#362421",
      "sort_bucket": "brown",
      "sort_hue": 0.02381,
      "sort_sat": 0.388889,
      "sort_val": 0.211765,
      "swatch_file_id": "gid://shopify/MediaImage/49494782869770",
      "swatch_filename": "jh030_Chocolate_Fudge_Brownie.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Chocolate_Fudge_Brownie.jpg?v=1774542299",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Chocolate_Fudge_Brownie.jpg?v=1774542299",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20CFU%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Chocolate_Fudge_Brownie.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Ginger Biscuit",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#8f3923",
      "sort_bucket": "brown",
      "sort_hue": 0.033951,
      "sort_sat": 0.755245,
      "sort_val": 0.560784,
      "swatch_file_id": "gid://shopify/MediaImage/49494783164682",
      "swatch_filename": "jh030_Ginger_Biscuit.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Ginger_Biscuit.jpg?v=1774542301",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Ginger_Biscuit.jpg?v=1774542301",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20GBT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Ginger_Biscuit.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Nude",
      "colour_group": "Brown > Light Brown",
      "rgb": "#d59d8b",
      "sort_bucket": "brown",
      "sort_hue": 0.040541,
      "sort_sat": 0.347418,
      "sort_val": 0.835294,
      "swatch_file_id": "gid://shopify/MediaImage/49494783230218",
      "swatch_filename": "jh030_Nude.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Nude.jpg?v=1774542303",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Nude.jpg?v=1774542303",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20NUD%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Nude.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Cocoa",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#6b3d2e",
      "sort_bucket": "brown",
      "sort_hue": 0.040984,
      "sort_sat": 0.570093,
      "sort_val": 0.419608,
      "swatch_file_id": "gid://shopify/MediaImage/49494481830154",
      "swatch_filename": "gd67_Cocoa.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Cocoa.jpg?v=1774542047",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Cocoa.jpg?v=1774542047",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20CCA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Cocoa.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961070858",
      "product_title": "AWDis Signature Heavyweight Sweatshirt",
      "product_handle": "jh123",
      "product_url": "/products/jh123",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-jh123",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/20% polyester/10% recycled polyester.*",
      "style_code": "JH123",
      "colour_name": "Espresso",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#4f413c",
      "sort_bucket": "brown",
      "sort_hue": 0.04386,
      "sort_sat": 0.240506,
      "sort_val": 0.309804,
      "swatch_file_id": "gid://shopify/MediaImage/49495087415562",
      "swatch_filename": "jh123_Espresso.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_Espresso.jpg?v=1774542425",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_Espresso.jpg?v=1774542425",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH123/ProductCarouselMain/JH123%20ESP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh123_Espresso.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969819914",
      "product_title": "Fruit of the Loom Iconic Premium Set-In Sweatshirt",
      "product_handle": "ss151",
      "product_url": "/products/ss151",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss151",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS151",
      "colour_name": "Desert Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#f0d1c4",
      "sort_bucket": "brown",
      "sort_hue": 0.049242,
      "sort_sat": 0.183333,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49497264881930",
      "swatch_filename": "ss151_Desert_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_Desert_Sand.jpg?v=1774543411",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_Desert_Sand.jpg?v=1774543411",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS151/ProductCarouselMain/SS151%20DSN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss151_Desert_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969885450",
      "product_title": "Fruit of the Loom Iconic Premium Zip Neck Sweatshirt",
      "product_handle": "ss154",
      "product_url": "/products/ss154",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss154",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.*",
      "style_code": "SS154",
      "colour_name": "Desert Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#f0d1c4",
      "sort_bucket": "brown",
      "sort_hue": 0.049242,
      "sort_sat": 0.183333,
      "sort_val": 0.941176,
      "swatch_file_id": "gid://shopify/MediaImage/49497302991114",
      "swatch_filename": "ss154_Desert_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss154_Desert_Sand.jpg?v=1774543426",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss154_Desert_Sand.jpg?v=1774543426",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS154/ProductCarouselMain/SS154%20DSN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss154_Desert_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Tangerine",
      "colour_group": "Orange > Light Orange",
      "rgb": "#ff804a",
      "sort_bucket": "brown",
      "sort_hue": 0.049724,
      "sort_sat": 0.709804,
      "sort_val": 1.0,
      "swatch_file_id": "gid://shopify/MediaImage/49494481895690",
      "swatch_filename": "gd67_Tangerine.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Tangerine.jpg?v=1774542049",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Tangerine.jpg?v=1774542049",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20TAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Tangerine.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Caramel Latte",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#a17a67",
      "sort_bucket": "brown",
      "sort_hue": 0.054598,
      "sort_sat": 0.360248,
      "sort_val": 0.631373,
      "swatch_file_id": "gid://shopify/MediaImage/49494783394058",
      "swatch_filename": "jh030_Caramel_Latte.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Caramel_Latte.jpg?v=1774542305",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Caramel_Latte.jpg?v=1774542305",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20CLT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Caramel_Latte.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Brown Savana",
      "colour_group": "Brown > Mid Brown",
      "rgb": "#65554a",
      "sort_bucket": "brown",
      "sort_hue": 0.067901,
      "sort_sat": 0.267327,
      "sort_val": 0.396078,
      "swatch_file_id": "gid://shopify/MediaImage/49494481993994",
      "swatch_filename": "gd67_Brown_Savana.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Brown_Savana.jpg?v=1774542051",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Brown_Savana.jpg?v=1774542051",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20BNS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Brown_Savana.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Mocha",
      "colour_group": "Brown > Light Brown",
      "rgb": "#65554a",
      "sort_bucket": "brown",
      "sort_hue": 0.067901,
      "sort_sat": 0.267327,
      "sort_val": 0.396078,
      "swatch_file_id": "gid://shopify/MediaImage/49494783426826",
      "swatch_filename": "jh030_Mocha.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Mocha.jpg?v=1774542306",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Mocha.jpg?v=1774542306",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20%20MOC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Mocha.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Sand",
      "colour_group": "Brown > Light Brown",
      "rgb": "#d6c1b2",
      "sort_bucket": "brown",
      "sort_hue": 0.069444,
      "sort_sat": 0.168224,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49494475997450",
      "swatch_filename": "gd56_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Sand.jpg?v=1774541927",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Sand.jpg?v=1774541927",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20SAN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Sand",
      "colour_group": "Brown > Light Brown",
      "rgb": "#d6c1b2",
      "sort_bucket": "brown",
      "sort_hue": 0.069444,
      "sort_sat": 0.168224,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49494482714890",
      "swatch_filename": "gd67_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Sand.jpg?v=1774542052",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Sand.jpg?v=1774542052",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20SAN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958187274",
      "product_title": "Gildan SoftStyle® Midweight Fleece 1/4 Zip Sweatshirt",
      "product_handle": "gd612",
      "product_url": "/products/gd612",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd612",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD612",
      "colour_name": "Sand",
      "colour_group": "Brown > Light Brown",
      "rgb": "#d6c1b2",
      "sort_bucket": "brown",
      "sort_hue": 0.069444,
      "sort_sat": 0.168224,
      "sort_val": 0.839216,
      "swatch_file_id": "gid://shopify/MediaImage/49494479012106",
      "swatch_filename": "gd612_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Sand.jpg?v=1774542006",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Sand.jpg?v=1774542006",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD612/ProductCarouselMain/GD612%20SAN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd612_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "Light Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#c7a993",
      "sort_bucket": "brown",
      "sort_hue": 0.070513,
      "sort_sat": 0.261307,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49495364436234",
      "swatch_filename": "kb4025_Light_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Light_Sand.jpg?v=1774542567",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Light_Sand.jpg?v=1774542567",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20LSA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_Light_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Pumpkin Pie",
      "colour_group": "Brown > Mid Brown",
      "rgb": "#c26415",
      "sort_bucket": "brown",
      "sort_hue": 0.076108,
      "sort_sat": 0.891753,
      "sort_val": 0.760784,
      "swatch_file_id": "gid://shopify/MediaImage/49494785032458",
      "swatch_filename": "jh030_Pumpkin_Pie.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Pumpkin_Pie.jpg?v=1774542308",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Pumpkin_Pie.jpg?v=1774542308",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20PMP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Pumpkin_Pie.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457956483338",
      "product_title": "Canvas Unisex Heavyweight Crew Neck Sweatshirt",
      "product_handle": "cv4711",
      "product_url": "/products/cv4711",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv4711",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% airlume combed ringspun cotton/40% polyester.",
      "style_code": "CV4711",
      "colour_name": "Vintage Brown",
      "colour_group": "Brown > Mid Brown",
      "rgb": "#87725b",
      "sort_bucket": "brown",
      "sort_hue": 0.087121,
      "sort_sat": 0.325926,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49494465282314",
      "swatch_filename": "cv4711_Vintage_Brown.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4711_Vintage_Brown.jpg?v=1774541752",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4711_Vintage_Brown.jpg?v=1774541752",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV4711/ProductCarouselMain/CV4711%20VBN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv4711_Vintage_Brown.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948225802",
      "product_title": "Anthem Organic Sweatshirt",
      "product_handle": "am20",
      "product_url": "/products/am20",
      "product_full_url": "None",
      "vendor": "Anthem",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-am20",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "AM20",
      "colour_name": "Desert Sand",
      "colour_group": "Brown > Light Brown",
      "rgb": "#bf8a4e",
      "sort_bucket": "brown",
      "sort_hue": 0.088496,
      "sort_sat": 0.591623,
      "sort_val": 0.74902,
      "swatch_file_id": "gid://shopify/MediaImage/49494308847882",
      "swatch_filename": "am20_Desert_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Desert_Sand.jpg?v=1774540538",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Desert_Sand.jpg?v=1774540538",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM20/ProductCarouselMain/AM20%20DSN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am20_Desert_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964085514",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns407",
      "product_url": "/products/ns407",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns407",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "Toffee",
      "colour_group": "Brown > Mid Brown",
      "rgb": "#615034",
      "sort_bucket": "brown",
      "sort_hue": 0.103704,
      "sort_sat": 0.463918,
      "sort_val": 0.380392,
      "swatch_file_id": "gid://shopify/MediaImage/49495760470282",
      "swatch_filename": "ns407_Toffee.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Toffee.jpg?v=1774542747",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Toffee.jpg?v=1774542747",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20TOF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns407_Toffee.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "Mocha",
      "colour_group": "Brown > Mid Brown",
      "rgb": "#605542",
      "sort_bucket": "brown",
      "sort_hue": 0.105556,
      "sort_sat": 0.3125,
      "sort_val": 0.376471,
      "swatch_file_id": "gid://shopify/MediaImage/49494289350922",
      "swatch_filename": "262m_Mocha.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Mocha.jpg?v=1774540359",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Mocha.jpg?v=1774540359",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20MOC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_Mocha.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964085514",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns407",
      "product_url": "/products/ns407",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns407",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "Raw Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#d4c8ac",
      "sort_bucket": "brown",
      "sort_hue": 0.116667,
      "sort_sat": 0.188679,
      "sort_val": 0.831373,
      "swatch_file_id": "gid://shopify/MediaImage/49495760535818",
      "swatch_filename": "ns407_Raw_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Raw_Natural.jpg?v=1774542749",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Raw_Natural.jpg?v=1774542749",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20RNA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns407_Raw_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964085514",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns407",
      "product_url": "/products/ns407",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns407",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "Driftwood",
      "colour_group": "Brown > Dark Brown",
      "rgb": "#7a7362",
      "sort_bucket": "brown",
      "sort_hue": 0.118056,
      "sort_sat": 0.196721,
      "sort_val": 0.478431,
      "swatch_file_id": "gid://shopify/MediaImage/49495760601354",
      "swatch_filename": "ns407_Driftwood.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Driftwood.jpg?v=1774542751",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Driftwood.jpg?v=1774542751",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20DFW%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns407_Driftwood.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030B",
      "colour_name": "Desert Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#ddca8f",
      "sort_bucket": "brown",
      "sort_hue": 0.126068,
      "sort_sat": 0.352941,
      "sort_val": 0.866667,
      "swatch_file_id": "gid://shopify/MediaImage/49494945497354",
      "swatch_filename": "jh030b_Desert_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Desert_Sand.jpg?v=1774542367",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Desert_Sand.jpg?v=1774542367",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20DSN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Desert_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Desert Sand",
      "colour_group": "Natural > Natural",
      "rgb": "#ddca8f",
      "sort_bucket": "brown",
      "sort_hue": 0.126068,
      "sort_sat": 0.352941,
      "sort_val": 0.866667,
      "swatch_file_id": "gid://shopify/MediaImage/49494785097994",
      "swatch_filename": "jh030_Desert_Sand.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Desert_Sand.jpg?v=1774542309",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Desert_Sand.jpg?v=1774542309",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20DSN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Desert_Sand.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970311434",
      "product_title": "Fruit of the Loom Classic Drop Shoulder Sweatshirt",
      "product_handle": "ss9",
      "product_url": "/products/ss9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS9",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#f5e8bf",
      "sort_bucket": "brown",
      "sort_hue": 0.126543,
      "sort_sat": 0.220408,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49497510347018",
      "swatch_filename": "ss9_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Natural.jpg?v=1774543513",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Natural.jpg?v=1774543513",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS9/ProductCarouselMain/SS9%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss9_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#f5e8bf",
      "sort_bucket": "brown",
      "sort_hue": 0.126543,
      "sort_sat": 0.220408,
      "sort_val": 0.960784,
      "swatch_file_id": "gid://shopify/MediaImage/49494289613066",
      "swatch_filename": "262m_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Natural.jpg?v=1774540361",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Natural.jpg?v=1774540361",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Olive Green",
      "colour_group": "Green > Olive/Military",
      "rgb": "#1f1a09",
      "sort_bucket": "brown",
      "sort_hue": 0.128788,
      "sort_sat": 0.709677,
      "sort_val": 0.121569,
      "swatch_file_id": "gid://shopify/MediaImage/49494785130762",
      "swatch_filename": "jh030_Olive_Green.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Olive_Green.jpg?v=1774542311",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Olive_Green.jpg?v=1774542311",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20OLI%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Olive_Green.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Vanilla Milkshake",
      "colour_group": "Natural > Natural",
      "rgb": "#fcfac2",
      "sort_bucket": "brown",
      "sort_hue": 0.16092,
      "sort_sat": 0.230159,
      "sort_val": 0.988235,
      "swatch_file_id": "gid://shopify/MediaImage/49494786310410",
      "swatch_filename": "jh030_Vanilla_Milkshake.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Vanilla_Milkshake.jpg?v=1774542312",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Vanilla_Milkshake.jpg?v=1774542312",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20VMK%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Vanilla_Milkshake.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Stone Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#68a8b5",
      "sort_bucket": "brown",
      "sort_hue": 0.528139,
      "sort_sat": 0.425414,
      "sort_val": 0.709804,
      "swatch_file_id": "gid://shopify/MediaImage/49494482813194",
      "swatch_filename": "gd67_Stone_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Stone_Blue.jpg?v=1774542053",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Stone_Blue.jpg?v=1774542053",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20SNB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Stone_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958187274",
      "product_title": "Gildan SoftStyle® Midweight Fleece 1/4 Zip Sweatshirt",
      "product_handle": "gd612",
      "product_url": "/products/gd612",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd612",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD612",
      "colour_name": "Stone Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#68a8b5",
      "sort_bucket": "brown",
      "sort_hue": 0.528139,
      "sort_sat": 0.425414,
      "sort_val": 0.709804,
      "swatch_file_id": "gid://shopify/MediaImage/49494479143178",
      "swatch_filename": "gd612_Stone_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Stone_Blue.jpg?v=1774542008",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Stone_Blue.jpg?v=1774542008",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD612/ProductCarouselMain/GD612%20SNB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd612_Stone_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968935178",
      "product_title": "SF Clothing Unisex Sustainable Fashion Sweatshirt",
      "product_handle": "sf530",
      "product_url": "/products/sf530",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-sf530",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% regenerated cotton/40% recycled polyester.",
      "style_code": "SF530",
      "colour_name": "Stone Blue",
      "colour_group": "Blue > Mid Blue",
      "rgb": "#4b8da2",
      "sort_bucket": "brown",
      "sort_hue": 0.54023,
      "sort_sat": 0.537037,
      "sort_val": 0.635294,
      "swatch_file_id": "gid://shopify/MediaImage/49497062113546",
      "swatch_filename": "sf530_Stone_Blue.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf530_Stone_Blue.jpg?v=1774543312",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf530_Stone_Blue.jpg?v=1774543312",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF530/ProductCarouselMain/SF530%20SNB%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf530_Stone_Blue.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457956024586",
      "product_title": "Brand Lab Ladies Plush Fleece Crew Neck Sweatshirt",
      "product_handle": "bh210",
      "product_url": "/products/bh210",
      "product_full_url": "None",
      "vendor": "Brand Lab",
      "product_type": "Sweatshirt",
      "tags": [
        "12-14",
        "12-14-16-18-8-10",
        "16-18",
        "8-10",
        "fleece",
        "PCBest_Seller",
        "style-bh210",
        "sweatshirts",
        "womens"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "BH210",
      "colour_name": "Blush Pink",
      "colour_group": "Pink > Mid Pink",
      "rgb": "#ceb8b8",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.106796,
      "sort_val": 0.807843,
      "swatch_file_id": "gid://shopify/MediaImage/49494457516298",
      "swatch_filename": "bh210_Blush_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bh210_Blush_Pink.jpg?v=1774541715",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bh210_Blush_Pink.jpg?v=1774541715",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Brand%20Lab/Product%20Images/BH210/ProductCarouselMain/BH210%20BLP%20FRONT%201.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bh210_Blush_Pink.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963036938",
      "product_title": "Kariban Ladies Oversized Sweatshirt",
      "product_handle": "kb471",
      "product_url": "/products/kb471",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "l-xl",
        "L-XL-S-M",
        "s-m",
        "style-kb471",
        "sweatshirts",
        "womens"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "87% cotton/9% polyester/4% viscose.",
      "style_code": "KB471",
      "colour_name": "Light Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#bdbdbd",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.741176,
      "swatch_file_id": "gid://shopify/MediaImage/49495456219402",
      "swatch_filename": "kb471_Light_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb471_Light_Grey.jpg?v=1774542598",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb471_Light_Grey.jpg?v=1774542598",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB471/ProductCarouselMain/KB471%20LGR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb471_Light_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455556161802",
      "product_title": "Tee Jays Heavy Sweatshirt",
      "product_handle": "t5429",
      "product_url": "/products/t5429",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-t5429",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/30% polyester.",
      "style_code": "T5429",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#999999",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49491171180810",
      "swatch_filename": "t5429_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5429_Heather_Grey.jpg?v=1774526134",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5429_Heather_Grey.jpg?v=1774526134",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5429/ProductCarouselMain/T5429%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5429_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555801354",
      "product_title": "Tee Jays Power Organic Sweatshirt",
      "product_handle": "t5100",
      "product_url": "/products/t5100",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-t5100",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% organic cotton/30% polyester.",
      "style_code": "T5100",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#999999",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49491209060618",
      "swatch_filename": "t5100_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5100_Heather_Grey.jpg?v=1774526224",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5100_Heather_Grey.jpg?v=1774526224",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Tee%20Jays/T5100/ProductCarouselMain/T5100%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5100_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10455555866890",
      "product_title": "Tee Jays Unlabeled Sweatshirt",
      "product_handle": "t5150",
      "product_url": "/products/t5150",
      "product_full_url": "None",
      "vendor": "Tee Jays",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-t5150",
        "sweatshirts",
        "t-shirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% organic ringspun cotton/30% recycled polyester.",
      "style_code": "T5150",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#999999",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49491204473098",
      "swatch_filename": "t5150_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5150_Heather_Grey.jpg?v=1774526212",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/t5150_Heather_Grey.jpg?v=1774526212",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Tee%20Jays/Product%20Images/T5150/ProductCarouselMain/T5150%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "t5150_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946259722",
      "product_title": "SOL'S Unisex New Supreme Sweatshirt",
      "product_handle": "13250",
      "product_url": "/products/13250",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-13250",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "13250",
      "colour_name": "Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#707070",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.439216,
      "swatch_file_id": "gid://shopify/MediaImage/49494285385994",
      "swatch_filename": "13250_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_Grey.jpg?v=1774540331",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_Grey.jpg?v=1774540331",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/13250/ProductCarouselMain/13250%20GRE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "13250_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962184970",
      "product_title": "Kustom Kit Regular Fit 1/4 Zip Piqué Sweatshirt",
      "product_handle": "k339",
      "product_url": "/products/k339",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-k339",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "K339",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#636363",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.388235,
      "swatch_file_id": "gid://shopify/MediaImage/49495277732106",
      "swatch_filename": "k339_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k339_Dark_Grey.jpg?v=1774542518",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k339_Dark_Grey.jpg?v=1774542518",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K339/ProductCarouselMain/K339%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k339_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962053898",
      "product_title": "Kustom Kit Regular Fit Piqué Sweatshirt",
      "product_handle": "k337",
      "product_url": "/products/k337",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-k337",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "K337",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#636363",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.388235,
      "swatch_file_id": "gid://shopify/MediaImage/49495249289482",
      "swatch_filename": "k337_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k337_Dark_Grey.jpg?v=1774542511",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k337_Dark_Grey.jpg?v=1774542511",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K337/ProductCarouselMain/K337%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k337_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961791754",
      "product_title": "Kustom Kit Regular Fit Sweatshirt",
      "product_handle": "k332",
      "product_url": "/products/k332",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k332",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "K332",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#636363",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.388235,
      "swatch_file_id": "gid://shopify/MediaImage/49495215997194",
      "swatch_filename": "k332_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k332_Dark_Grey.jpg?v=1774542493",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k332_Dark_Grey.jpg?v=1774542493",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K332/ProductCarouselMain/K332%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k332_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961890058",
      "product_title": "Kustom Kit Sweat Jacket",
      "product_handle": "k334",
      "product_url": "/products/k334",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "jackets",
        "L",
        "M",
        "S",
        "style-k334",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "65% cotton/35% polyester.",
      "style_code": "K334",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#636363",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.388235,
      "swatch_file_id": "gid://shopify/MediaImage/49495246471434",
      "swatch_filename": "k334_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k334_Dark_Grey.jpg?v=1774542502",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k334_Dark_Grey.jpg?v=1774542502",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K334/ProductCarouselMain/K334%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k334_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457956483338",
      "product_title": "Canvas Unisex Heavyweight Crew Neck Sweatshirt",
      "product_handle": "cv4711",
      "product_url": "/products/cv4711",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv4711",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% airlume combed ringspun cotton/40% polyester.",
      "style_code": "CV4711",
      "colour_name": "Asphalt",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#3b3b3b",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49494465315082",
      "swatch_filename": "cv4711_Asphalt.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4711_Asphalt.jpg?v=1774541753",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4711_Asphalt.jpg?v=1774541753",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV4711/ProductCarouselMain/CV4711%20ASP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv4711_Asphalt.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961758986",
      "product_title": "Kustom Kit Klassic Sweatshirt",
      "product_handle": "k302",
      "product_url": "/products/k302",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k302",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "65% polyester/35% cotton.",
      "style_code": "K302",
      "colour_name": "Dark Grey Marl",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#3b3b3b",
      "sort_bucket": "grey",
      "sort_hue": 0.0,
      "sort_sat": 0.0,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49495183982858",
      "swatch_filename": "k302_Dark_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k302_Dark_Grey_Marl.jpg?v=1774542486",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k302_Dark_Grey_Marl.jpg?v=1774542486",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K302/ProductCarouselMain/K302%20DKM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k302_Dark_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964347658",
      "product_title": "Native Spirit 1/4 Zip Sweatshirt",
      "product_handle": "ns428",
      "product_url": "/products/ns428",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns428",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "NS428",
      "colour_name": "Ivory",
      "colour_group": "Natural > Natural",
      "rgb": "#edebe0",
      "sort_bucket": "grey",
      "sort_hue": 0.141026,
      "sort_sat": 0.054852,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49495879155978",
      "swatch_filename": "ns428_Ivory.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns428_Ivory.jpg?v=1774542788",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns428_Ivory.jpg?v=1774542788",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS428/ProductCarouselMain/NS428%20IVO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns428_Ivory.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964544266",
      "product_title": "Native Spirit Ladies Crew Neck Sweatshirt",
      "product_handle": "ns439",
      "product_url": "/products/ns439",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns439",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "NS439",
      "colour_name": "Ivory",
      "colour_group": "Natural > Natural",
      "rgb": "#edebe0",
      "sort_bucket": "grey",
      "sort_hue": 0.141026,
      "sort_sat": 0.054852,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49495901700362",
      "swatch_filename": "ns439_Ivory.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns439_Ivory.jpg?v=1774542809",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns439_Ivory.jpg?v=1774542809",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS439/ProductCarouselMain/NS439%20IVO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns439_Ivory.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964445962",
      "product_title": "Native Spirit Ladies Oversized Cropped Sweatshirt",
      "product_handle": "ns429",
      "product_url": "/products/ns429",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns429",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "65% organic combed cotton/35% recycled polyester.",
      "style_code": "NS429",
      "colour_name": "Ivory",
      "colour_group": "Natural > Natural",
      "rgb": "#edebe0",
      "sort_bucket": "grey",
      "sort_hue": 0.141026,
      "sort_sat": 0.054852,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49495887610122",
      "swatch_filename": "ns429_Ivory.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns429_Ivory.jpg?v=1774542800",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns429_Ivory.jpg?v=1774542800",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS429/ProductCarouselMain/NS429%20IVO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns429_Ivory.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964642570",
      "product_title": "Native Spirit Unisex Crew Neck Sweatshirt",
      "product_handle": "ns443",
      "product_url": "/products/ns443",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns443",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS400",
      "colour_name": "Ivory",
      "colour_group": "Natural > Natural",
      "rgb": "#edebe0",
      "sort_bucket": "grey",
      "sort_hue": 0.141026,
      "sort_sat": 0.054852,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49495940727050",
      "swatch_filename": "ns443_Ivory.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns443_Ivory.jpg?v=1774542828",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns443_Ivory.jpg?v=1774542828",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS400/ProductCarouselMain/NS400%20IVO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns443_Ivory.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964085514",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns407",
      "product_url": "/products/ns407",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns407",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "Ivory",
      "colour_group": "Natural > Natural",
      "rgb": "#edebe0",
      "sort_bucket": "grey",
      "sort_hue": 0.141026,
      "sort_sat": 0.054852,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49495770923274",
      "swatch_filename": "ns407_Ivory.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Ivory.jpg?v=1774542753",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns407_Ivory.jpg?v=1774542753",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20IVO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns407_Ivory.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964609802",
      "product_title": "Native Spirit Unisex Oversized Sweatshirt",
      "product_handle": "ns440",
      "product_url": "/products/ns440",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-ns440",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS407",
      "colour_name": "Ivory",
      "colour_group": "Natural > Natural",
      "rgb": "#edebe0",
      "sort_bucket": "grey",
      "sort_hue": 0.141026,
      "sort_sat": 0.054852,
      "sort_val": 0.929412,
      "swatch_file_id": "gid://shopify/MediaImage/49495927619850",
      "swatch_filename": "ns440_Ivory.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns440_Ivory.jpg?v=1774542820",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns440_Ivory.jpg?v=1774542820",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS407/ProductCarouselMain/NS407%20IVO%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns440_Ivory.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457956483338",
      "product_title": "Canvas Unisex Heavyweight Crew Neck Sweatshirt",
      "product_handle": "cv4711",
      "product_url": "/products/cv4711",
      "product_full_url": "None",
      "vendor": "Bella+Canvas",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-cv4711",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% airlume combed ringspun cotton/40% polyester.",
      "style_code": "CV4711",
      "colour_name": "Dust",
      "colour_group": "Natural > Natural",
      "rgb": "#dbd9cc",
      "sort_bucket": "grey",
      "sort_hue": 0.144444,
      "sort_sat": 0.068493,
      "sort_val": 0.858824,
      "swatch_file_id": "gid://shopify/MediaImage/49494465347850",
      "swatch_filename": "cv4711_Dust.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4711_Dust.jpg?v=1774541755",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/cv4711_Dust.jpg?v=1774541755",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Bella%2BCanvas/Product%20Images/CV4711/ProductCarouselMain/CV4711%20DUS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "cv4711_Dust.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963790602",
      "product_title": "Mantis Unisex Essential Sweatshirt",
      "product_handle": "m05",
      "product_url": "/products/m05",
      "product_full_url": "None",
      "vendor": "Mantis",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-m05",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "80% organic cotton/20% recycled polyester.",
      "style_code": "M05",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#e6e6cc",
      "sort_bucket": "grey",
      "sort_hue": 0.166667,
      "sort_sat": 0.113043,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49495678877962",
      "swatch_filename": "m05_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m05_Natural.jpg?v=1774542707",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/m05_Natural.jpg?v=1774542707",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Mantis/M05/ProductCarouselMain/M05%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "m05_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457957826826",
      "product_title": "Front Row Premium Piqué 1/4 Zip Top",
      "product_handle": "fr045",
      "product_url": "/products/fr045",
      "product_full_url": "None",
      "vendor": "Front Row",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-fr045",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% cotton.",
      "style_code": "FR045",
      "colour_name": "Natural",
      "colour_group": "Natural > Natural",
      "rgb": "#d7d9c2",
      "sort_bucket": "grey",
      "sort_hue": 0.181159,
      "sort_sat": 0.105991,
      "sort_val": 0.85098,
      "swatch_file_id": "gid://shopify/MediaImage/49494472622346",
      "swatch_filename": "fr045_Natural.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/fr045_Natural.jpg?v=1774541862",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/fr045_Natural.jpg?v=1774541862",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Front%20Row/Product%20Images/FR045/ProductCarouselMain/FR045%20NAT%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "fr045_Natural.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "Grey Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#65665c",
      "sort_bucket": "grey",
      "sort_hue": 0.183333,
      "sort_sat": 0.098039,
      "sort_val": 0.4,
      "swatch_file_id": "gid://shopify/MediaImage/49495368401162",
      "swatch_filename": "kb4025_Grey_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Grey_Heather.jpg?v=1774542568",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Grey_Heather.jpg?v=1774542568",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20GYH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_Grey_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964544266",
      "product_title": "Native Spirit Ladies Crew Neck Sweatshirt",
      "product_handle": "ns439",
      "product_url": "/products/ns439",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns439",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "NS439",
      "colour_name": "Moon Grey Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a0a395",
      "sort_bucket": "grey",
      "sort_hue": 0.202381,
      "sort_sat": 0.08589,
      "sort_val": 0.639216,
      "swatch_file_id": "gid://shopify/MediaImage/49495909662986",
      "swatch_filename": "ns439_Moon_Grey_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns439_Moon_Grey_Heather.jpg?v=1774542811",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns439_Moon_Grey_Heather.jpg?v=1774542811",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS439/ProductCarouselMain/NS439%20MGH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns439_Moon_Grey_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964642570",
      "product_title": "Native Spirit Unisex Crew Neck Sweatshirt",
      "product_handle": "ns443",
      "product_url": "/products/ns443",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "organic-recycled",
        "recycled",
        "S",
        "style-ns443",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL-4XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic ringspun combed cotton/15% recycled polyester.",
      "style_code": "NS400",
      "colour_name": "Moon Grey Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a0a395",
      "sort_bucket": "grey",
      "sort_hue": 0.202381,
      "sort_sat": 0.08589,
      "sort_val": 0.639216,
      "swatch_file_id": "gid://shopify/MediaImage/49495947378954",
      "swatch_filename": "ns443_Moon_Grey_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns443_Moon_Grey_Heather.jpg?v=1774542830",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns443_Moon_Grey_Heather.jpg?v=1774542830",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Native%20Spirit/Product%20Images/NS400/ProductCarouselMain/NS400%20MGH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns443_Moon_Grey_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "Dark Khaki",
      "colour_group": "Green > Olive/Military",
      "rgb": "#52544b",
      "sort_bucket": "grey",
      "sort_hue": 0.203704,
      "sort_sat": 0.107143,
      "sort_val": 0.329412,
      "swatch_file_id": "gid://shopify/MediaImage/49495372431626",
      "swatch_filename": "kb4025_Dark_Khaki.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Dark_Khaki.jpg?v=1774542570",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Dark_Khaki.jpg?v=1774542570",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20DKH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_Dark_Khaki.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968935178",
      "product_title": "SF Clothing Unisex Sustainable Fashion Sweatshirt",
      "product_handle": "sf530",
      "product_url": "/products/sf530",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-sf530",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% regenerated cotton/40% recycled polyester.",
      "style_code": "SF530",
      "colour_name": "Light Stone",
      "colour_group": "Natural > Natural",
      "rgb": "#dee3d4",
      "sort_bucket": "grey",
      "sort_hue": 0.222222,
      "sort_sat": 0.066079,
      "sort_val": 0.890196,
      "swatch_file_id": "gid://shopify/MediaImage/49497062277386",
      "swatch_filename": "sf530_Light_Stone.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf530_Light_Stone.jpg?v=1774543314",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf530_Light_Stone.jpg?v=1774543314",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF530/ProductCarouselMain/SF530%20LTS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf530_Light_Stone.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963200778",
      "product_title": "Kariban Crew Neck Sweatshirt",
      "product_handle": "kb488",
      "product_url": "/products/kb488",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb488",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "KB488",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#383b37",
      "sort_bucket": "grey",
      "sort_hue": 0.291667,
      "sort_sat": 0.067797,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49495513989386",
      "swatch_filename": "kb488_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb488_Dark_Grey.jpg?v=1774542627",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb488_Dark_Grey.jpg?v=1774542627",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB488/ProductCarouselMain/KB488%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb488_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#383b37",
      "sort_bucket": "grey",
      "sort_hue": 0.291667,
      "sort_sat": 0.067797,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49495372464394",
      "swatch_filename": "kb4025_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Dark_Grey.jpg?v=1774542571",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Dark_Grey.jpg?v=1774542571",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963135242",
      "product_title": "Kariban Zip Neck Sweatshirt",
      "product_handle": "kb487",
      "product_url": "/products/kb487",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb487",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "KB487",
      "colour_name": "Dark Grey",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#383b37",
      "sort_bucket": "grey",
      "sort_hue": 0.291667,
      "sort_sat": 0.067797,
      "sort_val": 0.231373,
      "swatch_file_id": "gid://shopify/MediaImage/49495496327434",
      "swatch_filename": "kb487_Dark_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb487_Dark_Grey.jpg?v=1774542611",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb487_Dark_Grey.jpg?v=1774542611",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB487/ProductCarouselMain/KB487%20DGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb487_Dark_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970508042",
      "product_title": "Fruit of the Loom Premium Drop Shoulder Sweatshirt",
      "product_handle": "sse9",
      "product_url": "/products/sse9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-sse9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE9",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#222622",
      "sort_bucket": "grey",
      "sort_hue": 0.333333,
      "sort_sat": 0.105263,
      "sort_val": 0.14902,
      "swatch_file_id": "gid://shopify/MediaImage/49497539576074",
      "swatch_filename": "sse9_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse9_Charcoal.jpg?v=1774543541",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse9_Charcoal.jpg?v=1774543541",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Fruit%20of%20the%20Loom/SSE9/ProductCarouselMain/SSE9%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse9_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Ash",
      "colour_group": "Grey > Light Grey",
      "rgb": "#e1e6e1",
      "sort_bucket": "grey",
      "sort_hue": 0.333333,
      "sort_sat": 0.021739,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49494809936138",
      "swatch_filename": "jh030_Ash.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Ash.jpg?v=1774542314",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Ash.jpg?v=1774542314",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20ASH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Ash.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "Snow Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#b3b5b3",
      "sort_bucket": "grey",
      "sort_hue": 0.333333,
      "sort_sat": 0.01105,
      "sort_val": 0.709804,
      "swatch_file_id": "gid://shopify/MediaImage/49495372529930",
      "swatch_filename": "kb4025_Snow_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Snow_Grey.jpg?v=1774542573",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Snow_Grey.jpg?v=1774542573",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20SNWG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_Snow_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "Sage",
      "colour_group": "Green > Light Green",
      "rgb": "#95a697",
      "sort_bucket": "grey",
      "sort_hue": 0.352941,
      "sort_sat": 0.10241,
      "sort_val": 0.65098,
      "swatch_file_id": "gid://shopify/MediaImage/49495372562698",
      "swatch_filename": "kb4025_Sage.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Sage.jpg?v=1774542574",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Sage.jpg?v=1774542574",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20SAG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_Sage.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964282122",
      "product_title": "Native Spirit Unisex Terry 280 Oversized Sweatshirt",
      "product_handle": "ns415",
      "product_url": "/products/ns415",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns415",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS415",
      "colour_name": "Washed Ivory",
      "colour_group": "Natural > Natural",
      "rgb": "#d9e3db",
      "sort_bucket": "grey",
      "sort_hue": 0.366667,
      "sort_sat": 0.044053,
      "sort_val": 0.890196,
      "swatch_file_id": "gid://shopify/MediaImage/49495843569930",
      "swatch_filename": "ns415_Washed_Ivory.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns415_Washed_Ivory.jpg?v=1774542778",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns415_Washed_Ivory.jpg?v=1774542778",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Native%20Spirit/NS415/ProductCarouselMain/NS415%20WIV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns415_Washed_Ivory.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457964183818",
      "product_title": "Native Spirit Unisex Terry 280 Sweatshirt",
      "product_handle": "ns414",
      "product_url": "/products/ns414",
      "product_full_url": "None",
      "vendor": "Native Spirit",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "style-ns414",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton",
      "shopify_material": "Cotton",
      "csv_material": "100% organic ringspun combed cotton.",
      "style_code": "NS414",
      "colour_name": "Washed Ivory",
      "colour_group": "Natural > Natural",
      "rgb": "#d9e3db",
      "sort_bucket": "grey",
      "sort_hue": 0.366667,
      "sort_sat": 0.044053,
      "sort_val": 0.890196,
      "swatch_file_id": "gid://shopify/MediaImage/49495825088778",
      "swatch_filename": "ns414_Washed_Ivory.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns414_Washed_Ivory.jpg?v=1774542765",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ns414_Washed_Ivory.jpg?v=1774542765",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Native%20Spirit/NS414/ProductCarouselMain/NS414%20WIV%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ns414_Washed_Ivory.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961070858",
      "product_title": "AWDis Signature Heavyweight Sweatshirt",
      "product_handle": "jh123",
      "product_url": "/products/jh123",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-jh123",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% ringspun cotton/20% polyester/10% recycled polyester.*",
      "style_code": "JH123",
      "colour_name": "Natural Stone",
      "colour_group": "Natural > Natural",
      "rgb": "#a4ada6",
      "sort_bucket": "grey",
      "sort_hue": 0.37037,
      "sort_sat": 0.052023,
      "sort_val": 0.678431,
      "swatch_file_id": "gid://shopify/MediaImage/49495089807626",
      "swatch_filename": "jh123_Natural_Stone.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_Natural_Stone.jpg?v=1774542427",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_Natural_Stone.jpg?v=1774542427",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH123/ProductCarouselMain/JH123%20NTS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh123_Natural_Stone.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Natural Stone",
      "colour_group": "Natural > Natural",
      "rgb": "#a4ada6",
      "sort_bucket": "grey",
      "sort_hue": 0.37037,
      "sort_sat": 0.052023,
      "sort_val": 0.678431,
      "swatch_file_id": "gid://shopify/MediaImage/49494811541770",
      "swatch_filename": "jh030_Natural_Stone.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Natural_Stone.jpg?v=1774542315",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Natural_Stone.jpg?v=1774542315",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20NTS%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Natural_Stone.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Stone",
      "colour_group": "Grey > Dark Grey",
      "rgb": "#a4ada6",
      "sort_bucket": "grey",
      "sort_hue": 0.37037,
      "sort_sat": 0.052023,
      "sort_val": 0.678431,
      "swatch_file_id": "gid://shopify/MediaImage/49496984846602",
      "swatch_filename": "rx301_Stone.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Stone.jpg?v=1774543277",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Stone.jpg?v=1774543277",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20STO%20FRONT%202.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Stone.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "Urban Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#c7d9d6",
      "sort_bucket": "grey",
      "sort_hue": 0.472222,
      "sort_sat": 0.082949,
      "sort_val": 0.85098,
      "swatch_file_id": "gid://shopify/MediaImage/49494289678602",
      "swatch_filename": "262m_Urban_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Urban_Grey.jpg?v=1774540364",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Urban_Grey.jpg?v=1774540364",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20UGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_Urban_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Platinum Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#9aa6a4",
      "sort_bucket": "grey",
      "sort_hue": 0.472222,
      "sort_sat": 0.072289,
      "sort_val": 0.65098,
      "swatch_file_id": "gid://shopify/MediaImage/49494811607306",
      "swatch_filename": "jh030_Platinum_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Platinum_Grey.jpg?v=1774542317",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Platinum_Grey.jpg?v=1774542317",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20PLA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Platinum_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961300234",
      "product_title": "AWDis Campus Full Zip Sweatshirt",
      "product_handle": "jh147",
      "product_url": "/products/jh147",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "college-uni",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-jh147",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "65% ringspun cotton/35% polyester.",
      "style_code": "JH147",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a2a9a8",
      "sort_bucket": "grey",
      "sort_hue": 0.47619,
      "sort_sat": 0.04142,
      "sort_val": 0.662745,
      "swatch_file_id": "gid://shopify/MediaImage/49495114055946",
      "swatch_filename": "jh147_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh147_Heather_Grey.jpg?v=1774542446",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh147_Heather_Grey.jpg?v=1774542446",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH147/ProductCarouselMain/JH147%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh147_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961201930",
      "product_title": "AWDis Graduate Heavyweight Sweatshirt",
      "product_handle": "jh130",
      "product_url": "/products/jh130",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-jh130",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "Heather grey 65% ringspun cotton/35% polyester.",
      "style_code": "JH130",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a2a9a8",
      "sort_bucket": "grey",
      "sort_hue": 0.47619,
      "sort_sat": 0.04142,
      "sort_val": 0.662745,
      "swatch_file_id": "gid://shopify/MediaImage/49495108485386",
      "swatch_filename": "jh130_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh130_Heather_Grey.jpg?v=1774542437",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh130_Heather_Grey.jpg?v=1774542437",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH130/ProductCarouselMain/JH130%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh130_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960546570",
      "product_title": "AWDis Kids Sweatshirt",
      "product_handle": "jh030b",
      "product_url": "/products/jh030b",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-12-13-3-4-5-6-7-8-9-11",
        "12-13",
        "3-4",
        "5-6",
        "7-8",
        "9-11",
        "children",
        "fleece",
        "kids",
        "style-jh030b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "75% ringspun cotton/25% polyester.",
      "style_code": "JH030B",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a2a9a8",
      "sort_bucket": "grey",
      "sort_hue": 0.47619,
      "sort_sat": 0.04142,
      "sort_val": 0.662745,
      "swatch_file_id": "gid://shopify/MediaImage/49494957359370",
      "swatch_filename": "jh030b_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Heather_Grey.jpg?v=1774542368",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030b_Heather_Grey.jpg?v=1774542368",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030B/ProductCarouselMain/JH030B%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030b_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960644874",
      "product_title": "AWDis Ladies Sweatshirt",
      "product_handle": "jh030f",
      "product_url": "/products/jh030f",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-jh030f",
        "sweatshirts",
        "womens",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "75% ringspun cotton/25% polyester.",
      "style_code": "JH030F",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a2a9a8",
      "sort_bucket": "grey",
      "sort_hue": 0.47619,
      "sort_sat": 0.04142,
      "sort_val": 0.662745,
      "swatch_file_id": "gid://shopify/MediaImage/49494978920714",
      "swatch_filename": "jh030f_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030f_Heather_Grey.jpg?v=1774542381",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030f_Heather_Grey.jpg?v=1774542381",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030F/ProductCarouselMain/JH030F%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030f_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961070858",
      "product_title": "AWDis Signature Heavyweight Sweatshirt",
      "product_handle": "jh123",
      "product_url": "/products/jh123",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-jh123",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% ringspun cotton/30% polyester/10% recycled polyester.",
      "style_code": "JH123",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a2a9a8",
      "sort_bucket": "grey",
      "sort_hue": 0.47619,
      "sort_sat": 0.04142,
      "sort_val": 0.662745,
      "swatch_file_id": "gid://shopify/MediaImage/49495095345418",
      "swatch_filename": "jh123_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_Heather_Grey.jpg?v=1774542428",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh123_Heather_Grey.jpg?v=1774542428",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH123/ProductCarouselMain/JH123%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh123_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960874250",
      "product_title": "AWDis Sophomore Zip Neck Sweatshirt",
      "product_handle": "jh046",
      "product_url": "/products/jh046",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "S-M-L-XL-XXL",
        "style-jh046",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "Heather grey 75% ringpun cotton/25% polyester.",
      "style_code": "JH046",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a2a9a8",
      "sort_bucket": "grey",
      "sort_hue": 0.47619,
      "sort_sat": 0.04142,
      "sort_val": 0.662745,
      "swatch_file_id": "gid://shopify/MediaImage/49495041835274",
      "swatch_filename": "jh046_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh046_Heather_Grey.jpg?v=1774542402",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh046_Heather_Grey.jpg?v=1774542402",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH046/ProductCarouselMain/JH046%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh046_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "75% ringspun cotton/25% polyester.",
      "style_code": "JH030",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a2a9a8",
      "sort_bucket": "grey",
      "sort_hue": 0.47619,
      "sort_sat": 0.04142,
      "sort_val": 0.662745,
      "swatch_file_id": "gid://shopify/MediaImage/49494811771146",
      "swatch_filename": "jh030_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Heather_Grey.jpg?v=1774542319",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Heather_Grey.jpg?v=1774542319",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961398538",
      "product_title": "AWDis Unisex Organic Sweatshirt",
      "product_handle": "jh230",
      "product_url": "/products/jh230",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-jh230",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "JH230",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a2a9a8",
      "sort_bucket": "grey",
      "sort_hue": 0.47619,
      "sort_sat": 0.04142,
      "sort_val": 0.662745,
      "swatch_file_id": "gid://shopify/MediaImage/49495145316618",
      "swatch_filename": "jh230_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_Heather_Grey.jpg?v=1774542464",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh230_Heather_Grey.jpg?v=1774542464",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH230/ProductCarouselMain/JH230%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh230_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960972554",
      "product_title": "AWDis Vision Heavyweight Sweatshirt",
      "product_handle": "jh113",
      "product_url": "/products/jh113",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "heavyweight",
        "L",
        "M",
        "S",
        "style-jh113",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "65% ringspun cotton/25% polyester/10% recycled polyester.",
      "style_code": "JH113",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a2a9a8",
      "sort_bucket": "grey",
      "sort_hue": 0.47619,
      "sort_sat": 0.04142,
      "sort_val": 0.662745,
      "swatch_file_id": "gid://shopify/MediaImage/49495064838410",
      "swatch_filename": "jh113_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh113_Heather_Grey.jpg?v=1774542410",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh113_Heather_Grey.jpg?v=1774542410",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH113/ProductCarouselMain/JH113%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh113_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968640266",
      "product_title": "Pro RTX Pro Sweatshirt",
      "product_handle": "rx301",
      "product_url": "/products/rx301",
      "product_full_url": "None",
      "vendor": "Pro RTX",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "6XL",
        "7XL",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-rx301",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL-6XL-7XL",
        "XXL"
      ],
      "material": "Poly/Cotton",
      "shopify_material": "Poly/Cotton",
      "csv_material": "55% polyester/45% cotton.",
      "style_code": "RX301",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c5d3d3",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.066351,
      "sort_val": 0.827451,
      "swatch_file_id": "gid://shopify/MediaImage/49496984944906",
      "swatch_filename": "rx301_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Heather_Grey.jpg?v=1774543279",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/rx301_Heather_Grey.jpg?v=1774543279",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Pro%20RTX/Product%20Images/RX301/ProductCarouselMain/RX301%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "rx301_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457960382730",
      "product_title": "AWDis Sweatshirt",
      "product_handle": "jh030",
      "product_url": "/products/jh030",
      "product_full_url": "None",
      "vendor": "Just Hoods",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "PCBest_Seller",
        "S",
        "style-jh030",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "JH030",
      "colour_name": "Moondust Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#c5d3d3",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.066351,
      "sort_val": 0.827451,
      "swatch_file_id": "gid://shopify/MediaImage/49494811803914",
      "swatch_filename": "jh030_Moondust_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Moondust_Grey.jpg?v=1774542320",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/jh030_Moondust_Grey.jpg?v=1774542320",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Just%20Hoods/Product%20Images/JH030/ProductCarouselMain/JH030%20MOG%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "jh030_Moondust_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Cement",
      "colour_group": "Grey > Light Grey",
      "rgb": "#9ca6a6",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.060241,
      "sort_val": 0.65098,
      "swatch_file_id": "gid://shopify/MediaImage/49494482845962",
      "swatch_filename": "gd67_Cement.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Cement.jpg?v=1774542055",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Cement.jpg?v=1774542055",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20CEM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Cement.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946521866",
      "product_title": "Russell Athletic Authentic Sweat Jacket",
      "product_handle": "267m",
      "product_url": "/products/267m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "jackets",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-267m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun combed cotton/20% polyester.",
      "style_code": "267M",
      "colour_name": "Light Oxford",
      "colour_group": "Grey > Light Grey",
      "rgb": "#919999",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.052288,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494290268426",
      "swatch_filename": "267m_Light_Oxford.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/267m_Light_Oxford.jpg?v=1774540381",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/267m_Light_Oxford.jpg?v=1774540381",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/267M/ProductCarouselMain/267M%20LXF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "267m_Light_Oxford.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "Light Oxford",
      "colour_group": "Grey > Light Grey",
      "rgb": "#919999",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.052288,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494289744138",
      "swatch_filename": "262m_Light_Oxford.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Light_Oxford.jpg?v=1774540364",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Light_Oxford.jpg?v=1774540364",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20LXF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_Light_Oxford.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947308298",
      "product_title": "Russell Athletic Kids Raglan Sweatshirt",
      "product_handle": "762b",
      "product_url": "/products/762b",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "1-2",
        "1-2-11-12-3-4-5-6-7-8-9-10",
        "11-12",
        "3-4",
        "5-6",
        "7-8",
        "9-10",
        "children",
        "kids",
        "performance-activewear",
        "sports",
        "style-762b",
        "sweatshirts"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762B",
      "colour_name": "Light Oxford",
      "colour_group": "Grey > Light Grey",
      "rgb": "#919999",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.052288,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494299836682",
      "swatch_filename": "762b_Light_Oxford.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Light_Oxford.jpg?v=1774540440",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762b_Light_Oxford.jpg?v=1774540440",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762B/ProductCarouselMain/762B%20LXF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762b_Light_Oxford.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457947472138",
      "product_title": "Russell Athletic Raglan Sweatshirt",
      "product_handle": "762m",
      "product_url": "/products/762m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-762m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% polyester/50% combed ringspun cotton.*",
      "style_code": "762M",
      "colour_name": "Light Oxford",
      "colour_group": "Grey > Light Grey",
      "rgb": "#919999",
      "sort_bucket": "grey",
      "sort_hue": 0.5,
      "sort_sat": 0.052288,
      "sort_val": 0.6,
      "swatch_file_id": "gid://shopify/MediaImage/49494301278474",
      "swatch_filename": "762m_Light_Oxford.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762m_Light_Oxford.jpg?v=1774540455",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/762m_Light_Oxford.jpg?v=1774540455",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/762M/ProductCarouselMain/762M%20LXF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "762m_Light_Oxford.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457956024586",
      "product_title": "Brand Lab Ladies Plush Fleece Crew Neck Sweatshirt",
      "product_handle": "bh210",
      "product_url": "/products/bh210",
      "product_full_url": "None",
      "vendor": "Brand Lab",
      "product_type": "Sweatshirt",
      "tags": [
        "12-14",
        "12-14-16-18-8-10",
        "16-18",
        "8-10",
        "fleece",
        "PCBest_Seller",
        "style-bh210",
        "sweatshirts",
        "womens"
      ],
      "material": "Polyester",
      "shopify_material": "Polyester",
      "csv_material": "100% polyester.",
      "style_code": "BH210",
      "colour_name": "Silver Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#bdcfd1",
      "sort_bucket": "grey",
      "sort_hue": 0.516667,
      "sort_sat": 0.095694,
      "sort_val": 0.819608,
      "swatch_file_id": "gid://shopify/MediaImage/49494457549066",
      "swatch_filename": "bh210_Silver_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bh210_Silver_Grey.jpg?v=1774541716",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/bh210_Silver_Grey.jpg?v=1774541716",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Brand%20Lab/Product%20Images/BH210/ProductCarouselMain/BH210%20SIL%20FRONT%201.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "bh210_Silver_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970311434",
      "product_title": "Fruit of the Loom Classic Drop Shoulder Sweatshirt",
      "product_handle": "ss9",
      "product_url": "/products/ss9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-ss9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS9",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49497510379786",
      "swatch_filename": "ss9_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Heather_Grey.jpg?v=1774543514",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss9_Heather_Grey.jpg?v=1774543514",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS9/ProductCarouselMain/SS9%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss9_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970213130",
      "product_title": "Fruit of the Loom Classic Raglan Sweatshirt",
      "product_handle": "ss8",
      "product_url": "/products/ss8",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss8",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.*",
      "style_code": "SS8",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49497431245066",
      "swatch_filename": "ss8_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Heather_Grey.jpg?v=1774543484",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss8_Heather_Grey.jpg?v=1774543484",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS8/ProductCarouselMain/SS8%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss8_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970082058",
      "product_title": "Fruit of the Loom Classic Zip Neck Sweatshirt",
      "product_handle": "ss17",
      "product_url": "/products/ss17",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-ss17",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "SS17",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49497337266442",
      "swatch_filename": "ss17_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss17_Heather_Grey.jpg?v=1774543445",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss17_Heather_Grey.jpg?v=1774543445",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS17/ProductCarouselMain/SS17%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss17_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970180362",
      "product_title": "Fruit of the Loom Lady Fit Lightweight Raglan Sweatshirt",
      "product_handle": "ss180",
      "product_url": "/products/ss180",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "lightweight",
        "S",
        "style-ss180",
        "sweatshirts",
        "womens",
        "XS",
        "XS-S-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "SS180",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49497363546378",
      "swatch_filename": "ss180_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss180_Heather_Grey.jpg?v=1774543455",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss180_Heather_Grey.jpg?v=1774543455",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Fruit%20of%20the%20Loom/SS180/ProductCarouselMain/SS180%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss180_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969623306",
      "product_title": "Fruit of the Loom Lightweight Drop Shoulder Sweatshirt",
      "product_handle": "ss123",
      "product_url": "/products/ss123",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-ss123",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "SS123",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49497202491658",
      "swatch_filename": "ss123_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss123_Heather_Grey.jpg?v=1774543380",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss123_Heather_Grey.jpg?v=1774543380",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Fruit%20of%20the%20Loom/SS123/ProductCarouselMain/SS123%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss123_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969557770",
      "product_title": "Fruit of the Loom Lightweight Raglan Sweatshirt",
      "product_handle": "ss120",
      "product_url": "/products/ss120",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "lightweight",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-ss120",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "SS120",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49497183158538",
      "swatch_filename": "ss120_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss120_Heather_Grey.jpg?v=1774543372",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss120_Heather_Grey.jpg?v=1774543372",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS120/ProductCarouselMain/SS120%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss120_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970508042",
      "product_title": "Fruit of the Loom Premium Drop Shoulder Sweatshirt",
      "product_handle": "sse9",
      "product_url": "/products/sse9",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-sse9",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE9",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49497541214474",
      "swatch_filename": "sse9_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse9_Heather_Grey.jpg?v=1774543542",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse9_Heather_Grey.jpg?v=1774543542",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SSE9/ProductCarouselMain/SSE9%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse9_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970606346",
      "product_title": "Fruit of the Loom Premium Sweat Jacket",
      "product_handle": "sse92",
      "product_url": "/products/sse92",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "jackets",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-sse92",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE92",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49497549373706",
      "swatch_filename": "sse92_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse92_Heather_Grey.jpg?v=1774543552",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse92_Heather_Grey.jpg?v=1774543552",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SSE92/ProductCarouselMain/SSE92%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse92_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457970409738",
      "product_title": "Fruit of the Loom Premium Zip Neck Sweatshirt",
      "product_handle": "sse17",
      "product_url": "/products/sse17",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-sse17",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "70% cotton/30% polyester.",
      "style_code": "SSE17",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c0d4d7",
      "sort_bucket": "grey",
      "sort_hue": 0.521739,
      "sort_sat": 0.106977,
      "sort_val": 0.843137,
      "swatch_file_id": "gid://shopify/MediaImage/49497532498186",
      "swatch_filename": "sse17_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse17_Heather_Grey.jpg?v=1774543527",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sse17_Heather_Grey.jpg?v=1774543527",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SSE17/ProductCarouselMain/SSE17%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sse17_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969819914",
      "product_title": "Fruit of the Loom Iconic Premium Set-In Sweatshirt",
      "product_handle": "ss151",
      "product_url": "/products/ss151",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss151",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "67% cotton/33% polyester.",
      "style_code": "SS151",
      "colour_name": "Athletic Heather",
      "colour_group": "Grey > Light Grey",
      "rgb": "#a6b5b8",
      "sort_bucket": "grey",
      "sort_hue": 0.527778,
      "sort_sat": 0.097826,
      "sort_val": 0.721569,
      "swatch_file_id": "gid://shopify/MediaImage/49497264914698",
      "swatch_filename": "ss151_Athletic_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_Athletic_Heather.jpg?v=1774543412",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss151_Athletic_Heather.jpg?v=1774543412",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS151/ProductCarouselMain/SS151%20AHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss151_Athletic_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969983754",
      "product_title": "Fruit of the Loom Iconic Premium Sweat Jacket",
      "product_handle": "ss155",
      "product_url": "/products/ss155",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "jackets",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss155",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "67% cotton/33% polyester.",
      "style_code": "SS155",
      "colour_name": "Athletic Heather",
      "colour_group": "Grey > Light Grey",
      "rgb": "#a6b5b8",
      "sort_bucket": "grey",
      "sort_hue": 0.527778,
      "sort_sat": 0.097826,
      "sort_val": 0.721569,
      "swatch_file_id": "gid://shopify/MediaImage/49497311707402",
      "swatch_filename": "ss155_Athletic_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss155_Athletic_Heather.jpg?v=1774543439",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss155_Athletic_Heather.jpg?v=1774543439",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS155/ProductCarouselMain/SS155%20AHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss155_Athletic_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969885450",
      "product_title": "Fruit of the Loom Iconic Premium Zip Neck Sweatshirt",
      "product_handle": "ss154",
      "product_url": "/products/ss154",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss154",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "67% cotton/33% polyester.",
      "style_code": "SS154",
      "colour_name": "Athletic Heather",
      "colour_group": "Grey > Light Grey",
      "rgb": "#a6b5b8",
      "sort_bucket": "grey",
      "sort_hue": 0.527778,
      "sort_sat": 0.097826,
      "sort_val": 0.721569,
      "swatch_file_id": "gid://shopify/MediaImage/49497310888202",
      "swatch_filename": "ss154_Athletic_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss154_Athletic_Heather.jpg?v=1774543428",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss154_Athletic_Heather.jpg?v=1774543428",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS154/ProductCarouselMain/SS154%20AHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss154_Athletic_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457969721610",
      "product_title": "Fruit of the Loom Supercotton™ Sweatshirt",
      "product_handle": "ss141",
      "product_url": "/products/ss141",
      "product_full_url": "None",
      "vendor": "Fruit of the Loom",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL",
        "style-ss141",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "90% cotton/10% polyester.",
      "style_code": "SS141",
      "colour_name": "Athletic Heather",
      "colour_group": "Grey > Light Grey",
      "rgb": "#a6b5b8",
      "sort_bucket": "grey",
      "sort_hue": 0.527778,
      "sort_sat": 0.097826,
      "sort_val": 0.721569,
      "swatch_file_id": "gid://shopify/MediaImage/49497252954378",
      "swatch_filename": "ss141_Athletic_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss141_Athletic_Heather.jpg?v=1774543395",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/ss141_Athletic_Heather.jpg?v=1774543395",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Fruit%20of%20the%20Loom/Product%20Images/SS141/ProductCarouselMain/SS141%20AHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "ss141_Athletic_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962971402",
      "product_title": "Kariban Crew Neck Sweatshirt",
      "product_handle": "kb442",
      "product_url": "/products/kb442",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "fleece",
        "L",
        "M",
        "S",
        "style-kb442",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed cotton/20% polyester.",
      "style_code": "KB442",
      "colour_name": "Oxford Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#9fa8aa",
      "sort_bucket": "grey",
      "sort_hue": 0.530303,
      "sort_sat": 0.064706,
      "sort_val": 0.666667,
      "swatch_file_id": "gid://shopify/MediaImage/49495432003850",
      "swatch_filename": "kb442_Oxford_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb442_Oxford_Grey.jpg?v=1774542588",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb442_Oxford_Grey.jpg?v=1774542588",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB442/ProductCarouselMain/KB442%20OXF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb442_Oxford_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963200778",
      "product_title": "Kariban Crew Neck Sweatshirt",
      "product_handle": "kb488",
      "product_url": "/products/kb488",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb488",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed cotton/20% polyester.",
      "style_code": "KB442",
      "colour_name": "Oxford Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#9fa8aa",
      "sort_bucket": "grey",
      "sort_hue": 0.530303,
      "sort_sat": 0.064706,
      "sort_val": 0.666667,
      "swatch_file_id": "gid://shopify/MediaImage/49495514087690",
      "swatch_filename": "kb488_Oxford_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb488_Oxford_Grey.jpg?v=1774542629",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb488_Oxford_Grey.jpg?v=1774542629",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB442/ProductCarouselMain/KB442%20OXF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb488_Oxford_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "Oxford Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#9fa8aa",
      "sort_bucket": "grey",
      "sort_hue": 0.530303,
      "sort_sat": 0.064706,
      "sort_val": 0.666667,
      "swatch_file_id": "gid://shopify/MediaImage/49495372595466",
      "swatch_filename": "kb4025_Oxford_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Oxford_Grey.jpg?v=1774542576",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Oxford_Grey.jpg?v=1774542576",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20OXF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_Oxford_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457963135242",
      "product_title": "Kariban Zip Neck Sweatshirt",
      "product_handle": "kb487",
      "product_url": "/products/kb487",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb487",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "KB487",
      "colour_name": "Oxford Grey",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#9fa8aa",
      "sort_bucket": "grey",
      "sort_hue": 0.530303,
      "sort_sat": 0.064706,
      "sort_val": 0.666667,
      "swatch_file_id": "gid://shopify/MediaImage/49495496589578",
      "swatch_filename": "kb487_Oxford_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb487_Oxford_Grey.jpg?v=1774542613",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb487_Oxford_Grey.jpg?v=1774542613",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB487/ProductCarouselMain/KB487%20OXF%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb487_Oxford_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457962840330",
      "product_title": "Kariban Unisex Eco Friendly Crew Neck Sweatshirt",
      "product_handle": "kb4025",
      "product_url": "/products/kb4025",
      "product_full_url": "None",
      "vendor": "Kariban",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-kb4025",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% organic combed cotton/15% recycled polyester.",
      "style_code": "KB4025",
      "colour_name": "Ash Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#c9d5d8",
      "sort_bucket": "grey",
      "sort_hue": 0.533333,
      "sort_sat": 0.069444,
      "sort_val": 0.847059,
      "swatch_file_id": "gid://shopify/MediaImage/49495384457482",
      "swatch_filename": "kb4025_Ash_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Ash_Heather.jpg?v=1774542577",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/kb4025_Ash_Heather.jpg?v=1774542577",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kariban/Product%20Images/KB4025/ProductCarouselMain/KB4025%20AHH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "kb4025_Ash_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457957990666",
      "product_title": "Gildan DryBlend® Sweatshirt",
      "product_handle": "gd52",
      "product_url": "/products/gd52",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd52",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD52",
      "colour_name": "Sport Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8487",
      "sort_bucket": "grey",
      "sort_hue": 0.538462,
      "sort_sat": 0.096296,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49494473376010",
      "swatch_filename": "gd52_Sport_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd52_Sport_Grey.jpg?v=1774541877",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd52_Sport_Grey.jpg?v=1774541877",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD52/ProductCarouselMain/GD52%20SGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd52_Sport_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Sport Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8487",
      "sort_bucket": "grey",
      "sort_hue": 0.538462,
      "sort_sat": 0.096296,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49494476095754",
      "swatch_filename": "gd56_Sport_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Sport_Grey.jpg?v=1774541929",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Sport_Grey.jpg?v=1774541929",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20SGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Sport_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "75% cotton/25% polyester.",
      "style_code": "GD67",
      "colour_name": "Sport Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8487",
      "sort_bucket": "grey",
      "sort_hue": 0.538462,
      "sort_sat": 0.096296,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49494482944266",
      "swatch_filename": "gd67_Sport_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Sport_Grey.jpg?v=1774542057",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Sport_Grey.jpg?v=1774542057",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20SGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Sport_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958187274",
      "product_title": "Gildan SoftStyle® Midweight Fleece 1/4 Zip Sweatshirt",
      "product_handle": "gd612",
      "product_url": "/products/gd612",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL",
        "style-gd612",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "75% cotton/25% polyester.",
      "style_code": "GD612",
      "colour_name": "Sport Grey",
      "colour_group": "Grey > Light Grey",
      "rgb": "#7a8487",
      "sort_bucket": "grey",
      "sort_hue": 0.538462,
      "sort_sat": 0.096296,
      "sort_val": 0.529412,
      "swatch_file_id": "gid://shopify/MediaImage/49494479241482",
      "swatch_filename": "gd612_Sport_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Sport_Grey.jpg?v=1774542010",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd612_Sport_Grey.jpg?v=1774542010",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD612/ProductCarouselMain/GD612%20SGY%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd612_Sport_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "03814",
      "colour_name": "Ash",
      "colour_group": "Grey > Light Grey",
      "rgb": "#bfc5c7",
      "sort_bucket": "grey",
      "sort_hue": 0.541667,
      "sort_sat": 0.040201,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49494226272522",
      "swatch_filename": "03814_Ash.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Ash.jpg?v=1774540262",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Ash.jpg?v=1774540262",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03814/ProductCarouselMain/03814%20ASH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_Ash.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946259722",
      "product_title": "SOL'S Unisex New Supreme Sweatshirt",
      "product_handle": "13250",
      "product_url": "/products/13250",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-13250",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% ringspun cotton/50% polyester.",
      "style_code": "13250",
      "colour_name": "Ash",
      "colour_group": "Grey > Light Grey",
      "rgb": "#bfc5c7",
      "sort_bucket": "grey",
      "sort_hue": 0.541667,
      "sort_sat": 0.040201,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49494285648138",
      "swatch_filename": "13250_Ash.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_Ash.jpg?v=1774540333",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/13250_Ash.jpg?v=1774540333",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/13250/ProductCarouselMain/13250%20ASH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "13250_Ash.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944490250",
      "product_title": "SOL'S Unisex Sully Sweatshirt",
      "product_handle": "02990",
      "product_url": "/products/02990",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-02990",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "79% cotton/20% polyester/1% viscose.",
      "style_code": "02990",
      "colour_name": "Ash",
      "colour_group": "Grey > Light Grey",
      "rgb": "#bfc5c7",
      "sort_bucket": "grey",
      "sort_hue": 0.541667,
      "sort_sat": 0.040201,
      "sort_val": 0.780392,
      "swatch_file_id": "gid://shopify/MediaImage/49494217163018",
      "swatch_filename": "02990_Ash.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02990_Ash.jpg?v=1774540181",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/02990_Ash.jpg?v=1774540181",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/SOL%27S/02990/ProductCarouselMain/02990%20ASH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "02990_Ash.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Graphite Heather",
      "colour_group": "Grey > Graphite Grey",
      "rgb": "#74787a",
      "sort_bucket": "grey",
      "sort_hue": 0.555556,
      "sort_sat": 0.04918,
      "sort_val": 0.478431,
      "swatch_file_id": "gid://shopify/MediaImage/49494476292362",
      "swatch_filename": "gd56_Graphite_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Graphite_Heather.jpg?v=1774541932",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Graphite_Heather.jpg?v=1774541932",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20GHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Graphite_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Fan Charcoal Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#666869",
      "sort_bucket": "grey",
      "sort_hue": 0.555556,
      "sort_sat": 0.028571,
      "sort_val": 0.411765,
      "swatch_file_id": "gid://shopify/MediaImage/49494476226826",
      "swatch_filename": "gd56_Fan_Charcoal_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Fan_Charcoal_Heather.jpg?v=1774541930",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Fan_Charcoal_Heather.jpg?v=1774541930",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20FCHE%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Fan_Charcoal_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457957990666",
      "product_title": "Gildan DryBlend® Sweatshirt",
      "product_handle": "gd52",
      "product_url": "/products/gd52",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL",
        "style-gd52",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD52",
      "colour_name": "Ash",
      "colour_group": "Grey > Light Grey",
      "rgb": "#d1dee6",
      "sort_bucket": "grey",
      "sort_hue": 0.563492,
      "sort_sat": 0.091304,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49494473507082",
      "swatch_filename": "gd52_Ash.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd52_Ash.jpg?v=1774541879",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd52_Ash.jpg?v=1774541879",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Discontinued_Clearance/Product%20Images/Gildan/GD52/ProductCarouselMain/GD52%20ASH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd52_Ash.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958056202",
      "product_title": "Gildan Heavy Blend™ Sweatshirt",
      "product_handle": "gd56",
      "product_url": "/products/gd56",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "S",
        "S-M-L-XL-XXL-3XL-4XL-5XL",
        "style-gd56",
        "sweatshirts",
        "unisex",
        "XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "50% cotton/50% polyester.",
      "style_code": "GD56",
      "colour_name": "Ash",
      "colour_group": "Grey > Light Grey",
      "rgb": "#d1dee6",
      "sort_bucket": "grey",
      "sort_hue": 0.563492,
      "sort_sat": 0.091304,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49494476357898",
      "swatch_filename": "gd56_Ash.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Ash.jpg?v=1774541934",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd56_Ash.jpg?v=1774541934",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD56/ProductCarouselMain/GD56%20ASH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd56_Ash.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Ash",
      "colour_group": "Grey > Light Grey",
      "rgb": "#d1dee6",
      "sort_bucket": "grey",
      "sort_hue": 0.563492,
      "sort_sat": 0.091304,
      "sort_val": 0.901961,
      "swatch_file_id": "gid://shopify/MediaImage/49494482977034",
      "swatch_filename": "gd67_Ash.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Ash.jpg?v=1774542058",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Ash.jpg?v=1774542058",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20ASH%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Ash.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457968935178",
      "product_title": "SF Clothing Unisex Sustainable Fashion Sweatshirt",
      "product_handle": "sf530",
      "product_url": "/products/sf530",
      "product_full_url": "None",
      "vendor": "SF Clothing",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-sf530",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XXL",
        "XXS",
        "XXS-XS-S-M-L-XL-XXL-3XL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "60% regenerated cotton/40% recycled polyester.",
      "style_code": "SF530",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#989a9c",
      "sort_bucket": "grey",
      "sort_hue": 0.583333,
      "sort_sat": 0.025641,
      "sort_val": 0.611765,
      "swatch_file_id": "gid://shopify/MediaImage/49497085968650",
      "swatch_filename": "sf530_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf530_Heather_Grey.jpg?v=1774543316",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/sf530_Heather_Grey.jpg?v=1774543316",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SF%20Clothing/Product%20Images/SF530/ProductCarouselMain/SF530%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "sf530_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944785162",
      "product_title": "SOL'S Unisex Comet Organic Sweatshirt",
      "product_handle": "03574",
      "product_url": "/products/03574",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-03574",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "03574",
      "colour_name": "Deep Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#27282a",
      "sort_bucket": "grey",
      "sort_hue": 0.611111,
      "sort_sat": 0.071429,
      "sort_val": 0.164706,
      "swatch_file_id": "gid://shopify/MediaImage/49494223061258",
      "swatch_filename": "03574_Deep_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03574_Deep_Charcoal.jpg?v=1774540229",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03574_Deep_Charcoal.jpg?v=1774540229",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03574/ProductCarouselMain/03574%20DPC%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03574_Deep_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457946358026",
      "product_title": "Russell Athletic Authentic Sweatshirt",
      "product_handle": "262m",
      "product_url": "/products/262m",
      "product_full_url": "None",
      "vendor": "Russell Athletic",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "L",
        "M",
        "performance-activewear",
        "S",
        "sports",
        "style-262m",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% combed ringspun cotton/20% polyester.",
      "style_code": "262M",
      "colour_name": "Sport Heather",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#6e6e70",
      "sort_bucket": "grey",
      "sort_hue": 0.666667,
      "sort_sat": 0.017857,
      "sort_val": 0.439216,
      "swatch_file_id": "gid://shopify/MediaImage/49494289776906",
      "swatch_filename": "262m_Sport_Heather.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Sport_Heather.jpg?v=1774540366",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/262m_Sport_Heather.jpg?v=1774540366",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Russell%20Athletic/Product%20Images/262M/ProductCarouselMain/262M%20SHR%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "262m_Sport_Heather.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948225802",
      "product_title": "Anthem Organic Sweatshirt",
      "product_handle": "am20",
      "product_url": "/products/am20",
      "product_full_url": "None",
      "vendor": "Anthem",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-am20",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "73% organic cotton/21% recycled polyester/6% viscose.",
      "style_code": "AM20",
      "colour_name": "Grey Marl",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#a29fa6",
      "sort_bucket": "grey",
      "sort_hue": 0.738095,
      "sort_sat": 0.042169,
      "sort_val": 0.65098,
      "swatch_file_id": "gid://shopify/MediaImage/49494309077258",
      "swatch_filename": "am20_Grey_Marl.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Grey_Marl.jpg?v=1774540540",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Grey_Marl.jpg?v=1774540540",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM20/ProductCarouselMain/AM20%20GYM%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am20_Grey_Marl.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457958252810",
      "product_title": "Gildan SoftStyle® Midweight Crew Neck Sweatshirt",
      "product_handle": "gd67",
      "product_url": "/products/gd67",
      "product_full_url": "None",
      "vendor": "Gildan",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-gd67",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% ringspun cotton/20% polyester.*",
      "style_code": "GD67",
      "colour_name": "Paragon",
      "colour_group": "Grey > Mid Grey",
      "rgb": "#948794",
      "sort_bucket": "grey",
      "sort_hue": 0.833333,
      "sort_sat": 0.087838,
      "sort_val": 0.580392,
      "swatch_file_id": "gid://shopify/MediaImage/49494483042570",
      "swatch_filename": "gd67_Paragon.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Paragon.jpg?v=1774542060",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/gd67_Paragon.jpg?v=1774542060",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Gildan/Product%20Images/GD67/ProductCarouselMain/GD67%20PGN%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "gd67_Paragon.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961791754",
      "product_title": "Kustom Kit Regular Fit Sweatshirt",
      "product_handle": "k332",
      "product_url": "/products/k332",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "L",
        "M",
        "S",
        "style-k332",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "85% cotton/15% viscose.",
      "style_code": "K332",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#919091",
      "sort_bucket": "grey",
      "sort_hue": 0.833333,
      "sort_sat": 0.006897,
      "sort_val": 0.568627,
      "swatch_file_id": "gid://shopify/MediaImage/49495216193802",
      "swatch_filename": "k332_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k332_Heather_Grey.jpg?v=1774542495",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k332_Heather_Grey.jpg?v=1774542495",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K332/ProductCarouselMain/K332%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k332_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457961890058",
      "product_title": "Kustom Kit Sweat Jacket",
      "product_handle": "k334",
      "product_url": "/products/k334",
      "product_full_url": "None",
      "vendor": "Kustom Kit",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "jackets",
        "L",
        "M",
        "S",
        "style-k334",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% polyester.",
      "style_code": "K334",
      "colour_name": "Heather Grey",
      "colour_group": "Grey > Heather/Effect Grey",
      "rgb": "#919091",
      "sort_bucket": "grey",
      "sort_hue": 0.833333,
      "sort_sat": 0.006897,
      "sort_val": 0.568627,
      "swatch_file_id": "gid://shopify/MediaImage/49495246504202",
      "swatch_filename": "k334_Heather_Grey.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k334_Heather_Grey.jpg?v=1774542504",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/k334_Heather_Grey.jpg?v=1774542504",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Kustom%20Kit/Product%20Images/K334/ProductCarouselMain/K334%20HEA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "k334_Heather_Grey.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457948225802",
      "product_title": "Anthem Organic Sweatshirt",
      "product_handle": "am20",
      "product_url": "/products/am20",
      "product_full_url": "None",
      "vendor": "Anthem",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "fleece",
        "L",
        "M",
        "organic",
        "organic-recycled",
        "S",
        "style-am20",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% organic cotton/20% recycled polyester.*",
      "style_code": "AM20",
      "colour_name": "Charcoal",
      "colour_group": "Grey > Charcoal",
      "rgb": "#615a5b",
      "sort_bucket": "grey",
      "sort_hue": 0.97619,
      "sort_sat": 0.072165,
      "sort_val": 0.380392,
      "swatch_file_id": "gid://shopify/MediaImage/49494309142794",
      "swatch_filename": "am20_Charcoal.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Charcoal.jpg?v=1774540541",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/am20_Charcoal.jpg?v=1774540541",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/Anthem/Product%20Images/AM20/ProductCarouselMain/AM20%20CHA%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "am20_Charcoal.jpg"
    },
    {
      "product_id": "gid://shopify/Product/10457944949002",
      "product_title": "SOL'S Unisex Columbia Sweatshirt",
      "product_handle": "03814",
      "product_url": "/products/03814",
      "product_full_url": "None",
      "vendor": "SOL'S",
      "product_type": "Sweatshirt",
      "tags": [
        "3XL",
        "4XL",
        "5XL",
        "fleece",
        "L",
        "M",
        "S",
        "style-03814",
        "sweatshirts",
        "unisex",
        "XL",
        "XS",
        "XS-S-M-L-XL-XXL-3XL-4XL-5XL",
        "XXL"
      ],
      "material": "Cotton/Poly",
      "shopify_material": "Cotton/Poly",
      "csv_material": "80% cotton/20% recycled polyester.*",
      "style_code": "03814",
      "colour_name": "Creamy Pink",
      "colour_group": "Pink > Light Pink",
      "rgb": "#f2d5d8",
      "sort_bucket": "grey",
      "sort_hue": 0.982759,
      "sort_sat": 0.119835,
      "sort_val": 0.94902,
      "swatch_file_id": "gid://shopify/MediaImage/49494226403594",
      "swatch_filename": "03814_Creamy_Pink.jpg",
      "swatch_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Creamy_Pink.jpg?v=1774540264",
      "front_image_url": "https://cdn.shopify.com/s/files/1/0863/4862/8234/files/03814_Creamy_Pink.jpg?v=1774540264",
      "supplier_front_image_url": "https://www.fullcollection.com/storage/phoenix/2026/Phoenix%20All%20Images/SOL%27S/Product%20Images/03814/ProductCarouselMain/03814%20CYP%20FRONT.jpg",
      "match_source": "title/style + filename",
      "expected_filename": "03814_Creamy_Pink.jpg"
    }
  ]
}
